(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.g1.c5 === region.hM.c5)
	{
		return 'on line ' + region.g1.c5;
	}
	return 'on lines ' + region.g1.c5 + ' through ' + region.hM.c5;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kn,
		impl.lr,
		impl.lc,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bt: func(record.bt),
		la: record.la,
		kW: record.kW
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bt;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.la;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.kW) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kn,
		impl.lr,
		impl.lc,
		function(sendToApp, initialModel) {
			var view = impl.lv;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.kn,
		impl.lr,
		impl.lc,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.g0 && impl.g0(sendToApp)
			var view = impl.lv;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.h);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.bF) && (_VirtualDom_doc.title = title = doc.bF);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.kR;
	var onUrlRequest = impl.kS;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		g0: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.iH === next.iH
							&& curr.ki === next.ki
							&& curr.iC.a === next.iC.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		kn: function(flags)
		{
			return A3(impl.kn, flags, _Browser_getUrl(), key);
		},
		lv: impl.lv,
		lr: impl.lr,
		lc: impl.lc
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { kf: 'hidden', jM: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { kf: 'mozHidden', jM: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { kf: 'msHidden', jM: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { kf: 'webkitHidden', jM: 'webkitvisibilitychange' }
		: { kf: 'hidden', jM: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		iS: _Browser_getScene(),
		ju: {
			lA: _Browser_window.pageXOffset,
			lD: _Browser_window.pageYOffset,
			lz: _Browser_doc.documentElement.clientWidth,
			cW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		lz: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			iS: {
				lz: node.scrollWidth,
				cW: node.scrollHeight
			},
			ju: {
				lA: node.scrollLeft,
				lD: node.scrollTop,
				lz: node.clientWidth,
				cW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			iS: _Browser_getScene(),
			ju: {
				lA: x,
				lD: y,
				lz: _Browser_doc.documentElement.clientWidth,
				cW: _Browser_doc.documentElement.clientHeight
			},
			gj: {
				lA: x + rect.left,
				lD: y + rect.top,
				lz: rect.width,
				cW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.gm.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.gm.b, xhr)); });
		$elm$core$Maybe$isJust(request.jo) && _Http_track(router, xhr, request.jo.a);

		try {
			xhr.open(request.j, request.q, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.q));
		}

		_Http_configureRequest(xhr, request);

		request.h.a && xhr.setRequestHeader('Content-Type', request.h.a);
		xhr.send(request.h.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.i; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.m.a || 0;
	xhr.responseType = request.gm.d;
	xhr.withCredentials = request.jC;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		q: xhr.responseURL,
		bE: xhr.status,
		k9: xhr.statusText,
		i: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			k6: event.loaded,
			i_: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			kY: event.loaded,
			i_: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.kF) { flags += 'm'; }
	if (options.jK) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Main$ChangedUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.s) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.x),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.x);
		} else {
			var treeLen = builder.s * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.y) : builder.y;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.s);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.x) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.x);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{y: nodeList, s: (len / $elm$core$Array$branchFactor) | 0, x: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {go: fragment, ki: host, iA: path, iC: port_, iH: protocol, iI: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$HeaderMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$InitSession = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Route$Maintenance = {$: 1};
var $author$project$Main$SiderBarMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$UserLogged = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Csf$Flags$asset = F2(
	function (name, _v0) {
		var assets = _v0.f$;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, name, assets));
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Csf$Core$timeout = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $author$project$Helpers$Utilities$toMillis = $elm$core$Basics$mul(1000);
var $author$project$Helpers$Utilities$delay = function (secs) {
	return $author$project$Csf$Core$timeout(
		$author$project$Helpers$Utilities$toMillis(secs));
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Csf$Flags$defaultFlags = {f_: $elm$core$Maybe$Nothing, f$: $elm$core$Dict$empty, gV: $elm$core$Maybe$Nothing, g8: $elm$core$Maybe$Nothing, d: $elm$core$Maybe$Nothing, co: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing};
var $author$project$Csf$Flags$Flags = F7(
	function (assets, ticket, platformId, tenantId, applicationId, username, userNode) {
		return {f_: applicationId, f$: assets, gV: platformId, g8: tenantId, d: ticket, co: userNode, bJ: username};
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$map7 = _Json_map7;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Csf$Flags$flagsDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Csf$Flags$Flags,
	A2(
		$elm$json$Json$Decode$field,
		'assets',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'ticket', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'platformId', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'tenantId', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'applicationId', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'username', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing));
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Flags$flags = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Csf$Flags$defaultFlags,
		$elm$core$Result$toMaybe(
			A2($elm$json$Json$Decode$decodeValue, $author$project$Csf$Flags$flagsDecoder, value)));
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {bm: frag, bx: params, ba: unvisited, lt: value, bK: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ba;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.lt);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.lt);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.iA),
					$elm$url$Url$Parser$prepareQuery(url.iI),
					url.go,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$CargarStock = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$ConsultarStock = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$DashboardChie = {$: 2};
var $author$project$Route$HistorialDeCargas = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$Logout = {$: 0};
var $author$project$Route$PendientesAprobacion = function (a) {
	return {$: 10, a: a};
};
var $author$project$Route$PendientesDeFirma = function (a) {
	return {$: 9, a: a};
};
var $author$project$Route$RepositorioChie = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$SolicitarChie = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$SolicitudesChie = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$baseAppRoute = 'emision';
var $author$project$Route$emptyData = {iI: $elm$core$Dict$empty};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bK;
		var unvisited = _v0.ba;
		var params = _v0.bx;
		var frag = _v0.bm;
		var value = _v0.lt;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bK;
			var unvisited = _v1.ba;
			var params = _v1.bx;
			var frag = _v1.bm;
			var value = _v1.lt;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$RouteData = function (query) {
	return {iI: query};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Route$queryToDict = function (query_) {
	var headToString = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		$elm$core$Maybe$withDefault(''));
	var parseParam = function (list_) {
		return _Utils_Tuple2(
			headToString(
				A2($elm$core$List$take, 1, list_)),
			headToString(
				A2($elm$core$List$drop, 1, list_)));
	};
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('='),
				parseParam),
			A2($elm$core$String$split, '&', query_)));
};
var $author$project$Route$queryParser = function (_v0) {
	var query = _v0.iI;
	return A2(
		$elm$url$Url$Parser$Query$custom,
		'queryParser',
		function (_v1) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Route$queryToDict),
				$elm$core$Maybe$withDefault($elm$core$Dict$empty),
				query);
		});
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.bK;
		var unvisited = _v1.ba;
		var params = _v1.bx;
		var frag = _v1.bm;
		var value = _v1.lt;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bK;
		var unvisited = _v0.ba;
		var params = _v0.bx;
		var frag = _v0.bm;
		var value = _v0.lt;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$routeDataParser = F2(
	function (baseRoute_, url_) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RouteData,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s(baseRoute_),
					$author$project$Route$queryParser(url_))));
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bK;
			var unvisited = _v0.ba;
			var params = _v0.bx;
			var frag = _v0.bm;
			var value = _v0.lt;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Route$parser = function (url_) {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Logout,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
					$elm$url$Url$Parser$s('logout'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Maintenance,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
					$elm$url$Url$Parser$s('maintenance'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$DashboardChie,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
					$elm$url$Url$Parser$s('reportes-chie'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$RepositorioChie(''),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
					$elm$url$Url$Parser$s('repo'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$RepositorioChie,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$baseAppRoute),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('repo'),
						$elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CargarStock,
				A2($author$project$Route$routeDataParser, 'cargar-stock', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ConsultarStock($author$project$Route$emptyData),
				$elm$url$Url$Parser$s($author$project$Route$baseAppRoute)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$SolicitarChie,
				A2($author$project$Route$routeDataParser, 'solicitar-chie', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ConsultarStock,
				A2($author$project$Route$routeDataParser, 'consultar-stock', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$SolicitudesChie,
				A2($author$project$Route$routeDataParser, 'solicitudes-chie', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PendientesDeFirma,
				A2($author$project$Route$routeDataParser, 'solicitudes-por-firmar', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PendientesAprobacion,
				A2($author$project$Route$routeDataParser, 'solicitudes-pendientes', url_)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$HistorialDeCargas,
				A2($author$project$Route$routeDataParser, 'historial-cargas-chie', url_))
			]));
};
var $author$project$Route$fromUrl = function (url_) {
	return A2(
		$elm$url$Url$Parser$parse,
		$author$project$Route$parser(url_),
		url_);
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Route$goTo_ = function (navKey) {
	return $elm$browser$Browser$Navigation$pushUrl(navKey);
};
var $author$project$Route$dictQueryToString = function (queryDict_) {
	return A2(
		$elm$core$String$join,
		'&',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var key_ = _v0.a;
				var value_ = _v0.b;
				return A2(
					$elm$core$String$join,
					'=',
					_List_fromArray(
						[key_, value_]));
			},
			$elm$core$Dict$toList(queryDict_)));
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$core$String$trim = _String_trim;
var $author$project$Route$routeToString = function (route_) {
	var toString_ = F2(
		function (query_, path_) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$append(path_),
				$elm$core$List$singleton,
				$author$project$Route$dictQueryToString(query_));
		});
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$String$join('/'),
		$elm$core$Basics$append('/' + ($author$project$Route$baseAppRoute + '/')),
		function () {
			switch (route_.$) {
				case 0:
					return _List_fromArray(
						['logout']);
				case 1:
					return _List_fromArray(
						['maintenance']);
				case 2:
					return _List_fromArray(
						['reportes-chie']);
				case 3:
					var uuid_ = route_.a;
					return A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)(uuid_) ? _List_fromArray(
						['repo']) : _List_fromArray(
						['repo', uuid_]);
				case 4:
					return _List_fromArray(
						['cargar-stock']);
				case 5:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['solicitar-chie']) : A2(toString_, query, 'solicitar-chie?');
				case 6:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['consultar-stock']) : A2(toString_, query, 'consultar-stock?');
				case 7:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['solicitudes-chie']) : A2(toString_, query, 'solicitudes-chie?');
				case 9:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['solicitudes-por-firmar']) : A2(toString_, query, 'solicitudes-por-firmar?');
				case 10:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['solicitudes-pendientes']) : A2(toString_, query, 'solicitudes-pendientes?');
				default:
					var query = route_.a.iI;
					return $elm$core$Dict$isEmpty(query) ? _List_fromArray(
						['historial-cargas-chie']) : A2(toString_, query, 'historial-cargas-chie?');
			}
		}());
};
var $author$project$Route$goTo = function (navKey) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Route$routeToString,
		$author$project$Route$goTo_(navKey));
};
var $author$project$Csf$FilterSideBar$Collapsed = 0;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Csf$FilterSideBar$init = _Utils_Tuple2(
	{w: 0, lG: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$Csf$Header$init = function (session) {
	return _Utils_Tuple2(
		{g$: session, cn: false},
		$elm$core$Platform$Cmd$none);
};
var $pablen$toasty$Toasty$Stack = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $pablen$toasty$Toasty$initialState = A2(
	$pablen$toasty$Toasty$Stack,
	_List_Nil,
	$elm$random$Random$initialSeed(0));
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Csf$Session$navKey = function ($) {
	return $.gL;
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Helpers$Utilities$decodeMapString = F4(
	function (default_, mapping_, decoder_, string_) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Result$map(mapping_),
			$elm$core$Result$withDefault(default_),
			A2($elm$json$Json$Decode$decodeString, decoder_, string_));
	});
var $author$project$Helpers$Utilities$decodeString_ = F3(
	function (default_, decoder_, string_) {
		return A4($author$project$Helpers$Utilities$decodeMapString, default_, $elm$core$Basics$identity, decoder_, string_);
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{jC: false, h: r.h, gm: r.k, i: r.i, j: r.j, m: r.m, jo: $elm$core$Maybe$Nothing, q: r.q});
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Csf$Call$BadStatus = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Csf$Call$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Csf$Call$NetworkError = {$: 2};
var $author$project$Csf$Call$Timeout = {$: 1};
var $author$project$Csf$Call$Unauthorized = {$: 3};
var $author$project$Csf$Call$InvalidCreditals = F2(
	function (msg, error) {
		return {hP: error, kD: msg};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Csf$Call$decoder401 = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'msg',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Csf$Call$InvalidCreditals)));
var $author$project$Csf$Call$TicketResp = F2(
	function (response, success) {
		return {fj: response, ld: success};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Csf$Call$decoderNullTicket = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'success',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'response',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Csf$Call$TicketResp)));
var $author$project$Csf$Call$invalidTicketDesc = 'Something went wrong: %KeyError{key: :ticket, message: nil, term: %{}}';
var $author$project$Csf$Call$isJSON = function (dict) {
	return ('application/json' === A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Dict$get, 'content-type', dict))) || ('application/octet-stream' === A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Dict$get, 'content-type', dict)));
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Csf$Call$resolverString = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Csf$Call$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($author$project$Csf$Call$Timeout);
				case 2:
					return $elm$core$Result$Err($author$project$Csf$Call$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					var ret = $elm$core$Result$Err(
						A2($author$project$Csf$Call$BadStatus, metadata.bE, body));
					var _v1 = metadata.bE;
					switch (_v1) {
						case 401:
							return $elm$core$Result$Err($author$project$Csf$Call$Unauthorized);
						case 400:
							if ($author$project$Csf$Call$isJSON(metadata.i)) {
								var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Csf$Call$decoder401, body);
								if (!_v2.$) {
									var invalidCredentials = _v2.a;
									return (invalidCredentials.hP === '401') ? $elm$core$Result$Err($author$project$Csf$Call$Unauthorized) : ret;
								} else {
									return ret;
								}
							} else {
								return ret;
							}
						case 500:
							var _v3 = A2($elm$json$Json$Decode$decodeString, $author$project$Csf$Call$decoderNullTicket, body);
							if (!_v3.$) {
								var invalidTicket = _v3.a;
								return _Utils_eq(invalidTicket.fj, $author$project$Csf$Call$invalidTicketDesc) ? $elm$core$Result$Err($author$project$Csf$Call$Unauthorized) : ret;
							} else {
								var ret1 = _v3.a;
								return ret;
							}
						default:
							return ret;
					}
				default:
					var metadata = response.a;
					var body = response.b;
					return $elm$core$Result$Ok(
						decoder(body));
			}
		});
};
var $author$project$Helpers$ApiHandler$taskRequest = {
	h: $elm$http$Http$emptyBody,
	i: _List_Nil,
	j: 'GET',
	k: $author$project$Csf$Call$resolverString($elm$core$Basics$identity),
	m: $elm$core$Maybe$Nothing,
	q: '/'
};
var $author$project$Helpers$ApiHandler$get = F2(
	function (serviceUrl, headers_) {
		return $elm$http$Http$task(
			_Utils_update(
				$author$project$Helpers$ApiHandler$taskRequest,
				{i: headers_, q: serviceUrl}));
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Config$AppTenants$TenantRaw = F5(
	function (tenant, name, logo, height, styles) {
		return {cW: height, c7: logo, dc: name, dx: styles, jg: tenant};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Config$AppTenants$tenantRawDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Config$AppTenants$TenantRaw,
	A2($elm$json$Json$Decode$field, 'tenant', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'logo', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'styles',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$Config$AppTenants$tenantsDecoder = $elm$json$Json$Decode$list($author$project$Config$AppTenants$tenantRawDecoder);
var $author$project$Helpers$ApiHandler$tenantsInfoConfig = A2(
	$elm$core$Task$map,
	A2($author$project$Helpers$Utilities$decodeString_, _List_Nil, $author$project$Config$AppTenants$tenantsDecoder),
	A2($author$project$Helpers$ApiHandler$get, '/emision/config/tenants.json', _List_Nil));
var $author$project$Csf$Flags$ticket = function (flags_) {
	return A2($elm$core$Maybe$withDefault, '', flags_.d);
};
var $author$project$TaskNode$TaskNode = F2(
	function (id, properties) {
		return {p: id, dm: properties};
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Csf$AlbertoApi$decoderProps = $elm$json$Json$Decode$dict($elm$json$Json$Decode$value);
var $author$project$TaskNode$decode = F2(
	function (decoder, value) {
		return A2($elm$json$Json$Decode$decodeValue, decoder, value);
	});
var $author$project$TaskNode$prop = F3(
	function (decoder, key, props) {
		var _v0 = A2($elm$core$Dict$get, key, props);
		if (!_v0.$) {
			var value = _v0.a;
			var _v1 = A2($author$project$TaskNode$decode, decoder, value);
			if (!_v1.$) {
				var v = _v1.a;
				return $elm$core$Maybe$Just(v);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$TaskNode$string = $author$project$TaskNode$prop($elm$json$Json$Decode$string);
var $author$project$TaskNode$uniqueId = $author$project$TaskNode$string('unique_id');
var $author$project$TaskNode$uniqueIdWithDefault = F2(
	function (default_, props) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			$author$project$TaskNode$uniqueId(props));
	});
var $author$project$TaskNode$uniqueIdOrEmpty = $author$project$TaskNode$uniqueIdWithDefault('');
var $author$project$Csf$AlbertoApi$decoderTaskNode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2($elm$json$Json$Decode$field, '_id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, '_source', $author$project$Csf$AlbertoApi$decoderProps)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2($elm$json$Json$Decode$field, 'unique_id', $elm$json$Json$Decode$string),
			$author$project$Csf$AlbertoApi$decoderProps),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'msg', 'unique_id']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'msg']),
				$author$project$Csf$AlbertoApi$decoderProps)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'payload', 'unique_id']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'payload']),
				$author$project$Csf$AlbertoApi$decoderProps)),
			A2(
			$elm$json$Json$Decode$andThen,
			function (data) {
				return $elm$json$Json$Decode$succeed(
					A2(
						$author$project$TaskNode$TaskNode,
						$author$project$TaskNode$uniqueIdOrEmpty(data),
						data));
			},
			A2(
				$elm$json$Json$Decode$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault($elm$core$Dict$empty),
						$elm$json$Json$Decode$succeed)),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['response', 'payload']),
					$elm$json$Json$Decode$list($author$project$Csf$AlbertoApi$decoderProps)))),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['result', 'message']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['result']),
				$author$project$Csf$AlbertoApi$decoderProps)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'msg']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response']),
				$author$project$Csf$AlbertoApi$decoderProps)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2($elm$json$Json$Decode$field, 'namespace', $elm$json$Json$Decode$string),
			$author$project$Csf$AlbertoApi$decoderProps),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'updated', 'namespace']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'updated']),
				$author$project$Csf$AlbertoApi$decoderProps)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$TaskNode$TaskNode,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['task_id']),
				$elm$json$Json$Decode$string),
			$author$project$Csf$AlbertoApi$decoderProps)
		]));
var $author$project$TaskNode$emptyTask = {p: '', dm: $elm$core$Dict$empty};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Config$ApiEndpoint$url = $elm$url$Url$Builder$absolute;
var $author$project$Config$ApiEndpoint$userinfo = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['userservice', 'info']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$userInfo = function (ticket_) {
	var decoder_ = A2($elm$json$Json$Decode$field, 'user', $author$project$Csf$AlbertoApi$decoderTaskNode);
	var uInfoDecoder_ = A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, decoder_);
	return A2(
		$elm$core$Task$map,
		uInfoDecoder_,
		A2(
			$author$project$Helpers$ApiHandler$get,
			$author$project$Config$ApiEndpoint$userinfo(ticket_),
			_List_Nil));
};
var $author$project$Main$init = F3(
	function (flags_, url_, navKey_) {
		var session = {
			ka: $author$project$Csf$Flags$flags(flags_),
			ab: _List_Nil,
			gL: navKey_,
			a7: $pablen$toasty$Toasty$initialState
		};
		var page_ = A2($author$project$Main$InitSession, url_, session);
		var loadTenantsOnUserLoggedCmd = function (uNde) {
			return A2(
				$elm$core$Task$map,
				$elm$core$Tuple$pair(uNde),
				$author$project$Helpers$ApiHandler$tenantsInfoConfig);
		};
		var initCmd = function () {
			var _v2 = $author$project$Route$fromUrl(url_);
			if ((!_v2.$) && (_v2.a.$ === 3)) {
				return A2(
					$author$project$Helpers$Utilities$delay,
					0,
					$author$project$Main$ChangedUrl(url_));
			} else {
				return A3(
					$elm$core$Basics$composeR,
					$elm$core$Task$andThen(loadTenantsOnUserLoggedCmd),
					$elm$core$Task$attempt($author$project$Main$UserLogged),
					$author$project$Helpers$ApiHandler$userInfo(
						$author$project$Csf$Flags$ticket(session.ka)));
			}
		}();
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Main$SiderBarMsg),
			$author$project$Csf$FilterSideBar$init);
		var sidebar_ = _v0.a;
		var sidebarCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Main$HeaderMsg),
			$author$project$Csf$Header$init(session));
		var header_ = _v1.a;
		var headerCmd = _v1.b;
		var cmdActions = function (cmd) {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, headerCmd, sidebarCmd]));
		};
		var model = {et: header_, t: page_, dv: sidebar_, cl: $elm$core$Dict$empty, q: url_};
		return ('on' === A2($author$project$Csf$Flags$asset, 'maintenance', session.ka)) ? A2(
			$elm$core$Tuple$pair,
			model,
			A2(
				$author$project$Route$goTo,
				$author$project$Csf$Session$navKey(session),
				$author$project$Route$Maintenance)) : A2(
			$elm$core$Tuple$pair,
			model,
			cmdActions(initCmd));
	});
var $author$project$Main$CargarStockMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$CargasMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$ConsultarStockMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$PendientesMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$SolicitarChieMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$SolicitudesChieMsg = function (a) {
	return {$: 11, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {iB: pids, ja: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {cS: event, $8: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.iB,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.$8;
		var event = _v0.cS;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.ja);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Csf$Header$CloseProfileMsg = 1;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Csf$Header$isOutsideDropdown = function (dropdownId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return _Utils_eq(dropdownId, id) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Csf$Header$isOutsideDropdown(dropdownId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Csf$Header$onOutsideTarget = function (id) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (isOutside) {
			return isOutside ? $elm$json$Json$Decode$succeed(1) : $elm$json$Json$Decode$fail('inside dropdown');
		},
		A2(
			$elm$json$Json$Decode$field,
			'target',
			$author$project$Csf$Header$isOutsideDropdown(id)));
};
var $author$project$Csf$Header$subscriptions = function (_v0) {
	return $elm$browser$Browser$Events$onMouseDown(
		$author$project$Csf$Header$onOutsideTarget('profile-menu'));
};
var $author$project$Page$CargarStock$HandleSSEInformation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$CargarStock$CloseErrorTooltips = {$: 5};
var $author$project$Page$CargarStock$isOutsideIcon = function (id_) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (decoded_) {
					return _Utils_eq(id_, decoded_) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Page$CargarStock$isOutsideIcon(id_));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Page$CargarStock$outsideTarget = function (id_) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (outside_) {
			return outside_ ? $elm$json$Json$Decode$succeed($author$project$Page$CargarStock$CloseErrorTooltips) : $elm$json$Json$Decode$fail('inside icon');
		},
		A2(
			$elm$json$Json$Decode$field,
			'target',
			$author$project$Page$CargarStock$isOutsideIcon(id_)));
};
var $author$project$Ports$sseInformationState = _Platform_incomingPort('sseInformationState', $elm$json$Json$Decode$value);
var $author$project$Page$CargarStock$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$sseInformationState($author$project$Page$CargarStock$HandleSSEInformation),
				$elm$core$Dict$isEmpty(model.aH) ? $elm$core$Platform$Sub$none : A3(
				$elm$core$Basics$composeR,
				$author$project$Page$CargarStock$outsideTarget,
				$elm$browser$Browser$Events$onMouseDown,
				A3(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					$elm$core$Maybe$withDefault(''),
					$elm$core$Dict$keys(model.aH)))
			]));
};
var $author$project$Page$ConsultarStock$AnnoFilterField = 3;
var $author$project$Page$ConsultarStock$DropdownMsg = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Page$ConsultarStock$EstadoFilterField = 8;
var $author$project$Page$ConsultarStock$EstadoVhFilterField = 11;
var $author$project$Page$ConsultarStock$MarcaFilterField = 6;
var $author$project$Page$ConsultarStock$TipoFilterField = 4;
var $author$project$Customized$CustomDropdown$SelectTwoMsg_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$SelectTwo$Types$SelectTwoSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Customized$CustomDropdown$isOutsideDropbox = function (id_) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				function (_v0) {
				var andThen_ = _v0.a;
				var decoder_ = _v0.b;
				return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
			}(
				function (andThen_) {
					return _Utils_Tuple2(
						andThen_,
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
				}(
					function (decoded_) {
						return _Utils_eq(id_, decoded_) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
					})),
				$elm$json$Json$Decode$lazy(
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Customized$CustomDropdown$isOutsideDropbox(id_));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Customized$CustomDropdown$outsideTarget = function (id_) {
	return function (_v0) {
		var andThen_ = _v0.a;
		var decoder_ = _v0.b;
		return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
	}(
		function (andThen_) {
			return _Utils_Tuple2(
				andThen_,
				A2(
					$elm$json$Json$Decode$field,
					'target',
					$author$project$Customized$CustomDropdown$isOutsideDropbox(id_)));
		}(
			function (outside_) {
				return outside_ ? $elm$json$Json$Decode$succeed(
					$author$project$Customized$CustomDropdown$SelectTwoMsg_(
						$author$project$SelectTwo$Types$SelectTwoSelected($elm$core$Maybe$Nothing))) : $elm$json$Json$Decode$fail('inside dropbox');
			}));
};
var $author$project$Customized$CustomDropdown$subscriptions = function (model) {
	var dropdownId = model.cF;
	var dropdownOpen = model.bj;
	return dropdownOpen ? A3($elm$core$Basics$composeR, $author$project$Customized$CustomDropdown$outsideTarget, $elm$browser$Browser$Events$onMouseDown, 'dropbox__' + dropdownId) : $elm$core$Platform$Sub$none;
};
var $author$project$Page$ConsultarStock$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ConsultarStock$DropdownMsg(4),
				$author$project$Customized$CustomDropdown$subscriptions(model.a5)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ConsultarStock$DropdownMsg(3),
				$author$project$Customized$CustomDropdown$subscriptions(model.aN)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ConsultarStock$DropdownMsg(6),
				$author$project$Customized$CustomDropdown$subscriptions(model.aZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ConsultarStock$DropdownMsg(8),
				$author$project$Customized$CustomDropdown$subscriptions(model.aS)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Page$ConsultarStock$DropdownMsg(11),
				$author$project$Customized$CustomDropdown$subscriptions(model.bX))
			]));
};
var $author$project$Page$HistorialDeCargas$HandleSSEInformation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$HistorialDeCargas$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$sseInformationState($author$project$Page$HistorialDeCargas$HandleSSEInformation)
			]));
};
var $author$project$Page$SolicitarChie$DealerDropdownField = 1;
var $author$project$Page$SolicitarChie$DropdownMsg = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$InputDropdownMsg = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$VinDropdownField = 0;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $mercurymedia$elm_datetime_picker$SingleDatePicker$NeverVisible = {$: 0};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$Toggleable = function (a) {
	return {$: 1, a: a};
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$AlwaysVisible = function (a) {
	return {$: 2, a: a};
};
var $elm$time$Time$Mon = 0;
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$dayToNameString = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultTimePickerSettings = {
	dX: F2(
		function (_v0, _v1) {
			return {hN: 23, hO: 59, i4: 0, i5: 0};
		}),
	ln: F2(
		function (_v2, _v3) {
			return '';
		})
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthToNameString = function (month) {
	switch (month) {
		case 0:
			return 'Jan';
		case 1:
			return 'Feb';
		case 2:
			return 'Mar';
		case 3:
			return 'Apr';
		case 4:
			return 'May';
		case 5:
			return 'Jun';
		case 6:
			return 'Jul';
		case 7:
			return 'Aug';
		case 8:
			return 'Sep';
		case 9:
			return 'Oct';
		case 10:
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultSettings = function (zone) {
	return {
		jT: F2(
			function (_v0, _v1) {
				return '';
			}),
		ek: 0,
		kb: $elm$core$Maybe$Nothing,
		kc: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$dayToNameString,
		kd: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthToNameString,
		p: 'date-picker-component',
		kr: F2(
			function (_v2, _v3) {
				return false;
			}),
		fy: false,
		lm: $mercurymedia$elm_datetime_picker$SingleDatePicker$AlwaysVisible($mercurymedia$elm_datetime_picker$SingleDatePicker$defaultTimePickerSettings),
		lG: zone
	};
};
var $author$project$DatePicker$Date$monthToNameEs = function (m) {
	switch (m) {
		case 0:
			return 'enero';
		case 1:
			return 'febrero';
		case 2:
			return 'marzo';
		case 3:
			return 'abril';
		case 4:
			return 'mayo';
		case 5:
			return 'junio';
		case 6:
			return 'julio';
		case 7:
			return 'agosto';
		case 8:
			return 'septiembre';
		case 9:
			return 'octubre';
		case 10:
			return 'noviembre';
		default:
			return 'diciembre';
	}
};
var $author$project$DatePicker$Date$weekdayToNameEs = function (wd) {
	switch (wd) {
		case 0:
			return 'Lunes';
		case 1:
			return 'Martes';
		case 2:
			return 'Miércoles';
		case 3:
			return 'Jueves';
		case 4:
			return 'Viernes';
		case 5:
			return 'Sábado';
		default:
			return 'Domingo';
	}
};
var $author$project$DatePicker$Date$es = {
	jU: function (_v0) {
		return '';
	},
	kz: $author$project$DatePicker$Date$monthToNameEs,
	kA: A2(
		$elm$core$Basics$composeR,
		$author$project$DatePicker$Date$monthToNameEs,
		$elm$core$String$left(3)),
	lx: $author$project$DatePicker$Date$weekdayToNameEs,
	ly: A2(
		$elm$core$Basics$composeR,
		$author$project$DatePicker$Date$weekdayToNameEs,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $elm$time$Time$Fri = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $elm$time$Time$Jan = 0;
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {hE: d, il: m, jz: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		gQ: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		jz: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.jz, 0, date.gQ);
};
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.il;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.g1, posixMinutes) < 0) {
					return posixMinutes + era.gN;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		hE: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		il: month,
		jz: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hE;
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).il;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jz;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {gv: index, kw: match, kP: number, lb: submatches};
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{jK: false, kF: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Csf$DateFormat$dateRegex = $elm$regex$Regex$find(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|LT|.)')));
var $author$project$Csf$DateFormat$ampmA = F2(
	function (zone, posix) {
		return function (h) {
			return (h >= 12) ? 'PM' : 'AM';
		}(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Csf$DateFormat$dayDD = F2(
	function (zone, posix) {
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toDay, zone, posix)));
	});
var $author$project$Csf$DateFormat$hourh = F2(
	function (zone, posix) {
		var dozeFix = function (h_) {
			return (!h_) ? 12 : h_;
		};
		return $elm$core$String$fromInt(
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$modBy(12),
				dozeFix,
				A2($elm$time$Time$toHour, zone, posix)));
	});
var $author$project$Csf$DateFormat$minutemm = F2(
	function (zone, posix) {
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, zone, posix)));
	});
var $author$project$Csf$DateFormat$monthIndex = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$Csf$DateFormat$monthMM = F2(
	function (zone, posix) {
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				$author$project$Csf$DateFormat$monthIndex(
					A2($elm$time$Time$toMonth, zone, posix))));
	});
var $author$project$Csf$DateFormat$monthFullStr = function (month) {
	switch (month) {
		case 0:
			return 'enero';
		case 1:
			return 'febrero';
		case 2:
			return 'marzo';
		case 3:
			return 'abril';
		case 4:
			return 'mayo';
		case 5:
			return 'junio';
		case 6:
			return 'julio';
		case 7:
			return 'agosto';
		case 8:
			return 'septiembre';
		case 9:
			return 'octubre';
		case 10:
			return 'noviembre';
		default:
			return 'diciembre';
	}
};
var $author$project$Csf$DateFormat$monthStr = A2(
	$elm$core$Basics$composeR,
	$author$project$Csf$DateFormat$monthFullStr,
	$elm$core$String$left(3));
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$toLower = _String_toLower;
var $author$project$Csf$DateFormat$yearYYYY = F2(
	function (zone, posix) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, posix));
	});
var $author$project$Csf$DateFormat$formatDateToken = F3(
	function (zone, posix, token) {
		switch (token) {
			case 'M':
				return $elm$core$String$fromInt(
					$author$project$Csf$DateFormat$monthIndex(
						A2($elm$time$Time$toMonth, zone, posix)));
			case 'Mo':
				return token;
			case 'MM':
				return A2($author$project$Csf$DateFormat$monthMM, zone, posix);
			case 'MMM':
				return $author$project$Csf$DateFormat$monthStr(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'Q':
				return token;
			case 'Qo':
				return token;
			case 'D':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toDay, zone, posix));
			case 'Do':
				return token;
			case 'DD':
				return A2($author$project$Csf$DateFormat$dayDD, zone, posix);
			case 'DDD':
				return token;
			case 'DDDo':
				return token;
			case 'DDDD':
				return token;
			case 'd':
				return token;
			case 'do':
				return token;
			case 'dd':
				return token;
			case 'ddd':
				return token;
			case 'dddd':
				return token;
			case 'e':
				return token;
			case 'E':
				return token;
			case 'w':
				return token;
			case 'wo':
				return token;
			case 'ww':
				return token;
			case 'W':
				return token;
			case 'Wo':
				return token;
			case 'WW':
				return token;
			case 'YY':
				return A2(
					$elm$core$String$right,
					2,
					$elm$core$String$fromInt(
						A2($elm$time$Time$toYear, zone, posix)));
			case 'YYYY':
				return A2($author$project$Csf$DateFormat$yearYYYY, zone, posix);
			case 'Y':
				return token;
			case 'gg':
				return A2(
					$elm$core$String$right,
					2,
					$elm$core$String$fromInt(
						A2($elm$time$Time$toYear, zone, posix)));
			case 'gggg':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toYear, zone, posix));
			case 'GG':
				return A2(
					$elm$core$String$right,
					2,
					$elm$core$String$fromInt(
						A2($elm$time$Time$toYear, zone, posix)));
			case 'GGGG':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toYear, zone, posix));
			case 'A':
				return A2($author$project$Csf$DateFormat$ampmA, zone, posix);
			case 'a':
				return $elm$core$String$toLower(
					A2($author$project$Csf$DateFormat$ampmA, zone, posix));
			case 'H':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 'HH':
				return A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'h':
				return A2($author$project$Csf$DateFormat$hourh, zone, posix);
			case 'hh':
				return A3(
					$elm$core$String$padLeft,
					2,
					'0',
					A2($author$project$Csf$DateFormat$hourh, zone, posix));
			case 'k':
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'kk':
				return A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(
						1 + A2($elm$time$Time$toHour, zone, posix)));
			case 'm':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 'mm':
				return A2($author$project$Csf$DateFormat$minutemm, zone, posix);
			case 's':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 'ss':
				return A3(
					$elm$core$String$padLeft,
					2,
					'0',
					$elm$core$String$fromInt(
						A2($elm$time$Time$toMinute, zone, posix)));
			case 'S':
				return token;
			case 'SS':
				return token;
			case 'SSS':
				return token;
			case 'Z':
				return token;
			case 'ZZ':
				return token;
			case 'X':
				return token;
			case 'x':
				return token;
			case 'LT':
				return A2($author$project$Csf$DateFormat$hourh, zone, posix) + (':' + (A2($author$project$Csf$DateFormat$minutemm, zone, posix) + (' ' + A2($author$project$Csf$DateFormat$ampmA, zone, posix))));
			case 'LTS':
				return token;
			case 'L':
				return A2($author$project$Csf$DateFormat$dayDD, zone, posix) + ('/' + (A2($author$project$Csf$DateFormat$monthMM, zone, posix) + (A2($author$project$Csf$DateFormat$yearYYYY, zone, posix) + ' ')));
			case 'LL':
				return token;
			case 'll':
				return token;
			case 'LLL':
				return token;
			case 'lll':
				return token;
			case 'LLLL':
				return token;
			case 'llll':
				return token;
			default:
				return token;
		}
	});
var $author$project$Csf$DateFormat$formatDate = F3(
	function (format, zone, posix) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					A2($author$project$Csf$DateFormat$formatDateToken, zone, posix),
					function ($) {
						return $.kw;
					}),
				$author$project$Csf$DateFormat$dateRegex(format)));
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Page$SolicitarChie$dateTimePickerSettings = F2(
	function (key_, _v0) {
		var zone = _v0.lG;
		var currentDateTime = _v0.bS;
		var timePickerDefaults_ = $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultTimePickerSettings;
		var timePickerVisibility_ = (key_ === 'solicitud_documentos_fecha--dtpicker') ? $mercurymedia$elm_datetime_picker$SingleDatePicker$NeverVisible : $mercurymedia$elm_datetime_picker$SingleDatePicker$Toggleable(
			_Utils_update(
				timePickerDefaults_,
				{
					ln: $author$project$Csf$DateFormat$formatDate('hh:mm A')
				}));
		var disabledAfterToday = F2(
			function (zone_, dtime_) {
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(dtime_),
					$elm$time$Time$posixToMillis(
						A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone_, currentDateTime))) > 0;
			});
		var defaultSettings_ = $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultSettings($elm$time$Time$utc);
		return _Utils_update(
			defaultSettings_,
			{
				jT: $author$project$Csf$DateFormat$formatDate('DD/MM/YYYY'),
				kb: $elm$core$Maybe$Just(currentDateTime),
				kc: $author$project$DatePicker$Date$es.ly,
				kd: $author$project$DatePicker$Date$es.kz,
				p: key_,
				kr: disabledAfterToday,
				lm: timePickerVisibility_
			});
	});
var $author$project$Page$SolicitarChie$NoField = 0;
var $author$project$Helpers$Utilities$dataFromDict = F3(
	function (default_, key_, dataDictSet) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			A2($elm$core$Dict$get, key_, dataDictSet));
	});
var $author$project$Page$SolicitarChie$ImporterDropdownField = 1;
var $author$project$Page$SolicitarChie$VehicleTypeDropdownField = 2;
var $author$project$Page$SolicitarChie$fieldStringSet = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('ImporterDropdownField', 1),
			_Utils_Tuple2('VehicleTypeDropdownField', 2)
		]));
var $author$project$Page$SolicitarChie$fieldFromString = function (string_) {
	return A3($author$project$Helpers$Utilities$dataFromDict, 0, string_, $author$project$Page$SolicitarChie$fieldStringSet);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Customized$CustomDropdown$init = F4(
	function (dataListSet_, id_, pickedOption_, placeholder_) {
		return {
			ec: A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
				((!_Utils_eq($elm$core$Maybe$Nothing, pickedOption_)) && $elm$core$List$isEmpty(dataListSet_)) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, pickedOption_)) : dataListSet_),
			cF: A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)(id_) ? A2(
				$elm$core$Maybe$withDefault,
				'dropdown--' + $elm$core$String$fromInt(
					$elm$core$List$length(dataListSet_)),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					$elm$core$List$head(dataListSet_))) : id_,
			bj: false,
			gi: placeholder_,
			cG: false,
			by: A2($elm$core$Maybe$map, $elm$core$Tuple$first, pickedOption_),
			k5: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Helpers$Utilities$defaultDropdown = A4($author$project$Customized$CustomDropdown$init, _List_Nil, 'NoID_Dropdown', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Helpers$Utilities$getDropdown = F2(
	function (key_, _v0) {
		var moduleDropdowns = _v0.eP;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Helpers$Utilities$defaultDropdown,
			A2($elm$core$Dict$get, key_, moduleDropdowns));
	});
var $author$project$Customized$InputDropdown$DropdownClosed = {$: 2};
var $author$project$Customized$InputDropdown$isOutsideDropdown = function (id_) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				function (_v0) {
				var andThen_ = _v0.a;
				var decoder_ = _v0.b;
				return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
			}(
				function (andThen_) {
					return _Utils_Tuple2(
						andThen_,
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
				}(
					function (decoded_) {
						return _Utils_eq(id_, decoded_) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
					})),
				$elm$json$Json$Decode$lazy(
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Customized$InputDropdown$isOutsideDropdown(id_));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Customized$InputDropdown$outsideTarget = function (id_) {
	return function (_v0) {
		var andThen_ = _v0.a;
		var decoder_ = _v0.b;
		return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
	}(
		function (andThen_) {
			return _Utils_Tuple2(
				andThen_,
				A2(
					$elm$json$Json$Decode$field,
					'target',
					$author$project$Customized$InputDropdown$isOutsideDropdown(id_)));
		}(
			function (outside_) {
				return outside_ ? $elm$json$Json$Decode$succeed($author$project$Customized$InputDropdown$DropdownClosed) : $elm$json$Json$Decode$fail('inside dropbox');
			}));
};
var $author$project$Customized$InputDropdown$subscriptions = function (model) {
	var dropdownId = model.cF;
	var dropdownOpen = model.bj;
	return dropdownOpen ? A2($elm$core$Basics$composeR, $author$project$Customized$InputDropdown$outsideTarget, $elm$browser$Browser$Events$onMouseDown)(dropdownId) : $elm$core$Platform$Sub$none;
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$Close = {$: 10};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent = function (componentId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return _Utils_eq(componentId, id) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('check parent node');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent(componentId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$clickedOutsidePicker = F2(
	function (componentId, internalMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(
					internalMsg($mercurymedia$elm_datetime_picker$SingleDatePicker$Close)) : $elm$json$Json$Decode$fail('inside component');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$eventIsOutsideComponent(componentId)));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$subscriptions = F2(
	function (_v0, _v1) {
		var id = _v0.p;
		var model = _v1;
		var _v2 = model.ay;
		if (_v2.$ === 1) {
			return $elm$browser$Browser$Events$onMouseDown(
				A2($mercurymedia$elm_datetime_picker$SingleDatePicker$clickedOutsidePicker, id, model.K));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Page$SolicitarChie$subscriptions = function (model) {
	var moduleDropdowns = model.eP;
	var pickersListMap = function (_v0) {
		var key_ = _v0.a;
		var picker = _v0.b.aw;
		return A2(
			$mercurymedia$elm_datetime_picker$SingleDatePicker$subscriptions,
			A2($author$project$Page$SolicitarChie$dateTimePickerSettings, key_, model),
			picker);
	};
	var dteTimePickerSubscriptions = A2(
		$elm$core$List$map,
		pickersListMap,
		$elm$core$Dict$toList(model.E));
	var dropdownsMap_ = function (key_) {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$SolicitarChie$DropdownMsg(
				$author$project$Page$SolicitarChie$fieldFromString(key_)),
			$author$project$Customized$CustomDropdown$subscriptions(
				A2($author$project$Helpers$Utilities$getDropdown, key_, model)));
	};
	var dropdownsSubscriptions = A2(
		$elm$core$List$map,
		dropdownsMap_,
		$elm$core$Dict$keys(moduleDropdowns));
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append(dropdownsSubscriptions),
		$elm$core$Platform$Sub$batch,
		_Utils_ap(
			dteTimePickerSubscriptions,
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Page$SolicitarChie$InputDropdownMsg(0),
					$author$project$Customized$InputDropdown$subscriptions(model.ad)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Page$SolicitarChie$InputDropdownMsg(1),
					$author$project$Customized$InputDropdown$subscriptions(model.aP))
				])));
};
var $author$project$Page$SolicitudesChie$DropdownMsg = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$GotPrevLocation = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$SolicitudesChie$HandleSSEInformation = function (a) {
	return {$: 38, a: a};
};
var $author$project$Ports$backFromLocalStorage = _Platform_incomingPort('backFromLocalStorage', $elm$json$Json$Decode$string);
var $author$project$Page$SolicitudesChie$NoField = 0;
var $author$project$Page$SolicitudesChie$AnnoFilterDropdown = 6;
var $author$project$Page$SolicitudesChie$CITFilterField = 2;
var $author$project$Page$SolicitudesChie$ColorFilterDropdown = 7;
var $author$project$Page$SolicitudesChie$ConciliacionFilterDropdown = 15;
var $author$project$Page$SolicitudesChie$CorrelativoFilterField = 5;
var $author$project$Page$SolicitudesChie$DistribuidorFilterDropdown = 14;
var $author$project$Page$SolicitudesChie$EstadoFilterDropdown = 10;
var $author$project$Page$SolicitudesChie$ImportadorFilterDropdown = 13;
var $author$project$Page$SolicitudesChie$MarcaFilterDropdown = 8;
var $author$project$Page$SolicitudesChie$ModeloFilterDropdown = 9;
var $author$project$Page$SolicitudesChie$MotivoAnulacionDropdown = 4;
var $author$project$Page$SolicitudesChie$NroMotorFilterDropdown = 12;
var $author$project$Page$SolicitudesChie$PatenteFilterField = 3;
var $author$project$Page$SolicitudesChie$TipoFilterDropdown = 11;
var $author$project$Page$SolicitudesChie$VinFilterField = 1;
var $author$project$Page$SolicitudesChie$fieldStringSet = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('VinFilterField', 1),
			_Utils_Tuple2('CITFilterField', 2),
			_Utils_Tuple2('PatenteFilterField', 3),
			_Utils_Tuple2('MotivoAnulacionDropdown', 4),
			_Utils_Tuple2('EstadoFilterDropdown', 10),
			_Utils_Tuple2('CorrelativoFilterField', 5),
			_Utils_Tuple2('AnnoFilterDropdown', 6),
			_Utils_Tuple2('ColorFilterDropdown', 7),
			_Utils_Tuple2('MarcaFilterDropdown', 8),
			_Utils_Tuple2('ModeloFilterDropdown', 9),
			_Utils_Tuple2('TipoFilterDropdown', 11),
			_Utils_Tuple2('NroMotorFilterDropdown', 12),
			_Utils_Tuple2('ImportadorFilterDropdown', 13),
			_Utils_Tuple2('DistribuidorFilterDropdown', 14),
			_Utils_Tuple2('ConciliacionFilterDropdown', 15)
		]));
var $author$project$Page$SolicitudesChie$fieldFromString = function (string_) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Dict$get, string_, $author$project$Page$SolicitudesChie$fieldStringSet));
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Page$SolicitudesChie$CloseErrorTooltip = {$: 25};
var $author$project$Page$SolicitudesChie$isOutsideIcon = function (id_) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				function (_v0) {
				var andThen_ = _v0.a;
				var decoder_ = _v0.b;
				return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
			}(
				function (andThen_) {
					return _Utils_Tuple2(
						andThen_,
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
				}(
					function (decoded_) {
						return _Utils_eq(id_, decoded_) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
					})),
				$elm$json$Json$Decode$lazy(
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Page$SolicitudesChie$isOutsideIcon(id_));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Page$SolicitudesChie$outsideTarget = function (id_) {
	return function (_v0) {
		var andThen_ = _v0.a;
		var decoder_ = _v0.b;
		return A2($elm$json$Json$Decode$andThen, andThen_, decoder_);
	}(
		function (andThen_) {
			return _Utils_Tuple2(
				andThen_,
				A2(
					$elm$json$Json$Decode$field,
					'target',
					$author$project$Page$SolicitudesChie$isOutsideIcon(id_)));
		}(
			function (outside_) {
				return outside_ ? $elm$json$Json$Decode$succeed($author$project$Page$SolicitudesChie$CloseErrorTooltip) : $elm$json$Json$Decode$fail('inside icon');
			}));
};
var $author$project$Page$SolicitudesChie$subscriptions = function (model) {
	var dropdownsMap_ = function (key_) {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$SolicitudesChie$DropdownMsg(
				$author$project$Page$SolicitudesChie$fieldFromString(key_)),
			$author$project$Customized$CustomDropdown$subscriptions(
				A2($author$project$Helpers$Utilities$getDropdown, key_, model)));
	};
	var dropdownsSubscriptions = A2(
		$elm$core$List$map,
		dropdownsMap_,
		$elm$core$Dict$keys(model.eP));
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append(dropdownsSubscriptions),
		$elm$core$Platform$Sub$batch,
		_List_fromArray(
			[
				$author$project$Ports$backFromLocalStorage($author$project$Page$SolicitudesChie$GotPrevLocation),
				A2($elm$core$Dict$member, 'file_uuid', model.kX) ? $elm$core$Platform$Sub$none : $author$project$Ports$sseInformationState($author$project$Page$SolicitudesChie$HandleSSEInformation),
				$elm$core$Dict$isEmpty(model.ao) ? $elm$core$Platform$Sub$none : A3(
				$elm$core$Basics$composeR,
				$author$project$Page$SolicitudesChie$outsideTarget,
				$elm$browser$Browser$Events$onMouseDown,
				A3(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					$elm$core$Maybe$withDefault(''),
					$elm$core$Dict$keys(model.ao)))
			]));
};
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$DealerDropdownField = 1;
var $author$project$Page$SolicitudesPendientes$DropdownMsg = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$GotPrevLocation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$SolicitudesPendientes$InputDropdownMsg = F2(
	function (a, b) {
		return {$: 47, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$VinDropdownField = 0;
var $author$project$Page$SolicitudesPendientes$dateTimePickerSettings = F2(
	function (key_, _v0) {
		var zone = _v0.lG;
		var currentDateTime = _v0.bS;
		var timePickerDefaults_ = $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultTimePickerSettings;
		var timePickerVisibility_ = A2($elm$core$String$contains, 'documentos_fecha', key_) ? $mercurymedia$elm_datetime_picker$SingleDatePicker$NeverVisible : $mercurymedia$elm_datetime_picker$SingleDatePicker$Toggleable(
			_Utils_update(
				timePickerDefaults_,
				{
					ln: $author$project$Csf$DateFormat$formatDate('hh:mm A')
				}));
		var disabledAfterToday = F2(
			function (zone_, dtime_) {
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(dtime_),
					$elm$time$Time$posixToMillis(
						A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone_, currentDateTime))) > 0;
			});
		var defaultSettings_ = $mercurymedia$elm_datetime_picker$SingleDatePicker$defaultSettings($elm$time$Time$utc);
		return _Utils_update(
			defaultSettings_,
			{
				jT: $author$project$Csf$DateFormat$formatDate('DD/MM/YYYY'),
				kb: $elm$core$Maybe$Just(currentDateTime),
				kc: $author$project$DatePicker$Date$es.ly,
				kd: $author$project$DatePicker$Date$es.kz,
				p: key_,
				kr: disabledAfterToday,
				lm: timePickerVisibility_
			});
	});
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$NoField = 0;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$DistribuidorFilterDropdown = 8;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$EmailFilterField = 3;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$MarcaFilterDropdown = 5;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$ModeloFilterDropdown = 6;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$PatenteFilterField = 4;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$VehicleTypeDropdownField = 7;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$VehicleVinField = 2;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$VinFilterField = 1;
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$fieldStringSet = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('VinFilterField', 1),
			_Utils_Tuple2('VehicleVinField', 2),
			_Utils_Tuple2('EmailFilterField', 3),
			_Utils_Tuple2('PatenteFilterField', 4),
			_Utils_Tuple2('MarcaFilterDropdown', 5),
			_Utils_Tuple2('ModeloFilterDropdown', 6),
			_Utils_Tuple2('VehicleTypeDropdownField', 7),
			_Utils_Tuple2('DistribuidorFilterDropdown', 8)
		]));
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$fieldFromString = function (string_) {
	return A3($author$project$Helpers$Utilities$dataFromDict, 0, string_, $author$project$Page$SolicitudesPendientes$ModuleHelpers$fieldStringSet);
};
var $author$project$Page$SolicitudesPendientes$subscriptions = function (model) {
	var pickersListMap = function (_v0) {
		var key_ = _v0.a;
		var picker = _v0.b.aw;
		return A2(
			$mercurymedia$elm_datetime_picker$SingleDatePicker$subscriptions,
			A2($author$project$Page$SolicitudesPendientes$dateTimePickerSettings, key_, model),
			picker);
	};
	var dteTimePickerSubscriptions = A2(
		$elm$core$List$map,
		pickersListMap,
		$elm$core$Dict$toList(model.E));
	var dropdownsMap_ = function (key_) {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$SolicitudesPendientes$DropdownMsg(
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$fieldFromString(key_)),
			$author$project$Customized$CustomDropdown$subscriptions(
				A2($author$project$Helpers$Utilities$getDropdown, key_, model)));
	};
	var dropdownsSubscriptions = A2(
		$elm$core$List$map,
		dropdownsMap_,
		$elm$core$Dict$keys(model.eP));
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append(dropdownsSubscriptions),
		$elm$core$Platform$Sub$batch,
		_Utils_ap(
			dteTimePickerSubscriptions,
			_List_fromArray(
				[
					$author$project$Ports$backFromLocalStorage($author$project$Page$SolicitudesPendientes$GotPrevLocation),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Page$SolicitudesPendientes$InputDropdownMsg(0),
					$author$project$Customized$InputDropdown$subscriptions(model.ad)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Page$SolicitudesPendientes$InputDropdownMsg(1),
					$author$project$Customized$InputDropdown$subscriptions(model.aP))
				])));
};
var $author$project$Main$subscriptions = function (model) {
	var appSubscriptions_ = function (pageSubscriptions) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$HeaderMsg,
					$author$project$Csf$Header$subscriptions(model.et)),
					pageSubscriptions
				]));
	};
	return appSubscriptions_(
		function () {
			var _v0 = model.t;
			switch (_v0.$) {
				case 9:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$CargarStockMsg,
						$author$project$Page$CargarStock$subscriptions(model_));
				case 12:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$ConsultarStockMsg,
						$author$project$Page$ConsultarStock$subscriptions(model_));
				case 6:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$PendientesMsg,
						$author$project$Page$SolicitudesPendientes$subscriptions(model_));
				case 11:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$SolicitarChieMsg,
						$author$project$Page$SolicitarChie$subscriptions(model_));
				case 10:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$SolicitudesChieMsg,
						$author$project$Page$SolicitudesChie$subscriptions(model_));
				case 5:
					var model_ = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$CargasMsg,
						$author$project$Page$HistorialDeCargas$subscriptions(model_));
				default:
					return $elm$core$Platform$Sub$none;
			}
		}());
};
var $author$project$Main$CargarStock = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$Cargas = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$ConsultarStock = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$Dashboard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$DashboardMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Pendientes = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$Redirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$Repositorio = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$RepositorioMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$SolicitarChie = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$SolicitudesChie = function (a) {
	return {$: 10, a: a};
};
var $author$project$Helpers$Utilities$logosPath = $elm$core$Basics$append('/emision/static/logos');
var $author$project$Helpers$Utilities$buildTenantsDict = function (pairs) {
	var logosPathMap = function (tInfo) {
		var logo = tInfo.c7;
		return _Utils_update(
			tInfo,
			{
				c7: $author$project$Helpers$Utilities$logosPath(logo)
			});
	};
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond(logosPathMap),
			pairs));
};
var $author$project$Main$Logout = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Maintenance = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$NotFound = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$TicketExpired = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$CargarStock$allowedInQuery = _List_Nil;
var $author$project$Page$ConsultarStock$allowedInQuery = _List_fromArray(
	['page', 'pageSize', 'sortBy', 'vin', 'cit', 'tipo', 'anno', 'motor', 'marca', 'modelo', 'color', 'estado_vh', 'estado', 'id_carga', 'cargafini', 'cargaffin']);
var $author$project$Page$HistorialDeCargas$allowedInQuery = _List_fromArray(
	['page', 'pageSize', 'sortBy']);
var $author$project$Page$SolicitarChie$allowedInQuery = _List_fromArray(
	['format', 'inscription']);
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$String$endsWith = _String_endsWith;
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$TaskNode$dict = $author$project$TaskNode$prop(
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$value));
var $author$project$TaskNode$data = $author$project$TaskNode$dict('data');
var $author$project$TaskNode$dataWithDefault = F2(
	function (default_, props) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			$author$project$TaskNode$data(props));
	});
var $author$project$TaskNode$dataOrEmptyDict = $author$project$TaskNode$dataWithDefault($elm$core$Dict$empty);
var $author$project$TaskNode$liststr = $author$project$TaskNode$prop(
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Csf$TaskNodeUtils$mbdataliststr = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$TaskNode$liststr(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$dataliststr = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdataliststr(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Helpers$ApiHandler$userGroups = function () {
	var groupsMap_ = A2($elm$core$String$replace, 'DOX_SOPORTE_CHIE', 'DOX_CHIE_ROLE_SUPPORT');
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$List$map(groupsMap_),
		A2($author$project$Csf$TaskNodeUtils$dataliststr, _List_Nil, 'groups'));
}();
var $author$project$Config$User$AccountingManager = 6;
var $author$project$Config$User$Administrator = 3;
var $author$project$Config$User$Applicant = 2;
var $author$project$Config$User$Approver = 0;
var $author$project$Config$User$ImporterManager = 5;
var $author$project$Config$User$LegalRepresentative = 7;
var $author$project$Config$User$Nullifier = 1;
var $author$project$Config$User$SupportHandler = 4;
var $author$project$Config$User$userRoles = _List_fromArray(
	[
		_Utils_Tuple2(
		'SUPPORT',
		{aQ: 'Soporte de la plataforma', aX: '/emision/consultar-stock', a3: 4}),
		_Utils_Tuple2(
		'APPROVER',
		{aQ: 'Revisor de la importadora', aX: '/emision/solicitudes-chie', a3: 0}),
		_Utils_Tuple2(
		'NULLIFIER',
		{aQ: 'Anulador de la Importadora', aX: '/emision/solicitudes-chie', a3: 1}),
		_Utils_Tuple2(
		'MANAGER',
		{aQ: 'Gestor de la Importadora', aX: '/emision/dashboard', a3: 5}),
		_Utils_Tuple2(
		'APPLICANT',
		{aQ: 'Solicitante', aX: '/emision/solicitudes-chie', a3: 2}),
		_Utils_Tuple2(
		'ADMINISTRATOR',
		{aQ: 'Administrador de la importadora', aX: '/emision/consultar-stock', a3: 3}),
		_Utils_Tuple2(
		'ACCOUNTING_MANAGER',
		{aQ: 'Contable', aX: '/emision/liquidaciones-chie', a3: 6}),
		_Utils_Tuple2(
		'LEGAL_REPRESENTATIVE',
		{aQ: 'Representante legal de la importadora', aX: '/emision/consultar-stock', a3: 7})
	]);
var $author$project$Helpers$ApiHandler$rolesDeUser = function (userNde) {
	var userGroups_ = $author$project$Helpers$ApiHandler$userGroups(userNde);
	var filter_ = F2(
		function (key_, _v0) {
			return function (matches_) {
				return A2($elm$core$List$any, matches_, userGroups_);
			}(
				$elm$core$String$endsWith('_CHIE_ROLE_' + key_));
		});
	return A2(
		$elm$core$Dict$filter,
		filter_,
		$elm$core$Dict$fromList($author$project$Config$User$userRoles));
};
var $author$project$Helpers$ApiHandler$hasUserAccess = F2(
	function (user_logged, role_keys) {
		return function (itMatches) {
			return A2($elm$core$List$any, itMatches, role_keys);
		}(
			function (key_) {
				return A2(
					$elm$core$Dict$member,
					key_,
					$author$project$Helpers$ApiHandler$rolesDeUser(user_logged));
			});
	});
var $author$project$Csf$Flags$userNode = function (flags_) {
	return A2($elm$core$Maybe$withDefault, $author$project$TaskNode$emptyTask, flags_.co);
};
var $author$project$Page$SolicitudesChie$isSupportUser = function (_v0) {
	var flags = _v0.ka;
	return A2(
		$author$project$Helpers$ApiHandler$hasUserAccess,
		$author$project$Csf$Flags$userNode(flags),
		_List_fromArray(
			['SUPPORT']));
};
var $author$project$Page$SolicitudesChie$dealerAllowed = _List_fromArray(
	['APPROVER', 'NULLIFIER', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']);
var $author$project$Page$SolicitudesChie$showDealer = function (_v0) {
	var flags = _v0.ka;
	return A2(
		$author$project$Helpers$ApiHandler$hasUserAccess,
		$author$project$Csf$Flags$userNode(flags),
		$author$project$Page$SolicitudesChie$dealerAllowed);
};
var $author$project$Page$SolicitudesChie$allowedInQuery = function (session_) {
	var dealer_ = $author$project$Page$SolicitudesChie$isSupportUser(session_) ? _List_fromArray(
		['dealer', 'importer']) : ($author$project$Page$SolicitudesChie$showDealer(session_) ? _List_fromArray(
		['dealer']) : _List_fromArray(
		['importer']));
	return _Utils_ap(
		dealer_,
		_List_fromArray(
			['page', 'pageSize', 'file_uuid', 'sortBy', 'emisionfini', 'emisionffin', 'fechaini', 'fechafin', 'estado', 'conciliate', 'correlativo', 'cit', 'vin', 'anno', 'motor', 'color', 'marca', 'modelo', 'patente', 'tipo_vehiculo']));
};
var $author$project$Page$SolicitudesPendientes$allowedInQuery = _List_fromArray(
	['page', 'pageSize', 'namespace', 'sortBy', 'fechaini', 'fechafin', 'dealer', 'modelo', 'marca', 'email', 'vin', 'ppu']);
var $author$project$Ports$manageLocalStorage = _Platform_outgoingPort('manageLocalStorage', $elm$core$Basics$identity);
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Helpers$Utilities$handleLocalStorage_ = function (dataValue) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$json$Json$Encode$object,
		$author$project$Ports$manageLocalStorage,
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapSecond($elm$json$Json$Encode$string),
			dataValue));
};
var $author$project$Helpers$Utilities$clearLocalStorage = $author$project$Helpers$Utilities$handleLocalStorage_(
	_List_fromArray(
		[
			A2($elm$core$Tuple$pair, 'action', 'clear')
		]));
var $author$project$Csf$FileUploader$init = function (mimes_) {
	return {fZ: mimes_, hW: _List_Nil, eu: false};
};
var $author$project$Csf$Table$init = function (_v0) {
	var data = _v0.r;
	var state = _v0.w;
	return {
		r: A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, item) {
					return {r: item, gv: index, dt: false};
				}),
			data),
		w: state
	};
};
var $billstclair$elm_sortable_table$Table$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $billstclair$elm_sortable_table$Table$initialSort = function (header) {
	return A2($billstclair$elm_sortable_table$Table$State, header, false);
};
var $author$project$Csf$Table$initialSort = $billstclair$elm_sortable_table$Table$initialSort;
var $author$project$Page$CargarStock$init = function (session_) {
	return function (updMdel) {
		return _Utils_Tuple2(updMdel, $elm$core$Platform$Cmd$none);
	}(
		{
			ce: 0,
			dl: $author$project$TaskNode$emptyTask,
			a2: false,
			g$: session_,
			aH: $elm$core$Dict$empty,
			i6: {kh: _List_Nil, lo: 0},
			jb: $author$project$Csf$Table$init(
				{
					r: _List_Nil,
					w: $author$project$Csf$Table$initialSort('None')
				}),
			dG: $author$project$Csf$FileUploader$init(
				_List_fromArray(
					['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'])),
			az: false,
			aI: _List_Nil
		});
};
var $author$project$Page$ConsultarStock$CargaFinPickerMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$ConsultarStock$CargaIniPickerMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$ConsultarStock$CitFilterField = 2;
var $author$project$Page$ConsultarStock$ColorFilterField = 5;
var $author$project$Csf$AlbertoApi$Desc = 1;
var $author$project$Page$ConsultarStock$EmisionFinPickerMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$ConsultarStock$EmisionIniPickerMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$ConsultarStock$GotTimeZone = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Page$ConsultarStock$IdCargaFilterField = 9;
var $author$project$Page$ConsultarStock$ModeloFilterField = 7;
var $author$project$Page$ConsultarStock$NroMotorFilterField = 10;
var $author$project$Page$ConsultarStock$VinFilterField = 1;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Page$ConsultarStock$allowedToSortBy = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'vh_vin',
			{is: 'vin', lf: 'Vin'}),
			_Utils_Tuple2(
			'vh_carga',
			{is: 'id_lote', lf: 'ID Carga'}),
			_Utils_Tuple2(
			'vh_fcarga',
			{is: 'inserted_at', lf: 'Fecha | Hora'}),
			_Utils_Tuple2(
			'vh_tipo',
			{is: 'tipo', lf: 'Tipo'}),
			_Utils_Tuple2(
			'vh_marca',
			{is: 'marca', lf: 'Marca'}),
			_Utils_Tuple2(
			'vh_modelo',
			{is: 'modelo', lf: 'Modelo'}),
			_Utils_Tuple2(
			'vh_anno',
			{is: 'ano', lf: 'Año'}),
			_Utils_Tuple2(
			'vh_color',
			{is: 'color', lf: 'Color'}),
			_Utils_Tuple2(
			'vh_motor',
			{is: 'motor', lf: 'N° Motor'}),
			_Utils_Tuple2(
			'vh_cit',
			{is: 'cit', lf: 'C.I.T'}),
			_Utils_Tuple2(
			'vh_estado',
			{is: 'estado_vehiculo', lf: 'Estado Vehículo'}),
			_Utils_Tuple2(
			'vh_estado-chie',
			{is: 'estado_chie', lf: 'Estado CHI-e'})
		]));
var $author$project$Route$dataFromQuery = F2(
	function (key_, query_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$url$Url$percentDecode,
					$elm$core$Maybe$withDefault('')),
				A2($elm$core$Dict$get, key_, query_)));
	});
var $author$project$Helpers$ApiHandler$emptySearchResp = {kh: _List_Nil, lo: 0};
var $author$project$Config$AppStates$estadosCHIE = _List_fromArray(
	[
		_Utils_Tuple2('DISPONIBLE', 'Disponible'),
		_Utils_Tuple2('NO_DISPONIBLE', 'No Disponible'),
		_Utils_Tuple2('solicitud_anulada', 'Rechazado'),
		_Utils_Tuple2('solicitud_registrada', 'Solicitado'),
		_Utils_Tuple2('pendiente_revision', 'Pendiente revisión'),
		_Utils_Tuple2('registrado_mtt', 'Registrado MTT'),
		_Utils_Tuple2('conciliado_mtt', 'Conciliado MTT'),
		_Utils_Tuple2('notificado_cliente', 'Notificado al cliente'),
		_Utils_Tuple2('notificado_cliente_mtt', 'Notificado al cliente y MTT'),
		_Utils_Tuple2('notificado_registrado_mtt', 'Finalizado'),
		_Utils_Tuple2('pendiente_firma', 'Pendiente firma'),
		_Utils_Tuple2('firmado', 'Firmado'),
		_Utils_Tuple2('firmado_chie', 'Firmado'),
		_Utils_Tuple2('anulado_chie', 'Anulado'),
		_Utils_Tuple2('en_preparacion', 'Preparando Certificado')
	]);
var $author$project$Helpers$Utilities$estadoDelChie = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Config$AppStates$estadosCHIE));
};
var $author$project$Config$AppStates$estadosVehiculo = _List_fromArray(
	[
		_Utils_Tuple2('ANULADO', 'Anulado'),
		_Utils_Tuple2('REGISTRADO', 'Registrado')
	]);
var $author$project$Helpers$Utilities$estadoDelVehiculo = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Config$AppStates$estadosVehiculo));
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {hw: col, jQ: contextStack, iE: problem, iP: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.iP, s.hw, x, s.g));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.gN, s.c);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hw: 1, g: s.g, gu: s.gu, gN: s.gN + 1, iP: s.iP + 1, c: s.c}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hw: s.hw + 1, g: s.g, gu: s.gu, gN: newOffset, iP: s.iP, c: s.c}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.iE;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.c),
			s.gN) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.gN, s1.gN, s0.c),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.gN, s.iP, s.hw, s.c);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{hw: newCol, g: s.g, gu: s.gu, gN: newOffset, iP: newRow, c: s.c});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {hw: col, iE: problem, iP: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.iP, p.hw, p.iE);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{hw: 1, g: _List_Nil, gu: 1, gN: 0, iP: 1, c: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Csf$Modal$Hide = 3;
var $author$project$Csf$Modal$hidden = 3;
var $author$project$Csf$FilterBadges$init = F3(
	function (navKey_, handler_, route_) {
		return {gL: navKey_, bC: route_, ha: handler_};
	});
var $author$project$Csf$NodePager$trimmedEmpty = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty);
var $author$project$Csf$NodePager$stringToMaybe = function (string_) {
	return $author$project$Csf$NodePager$trimmedEmpty(string_) ? $elm$core$Maybe$Nothing : A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$Maybe$Just)(string_);
};
var $author$project$Csf$NodePager$totalPages_ = F2(
	function (pageSize_, totalElements_) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Basics$fdiv(totalElements_),
			$elm$core$Basics$ceiling,
			pageSize_);
	});
var $author$project$Csf$NodePager$init = F4(
	function (_v0, _v1, elementType_, totalElements) {
		var navKey_ = _v0.a;
		var route_ = _v0.b;
		var page_ = _v1.a;
		var pageSize_ = _v1.b;
		return {
			bb: page_,
			bc: pageSize_,
			af: page_,
			gk: A2(
				$elm$core$Maybe$withDefault,
				'Elementos',
				$author$project$Csf$NodePager$stringToMaybe(elementType_)),
			eB: pageSize_,
			bs: totalElements,
			gL: navKey_,
			gR: false,
			bC: route_,
			lp: A2($author$project$Csf$NodePager$totalPages_, pageSize_, totalElements)
		};
	});
var $author$project$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$DatePicker$DatePicker = $elm$core$Basics$identity;
var $author$project$DatePicker$Date$Month = 0;
var $author$project$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$DatePicker$init = _Utils_Tuple2(
	{
		O: $elm$core$Maybe$Just($author$project$DatePicker$Date$initDate),
		aV: false,
		aq: $elm$core$Maybe$Nothing,
		au: false,
		ag: 0,
		a8: $author$project$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $author$project$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Helpers$Utilities$initDashletDict = F2(
	function (toggled_, transitioning_) {
		return A3(
			$elm$core$Dict$insert,
			'transitioning_',
			$elm$json$Json$Encode$bool(transitioning_),
			A3(
				$elm$core$Dict$insert,
				'toggled_',
				$elm$json$Json$Encode$bool(toggled_),
				$elm$core$Dict$empty));
	});
var $author$project$Helpers$Utilities$initFieldDict = F2(
	function (name_, value_) {
		return A3(
			$elm$core$Dict$insert,
			'value_',
			$elm$json$Json$Encode$string(value_),
			A3(
				$elm$core$Dict$insert,
				'label_',
				$elm$json$Json$Encode$string(name_),
				$elm$core$Dict$empty));
	});
var $author$project$Csf$Core$localZone = function (msg) {
	return A2($elm$core$Task$perform, msg, $elm$time$Time$here);
};
var $author$project$Helpers$Utilities$pageFromQuery = A2(
	$elm$core$Basics$composeR,
	$author$project$Route$dataFromQuery('page'),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		$elm$core$Maybe$withDefault(1)));
var $author$project$Helpers$Utilities$pageSizeFromQuery = A2(
	$elm$core$Basics$composeR,
	$author$project$Route$dataFromQuery('pageSize'),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toInt,
		$elm$core$Maybe$withDefault(10)));
var $author$project$Route$removeFromQuery = $elm$core$Dict$remove;
var $billstclair$elm_sortable_table$Table$sortBy = $billstclair$elm_sortable_table$Table$State;
var $author$project$Csf$Table$sortBy = F2(
	function (header_, order_) {
		return A2(
			$billstclair$elm_sortable_table$Table$sortBy,
			header_,
			function () {
				if (!order_) {
					return false;
				} else {
					return true;
				}
			}());
	});
var $author$project$Csf$AlbertoApi$Asc = 0;
var $author$project$Helpers$Utilities$trimmedToLower = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toLower);
var $author$project$Helpers$Utilities$albSortOrder = function (order_) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(
				$author$project$Helpers$Utilities$trimmedToLower(order_)),
			_List_fromArray(
				[
					_Utils_Tuple2('asc', 0),
					_Utils_Tuple2('desc', 1)
				])));
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Csf$AlbertoApi$strSp = function (_v0) {
	var order = _v0.ix;
	return (!order) ? 'asc' : 'desc';
};
var $author$project$Helpers$Utilities$soterField = F2(
	function (field_, order_) {
		return _Utils_ap(
			field_ + ':',
			$author$project$Csf$AlbertoApi$strSp(
				{hV: field_, ix: order_}));
	});
var $author$project$Helpers$Utilities$sortByFromQuery = F2(
	function (allowedToSortBy, query_) {
		var head_ = function (list_) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(list_));
		};
		var handleSorter = function (sorter_) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$trimmedToLower,
				$elm$core$String$split(':'))(sorter_);
		};
		var fieldFromSort = function (key_) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					function ($) {
						return $.is;
					}),
				$elm$core$Maybe$withDefault(key_),
				A2($elm$core$Dict$get, key_, allowedToSortBy));
		};
		var handleResponse = function (_v1) {
			var key_ = _v1.a;
			var order_ = _v1.b;
			return _Utils_Tuple3(
				key_,
				order_,
				A2(
					$author$project$Helpers$Utilities$soterField,
					fieldFromSort(key_),
					order_));
		};
		var allowed_keys = $elm$core$Dict$keys(allowedToSortBy);
		var handleTuple = function (tuple_) {
			if (A2($elm$core$List$member, tuple_.a, allowed_keys)) {
				var _v0 = A2(
					$elm$core$List$member,
					tuple_.b,
					_List_fromArray(
						['asc', 'desc']));
				if (!_v0) {
					return $elm$core$Maybe$Nothing;
				} else {
					return A3(
						$elm$core$Basics$composeR,
						handleResponse,
						$elm$core$Maybe$Just,
						A2($elm$core$Tuple$mapSecond, $author$project$Helpers$Utilities$albSortOrder, tuple_));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var handleData = function (list_) {
			return (2 === $elm$core$List$length(list_)) ? handleTuple(
				_Utils_Tuple2(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$take(1),
						head_)(list_),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$drop(1),
						head_)(list_))) : $elm$core$Maybe$Nothing;
		};
		return A3(
			$elm$core$Basics$composeR,
			handleSorter,
			handleData,
			A2($author$project$Route$dataFromQuery, 'sortBy', query_));
	});
var $author$project$Page$ConsultarStock$fieldStringSet = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('VinFilterField', 1),
			_Utils_Tuple2('CitFilterField', 2),
			_Utils_Tuple2('AnnoFilterField', 3),
			_Utils_Tuple2('TipoFilterField', 4),
			_Utils_Tuple2('ColorFilterField', 5),
			_Utils_Tuple2('MarcaFilterField', 6),
			_Utils_Tuple2('ModeloFilterField', 7),
			_Utils_Tuple2('EstadoFilterField', 8),
			_Utils_Tuple2('IdCargaFilterField', 9),
			_Utils_Tuple2('NroMotorFilterField', 10),
			_Utils_Tuple2('EstadoVhFilterField', 11)
		]));
var $author$project$Helpers$Utilities$keyFromDict = F3(
	function (default_, data_, dataDictSet) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Dict$keys,
				$elm$core$List$head,
				A2(
					$elm$core$Dict$filter,
					F2(
						function (_v0, value_) {
							return _Utils_eq(data_, value_);
						}),
					dataDictSet)));
	});
var $author$project$Page$ConsultarStock$stringFromField = function (field_) {
	return A3($author$project$Helpers$Utilities$keyFromDict, 'NoField', field_, $author$project$Page$ConsultarStock$fieldStringSet);
};
var $author$project$Helpers$Utilities$trimmedEmpty = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty);
var $author$project$Helpers$Utilities$stringToMaybe = function (stringDta) {
	return $author$project$Helpers$Utilities$trimmedEmpty(stringDta) ? $elm$core$Maybe$Nothing : A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$Maybe$Just)(stringDta);
};
var $author$project$Page$ConsultarStock$init = F2(
	function (session_, query_) {
		var navKey = session_.gL;
		var toggled_vh = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['vin', 'cit', 'estado_vh', 'marca', 'anno', 'modelo', 'tipo', 'color', 'motor']));
		var toggle_chie = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['estado', 'emisionfini', 'emisionffin']));
		var toggle_carga = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['id_carga', 'cargafini', 'cargaffin']));
		var ticket_ = $author$project$Csf$Flags$ticket(session_.ka);
		var tableState_ = F2(
			function (sorter_key, order_) {
				return function (column_) {
					return A2($author$project$Csf$Table$sortBy, column_, order_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.lf;
							}),
						$elm$core$Maybe$withDefault('None'),
						A2($elm$core$Dict$get, sorter_key, $author$project$Page$ConsultarStock$allowedToSortBy)));
			});
		var page_ = $author$project$Helpers$Utilities$pageFromQuery(query_);
		var pageSize = $author$project$Helpers$Utilities$pageSizeFromQuery(query_);
		var nodePager_ = function (route_) {
			return A4(
				$author$project$Csf$NodePager$init,
				route_,
				_Utils_Tuple2(page_, pageSize),
				'Vehículos',
				0);
		}(
			_Utils_Tuple2(
				navKey,
				$author$project$Route$ConsultarStock(
					{iI: query_})));
		var fromIdx = A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$mul(pageSize),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$sub(pageSize),
				$elm$core$Basics$abs))(page_);
		var filterBadges_ = A3(
			$author$project$Csf$FilterBadges$init,
			navKey,
			A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$estadoDelChie, $author$project$Helpers$Utilities$estadoDelVehiculo),
			$author$project$Route$ConsultarStock(
				{iI: query_}));
		var dropdownFromQuery = F2(
			function (key_, action_) {
				return A2(
					$elm$core$Maybe$map,
					function (data_) {
						return A2(
							$elm$core$Tuple$pair,
							data_,
							action_(data_));
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Route$dataFromQuery(key_),
						$author$project$Helpers$Utilities$stringToMaybe)(query_));
			});
		var initAnnoDropdown = A4(
			$author$project$Customized$CustomDropdown$init,
			_List_Nil,
			$author$project$Page$ConsultarStock$stringFromField(3),
			A2(dropdownFromQuery, 'anno', $elm$core$Basics$identity),
			$elm$core$Maybe$Just('Seleccione año...'));
		var initEstadoDropdown = A4(
			$author$project$Customized$CustomDropdown$init,
			_List_Nil,
			$author$project$Page$ConsultarStock$stringFromField(8),
			A2(dropdownFromQuery, 'estado', $author$project$Helpers$Utilities$estadoDelChie),
			$elm$core$Maybe$Just('Seleccione estado...'));
		var initEstadoVhDropdown = A4(
			$author$project$Customized$CustomDropdown$init,
			$author$project$Config$AppStates$estadosVehiculo,
			$author$project$Page$ConsultarStock$stringFromField(11),
			A2(dropdownFromQuery, 'estado_vh', $author$project$Helpers$Utilities$estadoDelVehiculo),
			$elm$core$Maybe$Just('Seleccione estado...'));
		var initMarcaDropdown = A4(
			$author$project$Customized$CustomDropdown$init,
			_List_Nil,
			$author$project$Page$ConsultarStock$stringFromField(6),
			A2(dropdownFromQuery, 'marca', $elm$core$Basics$identity),
			$elm$core$Maybe$Just('Seleccione marca...'));
		var initTipoDropdown = A4(
			$author$project$Customized$CustomDropdown$init,
			_List_Nil,
			$author$project$Page$ConsultarStock$stringFromField(4),
			A2(dropdownFromQuery, 'tipo', $elm$core$Basics$identity),
			$elm$core$Maybe$Just('Seleccione tipo...'));
		var dateFromQuery_ = function (key_) {
			return A3(
				$elm$core$Basics$composeR,
				$justinmimbs$date$Date$fromIsoString,
				$elm$core$Result$toMaybe,
				A2($author$project$Route$dataFromQuery, key_, query_));
		};
		var callForNodes = function (sortSearchBy) {
			return $author$project$Csf$Core$localZone(
				A3(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					$author$project$Page$ConsultarStock$GotTimeZone,
					A3(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$object,
						$elm$json$Json$Encode$encode(0),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'sort_by',
								$elm$json$Json$Encode$string(sortSearchBy)),
								_Utils_Tuple2(
								'from_',
								$elm$json$Json$Encode$string(
									$elm$core$String$fromInt(fromIdx))),
								_Utils_Tuple2(
								'size_',
								$elm$json$Json$Encode$string(
									$elm$core$String$fromInt(pageSize)))
							]))));
		};
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$EmisionIniPickerMsg),
			$author$project$DatePicker$init);
		var pickerEmisionIni = _v0.a;
		var pickerEmisionIniCmdFix = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$EmisionFinPickerMsg),
			$author$project$DatePicker$init);
		var pickerEmisionFin = _v1.a;
		var pickerEmisionFinCmdFix = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$CargaIniPickerMsg),
			$author$project$DatePicker$init);
		var pickerCargaIni = _v2.a;
		var pickerCargaIniCmdFix = _v2.b;
		var _v3 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$CargaFinPickerMsg),
			$author$project$DatePicker$init);
		var pickerCargaFin = _v3.a;
		var pickerCargaFinCmdFix = _v3.b;
		var _v4 = function () {
			var _v5 = A2($author$project$Helpers$Utilities$sortByFromQuery, $author$project$Page$ConsultarStock$allowedToSortBy, query_);
			if (_v5.$ === 1) {
				return A2($elm$core$Dict$member, 'sortBy', query_) ? function (action_) {
					return _Utils_Tuple2(
						$author$project$Csf$Table$initialSort('None'),
						action_);
				}(
					function (route_) {
						return route_;
					}(
						A3(
							$elm$core$Basics$composeR,
							$author$project$Route$ConsultarStock,
							$author$project$Route$goTo(navKey),
							{
								iI: A2($author$project$Route$removeFromQuery, 'sortBy', query_)
							}))) : A2(
					$elm$core$Tuple$pair,
					A2(tableState_, 'vh_fcarga', 1),
					callForNodes('inserted_at:desc'));
			} else {
				var _v6 = _v5.a;
				var sorter_key = _v6.a;
				var order_ = _v6.b;
				var node_sorter = _v6.c;
				return _Utils_Tuple2(
					A2(tableState_, sorter_key, order_),
					callForNodes(node_sorter));
			}
		}();
		var tableState = _v4.a;
		var initCmdAction = _v4.b;
		var cmdActions = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[initCmdAction, pickerCargaIniCmdFix, pickerCargaFinCmdFix, pickerEmisionIniCmdFix, pickerEmisionFinCmdFix]));
		return function (model_) {
			return _Utils_Tuple2(model_, cmdActions);
		}(
			{
				aN: initAnnoDropdown,
				cB: $author$project$Csf$Modal$hidden,
				cH: pickerCargaFin,
				cI: pickerCargaIni,
				cJ: pickerEmisionFin,
				cK: pickerEmisionIni,
				aS: initEstadoDropdown,
				bX: initEstadoVhDropdown,
				bZ: false,
				b$: dateFromQuery_('cargaffin'),
				b0: dateFromQuery_('cargafini'),
				b1: dateFromQuery_('emisionffin'),
				b2: dateFromQuery_('emisionfini'),
				b8: filterBadges_,
				eH: $author$project$Helpers$ApiHandler$emptySearchResp,
				aZ: initMarcaDropdown,
				eO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashlet_chie',
							A2($author$project$Helpers$Utilities$initDashletDict, toggle_chie, false)),
							_Utils_Tuple2(
							'dashlet_carga',
							A2($author$project$Helpers$Utilities$initDashletDict, toggle_carga, false)),
							_Utils_Tuple2(
							'dashlet_vehiculo',
							A2($author$project$Helpers$Utilities$initDashletDict, toggled_vh, false))
						])),
				cf: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(1),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'Vin',
								A2($author$project$Route$dataFromQuery, 'vin', query_))),
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(2),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'C.I.T',
								A2($author$project$Route$dataFromQuery, 'cit', query_))),
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(5),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'Color',
								A2($author$project$Route$dataFromQuery, 'color', query_))),
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(7),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'Modelo',
								A2($author$project$Route$dataFromQuery, 'modelo', query_))),
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(9),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'Id Carga',
								A2($author$project$Route$dataFromQuery, 'id_carga', query_))),
							_Utils_Tuple2(
							$author$project$Page$ConsultarStock$stringFromField(10),
							A2(
								$author$project$Helpers$Utilities$initFieldDict,
								'Nro Motor',
								A2($author$project$Route$dataFromQuery, 'motor', query_)))
						])),
				aF: nodePager_,
				de: '',
				bw: false,
				kX: query_,
				g$: session_,
				dw: false,
				jb: $author$project$Csf$Table$init(
					{r: _List_Nil, w: tableState}),
				a5: initTipoDropdown,
				cm: _Utils_Tuple2('', ''),
				dE: 0,
				lG: $elm$time$Time$utc
			});
	});
var $author$project$Page$DashboardChie$FechaFinPickerMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$DashboardChie$FechaIniPickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$DashboardChie$GotTimeZone = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$fromOrdinalDate = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return $justinmimbs$date$Date$daysBeforeYear(y) + A3($elm$core$Basics$clamp, 1, daysInYear, od);
	});
var $author$project$Page$DashboardChie$init = function (session_) {
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Page$DashboardChie$FechaIniPickerMsg),
		$author$project$DatePicker$init);
	var fechaIniPicker = _v0.a;
	var fechaIniPickerCmd = _v0.b;
	var _v1 = A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Page$DashboardChie$FechaFinPickerMsg),
		$author$project$DatePicker$init);
	var fechaFinPicker = _v1.a;
	var fechaFinPickerCmd = _v1.b;
	var initCmdActions_ = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				fechaIniPickerCmd,
				fechaFinPickerCmd,
				$author$project$Csf$Core$localZone($author$project$Page$DashboardChie$GotTimeZone)
			]));
	return A2(
		$elm$core$Tuple$pair,
		{
			aL: 'tab_histogram',
			bT: false,
			cN: fechaFinPicker,
			cO: fechaIniPicker,
			an: '',
			aT: $elm$core$Maybe$Nothing,
			aU: $elm$core$Maybe$Nothing,
			ca: '',
			gN: 0,
			g$: session_,
			a8: A2($justinmimbs$date$Date$fromOrdinalDate, 1970, 1),
			lG: $elm$time$Time$utc
		},
		initCmdActions_);
};
var $author$project$Page$HistorialDeCargas$GotTimeZone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$HistorialDeCargas$HistoryLoaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$HistorialDeCargas$allowedToSortBy = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'vh_carga',
			{is: 'id_lote', lf: 'ID Carga'}),
			_Utils_Tuple2(
			'vh_fcarga',
			{is: 'inserted_at', lf: 'Fecha | Hora'}),
			_Utils_Tuple2(
			'vh_femision',
			{is: 'updated_at', lf: 'Fecha última emisión'}),
			_Utils_Tuple2(
			'vh_usuario',
			{is: 'creador_nombre', lf: 'Usuario'}),
			_Utils_Tuple2(
			'vh_estado',
			{is: 'estado_lote', lf: 'Estado'}),
			_Utils_Tuple2(
			'vh_registros',
			{is: 'cantidad_vehiculos', lf: 'Vehículos'}),
			_Utils_Tuple2(
			'vh_anulados',
			{is: 'vehiculos_anulados', lf: 'Vehículos anulados'}),
			_Utils_Tuple2(
			'vh_chie-emitidos',
			{is: 'chie_emitidos', lf: 'CHI-e emitidos'}),
			_Utils_Tuple2(
			'vh_chie-anulados',
			{is: 'chie_anulados', lf: 'CHI-e anulados'}),
			_Utils_Tuple2(
			'vh_chie-solicitados',
			{is: 'chie_solicitados', lf: 'CHI-e solicitados'})
		]));
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$ElasticSearch$encodeBoost = function (boost_) {
	return _Utils_Tuple2(
		'boost',
		A2($elm$core$Maybe$map, $elm$json$Json$Encode$float, boost_));
};
var $author$project$ElasticSearch$encodeMatchAll = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'match_all',
			$elm$json$Json$Encode$object(_List_Nil))
		]));
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$ElasticSearch$encodeValue = function (value) {
	switch (value.$) {
		case 0:
			var v = value.a;
			return $elm$json$Json$Encode$int(v);
		case 1:
			var v = value.a;
			return $elm$json$Json$Encode$string(v);
		case 2:
			var v = value.a;
			return $elm$json$Json$Encode$float(v);
		case 3:
			var v = value.a;
			return $elm$json$Json$Encode$int(
				$elm$time$Time$posixToMillis(v));
		default:
			var v = value.a;
			return $elm$json$Json$Encode$bool(v);
	}
};
var $author$project$ElasticSearch$encodeMatchQuery = function (q) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'match',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							q.dc,
							$author$project$ElasticSearch$encodeValue(q.lt))
						])))
			]));
};
var $author$project$ElasticSearch$encodeQueryName = function (name) {
	return _Utils_Tuple2(
		'_name',
		A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, name));
};
var $author$project$ElasticSearch$encodeLowerBound = function (bound) {
	switch (bound.$) {
		case 0:
			return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
		case 1:
			var value = bound.a;
			return _Utils_Tuple2(
				'gte',
				$elm$core$Maybe$Just(
					$author$project$ElasticSearch$encodeValue(value)));
		default:
			var value = bound.a;
			return _Utils_Tuple2(
				'gt',
				$elm$core$Maybe$Just(
					$author$project$ElasticSearch$encodeValue(value)));
	}
};
var $author$project$ElasticSearch$relationToString = function (rel) {
	switch (rel) {
		case 0:
			return 'within';
		case 1:
			return 'contains';
		case 2:
			return 'intersects';
		default:
			return 'disjoint';
	}
};
var $author$project$ElasticSearch$encodeRelation = function (rel) {
	return _Utils_Tuple2(
		'relation',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$ElasticSearch$relationToString, $elm$json$Json$Encode$string),
			rel));
};
var $author$project$ElasticSearch$encodeObject = function (list) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var name = _v0.a;
				var value = _v0.b;
				if (!value.$) {
					var v = value.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(name, v));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			list));
};
var $author$project$ElasticSearch$encodeSubObject = F2(
	function (path, attrs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (name, obj) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(name, obj)
							]));
				}),
			$author$project$ElasticSearch$encodeObject(attrs),
			path);
	});
var $author$project$ElasticSearch$encodeUpperBound = function (bound) {
	switch (bound.$) {
		case 0:
			return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
		case 1:
			var value = bound.a;
			return _Utils_Tuple2(
				'lte',
				$elm$core$Maybe$Just(
					$author$project$ElasticSearch$encodeValue(value)));
		default:
			var value = bound.a;
			return _Utils_Tuple2(
				'lt',
				$elm$core$Maybe$Just(
					$author$project$ElasticSearch$encodeValue(value)));
	}
};
var $author$project$ElasticSearch$encodeRangeQuery = function (q) {
	return A2(
		$author$project$ElasticSearch$encodeSubObject,
		_List_fromArray(
			['range', q.dc]),
		_List_fromArray(
			[
				$author$project$ElasticSearch$encodeLowerBound(q.hZ),
				$author$project$ElasticSearch$encodeUpperBound(q.ji),
				$author$project$ElasticSearch$encodeBoost(q.ak),
				$author$project$ElasticSearch$encodeRelation(q.iJ)
			]));
};
var $author$project$ElasticSearch$encodeTermQuery = function (q) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'term',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							q.dc,
							function () {
								var _v0 = _Utils_Tuple2(q.ak, q.cj);
								if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
									var _v1 = _v0.a;
									var _v2 = _v0.b;
									return $author$project$ElasticSearch$encodeValue(q.lt);
								} else {
									var boost_ = _v0.a;
									var qname = _v0.b;
									return $author$project$ElasticSearch$encodeObject(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'value',
												$elm$core$Maybe$Just(
													$author$project$ElasticSearch$encodeValue(q.lt))),
												$author$project$ElasticSearch$encodeBoost(boost_),
												$author$project$ElasticSearch$encodeQueryName(qname)
											]));
								}
							}())
						])))
			]));
};
var $author$project$ElasticSearch$encodeTypeQuery = function (q) {
	var tname = q;
	return A2(
		$author$project$ElasticSearch$encodeSubObject,
		_List_fromArray(
			['type']),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'value',
				$elm$core$Maybe$Just(
					$elm$json$Json$Encode$string(tname)))
			]));
};
var $author$project$ElasticSearch$encodeWildCardQuery = function (q) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'wildcard',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							q.dc,
							$author$project$ElasticSearch$encodeValue(q.lt))
						])))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$ElasticSearch$encodeBoolQuery = function (q) {
	return A2(
		$author$project$ElasticSearch$encodeSubObject,
		_List_fromArray(
			['bool']),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'must',
				$author$project$ElasticSearch$encodeQueryList(q.da)),
				_Utils_Tuple2(
				'must_not',
				$author$project$ElasticSearch$encodeQueryList(q.db)),
				_Utils_Tuple2(
				'filter',
				$author$project$ElasticSearch$encodeQueryList(q.cU)),
				_Utils_Tuple2(
				'should',
				$author$project$ElasticSearch$encodeQueryList(q.du)),
				$author$project$ElasticSearch$encodeBoost(q.ak),
				$author$project$ElasticSearch$encodeQueryName(q.cj)
			]));
};
var $author$project$ElasticSearch$encodeQuery = function (q) {
	switch (q.$) {
		case 0:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeTermQuery(q1);
		case 1:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeMatchQuery(q1);
		case 2:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeWildCardQuery(q1);
		case 3:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeRangeQuery(q1);
		case 4:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeTypeQuery(q1);
		case 5:
			var q1 = q.a;
			return $author$project$ElasticSearch$encodeBoolQuery(q1);
		default:
			return $author$project$ElasticSearch$encodeMatchAll;
	}
};
var $author$project$ElasticSearch$encodeQueryList = function (qlist) {
	if (!qlist.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (!qlist.b.b) {
			var single = qlist.a;
			return $elm$core$Maybe$Just(
				$author$project$ElasticSearch$encodeQuery(single));
		} else {
			var qlist1 = qlist;
			return $elm$core$Maybe$Just(
				A2($elm$json$Json$Encode$list, $author$project$ElasticSearch$encodeQuery, qlist1));
		}
	}
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Helpers$ApiHandler$post = F3(
	function (serviceUrl, headers_, httpBody_) {
		return $elm$http$Http$task(
			_Utils_update(
				$author$project$Helpers$ApiHandler$taskRequest,
				{h: httpBody_, i: headers_, j: 'POST', q: serviceUrl}));
	});
var $author$project$Config$ApiEndpoint$searchservice = F6(
	function (tenant_, node_type_, from_, size_, sortby, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['searchservice', 'tenant', tenant_, 'type', node_type_, 'from', from_, 'size', size_, 'sort', sortby]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Csf$AlbertoApi$SearchResp = F2(
	function (hits, total) {
		return {kh: hits, lo: total};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Helpers$ApiHandler$taskManagerDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Csf$AlbertoApi$SearchResp,
			A2(
				$elm$json$Json$Decode$field,
				'hits',
				$elm$json$Json$Decode$list($author$project$Csf$AlbertoApi$decoderTaskNode)),
			A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Csf$AlbertoApi$SearchResp,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['hits', 'hits']),
				$elm$json$Json$Decode$list($author$project$Csf$AlbertoApi$decoderTaskNode)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['hits', 'total']),
				$elm$json$Json$Decode$int)),
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Csf$AlbertoApi$SearchResp,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'search', 'hits', 'hits']),
				$elm$json$Json$Decode$list($author$project$Csf$AlbertoApi$decoderTaskNode)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['response', 'search', 'hits', 'total']),
				$elm$json$Json$Decode$int))
		]));
var $author$project$Helpers$ApiHandler$buscarNodes = F5(
	function (ticket_, _v0, _v1, sorter_, query_) {
		var from_ = _v0.a;
		var size_ = _v0.b;
		var tenant_ = _v1.a;
		var doc_type_ = _v1.b;
		var service_ = A6($author$project$Config$ApiEndpoint$searchservice, tenant_, doc_type_, from_, size_, sorter_, ticket_);
		var foundNodesMap_ = A2($author$project$Helpers$Utilities$decodeString_, $author$project$Helpers$ApiHandler$emptySearchResp, $author$project$Helpers$ApiHandler$taskManagerDecoder);
		return A3(
			$elm$core$Basics$composeR,
			A2($author$project$Helpers$ApiHandler$post, service_, _List_Nil),
			$elm$core$Task$map(foundNodesMap_),
			$elm$http$Http$jsonBody(
				A2($elm$json$Json$Encode$list, $author$project$ElasticSearch$encodeQuery, query_)));
	});
var $author$project$ElasticSearch$Bool = function (a) {
	return {$: 5, a: a};
};
var $author$project$ElasticSearch$emptyBoolQuery = {ak: $elm$core$Maybe$Nothing, cU: _List_Nil, gG: $elm$core$Maybe$Nothing, da: _List_Nil, db: _List_Nil, cj: $elm$core$Maybe$Nothing, du: _List_Nil};
var $author$project$ElasticSearch$bool = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$core$List$foldl,
		F2(
			function (clause, q) {
				switch (clause.$) {
					case 0:
						var list = clause.a;
						return _Utils_update(
							q,
							{
								da: _Utils_ap(q.da, list)
							});
					case 1:
						var list = clause.a;
						return _Utils_update(
							q,
							{
								cU: _Utils_ap(q.cU, list)
							});
					case 2:
						var list = clause.a;
						var minShouldMatch = clause.b;
						return _Utils_update(
							q,
							{
								gG: minShouldMatch,
								du: _Utils_ap(q.du, list)
							});
					default:
						var list = clause.a;
						return _Utils_update(
							q,
							{
								db: _Utils_ap(q.db, list)
							});
				}
			}),
		$author$project$ElasticSearch$emptyBoolQuery),
	$author$project$ElasticSearch$Bool);
var $author$project$ElasticSearch$BooleanValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$ElasticSearch$boolean = $author$project$ElasticSearch$BooleanValue;
var $author$project$ElasticSearch$Must = function (a) {
	return {$: 0, a: a};
};
var $author$project$ElasticSearch$must = $author$project$ElasticSearch$Must;
var $author$project$ElasticSearch$MustNot = function (a) {
	return {$: 3, a: a};
};
var $author$project$ElasticSearch$mustNot = $author$project$ElasticSearch$MustNot;
var $author$project$ElasticSearch$Term = function (a) {
	return {$: 0, a: a};
};
var $author$project$ElasticSearch$TermQuery = F4(
	function (name, value, boost, queryName) {
		return {ak: boost, dc: name, cj: queryName, lt: value};
	});
var $author$project$ElasticSearch$term = F2(
	function (name, value) {
		return $author$project$ElasticSearch$Term(
			A4($author$project$ElasticSearch$TermQuery, name, value, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
	});
var $author$project$Page$HistorialDeCargas$filtersFromQuery = function (queryData) {
	var mustClause_ = $author$project$ElasticSearch$must(_List_Nil);
	var musNotClause_ = A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$ElasticSearch$mustNot,
		A2(
			$elm$core$Basics$composeR,
			$author$project$ElasticSearch$boolean,
			$author$project$ElasticSearch$term('deleted'))(true));
	return $author$project$ElasticSearch$bool(
		_List_fromArray(
			[mustClause_, musNotClause_]));
};
var $author$project$Csf$Flags$tenantId = function (flags_) {
	return A2($elm$core$Maybe$withDefault, '', flags_.g8);
};
var $author$project$Page$HistorialDeCargas$init = F2(
	function (session_, query_) {
		var navKey = session_.gL;
		var tableState_ = F2(
			function (sorter_key, order_) {
				return function (column_) {
					return A2($author$project$Csf$Table$sortBy, column_, order_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.lf;
							}),
						$elm$core$Maybe$withDefault('None'),
						A2($elm$core$Dict$get, sorter_key, $author$project$Page$HistorialDeCargas$allowedToSortBy)));
			});
		var page_ = $author$project$Helpers$Utilities$pageFromQuery(query_);
		var pageSize = $author$project$Helpers$Utilities$pageSizeFromQuery(query_);
		var fromIdx = A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$mul(pageSize),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$sub(pageSize),
				$elm$core$Basics$abs))(page_);
		var callForNodes = function (sortSearchBy) {
			return A2(
				$elm$core$Task$attempt,
				$author$project$Page$HistorialDeCargas$HistoryLoaded,
				A5(
					$author$project$Helpers$ApiHandler$buscarNodes,
					$author$project$Csf$Flags$ticket(session_.ka),
					_Utils_Tuple2(
						$elm$core$String$fromInt(fromIdx),
						$elm$core$String$fromInt(pageSize)),
					_Utils_Tuple2(
						$author$project$Csf$Flags$tenantId(session_.ka),
						'lote_vehiculos'),
					sortSearchBy,
					_List_fromArray(
						[
							$author$project$Page$HistorialDeCargas$filtersFromQuery(query_)
						])));
		};
		var _v0 = function () {
			var _v1 = A2($author$project$Helpers$Utilities$sortByFromQuery, $author$project$Page$HistorialDeCargas$allowedToSortBy, query_);
			if (_v1.$ === 1) {
				return A2($elm$core$Dict$member, 'sortBy', query_) ? A2(
					$elm$core$Tuple$pair,
					$author$project$Csf$Table$initialSort('None'),
					A3(
						$elm$core$Basics$composeR,
						$author$project$Route$HistorialDeCargas,
						$author$project$Route$goTo(navKey),
						{
							iI: A2($author$project$Route$removeFromQuery, 'sortBy', query_)
						})) : A2(
					$elm$core$Tuple$pair,
					A2(tableState_, 'vh_fcarga', 1),
					callForNodes('inserted_at:desc'));
			} else {
				var _v2 = _v1.a;
				var sorter_key = _v2.a;
				var order_ = _v2.b;
				var node_sorter = _v2.c;
				return _Utils_Tuple2(
					A2(tableState_, sorter_key, order_),
					callForNodes(node_sorter));
			}
		}();
		var tableState = _v0.a;
		var initCmdAction = _v0.b;
		var cmdActions = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					initCmdAction,
					$author$project$Csf$Core$localZone($author$project$Page$HistorialDeCargas$GotTimeZone)
				]));
		return function (model_) {
			return _Utils_Tuple2(model_, cmdActions);
		}(
			{
				cB: $author$project$Csf$Modal$hidden,
				cQ: $author$project$Csf$Modal$hidden,
				cR: '',
				cZ: false,
				bq: $author$project$Helpers$ApiHandler$emptySearchResp,
				aF: function (route_) {
					return A4(
						$author$project$Csf$NodePager$init,
						route_,
						_Utils_Tuple2(page_, pageSize),
						'Cargas',
						0);
				}(
					_Utils_Tuple2(
						session_.gL,
						$author$project$Route$HistorialDeCargas(
							{iI: query_}))),
				de: '',
				bw: false,
				kX: query_,
				g$: session_,
				jb: $author$project$Csf$Table$init(
					{r: _List_Nil, w: tableState}),
				cm: _Utils_Tuple2('', ''),
				lG: $elm$time$Time$utc
			});
	});
var $author$project$Page$RepositorioChie$DocumentLoaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$RepositorioChie$GotTimeZone = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$RepositorioChie$removeSessionAsset = F2(
	function (key_, session) {
		var flags = session.ka;
		return _Utils_update(
			session,
			{
				ka: _Utils_update(
					flags,
					{
						f$: A2($elm$core$Dict$remove, key_, flags.f$)
					})
			});
	});
var $author$project$Csf$Form$NotFocusedValue = {$: 1};
var $author$project$Csf$Form$StrFieldModel = $elm$core$Basics$identity;
var $author$project$Csf$Form$strFieldModel = function (str) {
	return {aJ: $author$project$Csf$Form$NotFocusedValue, lt: str};
};
var $author$project$Config$ApiEndpoint$chiebycodigofirma = function (code_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-search-service', 'search-service', 'public', 'certificates']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'codigo_firma', code_)
			]));
};
var $author$project$Config$ApiEndpoint$chiecertificates = function (uuid_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-search-service', 'search-service', 'public', 'certificates']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'uuid', uuid_)
			]));
};
var $author$project$Page$RepositorioChie$verifyDocument = function (codeToVerify) {
	return function (taskEndpoint_) {
		return A2($author$project$Helpers$ApiHandler$get, taskEndpoint_, _List_Nil);
	}(
		(36 > A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$length)(codeToVerify)) ? $author$project$Config$ApiEndpoint$chiebycodigofirma(
			$elm$core$String$trim(codeToVerify)) : $author$project$Config$ApiEndpoint$chiecertificates(
			$elm$core$String$trim(codeToVerify)));
};
var $author$project$Page$RepositorioChie$init = F2(
	function (session_, exp_uuid_) {
		var flags = session_.ka;
		var failCaseAction_ = A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
			$author$project$Page$RepositorioChie$verifyDocument(exp_uuid_));
		var _v0 = $author$project$Helpers$Utilities$trimmedEmpty(exp_uuid_) ? A2(
			$elm$core$Tuple$pair,
			{p: 'doc_verify', dm: $elm$core$Dict$empty},
			$elm$core$Platform$Cmd$none) : A2(
			$elm$core$Tuple$pair,
			$author$project$TaskNode$emptyTask,
			A2(
				$elm$core$Task$attempt,
				$author$project$Page$RepositorioChie$DocumentLoaded,
				A4(
					$author$project$Helpers$Utilities$decodeMapString,
					failCaseAction_,
					$elm$core$Task$succeed,
					$author$project$Csf$AlbertoApi$decoderTaskNode,
					A2($author$project$Csf$Flags$asset, 'repo_document', flags))));
		var docNode = _v0.a;
		var cmdAction = _v0.b;
		var cmdActions_ = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmdAction,
					$author$project$Csf$Core$localZone($author$project$Page$RepositorioChie$GotTimeZone)
				]));
		return A2(
			$elm$core$Tuple$pair,
			{
				aA: $author$project$Csf$Form$strFieldModel(''),
				bh: false,
				bU: docNode,
				bW: '',
				gN: 0,
				g$: A2($author$project$Page$RepositorioChie$removeSessionAsset, 'repo_document', session_),
				cp: false,
				lG: $elm$time$Time$utc
			},
			cmdActions_);
	});
var $author$project$Page$SolicitarChie$CorrectTimeZone = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$SolicitarChie$GotMetadata = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$SolicitarChie$GotRequestsDealers = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$SolicitarChie$GotStockVins = function (a) {
	return {$: 28, a: a};
};
var $author$project$Config$ApiEndpoint$chieaggregations = F2(
	function (ticket_, type_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-search-service', 'search-service', type_, 'aggregation', 'terms']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$buscarAgregaciones = F3(
	function (ticket_, type_, aggregations_) {
		return A3(
			$author$project$Helpers$ApiHandler$post,
			A2($author$project$Config$ApiEndpoint$chieaggregations, ticket_, type_),
			_List_Nil,
			$elm$http$Http$jsonBody(
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, aggregations_)));
	});
var $author$project$Config$ApiEndpoint$chievinspublic = A2(
	$author$project$Config$ApiEndpoint$url,
	_List_fromArray(
		['chie-search-service', 'search-service', 'public', 'vin']),
	_List_Nil);
var $author$project$Helpers$Utilities$decodeMapValue = F4(
	function (default_, mapping_, decoder_, value_) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Result$map(mapping_),
			$elm$core$Result$withDefault(default_),
			A2($elm$json$Json$Decode$decodeValue, decoder_, value_));
	});
var $author$project$Helpers$Utilities$decodeMbMapValue = F4(
	function (default_, mapping_, decoder_, mbeValue_) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Helpers$Utilities$decodeMapValue, default_, mapping_, decoder_),
				mbeValue_));
	});
var $author$project$Helpers$Utilities$decodeMbValue = F3(
	function (default_, decoder_, mbeValue_) {
		return A4($author$project$Helpers$Utilities$decodeMbMapValue, default_, $elm$core$Basics$identity, decoder_, mbeValue_);
	});
var $author$project$Config$ApiEndpoint$extractorchie = F4(
	function (tenant_, unique_id, format_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-extractor-service', 'extractor-service', tenant_, 'inscripcion', unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'format', format_),
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Helpers$Utilities$removeFromString = F2(
	function (slice_, string_) {
		return A2(
			$elm$core$Maybe$withDefault,
			string_,
			A2(
				$elm$core$Maybe$map,
				function (regex_) {
					return A3(
						$elm$regex$Regex$replace,
						regex_,
						function (_v0) {
							return '';
						},
						string_);
				},
				$elm$regex$Regex$fromString(slice_)));
	});
var $author$project$Helpers$Utilities$forceStringDecoder = function (decoderMap) {
	return A2($elm$json$Json$Decode$map, decoderMap, $elm$json$Json$Decode$value);
}(
	function (value_) {
		return A3(
			$elm$core$String$replace,
			'\\',
			'',
			A2(
				$author$project$Helpers$Utilities$removeFromString,
				'[\"]',
				_Utils_eq($elm$json$Json$Encode$null, value_) ? '' : A2($elm$json$Json$Encode$encode, 0, value_)));
	});
var $author$project$Csf$TaskNodeUtils$mbvalue = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Dict$get(key),
		function ($) {
			return $.dm;
		});
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Helpers$Utilities$trimmedToUpper = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toUpper);
var $author$project$Config$ApiEndpoint$vehiclesbyfield = F3(
	function (ticket_, field_, value_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-search-service', 'search-service', 'vehicle', 'by', field_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'value', value_),
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$vehiculoByVin = F2(
	function (ticket_, vin_) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$Helpers$ApiHandler$emptySearchResp, $author$project$Helpers$ApiHandler$taskManagerDecoder),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A3($author$project$Config$ApiEndpoint$vehiclesbyfield, ticket_, 'vin', vin_),
				_List_Nil));
	});
var $elm$core$String$words = _String_words;
var $author$project$Helpers$ApiHandler$extraerMetadata = F4(
	function (ticket_, tenant_, extension_, unique_id) {
		var searchDataMap = F2(
			function (taskNde_, inStock_) {
				return {h7: inStock_, je: taskNde_};
			});
		var handlesVinData_ = function (vin_) {
			return $elm$core$String$isEmpty(vin_) ? $elm$core$Task$succeed($author$project$TaskNode$emptyTask) : A2(
				$elm$core$Task$onError,
				function (_v2) {
					return $elm$core$Task$succeed($author$project$TaskNode$emptyTask);
				},
				A2(
					$elm$core$Task$map,
					A2(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kh;
							},
							$elm$core$List$head),
						$elm$core$Maybe$withDefault($author$project$TaskNode$emptyTask)),
					A2($author$project$Helpers$ApiHandler$vehiculoByVin, ticket_, vin_)));
		};
		var handleTaskError = function (error_) {
			return $elm$core$Task$succeed(
				{h7: $author$project$TaskNode$emptyTask, je: $author$project$TaskNode$emptyTask});
		};
		var format_ = ('pdf' !== extension_) ? 'image' : extension_;
		var decodes_ = function (json_) {
			return function (decoder_) {
				return A3($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, decoder_, json_);
			}(
				A3(
					$elm$json$Json$Decode$map2,
					$author$project$TaskNode$TaskNode,
					$elm$json$Json$Decode$succeed(unique_id),
					$author$project$Csf$AlbertoApi$decoderProps));
		};
		var dataFromNde_ = function (_v1) {
			var key_ = _v1.a;
			var field_ = _v1.b;
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Csf$TaskNodeUtils$mbvalue(key_),
				A2(
					$author$project$Helpers$Utilities$decodeMbValue,
					'',
					A2($elm$json$Json$Decode$field, field_, $author$project$Helpers$Utilities$forceStringDecoder)));
		};
		var dataFromNde = function (_v0) {
			var key_ = _v0.a;
			var field_ = _v0.b;
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Csf$TaskNodeUtils$mbvalue(key_),
				A2(
					$author$project$Helpers$Utilities$decodeMbValue,
					'',
					A2($elm$json$Json$Decode$field, field_, $elm$json$Json$Decode$string)));
		};
		var andThen_ = function (taskNde) {
			return A2(
				$elm$core$Task$map,
				searchDataMap(taskNde),
				A3(
					$elm$core$Basics$composeR,
					$author$project$Helpers$Utilities$trimmedToUpper,
					handlesVinData_,
					A3(
						$elm$core$Basics$composeR,
						$elm$core$String$words,
						$elm$core$String$join(''),
						$author$project$Helpers$Utilities$trimmedEmpty(
							A2(
								dataFromNde,
								_Utils_Tuple2('vehiculo', 'vin'),
								taskNde)) ? A2(
							dataFromNde_,
							_Utils_Tuple2('vehiculo', 'chassis'),
							taskNde) : A2(
							dataFromNde_,
							_Utils_Tuple2('vehiculo', 'vin'),
							taskNde))));
		};
		return A2(
			$elm$core$Task$onError,
			handleTaskError,
			A2(
				$elm$core$Task$andThen,
				A2($elm$core$Basics$composeR, decodes_, andThen_),
				function (endpoint_) {
					return A2($author$project$Helpers$ApiHandler$get, endpoint_, _List_Nil);
				}(
					A4($author$project$Config$ApiEndpoint$extractorchie, tenant_, unique_id, format_, ticket_))));
	});
var $author$project$Customized$InputDropdown$init = F2(
	function (id_, dropdownData_) {
		return {gh: dropdownData_, cF: id_ + '__input-dropdown', bj: false, cY: ''};
	});
var $author$project$Helpers$Utilities$updateDropdown = F3(
	function (key_, dropdown_, mdel) {
		var moduleDropdowns = mdel.eP;
		return _Utils_update(
			mdel,
			{
				eP: A3($elm$core$Dict$insert, key_, dropdown_, moduleDropdowns)
			});
	});
var $author$project$Helpers$Utilities$initDropdown = F5(
	function (options_, key_, pickedOption_, placeholder_, mdel) {
		return A3(
			$author$project$Helpers$Utilities$updateDropdown,
			key_,
			A4($author$project$Customized$CustomDropdown$init, options_, key_, pickedOption_, placeholder_),
			mdel);
	});
var $author$project$Page$SolicitarChie$stringFromField = function (field_) {
	return A3($author$project$Helpers$Utilities$keyFromDict, 'NoField', field_, $author$project$Page$SolicitarChie$fieldStringSet);
};
var $author$project$Config$AppVehiculos$vehiculosMoto = _List_fromArray(
	['MOTOCICLETA', 'BICIMOTO', 'TRIMOTO', 'CUADRIMOTO', 'BICICLETA MOTOR', 'TRICICLO MOTOR']);
var $author$project$Config$AppVehiculos$vehiculosOtros = _List_fromArray(
	['AUTOMOVIL', 'STATION WAGON', 'FURGON', 'CAMIONETA', 'MINIBUS', 'JEEP', 'LIMUSINA', 'BUS', 'MICROBUS', 'OMNIBUS', 'TRACTOR', 'CASA RODANTE MOTORIZADA', 'MAQUINA INDUSTRIAL', 'AMBULANCIA', 'CARROBOMBA', 'TROLEBUS', 'CHASIS CABINADO', 'COCHE MORTUORIO', 'BUGGI', 'TRACTOR ANFIBIO']);
var $author$project$Helpers$Utilities$tiposDeVehiculo = A2(
	$elm$core$List$map,
	function (t) {
		return A2($elm$core$Tuple$pair, t, t);
	},
	_Utils_ap($author$project$Config$AppVehiculos$vehiculosMoto, $author$project$Config$AppVehiculos$vehiculosOtros));
var $author$project$Page$SolicitarChie$init = F3(
	function (session_, tenantsDict_, query_) {
		var flags = session_.ka;
		var isQueryEmpty = $elm$core$Dict$isEmpty(query_);
		var inscriptionUUID_ = A2($author$project$Route$dataFromQuery, 'inscription', query_);
		var inscriptionFormat_ = A3(
			$elm$core$Basics$composeR,
			$author$project$Helpers$Utilities$stringToMaybe,
			$elm$core$Maybe$withDefault('pdf'),
			A2($author$project$Route$dataFromQuery, 'format', query_));
		var initUploader_ = $author$project$Csf$FileUploader$init(
			_List_fromArray(
				['application/pdf']));
		var initModuleDropdowns = function (model_) {
			return A5(
				$author$project$Helpers$Utilities$initDropdown,
				$author$project$Helpers$Utilities$tiposDeVehiculo,
				$author$project$Page$SolicitarChie$stringFromField(2),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just('Seleccione tipo...'),
				A5(
					$author$project$Helpers$Utilities$initDropdown,
					_List_Nil,
					$author$project$Page$SolicitarChie$stringFromField(1),
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just('Seleccione importador...'),
					model_));
		};
		var dateTimeAndtimeZone_ = A2(
			$elm$core$Task$perform,
			$author$project$Page$SolicitarChie$CorrectTimeZone,
			A2(
				$elm$core$Task$andThen,
				function (now) {
					return A2(
						$elm$core$Task$map,
						$elm$core$Tuple$pair(now),
						$elm$time$Time$here);
				},
				$elm$time$Time$now));
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$cons(dateTimeAndtimeZone_),
				$elm$core$Platform$Cmd$batch),
			isQueryEmpty ? A2($elm$core$Tuple$pair, 1, _List_Nil) : A2(
				$elm$core$Tuple$pair,
				2,
				_List_fromArray(
					[
						A2(
						$elm$core$Task$attempt,
						$author$project$Page$SolicitarChie$GotStockVins,
						A2($author$project$Helpers$ApiHandler$get, $author$project$Config$ApiEndpoint$chievinspublic, _List_Nil)),
						A2(
						$elm$core$Task$attempt,
						$author$project$Page$SolicitarChie$GotRequestsDealers,
						A3(
							$author$project$Helpers$ApiHandler$buscarAgregaciones,
							$author$project$Csf$Flags$ticket(flags),
							'files',
							_List_fromArray(
								['distribuidor']))),
						A2(
						$elm$core$Task$attempt,
						$author$project$Page$SolicitarChie$GotMetadata,
						A4(
							$author$project$Helpers$ApiHandler$extraerMetadata,
							$author$project$Csf$Flags$ticket(flags),
							$author$project$Csf$Flags$tenantId(flags),
							inscriptionFormat_,
							inscriptionUUID_))
					])));
		var actualStep_ = _v0.a;
		var cmdAction_ = _v0.b;
		return A2(
			$elm$core$Tuple$mapFirst,
			initModuleDropdowns,
			function (model) {
				return A2($elm$core$Tuple$pair, model, cmdAction_);
			}(
				{
					cu: actualStep_,
					X: $author$project$TaskNode$emptyTask,
					bS: $elm$time$Time$millisToPosix(0),
					E: $elm$core$Dict$empty,
					aP: A2($author$project$Customized$InputDropdown$init, 'vehicleDealer', _List_Nil),
					cP: {cV: '', bt: ''},
					cQ: $author$project$Csf$Modal$hidden,
					bl: false,
					ar: false,
					c6: !isQueryEmpty,
					eP: $elm$core$Dict$empty,
					kX: query_,
					u: false,
					dn: !isQueryEmpty,
					bB: !isQueryEmpty,
					$7: !isQueryEmpty,
					dp: !isQueryEmpty,
					g$: session_,
					fz: false,
					l: $elm$core$Dict$empty,
					cl: tenantsDict_,
					dG: initUploader_,
					az: false,
					fV: $author$project$TaskNode$emptyTask,
					aj: $elm$core$Dict$empty,
					ad: A2($author$project$Customized$InputDropdown$init, 'vehicleVin', _List_Nil),
					fX: _List_Nil,
					cr: '',
					lG: $elm$time$Time$utc
				}));
	});
var $author$project$Page$SolicitudesChie$DatePickerMsg = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$GotTimeZone = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$allowedToSortBy = function (session_) {
	var dealer_ = $author$project$Page$SolicitudesChie$isSupportUser(session_) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'fl_importer',
			{is: 'tenant', lf: 'Importador'}),
			_Utils_Tuple2(
			'fl_dealer',
			{is: 'distribuidor', lf: 'Distribuidor'})
		]) : ($author$project$Page$SolicitudesChie$showDealer(session_) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'fl_dealer',
			{is: 'distribuidor', lf: 'Distribuidor'})
		]) : _List_fromArray(
		[
			_Utils_Tuple2(
			'fl_importer',
			{is: 'tenant', lf: 'Importador'})
		]));
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append(dealer_),
		$elm$core$Dict$fromList,
		_List_fromArray(
			[
				_Utils_Tuple2(
				'vh_vin',
				{is: 'vin', lf: 'Vin'}),
				_Utils_Tuple2(
				'vh_tipo',
				{is: 'tipo', lf: 'Tipo'}),
				_Utils_Tuple2(
				'vh_marca',
				{is: 'marca', lf: 'Marca'}),
				_Utils_Tuple2(
				'vh_modelo',
				{is: 'modelo', lf: 'Modelo'}),
				_Utils_Tuple2(
				'vh_anno',
				{is: 'ano', lf: 'Año'}),
				_Utils_Tuple2(
				'vh_color',
				{is: 'color', lf: 'Color'}),
				_Utils_Tuple2(
				'vh_motor',
				{is: 'motor', lf: 'N° Motor'}),
				_Utils_Tuple2(
				'vh_cit',
				{is: 'cit', lf: 'C.I.T'}),
				_Utils_Tuple2(
				'fl_patente',
				{is: 'patente', lf: 'Patente'}),
				_Utils_Tuple2(
				'fl_estado',
				{is: 'estado_chie', lf: 'Estado CHI-e'}),
				_Utils_Tuple2(
				'fl_emited',
				{is: 'fecha_emision_chie', lf: 'Fecha | Hora Emisión'}),
				_Utils_Tuple2(
				'fl_created',
				{is: 'inserted_at', lf: 'Fecha | Hora Solicitud'}),
				_Utils_Tuple2(
				'fl_correlativo',
				{is: 'correlativo', lf: 'Correlativo'}),
				_Utils_Tuple2(
				'fl_conciliacion',
				{is: 'estado_conciliacion_mtt', lf: 'Conciliación'})
			]));
};
var $author$project$Config$AppStates$estadosConciliacion = _List_fromArray(
	[
		A2($elm$core$Tuple$pair, 'CONCILIADO', 'Conciliado'),
		A2($elm$core$Tuple$pair, 'PENDIENTE_CONCILIACION', 'Pendiente'),
		A2($elm$core$Tuple$pair, 'PENDIENTE_CONCILIACION_POR_ERROR', 'Pendiente por error')
	]);
var $author$project$Helpers$Utilities$estadoDeConciliacion = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Config$AppStates$estadosConciliacion));
};
var $author$project$Page$SolicitudesChie$GotNodeDetails = function (a) {
	return {$: 48, a: a};
};
var $author$project$Csf$TaskNodeUtils$mbdatastring = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$TaskNode$string(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$datastring = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdatastring(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Config$ApiEndpoint$nodedetails = F3(
	function (tenant_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'tenant', tenant_, 'node', unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$detallesDeNode = F3(
	function (ticket_, tenant_, unique_id) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A3($author$project$Config$ApiEndpoint$nodedetails, tenant_, unique_id, ticket_),
				_List_Nil));
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Page$SolicitudesChie$fileNodeDetails = F2(
	function (ticket_, file_uuid) {
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$String$join(''),
			$elm$core$String$join(''),
			function (data) {
				return _Utils_Tuple2(
					A2($elm$core$List$drop, 1, data),
					A2($elm$core$List$take, 1, data));
			}(
				A2($elm$core$String$split, ':', file_uuid)));
		var unique_id = _v0.a;
		var tenant_ = _v0.b;
		var andThenInscription_ = function (expNde) {
			return A2(
				$elm$core$Task$map,
				$elm$core$Tuple$pair(expNde),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Task$succeed($author$project$TaskNode$emptyTask),
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Helpers$ApiHandler$detallesDeNode, ticket_, tenant_),
						$author$project$Helpers$Utilities$stringToMaybe(
							A3($author$project$Csf$TaskNodeUtils$datastring, '', 'solicitud_inscripcion', expNde)))));
		};
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Task$andThen(andThenInscription_),
			$elm$core$Task$attempt($author$project$Page$SolicitudesChie$GotNodeDetails),
			A3($author$project$Helpers$ApiHandler$detallesDeNode, ticket_, tenant_, unique_id));
	});
var $author$project$Page$SolicitudesChie$GotTime = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$SolicitudesChie$getCurrentTime = A2($elm$core$Task$perform, $author$project$Page$SolicitudesChie$GotTime, $elm$time$Time$now);
var $author$project$Helpers$Utilities$initDtePicker = function (pickerMsg) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map(pickerMsg),
		$author$project$DatePicker$init);
};
var $author$project$Config$AppStates$motivosAnulacionCHIE = _List_fromArray(
	[
		_Utils_Tuple2('Nota de Crédito a Factura', 'Nota de Crédito a Factura'),
		_Utils_Tuple2('Resciliación de motocicleta', 'Resciliación de motocicleta'),
		_Utils_Tuple2('Otro', 'Otro (agregue la causa)')
	]);
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Page$SolicitudesChie$stringFromField = function (field_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'NoField',
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$keys,
			$elm$core$List$head,
			A2(
				$elm$core$Dict$filter,
				F2(
					function (_v0, value_) {
						return _Utils_eq(field_, value_);
					}),
				$author$project$Page$SolicitudesChie$fieldStringSet)));
};
var $author$project$Config$AppTenants$emptyTenantInfo = {cW: '', c7: '', dc: '', dx: _List_Nil};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Helpers$Utilities$tenantInfo = F2(
	function (dict_, tenant_) {
		var yamaImportInfoMap_ = function (tInfo) {
			return (tenant_ !== 'yamaimport_qa_chie') ? tInfo : _Utils_update(
				tInfo,
				{
					c7: A3($elm$core$String$replace, 'yamaimport', 'gm', tInfo.c7),
					dx: _List_Nil
				});
		};
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Config$AppTenants$emptyTenantInfo,
			A2(
				$elm$core$Maybe$map,
				yamaImportInfoMap_,
				function (key_) {
					return A2($elm$core$Dict$get, key_, dict_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						$elm$core$Maybe$withDefault(''),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$split('|'),
								$elm$core$List$member(tenant_)),
							$elm$core$Dict$keys(dict_))))));
	});
var $author$project$Helpers$Utilities$updateDtePicker = F3(
	function (key_, dtePicker, model) {
		var moduleDatePickers = model.gI;
		return function (pickers_) {
			return _Utils_update(
				model,
				{gI: pickers_});
		}(
			A3($elm$core$Dict$insert, key_, dtePicker, moduleDatePickers));
	});
var $author$project$Helpers$Utilities$updateModuleDate = F3(
	function (key_, mbDate_, model) {
		var moduleDates = model.gJ;
		return function (dates_) {
			return _Utils_update(
				model,
				{gJ: dates_});
		}(
			A2(
				$elm$core$Maybe$withDefault,
				A2($elm$core$Dict$remove, key_, moduleDates),
				A2(
					$elm$core$Maybe$map,
					function (date_) {
						return A3($elm$core$Dict$insert, key_, date_, moduleDates);
					},
					mbDate_)));
	});
var $author$project$Page$SolicitudesChie$init = F3(
	function (session_, tenantsDict_, query_) {
		var navKey = session_.gL;
		var toggle_vehicle = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['tipo_vehiculo', 'patente', 'cit', 'vin', 'motor', 'anno', 'color', 'marca', 'modelo']));
		var toggle_fecha = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['fechaini', 'fechafin']));
		var toggle_emision = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['emisionfini', 'emisionffin']));
		var toggle_chie = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['estado', 'dealer', 'importer', 'conciliate', 'correlativo']));
		var ticket_ = $author$project$Csf$Flags$ticket(session_.ka);
		var tenantInfo_ = function (tnant) {
			return A2(
				$elm$core$Maybe$withDefault,
				tnant,
				$author$project$Helpers$Utilities$stringToMaybe(
					A2(
						$elm$core$Basics$composeR,
						$author$project$Helpers$Utilities$tenantInfo(tenantsDict_),
						function ($) {
							return $.dc;
						})(tnant)));
		};
		var tableState_ = F2(
			function (sorter_key, order_) {
				return function (column_) {
					return A2($author$project$Csf$Table$sortBy, column_, order_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.lf;
							}),
						$elm$core$Maybe$withDefault('None'),
						A2(
							$elm$core$Dict$get,
							sorter_key,
							$author$project$Page$SolicitudesChie$allowedToSortBy(session_))));
			});
		var page_ = $author$project$Helpers$Utilities$pageFromQuery(query_);
		var pageSize = $author$project$Helpers$Utilities$pageSizeFromQuery(query_);
		var nodePager_ = function (route_) {
			return A4(
				$author$project$Csf$NodePager$init,
				route_,
				_Utils_Tuple2(page_, pageSize),
				'Expedientes',
				0);
		}(
			_Utils_Tuple2(
				navKey,
				$author$project$Route$SolicitudesChie(
					{iI: query_})));
		var initModuleDate_ = F2(
			function (key_, model_) {
				return function (mbDate) {
					return A3($author$project$Helpers$Utilities$updateModuleDate, key_, mbDate, model_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$justinmimbs$date$Date$fromIsoString,
						$elm$core$Result$toMaybe,
						A2($author$project$Route$dataFromQuery, key_, query_)));
			});
		var initDateNPicker = F2(
			function (key_, _v6) {
				var model_ = _v6.a;
				var cmdActionList = _v6.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (pickerCmd) {
						return A2($elm$core$List$cons, pickerCmd, cmdActionList);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						initModuleDate_(key_),
						A2(
							$elm$core$Tuple$mapFirst,
							function (picker_) {
								return A3($author$project$Helpers$Utilities$updateDtePicker, key_, picker_, model_);
							},
							$author$project$Helpers$Utilities$initDtePicker(
								$author$project$Page$SolicitudesChie$DatePickerMsg(key_)))));
			});
		var initDatesAndPickers = function (_v5) {
			var model_ = _v5.a;
			var cmdAction_ = _v5.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$batch,
				A2(
					initDateNPicker,
					'emisionffin',
					A2(
						initDateNPicker,
						'emisionfini',
						A2(
							initDateNPicker,
							'fechafin',
							A2(
								initDateNPicker,
								'fechaini',
								_Utils_Tuple2(
									model_,
									_List_fromArray(
										[cmdAction_])))))));
		};
		var fromIdx = A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$mul(pageSize),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$sub(pageSize),
				$elm$core$Basics$abs))(page_);
		var filterBadges_ = A3(
			$author$project$Csf$FilterBadges$init,
			navKey,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$estadoDelChie, tenantInfo_),
				$author$project$Helpers$Utilities$estadoDeConciliacion),
			$author$project$Route$SolicitudesChie(
				{iI: query_}));
		var dropdownFromQuery = F2(
			function (key_, action_) {
				return A2(
					$elm$core$Maybe$map,
					function (data_) {
						return A2(
							$elm$core$Tuple$pair,
							data_,
							action_(data_));
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Route$dataFromQuery(key_),
						$author$project$Helpers$Utilities$stringToMaybe)(query_));
			});
		var initModuleDropdowns_ = function (model_) {
			return A5(
				$author$project$Helpers$Utilities$initDropdown,
				$author$project$Config$AppStates$motivosAnulacionCHIE,
				$author$project$Page$SolicitudesChie$stringFromField(4),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just('Seleccione motivo...'),
				A5(
					$author$project$Helpers$Utilities$initDropdown,
					_List_Nil,
					$author$project$Page$SolicitudesChie$stringFromField(9),
					A2(dropdownFromQuery, 'modelo', $elm$core$Basics$identity),
					$elm$core$Maybe$Just('Seleccione modelo...'),
					A5(
						$author$project$Helpers$Utilities$initDropdown,
						_List_Nil,
						$author$project$Page$SolicitudesChie$stringFromField(8),
						A2(dropdownFromQuery, 'marca', $elm$core$Basics$identity),
						$elm$core$Maybe$Just('Seleccione marca...'),
						A5(
							$author$project$Helpers$Utilities$initDropdown,
							_List_Nil,
							$author$project$Page$SolicitudesChie$stringFromField(7),
							A2(dropdownFromQuery, 'color', $elm$core$Basics$identity),
							$elm$core$Maybe$Just('Seleccione color...'),
							A5(
								$author$project$Helpers$Utilities$initDropdown,
								_List_Nil,
								$author$project$Page$SolicitudesChie$stringFromField(6),
								A2(dropdownFromQuery, 'anno', $elm$core$Basics$identity),
								$elm$core$Maybe$Just('Seleccione año...'),
								A5(
									$author$project$Helpers$Utilities$initDropdown,
									_List_Nil,
									$author$project$Page$SolicitudesChie$stringFromField(11),
									A2(dropdownFromQuery, 'tipo_vehiculo', $elm$core$Basics$identity),
									$elm$core$Maybe$Just('Seleccione tipo...'),
									A5(
										$author$project$Helpers$Utilities$initDropdown,
										_List_Nil,
										$author$project$Page$SolicitudesChie$stringFromField(12),
										A2(dropdownFromQuery, 'motor', $elm$core$Basics$identity),
										$elm$core$Maybe$Just('Seleccione Nro Motor...'),
										A5(
											$author$project$Helpers$Utilities$initDropdown,
											$author$project$Config$AppStates$estadosConciliacion,
											$author$project$Page$SolicitudesChie$stringFromField(15),
											A2(dropdownFromQuery, 'conciliate', $author$project$Helpers$Utilities$estadoDeConciliacion),
											$elm$core$Maybe$Just('Seleccione estado...'),
											A5(
												$author$project$Helpers$Utilities$initDropdown,
												_List_Nil,
												$author$project$Page$SolicitudesChie$stringFromField(10),
												A2(dropdownFromQuery, 'estado', $author$project$Helpers$Utilities$estadoDelChie),
												$elm$core$Maybe$Just('Seleccione estado...'),
												A5(
													$author$project$Helpers$Utilities$initDropdown,
													_List_Nil,
													$author$project$Page$SolicitudesChie$stringFromField(14),
													A2(dropdownFromQuery, 'dealer', $elm$core$Basics$identity),
													$elm$core$Maybe$Just('Seleccione distribuidor...'),
													A5(
														$author$project$Helpers$Utilities$initDropdown,
														_List_Nil,
														$author$project$Page$SolicitudesChie$stringFromField(13),
														A2(dropdownFromQuery, 'importer', tenantInfo_),
														$elm$core$Maybe$Just('Seleccione importador...'),
														model_)))))))))));
		};
		var callForNodes = function (sortSearchBy) {
			return $author$project$Csf$Core$localZone(
				A3(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					$author$project$Page$SolicitudesChie$GotTimeZone,
					A3(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$object,
						$elm$json$Json$Encode$encode(0),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'sort_by',
								$elm$json$Json$Encode$string(sortSearchBy)),
								_Utils_Tuple2(
								'from_',
								$elm$json$Json$Encode$string(
									$elm$core$String$fromInt(fromIdx))),
								_Utils_Tuple2(
								'size_',
								$elm$json$Json$Encode$string(
									$elm$core$String$fromInt(pageSize)))
							]))));
		};
		var _v0 = function () {
			var _v1 = A2(
				$author$project$Helpers$Utilities$sortByFromQuery,
				$author$project$Page$SolicitudesChie$allowedToSortBy(session_),
				query_);
			if (_v1.$ === 1) {
				return A2($elm$core$Dict$member, 'sortBy', query_) ? A2(
					$elm$core$Tuple$pair,
					$author$project$Csf$Table$initialSort('None'),
					A3(
						$elm$core$Basics$composeR,
						$author$project$Route$SolicitudesChie,
						$author$project$Route$goTo(navKey),
						{
							iI: A2($author$project$Route$removeFromQuery, 'sortBy', query_)
						})) : A2(
					$elm$core$Tuple$pair,
					A2(tableState_, 'fl_created', 1),
					callForNodes('inserted_at:desc'));
			} else {
				var _v2 = _v1.a;
				var sorter_key = _v2.a;
				var order_ = _v2.b;
				var node_sorter = _v2.c;
				return _Utils_Tuple2(
					A2(tableState_, sorter_key, order_),
					callForNodes(node_sorter));
			}
		}();
		var tableState = _v0.a;
		var initCmdAction = _v0.b;
		var cmdActions = $elm$core$Platform$Cmd$batch(
			function () {
				var _v3 = _Utils_Tuple2(
					A2($elm$core$Dict$member, 'file_uuid', query_),
					1 !== $elm$core$Dict$size(query_));
				if (_v3.a) {
					if (_v3.b) {
						return A3(
							$elm$core$Basics$composeR,
							$author$project$Route$goTo(navKey),
							$elm$core$List$singleton,
							function (updQuery) {
								return $author$project$Route$SolicitudesChie(
									{iI: updQuery});
							}(
								A2(
									$elm$core$Dict$filter,
									F2(
										function (key_, _v4) {
											return 'file_uuid' === key_;
										}),
									query_)));
					} else {
						return _List_fromArray(
							[
								$author$project$Csf$Core$localZone(
								$author$project$Page$SolicitudesChie$GotTimeZone($elm$core$Maybe$Nothing)),
								A2(
								$author$project$Page$SolicitudesChie$fileNodeDetails,
								ticket_,
								A2($author$project$Route$dataFromQuery, 'file_uuid', query_)),
								$author$project$Page$SolicitudesChie$getCurrentTime
							]);
					}
				} else {
					return _List_fromArray(
						[initCmdAction]);
				}
			}());
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$mapFirst(initModuleDropdowns_),
			initDatesAndPickers,
			function (model) {
				return A2($elm$core$Tuple$pair, model, cmdActions);
			}(
				{
					aK: '',
					ae: 'tab_solicitud',
					bL: $author$project$Csf$Modal$hidden,
					bQ: false,
					bR: '',
					d9: '',
					am: {ef: '', hP: '', br: false, bF: '', dJ: $author$project$Csf$Modal$hidden},
					cD: A2($elm$core$Dict$member, 'file_uuid', query_),
					ao: $elm$core$Dict$empty,
					bZ: false,
					b_: $author$project$Csf$Modal$hidden,
					cT: $author$project$Csf$Modal$hidden,
					b5: _List_Nil,
					b6: _List_Nil,
					b: $author$project$TaskNode$emptyTask,
					b7: false,
					b8: filterBadges_,
					bp: $author$project$Helpers$ApiHandler$emptySearchResp,
					bu: $elm$core$Dict$empty,
					eO: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dashlet_fecha',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_fecha, false)),
								_Utils_Tuple2(
								'dashlet_emision',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_emision, false)),
								_Utils_Tuple2(
								'dashlet_chie',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_chie, false)),
								_Utils_Tuple2(
								'dashlet_vehicle',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_vehicle, false))
							])),
					gI: $elm$core$Dict$empty,
					gJ: $elm$core$Dict$empty,
					eP: $elm$core$Dict$empty,
					cf: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Page$SolicitudesChie$stringFromField(1),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Vin',
									A2($author$project$Route$dataFromQuery, 'vin', query_))),
								_Utils_Tuple2(
								$author$project$Page$SolicitudesChie$stringFromField(2),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'C.I.T',
									A2($author$project$Route$dataFromQuery, 'cit', query_))),
								_Utils_Tuple2(
								$author$project$Page$SolicitudesChie$stringFromField(3),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Patente',
									A2($author$project$Route$dataFromQuery, 'patente', query_))),
								_Utils_Tuple2(
								$author$project$Page$SolicitudesChie$stringFromField(5),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Correlativo',
									A2($author$project$Route$dataFromQuery, 'correlativo', query_)))
							])),
					aF: nodePager_,
					Q: $author$project$Csf$Form$strFieldModel(''),
					de: '',
					ch: $author$project$Csf$Modal$hidden,
					ci: 'Anular CHI-e',
					bw: false,
					dj: $elm$core$Maybe$Nothing,
					aG: $author$project$Csf$Form$strFieldModel(''),
					kX: query_,
					g$: session_,
					l: $elm$core$Dict$empty,
					jb: $author$project$Csf$Table$init(
						{r: _List_Nil, w: tableState}),
					cl: tenantsDict_,
					dE: 0,
					lG: $elm$time$Time$utc
				}));
	});
var $author$project$Page$SolicitudesPendientes$FechaFinPickerMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$SolicitudesPendientes$FechaIniPickerMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$SolicitudesPendientes$GotRequestsDealers = function (a) {
	return {$: 39, a: a};
};
var $author$project$Page$SolicitudesPendientes$GotTimeZone = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$TaskFullDetails = function (a) {
	return {$: 41, a: a};
};
var $author$project$Page$SolicitudesPendientes$allowedToSortBy = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'tsk_fecha',
			{is: 'inserted_at', lf: 'Fecha Tarea'})
		]));
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField = function (field_) {
	return A3($author$project$Helpers$Utilities$keyFromDict, 'NoField', field_, $author$project$Page$SolicitudesPendientes$ModuleHelpers$fieldStringSet);
};
var $author$project$Config$ApiEndpoint$nodechildren = F3(
	function (tenant_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'tenant', tenant_, 'node', unique_id, 'children', 'secondary']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$TaskNode$type_ = $author$project$TaskNode$string('type');
var $author$project$TaskNode$typeWithDefault = F2(
	function (default_, props) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			$author$project$TaskNode$type_(props));
	});
var $author$project$TaskNode$typeOrEmpty = $author$project$TaskNode$typeWithDefault('');
var $author$project$Helpers$ApiHandler$childrenFromNode = F3(
	function (ticket_, tenant_, unique_id) {
		var childrenDecoder_ = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['response', 'msg']),
			$elm$json$Json$Decode$list($author$project$Csf$AlbertoApi$decoderTaskNode));
		var andFilter_ = $elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.dm;
					},
					$author$project$TaskNode$typeOrEmpty),
				$elm$core$Basics$neq('solicitud_chie')));
		return A2(
			$elm$core$Task$map,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Helpers$Utilities$decodeString_, _List_Nil, childrenDecoder_),
				andFilter_),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A3($author$project$Config$ApiEndpoint$nodechildren, tenant_, unique_id, ticket_),
				_List_Nil));
	});
var $author$project$TaskNode$list = $author$project$TaskNode$prop(
	$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
var $author$project$Csf$TaskNodeUtils$mbdatalist = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$TaskNode$list(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$datalist = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdatalist(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Helpers$ExtensionsUtils$ExtensionData = function (estado_chie) {
	return function (estado_general) {
		return function (fecha_solicitud_extension) {
			return function (fecha_emision_extension) {
				return function (fecha_vencimiento_extension) {
					return function (uuid_extension) {
						return function (numero_extension) {
							return function (solicitante) {
								return function (correlativo) {
									return function (fecha_anulacion_extension) {
										return function (anulado_por_nombre) {
											return function (motivo_anulacion) {
												return function (causa_anulacion) {
													return function (anulado_por_usuario) {
														return {jD: anulado_por_nombre, jE: anulado_por_usuario, jL: causa_anulacion, jR: correlativo, j0: estado_chie, gl: estado_general, j6: fecha_anulacion_extension, j7: fecha_emision_extension, j8: fecha_solicitud_extension, j9: fecha_vencimiento_extension, kC: motivo_anulacion, kQ: numero_extension, k8: solicitante, ls: uuid_extension};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Helpers$ExtensionsUtils$decodeExtensionData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'anulado_por_usuario',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'causa_anulacion',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'motivo_anulacion',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'anulado_por_nombre',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'fecha_anulacion_extension',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'correlativo',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'solicitante',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'numero_extension',
								$elm$json$Json$Decode$int,
								1,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'uuid_extension',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'fecha_vencimiento_extension',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'fecha_emision_extension',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'fecha_solicitud_extension',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'estado_general',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'estado_chie',
														$elm$json$Json$Decode$string,
														'',
														$elm$json$Json$Decode$succeed($author$project$Helpers$ExtensionsUtils$ExtensionData)))))))))))))));
var $author$project$Helpers$ExtensionsUtils$decodeExtensions = function (taskNode_) {
	var extensionesValues = A3($author$project$Csf$TaskNodeUtils$datalist, _List_Nil, 'extensiones', taskNode_);
	var decodedExtensions = A2(
		$elm$core$List$filterMap,
		function (val) {
			return $elm$core$Result$toMaybe(
				A2($elm$json$Json$Decode$decodeValue, $author$project$Helpers$ExtensionsUtils$decodeExtensionData, val));
		},
		extensionesValues);
	return decodedExtensions;
};
var $author$project$Helpers$ApiHandler$decodeTaskNode = function () {
	var decode_namespace = function (andThen_) {
		return A2($elm$json$Json$Decode$andThen, andThen_, $elm$json$Json$Decode$string);
	}(
		function (string_) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Error decoding namespace.'),
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Decode$succeed,
					A3(
						$elm$core$Basics$composeR,
						$elm$core$List$reverse,
						$elm$core$List$head,
						A2($elm$core$String$split, '/', string_))));
		});
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A3(
				$elm$json$Json$Decode$map2,
				$author$project$TaskNode$TaskNode,
				A2($elm$json$Json$Decode$field, 'uuid', $elm$json$Json$Decode$string),
				$author$project$Csf$AlbertoApi$decoderProps),
				A3(
				$elm$json$Json$Decode$map2,
				$author$project$TaskNode$TaskNode,
				A2($elm$json$Json$Decode$field, 'namespace', decode_namespace),
				$author$project$Csf$AlbertoApi$decoderProps),
				A3(
				$elm$json$Json$Decode$map2,
				$author$project$TaskNode$TaskNode,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['response', 'task', 'namespace']),
					decode_namespace),
				A2($elm$json$Json$Decode$field, 'response', $author$project$Csf$AlbertoApi$decoderProps))
			]));
}();
var $author$project$Helpers$ApiHandler$taskNodeFromString = A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode);
var $author$project$Config$ApiEndpoint$workflowdetails = F3(
	function (task_service_, task_uuid_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['workflowservice', 'service', task_service_, 'task', task_uuid_, 'details']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$detallesDeTarea = F3(
	function (ticket_, service_, uuid_) {
		return A2(
			$elm$core$Task$map,
			$author$project$Helpers$ApiHandler$taskNodeFromString,
			A2(
				$author$project$Helpers$ApiHandler$get,
				A3($author$project$Config$ApiEndpoint$workflowdetails, service_, uuid_, ticket_),
				_List_Nil));
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Config$ApiEndpoint$workflowhistoryExtended = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-extension-service', 'api', 'all_history_tasks']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$historialExtendedEnWorkflow = F2(
	function (ticket_, ids_) {
		var taskNdeDcoder_ = $elm$json$Json$Decode$list($author$project$Helpers$ApiHandler$decodeTaskNode);
		var stringDcoder_ = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['response', 'workflow_details']),
			taskNdeDcoder_);
		var mapDecoder_ = A2($author$project$Helpers$Utilities$decodeString_, _List_Nil, stringDcoder_);
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ids_))
				]));
		return A2(
			$elm$core$Task$map,
			mapDecoder_,
			A3(
				$author$project$Helpers$ApiHandler$post,
				$author$project$Config$ApiEndpoint$workflowhistoryExtended(ticket_),
				_List_Nil,
				$elm$http$Http$jsonBody(body_)));
	});
var $author$project$Csf$TaskNodeUtils$mbstring = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TaskNode$string(key),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$string = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbstring(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Csf$TaskNodeUtils$value = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbvalue(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Page$SolicitudesPendientes$ModuleActions$taskFullDetails = F2(
	function (ticket_, namespace_) {
		var vehicleNodeFromSearch_ = A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kh;
				},
				$elm$core$List$head),
			$elm$core$Maybe$withDefault($author$project$TaskNode$emptyTask));
		var unconsTaskItem_ = F2(
			function (idx, lst) {
				return A3(
					$elm$core$Basics$composeR,
					$elm$core$List$head,
					$elm$core$Maybe$withDefault($author$project$TaskNode$emptyTask),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm_community$list_extra$List$Extra$getAt, idx, lst)));
			});
		var taskSequenceMap_ = function (taskList) {
			return {
				j_: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm_community$list_extra$List$Extra$getAt, 3, taskList)),
				kg: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm_community$list_extra$List$Extra$getAt, 4, taskList)),
				kp: A2(unconsTaskItem_, 2, taskList),
				li: A2(unconsTaskItem_, 0, taskList),
				lu: A2(unconsTaskItem_, 1, taskList)
			};
		};
		var node_ = function (tNde) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$Just,
				A2($author$project$Helpers$Utilities$decodeMbValue, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
				A3($author$project$Csf$TaskNodeUtils$value, $elm$json$Json$Encode$null, 'node', tNde));
		};
		var taskNodeId_ = A2(
			$elm$core$Basics$composeR,
			node_,
			function ($) {
				return $.p;
			});
		var taskNodeTenant_ = A2(
			$elm$core$Basics$composeR,
			node_,
			A2($author$project$Csf$TaskNodeUtils$string, '', 'tenant'));
		var taskNodeType_ = A2(
			$elm$core$Basics$composeR,
			node_,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dm;
				},
				$author$project$TaskNode$typeOrEmpty));
		var vehicleVin_ = A2(
			$elm$core$Basics$composeR,
			node_,
			A2($author$project$Csf$TaskNodeUtils$datastring, '', 'vin'));
		var inscriptionUUID_ = A2(
			$elm$core$Basics$composeR,
			node_,
			A2($author$project$Csf$TaskNodeUtils$datastring, '', 'solicitud_inscripcion'));
		var taskDetailsAndThen = function (tNde) {
			var historialExtendedEnWorkFlow_ = function () {
				var ids_ = A2(
					$elm$core$List$cons,
					taskNodeId_(tNde),
					A2(
						$elm$core$List$map,
						function (e) {
							return e.ls;
						},
						$author$project$Helpers$ExtensionsUtils$decodeExtensions(tNde)));
				return A2($author$project$Helpers$ApiHandler$historialExtendedEnWorkflow, ticket_, ids_);
			}();
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Task$sequence,
				$elm$core$Task$map(taskSequenceMap_))(
				_List_fromArray(
					[
						$elm$core$Task$succeed(
						_List_fromArray(
							[tNde])),
						A2(
						$elm$core$Task$map,
						A2($elm$core$Basics$composeR, vehicleNodeFromSearch_, $elm$core$List$singleton),
						A2(
							$author$project$Helpers$ApiHandler$vehiculoByVin,
							ticket_,
							vehicleVin_(tNde))),
						A2(
						$elm$core$Task$map,
						$elm$core$List$singleton,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Task$succeed($author$project$TaskNode$emptyTask),
							A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Helpers$ApiHandler$detallesDeNode,
									ticket_,
									taskNodeTenant_(tNde)),
								A2($elm$core$Basics$composeR, inscriptionUUID_, $author$project$Helpers$Utilities$stringToMaybe)(tNde)))),
						A3(
						$author$project$Helpers$ApiHandler$childrenFromNode,
						ticket_,
						taskNodeTenant_(tNde),
						taskNodeId_(tNde)),
						historialExtendedEnWorkFlow_
					]));
		};
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$String$join(''),
			$elm$core$String$join(''),
			function (l) {
				return _Utils_Tuple2(
					A2($elm$core$List$take, 1, l),
					A2($elm$core$List$drop, 1, l));
			}(
				A2($elm$core$String$split, ':', namespace_)));
		var service_ = _v0.a;
		var uuid_ = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			taskDetailsAndThen,
			A3($author$project$Helpers$ApiHandler$detallesDeTarea, ticket_, service_, uuid_));
	});
var $author$project$Page$SolicitudesPendientes$init = F3(
	function (taskName_, session_, query_) {
		var navKey = session_.gL;
		var toggle_vehicle = false;
		var toggle_tarea = A2(
			$elm$core$List$any,
			function (key_) {
				return A2($elm$core$Dict$member, key_, query_);
			},
			_List_fromArray(
				['fechaini', 'fechafin', 'dealer', 'ppu']));
		var ticket_ = $author$project$Csf$Flags$ticket(session_.ka);
		var tableState_ = F2(
			function (sorter_key, order_) {
				return function (column_) {
					return A2($author$project$Csf$Table$sortBy, column_, order_);
				}(
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.lf;
							}),
						$elm$core$Maybe$withDefault('None'),
						A2($elm$core$Dict$get, sorter_key, $author$project$Page$SolicitudesPendientes$allowedToSortBy)));
			});
		var page_ = $author$project$Helpers$Utilities$pageFromQuery(query_);
		var pageSize = $author$project$Helpers$Utilities$pageSizeFromQuery(query_);
		var pageRoute_ = A2(
			$elm$core$List$member,
			taskName_,
			_List_fromArray(
				['chie_firmar_certificado', 'chie_firmar_certificado_extension'])) ? $author$project$Route$PendientesDeFirma : $author$project$Route$PendientesAprobacion;
		var nodePager_ = function (route_) {
			return A4(
				$author$project$Csf$NodePager$init,
				route_,
				_Utils_Tuple2(page_, pageSize),
				'Solicitudes',
				0);
		}(
			_Utils_Tuple2(
				navKey,
				pageRoute_(
					{iI: query_})));
		var fromIdx = A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$mul(pageSize),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$sub(pageSize),
				$elm$core$Basics$abs))(page_);
		var filterBadges_ = A3(
			$author$project$Csf$FilterBadges$init,
			navKey,
			$elm$core$Basics$identity,
			pageRoute_(
				{iI: query_}));
		var fechaFilterIni_ = A3(
			$elm$core$Basics$composeR,
			$justinmimbs$date$Date$fromIsoString,
			$elm$core$Result$toMaybe,
			A2($author$project$Route$dataFromQuery, 'fechaini', query_));
		var fechaFilterFin_ = A3(
			$elm$core$Basics$composeR,
			$justinmimbs$date$Date$fromIsoString,
			$elm$core$Result$toMaybe,
			A2($author$project$Route$dataFromQuery, 'fechafin', query_));
		var dropdownFromQuery = F2(
			function (key_, action_) {
				return A2(
					$elm$core$Maybe$map,
					function (data_) {
						return A2(
							$elm$core$Tuple$pair,
							data_,
							action_(data_));
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Route$dataFromQuery(key_),
						$author$project$Helpers$Utilities$stringToMaybe)(query_));
			});
		var initModuleDropdowns_ = function (model_) {
			return A5(
				$author$project$Helpers$Utilities$initDropdown,
				$author$project$Helpers$Utilities$tiposDeVehiculo,
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(7),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just('Seleccione tipo...'),
				A5(
					$author$project$Helpers$Utilities$initDropdown,
					_List_Nil,
					$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(6),
					A2(dropdownFromQuery, 'modelo', $elm$core$Basics$identity),
					$elm$core$Maybe$Just('Seleccione modelo...'),
					A5(
						$author$project$Helpers$Utilities$initDropdown,
						_List_Nil,
						$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(5),
						A2(dropdownFromQuery, 'marca', $elm$core$Basics$identity),
						$elm$core$Maybe$Just('Seleccione marca...'),
						A5(
							$author$project$Helpers$Utilities$initDropdown,
							_List_Nil,
							$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(8),
							A2(dropdownFromQuery, 'dealer', $elm$core$Basics$identity),
							$elm$core$Maybe$Just('Seleccione distribuidor...'),
							model_))));
		};
		var dateTimeAndZone_ = function (msg_) {
			return A2(
				$elm$core$Task$perform,
				msg_,
				A2(
					$elm$core$Task$andThen,
					function (here) {
						return A2(
							$elm$core$Task$map,
							$elm$core$Tuple$pair(here),
							$elm$time$Time$now);
					},
					$elm$time$Time$here));
		};
		var callForNodes = function (sortSearchBy) {
			return A3(
				$elm$core$Basics$composeR,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Page$SolicitudesPendientes$GotTimeZone),
				dateTimeAndZone_,
				A3(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$object,
					$elm$json$Json$Encode$encode(0),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'sort_by',
							$elm$json$Json$Encode$string(sortSearchBy)),
							_Utils_Tuple2(
							'from_',
							$elm$json$Json$Encode$string(
								$elm$core$String$fromInt(fromIdx))),
							_Utils_Tuple2(
							'size_',
							$elm$json$Json$Encode$string(
								$elm$core$String$fromInt(pageSize)))
						])));
		};
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$FechaIniPickerMsg),
			$author$project$DatePicker$init);
		var pickerFechaIni = _v0.a;
		var pickerFechaIniCmdFix = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$FechaFinPickerMsg),
			$author$project$DatePicker$init);
		var pickerFechaFin = _v1.a;
		var pickerFechaFinCmdFix = _v1.b;
		var _v2 = function () {
			var _v3 = A2($author$project$Helpers$Utilities$sortByFromQuery, $author$project$Page$SolicitudesPendientes$allowedToSortBy, query_);
			if (_v3.$ === 1) {
				return A2($elm$core$Dict$member, 'sortBy', query_) ? A2(
					$elm$core$Tuple$pair,
					$author$project$Csf$Table$initialSort('None'),
					A3(
						$elm$core$Basics$composeR,
						pageRoute_,
						$author$project$Route$goTo(navKey),
						{
							iI: A2($author$project$Route$removeFromQuery, 'sortBy', query_)
						})) : A2(
					$elm$core$Tuple$pair,
					A2(tableState_, 'tsk_fecha', 1),
					callForNodes('inserted_at:desc'));
			} else {
				var _v4 = _v3.a;
				var sorter_key = _v4.a;
				var order_ = _v4.b;
				var node_sorter = _v4.c;
				return _Utils_Tuple2(
					A2(tableState_, sorter_key, order_),
					callForNodes(node_sorter));
			}
		}();
		var tableState = _v2.a;
		var initCmdAction = _v2.b;
		var cmdActions = $elm$core$Platform$Cmd$batch(
			(A2($elm$core$Dict$member, 'namespace', query_) && A3(
				$elm$core$Basics$composeR,
				$elm$core$Dict$size,
				$elm$core$Basics$neq(1),
				query_)) ? A3(
				$elm$core$Basics$composeR,
				$author$project$Route$goTo(session_.gL),
				$elm$core$List$singleton,
				function (updQuery) {
					return pageRoute_(
						{iI: updQuery});
				}(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (key_, _v5) {
								return key_ === 'namespace';
							}),
						query_))) : (A2($elm$core$Dict$member, 'namespace', query_) ? _List_fromArray(
				[
					dateTimeAndZone_(
					$author$project$Page$SolicitudesPendientes$GotTimeZone($elm$core$Maybe$Nothing)),
					A2(
					$elm$core$Task$attempt,
					$author$project$Page$SolicitudesPendientes$GotRequestsDealers,
					A3(
						$author$project$Helpers$ApiHandler$buscarAgregaciones,
						ticket_,
						'files',
						_List_fromArray(
							['distribuidor']))),
					A2(
					$elm$core$Task$attempt,
					$author$project$Page$SolicitudesPendientes$TaskFullDetails,
					A2(
						$author$project$Page$SolicitudesPendientes$ModuleActions$taskFullDetails,
						ticket_,
						A2($author$project$Route$dataFromQuery, 'namespace', query_)))
				]) : _List_fromArray(
				[initCmdAction, pickerFechaIniCmdFix, pickerFechaFinCmdFix])));
		return A2(
			$elm$core$Tuple$mapFirst,
			initModuleDropdowns_,
			function (model) {
				return A2($elm$core$Tuple$pair, model, cmdActions);
			}(
				{
					aK: '',
					ae: 'tab_solicitud',
					bS: $elm$time$Time$millisToPosix(0),
					E: $elm$core$Dict$empty,
					aP: A2($author$project$Customized$InputDropdown$init, 'vehicleDealer', _List_Nil),
					cD: A2($elm$core$Dict$member, 'namespace', query_),
					cL: pickerFechaFin,
					cM: pickerFechaIni,
					b3: fechaFilterFin_,
					b4: fechaFilterIni_,
					b8: filterBadges_,
					e: false,
					aW: '',
					ar: false,
					eI: $author$project$Helpers$ApiHandler$emptySearchResp,
					eO: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dashlet_tarea',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_tarea, false)),
								_Utils_Tuple2(
								'dashlet_vehicle',
								A2($author$project$Helpers$Utilities$initDashletDict, toggle_vehicle, false))
							])),
					eP: $elm$core$Dict$empty,
					cf: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(1),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Vin',
									A2($author$project$Route$dataFromQuery, 'vin', query_))),
								_Utils_Tuple2(
								$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(3),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Email Propietario',
									A2($author$project$Route$dataFromQuery, 'email', query_))),
								_Utils_Tuple2(
								$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(4),
								A2(
									$author$project$Helpers$Utilities$initFieldDict,
									'Patente',
									A2($author$project$Route$dataFromQuery, 'ppu', query_)))
							])),
					aF: nodePager_,
					bv: $author$project$Csf$Modal$hidden,
					df: $author$project$Csf$Form$strFieldModel(''),
					kX: query_,
					dn: A2($elm$core$Dict$member, 'namespace', query_),
					g$: session_,
					fz: false,
					l: $elm$core$Dict$empty,
					jb: $author$project$Csf$Table$init(
						{r: _List_Nil, w: tableState}),
					fD: _List_Nil,
					fE: _List_Nil,
					fF: $author$project$TaskNode$emptyTask,
					jd: taskName_,
					dA: false,
					dE: 0,
					fV: $author$project$TaskNode$emptyTask,
					aj: $elm$core$Dict$empty,
					ad: A2($author$project$Customized$InputDropdown$init, 'vehicleVin', _List_Nil),
					fX: _List_Nil,
					lG: $elm$time$Time$utc
				}));
	});
var $author$project$Helpers$ApiHandler$delete = F2(
	function (serviceUrl, headers_) {
		return $elm$http$Http$task(
			_Utils_update(
				$author$project$Helpers$ApiHandler$taskRequest,
				{i: headers_, j: 'DELETE', q: serviceUrl}));
	});
var $author$project$Config$ApiEndpoint$userlogout = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['userservice', 'logout']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$logout = A2(
	$elm$core$Basics$composeR,
	$author$project$Config$ApiEndpoint$userlogout,
	function (service_) {
		return A2($author$project$Helpers$ApiHandler$delete, service_, _List_Nil);
	});
var $author$project$Ports$doLogout = _Platform_outgoingPort('doLogout', $elm$core$Basics$identity);
var $author$project$Helpers$ApiHandler$logout_ = function (stringPath) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$json$Json$Encode$object,
		$author$project$Ports$doLogout,
		_List_fromArray(
			[
				_Utils_Tuple2(
				'path',
				$elm$json$Json$Encode$string(stringPath))
			]));
};
var $author$project$Page$CargarStock$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$ConsultarStock$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$DashboardChie$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$HistorialDeCargas$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$RepositorioChie$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$SolicitarChie$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$SolicitudesChie$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Page$SolicitudesPendientes$toSession = function (_v0) {
	var session = _v0.g$;
	return session;
};
var $author$project$Main$pageSession = function (page) {
	switch (page.$) {
		case 0:
			var session = page.a;
			return session;
		case 1:
			var session = page.a;
			return session;
		case 3:
			var session = page.a;
			return session;
		case 2:
			var session = page.a;
			return session;
		case 4:
			var session = page.b;
			return session;
		case 7:
			var model_ = page.a;
			return $author$project$Page$DashboardChie$toSession(model_);
		case 8:
			var model_ = page.a;
			return $author$project$Page$RepositorioChie$toSession(model_);
		case 5:
			var model_ = page.a;
			return $author$project$Page$HistorialDeCargas$toSession(model_);
		case 6:
			var model_ = page.a;
			return $author$project$Page$SolicitudesPendientes$toSession(model_);
		case 9:
			var model_ = page.a;
			return $author$project$Page$CargarStock$toSession(model_);
		case 11:
			var model_ = page.a;
			return $author$project$Page$SolicitarChie$toSession(model_);
		case 12:
			var model_ = page.a;
			return $author$project$Page$ConsultarStock$toSession(model_);
		default:
			var model_ = page.a;
			return $author$project$Page$SolicitudesChie$toSession(model_);
	}
};
var $author$project$Main$resetSessionFlags = function (session_) {
	return _Utils_update(
		session_,
		{
			ka: {f_: $elm$core$Maybe$Nothing, f$: $elm$core$Dict$empty, gV: $elm$core$Maybe$Nothing, g8: $elm$core$Maybe$Nothing, d: $elm$core$Maybe$Nothing, co: $elm$core$Maybe$Nothing, bJ: $elm$core$Maybe$Nothing}
		});
};
var $author$project$Main$toRoute = function (page) {
	switch (page.$) {
		case 0:
			var session = page.a;
			return $author$project$Route$Logout;
		case 7:
			return $author$project$Route$DashboardChie;
		case 5:
			var queryData = page.a.kX;
			return $author$project$Route$HistorialDeCargas(
				{iI: queryData});
		case 6:
			var queryData = page.a.kX;
			var taskName = page.a.jd;
			return A2(
				$elm$core$List$member,
				taskName,
				_List_fromArray(
					['chie_firmar_certificado', 'chie_firmar_certificado_extension'])) ? $author$project$Route$PendientesDeFirma(
				{iI: queryData}) : $author$project$Route$PendientesAprobacion(
				{iI: queryData});
		case 11:
			var queryData = page.a.kX;
			return $author$project$Route$SolicitarChie(
				{iI: queryData});
		case 12:
			var queryData = page.a.kX;
			return $author$project$Route$ConsultarStock(
				{iI: queryData});
		case 10:
			var queryData = page.a.kX;
			return $author$project$Route$SolicitudesChie(
				{iI: queryData});
		default:
			return $author$project$Route$ConsultarStock($author$project$Route$emptyData);
	}
};
var $author$project$Main$updateWith = F4(
	function (toPage, toMsg, model, _v0) {
		var mdel = _v0.a;
		var mdelCmd = _v0.b;
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{
					t: toPage(mdel)
				}),
			A2($elm$core$Platform$Cmd$map, toMsg, mdelCmd));
	});
var $author$project$Helpers$ApiHandler$userHomeRoute = F2(
	function (default_, userNde) {
		var keyDataMap = function (key_) {
			return A2(
				$elm$core$Maybe$withDefault,
				default_,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key_),
					$elm$core$Maybe$map(
						function ($) {
							return $.aX;
						}))(
					$author$project$Helpers$ApiHandler$rolesDeUser(userNde)));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			A3(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				$elm$core$Maybe$map(keyDataMap),
				A2($elm$core$Basics$composeR, $author$project$Helpers$ApiHandler$rolesDeUser, $elm$core$Dict$keys)(userNde)));
	});
var $author$project$Main$changeRouteTo = F2(
	function (mbeRoute, model) {
		var session = $author$project$Main$pageSession(model.t);
		var pageNotFound = A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{
					t: $author$project$Main$NotFound(session)
				}),
			$elm$core$Platform$Cmd$none);
		var maintenance_on = 'on' === A2($author$project$Csf$Flags$asset, 'maintenance', session.ka);
		var logged_user = $author$project$Csf$Flags$userNode(session.ka);
		var isRouteDenied = F2(
			function (query_, allowed_) {
				return A2($elm$core$Basics$composeR, $elm$core$Dict$isEmpty, $elm$core$Basics$not)(query_) && function (complies_) {
					return A2(
						$elm$core$List$any,
						complies_,
						$elm$core$Dict$keys(query_));
				}(
					function (key_) {
						return !A2($elm$core$List$member, key_, allowed_);
					});
			});
		var homeRouteOrLogout = A3(
			$elm$core$Basics$composeL,
			$elm$core$Tuple$pair(model),
			$elm$browser$Browser$Navigation$pushUrl(
				$author$project$Csf$Session$navKey(session)),
			A2(
				$author$project$Helpers$ApiHandler$userHomeRoute,
				$author$project$Route$routeToString($author$project$Route$Logout),
				logged_user));
		var hasAccess = function (role_keys) {
			return A2($author$project$Helpers$ApiHandler$hasUserAccess, logged_user, role_keys);
		};
		var handleRoute = F4(
			function (query_, allowed_, role_keys, defaultInit_) {
				return A2($elm$core$Basics$composeR, hasAccess, $elm$core$Basics$not)(role_keys) ? homeRouteOrLogout : (A2(isRouteDenied, query_, allowed_) ? pageNotFound : defaultInit_);
			});
		var dashboard_on = 'on' === A2($author$project$Csf$Flags$asset, 'dashboard', session.ka);
		var _v0 = _Utils_Tuple2(mbeRoute, maintenance_on);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				switch (_v0.a.a.$) {
					case 1:
						if (_v0.b) {
							var _v1 = _v0.a.a;
							return A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{
										t: $author$project$Main$Maintenance(session)
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v2 = _v0.a.a;
							return homeRouteOrLogout;
						}
					case 0:
						if (_v0.b) {
							break _v0$2;
						} else {
							var _v3 = _v0.a.a;
							return A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{
										t: $author$project$Main$Logout(
											$author$project$Main$resetSessionFlags(session))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Helpers$Utilities$clearLocalStorage,
											A2($elm$core$Basics$composeR, $author$project$Route$routeToString, $author$project$Helpers$ApiHandler$logout_)(
											$author$project$Main$toRoute(model.t)),
											A3(
											$elm$core$Basics$composeR,
											$author$project$Helpers$ApiHandler$logout,
											$elm$core$Task$attempt($author$project$Main$TicketExpired),
											$author$project$Csf$Flags$ticket(session.ka))
										])));
						}
					case 2:
						if (_v0.b) {
							break _v0$2;
						} else {
							var _v4 = _v0.a.a;
							return (!dashboard_on) ? homeRouteOrLogout : ((!_Utils_eq($elm$core$Maybe$Nothing, model.q.iI)) ? pageNotFound : A4(
								handleRoute,
								$elm$core$Dict$empty,
								_List_Nil,
								_List_fromArray(
									['MANAGER']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$Dashboard,
									$author$project$Main$DashboardMsg,
									model,
									$author$project$Page$DashboardChie$init(session))));
						}
					case 3:
						if (_v0.b) {
							break _v0$2;
						} else {
							var nodeuuid = _v0.a.a.a;
							return (!_Utils_eq($elm$core$Maybe$Nothing, model.q.iI)) ? pageNotFound : A4(
								$author$project$Main$updateWith,
								$author$project$Main$Repositorio,
								$author$project$Main$RepositorioMsg,
								model,
								A2($author$project$Page$RepositorioChie$init, session, nodeuuid));
						}
					case 10:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$SolicitudesPendientes$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'APPROVER']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$Pendientes,
									$author$project$Main$PendientesMsg,
									model,
									A3($author$project$Page$SolicitudesPendientes$init, 'chie_aprobar_emision', session, query)));
						}
					case 9:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$SolicitudesPendientes$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'LEGAL_REPRESENTATIVE']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$Pendientes,
									$author$project$Main$PendientesMsg,
									model,
									A3($author$project$Page$SolicitudesPendientes$init, 'chie_firmar_certificado', session, query)));
						}
					case 4:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$CargarStock$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$CargarStock,
									$author$project$Main$CargarStockMsg,
									model,
									$author$project$Page$CargarStock$init(session)));
						}
					case 5:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$SolicitarChie$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'APPLICANT']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$SolicitarChie,
									$author$project$Main$SolicitarChieMsg,
									model,
									A3($author$project$Page$SolicitarChie$init, session, model.cl, query)));
						}
					case 7:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$SolicitudesChie$allowedInQuery(session),
								_List_fromArray(
									['SUPPORT', 'APPROVER', 'APPLICANT', 'NULLIFIER', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$SolicitudesChie,
									$author$project$Main$SolicitudesChieMsg,
									model,
									A3($author$project$Page$SolicitudesChie$init, session, model.cl, query)));
						}
					case 6:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$ConsultarStock$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$ConsultarStock,
									$author$project$Main$ConsultarStockMsg,
									model,
									A2($author$project$Page$ConsultarStock$init, session, query)));
						}
					default:
						if (_v0.b) {
							break _v0$2;
						} else {
							var query = _v0.a.a.a.iI;
							return A4(
								handleRoute,
								query,
								$author$project$Page$HistorialDeCargas$allowedInQuery,
								_List_fromArray(
									['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']),
								A4(
									$author$project$Main$updateWith,
									$author$project$Main$Cargas,
									$author$project$Main$CargasMsg,
									model,
									A2($author$project$Page$HistorialDeCargas$init, session, query)));
						}
				}
			} else {
				if (_v0.b) {
					break _v0$2;
				} else {
					return pageNotFound;
				}
			}
		}
		return A2(
			$elm$core$Tuple$pair,
			model,
			A2(
				$author$project$Route$goTo,
				$author$project$Csf$Session$navKey(session),
				$author$project$Route$Maintenance));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Config$AppTenants$tenantRawToTuple = function (raw) {
	return A2(
		$elm$core$Tuple$pair,
		raw.jg,
		{
			cW: raw.cW,
			c7: raw.c7,
			dc: raw.dc,
			dx: $elm$core$Dict$toList(raw.dx)
		});
};
var $author$project$Main$updPageSession = F2(
	function (page, session_) {
		switch (page.$) {
			case 7:
				var model_ = page.a;
				return $author$project$Main$Dashboard(
					_Utils_update(
						model_,
						{g$: session_}));
			case 8:
				var model_ = page.a;
				return $author$project$Main$Repositorio(
					_Utils_update(
						model_,
						{g$: session_}));
			case 5:
				var model_ = page.a;
				return $author$project$Main$Cargas(
					_Utils_update(
						model_,
						{g$: session_}));
			case 6:
				var model_ = page.a;
				return $author$project$Main$Pendientes(
					_Utils_update(
						model_,
						{g$: session_}));
			case 9:
				var model_ = page.a;
				return $author$project$Main$CargarStock(
					_Utils_update(
						model_,
						{g$: session_}));
			case 11:
				var model_ = page.a;
				return $author$project$Main$SolicitarChie(
					_Utils_update(
						model_,
						{g$: session_}));
			case 12:
				var model_ = page.a;
				return $author$project$Main$ConsultarStock(
					_Utils_update(
						model_,
						{g$: session_}));
			case 10:
				var model_ = page.a;
				return $author$project$Main$SolicitudesChie(
					_Utils_update(
						model_,
						{g$: session_}));
			default:
				return page;
		}
	});
var $author$project$Csf$FilterSideBar$Fixed = 2;
var $author$project$Csf$FilterSideBar$ActionableZone = 1;
var $author$project$Csf$FilterSideBar$Expanded = 1;
var $author$project$Csf$FilterSideBar$SidebarZone = 0;
var $author$project$Csf$FilterSideBar$onMouseEnterMsg = F2(
	function (zone, model) {
		var _v0 = _Utils_Tuple2(zone, model.w);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								w: 1,
								lG: $elm$core$Maybe$Just(0)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b === 1) {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								w: 1,
								lG: $elm$core$Maybe$Just(1)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$FilterSideBar$TransitionTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Csf$FilterSideBar$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $author$project$Csf$FilterSideBar$onMouseLeaveMsg = F2(
	function (zone, model) {
		var _v0 = _Utils_Tuple2(zone, model.w);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (_v0.b === 1) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Csf$FilterSideBar$delay,
							100,
							A2($author$project$Csf$FilterSideBar$TransitionTo, 0, 0)));
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b === 1) {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{w: 0, lG: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$FilterSideBar$onTransitionTo = F2(
	function (_v0, model) {
		var zone = _v0.a;
		var state = _v0.b;
		var _v1 = _Utils_Tuple2(model.lG, state);
		_v1$2:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.a.a === 1) {
					if (!_v1.b) {
						var _v2 = _v1.a.a;
						var _v3 = _v1.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						break _v1$2;
					}
				} else {
					if (!_v1.b) {
						var _v4 = _v1.a.a;
						var _v5 = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{w: 0, lG: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$FilterSideBar$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (msg.a === 1) {
					var _v1 = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{w: 2}),
						$elm$core$Platform$Cmd$none);
				} else {
					var state = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{w: state}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var zone = msg.a;
				return A2($author$project$Csf$FilterSideBar$onMouseEnterMsg, zone, model);
			case 2:
				var zone = msg.a;
				return A2($author$project$Csf$FilterSideBar$onMouseLeaveMsg, zone, model);
			default:
				var zone = msg.a;
				var state = msg.b;
				return A2(
					$author$project$Csf$FilterSideBar$onTransitionTo,
					_Utils_Tuple2(zone, state),
					model);
		}
	});
var $author$project$Csf$Header$onCloseProfile = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cn: false}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Csf$Header$onToggledProfile = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cn: !model.cn}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Csf$Header$update = F2(
	function (msg, model) {
		if (!msg) {
			return $author$project$Csf$Header$onToggledProfile(model);
		} else {
			return $author$project$Csf$Header$onCloseProfile(model);
		}
	});
var $author$project$Page$CargarStock$CompleteRegistration = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$CargarStock$DataExtracted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$CargarStock$NotificationsMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$CargarStock$TableMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$CargarStock$ToggleErrorTooltip = function (a) {
	return {$: 6, a: a};
};
var $author$project$TaskNode$bool = $author$project$TaskNode$prop($elm$json$Json$Decode$bool);
var $author$project$Csf$TaskNodeUtils$mbbool = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TaskNode$bool(key),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$bool = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbbool(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Csf$TaskNodeUtils$mbdatabool = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$TaskNode$bool(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$databool = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdatabool(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$TaskNode$int = $author$project$TaskNode$prop($elm$json$Json$Decode$int);
var $author$project$Csf$TaskNodeUtils$mbdataint = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$TaskNode$int(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$dataint = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdataint(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Helpers$Utilities$decodeValue_ = F3(
	function (default_, decoder_, value_) {
		return A4($author$project$Helpers$Utilities$decodeMapValue, default_, $elm$core$Basics$identity, decoder_, value_);
	});
var $author$project$Helpers$Utilities$delayTask = F2(
	function (secs, task_) {
		return A2(
			$elm$core$Task$andThen,
			function (_v0) {
				return task_;
			},
			A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$toMillis, $elm$core$Process$sleep)(secs));
	});
var $author$project$Config$Captions$captionMessages = _List_fromArray(
	[
		_Utils_Tuple2('app_title', 'Sistema de Emisión CHI-e'),
		_Utils_Tuple2('load_stock', 'Cargar Vehículos'),
		_Utils_Tuple2('check_stock', 'Stock de Vehículos'),
		_Utils_Tuple2('chie_files', 'Solicitudes CHI-e'),
		_Utils_Tuple2('search_chie', 'Buscar Homologado'),
		_Utils_Tuple2('request_chie', 'Nueva Solicitud'),
		_Utils_Tuple2('logging_loads', 'Historial de Cargas'),
		_Utils_Tuple2('pending_tasks', 'Revisar Solicitudes'),
		_Utils_Tuple2('signing_tasks', 'Firmar CHI-e'),
		_Utils_Tuple2('mtt_shippings', 'Gestionar Envíos MTT'),
		_Utils_Tuple2('tab_historial', 'Historial'),
		_Utils_Tuple2('tab_documentos', 'Documentos'),
		_Utils_Tuple2('tab_solicitud', 'Solicitud CHI-e'),
		_Utils_Tuple2('app_dashboard', 'Reportes'),
		_Utils_Tuple2('app_repository', 'Repositorio Electrónico'),
		_Utils_Tuple2('notfound_title', 'Página no Encontrada'),
		_Utils_Tuple2('page_notfound', '¡Ooops! La página que ha solicitado al parecer no existe.'),
		_Utils_Tuple2('maintenance_title', 'Aplicación en Mantenimiento'),
		_Utils_Tuple2('maintenance_h2', 'El Sistema de Emisión CHI-e se encuentra actualmente en mantenimiento.'),
		_Utils_Tuple2('maintenance_h3', 'Estaremos disponibles al culminar las tareas de soporte. Disculpe las molestias.'),
		_Utils_Tuple2('filtered_empty', 'No existen resultados para los filtros aplicados'),
		_Utils_Tuple2('working_action', 'La acción no puede ser procesada. Funcionalidad en desarrollo.'),
		_Utils_Tuple2('fields_required', 'Lo sentimos, debe rellenar los campos requeridos.'),
		_Utils_Tuple2('fields_with_errors', 'Lo sentimos, debe corregir los campos con errores.'),
		_Utils_Tuple2('wrong_file', 'Lo sentimos, el tipo de fichero que intenta subir no es válido.'),
		_Utils_Tuple2('error_received', 'Lo sentimos, ha ocurrido un error consultando el servicio.'),
		_Utils_Tuple2('error_badurl', 'Lo sentimos, la URL del servicio que intenta consultar es incorrecta.'),
		_Utils_Tuple2('error_timeout', 'Lo sentimos, el servicio está tardando demasiado en responder.'),
		_Utils_Tuple2('error_badbody', 'Lo sentimos, ha ocurrido un error procesando la respuesta del servicio.'),
		_Utils_Tuple2('error_forbbiden', 'Lo sentimos, usted no cuenta con los permisos necesarios para realizar esta operación.'),
		_Utils_Tuple2('error_networkerror', 'Lo sentimos, ha ocurrido un error de red. Verifique su conexión.')
	]);
var $author$project$Helpers$Utilities$appMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Config$Captions$captionMessages));
};
var $author$project$Page$CargarStock$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('upload_ok', 'La nómina se ha subido exitosamente.'),
		_Utils_Tuple2('upload_fail', 'Lo sentimos, ha ocurrido un error en la subida de la nómina.'),
		_Utils_Tuple2('upload_empty', 'Lo sentimos, no ha sido posible extraer vehículos de la nómina.'),
		_Utils_Tuple2('head_unload', 'Stock de Vehículos Disponibles para Emisión de CHI-e'),
		_Utils_Tuple2('head_loaded', 'Carga de Stock de Vehículos Disponibles para Emisión de CHI-e'),
		_Utils_Tuple2('card_title_unload', 'Carga de Planilla de Vehículos Importados'),
		_Utils_Tuple2('card_title_loaded', 'Stock de Vehículos para Emisión de CHI-e'),
		_Utils_Tuple2('stock_loaded_ok', 'Los vehículos se han ingresado exitosamente en el stock.'),
		_Utils_Tuple2('stock_loaded_fail', 'Lo sentimos, ha ocurrido un error en la carga de la nómina.'),
		_Utils_Tuple2('validation_failed', 'Ha ocurrido un error durante el proceso de validación.'),
		_Utils_Tuple2('validation_running', 'No es posible realizar esta acción mientras se procesa la nómina.'),
		_Utils_Tuple2('validation_with_errors', 'Lo sentimos, debe corregir los errores antes de enviar al stock.'),
		_Utils_Tuple2('registration_ok', 'Los vehículos se ha ingresado exitosamente en el stock.'),
		_Utils_Tuple2('registration_fail', 'Ha ocurrido un error registrando la nómina.'),
		_Utils_Tuple2('registration_running', 'Lo sentimos, no puede cancelar mientras se registra la nómina'),
		_Utils_Tuple2('DUPLICATED_IN_ORDER', 'Vehículo duplicado en la nómina.'),
		_Utils_Tuple2('ALREADY_IN_STOCK', 'Vehículo existente en stock.'),
		_Utils_Tuple2('EMPTY_FIELD_VIN', 'Campo VIN vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_YEAR', 'Campo Año vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_COLOR', 'Campo Color vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_BRAND', 'Campo Marca vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_MODEL', 'Campo Modelo vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_MOTOR', 'Campo Motor vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_TYPE', 'Campo Tipo vacío.'),
		_Utils_Tuple2('EMPTY_FIELD_CIT', 'Campo C.I.T vacío.'),
		_Utils_Tuple2('INVALID_VIN_LENGTH', 'Longitud del VIN incorrecta (17 caracteres).'),
		_Utils_Tuple2('INVALID_MODEL_LENGTH', 'Modelo excede tamaño permitido (23 caracteres).'),
		_Utils_Tuple2('INVALID_VEHICLE_TYPE', 'Tipo de Vehículo no reconocido.'),
		_Utils_Tuple2('INVALID_VEHICLE_IMPORTER', 'Marca no permitida para este Importador.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_VIN', 'El campo VIN contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_CIT', 'El campo C.I.T contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_COLOR', 'El campo Color contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_BRAND', 'El campo Marca contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_MOTOR', 'El campo Motor contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_TYPE', 'El campo Tipo contiene caracteres no permitidos.'),
		_Utils_Tuple2('INVALID_CHARACTERS_FIELD_MODEL', 'El campo Modelo contiene caracteres no permitidos.')
	]);
var $author$project$Page$CargarStock$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_),
			$author$project$Page$CargarStock$moduleCaptions_));
};
var $author$project$Csf$Notifications$NotificationInfo = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Csf$Notifications$NotificationWarning = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Csf$Notifications$NotificationError = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Csf$Notifications$error = F2(
	function (toMsg, message) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			A2(
				$author$project$Csf$Core$timeout,
				0.0,
				A2($author$project$Csf$Notifications$NotificationError, 'Error', message)));
	});
var $author$project$Csf$Notifications$NotificationSuccess = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Csf$Notifications$success = F2(
	function (toMsg, message) {
		return A2(
			$elm$core$Platform$Cmd$map,
			toMsg,
			A2(
				$author$project$Csf$Core$timeout,
				0.0,
				A2($author$project$Csf$Notifications$NotificationSuccess, 'Success', message)));
	});
var $author$project$Helpers$Utilities$setNotification = F3(
	function (toMsg, mssgType, message_) {
		switch (mssgType) {
			case 'error':
				return A2($author$project$Csf$Notifications$error, toMsg, message_);
			case 'success':
				return A2($author$project$Csf$Notifications$success, toMsg, message_);
			case 'info':
				return A3(
					$elm$core$Basics$composeR,
					toMsg,
					$author$project$Helpers$Utilities$delay(0),
					A2($author$project$Csf$Notifications$NotificationInfo, 'Info', message_));
			case 'warning':
				return A3(
					$elm$core$Basics$composeR,
					toMsg,
					$author$project$Helpers$Utilities$delay(0),
					A2($author$project$Csf$Notifications$NotificationWarning, 'Warning', message_));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$CargarStock$doNotify = function (type_) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$CargarStock$moduleMessage,
		A2($author$project$Helpers$Utilities$setNotification, $author$project$Page$CargarStock$NotificationsMsg, type_));
};
var $author$project$Config$ApiEndpoint$extractornomina = F3(
	function (tenant_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-extractor-service', 'extractor-service', tenant_, 'lote', unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$handleCallError = F2(
	function (error_, defaultMssg) {
		switch (error_.$) {
			case 1:
				return 'error_timeout';
			case 0:
				var url_ = error_.a;
				return 'error_badurl';
			case 2:
				return 'error_networkerror';
			case 3:
				return 'redirect_';
			case 5:
				var string_ = error_.a;
				return 'error_badbody';
			case 4:
				var status_ = error_.a;
				var body_ = error_.b;
				return (403 === status_) ? 'redirect_' : defaultMssg;
			default:
				return defaultMssg;
		}
	});
var $pablen$toasty$Toasty$Defaults$Error = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $pablen$toasty$Toasty$Defaults$Success = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $pablen$toasty$Toasty$Defaults$Warning = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $pablen$toasty$Toasty$hasToast = F2(
	function (toast, _v0) {
		var toasts = _v0.a;
		return A2(
			$elm$core$List$member,
			toast,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var t = _v1.c;
					return t;
				},
				toasts));
	});
var $author$project$Helpers$Utilities$hasNotification = F3(
	function (mssgType, message_, toasties_) {
		switch (mssgType) {
			case 'error':
				return function (toast_) {
					return A2($pablen$toasty$Toasty$hasToast, toast_, toasties_);
				}(
					A2($pablen$toasty$Toasty$Defaults$Error, 'Error', message_));
			case 'info':
				return function (toast_) {
					return A2($pablen$toasty$Toasty$hasToast, toast_, toasties_);
				}(
					A2($pablen$toasty$Toasty$Defaults$Success, 'Info', message_));
			case 'success':
				return function (toast_) {
					return A2($pablen$toasty$Toasty$hasToast, toast_, toasties_);
				}(
					A2($pablen$toasty$Toasty$Defaults$Success, 'Success', message_));
			case 'warning':
				return function (toast_) {
					return A2($pablen$toasty$Toasty$hasToast, toast_, toasties_);
				}(
					A2($pablen$toasty$Toasty$Defaults$Warning, 'Warning', message_));
			default:
				return false;
		}
	});
var $author$project$Page$CargarStock$handleNotifications = F2(
	function (model, _v0) {
		var session = model.g$;
		var toasties = _v0.a.a7;
		var notifyCmd_ = _v0.b;
		var onRegistered_ = function (removed_) {
			return (!model.a2) && removed_;
		}(
			(!A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$CargarStock$moduleMessage('registration_ok'),
				toasties)) && A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$CargarStock$moduleMessage('registration_ok'),
				session.a7));
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{
					g$: _Utils_update(
						session,
						{a7: toasties})
				}),
			onRegistered_ ? $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						notifyCmd_,
						A2(
						$author$project$Route$goTo,
						session.gL,
						$author$project$Route$ConsultarStock($author$project$Route$emptyData))
					])) : notifyCmd_);
	});
var $author$project$Page$CargarStock$FileUploaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$CargarStock$UploaderMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$CargarStock$WrongFileUploaded = {$: 2};
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Config$ApiEndpoint$nodecreate = F3(
	function (tenant_, node_type_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'tenant', tenant_, 'type', node_type_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Helpers$ApiHandler$importarNomina = F6(
	function (ticket_, username_, useremail_, userfullname_, tenant_, file_) {
		return A2(
			$elm$core$Task$map,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
				function ($) {
					return $.p;
				}),
			A3(
				$author$project$Helpers$ApiHandler$post,
				A3($author$project$Config$ApiEndpoint$nodecreate, tenant_, 'lote_vehiculos', ticket_),
				_List_Nil,
				$elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file_),
							A2($elm$http$Http$stringPart, 'modo_procesamiento', 'ASISTIDO'),
							A2($elm$http$Http$stringPart, 'creador_nombre', userfullname_),
							A2($elm$http$Http$stringPart, 'creador_usuario', username_),
							A2($elm$http$Http$stringPart, 'creador_email', useremail_)
						]))));
	});
var $elm$file$File$name = _File_name;
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$CargarStock$handleUploader = F3(
	function (uploaderMsg, model, _v0) {
		var session = model.g$;
		var uploader_ = _v0.a;
		var cmd_ = _v0.b;
		var userNode = $author$project$Csf$Flags$userNode(session.ka);
		var userName_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'username', userNode);
		var userEmail_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'email', userNode);
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var thirdNameAttempt_ = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($author$project$Helpers$Utilities$stringToMaybe),
			$elm$core$String$join(''))(
			_List_fromArray(
				[
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'nombre', userNode),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'apellido', userNode),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'segundoApellido', userNode)
				]));
		var tenant_ = $author$project$Csf$Flags$tenantId(session.ka);
		var secondNameAttempt_ = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($author$project$Helpers$Utilities$stringToMaybe),
			$elm$core$String$join(' '))(
			_List_fromArray(
				[
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'nombres', userNode),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'paterno', userNode),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'materno', userNode)
				]));
		var hasExcelExtension = function (file_) {
			return function (name_) {
				return A2($elm$core$String$endsWith, '.xls', name_) || A2($elm$core$String$endsWith, '.xlsx', name_);
			}(
				A2($elm$core$Basics$composeR, $elm$file$File$name, $author$project$Helpers$Utilities$trimmedToLower)(file_));
		};
		var fullNameHandler = function (attempts_) {
			return A2(
				$elm$core$Maybe$withDefault,
				userName_,
				function (attemptMap) {
					return A2(
						$elm$core$Maybe$map,
						attemptMap,
						$elm$core$List$head(attempts_));
				}(
					function (name_) {
						return $author$project$Helpers$Utilities$trimmedEmpty(name_) ? A3(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(_List_Nil),
							fullNameHandler,
							$elm$core$List$tail(attempts_)) : name_;
					}));
		};
		var firstNameAttempt_ = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap($author$project$Helpers$Utilities$stringToMaybe),
			$elm$core$String$join(' '))(
			_List_fromArray(
				[
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'firstname', userNode),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'lastname', userNode)
				]));
		var userFullname_ = fullNameHandler(
			_List_fromArray(
				[firstNameAttempt_, secondNameAttempt_, thirdNameAttempt_]));
		return function (_v1) {
			var updMdel = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					updMdel,
					{dG: uploader_}),
				cmd);
		}(
			function () {
				if (uploaderMsg.$ === 3) {
					var file_ = uploaderMsg.a;
					return hasExcelExtension(file_) ? function (action_) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{az: true}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Page$CargarStock$UploaderMsg, cmd_),
										action_
									])));
					}(
						A2(
							$elm$core$Task$attempt,
							$author$project$Page$CargarStock$FileUploaded,
							A6($author$project$Helpers$ApiHandler$importarNomina, ticket_, userName_, userEmail_, userFullname_, tenant_, file_))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{az: true}),
						A2($author$project$Helpers$Utilities$delay, 1.8, $author$project$Page$CargarStock$WrongFileUploaded));
				} else {
					return _Utils_Tuple2(
						model,
						A2($elm$core$Platform$Cmd$map, $author$project$Page$CargarStock$UploaderMsg, cmd_));
				}
			}());
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Csf$TaskNodeUtils$mblist = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TaskNode$list(key),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$list = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mblist(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Helpers$ApiHandler$put = F3(
	function (serviceUrl, headers_, httpBody_) {
		return $elm$http$Http$task(
			_Utils_update(
				$author$project$Helpers$ApiHandler$taskRequest,
				{h: httpBody_, i: headers_, j: 'PUT', q: serviceUrl}));
	});
var $author$project$Config$ApiEndpoint$registarnomina_ = F3(
	function (tenant_, uuid_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-stock-service', 'stock-service', tenant_, 'lote', uuid_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$registrarNomina_ = F3(
	function (ticket_, tenant_, unique_id) {
		return A3(
			$author$project$Helpers$ApiHandler$put,
			A3($author$project$Config$ApiEndpoint$registarnomina_, tenant_, unique_id, ticket_),
			_List_Nil,
			A2($elm$core$Basics$composeR, $elm$json$Json$Encode$object, $elm$http$Http$jsonBody)(_List_Nil));
	});
var $author$project$Helpers$ApiHandler$taskNodeFromValue = A2($author$project$Helpers$Utilities$decodeValue_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode);
var $author$project$Helpers$ApiHandler$toUserHome = function (_v0) {
	var flags = _v0.ka;
	var navKey = _v0.gL;
	return A2(
		$elm$browser$Browser$Navigation$pushUrl,
		navKey,
		A2(
			$author$project$Helpers$ApiHandler$userHomeRoute,
			$author$project$Route$routeToString($author$project$Route$Logout),
			$author$project$Csf$Flags$userNode(flags)));
};
var $author$project$Ports$callUpInformationSSE = _Platform_outgoingPort('callUpInformationSSE', $elm$core$Basics$identity);
var $author$project$Config$ApiEndpoint$chiessechannel = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-sse-service', 'emision-chie', 'sse', 'channel']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$trackValidation = F2(
	function (ticket_, order_uuid) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$json$Json$Encode$object,
			$author$project$Ports$callUpInformationSSE,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'order',
					$elm$json$Json$Encode$string(order_uuid)),
					A2(
					$elm$core$Tuple$pair,
					'path',
					A2($elm$core$Basics$composeR, $author$project$Config$ApiEndpoint$chiessechannel, $elm$json$Json$Encode$string)(ticket_))
				]));
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Csf$FileUploader$OnFileUploaded = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $author$project$Csf$FileUploader$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eu: true}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eu: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return function (cmdAction) {
					return _Utils_Tuple2(model, cmdAction);
				}(
					A2($elm$file$File$Select$files, model.fZ, $author$project$Csf$FileUploader$OnFileUploaded));
			default:
				var file_ = msg.a;
				var files_ = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hW: A2($elm$core$List$cons, file_, files_)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Csf$Notifications$ToastyMsg = function (a) {
	return {$: 5, a: a};
};
var $pablen$toasty$Toasty$Temporary = 0;
var $pablen$toasty$Toasty$Entered = 0;
var $pablen$toasty$Toasty$TransitionOut = function (a) {
	return {$: 2, a: a};
};
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $pablen$toasty$Toasty$getNewId = function (seed) {
	return A2(
		$elm$random$Random$step,
		A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt),
		seed);
};
var $pablen$toasty$Toasty$addToast_ = F5(
	function (removeBehaviour, _v0, tagger, toast, _v1) {
		var cfg = _v0;
		var model = _v1.a;
		var cmd = _v1.b;
		var _v2 = model.a7;
		var toasts = _v2.a;
		var seed = _v2.b;
		var _v3 = $pablen$toasty$Toasty$getNewId(seed);
		var newId = _v3.a;
		var newSeed = _v3.b;
		var task = function () {
			if (!removeBehaviour) {
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return tagger(
							$pablen$toasty$Toasty$TransitionOut(newId));
					},
					$elm$core$Process$sleep(cfg.jX));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a7: A2(
						$pablen$toasty$Toasty$Stack,
						_Utils_ap(
							toasts,
							_List_fromArray(
								[
									_Utils_Tuple3(newId, 0, toast)
								])),
						newSeed)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, task])));
	});
var $pablen$toasty$Toasty$addToast = $pablen$toasty$Toasty$addToast_(0);
var $author$project$Csf$Notifications$lazyToastyTypeStr = function (type_) {
	switch (type_) {
		case 0:
			return 'Success';
		case 1:
			return 'Info';
		case 2:
			return 'Warning';
		default:
			return 'Error';
	}
};
var $pablen$toasty$Toasty$Config = $elm$core$Basics$identity;
var $pablen$toasty$Toasty$config = {f9: _List_Nil, jX: 5000, gD: _List_Nil, hc: _List_Nil, hd: _List_Nil, he: 0};
var $pablen$toasty$Toasty$containerAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{f9: attrs});
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $pablen$toasty$Toasty$Defaults$containerAttrs = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
		A2($elm$html$Html$Attributes$style, 'top', '0'),
		A2($elm$html$Html$Attributes$style, 'right', '0'),
		A2($elm$html$Html$Attributes$style, 'width', '100%'),
		A2($elm$html$Html$Attributes$style, 'max-width', '300px'),
		A2($elm$html$Html$Attributes$style, 'list-style-type', 'none'),
		A2($elm$html$Html$Attributes$style, 'padding', '0'),
		A2($elm$html$Html$Attributes$style, 'margin', '0')
	]);
var $pablen$toasty$Toasty$delay = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{jX: time});
	});
var $pablen$toasty$Toasty$itemAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{gD: attrs});
	});
var $pablen$toasty$Toasty$Defaults$itemAttrs = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'margin', '1em 1em 0 1em'),
		A2($elm$html$Html$Attributes$style, 'max-height', '100px'),
		A2($elm$html$Html$Attributes$style, 'transition', 'max-height 0.6s, margin-top 0.6s')
	]);
var $pablen$toasty$Toasty$transitionInAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{hc: attrs});
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $pablen$toasty$Toasty$Defaults$transitionInAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated bounceInRight')
	]);
var $pablen$toasty$Toasty$transitionOutAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{hd: attrs});
	});
var $pablen$toasty$Toasty$Defaults$transitionOutAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated fadeOutRightBig'),
		A2($elm$html$Html$Attributes$style, 'max-height', '0'),
		A2($elm$html$Html$Attributes$style, 'margin-top', '0')
	]);
var $pablen$toasty$Toasty$transitionOutDuration = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{he: time});
	});
var $pablen$toasty$Toasty$Defaults$config = A2(
	$pablen$toasty$Toasty$delay,
	5000,
	A2(
		$pablen$toasty$Toasty$itemAttrs,
		$pablen$toasty$Toasty$Defaults$itemAttrs,
		A2(
			$pablen$toasty$Toasty$containerAttrs,
			$pablen$toasty$Toasty$Defaults$containerAttrs,
			A2(
				$pablen$toasty$Toasty$transitionInAttrs,
				$pablen$toasty$Toasty$Defaults$transitionInAttrs,
				A2(
					$pablen$toasty$Toasty$transitionOutAttrs,
					$pablen$toasty$Toasty$Defaults$transitionOutAttrs,
					A2($pablen$toasty$Toasty$transitionOutDuration, 700, $pablen$toasty$Toasty$config))))));
var $author$project$Csf$Notifications$toastingContainerAttrs = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
		A2($elm$html$Html$Attributes$style, 'top', '70px'),
		A2($elm$html$Html$Attributes$style, 'right', '0'),
		A2($elm$html$Html$Attributes$style, 'list-style-type', 'none'),
		A2($elm$html$Html$Attributes$style, 'padding', '0'),
		A2($elm$html$Html$Attributes$style, 'margin', '0'),
		A2($elm$html$Html$Attributes$style, 'z-index', '100')
	]);
var $author$project$Csf$Notifications$transitionInAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated fadeInRight'),
		A2($elm$html$Html$Attributes$style, 'width', 'fit-content')
	]);
var $author$project$Csf$Notifications$transitionOutAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated fadeOutRightBig'),
		A2($elm$html$Html$Attributes$style, 'max-height', '0'),
		A2($elm$html$Html$Attributes$style, 'margin-top', '0')
	]);
var $author$project$Csf$Notifications$toastConfig = A2(
	$pablen$toasty$Toasty$transitionInAttrs,
	$author$project$Csf$Notifications$transitionInAttrs,
	A2(
		$pablen$toasty$Toasty$transitionOutAttrs,
		$author$project$Csf$Notifications$transitionOutAttrs,
		A2(
			$pablen$toasty$Toasty$containerAttrs,
			$author$project$Csf$Notifications$toastingContainerAttrs,
			A2(
				$pablen$toasty$Toasty$transitionOutDuration,
				100,
				A2($pablen$toasty$Toasty$delay, 10000, $pablen$toasty$Toasty$Defaults$config)))));
var $pablen$toasty$Toasty$Leaving = 1;
var $pablen$toasty$Toasty$Remove = function (a) {
	return {$: 1, a: a};
};
var $pablen$toasty$Toasty$update = F4(
	function (_v0, tagger, msg, model) {
		var cfg = _v0;
		var _v1 = model.a7;
		var toasts = _v1.a;
		var seed = _v1.b;
		switch (msg.$) {
			case 0:
				var toast = msg.a;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$pablen$toasty$Toasty$config,
					tagger,
					toast,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 1:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$filter,
					function (_v3) {
						var id = _v3.a;
						var toast = _v3.b;
						var status = _v3.c;
						return !_Utils_eq(id, targetId);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a7: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$map,
					function (_v5) {
						var id = _v5.a;
						var status = _v5.b;
						var toast = _v5.c;
						return _Utils_eq(id, targetId) ? _Utils_Tuple3(id, 1, toast) : _Utils_Tuple3(id, status, toast);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a7: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					A2(
						$elm$core$Task$perform,
						function (_v4) {
							return tagger(
								$pablen$toasty$Toasty$Remove(targetId));
						},
						$elm$core$Process$sleep(cfg.he)));
		}
	});
var $author$project$Csf$Notifications$update1 = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var title = msg.a;
				var message = msg.b;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$author$project$Csf$Notifications$toastConfig,
					$author$project$Csf$Notifications$ToastyMsg,
					A2($pablen$toasty$Toasty$Defaults$Success, title, message),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 1:
				var title = msg.a;
				var message = msg.b;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$author$project$Csf$Notifications$toastConfig,
					$author$project$Csf$Notifications$ToastyMsg,
					A2($pablen$toasty$Toasty$Defaults$Success, title, message),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 3:
				var title = msg.a;
				var message = msg.b;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$author$project$Csf$Notifications$toastConfig,
					$author$project$Csf$Notifications$ToastyMsg,
					A2($pablen$toasty$Toasty$Defaults$Warning, title, message),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 4:
				var title = msg.a;
				var message = msg.b;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$author$project$Csf$Notifications$toastConfig,
					$author$project$Csf$Notifications$ToastyMsg,
					A2($pablen$toasty$Toasty$Defaults$Error, title, message),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 0:
				var type_ = msg.a;
				var delay = msg.b;
				var message = msg.c;
				var title = $author$project$Csf$Notifications$lazyToastyTypeStr(type_);
				var msg_ = {bt: message, bF: title, a9: type_};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ab: A2(
								$elm$core$List$cons,
								{jX: delay, kD: msg_},
								model.ab)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				return A4($pablen$toasty$Toasty$update, $author$project$Csf$Notifications$toastConfig, $author$project$Csf$Notifications$ToastyMsg, subMsg, model);
		}
	});
var $author$project$Csf$Notifications$update = F2(
	function (msg, _v0) {
		var toasties = _v0.a7;
		return A2(
			$author$project$Csf$Notifications$update1,
			msg,
			{ab: _List_Nil, a7: toasties});
	});
var $author$project$Csf$Table$onCustomEvent = F2(
	function (any, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$Table$onSelectData = F2(
	function (_v0, model) {
		var data = _v0.a;
		var isSelected = _v0.b;
		var datas = A3(
			$elm$core$List$foldr,
			F2(
				function (item, acc) {
					return _Utils_eq(item.gv, data.gv) ? A2(
						$elm$core$List$cons,
						_Utils_update(
							item,
							{dt: isSelected}),
						acc) : A2($elm$core$List$cons, item, acc);
				}),
			_List_Nil,
			model.r);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{r: datas}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$Table$onTable = F2(
	function (state, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{w: state}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Csf$Table$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var data = msg.a;
				var selected = msg.b;
				return A2(
					$author$project$Csf$Table$onSelectData,
					_Utils_Tuple2(data, selected),
					model);
			case 2:
				var subMsg = msg.a;
				return A2($author$project$Csf$Table$onTable, subMsg, model);
			case 3:
				var name = msg.a;
				var subMsg = msg.b;
				return A2(
					$author$project$Csf$Table$onCustomEvent,
					_Utils_Tuple2(name, subMsg),
					model);
			default:
				var subMsg = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Csf$Flags$username = function (flags_) {
	return A2($elm$core$Maybe$withDefault, '', flags_.bJ);
};
var $author$project$Page$CargarStock$update = F2(
	function (msg, model) {
		var session = model.g$;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var tenant_ = $author$project$Csf$Flags$tenantId(session.ka);
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$author$project$Route$goTo,
						session.gL,
						$author$project$Route$ConsultarStock($author$project$Route$emptyData)));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: false}),
					A2($author$project$Page$CargarStock$doNotify, 'error', 'wrong_file'));
			case 3:
				return A3(
					$elm$core$Basics$composeR,
					$elm$core$List$length,
					$elm$core$Basics$neq(model.ce),
					model.jb.r) ? _Utils_Tuple2(
					model,
					A2($author$project$Page$CargarStock$doNotify, 'error', 'validation_running')) : (model.a2 ? _Utils_Tuple2(
					model,
					A2($author$project$Page$CargarStock$doNotify, 'error', 'registration_running')) : A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$author$project$Route$goTo,
						session.gL,
						$author$project$Route$CargarStock($author$project$Route$emptyData))));
			case 4:
				return A3(
					$elm$core$Basics$composeR,
					$elm$core$List$length,
					$elm$core$Basics$neq(model.ce),
					model.jb.r) ? _Utils_Tuple2(
					model,
					A2($author$project$Page$CargarStock$doNotify, 'error', 'validation_running')) : (A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ld;
						},
						$elm$core$Basics$not),
					model.aI) ? _Utils_Tuple2(
					model,
					A2($author$project$Page$CargarStock$doNotify, 'error', 'validation_with_errors')) : A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{a2: true}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$CargarStock$CompleteRegistration,
						A3(
							$author$project$Helpers$ApiHandler$registrarNomina_,
							ticket_,
							tenant_,
							A3($author$project$Csf$TaskNodeUtils$string, '', 'unique_id', model.dl)))));
			case 6:
				var uuid_ = msg.a;
				return function (showError_) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aH: showError_}),
						$elm$core$Platform$Cmd$none);
				}(
					A2(
						$elm$core$Maybe$withDefault,
						A3($elm$core$Dict$insert, uuid_, true, $elm$core$Dict$empty),
						A2(
							$elm$core$Maybe$map,
							function (show_) {
								return A3($elm$core$Dict$insert, uuid_, !show_, model.aH);
							},
							A2($elm$core$Dict$get, uuid_, model.aH))));
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aH: $elm$core$Dict$empty}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var event_ = msg.a;
				var eventNode = A3($author$project$Helpers$Utilities$decodeValue_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode, event_);
				var index_ = A3($author$project$Csf$TaskNodeUtils$dataint, 0, 'index', eventNode);
				var uuid_ = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.r;
							},
							function ($) {
								return $.p;
							}),
						A2($elm_community$list_extra$List$Extra$getAt, index_ - 1, model.jb.r)));
				var notEventOwner = !_Utils_eq(
					$author$project$Csf$Flags$username(session.ka),
					A3($author$project$Csf$TaskNodeUtils$string, '', 'owner', eventNode));
				var notFromMyStockLoad = notEventOwner || ('VEHICLE_VALIDATION' !== A3($author$project$Csf$TaskNodeUtils$string, '', 'event_type', eventNode));
				var vehicle_ = {
					hQ: A3($author$project$Csf$TaskNodeUtils$dataliststr, _List_Nil, 'errors', eventNode),
					gv: index_,
					kT: A3($author$project$Csf$TaskNodeUtils$datastring, '', 'order', eventNode),
					ld: A3($author$project$Csf$TaskNodeUtils$databool, false, 'success', eventNode),
					dH: uuid_
				};
				var closed_onerror = A3($author$project$Csf$TaskNodeUtils$bool, false, 'closed_onerror', eventNode);
				return closed_onerror ? A2(
					$elm$core$Tuple$pair,
					model,
					A2($author$project$Helpers$ApiHandler$trackValidation, ticket_, model.dl.p)) : ((notFromMyStockLoad || (!index_)) ? A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none) : function (model_) {
					return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
				}(
					_Utils_update(
						model,
						{
							ce: index_,
							aI: A2(
								$elm_community$list_extra$List$Extra$uniqueBy,
								function ($) {
									return $.dH;
								},
								_Utils_ap(
									$elm$core$List$singleton(vehicle_),
									model.aI))
						})));
			case 8:
				if (!msg.a.$) {
					var unique_id = msg.a.a;
					var trackingProcess_ = A2($author$project$Helpers$ApiHandler$trackValidation, ticket_, unique_id);
					var extractNominaData_ = A3(
						$elm$core$Basics$composeR,
						$author$project$Helpers$Utilities$delayTask(0.8),
						$elm$core$Task$attempt($author$project$Page$CargarStock$DataExtracted),
						A2(
							$elm$core$Task$map,
							$author$project$Helpers$ApiHandler$taskNodeFromString,
							A2(
								$author$project$Helpers$ApiHandler$get,
								A3($author$project$Config$ApiEndpoint$extractornomina, tenant_, unique_id, ticket_),
								_List_fromArray(
									[
										A2($elm$http$Http$header, 'Content-Type', 'application/json')
									]))));
					return $author$project$Helpers$Utilities$trimmedEmpty(unique_id) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{az: false}),
						A2($author$project$Page$CargarStock$doNotify, 'error', 'upload_fail')) : _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[trackingProcess_, extractNominaData_])));
				} else {
					var error = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'upload_fail');
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{az: false}),
						('redirect_' === handled_) ? A2($author$project$Page$CargarStock$doNotify, 'error', 'error_forbbiden') : A2($author$project$Page$CargarStock$doNotify, 'error', handled_));
				}
			case 9:
				if (!msg.a.$) {
					var taskNode_ = msg.a.a;
					var vehicles_ = A2(
						$elm$core$List$map,
						$author$project$Helpers$ApiHandler$taskNodeFromValue,
						_Utils_ap(
							A3($author$project$Csf$TaskNodeUtils$list, _List_Nil, 'vehicles', taskNode_),
							A3($author$project$Csf$TaskNodeUtils$list, _List_Nil, 'vehiculos', taskNode_)));
					var validatedMap_ = function (validated) {
						return _Utils_update(
							validated,
							{
								dH: A3(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$map(
										function ($) {
											return $.p;
										}),
									$elm$core$Maybe$withDefault(validated.dH),
									A2($elm_community$list_extra$List$Extra$getAt, validated.gv - 1, vehicles_))
							});
					};
					return (!$elm$core$List$length(vehicles_)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{az: false}),
						A2($author$project$Page$CargarStock$doNotify, 'error', 'upload_empty')) : function (model_) {
						return A2(
							$elm$core$Tuple$pair,
							model_,
							A2($author$project$Page$CargarStock$doNotify, 'success', 'upload_ok'));
					}(
						_Utils_update(
							model,
							{
								dl: taskNode_,
								jb: $author$project$Csf$Table$init(
									{
										r: vehicles_,
										w: $author$project$Csf$Table$initialSort('None')
									}),
								az: false,
								aI: A2($elm$core$List$map, validatedMap_, model.aI)
							}));
				} else {
					var error = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'upload_empty');
					return A2(
						$elm$core$Tuple$pair,
						model,
						('redirect_' === handled_) ? A2($author$project$Page$CargarStock$doNotify, 'error', 'error_forbbiden') : A2($author$project$Page$CargarStock$doNotify, 'error', handled_));
				}
			case 10:
				if (!msg.a.$) {
					var stringJson = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a2: false}),
						A2($author$project$Page$CargarStock$doNotify, 'success', 'registration_ok'));
				} else {
					var error_ = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'registration_fail');
					return function (cmdAction) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{a2: false}),
							cmdAction);
					}(
						('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$CargarStock$doNotify, 'error', handled_));
				}
			case 11:
				var uploaderMsg = msg.a;
				return A3(
					$author$project$Page$CargarStock$handleUploader,
					uploaderMsg,
					model,
					A2($author$project$Csf$FileUploader$update, uploaderMsg, model.dG));
			case 12:
				if ((msg.a.$ === 3) && (msg.a.a === 'toggle_error_tooltip')) {
					var _v1 = msg.a;
					var tNde = _v1.b;
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$author$project$Helpers$Utilities$delay,
							0,
							$author$project$Page$CargarStock$ToggleErrorTooltip(tNde.p)));
				} else {
					var tableMsg = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (table_) {
							return _Utils_update(
								model,
								{jb: table_});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$CargarStock$TableMsg),
							A2($author$project$Csf$Table$update, tableMsg, model.jb)));
				}
			default:
				var notifyMsg = msg.a;
				return A2(
					$author$project$Page$CargarStock$handleNotifications,
					model,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Page$CargarStock$NotificationsMsg),
						A2(
							$author$project$Csf$Notifications$update,
							notifyMsg,
							{a7: session.a7})));
		}
	});
var $author$project$Page$ConsultarStock$DateOnQuery = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Page$ConsultarStock$ExportXLSDone = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$ConsultarStock$FilterBadgesMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$ConsultarStock$FilterOnDelay = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$ConsultarStock$GotNowPosix = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$ConsultarStock$NodePagerMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$ConsultarStock$NotificationsMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$ConsultarStock$NullifyDone = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$ConsultarStock$ParseDatesToISO = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$ConsultarStock$ReloadModule = {$: 2};
var $author$project$Page$ConsultarStock$StockLoaded = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$ConsultarStock$TableMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Page$ConsultarStock$TransitioningOFF = function (a) {
	return {$: 14, a: a};
};
var $author$project$Config$ApiEndpoint$anularenstock = F4(
	function (tenant_, stock_item_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-stock-service', 'stock-service', tenant_, stock_item_, unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$anularVehiculo = F3(
	function (ticket_, tenant_, unique_id) {
		return function (deleteEndpoint_) {
			return A2($author$project$Helpers$ApiHandler$delete, deleteEndpoint_, _List_Nil);
		}(
			A4($author$project$Config$ApiEndpoint$anularenstock, tenant_, 'vehicle', unique_id, ticket_));
	});
var $author$project$Route$appendToQuery = F3(
	function (key_, data_, query_) {
		return A3(
			$elm$core$Dict$insert,
			key_,
			$elm$url$Url$percentEncode(data_),
			query_);
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Helpers$Utilities$embeddedDict = F2(
	function (key_, dashlets_) {
		return A3($author$project$Helpers$Utilities$dataFromDict, $elm$core$Dict$empty, key_, dashlets_);
	});
var $author$project$Helpers$Utilities$fromEmbeddedDict = F5(
	function (outter_key_, inner_key_, default_, decoder_, dashlets_) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$get(inner_key_),
			A2($author$project$Helpers$Utilities$decodeMbValue, default_, decoder_),
			A2($author$project$Helpers$Utilities$embeddedDict, outter_key_, dashlets_));
	});
var $author$project$Helpers$Utilities$dashletToggle = F3(
	function (dashlet_, cmdAction, model) {
		var moduleDashlets = model.eO;
		var updToggled = A5($author$project$Helpers$Utilities$fromEmbeddedDict, dashlet_, 'toggled_', false, $elm$json$Json$Decode$bool, moduleDashlets);
		var updDashlet = A3(
			$elm$core$Dict$insert,
			'transitioning_',
			$elm$json$Json$Encode$bool(true),
			A3(
				$elm$core$Dict$insert,
				'toggled_',
				$elm$json$Json$Encode$bool(!updToggled),
				A2($author$project$Helpers$Utilities$embeddedDict, dashlet_, moduleDashlets)));
		return function (dashlets_) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{eO: dashlets_}),
				cmdAction);
		}(
			A3($elm$core$Dict$insert, dashlet_, updDashlet, moduleDashlets));
	});
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hE;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.gQ;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		jw: 1 + (((rd - week1Day1) / 7) | 0),
		jx: wy,
		lw: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.jw;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.jx;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.kA(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.kz(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.kA(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.jU(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.ly(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.ly(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.ly(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.lx(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ly(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.ly(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.c);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.gN, offset) < 0,
					0,
					{hw: col, g: s0.g, gu: s0.gu, gN: offset, iP: row, c: s0.c});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.gN, s.iP, s.hw, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.gN, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	jU: $justinmimbs$date$Date$withOrdinalSuffix,
	kz: $justinmimbs$date$Date$monthToName,
	kA: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	lx: $justinmimbs$date$Date$weekdayToName,
	ly: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $author$project$Helpers$Utilities$appendDateToQuery = F2(
	function (datesData, queryData) {
		var list_tail = function (list_) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$List$tail,
				$elm$core$Maybe$withDefault(_List_Nil))(list_);
		};
		var appendMap = F3(
			function (query_, tail_, _v0) {
				var key_ = _v0.a;
				var mbDate_ = _v0.b;
				return A2(
					$author$project$Helpers$Utilities$appendDateToQuery,
					tail_,
					function (date_) {
						return A3($author$project$Route$appendToQuery, key_, date_, query_);
					}(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$justinmimbs$date$Date$format('yyyy-MM-dd'),
								mbDate_))));
			});
		return A2(
			$elm$core$Maybe$withDefault,
			queryData,
			A2(
				$elm$core$Maybe$map,
				A2(
					appendMap,
					queryData,
					list_tail(datesData)),
				$elm$core$List$head(datesData)));
	});
var $author$project$Helpers$Utilities$removeDateFromQuery = F2(
	function (datesData, queryData) {
		var removeMap = F3(
			function (query_, tail_, _v0) {
				var key_ = _v0.a;
				return A2(
					$author$project$Helpers$Utilities$removeDateFromQuery,
					tail_,
					A2($elm$core$Dict$remove, key_, query_));
			});
		var list_tail = function (list_) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(list_));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			queryData,
			A2(
				$elm$core$Maybe$map,
				A2(
					removeMap,
					queryData,
					list_tail(datesData)),
				$elm$core$List$head(datesData)));
	});
var $author$project$Route$updateRouteData = F2(
	function (route_, routeDta) {
		switch (route_.$) {
			case 4:
				return $author$project$Route$CargarStock(routeDta);
			case 5:
				return $author$project$Route$SolicitarChie(routeDta);
			case 6:
				return $author$project$Route$ConsultarStock(routeDta);
			case 7:
				return $author$project$Route$SolicitudesChie(routeDta);
			case 9:
				return $author$project$Route$PendientesDeFirma(routeDta);
			case 10:
				return $author$project$Route$PendientesAprobacion(routeDta);
			case 8:
				return $author$project$Route$HistorialDeCargas(routeDta);
			default:
				return route_;
		}
	});
var $author$project$Helpers$ApiHandler$dateOnQueryMsg = F5(
	function (action_, datesData, navKey, queryData, route_) {
		switch (action_) {
			case 'clear_query':
				return A2(
					$author$project$Route$goTo,
					navKey,
					A2(
						$author$project$Route$updateRouteData,
						route_,
						{
							iI: A2($author$project$Helpers$Utilities$removeDateFromQuery, datesData, queryData)
						}));
			case 'update_query':
				return A2(
					$author$project$Route$goTo,
					navKey,
					A2(
						$author$project$Route$updateRouteData,
						route_,
						{
							iI: A2($author$project$Helpers$Utilities$appendDateToQuery, datesData, queryData)
						}));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Helpers$Utilities$decodeAggregations_ = F3(
	function (field_, decoder_, string_) {
		var fail_ = $elm$json$Json$Decode$fail('Error decoding aggregations');
		var andThen_ = function (value__) {
			return A2(
				$elm$core$Result$withDefault,
				fail_,
				A2(
					$elm$core$Result$map,
					$elm$json$Json$Decode$succeed,
					A2($elm$json$Json$Decode$decodeValue, decoder_, value__)));
		};
		return function (decodes_) {
			return A3($author$project$Helpers$Utilities$decodeString_, _List_Nil, decodes_, string_);
		}(
			A3(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$list,
				$elm$json$Json$Decode$at(
					_List_fromArray(
						['aggregations', field_, 'buckets'])),
				A2($elm$json$Json$Decode$andThen, andThen_, $elm$json$Json$Decode$value)));
	});
var $author$project$Helpers$Utilities$decodeAggregations = F3(
	function (field_, decoder_, string_) {
		return A3(
			$author$project$Helpers$Utilities$decodeAggregations_,
			field_,
			A2($elm$json$Json$Decode$field, 'key', decoder_),
			string_);
	});
var $author$project$Page$ConsultarStock$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('head_loaded', 'Stock de Vehículos de la Importadora'),
		_Utils_Tuple2('card_title_loaded', 'Vehículos'),
		_Utils_Tuple2('export_ok', 'Se ha exportado el excel exitosamente.'),
		_Utils_Tuple2('export_failed', 'Lo sentimos, ha ocurrido un error en la exportación.'),
		_Utils_Tuple2('export_filename', 'Vehiculos_del_Stock.xlsx'),
		_Utils_Tuple2('vehiculos_empty', 'No hay vehículos en el stock'),
		_Utils_Tuple2('nullify_ok', 'Se ha anulado el vehículo exitosamente.'),
		_Utils_Tuple2('nullify_failed', 'Ha ocurrido un error intentando anular el vehículo.'),
		_Utils_Tuple2('confirm_nullify', 'Confirme que desea anular el vehículo seleccionado.'),
		_Utils_Tuple2('nullify_unavailable', 'No es posible anular el vehículo en su estado actual.'),
		_Utils_Tuple2('nullify_forbidden', 'Lo sentimos, no posee los privilegios necesarios para anular el vehículo.'),
		_Utils_Tuple2('vehiculos_failed', 'No ha sido posible listar los vehículos del stock'),
		_Utils_Tuple2('stock_load_failed', 'Lo sentimos, ha ocurrido un error en la carga del stock de vehículos.')
	]);
var $author$project$Page$ConsultarStock$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_),
			$author$project$Page$ConsultarStock$moduleCaptions_));
};
var $author$project$Page$ConsultarStock$doNotify = function (type_) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$ConsultarStock$moduleMessage,
		A2($author$project$Helpers$Utilities$setNotification, $author$project$Page$ConsultarStock$NotificationsMsg, type_));
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$bytesResolver = A2(_Http_expect, 'arraybuffer', _Http_toDataView);
var $author$project$Csf$Call$bytesResolver = $elm$http$Http$bytesResolver(
	function (response) {
		switch (response.$) {
			case 4:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Ok(body);
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			default:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.bE));
		}
	});
var $author$project$Config$ApiEndpoint$exportarreporte = F3(
	function (tenant_, report_item_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-report-service', 'report-service', tenant_, report_item_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$exportarVehiculos = F3(
	function (ticket_, tenant_, query_) {
		return $elm$http$Http$task(
			{
				h: A2($elm$core$Basics$composeR, $author$project$ElasticSearch$encodeQuery, $elm$http$Http$jsonBody)(query_),
				i: _List_Nil,
				j: 'POST',
				k: $author$project$Csf$Call$bytesResolver,
				m: $elm$core$Maybe$Nothing,
				q: A3($author$project$Config$ApiEndpoint$exportarreporte, tenant_, 'vehicles', ticket_)
			});
	});
var $author$project$ElasticSearch$Gte = function (a) {
	return {$: 1, a: a};
};
var $author$project$ElasticSearch$gte = $author$project$ElasticSearch$Gte;
var $author$project$ElasticSearch$NoLowerBound = {$: 0};
var $author$project$ElasticSearch$gtn = $author$project$ElasticSearch$NoLowerBound;
var $author$project$ElasticSearch$Lte = function (a) {
	return {$: 1, a: a};
};
var $author$project$ElasticSearch$lte = $author$project$ElasticSearch$Lte;
var $author$project$ElasticSearch$NoUpperBound = {$: 0};
var $author$project$ElasticSearch$ltn = $author$project$ElasticSearch$NoUpperBound;
var $author$project$ElasticSearch$Range = function (a) {
	return {$: 3, a: a};
};
var $author$project$ElasticSearch$RangeQuery = F6(
	function (name, from, to, boost, queryName, relation) {
		return {ak: boost, hZ: from, dc: name, cj: queryName, iJ: relation, ji: to};
	});
var $author$project$ElasticSearch$range = F3(
	function (name, from, to) {
		return $author$project$ElasticSearch$Range(
			A6($author$project$ElasticSearch$RangeQuery, name, from, to, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
	});
var $author$project$ElasticSearch$StringValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$ElasticSearch$string = $author$project$ElasticSearch$StringValue;
var $author$project$Helpers$Utilities$appendDateRange = F2(
	function (field_, _v0) {
		var startDte = _v0.a;
		var endDte = _v0.b;
		var _v1 = _Utils_Tuple2(startDte, endDte);
		if (_v1.a === '') {
			if (_v1.b === '') {
				return _List_Nil;
			} else {
				var end_ = _v1.b;
				return $elm$core$List$singleton(
					A3(
						$author$project$ElasticSearch$range,
						field_,
						$author$project$ElasticSearch$gtn,
						A2($elm$core$Basics$composeR, $author$project$ElasticSearch$string, $author$project$ElasticSearch$lte)(end_)));
			}
		} else {
			if (_v1.b === '') {
				var start_ = _v1.a;
				return $elm$core$List$singleton(
					function (lowerBound_) {
						return A3($author$project$ElasticSearch$range, field_, lowerBound_, $author$project$ElasticSearch$ltn);
					}(
						A2($elm$core$Basics$composeR, $author$project$ElasticSearch$string, $author$project$ElasticSearch$gte)(start_)));
			} else {
				var start_ = _v1.a;
				var end_ = _v1.b;
				return $elm$core$List$singleton(
					A3(
						$author$project$ElasticSearch$range,
						field_,
						A2($elm$core$Basics$composeR, $author$project$ElasticSearch$string, $author$project$ElasticSearch$gte)(start_),
						A2($elm$core$Basics$composeR, $author$project$ElasticSearch$string, $author$project$ElasticSearch$lte)(end_)));
			}
		}
	});
var $author$project$Helpers$Utilities$handleQueryFilter = F4(
	function (discardDeleted, filterMap, queryData, appendToQry) {
		var mustNotDeleted = function () {
			if (!discardDeleted) {
				return _List_Nil;
			} else {
				return $elm$core$List$singleton(
					$author$project$ElasticSearch$mustNot(
						$elm$core$List$singleton(
							A2(
								$author$project$ElasticSearch$term,
								'deleted',
								$author$project$ElasticSearch$boolean(true)))));
			}
		}();
		return $author$project$ElasticSearch$bool(
			A3(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$core$List$append(mustNotDeleted),
				A3(
					$elm$core$Basics$composeR,
					$elm$core$List$concat,
					$author$project$ElasticSearch$must,
					_Utils_ap(
						appendToQry,
						A2(
							$elm$core$List$filterMap,
							filterMap,
							$elm$core$Dict$keys(queryData))))));
	});
var $author$project$ElasticSearch$IntValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$ElasticSearch$int = $author$project$ElasticSearch$IntValue;
var $author$project$ElasticSearch$Match = function (a) {
	return {$: 1, a: a};
};
var $author$project$ElasticSearch$MatchQuery = F2(
	function (name, value) {
		return {dc: name, lt: value};
	});
var $author$project$ElasticSearch$match = F2(
	function (name, value) {
		return $author$project$ElasticSearch$Match(
			A2($author$project$ElasticSearch$MatchQuery, name, value));
	});
var $author$project$ElasticSearch$WildCard = function (a) {
	return {$: 2, a: a};
};
var $author$project$ElasticSearch$WildCardQuery = F2(
	function (name, value) {
		return {dc: name, lt: value};
	});
var $author$project$ElasticSearch$wildcard = F2(
	function (name, value) {
		return $author$project$ElasticSearch$WildCard(
			A2($author$project$ElasticSearch$WildCardQuery, name, value));
	});
var $author$project$Page$ConsultarStock$filtersFromQuery = function (queryData) {
	var toWildcard = F2(
		function (field_, data_) {
			return A3(
				$elm$core$Basics$composeR,
				$author$project$ElasticSearch$string,
				$author$project$ElasticSearch$wildcard(field_),
				'*' + (data_ + '*'));
		});
	var mbeDtaMap = F2(
		function (key_, value_) {
			if ($author$project$Helpers$Utilities$trimmedEmpty(value_)) {
				return _List_Nil;
			} else {
				switch (key_) {
					case 'vin':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('vin'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'cit':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('cit'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'anno':
						return $elm$core$List$singleton(
							A3(
								$elm$core$Basics$composeR,
								$author$project$ElasticSearch$int,
								$author$project$ElasticSearch$term('ano'),
								A2(
									$elm$core$Maybe$withDefault,
									2019,
									$elm$core$String$toInt(value_))));
					case 'tipo':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('tipo'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'marca':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('marca'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'motor':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('motor'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'estado':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$match('estado_chie'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'estado_vh':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$match('estado_vehiculo'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'modelo':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('modelo'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'color':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('color'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'id_carga':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('id_lote'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					default:
						return _List_Nil;
				}
			}
		});
	var queryDtaMap = function (key_) {
		return A2(
			$elm$core$Maybe$map,
			mbeDtaMap(key_),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Route$dataFromQuery(key_),
				$elm$core$Maybe$Just)(queryData));
	};
	var excluded_keys = _List_fromArray(
		['cargafini', 'cargaffin', 'emisionfini', 'emisionffin']);
	var queryData_ = function (filter_) {
		return A2($elm$core$Dict$filter, filter_, queryData);
	}(
		F2(
			function (key_, _v1) {
				return A2(
					$elm$core$Basics$composeR,
					$elm$core$List$member(key_),
					$elm$core$Basics$not)(excluded_keys);
			}));
	var dataTrimmed = function (key_) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Route$dataFromQuery(key_),
			$elm$core$String$trim)(queryData);
	};
	var appendRange = F2(
		function (_v0, field_) {
			var start_key = _v0.a;
			var end_key = _v0.b;
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$appendDateRange(field_),
				$elm$core$List$singleton,
				_Utils_Tuple2(
					dataTrimmed(start_key),
					dataTrimmed(end_key)));
		});
	var dateRanges_ = _Utils_ap(
		A2(
			appendRange,
			_Utils_Tuple2('cargafini', 'cargaffin'),
			'inserted_at'),
		A2(
			appendRange,
			_Utils_Tuple2('emisionfini', 'emisionffin'),
			'fecha_emision_chie'));
	return A4($author$project$Helpers$Utilities$handleQueryFilter, true, queryDtaMap, queryData_, dateRanges_);
};
var $author$project$SelectTwo$Types$DelayedSelectTwoAjax = function (a) {
	return {$: 5, a: a};
};
var $author$project$SelectTwo$Types$STRes = function (a) {
	return {$: 6, a: a};
};
var $author$project$SelectTwo$Types$SelectTwoOpen = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$SelectTwo$Types$SentAjax = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$SelectTwo$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$SelectTwo$ajaxCmd = F4(
	function (sender, ajaxParams, reset, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (id_) {
					return $author$project$SelectTwo$send(
						sender(
							A3($author$project$SelectTwo$Types$SentAjax, id_, ajaxParams, reset)));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (st) {
						return st.jB ? $elm$core$Maybe$Just(st.kk) : $elm$core$Maybe$Nothing;
					},
					model.k5)));
	});
var $author$project$SelectTwo$Private$defaultParams = function (filter) {
	return {br: true, kB: false, t: 1, lj: filter};
};
var $author$project$SelectTwo$incrementPage = F3(
	function (scrollTop, scrollHeight, params) {
		var scrollPageHeight = scrollHeight / params.t;
		var scrollPageTop = (scrollTop - scrollHeight) + scrollPageHeight;
		return ((scrollPageTop / scrollPageHeight) > 0.7) && ((!params.br) && params.kB);
	});
var $author$project$SelectTwo$map = F2(
	function (f, model) {
		var newSelectTwo = A2($elm$core$Maybe$map, f, model.k5);
		return _Utils_update(
			model,
			{k5: newSelectTwo});
	});
var $author$project$SelectTwo$sendPageIncrement = F5(
	function (sender, model, scrollTop, scrollHeight, ajaxParams) {
		if (A3($author$project$SelectTwo$incrementPage, scrollTop, scrollHeight, ajaxParams)) {
			var newModel = A2(
				$author$project$SelectTwo$map,
				function (s) {
					return _Utils_update(
						s,
						{
							bd: $elm$core$Maybe$Just(
								_Utils_update(
									ajaxParams,
									{t: ajaxParams.t + 1}))
						});
				},
				model);
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					newModel,
					A4(
						$author$project$SelectTwo$ajaxCmd,
						sender,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$SelectTwo$Private$defaultParams(''),
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.bd;
								},
								newModel.k5)),
						false,
						newModel)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$SelectTwo$checkScrollPage = F4(
	function (scrollTop, scrollHeight, sender, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$andThen,
				A4($author$project$SelectTwo$sendPageIncrement, sender, model, scrollTop, scrollHeight),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.bd;
					},
					model.k5)));
	});
var $author$project$SelectTwo$delayedSend = F2(
	function (milli, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(1000 * milli));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$SelectTwo$new = F2(
	function (dropdown, model) {
		return _Utils_update(
			model,
			{
				k5: $elm$core$Maybe$Just(
					{
						jB: dropdown.jB,
						bd: $elm$core$Maybe$Just(
							$author$project$SelectTwo$Private$defaultParams('')),
						eg: dropdown,
						h3: $elm$core$Maybe$Nothing,
						kk: dropdown.kk,
						kv: _List_Nil,
						gZ: $elm$core$Maybe$Nothing
					})
			});
	});
var $author$project$SelectTwo$setSearch = function (filter) {
	var search = (filter === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(filter);
	return $author$project$SelectTwo$map(
		function (s) {
			return _Utils_update(
				s,
				{gZ: search});
		});
};
var $author$project$SelectTwo$Private$uncurry3 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return A3(f, a, b, c);
	});
var $author$project$SelectTwo$updateDropdown = F2(
	function (elem, model) {
		var selectTwo = A2(
			$elm$core$Maybe$map,
			function (st) {
				var dropdown = st.eg;
				var newDropdown = _Utils_update(
					dropdown,
					{lz: elem.gj.lz, lD: 49});
				return _Utils_update(
					st,
					{eg: newDropdown});
			},
			model.k5);
		return _Utils_update(
			model,
			{k5: selectTwo});
	});
var $author$project$SelectTwo$update = F4(
	function (sender, msg, maybeAjax, model) {
		switch (msg.$) {
			case 0:
				var dd = msg.a;
				var newModel = A2($author$project$SelectTwo$new, dd, model);
				return _Utils_Tuple2(
					newModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeR,
							$author$project$SelectTwo$Types$SelectTwoOpen(dd),
							sender),
						$elm$browser$Browser$Dom$getElement(dd.kk)));
			case 1:
				if (!msg.b.$) {
					var dd = msg.a;
					var elem = msg.b.a;
					var newModel = A2($author$project$SelectTwo$updateDropdown, elem, model);
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									A2($elm$core$Basics$composeR, $author$project$SelectTwo$Types$STRes, sender),
									$elm$browser$Browser$Dom$focus(dd.kk + '--search')),
									A4(
									$author$project$SelectTwo$ajaxCmd,
									sender,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$SelectTwo$Private$defaultParams(''),
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.bd;
											},
											newModel.k5)),
									false,
									A2(
										$author$project$SelectTwo$map,
										function (s) {
											return _Utils_update(
												s,
												{kv: _List_Nil});
										},
										newModel))
								])));
				} else {
					var dd = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k5: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var hovered = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$SelectTwo$map,
						function (s) {
							return _Utils_update(
								s,
								{h3: hovered});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 3:
				var mg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k5: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$SelectTwo$send, mg)));
			case 4:
				var filter = msg.a;
				return _Utils_Tuple2(
					A2($author$project$SelectTwo$setSearch, filter, model),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$andThen,
							function (dd) {
								return $elm$core$Maybe$Just(
									A2(
										$author$project$SelectTwo$delayedSend,
										dd.jX,
										sender(
											$author$project$SelectTwo$Types$DelayedSelectTwoAjax(filter))));
							},
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.eg;
								},
								model.k5))));
			case 5:
				var filter = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$andThen,
							function (search) {
								return _Utils_eq(search, filter) ? $elm$core$Maybe$Just(
									A4(
										$author$project$SelectTwo$ajaxCmd,
										sender,
										$author$project$SelectTwo$Private$defaultParams(filter),
										true,
										A2(
											$author$project$SelectTwo$map,
											function (s) {
												return _Utils_update(
													s,
													{kv: _List_Nil});
											},
											model))) : $elm$core$Maybe$Nothing;
							},
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$Basics$identity,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.gZ;
									},
									model.k5)))));
			case 10:
				var scrollHeight = msg.a.k3;
				var scrollTop = msg.a.k4;
				return A4($author$project$SelectTwo$checkScrollPage, scrollTop, scrollHeight, sender, model);
			case 7:
				var mg = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$SelectTwo$send(mg));
			case 6:
				var a = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var id_ = msg.a;
				var params = msg.b;
				var reset = msg.c;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2(
								$author$project$SelectTwo$Private$uncurry3,
								a,
								_Utils_Tuple3(id_, params, reset));
						},
						maybeAjax));
		}
	});
var $author$project$Customized$CustomDropdown$update = F2(
	function (mssg, model) {
		if (!mssg.$) {
			var mbString = mssg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bj: false, by: mbString}),
				$elm$core$Platform$Cmd$none);
		} else {
			var selectMsg = mssg.a;
			var isOpen_ = function () {
				if (selectMsg.$ === 1) {
					return true;
				} else {
					return model.bj;
				}
			}();
			return function (_v1) {
				var model_ = _v1.a;
				var cmdAction = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model_,
						{bj: isOpen_}),
					cmdAction);
			}(
				function (ajaxParams) {
					return A4(
						$author$project$SelectTwo$update,
						$author$project$Customized$CustomDropdown$SelectTwoMsg_,
						selectMsg,
						$elm$core$Maybe$Just(ajaxParams),
						model);
				}(
					F3(
						function (id_, params, reset) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						})));
		}
	});
var $author$project$Page$ConsultarStock$updateQueryFromDropdown = F3(
	function (queryKey, mbString, model) {
		var session = model.g$;
		var queryData = model.kX;
		return function (route_) {
			return _Utils_Tuple2(
				model,
				A2($author$project$Route$goTo, session.gL, route_));
		}(
			function (query_) {
				return $author$project$Route$ConsultarStock(
					{iI: query_});
			}(
				function () {
					if (!mbString.$) {
						var string_ = mbString.a;
						return A3($author$project$Route$appendToQuery, queryKey, string_, queryData);
					} else {
						return A2($author$project$Route$removeFromQuery, queryKey, queryData);
					}
				}()));
	});
var $author$project$Page$ConsultarStock$handleAnnoDropdown = F2(
	function (dropdownMsg, model) {
		var annoDropdown = model.aN;
		if (!dropdownMsg.$) {
			var mbString = dropdownMsg.a;
			return A3($author$project$Page$ConsultarStock$updateQueryFromDropdown, 'anno', mbString, model);
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return _Utils_update(
						model,
						{aN: dropdown_});
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						$author$project$Page$ConsultarStock$DropdownMsg(3)),
					A2($author$project$Customized$CustomDropdown$update, dropdownMsg, annoDropdown)));
		}
	});
var $author$project$Page$ConsultarStock$handleEstadoDropdown = F2(
	function (dropdownMsg, model) {
		var estadoDropdown = model.aS;
		if (!dropdownMsg.$) {
			var mbString = dropdownMsg.a;
			return A3($author$project$Page$ConsultarStock$updateQueryFromDropdown, 'estado', mbString, model);
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return _Utils_update(
						model,
						{aS: dropdown_});
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						$author$project$Page$ConsultarStock$DropdownMsg(8)),
					A2($author$project$Customized$CustomDropdown$update, dropdownMsg, estadoDropdown)));
		}
	});
var $author$project$Page$ConsultarStock$handleEstadoVhDropdown = F2(
	function (dropdownMsg, model) {
		var estadoVhDropdown = model.bX;
		if (!dropdownMsg.$) {
			var mbString = dropdownMsg.a;
			return A3($author$project$Page$ConsultarStock$updateQueryFromDropdown, 'estado_vh', mbString, model);
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return _Utils_update(
						model,
						{bX: dropdown_});
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						$author$project$Page$ConsultarStock$DropdownMsg(11)),
					A2($author$project$Customized$CustomDropdown$update, dropdownMsg, estadoVhDropdown)));
		}
	});
var $author$project$Helpers$ApiHandler$handleHttpError = F2(
	function (error_, stringMssg) {
		switch (error_.$) {
			case 1:
				return 'error_timeout';
			case 0:
				var url_ = error_.a;
				return 'error_badurl';
			case 2:
				return 'error_networkerror';
			case 4:
				var string_ = error_.a;
				return 'error_badbody';
			default:
				var status_ = error_.a;
				return A2(
					$elm$core$List$member,
					status_,
					_List_fromArray(
						[401, 403])) ? 'redirect_' : stringMssg;
		}
	});
var $author$project$Page$ConsultarStock$handleMarcaDropdown = F2(
	function (dropdownMsg, model) {
		var marcaDropdown = model.aZ;
		if (!dropdownMsg.$) {
			var mbString = dropdownMsg.a;
			return A3($author$project$Page$ConsultarStock$updateQueryFromDropdown, 'marca', mbString, model);
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return _Utils_update(
						model,
						{aZ: dropdown_});
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						$author$project$Page$ConsultarStock$DropdownMsg(6)),
					A2($author$project$Customized$CustomDropdown$update, dropdownMsg, marcaDropdown)));
		}
	});
var $author$project$Page$ConsultarStock$ConfirmNullifyModal = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$ConsultarStock$handleNullify = F2(
	function (tNde, model) {
		var session = model.g$;
		var notNullified = function (state_) {
			return !A2(
				$elm$core$List$member,
				$author$project$Helpers$Utilities$trimmedToLower(state_),
				_List_fromArray(
					['anulado']));
		}(
			A3($author$project$Csf$TaskNodeUtils$string, '', 'estado_vehiculo', tNde));
		var isUserAdmin = function (user_) {
			return A2(
				$author$project$Helpers$ApiHandler$hasUserAccess,
				user_,
				_List_fromArray(
					['ADMINISTRATOR']));
		}(
			$author$project$Csf$Flags$userNode(session.ka));
		var availableStates = _List_fromArray(
			['disponible', 'anulado_chie', 'solicitud_anulada']);
		var isAvailable = notNullified && function (state_) {
			return A2(
				$elm$core$List$member,
				$author$project$Helpers$Utilities$trimmedToLower(state_),
				availableStates);
		}(
			A3($author$project$Csf$TaskNodeUtils$string, '', 'estado_chie', tNde));
		return A2(
			$elm$core$Tuple$pair,
			model,
			(isUserAdmin && isAvailable) ? A3(
				$elm$core$Basics$composeR,
				$author$project$Page$ConsultarStock$ConfirmNullifyModal,
				$author$project$Helpers$Utilities$delay(0),
				_Utils_Tuple2(
					A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', tNde),
					tNde.p)) : (isUserAdmin ? A2($author$project$Page$ConsultarStock$doNotify, 'error', 'nullify_unavailable') : A2($author$project$Page$ConsultarStock$doNotify, 'error', 'nullify_forbidden')));
	});
var $author$project$DatePicker$Clear = {$: 3};
var $author$project$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$DatePicker$EmptyString = {$: 1};
var $author$project$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $author$project$DatePicker$None = {$: 0};
var $author$project$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $author$project$DatePicker$Date$Year = 1;
var $author$project$DatePicker$Date$nextPeriod = function (period) {
	switch (period) {
		case 2:
			return 1;
		case 1:
			return 0;
		default:
			return period;
	}
};
var $author$project$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.aV;
		var focused = model.O;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: $elm$core$Maybe$Just(date),
							a8: date
						}),
					$author$project$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: $elm$core$Maybe$Just(date),
							ag: $author$project$DatePicker$Date$nextPeriod(model.ag)
						}),
					$author$project$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: $elm$core$Maybe$Just(date)
						}),
					$author$project$DatePicker$None);
			case 3:
				var period = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ag: period}),
					$author$project$DatePicker$None);
			case 4:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{O: $elm$core$Maybe$Nothing, aq: $elm$core$Maybe$Nothing, au: false}),
					$author$project$DatePicker$Picked(date));
			case 5:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aq: $elm$core$Maybe$Just(text)
						}),
					$author$project$DatePicker$None);
			case 6:
				if (forceOpen) {
					return _Utils_Tuple2(model, $author$project$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.aq;
						if (_v5.$ === 1) {
							return $author$project$DatePicker$FailedInput($author$project$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $author$project$DatePicker$FailedInput($author$project$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.gT(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.ey(date) ? $author$project$DatePicker$FailedInput(
										$author$project$DatePicker$Disabled(date)) : $author$project$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $author$project$DatePicker$FailedInput(
										$author$project$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								O: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.O;
									}
								}(),
								aq: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aq;
									}
								}()
							}),
						dateEvent);
				}
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aV: false, au: true}),
					$author$project$DatePicker$None);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{au: forceOpen}),
					$author$project$DatePicker$None);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aV: true}),
					$author$project$DatePicker$None);
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aV: false}),
					$author$project$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{au: forceOpen}),
					$author$project$DatePicker$Clear);
		}
	});
var $author$project$Helpers$Utilities$handlePickerMsg = F3(
	function (_v0, settings_, pickerMsg) {
		var mdelDate = _v0.a;
		var mdelPicker = _v0.b;
		var updateMap = function (_v2) {
			var picker_ = _v2.a;
			var pickerEvt = _v2.b;
			switch (pickerEvt.$) {
				case 1:
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_update(
							picker_,
							{aq: $elm$core$Maybe$Nothing}),
						'');
				case 2:
					var date_ = pickerEvt.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Just(date_),
						picker_,
						'update_query');
				case 3:
					return _Utils_Tuple3($elm$core$Maybe$Nothing, picker_, 'clear_query');
				default:
					return _Utils_Tuple3(mdelDate, picker_, '');
			}
		};
		return updateMap(
			A3($author$project$DatePicker$update, settings_, pickerMsg, mdelPicker));
	});
var $billstclair$elm_sortable_table$Table$getSortState = function (state) {
	var column = state.a;
	var isReversed = state.b;
	return _Utils_Tuple2(column, isReversed);
};
var $author$project$Csf$Table$getSortState = function (state_) {
	var mapSecond = function (sorted_) {
		return sorted_ ? 1 : 0;
	};
	return A2(
		$elm$core$Tuple$mapSecond,
		mapSecond,
		$billstclair$elm_sortable_table$Table$getSortState(state_));
};
var $author$project$Helpers$ApiHandler$handleTableSort = F4(
	function (state_, model, allowedToSortBy_, route_) {
		var session = model.g$;
		var queryData = model.kX;
		var tableModel = model.jb;
		var _v0 = $author$project$Csf$Table$getSortState(state_);
		var column_ = _v0.a;
		var order_ = _v0.b;
		var sorter_key = A2(
			$elm$core$Maybe$withDefault,
			'',
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Dict$keys,
				$elm$core$List$head,
				function (filter_) {
					return A2($elm$core$Dict$filter, filter_, allowedToSortBy_);
				}(
					F2(
						function (_v1, _v2) {
							var table_column = _v2.lf;
							return _Utils_eq(column_, table_column);
						}))));
		var thereIsNoChange = _Utils_eq(
			_Utils_Tuple2(column_, order_),
			$author$project$Csf$Table$getSortState(tableModel.w));
		return A2(
			$elm$core$Tuple$pair,
			model,
			thereIsNoChange ? $elm$core$Platform$Cmd$none : A2(
				$author$project$Route$goTo,
				session.gL,
				function (query_) {
					return A2(
						$author$project$Route$updateRouteData,
						route_,
						{iI: query_});
				}(
					A3(
						$author$project$Route$appendToQuery,
						'sortBy',
						A2($author$project$Helpers$Utilities$soterField, sorter_key, order_),
						queryData))));
	});
var $author$project$Page$ConsultarStock$handleTipoDropdown = F2(
	function (dropdownMsg, model) {
		var tipoDropdown = model.a5;
		if (!dropdownMsg.$) {
			var mbString = dropdownMsg.a;
			return A3($author$project$Page$ConsultarStock$updateQueryFromDropdown, 'tipo', mbString, model);
		} else {
			return A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return _Utils_update(
						model,
						{a5: dropdown_});
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(
						$author$project$Page$ConsultarStock$DropdownMsg(4)),
					A2($author$project$Customized$CustomDropdown$update, dropdownMsg, tipoDropdown)));
		}
	});
var $author$project$Page$ConsultarStock$keyQueryFromField = function (field_) {
	switch (field_) {
		case 1:
			return 'vin';
		case 2:
			return 'cit';
		case 5:
			return 'color';
		case 7:
			return 'modelo';
		case 9:
			return 'id_carga';
		case 10:
			return 'motor';
		default:
			return '';
	}
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.jz - 1)) + ($justinmimbs$date$Date$monthToNumber(date.il) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.hE,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Helpers$Utilities$lastNDaysRange = F3(
	function (_v0, nDays, modelMsg) {
		var iniField = _v0.a;
		var endField = _v0.b;
		return A2(
			$elm$core$Task$perform,
			modelMsg,
			function (andThen_) {
				return A2($elm$core$Task$andThen, andThen_, $justinmimbs$date$Date$today);
			}(
				function (date_) {
					return function (fromDate) {
						return $elm$core$Task$succeed(
							_List_fromArray(
								[
									fromDate,
									_Utils_Tuple2(
									endField,
									$elm$core$Maybe$Just(date_))
								]));
					}(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$Just,
							$elm$core$Tuple$pair(iniField))(
							A3($justinmimbs$date$Date$add, 3, nDays, date_)));
				}));
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Config$MimeTypes$defaultMime = 'application/octet-stream';
var $author$project$Config$MimeTypes$fileMimeTypes = _List_fromArray(
	[
		_Utils_Tuple2('bin', 'application/octet-stream'),
		_Utils_Tuple2('jpg', 'image/jpeg'),
		_Utils_Tuple2('jpeg', 'image/jpeg'),
		_Utils_Tuple2('png', 'image/png'),
		_Utils_Tuple2('tif', 'image/tiff'),
		_Utils_Tuple2('tiff', 'image/tiff'),
		_Utils_Tuple2('bmp', 'image/bmp'),
		_Utils_Tuple2('pdf', 'application/pdf'),
		_Utils_Tuple2('doc', 'application/msword'),
		_Utils_Tuple2('docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'),
		_Utils_Tuple2('xml', 'application/xml'),
		_Utils_Tuple2('xls', 'application/vnd.ms-excel'),
		_Utils_Tuple2('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
	]);
var $author$project$Helpers$Utilities$mimeFromExtension = function (fileExtension) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Config$MimeTypes$defaultMime,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(fileExtension))($author$project$Config$MimeTypes$fileMimeTypes));
};
var $author$project$Csf$Core$onTimeZone = F2(
	function (zone, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{lG: zone}),
			$elm$core$Platform$Cmd$none);
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $author$project$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $author$project$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $author$project$DatePicker$Date$Off = {$: 0};
var $author$project$DatePicker$off = $author$project$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$DatePicker$defaultSettings = {
	f5: $author$project$DatePicker$formatCell,
	d2: $author$project$DatePicker$off,
	bP: 'elm-datepicker--',
	ga: _List_Nil,
	gd: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	ge: $author$project$DatePicker$Date$formatDay,
	ej: 6,
	gy: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	gz: _List_Nil,
	gA: $elm$core$Maybe$Nothing,
	gB: $elm$core$Maybe$Nothing,
	ey: $elm$core$Basics$always(false),
	gK: $author$project$DatePicker$Date$formatMonth,
	gT: $justinmimbs$date$Date$fromIsoString,
	kV: 'Seleccionar una fecha',
	dR: $elm$core$String$fromInt
};
var $author$project$Helpers$Utilities$pickerSettings_ = function (pickerID) {
	return function (settings_) {
		return _Utils_update(
			settings_,
			{
				ge: $author$project$DatePicker$Date$es.ly,
				gz: _List_fromArray(
					[
						_Utils_Tuple2('form-control', true)
					]),
				gA: $elm$core$Maybe$Just('date-' + pickerID),
				gB: $elm$core$Maybe$Just('datePicker-' + pickerID),
				gK: $author$project$DatePicker$Date$es.kz
			});
	}($author$project$DatePicker$defaultSettings);
};
var $author$project$Csf$Modal$Show = 0;
var $author$project$Csf$Modal$shown = 0;
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Csf$DateFormat$formatIsoDate = F3(
	function (format_, zone_, string_) {
		return A2(
			$elm$core$Maybe$map,
			A2($author$project$Csf$DateFormat$formatDate, format_, zone_),
			$elm$core$Result$toMaybe(
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(string_)));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Csf$DateFormat$toUtcIsoString = F4(
	function (offset_, hours_, minutes_, string_) {
		var utcIsoFormat = 'YYYY-MM-DDTHH:mm:ss.sssZ';
		var tzOffset = $elm$core$List$sum(
			_List_fromArray(
				[hours_ * 60, minutes_, offset_ * (-1)]));
		var customZone_ = A2($elm$time$Time$customZone, tzOffset, _List_Nil);
		return A3($author$project$Csf$DateFormat$formatIsoDate, utcIsoFormat, customZone_, string_);
	});
var $author$project$Helpers$Utilities$todaysDateRange = F2(
	function (_v0, modelMsg) {
		var iniField = _v0.a;
		var endField = _v0.b;
		return A2(
			$elm$core$Task$perform,
			modelMsg,
			function (andThen_) {
				return A2($elm$core$Task$andThen, andThen_, $justinmimbs$date$Date$today);
			}(
				function (date_) {
					return $elm$core$Task$succeed(
						_List_fromArray(
							[
								_Utils_Tuple2(
								iniField,
								$elm$core$Maybe$Just(date_)),
								_Utils_Tuple2(
								endField,
								$elm$core$Maybe$Just(date_))
							]));
				}));
	});
var $author$project$Helpers$Utilities$transitioningOff = F2(
	function (dashlet_, model) {
		var moduleDashlets = model.eO;
		return function (moduleDashlets_) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{eO: moduleDashlets_}),
				$elm$core$Platform$Cmd$none);
		}(
			function (updted_) {
				return A3($elm$core$Dict$insert, dashlet_, updted_, moduleDashlets);
			}(
				A3(
					$elm$core$Dict$insert,
					'transitioning_',
					$elm$json$Json$Encode$bool(false),
					A2($author$project$Helpers$Utilities$embeddedDict, dashlet_, moduleDashlets))));
	});
var $author$project$Route$queryFromRoute = function (route_) {
	switch (route_.$) {
		case 4:
			var query = route_.a.iI;
			return query;
		case 5:
			var query = route_.a.iI;
			return query;
		case 6:
			var query = route_.a.iI;
			return query;
		case 7:
			var query = route_.a.iI;
			return query;
		case 8:
			var query = route_.a.iI;
			return query;
		case 10:
			var query = route_.a.iI;
			return query;
		case 9:
			var query = route_.a.iI;
			return query;
		default:
			return $elm$core$Dict$empty;
	}
};
var $author$project$Csf$FilterBadges$routeFilter = F3(
	function (action_, key_, _v0) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$member(key_),
			action_,
			_List_fromArray(
				['page', 'pageSize', 'sortBy']));
	});
var $author$project$Csf$FilterBadges$update = F2(
	function (mssg, model) {
		if (!mssg.$) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var badge_ = mssg.a;
			return function (route_) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bC: route_}),
					A2($author$project$Route$goTo, model.gL, route_));
			}(
				function (query_) {
					return A2(
						$author$project$Route$updateRouteData,
						model.bC,
						{iI: query_});
				}(
					function () {
						if (badge_ === 'all-badges') {
							return A2(
								$elm$core$Dict$filter,
								$author$project$Csf$FilterBadges$routeFilter($elm$core$Basics$identity),
								$author$project$Route$queryFromRoute(model.bC));
						} else {
							return A2(
								$elm$core$Dict$remove,
								badge_,
								$author$project$Route$queryFromRoute(model.bC));
						}
					}()));
		}
	});
var $author$project$Csf$NodePager$GoToPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Csf$NodePager$focuseOnValue = _Platform_outgoingPort('focuseOnValue', $elm$json$Json$Encode$string);
var $author$project$Csf$NodePager$processPagerMdel = F2(
	function (pageAction, model) {
		var route = model.bC;
		var navKey = model.gL;
		var currentPage = model.af;
		var routeToGo = function (qry) {
			return A2(
				$author$project$Route$updateRouteData,
				route,
				{iI: qry});
		};
		var query_ = $author$project$Route$queryFromRoute(route);
		return A2(
			$elm$core$Tuple$pair,
			model,
			A3(
				$elm$core$Basics$composeR,
				routeToGo,
				$author$project$Route$goTo(navKey),
				function (pageToGo) {
					return A3($author$project$Route$appendToQuery, 'page', pageToGo, query_);
				}(
					A2($elm$core$Basics$composeR, pageAction, $elm$core$String$fromInt)(currentPage))));
	});
var $author$project$Csf$NodePager$update = F2(
	function (mssg, model) {
		var stringToInt = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toInt,
			$elm$core$Maybe$withDefault(0));
		var isValidInt = A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toInt,
				$elm$core$Maybe$map(
					function (_v7) {
						return true;
					})),
			$elm$core$Maybe$withDefault(false));
		switch (mssg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return A2(
					$author$project$Csf$NodePager$processPagerMdel,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$sub(1),
						$elm$core$Basics$abs),
					model);
			case 2:
				return A2(
					$author$project$Csf$NodePager$processPagerMdel,
					$elm$core$Basics$add(1),
					model);
			case 3:
				var pageIdx = mssg.a;
				return A2(
					$author$project$Csf$NodePager$processPagerMdel,
					$elm$core$Basics$mul(1),
					model);
			case 4:
				var field_ = mssg.a;
				if (!field_) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bb: model.af}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bc: model.eB}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var field_ = mssg.a;
				if (field_ === 1) {
					return _Utils_Tuple2(
						model,
						$author$project$Csf$NodePager$focuseOnValue('_perPage'));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$Csf$NodePager$focuseOnValue('_actualPage'));
				}
			case 6:
				var field_ = mssg.a;
				var data_ = mssg.b;
				var parseCondition = function (condition_) {
					return $author$project$Csf$NodePager$trimmedEmpty(data_) || (isValidInt(data_) && condition_);
				};
				if (!field_) {
					return A3(
						$elm$core$Basics$composeR,
						$elm$core$Basics$ge(model.lp),
						parseCondition,
						stringToInt(data_)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bb: stringToInt(data_)
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					if (parseCondition(true)) {
						var _v4 = _Utils_cmp(
							model.bs,
							stringToInt(data_)) < 0;
						if (_v4) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bc: model.bs}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										bc: stringToInt(data_)
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			default:
				var field_ = mssg.a;
				var code_ = mssg.b;
				if (13 !== code_) {
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				} else {
					if (!field_) {
						return function (model_) {
							return _Utils_Tuple2(
								model_,
								A2(
									$author$project$Csf$Core$timeout,
									0,
									$author$project$Csf$NodePager$GoToPage(model_.af)));
						}(
							_Utils_update(
								model,
								{
									af: A2($elm$core$Basics$max, 1, model.bb)
								}));
					} else {
						var routeToGo = function (qry) {
							return A2(
								$author$project$Route$updateRouteData,
								model.bC,
								{iI: qry});
						};
						var actualPerPage_ = A2($elm$core$Basics$max, 1, model.bc);
						var pages_ = A2($author$project$Csf$NodePager$totalPages_, actualPerPage_, model.bs);
						var sizeToGo = $elm$core$String$fromInt(actualPerPage_);
						var _v6 = (_Utils_cmp(pages_, model.af) < 0) ? A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bb: pages_, af: pages_}),
							A3(
								$author$project$Route$appendToQuery,
								'page',
								$elm$core$String$fromInt(pages_),
								$author$project$Route$queryFromRoute(model.bC))) : A2(
							$elm$core$Tuple$pair,
							model,
							$author$project$Route$queryFromRoute(model.bC));
						var mdel = _v6.a;
						var query_ = _v6.b;
						return A2(
							$elm$core$Tuple$pair,
							mdel,
							A3(
								$elm$core$Basics$composeR,
								routeToGo,
								$author$project$Route$goTo(mdel.gL),
								A3($author$project$Route$appendToQuery, 'pageSize', sizeToGo, query_)));
					}
				}
		}
	});
var $author$project$Customized$CustomDropdown$updateDataListSet = F2(
	function (dataListSet_, model) {
		return _Utils_update(
			model,
			{
				ec: A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
					dataListSet_)
			});
	});
var $author$project$Csf$NodePager$updateNodePager = F2(
	function (totalElements, model) {
		var itemsPerPage = model.eB;
		var currentPage = model.af;
		var zeroElements = !totalElements;
		var query_ = $author$project$Route$queryFromRoute(model.bC);
		var pages_ = A2($author$project$Csf$NodePager$totalPages_, itemsPerPage, totalElements);
		var handlePageSize = function (qry) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$ge(0),
				$elm$core$Basics$or(zeroElements),
				itemsPerPage) ? A2($author$project$Route$removeFromQuery, 'pageSize', qry) : qry;
		};
		var handlePage = function (qry) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$ge(0),
				$elm$core$Basics$or(zeroElements),
				currentPage) ? A2($author$project$Route$removeFromQuery, 'page', qry) : ((_Utils_cmp(currentPage, pages_) > 0) ? function (page_) {
				return A3($author$project$Route$appendToQuery, 'page', page_, qry);
			}(
				$elm$core$String$fromInt(pages_)) : qry);
		};
		var correctQuery = A2($elm$core$Basics$composeR, handlePage, handlePageSize)(query_);
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{bs: totalElements, gR: true, lp: pages_}),
			(!_Utils_eq(query_, correctQuery)) ? A2(
				$author$project$Route$goTo,
				model.gL,
				A2(
					$author$project$Route$updateRouteData,
					model.bC,
					{iI: correctQuery})) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$ConsultarStock$update = F2(
	function (mssg_, model) {
		var session = model.g$;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		_v0$33:
		while (true) {
			switch (mssg_.$) {
				case 0:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 1:
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bZ: true}),
						A3(
							$elm$core$Basics$composeR,
							$author$project$Page$ConsultarStock$ParseDatesToISO,
							$author$project$Helpers$Utilities$delay(0),
							A3(
								$elm$core$Basics$composeR,
								$elm$json$Json$Encode$object,
								$elm$json$Json$Encode$encode(0),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'from_action',
										$elm$json$Json$Encode$string('export_xls'))
									]))));
				case 2:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$goTo,
							session.gL,
							$author$project$Route$ConsultarStock(
								{iI: model.kX})));
				case 3:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$goTo,
							session.gL,
							$author$project$Route$CargarStock($author$project$Route$emptyData)));
				case 4:
					return function (action_) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bw: true}),
							action_);
					}(
						A2(
							$elm$core$Task$attempt,
							$author$project$Page$ConsultarStock$NullifyDone,
							A3($author$project$Helpers$ApiHandler$anularVehiculo, ticket_, model.cm.a, model.cm.b)));
				case 5:
					var stringJson = mssg_.a;
					var query_ = function (queryDatesMap) {
						return A2($elm$core$Dict$map, queryDatesMap, model.kX);
					}(
						F2(
							function (key_, value_) {
								switch (key_) {
									case 'cargafini':
										return A2(
											$elm$core$Maybe$withDefault,
											value_,
											A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 0, 0, value_));
									case 'cargaffin':
										return A2(
											$elm$core$Maybe$withDefault,
											value_,
											A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 23, 59, value_));
									default:
										return value_;
								}
							}));
					var fromStringJson_ = F3(
						function (key_, default_, decodes_) {
							return function (decoder_) {
								return A3($author$project$Helpers$Utilities$decodeString_, default_, decoder_, stringJson);
							}(
								A2($elm$json$Json$Decode$field, key_, decodes_));
						});
					var stringFromJson = F2(
						function (key_, default_) {
							return A3(fromStringJson_, key_, default_, $elm$json$Json$Decode$string);
						});
					var andThenFromStock = function (search_) {
						return A2(
							$elm$core$Task$map,
							$elm$core$Tuple$pair(search_),
							A3(
								$author$project$Helpers$ApiHandler$buscarAgregaciones,
								ticket_,
								'vehicle',
								_List_fromArray(
									['tipo', 'ano', 'marca', 'estado_chie'])));
					};
					return function (cmdAction) {
						return _Utils_Tuple2(model, cmdAction);
					}(
						function () {
							var _v1 = A2(stringFromJson, 'from_action', '');
							if (_v1 === 'export_xls') {
								return A2(
									$elm$core$Task$attempt,
									$author$project$Page$ConsultarStock$ExportXLSDone,
									A3(
										$author$project$Helpers$ApiHandler$exportarVehiculos,
										ticket_,
										$author$project$Csf$Flags$tenantId(session.ka),
										$author$project$Page$ConsultarStock$filtersFromQuery(query_)));
							} else {
								return A3(
									$elm$core$Basics$composeR,
									$elm$core$Task$andThen(andThenFromStock),
									$elm$core$Task$attempt($author$project$Page$ConsultarStock$StockLoaded),
									A5(
										$author$project$Helpers$ApiHandler$buscarNodes,
										ticket_,
										_Utils_Tuple2(
											A2(stringFromJson, 'from_', '0'),
											A2(stringFromJson, 'size_', '10')),
										_Utils_Tuple2(
											$author$project$Csf$Flags$tenantId(session.ka),
											'ficha_tecnica_vehicular'),
										A2(stringFromJson, 'sort_by', 'inserted_at:desc'),
										_List_fromArray(
											[
												$author$project$Page$ConsultarStock$filtersFromQuery(query_)
											])));
							}
						}());
				case 6:
					var stringJson = mssg_.a;
					var posix_ = mssg_.b;
					var parseDatesToISO_ = A2(
						$author$project$Helpers$Utilities$delay,
						0,
						$author$project$Page$ConsultarStock$ParseDatesToISO(stringJson));
					var offset_ = A2($justinmimbs$time_extra$Time$Extra$toOffset, model.lG, posix_);
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{dE: offset_}),
						parseDatesToISO_);
				case 7:
					var mbeString = mssg_.a;
					var zone_ = mssg_.b;
					var actionMap_ = function (cmd_) {
						return A2(
							$elm$core$Maybe$withDefault,
							cmd_,
							function (stringMap_) {
								return A2($elm$core$Maybe$map, stringMap_, mbeString);
							}(
								function (string_) {
									return A2(
										$elm$core$Task$perform,
										$author$project$Page$ConsultarStock$GotNowPosix(string_),
										$elm$time$Time$now);
								}));
					};
					return A2(
						$elm$core$Tuple$mapSecond,
						actionMap_,
						A2($author$project$Csf$Core$onTimeZone, zone_, model));
				case 8:
					var query_ = mssg_.a;
					return (!_Utils_eq(query_, model.kX)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						model,
						A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$ConsultarStock$ReloadModule));
				case 9:
					var dashlet_ = mssg_.a;
					var action_ = function (dateTuple) {
						return A2(
							$author$project$Helpers$Utilities$todaysDateRange,
							dateTuple,
							$author$project$Page$ConsultarStock$DateOnQuery('update_query'));
					};
					return function (cmdAction_) {
						return _Utils_Tuple2(model, cmdAction_);
					}(
						function () {
							switch (dashlet_) {
								case 'dashlet_carga':
									return action_(
										_Utils_Tuple2('cargafini', 'cargaffin'));
								case 'dashlet_chie':
									return action_(
										_Utils_Tuple2('emisionfini', 'emisionffin'));
								default:
									return $elm$core$Platform$Cmd$none;
							}
						}());
				case 10:
					var dashlet_ = mssg_.a;
					var action_ = function (dateTuple) {
						return A3(
							$author$project$Helpers$Utilities$lastNDaysRange,
							dateTuple,
							-7,
							$author$project$Page$ConsultarStock$DateOnQuery('update_query'));
					};
					return function (cmdAction_) {
						return _Utils_Tuple2(model, cmdAction_);
					}(
						function () {
							switch (dashlet_) {
								case 'dashlet_carga':
									return action_(
										_Utils_Tuple2('cargafini', 'cargaffin'));
								case 'dashlet_chie':
									return action_(
										_Utils_Tuple2('emisionfini', 'emisionffin'));
								default:
									return $elm$core$Platform$Cmd$none;
							}
						}());
				case 11:
					var dashlet_ = mssg_.a;
					var action_ = function (dateTuple) {
						return A3(
							$author$project$Helpers$Utilities$lastNDaysRange,
							dateTuple,
							-30,
							$author$project$Page$ConsultarStock$DateOnQuery('update_query'));
					};
					return function (cmdAction_) {
						return _Utils_Tuple2(model, cmdAction_);
					}(
						function () {
							switch (dashlet_) {
								case 'dashlet_carga':
									return action_(
										_Utils_Tuple2('cargafini', 'cargaffin'));
								case 'dashlet_chie':
									return action_(
										_Utils_Tuple2('emisionfini', 'emisionffin'));
								default:
									return $elm$core$Platform$Cmd$none;
							}
						}());
				case 12:
					var field_ = mssg_.a;
					var data_ = mssg_.b;
					var queryDta = $author$project$Helpers$Utilities$trimmedEmpty(data_) ? function (key_) {
						return A2($elm$core$Dict$remove, key_, model.kX);
					}(
						$author$project$Page$ConsultarStock$keyQueryFromField(field_)) : A3(
						$author$project$Route$appendToQuery,
						$author$project$Page$ConsultarStock$keyQueryFromField(field_),
						$elm$core$String$trim(data_),
						model.kX);
					var field_key = $author$project$Page$ConsultarStock$stringFromField(field_);
					var updField = A3(
						$elm$core$Dict$insert,
						'value_',
						$elm$json$Json$Encode$string(data_),
						A2($author$project$Helpers$Utilities$embeddedDict, field_key, model.cf));
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{
								cf: A3($elm$core$Dict$insert, field_key, updField, model.cf),
								kX: queryDta
							}),
						A2(
							$author$project$Helpers$Utilities$delay,
							1.5,
							$author$project$Page$ConsultarStock$FilterOnDelay(queryDta)));
				case 13:
					var dashlet_ = mssg_.a;
					return function (action_) {
						return A3($author$project$Helpers$Utilities$dashletToggle, dashlet_, action_, model);
					}(
						A2(
							$author$project$Helpers$Utilities$delay,
							0.5,
							$author$project$Page$ConsultarStock$TransitioningOFF(dashlet_)));
				case 14:
					var dashlet_ = mssg_.a;
					return A2($author$project$Helpers$Utilities$transitioningOff, dashlet_, model);
				case 15:
					var pickerMsg = mssg_.a;
					return function (_v7) {
						var model_ = _v7.a;
						var action_ = _v7.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$ConsultarStock$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('cargafini', model_.b0)
										]))));
					}(
						function (_v6) {
							var date_ = _v6.a;
							var picker_ = _v6.b;
							var action_ = _v6.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cI: picker_, b0: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b0, model.cI),
								$author$project$Helpers$Utilities$pickerSettings_('cargafini'),
								pickerMsg)));
				case 16:
					var pickerMsg = mssg_.a;
					return function (_v9) {
						var model_ = _v9.a;
						var action_ = _v9.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$ConsultarStock$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('cargaffin', model_.b$)
										]))));
					}(
						function (_v8) {
							var date_ = _v8.a;
							var picker_ = _v8.b;
							var action_ = _v8.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cH: picker_, b$: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b$, model.cH),
								$author$project$Helpers$Utilities$pickerSettings_('cargaffin'),
								pickerMsg)));
				case 17:
					var pickerMsg = mssg_.a;
					return function (_v11) {
						var model_ = _v11.a;
						var action_ = _v11.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$ConsultarStock$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('emisionfini', model_.b2)
										]))));
					}(
						function (_v10) {
							var date_ = _v10.a;
							var picker_ = _v10.b;
							var action_ = _v10.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cK: picker_, b2: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b2, model.cK),
								$author$project$Helpers$Utilities$pickerSettings_('emisionfini'),
								pickerMsg)));
				case 18:
					var pickerMsg = mssg_.a;
					return function (_v13) {
						var model_ = _v13.a;
						var action_ = _v13.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$ConsultarStock$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('emisionffin', model_.b1)
										]))));
					}(
						function (_v12) {
							var date_ = _v12.a;
							var picker_ = _v12.b;
							var action_ = _v12.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cJ: picker_, b1: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b1, model.cJ),
								$author$project$Helpers$Utilities$pickerSettings_('emisionffin'),
								pickerMsg)));
				case 19:
					var action_ = mssg_.a;
					var datesData = mssg_.b;
					return A2(
						$elm$core$Tuple$pair,
						model,
						A5(
							$author$project$Helpers$ApiHandler$dateOnQueryMsg,
							action_,
							datesData,
							session.gL,
							model.kX,
							$author$project$Route$ConsultarStock($author$project$Route$emptyData)));
				case 20:
					var tuple_ = mssg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cB: $author$project$Csf$Modal$shown, cm: tuple_}),
						$elm$core$Platform$Cmd$none);
				case 21:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cB: $author$project$Csf$Modal$hidden,
								cm: _Utils_Tuple2('', '')
							}),
						$elm$core$Platform$Cmd$none);
				case 22:
					if (!mssg_.a.$) {
						var strJson = mssg_.a.a;
						return function (actions_) {
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(actions_));
						}(
							_List_fromArray(
								[
									A2($author$project$Helpers$Utilities$delay, 2.5, $author$project$Page$ConsultarStock$ReloadModule),
									A2($author$project$Page$ConsultarStock$doNotify, 'success', 'nullify_ok')
								]));
					} else {
						var error = mssg_.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'nullify_failed');
						return function (_v14) {
							var model_ = _v14.a;
							var cmdAction = _v14.b;
							return _Utils_Tuple2(
								_Utils_update(
									model_,
									{bw: false}),
								cmdAction);
						}(
							('redirect_' === handled_) ? _Utils_Tuple2(
								model,
								$author$project$Helpers$ApiHandler$toUserHome(session)) : _Utils_Tuple2(
								_Utils_update(
									model,
									{
										de: $author$project$Page$ConsultarStock$moduleMessage(handled_)
									}),
								$elm$core$Platform$Cmd$none));
					}
				case 23:
					if (!mssg_.a.$) {
						var dataBytes = mssg_.a.a;
						var filename_ = $author$project$Page$ConsultarStock$moduleMessage('export_filename');
						return function (cmdActions_) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bZ: false}),
								$elm$core$Platform$Cmd$batch(cmdActions_));
						}(
							_List_fromArray(
								[
									A2($author$project$Page$ConsultarStock$doNotify, 'success', 'export_ok'),
									A3(
									$elm$file$File$Download$bytes,
									filename_,
									$author$project$Helpers$Utilities$mimeFromExtension('xlsx'),
									dataBytes)
								]));
					} else {
						var error = mssg_.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'export_failed');
						return function (cmdAction) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bZ: false}),
								cmdAction);
						}(
							('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$ConsultarStock$doNotify, 'error', handled_));
					}
				case 24:
					if (!mssg_.a.$) {
						var _v15 = mssg_.a.a;
						var searchResp = _v15.a;
						var aggregations = _v15.b;
						var decodeAggregations_ = F2(
							function (field_, actionMap) {
								return A2(
									$elm$core$List$map,
									function (agg) {
										return _Utils_Tuple2(
											agg,
											actionMap(agg));
									},
									A3($author$project$Helpers$Utilities$decodeAggregations, field_, $elm$json$Json$Decode$string, aggregations));
							});
						var estadosAggs = A2(decodeAggregations_, 'estado_chie', $author$project$Helpers$Utilities$estadoDelChie);
						var marcaAggs = A2(decodeAggregations_, 'marca', $elm$core$Basics$identity);
						var tipoAggs = A2(decodeAggregations_, 'tipo', $elm$core$Basics$identity);
						var annoAggs = $elm$core$List$sort(
							A2(
								$elm$core$List$map,
								function (agg) {
									return _Utils_Tuple2(
										$elm$core$String$fromInt(agg),
										$elm$core$String$fromInt(agg));
								},
								A3($author$project$Helpers$Utilities$decodeAggregations, 'ano', $elm$json$Json$Decode$int, aggregations)));
						var _v16 = A2($author$project$Csf$NodePager$updateNodePager, searchResp.lo, model.aF);
						var ndePager = _v16.a;
						var pagerCmd = _v16.b;
						return function (model_) {
							return _Utils_Tuple2(
								model_,
								A2($elm$core$Platform$Cmd$map, $author$project$Page$ConsultarStock$NodePagerMsg, pagerCmd));
						}(
							_Utils_update(
								model,
								{
									aN: A2($author$project$Customized$CustomDropdown$updateDataListSet, annoAggs, model.aN),
									aS: A2($author$project$Customized$CustomDropdown$updateDataListSet, estadosAggs, model.aS),
									eH: searchResp,
									aZ: A2($author$project$Customized$CustomDropdown$updateDataListSet, marcaAggs, model.aZ),
									aF: ndePager,
									dw: false,
									jb: $author$project$Csf$Table$init(
										{r: searchResp.kh, w: model.jb.w}),
									a5: A2($author$project$Customized$CustomDropdown$updateDataListSet, tipoAggs, model.a5)
								}));
					} else {
						var error = mssg_.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'stock_load_failed');
						var cmdAction = ('redirect_' === handled_) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$ConsultarStock$doNotify, 'error', handled_);
						return function (model_) {
							return _Utils_Tuple2(model_, cmdAction);
						}(
							_Utils_update(
								model,
								{
									aF: function (pager_) {
										return _Utils_update(
											pager_,
											{gR: true});
									}(model.aF),
									dw: true
								}));
					}
				case 26:
					var pagerMsg = mssg_.a;
					return function (_v17) {
						var pager_ = _v17.a;
						var pagerCmd = _v17.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aF: pager_}),
							pagerCmd);
					}(
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$NodePagerMsg),
							A2($author$project$Csf$NodePager$update, pagerMsg, model.aF)));
				case 27:
					var fbadgesMsg = mssg_.a;
					return function (_v18) {
						var filterBadges_ = _v18.a;
						var fbadgesCmd = _v18.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{b8: filterBadges_}),
							fbadgesCmd);
					}(
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$FilterBadgesMsg),
							A2($author$project$Csf$FilterBadges$update, fbadgesMsg, model.b8)));
				case 25:
					var field_ = mssg_.a;
					var dropdownMsg = mssg_.b;
					switch (field_) {
						case 4:
							return A2($author$project$Page$ConsultarStock$handleTipoDropdown, dropdownMsg, model);
						case 3:
							return A2($author$project$Page$ConsultarStock$handleAnnoDropdown, dropdownMsg, model);
						case 6:
							return A2($author$project$Page$ConsultarStock$handleMarcaDropdown, dropdownMsg, model);
						case 8:
							return A2($author$project$Page$ConsultarStock$handleEstadoDropdown, dropdownMsg, model);
						case 11:
							return A2($author$project$Page$ConsultarStock$handleEstadoVhDropdown, dropdownMsg, model);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 28:
					switch (mssg_.a.$) {
						case 3:
							if (mssg_.a.a === 'anular_vehiculo') {
								var _v20 = mssg_.a;
								var taskNode_ = _v20.b;
								return A2($author$project$Page$ConsultarStock$handleNullify, taskNode_, model);
							} else {
								break _v0$33;
							}
						case 2:
							var state_ = mssg_.a.a;
							return A4(
								$author$project$Helpers$ApiHandler$handleTableSort,
								state_,
								model,
								$author$project$Page$ConsultarStock$allowedToSortBy,
								$author$project$Route$ConsultarStock($author$project$Route$emptyData));
						default:
							break _v0$33;
					}
				default:
					var notifyMsg = mssg_.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (_v21) {
							var toasties = _v21.a7;
							return _Utils_update(
								model,
								{
									g$: _Utils_update(
										session,
										{a7: toasties})
								});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$NotificationsMsg),
							A2(
								$author$project$Csf$Notifications$update,
								notifyMsg,
								{a7: session.a7})));
			}
		}
		var tableMsg = mssg_.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (table_) {
				return _Utils_update(
					model,
					{jb: table_});
			},
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Page$ConsultarStock$TableMsg),
				A2($author$project$Csf$Table$update, tableMsg, model.jb)));
	});
var $author$project$Page$DashboardChie$FecthDataForDraw = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$DashboardChie$GotNowPosix = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$DashboardChie$OnDateChanged = {$: 1};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Page$DashboardChie$drawGoogleCharts = _Platform_outgoingPort('drawGoogleCharts', $elm$core$Basics$identity);
var $author$project$Page$DashboardChie$fechaFinSettings = $author$project$Helpers$Utilities$pickerSettings_('fechaFin');
var $author$project$Page$DashboardChie$fechaIniSettings = $author$project$Helpers$Utilities$pickerSettings_('fechaIni');
var $author$project$Page$DashboardChie$GotDataForDraw = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$DashboardChie$fecthDataForDraw = F2(
	function (model, taskAction_) {
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{bT: true, ca: ''}),
			A2($elm$core$Task$attempt, $author$project$Page$DashboardChie$GotDataForDraw, taskAction_));
	});
var $author$project$Config$ApiEndpoint$reportechieemitidos = F5(
	function (tenant_, field_, finicio, ffin, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-report-service', 'report-service', tenant_, 'aggregation', 'field', field_, 'from', finicio, 'to', ffin]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$obtenerEmitidos = F5(
	function (ticket_, tenant_, emitidos_por_, finicio, ffin) {
		var decoderMap_ = F2(
			function (key_, count_) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							A2($elm$core$Tuple$pair, 'item', key_),
							A2($elm$core$Tuple$pair, 'emitidos', count_)
						]));
			});
		var decoder_ = A3(
			$elm$json$Json$Decode$map2,
			decoderMap_,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$value),
			A2($elm$json$Json$Decode$field, 'doc_count', $elm$json$Json$Decode$value));
		return A2(
			$elm$core$Task$map,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Helpers$Utilities$decodeAggregations_, 'data', decoder_),
				$elm$json$Json$Encode$list($elm$core$Basics$identity)),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A5($author$project$Config$ApiEndpoint$reportechieemitidos, tenant_, emitidos_por_, finicio, ffin, ticket_),
				_List_Nil));
	});
var $author$project$Config$ApiEndpoint$chiehistograma = F6(
	function (tenant_, field_, interval_, finicio, ffin, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-report-service', 'report-service', tenant_, 'histogram', 'field', field_, 'interval', interval_, 'from', finicio, 'to', ffin]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$obtenerHistograma = F6(
	function (ticket_, tenant_, intervalo_, by_field, finicio, ffin) {
		var decoderMap_ = F2(
			function (count_, date_) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							A2($elm$core$Tuple$pair, 'fecha', date_),
							A2($elm$core$Tuple$pair, 'emitidos', count_)
						]));
			});
		var dateFormat_ = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Encode$string),
			A2($author$project$Csf$DateFormat$formatIsoDate, 'DD/MM/YYYY', $elm$time$Time$utc));
		var dateDcoder_ = A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, dateFormat_, $elm$json$Json$Decode$succeed),
			$elm$json$Json$Decode$string);
		var decoder_ = A3(
			$elm$json$Json$Decode$map2,
			decoderMap_,
			A2($elm$json$Json$Decode$field, 'doc_count', $elm$json$Json$Decode$value),
			A2($elm$json$Json$Decode$field, 'key_as_string', dateDcoder_));
		return A2(
			$elm$core$Task$map,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Helpers$Utilities$decodeAggregations_, 'histogram', decoder_),
				$elm$json$Json$Encode$list($elm$core$Basics$identity)),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A6($author$project$Config$ApiEndpoint$chiehistograma, tenant_, by_field, intervalo_, finicio, ffin, ticket_),
				_List_Nil));
	});
var $author$project$Page$DashboardChie$toChartID = A2($elm$core$String$replace, 'tab_', 'chart_');
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Page$DashboardChie$update = F2(
	function (mssg_, model) {
		var session = model.g$;
		var activeTab = model.aL;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var tenant_ = $author$project$Csf$Flags$tenantId(session.ka);
		var fechaIni_ = A2(
			$elm$core$Maybe$withDefault,
			$justinmimbs$date$Date$toIsoString(model.a8),
			A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.aU));
		var fechaFin_ = A2(
			$elm$core$Maybe$withDefault,
			$justinmimbs$date$Date$toIsoString(model.a8),
			A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.aT));
		_v0$11:
		while (true) {
			switch (mssg_.$) {
				case 1:
					var _v1 = _Utils_Tuple2(model.aU, model.aT);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var fIni = _v1.a.a;
						var fFin = _v1.b.a;
						if (2 !== A2($justinmimbs$date$Date$compare, fIni, fFin)) {
							var _v2 = A2($justinmimbs$date$Date$compare, fFin, model.a8);
							if (_v2 === 2) {
								return A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{an: 'future_range'}),
									$elm$core$Platform$Cmd$none);
							} else {
								return A2(
									$elm$core$Tuple$pair,
									model,
									A2(
										$author$project$Helpers$Utilities$delay,
										0,
										$author$project$Page$DashboardChie$FecthDataForDraw(activeTab)));
							}
						} else {
							return A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{an: 'invalid_range'}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var zone_ = mssg_.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						function (_v3) {
							return A2($elm$core$Task$perform, $author$project$Page$DashboardChie$GotNowPosix, $elm$time$Time$now);
						},
						A2($author$project$Csf$Core$onTimeZone, zone_, model));
				case 3:
					var posix_ = mssg_.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{
								aT: $elm$core$Maybe$Just(
									A2($justinmimbs$date$Date$fromPosix, model.lG, posix_)),
								aU: $elm$core$Maybe$Just(
									A3(
										$justinmimbs$date$Date$add,
										1,
										-1,
										A2($justinmimbs$date$Date$fromPosix, model.lG, posix_))),
								gN: A2($justinmimbs$time_extra$Time$Extra$toOffset, model.lG, posix_),
								a8: A2($justinmimbs$date$Date$fromPosix, model.lG, posix_)
							}),
						A2(
							$author$project$Helpers$Utilities$delay,
							0,
							$author$project$Page$DashboardChie$FecthDataForDraw(activeTab)));
				case 4:
					var pickerMsg = mssg_.a;
					var _v4 = A3(
						$author$project$Helpers$Utilities$handlePickerMsg,
						_Utils_Tuple2(model.aU, model.cO),
						$author$project$Page$DashboardChie$fechaIniSettings,
						pickerMsg);
					var mbeDate = _v4.a;
					var picker_ = _v4.b;
					var action_ = _v4.c;
					var model_ = _Utils_update(
						model,
						{cO: picker_, an: '', aU: mbeDate});
					return A2(
						$elm$core$Tuple$pair,
						model_,
						('update_query' !== action_) ? $elm$core$Platform$Cmd$none : A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$DashboardChie$OnDateChanged));
				case 5:
					var pickerMsg = mssg_.a;
					var _v5 = A3(
						$author$project$Helpers$Utilities$handlePickerMsg,
						_Utils_Tuple2(model.aT, model.cN),
						$author$project$Page$DashboardChie$fechaFinSettings,
						pickerMsg);
					var mbeDate = _v5.a;
					var picker_ = _v5.b;
					var action_ = _v5.c;
					var model_ = _Utils_update(
						model,
						{cN: picker_, an: '', aT: mbeDate});
					return A2(
						$elm$core$Tuple$pair,
						model_,
						('update_query' !== action_) ? $elm$core$Platform$Cmd$none : A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$DashboardChie$OnDateChanged));
				case 6:
					var tabKey_ = mssg_.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{aL: tabKey_, an: ''}),
						A2($elm$core$Task$perform, $author$project$Page$DashboardChie$GotNowPosix, $elm$time$Time$now));
				case 7:
					switch (mssg_.a) {
						case 'tab_histogram':
							return A2(
								$author$project$Page$DashboardChie$fecthDataForDraw,
								model,
								A6($author$project$Helpers$ApiHandler$obtenerHistograma, ticket_, tenant_, 'day', 'inserted_at', fechaIni_, fechaFin_));
						case 'tab_regions':
							return A2(
								$author$project$Page$DashboardChie$fecthDataForDraw,
								model,
								A3(
									$elm$core$Basics$composeR,
									$elm$core$Task$succeed,
									$author$project$Helpers$Utilities$delayTask(1.5),
									A2(
										$elm$json$Json$Encode$list,
										$elm$json$Json$Encode$string,
										_List_fromArray(
											['regions chart']))));
						case 'tab_dealers':
							return A2(
								$author$project$Page$DashboardChie$fecthDataForDraw,
								model,
								A5($author$project$Helpers$ApiHandler$obtenerEmitidos, ticket_, tenant_, 'distribuidor', fechaIni_, fechaFin_));
						default:
							break _v0$11;
					}
				case 8:
					if (!mssg_.a.$) {
						var dataValue_ = mssg_.a.a;
						var model_ = _Utils_update(
							model,
							{bT: false});
						var dcodedDtaValue_ = A3(
							$author$project$Helpers$Utilities$decodeValue_,
							_List_Nil,
							$elm$json$Json$Decode$list($elm$json$Json$Decode$value),
							dataValue_);
						return $elm$core$List$isEmpty(dcodedDtaValue_) ? A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model_,
								{ca: 'emptydata_response'}),
							$elm$core$Platform$Cmd$none) : A2(
							$elm$core$Tuple$pair,
							model_,
							A3(
								$elm$core$Basics$composeR,
								$elm$json$Json$Encode$object,
								$author$project$Page$DashboardChie$drawGoogleCharts,
								_List_fromArray(
									[
										A2($elm$core$Tuple$pair, 'data', dataValue_),
										A2(
										$elm$core$Tuple$pair,
										'chart',
										$elm$json$Json$Encode$string(
											$author$project$Page$DashboardChie$toChartID(activeTab)))
									])));
					} else {
						var error_ = mssg_.a.a;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bT: false, ca: 'gotdrawdata_failed'}),
							$elm$core$Platform$Cmd$none);
					}
				default:
					break _v0$11;
			}
		}
		return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$HistorialDeCargas$ErrorInfoModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$HistorialDeCargas$NodePagerMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$HistorialDeCargas$NotificationsMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$HistorialDeCargas$NullifyDone = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$HistorialDeCargas$ReloadModule = {$: 1};
var $author$project$Page$HistorialDeCargas$ShowModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$HistorialDeCargas$TableMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Helpers$ApiHandler$anularCargaDeStock = F3(
	function (ticket_, tenant_, unique_id) {
		return function (deleteEndpoint_) {
			return A2($author$project$Helpers$ApiHandler$delete, deleteEndpoint_, _List_Nil);
		}(
			A4($author$project$Config$ApiEndpoint$anularenstock, tenant_, 'lote', unique_id, ticket_));
	});
var $author$project$Csf$TaskNodeUtils$mbdatavalue = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Dict$get(key),
			$author$project$TaskNode$dataOrEmptyDict),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$datavalue = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbdatavalue(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $author$project$Page$HistorialDeCargas$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('head_loaded', 'Historial de Cargas de Vehículos al Stock'),
		_Utils_Tuple2('card_title_loaded', 'Cargas'),
		_Utils_Tuple2('download_ok', 'Se ha exportado el excel exitosamente.'),
		_Utils_Tuple2('download_failed', 'Ha ocurrido un error en la descarga de la nómina.'),
		_Utils_Tuple2('history_empty', 'No existen Cargas de Vehículos al Stock'),
		_Utils_Tuple2('history_failed', 'No ha sido posible listar las Cargas de Vehículos al Stock'),
		_Utils_Tuple2('history_load_failed', 'Lo sentimos, ha ocurrido un error al consultar el historial de cargas de vehículos al stock.'),
		_Utils_Tuple2('confirm_nullify', 'Confirme que desea anular la carga seleccionada.'),
		_Utils_Tuple2('nomina_inprocess', 'La carga seleccionada no se encuentra lista aún, estamos validando los datos.'),
		_Utils_Tuple2('nomina_failed', 'Ha ocurrido un error procesando la carga. Por favor contacte a los administradores de sistema.'),
		_Utils_Tuple2('nullify_ok', 'Se ha anulado la nómina exitosamente.'),
		_Utils_Tuple2('nullify_failed', 'Lo sentimos, no ha sido posible anular la nómina. Póngase en contacto con nuestro equipo de soporte.'),
		_Utils_Tuple2('nullify_forbidden', 'Lo sentimos, no posee los privilegios necesarios para anular la carga.'),
		_Utils_Tuple2('nullify_already', 'No es posible anular la carga porque ha sido anulada previamente.'),
		_Utils_Tuple2('nullify_beyond_approval', 'No es posible anular la carga proque se encuentra finalizada.'),
		_Utils_Tuple2('nullify_before_approval', 'No es posible anular la carga porque no ha sido aprobada previamente.'),
		_Utils_Tuple2('nullify_vh_requested', 'No es posible anular la carga porque existen vehículos con chie solicitados o emitidos.')
	]);
var $author$project$Page$HistorialDeCargas$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Page$HistorialDeCargas$moduleCaptions_));
};
var $author$project$Page$HistorialDeCargas$doNotify = F2(
	function (type_, key_) {
		return A3(
			$author$project$Helpers$Utilities$setNotification,
			$author$project$Page$HistorialDeCargas$NotificationsMsg,
			type_,
			$author$project$Page$HistorialDeCargas$moduleMessage(key_));
	});
var $author$project$Page$HistorialDeCargas$NodeDownloaded = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Config$ApiEndpoint$nodedownload_ = F3(
	function (unique_id, tenant_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'download', 'tenant', tenant_, 'node', unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$descargarNodeFile = F3(
	function (ticket_, tenant_, unique_id) {
		return $elm$http$Http$task(
			{
				h: $elm$http$Http$emptyBody,
				i: _List_Nil,
				j: 'GET',
				k: $author$project$Csf$Call$bytesResolver,
				m: $elm$core$Maybe$Nothing,
				q: A3($author$project$Config$ApiEndpoint$nodedownload_, unique_id, tenant_, ticket_)
			});
	});
var $author$project$Page$HistorialDeCargas$handleDownload = F2(
	function (tNde, model) {
		var session = model.g$;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var name_ = A3($author$project$Csf$TaskNodeUtils$string, '', 'name', tNde);
		var idLote_ = A3($author$project$Csf$TaskNodeUtils$string, '', 'id_lote', tNde);
		var filename_ = A3(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append(
				_List_fromArray(
					[idLote_])),
			$elm$core$String$join('.'),
			function (nameLst) {
				return A2(
					$elm$core$List$drop,
					$elm$core$List$length(nameLst) - 1,
					nameLst);
			}(
				A2($elm$core$String$split, '.', name_)));
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none),
			$elm$core$Tuple$pair(model),
			function (mapTenant) {
				return A2(
					$elm$core$Maybe$map,
					mapTenant,
					A2($author$project$Csf$TaskNodeUtils$mbstring, 'tenant', tNde));
			}(
				function (tenant_) {
					return A2(
						$elm$core$Task$attempt,
						$author$project$Page$HistorialDeCargas$NodeDownloaded(filename_),
						A3($author$project$Helpers$ApiHandler$descargarNodeFile, ticket_, tenant_, tNde.p));
				}));
	});
var $author$project$Page$HistorialDeCargas$NullifyModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$HistorialDeCargas$handleNullify = F2(
	function (tNde, model) {
		var session = model.g$;
		return A2(
			$elm$core$Tuple$pair,
			model,
			A2(
				$author$project$Helpers$ApiHandler$hasUserAccess,
				$author$project$Csf$Flags$userNode(session.ka),
				_List_fromArray(
					['ADMINISTRATOR'])) ? A3(
				$elm$core$Basics$composeR,
				$author$project$Page$HistorialDeCargas$ShowModal,
				$author$project$Helpers$Utilities$delay(0),
				$author$project$Page$HistorialDeCargas$NullifyModal(
					_Utils_Tuple2(
						A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', tNde),
						tNde.p))) : A2($author$project$Page$HistorialDeCargas$doNotify, 'error', 'nullify_forbidden'));
	});
var $author$project$TaskNode$put = F3(
	function (key, value, node) {
		return _Utils_update(
			node,
			{
				dm: A3($elm$core$Dict$insert, key, value, node.dm)
			});
	});
var $author$project$Helpers$ApiHandler$triggsUpInfoChannel = function (ticket_) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$json$Json$Encode$object,
		$author$project$Ports$callUpInformationSSE,
		_List_fromArray(
			[
				A2(
				$elm$core$Tuple$pair,
				'path',
				A2($elm$core$Basics$composeR, $author$project$Config$ApiEndpoint$chiessechannel, $elm$json$Json$Encode$string)(ticket_))
			]));
};
var $author$project$Page$HistorialDeCargas$update = F2(
	function (msg, model) {
		var session = model.g$;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		_v0$18:
		while (true) {
			switch (msg.$) {
				case 1:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$goTo,
							session.gL,
							$author$project$Route$HistorialDeCargas(
								{iI: model.kX})));
				case 2:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$goTo,
							session.gL,
							$author$project$Route$ConsultarStock($author$project$Route$emptyData)));
				case 3:
					return function (action_) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bw: true}),
							action_);
					}(
						A2(
							$elm$core$Task$attempt,
							$author$project$Page$HistorialDeCargas$NullifyDone,
							A3($author$project$Helpers$ApiHandler$anularCargaDeStock, ticket_, model.cm.a, model.cm.b)));
				case 4:
					var zone_ = msg.a;
					return A2($author$project$Csf$Core$onTimeZone, zone_, model);
				case 5:
					var modalType_ = msg.a;
					if (modalType_.$ === 1) {
						var tupleData_ = modalType_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cB: $author$project$Csf$Modal$shown, cm: tupleData_}),
							$elm$core$Platform$Cmd$none);
					} else {
						var message_ = modalType_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cQ: $author$project$Csf$Modal$shown, cR: message_}),
							$elm$core$Platform$Cmd$none);
					}
				case 6:
					var modalType_ = msg.a;
					if (modalType_.$ === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cB: $author$project$Csf$Modal$hidden,
									cm: _Utils_Tuple2('', '')
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cQ: $author$project$Csf$Modal$hidden, cR: ''}),
							$elm$core$Platform$Cmd$none);
					}
				case 7:
					var event_ = msg.a;
					var eventNode = A3($author$project$Helpers$Utilities$decodeValue_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode, event_);
					var notEventOwner = !_Utils_eq(
						$author$project$Csf$Flags$username(session.ka),
						A3($author$project$Csf$TaskNodeUtils$string, '', 'owner', eventNode));
					var notFromLoteLoad_ = 'ORDER_UPDATE' !== A3($author$project$Csf$TaskNodeUtils$string, '', 'event_type', eventNode);
					var putIntoNode_ = F3(
						function (key_, default_, tNde) {
							return function (dataValue_) {
								return A3($author$project$TaskNode$put, key_, dataValue_, tNde);
							}(
								A3($author$project$Csf$TaskNodeUtils$datavalue, default_, key_, eventNode));
						});
					var stringFromData_ = function (key_) {
						return A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, eventNode);
					};
					var updatedHits_ = function (tNdeMap_) {
						return A2($elm$core$List$map, tNdeMap_, model.bq.kh);
					}(
						function (tNde) {
							return _Utils_eq(
								tNde.p,
								stringFromData_('lote')) ? A3(
								putIntoNode_,
								'fecha_ultima_emision_chie',
								$elm$json$Json$Encode$string(''),
								A3(
									putIntoNode_,
									'vehiculos_anulados',
									$elm$json$Json$Encode$int(0),
									A3(
										putIntoNode_,
										'chie_solicitados',
										$elm$json$Json$Encode$int(0),
										A3(
											putIntoNode_,
											'chie_anulados',
											$elm$json$Json$Encode$int(0),
											A3(
												putIntoNode_,
												'chie_emitidos',
												$elm$json$Json$Encode$int(0),
												tNde))))) : tNde;
						});
					var closed_onerror = A3($author$project$Csf$TaskNodeUtils$bool, false, 'closed_onerror', eventNode);
					if (closed_onerror) {
						return A2(
							$elm$core$Tuple$pair,
							model,
							$author$project$Helpers$ApiHandler$triggsUpInfoChannel(ticket_));
					} else {
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							notFromLoteLoad_ ? model : _Utils_update(
								model,
								{
									bq: function (loaded_) {
										return _Utils_update(
											loaded_,
											{kh: updatedHits_});
									}(model.bq),
									jb: $author$project$Csf$Table$init(
										{r: updatedHits_, w: model.jb.w})
								}));
					}
				case 8:
					if (!msg.a.$) {
						var strJson = msg.a.a;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bw: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Helpers$Utilities$delay, 2.5, $author$project$Page$HistorialDeCargas$ReloadModule),
										A2($author$project$Page$HistorialDeCargas$doNotify, 'success', 'nullify_ok')
									])));
					} else {
						var error = msg.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'nullify_failed');
						return A2(
							$elm$core$Tuple$mapFirst,
							function (model_) {
								return _Utils_update(
									model_,
									{bw: false});
							},
							('redirect_' === handled_) ? A2(
								$elm$core$Tuple$pair,
								model,
								$author$project$Helpers$ApiHandler$toUserHome(session)) : A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{
										de: $author$project$Page$HistorialDeCargas$moduleMessage(handled_)
									}),
								$elm$core$Platform$Cmd$none));
					}
				case 9:
					if (!msg.a.$) {
						var searchResp = msg.a.a;
						var _v4 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$HistorialDeCargas$NodePagerMsg),
							A2($author$project$Csf$NodePager$updateNodePager, searchResp.lo, model.aF));
						var ndePager = _v4.a;
						var pagerCmd = _v4.b;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{
									cZ: false,
									bq: searchResp,
									aF: ndePager,
									jb: $author$project$Csf$Table$init(
										{r: searchResp.kh, w: model.jb.w})
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										pagerCmd,
										$author$project$Helpers$ApiHandler$triggsUpInfoChannel(ticket_)
									])));
					} else {
						var error = msg.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'history_load_failed');
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{cZ: true}),
							('redirect_' === handled_) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$HistorialDeCargas$doNotify, 'error', handled_));
					}
				case 10:
					if (!msg.b.$) {
						var filename_ = msg.a;
						var dataBytes = msg.b.a;
						var mimeType_ = A3(
							$elm$core$Basics$composeR,
							$elm$core$String$join(''),
							$author$project$Helpers$Utilities$mimeFromExtension,
							A3(
								$elm$core$Basics$composeR,
								$elm$core$List$reverse,
								$elm$core$List$take(1),
								A2($elm$core$String$split, '.', filename_)));
						return A2(
							$elm$core$Basics$composeR,
							$elm$core$Platform$Cmd$batch,
							$elm$core$Tuple$pair(model))(
							_List_fromArray(
								[
									A2($author$project$Page$HistorialDeCargas$doNotify, 'success', 'download_ok'),
									A3($elm$file$File$Download$bytes, filename_, mimeType_, dataBytes)
								]));
					} else {
						var error = msg.b.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'download_failed');
						return A2(
							$elm$core$Tuple$pair,
							model,
							('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$HistorialDeCargas$doNotify, 'error', handled_));
					}
				case 11:
					var pagerMsg = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (pager_) {
							return _Utils_update(
								model,
								{aF: pager_});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$HistorialDeCargas$NodePagerMsg),
							A2($author$project$Csf$NodePager$update, pagerMsg, model.aF)));
				case 12:
					switch (msg.a.$) {
						case 3:
							switch (msg.a.a) {
								case 'show_infoModal':
									var _v5 = msg.a;
									var taskNode_ = _v5.b;
									return A2(
										$elm$core$Tuple$pair,
										model,
										A3(
											$elm$core$Basics$composeR,
											$author$project$Page$HistorialDeCargas$ShowModal,
											$author$project$Helpers$Utilities$delay(0),
											('RECHAZADO' === A3($author$project$Csf$TaskNodeUtils$string, '', 'estado_lote', taskNode_)) ? $author$project$Page$HistorialDeCargas$ErrorInfoModal(
												$author$project$Page$HistorialDeCargas$moduleMessage('nomina_failed')) : $author$project$Page$HistorialDeCargas$ErrorInfoModal(
												$author$project$Page$HistorialDeCargas$moduleMessage('nomina_inprocess'))));
								case 'anular_carga':
									var _v6 = msg.a;
									var taskNode_ = _v6.b;
									return A2($author$project$Page$HistorialDeCargas$handleNullify, taskNode_, model);
								case 'download_carga':
									var _v7 = msg.a;
									var taskNode_ = _v7.b;
									return A2($author$project$Page$HistorialDeCargas$handleDownload, taskNode_, model);
								default:
									break _v0$18;
							}
						case 2:
							var state_ = msg.a.a;
							return A4(
								$author$project$Helpers$ApiHandler$handleTableSort,
								state_,
								model,
								$author$project$Page$HistorialDeCargas$allowedToSortBy,
								$author$project$Route$HistorialDeCargas($author$project$Route$emptyData));
						default:
							break _v0$18;
					}
				case 13:
					var notifyMsg = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (_v8) {
							var toasties = _v8.a7;
							return _Utils_update(
								model,
								{
									g$: _Utils_update(
										session,
										{a7: toasties})
								});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$HistorialDeCargas$NotificationsMsg),
							A2(
								$author$project$Csf$Notifications$update,
								notifyMsg,
								{a7: session.a7})));
				default:
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
			}
		}
		var tableMsg = msg.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (table_) {
				return _Utils_update(
					model,
					{jb: table_});
			},
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Page$HistorialDeCargas$TableMsg),
				A2($author$project$Csf$Table$update, tableMsg, model.jb)));
	});
var $author$project$Page$RepositorioChie$CodeVerified = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$RepositorioChie$GotNowPosix = function (a) {
	return {$: 2, a: a};
};
var $author$project$Csf$Form$Required = {$: 5};
var $author$project$Csf$Form$ValidValue = {$: 2};
var $author$project$Csf$Form$strIsValid = function (_v0) {
	var validationResult = _v0.aJ;
	return _Utils_eq(validationResult, $author$project$Csf$Form$ValidValue) || _Utils_eq(validationResult, $author$project$Csf$Form$NotFocusedValue);
};
var $author$project$Csf$Form$strVal = function (_v0) {
	var value = _v0.lt;
	return value;
};
var $korutx$elm_rut$Rut$Cleared = 2;
var $author$project$Csf$Form$InvalidValue = function (a) {
	return {$: 0, a: a};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Csf$Form$emailRegExpStr = '^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$';
var $korutx$elm_rut$Rut$justStr = function (maybeStr) {
	if (maybeStr.$ === 1) {
		return '';
	} else {
		var str = maybeStr.a;
		return str;
	}
};
var $korutx$elm_rut$Rut$replace = F3(
	function (regexStr, replacer, str) {
		var _v0 = $elm$regex$Regex$fromString(regexStr);
		if (_v0.$ === 1) {
			return str;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, str);
		}
	});
var $korutx$elm_rut$Rut$clearFormat = function (str) {
	return A3(
		$korutx$elm_rut$Rut$replace,
		'[\\.\\-]',
		function (_v0) {
			return '';
		},
		str);
};
var $korutx$elm_rut$Rut$splitRutAndDv = function (str) {
	var clearedStr = $korutx$elm_rut$Rut$clearFormat(str);
	var _v0 = $elm$core$String$length(clearedStr);
	switch (_v0) {
		case 0:
			return {aB: $elm$core$Maybe$Nothing, ai: $elm$core$Maybe$Nothing};
		case 1:
			return {
				aB: $elm$core$Maybe$Nothing,
				ai: $elm$core$Maybe$Just(clearedStr)
			};
		default:
			return {
				aB: $elm$core$Maybe$Just(
					A2($elm$core$String$right, 1, clearedStr)),
				ai: $elm$core$Maybe$Just(
					A3($elm$core$String$slice, 0, -1, clearedStr))
			};
	}
};
var $korutx$elm_rut$Rut$thousandsFormatter = F2(
	function (_char, text) {
		return (($elm$core$String$length(text) > 0) && (!A2(
			$elm$core$Basics$modBy,
			3,
			$elm$core$String$length(
				$korutx$elm_rut$Rut$clearFormat(text))))) ? ($elm$core$String$fromChar(_char) + ('.' + text)) : _Utils_ap(
			$elm$core$String$fromChar(_char),
			text);
	});
var $korutx$elm_rut$Rut$thousandsFormat = A2($elm$core$String$foldr, $korutx$elm_rut$Rut$thousandsFormatter, '');
var $korutx$elm_rut$Rut$format = F2(
	function (formatter, value) {
		var rutdv = $korutx$elm_rut$Rut$splitRutAndDv(value);
		if (_Utils_eq(rutdv.ai, $elm$core$Maybe$Nothing)) {
			return $elm$core$Maybe$Just(value);
		} else {
			if ((!_Utils_eq(rutdv.ai, $elm$core$Maybe$Nothing)) && _Utils_eq(rutdv.aB, $elm$core$Maybe$Nothing)) {
				return rutdv.ai;
			} else {
				switch (formatter) {
					case 0:
						return $elm$core$Maybe$Just(
							$korutx$elm_rut$Rut$thousandsFormat(
								$korutx$elm_rut$Rut$justStr(rutdv.ai)) + ('-' + $korutx$elm_rut$Rut$justStr(rutdv.aB)));
					case 1:
						return $elm$core$Maybe$Just(
							$korutx$elm_rut$Rut$justStr(rutdv.ai) + ('-' + $korutx$elm_rut$Rut$justStr(rutdv.aB)));
					default:
						return $elm$core$Maybe$Just(
							_Utils_ap(
								$korutx$elm_rut$Rut$justStr(rutdv.ai),
								$korutx$elm_rut$Rut$justStr(rutdv.aB)));
				}
			}
		}
	});
var $korutx$elm_rut$Rut$computeDv = function (rut) {
	var _v0 = A3(
		$elm$core$List$foldr,
		F2(
			function (d, _v1) {
				var suma = _v1.a;
				var mul = _v1.b;
				var num = $elm$core$Char$toCode(d) - 48;
				var mul1 = A2($elm$core$Basics$modBy, 8, mul + 1);
				var mul2 = (mul1 > 0) ? mul1 : 2;
				return _Utils_Tuple2(suma + (num * mul), mul2);
			}),
		_Utils_Tuple2(0, 2),
		$elm$core$String$toList(rut));
	var s = _v0.a;
	var m = _v0.b;
	var _v2 = A2($elm$core$Basics$modBy, 11, s);
	switch (_v2) {
		case 1:
			return 'k';
		case 0:
			return '0';
		default:
			return $elm$core$String$fromInt(
				11 - A2($elm$core$Basics$modBy, 11, s));
	}
};
var $korutx$elm_rut$Rut$isValidRut = F2(
	function (minimumLength, rut) {
		var crut = $korutx$elm_rut$Rut$clearFormat(rut);
		if (_Utils_cmp(
			$elm$core$String$length(crut),
			minimumLength) < 0) {
			return false;
		} else {
			var rutdv = $korutx$elm_rut$Rut$splitRutAndDv(rut);
			return _Utils_eq(
				$elm$core$String$toLower(
					$korutx$elm_rut$Rut$computeDv(
						$korutx$elm_rut$Rut$justStr(rutdv.ai))),
				$elm$core$String$toLower(
					$korutx$elm_rut$Rut$justStr(rutdv.aB)));
		}
	});
var $author$project$Csf$Form$regExp = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $author$project$Csf$Form$strValidator = F2(
	function (validations_, aVal_) {
		var vr = A3(
			$elm$core$List$foldl,
			F2(
				function (val, acc) {
					var _v0 = _Utils_Tuple2(val, aVal_);
					_v0$13:
					while (true) {
						switch (_v0.a.$) {
							case 0:
								if (_v0.b === '') {
									var _v1 = _v0.a;
									return acc;
								} else {
									var _v2 = _v0.a;
									var val_ = _v0.b;
									return (!A2(
										$elm$regex$Regex$contains,
										$author$project$Csf$Form$regExp('^\\w+$'),
										val_)) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue('Solo se admiten letras dígitos y el caracter _'),
										acc) : acc;
								}
							case 1:
								if (_v0.b === '') {
									var _v3 = _v0.a;
									return acc;
								} else {
									var _v4 = _v0.a;
									var expression_ = _v4.a;
									var errMsg = _v4.b;
									var val_ = _v0.b;
									return (!A2(
										$elm$regex$Regex$contains,
										$author$project$Csf$Form$regExp(expression_),
										val_)) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue(errMsg),
										acc) : acc;
								}
							case 2:
								if (_v0.b === '') {
									var _v5 = _v0.a;
									return acc;
								} else {
									var _v6 = _v0.a;
									var fn = _v6.a;
									var errMsg = _v6.b;
									var val_ = _v0.b;
									return A2(
										$elm$core$List$member,
										val_,
										fn(val_)) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue(errMsg),
										acc) : acc;
								}
							case 8:
								if (_v0.b === '') {
									var _v7 = _v0.a;
									return acc;
								} else {
									var _v8 = _v0.a;
									var val_ = _v0.b;
									return (!A2(
										$elm$regex$Regex$contains,
										$author$project$Csf$Form$regExp($author$project$Csf$Form$emailRegExpStr),
										val_)) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue('El formato de email no es válido'),
										acc) : acc;
								}
							case 4:
								if (_v0.b === '') {
									return acc;
								} else {
									var _int = _v0.a.a;
									var val_ = _v0.b;
									return (_Utils_cmp(
										$elm$core$String$length(val_),
										_int) < 0) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue(
											'Se requien al menos ' + ($elm$core$String$fromInt(_int) + ' caracteres')),
										acc) : acc;
								}
							case 5:
								var _v9 = _v0.a;
								var val_ = _v0.b;
								return A2(
									$elm$regex$Regex$contains,
									$author$project$Csf$Form$regExp('(^$)|(^\\s+$)'),
									val_) ? A2(
									$elm$core$List$cons,
									$author$project$Csf$Form$InvalidValue('Campo requerido'),
									acc) : acc;
							case 6:
								if (_v0.b === '') {
									return acc;
								} else {
									var _int = _v0.a.a;
									var val_ = _v0.b;
									return (!A2($korutx$elm_rut$Rut$isValidRut, _int, val_)) ? A2(
										$elm$core$List$cons,
										$author$project$Csf$Form$InvalidValue(
											'Solo se admiten rut válidos con al menos ' + ($elm$core$String$fromInt(_int) + ' dígitos')),
										acc) : acc;
								}
							case 7:
								if (!_v0.a.a) {
									if (_v0.b === '') {
										break _v0$13;
									} else {
										var _v10 = _v0.a.a;
										var val_ = _v0.b;
										var isValid = A2(
											$elm$core$Maybe$map,
											$elm$core$Basics$le(5.0e7 - 1),
											A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Maybe$Nothing,
												A2(
													$elm$core$Maybe$map,
													$elm$core$String$toFloat,
													A2(
														$elm$core$Maybe$map,
														A2($elm$core$String$slice, 0, -1),
														A2($korutx$elm_rut$Rut$format, 2, val_)))));
										return _Utils_eq(
											isValid,
											$elm$core$Maybe$Just(true)) ? acc : A2(
											$elm$core$List$cons,
											$author$project$Csf$Form$InvalidValue('El rut empresa no es válido'),
											acc);
									}
								} else {
									if (_v0.b === '') {
										break _v0$13;
									} else {
										var _v11 = _v0.a.a;
										var val_ = _v0.b;
										var isValid = A2(
											$elm$core$Maybe$map,
											$elm$core$Basics$ge(5.0e7),
											A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Maybe$Nothing,
												A2(
													$elm$core$Maybe$map,
													$elm$core$String$toFloat,
													A2(
														$elm$core$Maybe$map,
														A2($elm$core$String$slice, 0, -1),
														A2($korutx$elm_rut$Rut$format, 2, val_)))));
										return _Utils_eq(
											isValid,
											$elm$core$Maybe$Just(true)) ? acc : A2(
											$elm$core$List$cons,
											$author$project$Csf$Form$InvalidValue('El rut persona no es válido'),
											acc);
									}
								}
							default:
								return acc;
						}
					}
					return acc;
				}),
			_List_Nil,
			validations_);
		return {
			aJ: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Csf$Form$ValidValue,
				$elm$core$List$head(vr)),
			lt: aVal_
		};
	});
var $author$project$Page$RepositorioChie$updateSessionAsset = F3(
	function (key_, data_, session) {
		var flags = session.ka;
		return _Utils_update(
			session,
			{
				ka: _Utils_update(
					flags,
					{
						f$: A3($elm$core$Dict$insert, key_, data_, flags.f$)
					})
			});
	});
var $author$project$Page$RepositorioChie$update = F2(
	function (mssg_, model) {
		var session = model.g$;
		switch (mssg_.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var zone_ = mssg_.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (_v1) {
						return A2($elm$core$Task$perform, $author$project$Page$RepositorioChie$GotNowPosix, $elm$time$Time$now);
					},
					A2($author$project$Csf$Core$onTimeZone, zone_, model));
			case 2:
				var posix_ = mssg_.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{
							gN: A2($justinmimbs$time_extra$Time$Extra$toOffset, model.lG, posix_)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return function (code_) {
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{aA: code_}),
						$elm$core$Platform$Cmd$none);
				}(
					A2(
						$author$project$Csf$Form$strValidator,
						_List_fromArray(
							[$author$project$Csf$Form$Required]),
						A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(model.aA)));
			case 4:
				var codeField_ = A3(
					$elm$core$Basics$composeR,
					$elm$core$String$trim,
					$author$project$Csf$Form$strValidator(
						_List_fromArray(
							[$author$project$Csf$Form$Required])),
					$author$project$Csf$Form$strVal(model.aA));
				return (!$author$project$Csf$Form$strIsValid(codeField_)) ? A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{aA: codeField_}),
					$elm$core$Platform$Cmd$none) : A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{cp: true}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$RepositorioChie$CodeVerified,
						$author$project$Page$RepositorioChie$verifyDocument(
							$author$project$Csf$Form$strVal(codeField_))));
			case 5:
				var code_ = mssg_.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{
							aA: A2(
								$author$project$Csf$Form$strValidator,
								_List_fromArray(
									[$author$project$Csf$Form$Required]),
								code_),
							bW: ''
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				if (!mssg_.a.$) {
					var string_ = mssg_.a.a;
					var session_ = A3($author$project$Page$RepositorioChie$updateSessionAsset, 'repo_document', string_, session);
					var navKey = session_.gL;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{g$: session_}),
						A2(
							$author$project$Route$goTo,
							navKey,
							$author$project$Route$RepositorioChie(
								$author$project$Csf$Form$strVal(model.aA))));
				} else {
					var error = mssg_.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'El código es inválido o el documento no existe.');
					return function (model_) {
						return _Utils_Tuple2(
							_Utils_update(
								model_,
								{cp: false}),
							$elm$core$Platform$Cmd$none);
					}(
						('redirect_' === handled_) ? _Utils_update(
							model,
							{bW: 'No tiene acceso al servicio de verificación.'}) : _Utils_update(
							model,
							{
								bW: $author$project$Helpers$Utilities$appMessage(handled_)
							}));
				}
			default:
				if (!mssg_.a.$) {
					var taskNode_ = mssg_.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bh: true, bU: taskNode_}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = mssg_.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bh: true}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Csf$Form$AllowedExpression = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$ChangeActualStep = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$SolicitarChie$DateTimePickerChanged = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Customized$InputDropdown$DropdownOpened = {$: 1};
var $author$project$Csf$Form$Email = {$: 8};
var $author$project$Page$SolicitarChie$ErrorInfoModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$GotImporters = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$SolicitarChie$HandleVinData = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$SolicitarChie$ImportersOnDelay = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$SolicitarChie$InscriptionUpdated = function (a) {
	return {$: 24, a: a};
};
var $author$project$Customized$InputDropdown$ItemClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$SolicitarChie$MetadataLoadDone = {$: 3};
var $author$project$Page$SolicitarChie$NoOp = {$: 0};
var $author$project$Page$SolicitarChie$NodeDownloaded = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$NotificationsMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$SolicitarChie$OnSolicitudUpdated = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$OpenDateTimePicker = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Customized$CustomDropdown$PickedOption = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$SolicitarChie$ShowModal = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$SolicitarChie$SolicitudDone = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$SolicitarChie$UploaderMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Page$SolicitarChie$VinsFounded = function (a) {
	return {$: 27, a: a};
};
var $author$project$Config$ApiEndpoint$nodeupdate = F3(
	function (tenant_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'tenant', tenant_, 'node', unique_id, 'update']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Helpers$ApiHandler$actualizarNode = F4(
	function (ticket_, tenant_, unique_id, jsonBody) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
			A3(
				$author$project$Helpers$ApiHandler$post,
				A3($author$project$Config$ApiEndpoint$nodeupdate, tenant_, unique_id, ticket_),
				_List_Nil,
				A2(
					$elm$http$Http$stringBody,
					'application/x-www-form-urlencoded',
					A2($elm$json$Json$Encode$encode, 0, jsonBody))));
	});
var $author$project$Helpers$Utilities$allowedChars = '^[0-9a-zA-ZñÑáÁéÉíÍóÓúÚ,.;:\\-_{}*\\[\\]?¿\'!¡@·#$%&\\(\\)=\\s]+$';
var $author$project$Helpers$Utilities$allowedRutFormat = '(^(\\d{7,8}-)([kK]{1}$|\\d{1}$))|(^((\\d{1,2})\\.\\d{3}\\.\\d{3}-)([kK]{1}$|\\d{1}$))';
var $author$project$Config$ApiEndpoint$chieimporters = F3(
	function (ticket_, vin_, brand_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-request-service', 'request-service', 'importers']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'brand', brand_),
					A2($elm$url$Url$Builder$string, 'vin', vin_),
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$buscarImportadores = F3(
	function (ticket_, vin_, brand_) {
		var decoderMap_ = F2(
			function (tNde, available) {
				return A3($author$project$TaskNode$put, 'stock_available', available, tNde);
			});
		var taskNdeDcoder_ = A3(
			$elm$json$Json$Decode$map2,
			decoderMap_,
			A2($elm$json$Json$Decode$field, 'tenant', $author$project$Csf$AlbertoApi$decoderTaskNode),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['stock', 'available']),
				$elm$json$Json$Decode$value));
		var stringDcoder_ = $elm$json$Json$Decode$list(taskNdeDcoder_);
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, _List_Nil, stringDcoder_),
			A2(
				$author$project$Helpers$ApiHandler$get,
				A3($author$project$Config$ApiEndpoint$chieimporters, ticket_, vin_, brand_),
				_List_Nil));
	});
var $author$project$Helpers$Utilities$correctTipoVehiculo_ = function (tipoVehiculo_) {
	var _v0 = $author$project$Helpers$Utilities$trimmedToUpper(tipoVehiculo_);
	if (_v0 === 'MOTO') {
		return 'MOTOCICLETA';
	} else {
		var tvehiculo = _v0;
		return tvehiculo;
	}
};
var $author$project$Config$AppVehiculos$couldBeMoto = function (tipoVehiculo_) {
	return function (couldBe) {
		return A2(
			$elm$core$Tuple$pair,
			couldBe,
			couldBe ? '3' : '4');
	}(
		A2($elm$core$List$member, tipoVehiculo_, $author$project$Config$AppVehiculos$vehiculosMoto));
};
var $author$project$Helpers$Utilities$customRegex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $author$project$Helpers$Utilities$regexContains = function (regex_) {
	return $elm$regex$Regex$contains(
		$author$project$Helpers$Utilities$customRegex(regex_));
};
var $author$project$Helpers$Utilities$correctVehiclePPU_ = F2(
	function (tipoVehiculo_, stringPPU_) {
		var lettersCount_ = $author$project$Config$AppVehiculos$couldBeMoto(tipoVehiculo_).b;
		var lettersMatch_ = A2($elm$core$String$replace, 'char_match', '[A-Z]{' + (lettersCount_ + '}'));
		var count_ = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(lettersCount_));
		var handleCorrection_ = _List_fromArray(
			[
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match\\-)(\\d{2}$))'),
				stringPPU_),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match\\.0)(\\d{2}$))'),
				A3($elm$core$String$replace, '.0', '-', stringPPU_)),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match\\.)(\\d{2}\\-)([kK]{1}$|\\d{1}$))'),
				A3(
					$elm$core$String$replace,
					'.',
					'-',
					A3(
						$elm$core$Basics$composeR,
						$elm$core$List$take(1),
						$elm$core$String$join(''),
						A2($elm$core$String$split, '-', stringPPU_)))),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match\\.)(\\d{2}$))'),
				A3($elm$core$String$replace, '.', '-', stringPPU_)),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match\\.0)(\\d{2}\\-)([kK]{1}$|\\d{1}$))'),
				A3(
					$elm$core$String$replace,
					'.0',
					'-',
					A3(
						$elm$core$Basics$composeR,
						$elm$core$List$take(1),
						$elm$core$String$join(''),
						A2($elm$core$String$split, '-', stringPPU_)))),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match0)(\\d{2}\\-)([kK]{1}$|\\d{1}$))'),
				A3(
					$elm$core$String$replace,
					'0',
					'-',
					A3(
						$elm$core$Basics$composeR,
						$elm$core$List$take(1),
						$elm$core$String$join(''),
						A2($elm$core$String$split, '-', stringPPU_)))),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match0)(\\d{2}$))'),
				_Utils_ap(
					A2($elm$core$String$left, count_, stringPPU_) + '-',
					A2($elm$core$String$dropLeft, count_ + 1, stringPPU_))),
				A2(
				$elm$core$Tuple$pair,
				lettersMatch_('(^(char_match)(\\d{2}$))'),
				_Utils_ap(
					A2($elm$core$String$left, count_, stringPPU_) + '-',
					A2($elm$core$String$dropLeft, count_, stringPPU_)))
			]);
		var correctionMap_ = function (_v0) {
			var regex_ = _v0.a;
			var correctedPPU_ = _v0.b;
			return A2($author$project$Helpers$Utilities$regexContains, regex_, stringPPU_) ? $elm$core$Maybe$Just(correctedPPU_) : $elm$core$Maybe$Nothing;
		};
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$withDefault(''),
			A2($elm$core$List$filterMap, correctionMap_, handleCorrection_));
	});
var $author$project$Page$SolicitarChie$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('upload_ok', 'El documento se ha subido exitosamente.'),
		_Utils_Tuple2('upload_fail', 'Lo sentimos, ha ocurrido un error en la subida del documento.'),
		_Utils_Tuple2('vinsearch_failed', 'Lo sentimos, ha ocurrido un error en la consulta al Stock.'),
		_Utils_Tuple2('download_ok', 'Se ha descargado el documento de Primera Inscripción exitosamente.'),
		_Utils_Tuple2('download_failed', 'Ha ocurrido un error en la descarga del documento de Primera Inscripción.'),
		_Utils_Tuple2('vehicle_notfound', 'No se han podido obtener los datos del vehículo en la consulta al stock. Compruebe el VIN.'),
		_Utils_Tuple2('vehicle_nullyfied', 'El vehículo se encuentra ANULADO en el Stock. Compruebe el VIN.'),
		_Utils_Tuple2('empty_cit', 'No ha sido posible obtener todos los datos. Queda pendiente de aprobación la solicitud.'),
		_Utils_Tuple2('data_incomplete', 'No se han podido extraer todos los datos del Certificado'),
		_Utils_Tuple2('inscription_empty', 'No se obtuvo información de la Primera Inscripción'),
		_Utils_Tuple2('inscription_fail', 'Ha ocurrido un error obteniendo los datos de la Primera Inscripción.'),
		_Utils_Tuple2('metadata_fail', 'Ha ocurrido un error extrayendo metadatos de la Primera Inscripción.'),
		_Utils_Tuple2('solicitud_fail', 'Lo sentimos, ha ocurrido un error al procesar la solicitud.'),
		_Utils_Tuple2('solicitud_ok_heading', '¡Se ha creado exitosamente la solicitud!'),
		_Utils_Tuple2('solicitud_ok_revision', 'El Revisor de la Importadora deberá aprobar la solicitud.'),
		_Utils_Tuple2('inscription_update_ok', 'Se han actualizando los datos de la inscripción satisfactoriamente.'),
		_Utils_Tuple2('inscription_update_fail', 'Ha ocurrido un error actualizando los datos de la inscripción.'),
		_Utils_Tuple2('invalid_importer', 'Marca no representada por ningún importador.'),
		_Utils_Tuple2('INVALID_VIN_LENGTH', 'Longitud del VIN incorrecta. Debe tener 17 caracteres.'),
		_Utils_Tuple2('INVALID_VEHICLE_TYPE', 'Tipo de Vehículo no reconocido.'),
		_Utils_Tuple2('solicitud_duplicada', 'Solicitud duplicada. Ya existe una solicitud de emisión de CHI-e para este vehículo.')
	]);
var $author$project$Page$SolicitarChie$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Page$SolicitarChie$moduleCaptions_));
};
var $author$project$Page$SolicitarChie$doNotify = F2(
	function (type_, key_) {
		return A3(
			$author$project$Helpers$Utilities$setNotification,
			$author$project$Page$SolicitarChie$NotificationsMsg,
			type_,
			$author$project$Page$SolicitarChie$moduleMessage(key_));
	});
var $author$project$Page$SolicitarChie$getFormField = F3(
	function (key_, default_, formDict) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Csf$Form$strFieldModel(default_),
			A2($elm$core$Dict$get, key_, formDict));
	});
var $author$project$Page$SolicitarChie$formFieldValue = F3(
	function (key_, default_, formDict) {
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Csf$Form$strVal,
			$elm$core$String$trim,
			A3($author$project$Page$SolicitarChie$getFormField, key_, default_, formDict));
	});
var $author$project$Page$SolicitarChie$handleDealerDropdown = F2(
	function (dropdownMsg, _v0) {
		var model = _v0.a;
		var dropdownCmd = _v0.b;
		var solicitudForm_ = function (fieldData_) {
			return function (strField) {
				return A3($elm$core$Dict$insert, 'solicitud_dealer', strField, model.l);
			}(
				A2(
					$author$project$Csf$Form$strValidator,
					_List_fromArray(
						[$author$project$Csf$Form$Required]),
					fieldData_));
		};
		var cmdAction_ = A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Page$SolicitarChie$InputDropdownMsg(1),
			dropdownCmd);
		return function (model_) {
			return A2($elm$core$Tuple$pair, model_, cmdAction_);
		}(
			function () {
				if (dropdownMsg.$ === 3) {
					var dealer_ = dropdownMsg.a;
					return _Utils_update(
						model,
						{
							l: solicitudForm_(dealer_)
						});
				} else {
					return model;
				}
			}());
	});
var $author$project$Helpers$Utilities$handleDropdownMssg = F5(
	function (key_, toMssg, dropdownMssg, onPickedAction_, mdel) {
		var moduleDropdowns = mdel.eP;
		var finalTupleMap_ = function (_v1) {
			var mdel_ = _v1.a;
			var cmdAction_ = _v1.b;
			if (!dropdownMssg.$) {
				var mbString = dropdownMssg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd_) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd_, cmdAction_]));
					},
					A2(onPickedAction_, mbString, mdel_));
			} else {
				return A2($elm$core$Tuple$pair, mdel_, cmdAction_);
			}
		};
		return finalTupleMap_(
			A2(
				$elm$core$Tuple$mapFirst,
				function (dropdown_) {
					return A3($author$project$Helpers$Utilities$updateDropdown, key_, dropdown_, mdel);
				},
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(toMssg),
					A2(
						$author$project$Customized$CustomDropdown$update,
						dropdownMssg,
						A2($author$project$Helpers$Utilities$getDropdown, key_, mdel)))));
	});
var $author$project$Page$SolicitarChie$handleNotifications = F2(
	function (model, _v0) {
		var session = model.g$;
		var certificado = model.X;
		var toasties = _v0.a.a7;
		var notifyCmd_ = _v0.b;
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{
					g$: _Utils_update(
						session,
						{a7: toasties})
				}),
			notifyCmd_);
	});
var $author$project$Page$SolicitarChie$FileUploaded = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$SolicitarChie$WrongFileUploaded = {$: 7};
var $author$project$Helpers$ApiHandler$importarCertificado = F3(
	function (ticket_, tenant_, file_) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
			A3(
				$author$project$Helpers$ApiHandler$post,
				A3($author$project$Config$ApiEndpoint$nodecreate, tenant_, 'solicitud_primera_inscripcion', ticket_),
				_List_Nil,
				$elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file_)
						]))));
	});
var $author$project$Page$SolicitarChie$handleUploader = F2(
	function (uploaderMsg, _v0) {
		var model = _v0.a;
		var session = model.g$;
		var cmdAction = _v0.b;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var tenant_ = $author$project$Csf$Flags$tenantId(session.ka);
		var hasAllowedExtension = function (file_) {
			return function (condition_) {
				return A2(
					$elm$core$List$any,
					condition_,
					_List_fromArray(
						['.pdf']));
			}(
				function (extension_) {
					return A2(
						$elm$core$String$endsWith,
						extension_,
						A2($elm$core$Basics$composeR, $elm$file$File$name, $author$project$Helpers$Utilities$trimmedToLower)(file_));
				});
		};
		if (uploaderMsg.$ === 3) {
			var file = uploaderMsg.a;
			return function (uploadAction) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: true}),
					uploadAction);
			}(
				hasAllowedExtension(file) ? function (importAction_) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmdAction,
								A2($elm$core$Task$attempt, $author$project$Page$SolicitarChie$FileUploaded, importAction_)
							]));
				}(
					A3($author$project$Helpers$ApiHandler$importarCertificado, ticket_, tenant_, file)) : A2($author$project$Helpers$Utilities$delay, 1.8, $author$project$Page$SolicitarChie$WrongFileUploaded));
		} else {
			return _Utils_Tuple2(model, cmdAction);
		}
	});
var $author$project$Page$SolicitarChie$VehicleVinFound = function (a) {
	return {$: 25, a: a};
};
var $author$project$Page$SolicitarChie$handleVinDropdown = F2(
	function (dropdownMsg, _v0) {
		var model = _v0.a;
		var session = model.g$;
		var dropdownCmd = _v0.b;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var solicitudForm_ = function (fieldData_) {
			return function (strField) {
				return A3($elm$core$Dict$insert, 'solicitud_vin', strField, model.l);
			}(
				A2(
					$author$project$Csf$Form$strValidator,
					_List_fromArray(
						[$author$project$Csf$Form$Required]),
					fieldData_));
		};
		if (dropdownMsg.$ === 3) {
			var vinNumber_ = dropdownMsg.a;
			return A2(
				$elm$core$Tuple$pair,
				_Utils_update(
					model,
					{
						u: true,
						l: solicitudForm_(vinNumber_)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$author$project$Helpers$Utilities$delay,
							0,
							$author$project$Page$SolicitarChie$ImportersOnDelay(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(vinNumber_),
									$elm$core$Maybe$Nothing))),
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Page$SolicitarChie$InputDropdownMsg(0),
							dropdownCmd),
							A2(
							$elm$core$Task$attempt,
							$author$project$Page$SolicitarChie$VehicleVinFound,
							A2($author$project$Helpers$ApiHandler$vehiculoByVin, ticket_, vinNumber_))
						])));
		} else {
			return A2(
				$elm$core$Tuple$pair,
				model,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Page$SolicitarChie$InputDropdownMsg(0),
					dropdownCmd));
		}
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$Closed = {$: 0};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$DatePicker = $elm$core$Basics$identity;
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy = {$: 0};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$init = function (internalMsg) {
	return {bi: $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy, h3: $elm$core$Maybe$Nothing, K: internalMsg, S: $elm$core$Maybe$Nothing, ay: $mercurymedia$elm_datetime_picker$SingleDatePicker$Closed, U: 0};
};
var $author$project$Helpers$Utilities$isValidPPU_ = function (ppu_) {
	return A2($author$project$Helpers$Utilities$regexContains, '(^([A-Z]{4}\\-)(\\d{2}$))', ppu_) || A2($author$project$Helpers$Utilities$regexContains, '(^([A-Z]{3}\\-)(\\d{2}$))', ppu_);
};
var $author$project$Helpers$Utilities$isInvalidPPU_ = F2(
	function (tipoVehiculo_, vhPPU) {
		return !($author$project$Helpers$Utilities$trimmedEmpty(tipoVehiculo_) || ($author$project$Helpers$Utilities$trimmedEmpty(vhPPU) || $author$project$Helpers$Utilities$isValidPPU_(
			A2($author$project$Helpers$Utilities$correctVehiclePPU_, tipoVehiculo_, vhPPU))));
	});
var $author$project$Customized$CustomDropdown$isValidDropbox = function (_v0) {
	var dropdownRequired = _v0.cG;
	var pickedOption = _v0.by;
	return dropdownRequired ? A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				return true;
			},
			pickedOption)) : true;
};
var $author$project$Helpers$Utilities$mbeTipoDeVehiculo = function (tipo) {
	return A2(
		$elm$core$Dict$get,
		$author$project$Helpers$Utilities$trimmedToUpper(tipo),
		$elm$core$Dict$fromList($author$project$Helpers$Utilities$tiposDeVehiculo));
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$closePicker = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{ay: $mercurymedia$elm_datetime_picker$SingleDatePicker$Closed});
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$Open = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$OutsideHierarchy = function (a) {
	return {$: 1, a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix = F2(
	function (zone, posix) {
		return _Utils_Tuple2(
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries = F3(
	function (zone, pickerDay, selection) {
		var _v0 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.g1);
		var startHour = _v0.a;
		var startMinute = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectionHour = _v1.a;
		var selectionMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.hM);
		var endHour = _v2.a;
		var endMinute = _v2.b;
		return (_Utils_eq(startHour, selectionHour) && (_Utils_cmp(startMinute, selectionMinute) < 1)) || (((_Utils_cmp(startHour, selectionHour) < 0) && (_Utils_cmp(selectionHour, endHour) < 0)) || (_Utils_eq(selectionHour, endHour) && (_Utils_cmp(selectionMinute, endMinute) < 1)));
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.jz;
		var month = _v0.il;
		var day = _v0.hE;
		var hour = _v0.gr;
		var minute = _v0.gH;
		var second = _v0.g_;
		var millisecond = _v0.gF;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			hE: A2($elm$time$Time$toDay, zone, posix),
			gr: A2($elm$time$Time$toHour, zone, posix),
			gF: A2($elm$time$Time$toMillis, zone, posix),
			gH: A2($elm$time$Time$toMinute, zone, posix),
			il: A2($elm$time$Time$toMonth, zone, posix),
			g_: A2($elm$time$Time$toSecond, zone, posix),
			jz: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay = F5(
	function (zone, hour, minute, second, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{gr: hour, gH: minute, g_: second});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectDay = F3(
	function (zone, previousSelectionTuple, selectedPickerDay) {
		if (selectedPickerDay.jY) {
			return previousSelectionTuple;
		} else {
			if (!previousSelectionTuple.$) {
				var _v1 = previousSelectionTuple.a;
				var previousSelection = _v1.b;
				return A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries, zone, selectedPickerDay, previousSelection) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						selectedPickerDay,
						A5(
							$mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay,
							zone,
							A2($elm$time$Time$toHour, zone, previousSelection),
							A2($elm$time$Time$toMinute, zone, previousSelection),
							0,
							selectedPickerDay.g1))) : $elm$core$Maybe$Just(
					_Utils_Tuple2(selectedPickerDay, selectedPickerDay.g1));
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(selectedPickerDay, selectedPickerDay.g1));
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour = F2(
	function (zone, _v0) {
		var pickerDay = _v0.a;
		var selection = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.g1);
		var startBoundaryHour = _v1.a;
		var startBoundaryMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectedHour = _v2.a;
		var selectedMinute = _v2.b;
		var earliestSelectableMinute = _Utils_eq(startBoundaryHour, selectedHour) ? startBoundaryMinute : 0;
		var _v3 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.hM);
		var endBoundaryHour = _v3.a;
		var endBoundaryMinute = _v3.b;
		var latestSelectableMinute = _Utils_eq(endBoundaryHour, selectedHour) ? endBoundaryMinute : 59;
		return _Utils_Tuple2(earliestSelectableMinute, latestSelectableMinute);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay = F3(
	function (zone, hour, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{gr: hour});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay = F3(
	function (zone, minute, timeToUpdate) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, timeToUpdate);
		var newParts = _Utils_update(
			parts,
			{gH: minute});
		return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, newParts);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$doDaysMatch = F3(
	function (zone, dateTimeOne, dateTimeTwo) {
		var twoParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTimeTwo);
		var oneParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, dateTimeOne);
		return _Utils_eq(oneParts.hE, twoParts.hE) && (_Utils_eq(oneParts.il, twoParts.il) && _Utils_eq(oneParts.jz, twoParts.jz));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault = F3(
	function (zone, _default, _v0) {
		var selectionPickerDay = _v0.a;
		var selection = _v0.b;
		var selectionDayEqualsPickerDay = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$doDaysMatch, zone, selection, selectionPickerDay.g1);
		return (A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$posixWithinPickerDayBoundaries, zone, selectionPickerDay, selection) && ((!selectionPickerDay.jY) && selectionDayEqualsPickerDay)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(selectionPickerDay, selection)) : _default;
	});
var $mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectHour = F4(
	function (zone, basePickerDay, selectionTuple, newHour) {
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
			zone,
			selectionTuple,
			function (_v1) {
				var pickerDay = _v1.a;
				var selection = _v1.b;
				var _v2 = A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
					zone,
					_Utils_Tuple2(pickerDay, selection));
				var earliestSelectableMinute = _v2.a;
				return _Utils_eq(selectionTuple, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
					pickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, earliestSelectableMinute, selection)) : ((_Utils_cmp(
					A2($elm$time$Time$toMinute, zone, selection),
					earliestSelectableMinute) < 0) ? _Utils_Tuple2(
					pickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, earliestSelectableMinute, selection)) : _Utils_Tuple2(pickerDay, selection));
			}(
				function (_v0) {
					var pickerDay = _v0.a;
					var selection = _v0.b;
					return _Utils_Tuple2(
						pickerDay,
						A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setHourNotDay, zone, newHour, selection));
				}(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(basePickerDay, basePickerDay.g1),
						selectionTuple))));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectMinute = F4(
	function (zone, basePickerDay, selectionTuple, newMinute) {
		return A3(
			$mercurymedia$elm_datetime_picker$DatePicker$Utilities$validSelectionOrDefault,
			zone,
			selectionTuple,
			function (_v0) {
				var pickerDay = _v0.a;
				var selection = _v0.b;
				return _Utils_Tuple2(
					pickerDay,
					A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setMinuteNotDay, zone, newMinute, selection));
			}(
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(basePickerDay, basePickerDay.g1),
					selectionTuple)));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var _v1 = model.ay;
		if (_v1.$ === 1) {
			var timePickerVisible = _v1.a;
			var baseDay = _v1.b;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U: model.U + 1}),
						$elm$core$Maybe$Nothing);
				case 1:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U: model.U - 1}),
						$elm$core$Maybe$Nothing);
				case 2:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U: model.U + 12}),
						$elm$core$Maybe$Nothing);
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U: model.U - 12}),
						$elm$core$Maybe$Nothing);
				case 4:
					var pickerDay = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h3: $elm$core$Maybe$Just(pickerDay)
							}),
						$elm$core$Maybe$Nothing);
				case 5:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{h3: $elm$core$Maybe$Nothing}),
						$elm$core$Maybe$Nothing);
				case 6:
					var pickerDay = msg.a;
					var _v3 = A3($mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectDay, settings.lG, model.S, pickerDay);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var newPickerDay = _v4.a;
						var newSelection = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple2(newPickerDay, newSelection))
								}),
							$elm$core$Maybe$Just(newSelection));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{S: $elm$core$Maybe$Nothing}),
							$elm$core$Maybe$Nothing);
					}
				case 7:
					var _v5 = settings.lm;
					if (_v5.$ === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ay: A2($mercurymedia$elm_datetime_picker$SingleDatePicker$Open, !timePickerVisible, baseDay)
								}),
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					}
				case 8:
					var hour = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Maybe$Nothing),
						A2(
							$elm$core$Maybe$map,
							function (_v6) {
								var pickerDay = _v6.a;
								var selection = _v6.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											S: $elm$core$Maybe$Just(
												_Utils_Tuple2(pickerDay, selection))
										}),
									$elm$core$Maybe$Just(selection));
							},
							A4($mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectHour, settings.lG, baseDay, model.S, hour)));
				case 9:
					var minute = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Maybe$Nothing),
						A2(
							$elm$core$Maybe$map,
							function (_v7) {
								var pickerDay = _v7.a;
								var selection = _v7.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											S: $elm$core$Maybe$Just(
												_Utils_Tuple2(pickerDay, selection))
										}),
									$elm$core$Maybe$Just(selection));
							},
							A4($mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectMinute, settings.lG, baseDay, model.S, minute)));
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ay: $mercurymedia$elm_datetime_picker$SingleDatePicker$Closed}),
						$elm$core$Maybe$Nothing);
				case 11:
					var newDomElements = msg.a;
					var updatedDomLocation = function () {
						var _v8 = model.bi;
						if (_v8.$ === 1) {
							var domElements = _v8.a;
							var triggerDomElement = domElements.bH;
							var pickerDomElement = domElements.bz;
							return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$OutsideHierarchy(
								_Utils_update(
									domElements,
									{
										bz: _Utils_update(
											pickerDomElement,
											{
												gj: $elm$core$Maybe$Just(newDomElements.bz)
											}),
										bH: _Utils_update(
											triggerDomElement,
											{
												gj: $elm$core$Maybe$Just(newDomElements.bH)
											})
									}));
						} else {
							return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$InsideHierarchy;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bi: updatedDomLocation}),
						$elm$core$Maybe$Nothing);
				default:
					return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Page$SolicitarChie$onDateTimePickerChanged = F3(
	function (key_, dtePickerMsg, model) {
		var handleDtePickerUpdate = F2(
			function (dTPicker, _v2) {
				var newPicker = _v2.a;
				var newPicked = _v2.b;
				if (key_ === 'solicitud_documentos_fecha--dtpicker') {
					if (!newPicked.$) {
						var p = newPicked.a;
						return _Utils_update(
							dTPicker,
							{
								a0: newPicked,
								aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$closePicker(newPicker)
							});
					} else {
						return _Utils_update(
							dTPicker,
							{aw: newPicker});
					}
				} else {
					return function (_v1) {
						var pkr = _v1.a;
						var pkd = _v1.b;
						return _Utils_update(
							dTPicker,
							{a0: pkd, aw: pkr});
					}(
						A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$core$Maybe$Just),
								$elm$core$Maybe$withDefault(dTPicker.a0)),
							_Utils_Tuple2(newPicker, newPicked)));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return function (dTPicker_) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{
									E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
								}),
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$SolicitarChie$OnSolicitudUpdated,
									A3($elm$core$String$replace, '--dtpicker', '', key_),
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, dTPicker_.a0)))));
					}(
						A2(
							handleDtePickerUpdate,
							dTPicker,
							function (settings_) {
								return A3($mercurymedia$elm_datetime_picker$SingleDatePicker$update, settings_, dtePickerMsg, dTPicker.aw);
							}(
								A2($author$project$Page$SolicitarChie$dateTimePickerSettings, key_, model))));
				},
				A2($elm$core$Dict$get, key_, model.E)));
	});
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateViewOffset = F3(
	function (zone, referenceTime, subjectTime) {
		var flooredReference = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, referenceTime);
		if (subjectTime.$ === 1) {
			return 0;
		} else {
			var time = subjectTime.a;
			var flooredSubject = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, time);
			return (_Utils_cmp(
				$elm$time$Time$posixToMillis(flooredReference),
				$elm$time$Time$posixToMillis(flooredSubject)) < 1) ? A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, flooredReference, flooredSubject) : (0 - A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, flooredSubject, flooredReference));
		}
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$getTimePickerSettings = function (settings) {
	var _v0 = settings.lm;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var timePickerSettings = _v0.a;
			return $elm$core$Maybe$Just(timePickerSettings);
		default:
			var timePickerSettings = _v0.a;
			return $elm$core$Maybe$Just(timePickerSettings);
	}
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix = F4(
	function (zone, isDisabledFn, allowableTimesFn, posix) {
		var flooredPosix = A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone, posix);
		var allowableTimes = A2(
			$elm$core$Maybe$withDefault,
			{hN: 23, hO: 59, i4: 0, i5: 0},
			A2(
				$elm$core$Maybe$map,
				function (fn) {
					return A2(fn, zone, flooredPosix);
				},
				allowableTimesFn));
		return {
			jY: A2(
				isDisabledFn,
				zone,
				A3($justinmimbs$time_extra$Time$Extra$floor, 11, zone, flooredPosix)),
			hM: A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay, zone, allowableTimes.hN, allowableTimes.hO, 59, flooredPosix),
			g1: A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$setTimeOfDay, zone, allowableTimes.i4, allowableTimes.i5, 0, flooredPosix)
		};
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$generatePickerDay = F2(
	function (settings, time) {
		return A2(
			$elm$core$Maybe$withDefault,
			A4($mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix, settings.lG, settings.kr, $elm$core$Maybe$Nothing, time),
			A2(
				$elm$core$Maybe$map,
				function (timePickerSettings) {
					return A4(
						$mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix,
						settings.lG,
						settings.kr,
						$elm$core$Maybe$Just(timePickerSettings.dX),
						time);
				},
				$mercurymedia$elm_datetime_picker$SingleDatePicker$getTimePickerSettings(settings)));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$openPicker = F4(
	function (settings, baseTime, pickedTime, _v0) {
		var model = _v0;
		var viewOffset = A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculateViewOffset, settings.lG, baseTime, pickedTime);
		var timePickerVisible = function () {
			var _v1 = settings.lm;
			switch (_v1.$) {
				case 0:
					return false;
				case 1:
					return false;
				default:
					return true;
			}
		}();
		var selectionTuple = A2(
			$elm$core$Maybe$map,
			function (pt) {
				return _Utils_Tuple2(
					A2($mercurymedia$elm_datetime_picker$SingleDatePicker$generatePickerDay, settings, pt),
					pt);
			},
			pickedTime);
		return _Utils_update(
			model,
			{
				S: selectionTuple,
				ay: A2(
					$mercurymedia$elm_datetime_picker$SingleDatePicker$Open,
					timePickerVisible,
					A2($mercurymedia$elm_datetime_picker$SingleDatePicker$generatePickerDay, settings, baseTime)),
				U: viewOffset
			});
	});
var $author$project$Page$SolicitarChie$openDateTimePicker = F2(
	function (key_, model) {
		var dateTimePickers = model.E;
		var currentDateTime = model.bS;
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return function (dTPicker_) {
						return _Utils_update(
							model,
							{
								E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
							});
					}(
						function (picker_) {
							return _Utils_update(
								dTPicker,
								{aw: picker_});
						}(
							function (settings_) {
								return A4($mercurymedia$elm_datetime_picker$SingleDatePicker$openPicker, settings_, currentDateTime, dTPicker.a0, dTPicker.aw);
							}(
								A2($author$project$Page$SolicitarChie$dateTimePickerSettings, key_, model))));
				},
				A2($elm$core$Dict$get, key_, dateTimePickers)));
	});
var $author$project$Page$SolicitarChie$sameAsStockData_ = function (_v0) {
	var vhInStockForm = _v0.aj;
	var solicitudForm = _v0.l;
	var stockFormMap = F2(
		function (_v2, strField_) {
			return $author$project$Csf$Form$strVal(strField_);
		});
	var keyFromRequest = A2($elm$core$String$replace, 'solicitud_', 'instock_');
	var filterDataMap_ = function (tuple_) {
		return function (mapAction_) {
			return mapAction_(
				A2($elm$core$Tuple$mapFirst, keyFromRequest, tuple_));
		}(
			function (_v1) {
				var key_ = _v1.a;
				var value_ = _v1.b;
				return A2($elm$core$Dict$member, key_, vhInStockForm) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						key_,
						$author$project$Csf$Form$strVal(value_))) : $elm$core$Maybe$Nothing;
			});
	};
	var solicitudForm_ = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$filterMap,
			filterDataMap_,
			$elm$core$Dict$toList(solicitudForm)));
	return _Utils_eq(
		solicitudForm_,
		A2($elm$core$Dict$map, stockFormMap, vhInStockForm));
};
var $author$project$Ports$scrollToBottom = _Platform_outgoingPort('scrollToBottom', $elm$json$Json$Encode$string);
var $author$project$Customized$CustomDropdown$selectedOption = function (_v0) {
	var pickedOption = _v0.by;
	return A2($elm$core$Maybe$withDefault, '', pickedOption);
};
var $author$project$Config$ApiEndpoint$dealerrequest = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-request-service', 'request-service', 'request']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$solicitarCHIENode = F2(
	function (ticket_, jsonBody) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode),
			A3(
				$author$project$Helpers$ApiHandler$post,
				$author$project$Config$ApiEndpoint$dealerrequest(ticket_),
				_List_Nil,
				$elm$http$Http$jsonBody(jsonBody)));
	});
var $author$project$Customized$InputDropdown$update = F2(
	function (mssg, model) {
		switch (mssg.$) {
			case 0:
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{cY: ''}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{bj: true}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{bj: false}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var dataValue_ = mssg.a;
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2($author$project$Helpers$Utilities$delay, 0, $author$project$Customized$InputDropdown$DropdownClosed));
			default:
				var dataValue_ = mssg.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{cY: dataValue_}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Helpers$Utilities$updateDropdownOptions = F3(
	function (key_, options_, mdel) {
		return function (dropdown_) {
			return A3($author$project$Helpers$Utilities$updateDropdown, key_, dropdown_, mdel);
		}(
			A2(
				$author$project$Customized$CustomDropdown$updateDataListSet,
				options_,
				A2($author$project$Helpers$Utilities$getDropdown, key_, mdel)));
	});
var $author$project$Page$SolicitarChie$validateFormField_ = F3(
	function (key_, validation_, formDict) {
		return function (strField_) {
			return A3($elm$core$Dict$insert, key_, strField_, formDict);
		}(
			A2(
				$author$project$Csf$Form$strValidator,
				validation_,
				A3(
					$elm$core$Basics$composeR,
					$author$project$Csf$Form$strVal,
					$elm$core$String$trim,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Csf$Form$strFieldModel(''),
						A2($elm$core$Dict$get, key_, formDict)))));
	});
var $author$project$Customized$CustomDropdown$validateRequired = F2(
	function (required_, model) {
		return _Utils_update(
			model,
			{cG: required_});
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Page$SolicitarChie$update = F2(
	function (msg, model) {
		var session = model.g$;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var tenant_ = $author$project$Csf$Flags$tenantId(session.ka);
		var obtainImporters = function (vin_) {
			return A2(
				$elm$core$Basics$composeR,
				A2($author$project$Helpers$ApiHandler$buscarImportadores, ticket_, vin_),
				$elm$core$Task$attempt($author$project$Page$SolicitarChie$GotImporters));
		};
		var isValidIntPeso = function (data_) {
			var _v27 = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toInt)(data_);
			if (!_v27.$) {
				var n = _v27.a;
				return n > 0;
			} else {
				return false;
			}
		};
		var isValidInt = function (data_) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v26) {
						return true;
					},
					A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toInt)(data_)));
		};
		var allowedRutFormat_ = A2($author$project$Csf$Form$AllowedExpression, $author$project$Helpers$Utilities$allowedRutFormat, 'Formato de RUT inválido');
		var allowedExpression_ = A2($author$project$Csf$Form$AllowedExpression, $author$project$Helpers$Utilities$allowedChars, 'El campo contiene caracteres no permitidos');
		switch (msg.$) {
			case 2:
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$author$project$Route$goTo,
						session.gL,
						$author$project$Route$SolicitarChie($author$project$Route$emptyData)));
			case 3:
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{c6: model.dn || (model.bB || (model.dp || model.$7))}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$author$project$Route$goTo,
						session.gL,
						$author$project$Route$SolicitudesChie($author$project$Route$emptyData)));
			case 5:
				var solicitudForm_ = A3(
					$author$project$Page$SolicitarChie$validateFormField_,
					'solicitud_adquiriente_correo',
					_List_fromArray(
						[$author$project$Csf$Form$Email]),
					A3(
						$author$project$Page$SolicitarChie$validateFormField_,
						'solicitud_adquiriente_rut',
						_List_fromArray(
							[$author$project$Csf$Form$Required, allowedExpression_, allowedRutFormat_]),
						A3(
							$author$project$Page$SolicitarChie$validateFormField_,
							'solicitud_documentos_numero',
							_List_fromArray(
								[$author$project$Csf$Form$Required, allowedExpression_]),
							A3(
								$author$project$Page$SolicitarChie$validateFormField_,
								'solicitud_dealer_rut',
								_List_fromArray(
									[$author$project$Csf$Form$Required, allowedExpression_, allowedRutFormat_]),
								A3(
									$author$project$Page$SolicitarChie$validateFormField_,
									'solicitud_dealer',
									_List_fromArray(
										[$author$project$Csf$Form$Required, allowedExpression_]),
									A3(
										$author$project$Page$SolicitarChie$validateFormField_,
										'solicitud_ppu',
										_List_fromArray(
											[$author$project$Csf$Form$Required, allowedExpression_]),
										A3(
											$author$project$Page$SolicitarChie$validateFormField_,
											'solicitud_peso',
											_List_fromArray(
												[$author$project$Csf$Form$Required]),
											A3(
												$author$project$Page$SolicitarChie$validateFormField_,
												'solicitud_anno',
												_List_fromArray(
													[$author$project$Csf$Form$Required]),
												A3(
													$author$project$Page$SolicitarChie$validateFormField_,
													'solicitud_color',
													_List_fromArray(
														[$author$project$Csf$Form$Required, allowedExpression_]),
													A3(
														$author$project$Page$SolicitarChie$validateFormField_,
														'solicitud_vin',
														_List_fromArray(
															[$author$project$Csf$Form$Required, allowedExpression_]),
														A3(
															$author$project$Page$SolicitarChie$validateFormField_,
															'solicitud_nro_motor',
															_List_fromArray(
																[$author$project$Csf$Form$Required, allowedExpression_]),
															A3(
																$author$project$Page$SolicitarChie$validateFormField_,
																'solicitud_modelo',
																_List_fromArray(
																	[$author$project$Csf$Form$Required, allowedExpression_]),
																A3(
																	$author$project$Page$SolicitarChie$validateFormField_,
																	'solicitud_marca',
																	_List_fromArray(
																		[$author$project$Csf$Form$Required, allowedExpression_]),
																	A3(
																		$author$project$Page$SolicitarChie$validateFormField_,
																		'solicitud_email',
																		_List_fromArray(
																			[$author$project$Csf$Form$Required, $author$project$Csf$Form$Email]),
																		A3(
																			$author$project$Page$SolicitarChie$validateFormField_,
																			'solicitud_tipo_vehiculo',
																			_List_fromArray(
																				[$author$project$Csf$Form$Required, allowedExpression_]),
																			model.l)))))))))))))));
				var notValidFormFields_ = A2(
					$elm$core$List$any,
					A2($elm$core$Basics$composeR, $author$project$Csf$Form$strIsValid, $elm$core$Basics$not),
					$elm$core$Dict$values(solicitudForm_));
				var formField_ = function (key_) {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Csf$Form$strVal,
							A2($elm$core$Dict$get, key_, solicitudForm_)));
				};
				var tipoVehiculo_ = formField_('solicitud_tipo_vehiculo');
				var invalidFormPPU_ = A2(
					$author$project$Helpers$Utilities$isInvalidPPU_,
					tipoVehiculo_,
					formField_('solicitud_ppu'));
				var model_ = _Utils_update(
					model,
					{
						eP: A2(
							$elm$core$Dict$map,
							F2(
								function (_v1, d) {
									return A2($author$project$Customized$CustomDropdown$validateRequired, true, d);
								}),
							model.eP)
					});
				var moduleDropdowns = model_.eP;
				var notValidDropdowns_ = A2(
					$elm$core$List$any,
					A2($elm$core$Basics$composeR, $author$project$Customized$CustomDropdown$isValidDropbox, $elm$core$Basics$not),
					$elm$core$Dict$values(moduleDropdowns));
				var atLeastOneInvalid_ = notValidFormFields_ || notValidDropdowns_;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model_,
						{ar: invalidFormPPU_, l: solicitudForm_}),
					(atLeastOneInvalid_ || invalidFormPPU_) ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Helpers$Utilities$delay,
						0,
						$author$project$Page$SolicitarChie$ChangeActualStep(3)));
			case 6:
				var tupleData = F2(
					function (key_, field_) {
						return A2(
							$elm$core$Tuple$pair,
							key_ + ('_' + field_),
							A3(
								$author$project$Helpers$Utilities$decodeMbValue,
								$elm$json$Json$Encode$null,
								A2($elm$json$Json$Decode$field, field_, $elm$json$Json$Decode$value),
								A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, model.X)));
					});
				var fromSolicitud_ = function (key_) {
					return A3($author$project$Page$SolicitarChie$formFieldValue, key_, '', model.l);
				};
				var extractedData_ = _List_fromArray(
					[
						A2(tupleData, 'extraccion', 'track_id'),
						A2(tupleData, 'extraccion', 'fecha_solicitud'),
						A2(tupleData, 'extraccion', 'fecha_resolucion'),
						A2(tupleData, 'extraccion', 'extractor_texto'),
						A2(tupleData, 'extraccion', 'naturaleza_documento'),
						A2(tupleData, 'extraccion', 'tipo_inscripcion'),
						A2(tupleData, 'extraccion', 'formato_documento'),
						A2(tupleData, 'extraccion', 'tiempo_procesamiento'),
						A2(tupleData, 'solicitud', 'region'),
						A2(tupleData, 'solicitud', 'oficina'),
						A2(tupleData, 'solicitud', 'nro_solicitud'),
						A2(tupleData, 'vehiculo', 'carga'),
						A2(tupleData, 'vehiculo', 'asientos'),
						A2(tupleData, 'vehiculo', 'puertas'),
						A2(tupleData, 'vehiculo', 'serie'),
						A2(tupleData, 'vehiculo', 'chassis'),
						A2(tupleData, 'vehiculo', 'peso_bruto'),
						A2(tupleData, 'vehiculo', 'tipo_combustible'),
						A2(tupleData, 'solicitante', 'rut'),
						A2(tupleData, 'solicitante', 'nombre'),
						A2(tupleData, 'solicitante', 'comuna'),
						A2(tupleData, 'solicitante', 'domicilio'),
						A2(tupleData, 'solicitante', 'telefono'),
						A2(tupleData, 'solicitante', 'correo'),
						A2(tupleData, 'datos_adicionales', 'valor_derecho_inscripcion'),
						A2(tupleData, 'datos_adicionales', 'valor_placa'),
						A2(tupleData, 'datos_adicionales', 'valor_total'),
						A2(tupleData, 'datos_adicionales', 'fecha_emision_impresion'),
						A2(tupleData, 'datos_adicionales', 'folio_impresion'),
						A2(tupleData, 'datos_adicionales', 'codigo_verificacion_impresion'),
						A2(tupleData, 'datos_adicionales', 'codigo_barra_impresion')
					]);
				var encodeMapValue_ = function (val) {
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Encode$string,
							$author$project$Helpers$Utilities$stringToMaybe(val)));
				};
				var updateInscription_ = A4(
					$author$project$Helpers$ApiHandler$actualizarNode,
					ticket_,
					tenant_,
					model.X.p,
					A3(
						$elm$core$Basics$composeR,
						$elm$core$Basics$append(extractedData_),
						$elm$json$Json$Encode$object,
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$mapSecond(encodeMapValue_),
							_List_fromArray(
								[
									_Utils_Tuple2('id_negocio', 'emision-chie'),
									_Utils_Tuple2(
									'solicitud_fecha_solicitud',
									fromSolicitud_('solicitud_fecha_solicitud')),
									_Utils_Tuple2(
									'vehiculo_vin',
									fromSolicitud_('solicitud_vin')),
									_Utils_Tuple2(
									'vehiculo_ppu',
									fromSolicitud_('solicitud_ppu')),
									_Utils_Tuple2(
									'vehiculo_ano',
									fromSolicitud_('solicitud_anno')),
									_Utils_Tuple2(
									'vehiculo_peso_bruto',
									fromSolicitud_('solicitud_peso')),
									_Utils_Tuple2(
									'vehiculo_marca',
									fromSolicitud_('solicitud_marca')),
									_Utils_Tuple2(
									'vehiculo_modelo',
									fromSolicitud_('solicitud_modelo')),
									_Utils_Tuple2(
									'vehiculo_color',
									fromSolicitud_('solicitud_color')),
									_Utils_Tuple2(
									'vehiculo_motor',
									fromSolicitud_('solicitud_nro_motor')),
									_Utils_Tuple2(
									'vehiculo_tipo_vehiculo',
									fromSolicitud_('solicitud_tipo_vehiculo')),
									_Utils_Tuple2(
									'adquiriente_nombre',
									fromSolicitud_('solicitud_adquiriente_nombre')),
									_Utils_Tuple2(
									'adquiriente_rut',
									fromSolicitud_('solicitud_adquiriente_rut')),
									_Utils_Tuple2(
									'adquiriente_domicilio',
									fromSolicitud_('solicitud_adquiriente_domicilio')),
									_Utils_Tuple2(
									'adquiriente_comuna',
									fromSolicitud_('solicitud_adquiriente_comuna')),
									_Utils_Tuple2(
									'adquiriente_correo',
									fromSolicitud_('solicitud_adquiriente_correo')),
									_Utils_Tuple2(
									'documentos_autorizante',
									fromSolicitud_('solicitud_dealer')),
									_Utils_Tuple2(
									'documentos_rut_emisor',
									fromSolicitud_('solicitud_dealer_rut')),
									_Utils_Tuple2(
									'documentos_numero',
									fromSolicitud_('solicitud_documentos_numero')),
									_Utils_Tuple2(
									'documentos_tipo',
									fromSolicitud_('solicitud_documentos_tipo')),
									_Utils_Tuple2(
									'documentos_naturaleza',
									fromSolicitud_('solicitud_documentos_naturaleza')),
									_Utils_Tuple2(
									'documentos_lugar',
									fromSolicitud_('solicitud_documentos_lugar')),
									A2(
									$elm$core$Tuple$pair,
									'documentos_fecha',
									A3(
										$elm$core$Basics$composeR,
										$elm$core$List$head,
										$elm$core$Maybe$withDefault(''),
										A2(
											$elm$core$Basics$composeR,
											fromSolicitud_,
											$elm$core$String$split('T'))('solicitud_documentos_fecha')))
								]))));
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{u: true}),
					A2($elm$core$Task$attempt, $author$project$Page$SolicitarChie$InscriptionUpdated, updateInscription_));
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: false}),
					A2($author$project$Page$SolicitarChie$doNotify, 'error', 'wrong_file'));
			case 9:
				var key_ = msg.a;
				var updateMdelPickers = function (dTPicker_) {
					return _Utils_update(
						model,
						{
							E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
						});
				};
				var cmdAction_ = A2(
					$author$project$Helpers$Utilities$delay,
					0,
					A2(
						$author$project$Page$SolicitarChie$OnSolicitudUpdated,
						A3($elm$core$String$replace, '--dtpicker', '', key_),
						''));
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (dTPicker) {
							return function (mdel) {
								return A2($elm$core$Tuple$pair, mdel, cmdAction_);
							}(
								updateMdelPickers(
									_Utils_update(
										dTPicker,
										{
											a0: $elm$core$Maybe$Nothing,
											aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$init(
												$author$project$Page$SolicitarChie$DateTimePickerChanged(key_))
										})));
						},
						A2($elm$core$Dict$get, key_, model.E)));
			case 8:
				var show_ = msg.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{fz: show_}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var _v2 = msg.a;
				var nowDateTime = _v2.a;
				var currentTimeZone = _v2.b;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{bS: nowDateTime, lG: currentTimeZone}),
					$elm$core$Platform$Cmd$none);
			case 11:
				if (msg.b.$ === 1) {
					var key_ = msg.a;
					var _v3 = msg.b;
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Page$SolicitarChie$OpenDateTimePicker(key_),
							A2($elm$core$Task$map, $elm$core$Maybe$Just, $elm$time$Time$now)));
				} else {
					var key_ = msg.a;
					var nowDateTime = msg.b.a;
					return function (mdel) {
						return A2($elm$core$Tuple$pair, mdel, $elm$core$Platform$Cmd$none);
					}(
						A2(
							$author$project$Page$SolicitarChie$openDateTimePicker,
							key_,
							_Utils_update(
								model,
								{bS: nowDateTime})));
				}
			case 12:
				var key_ = msg.a;
				var dtePickerMsg = msg.b;
				return A3($author$project$Page$SolicitarChie$onDateTimePickerChanged, key_, dtePickerMsg, model);
			case 13:
				var modalType = msg.a;
				return function (model_) {
					return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
				}(
					function () {
						var heading_ = modalType.a;
						var message_ = modalType.b;
						return _Utils_update(
							model,
							{
								cP: {cV: heading_, bt: message_},
								cQ: $author$project$Csf$Modal$shown
							});
					}());
			case 14:
				var modalType = msg.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{cQ: $author$project$Csf$Modal$hidden}),
					A2(
						$author$project$Route$goTo,
						session.gL,
						A2($elm$core$String$contains, 'creado', model.cP.cV) ? $author$project$Route$SolicitudesChie($author$project$Route$emptyData) : $author$project$Route$SolicitarChie($author$project$Route$emptyData)));
			case 15:
				var step_ = msg.a;
				return A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{cu: step_}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var instock_key = msg.a;
				var request_key = A3($elm$core$String$replace, 'instock_', 'solicitud_', instock_key);
				var stringFieldMap = function (field_) {
					return A3($elm$core$Dict$insert, request_key, field_, model.l);
				};
				var fromStock = F2(
					function (_default, mapAction) {
						return A2(
							$elm$core$Maybe$withDefault,
							_default,
							A2(
								$elm$core$Maybe$map,
								mapAction,
								A2($elm$core$Dict$get, instock_key, model.aj)));
					});
				var model_ = _Utils_update(
					model,
					{
						l: A2(fromStock, model.l, stringFieldMap)
					});
				switch (instock_key) {
					case 'instock_marca':
						return A2(
							$elm$core$Tuple$pair,
							model_,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitarChie$ImportersOnDelay,
								$author$project$Helpers$Utilities$delay(0),
								A2(
									$elm$core$Tuple$pair,
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(
										A2(fromStock, '', $author$project$Csf$Form$strVal)))));
					case 'instock_vin':
						return A2(
							$elm$core$Tuple$pair,
							model_,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitarChie$ImportersOnDelay,
								$author$project$Helpers$Utilities$delay(0),
								A2(
									$elm$core$Tuple$pair,
									$elm$core$Maybe$Just(
										A2(fromStock, '', $author$project$Csf$Form$strVal)),
									$elm$core$Maybe$Nothing)));
					case 'instock_tipo_vehiculo':
						return A2(
							$elm$core$Tuple$pair,
							model_,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Page$SolicitarChie$DropdownMsg(2),
								A3(
									$elm$core$Basics$composeR,
									$author$project$Customized$CustomDropdown$PickedOption,
									$author$project$Helpers$Utilities$delay(0),
									A3(
										$elm$core$Basics$composeR,
										$author$project$Helpers$Utilities$correctTipoVehiculo_,
										$author$project$Helpers$Utilities$mbeTipoDeVehiculo,
										A2(fromStock, '', $author$project$Csf$Form$strVal)))));
					default:
						return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
				}
			case 17:
				var vinDta = msg.a;
				var vinDta_ = $author$project$Helpers$Utilities$trimmedToUpper(vinDta);
				var _v7 = model;
				var vinDropdown = _v7.ad;
				var vinsRetrieved = _v7.fX;
				var doNotSearch_ = $elm$core$String$isEmpty(vinDta_) || A2(
					$elm$core$List$any,
					$elm$core$String$contains(vinDta_),
					vinsRetrieved);
				return doNotSearch_ ? A2(
					$elm$core$Tuple$pair,
					_Utils_update(
						model,
						{
							ad: _Utils_update(
								vinDropdown,
								{gh: vinsRetrieved})
						}),
					$elm$core$Platform$Cmd$none) : A3(
					$elm$core$Basics$composeR,
					$elm$core$Task$attempt($author$project$Page$SolicitarChie$VinsFounded),
					$elm$core$Tuple$pair(model),
					function (service_) {
						return A2($author$project$Helpers$ApiHandler$get, service_, _List_Nil);
					}($author$project$Config$ApiEndpoint$chievinspublic + ('?filter=*' + (vinDta_ + '*'))));
			case 18:
				var filename_ = msg.a;
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$SolicitarChie$NodeDownloaded(filename_),
						A3($author$project$Helpers$ApiHandler$descargarNodeFile, ticket_, tenant_, model.X.p)));
			case 19:
				var _v8 = msg.a;
				var mbVin = _v8.a;
				var mbBrand = _v8.b;
				var fromSolicitud = function (key_) {
					return $elm$core$String$trim(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Csf$Form$strVal,
								A2($elm$core$Dict$get, key_, model.l))));
				};
				var vin_ = $elm$core$String$trim(
					A2(
						$elm$core$Maybe$withDefault,
						fromSolicitud('solicitud_vin'),
						mbVin));
				var brand_ = $elm$core$String$trim(
					A2(
						$elm$core$Maybe$withDefault,
						fromSolicitud('solicitud_marca'),
						mbBrand));
				var doesValuesMatches = _Utils_eq(
					fromSolicitud('solicitud_marca'),
					brand_) && _Utils_eq(
					fromSolicitud('solicitud_vin'),
					vin_);
				if (!doesValuesMatches) {
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				} else {
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bB: true}),
						A2(obtainImporters, vin_, brand_));
				}
			case 20:
				var key_ = msg.a;
				switch (key_) {
					case 'solicitud_vin':
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2($author$project$Page$SolicitarChie$InputDropdownMsg, 0, $author$project$Customized$InputDropdown$DropdownOpened)));
					case 'solicitud_dealer':
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2($author$project$Page$SolicitarChie$InputDropdownMsg, 1, $author$project$Customized$InputDropdown$DropdownOpened)));
					default:
						return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				}
			case 21:
				var key_ = msg.a;
				var code_ = msg.b;
				if (key_ === 'solicitud_vin') {
					var vinFormField_ = A3(
						$elm$core$Basics$composeR,
						$elm$core$String$words,
						$elm$core$String$join(''),
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Csf$Form$strVal,
								A2($elm$core$Dict$get, 'solicitud_vin', model.l))));
					return A2(
						$elm$core$Tuple$pair,
						model,
						((13 === code_) && A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedEmpty, $elm$core$Basics$not)(vinFormField_)) ? A2(
							$author$project$Helpers$Utilities$delay,
							0,
							A2(
								$author$project$Page$SolicitarChie$InputDropdownMsg,
								0,
								$author$project$Customized$InputDropdown$ItemClicked(vinFormField_))) : $elm$core$Platform$Cmd$none);
				} else {
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				}
			case 22:
				var dict_key = msg.a;
				var fieldDta = msg.b;
				var insert_ = function (strField) {
					return function (sForm) {
						return _Utils_update(
							model,
							{l: sForm});
					}(
						A3($elm$core$Dict$insert, dict_key, strField, model.l));
				};
				var formField_ = F2(
					function (key__, mdel) {
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Csf$Form$strVal,
								A2($elm$core$Dict$get, key__, mdel.l)));
					});
				var formPPU_ = formField_('solicitud_ppu');
				var tipoVehiculo_ = formField_('solicitud_tipo_vehiculo');
				var validateFormPPU_ = function (mdel) {
					return _Utils_update(
						mdel,
						{
							ar: A2(
								$elm$core$List$member,
								dict_key,
								_List_fromArray(
									['solicitud_ppu', 'solicitud_tipo_vehiculo'])) ? A2(
								$author$project$Helpers$Utilities$isInvalidPPU_,
								tipoVehiculo_(mdel),
								formPPU_(mdel)) : mdel.ar
						});
				};
				var invertTuple_ = function (_v13) {
					var cmdAction_ = _v13.a;
					var mdel = _v13.b;
					return A2(
						$elm$core$Tuple$pair,
						validateFormPPU_(mdel),
						cmdAction_);
				};
				return invertTuple_(
					function () {
						switch (dict_key) {
							case 'solicitud_email':
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									A3(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[$author$project$Csf$Form$Required, $author$project$Csf$Form$Email])),
										insert_,
										$elm$core$String$toLower(fieldDta)));
							case 'solicitud_cit':
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									A3(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[allowedExpression_])),
										insert_,
										$elm$core$String$toUpper(fieldDta)));
							case 'solicitud_anno':
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									($author$project$Helpers$Utilities$trimmedEmpty(fieldDta) || isValidInt(fieldDta)) ? A2(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[$author$project$Csf$Form$Required])),
										insert_)(fieldDta) : model);
							case 'solicitud_peso':
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									($author$project$Helpers$Utilities$trimmedEmpty(fieldDta) || isValidIntPeso(fieldDta)) ? A2(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[$author$project$Csf$Form$Required])),
										insert_)(fieldDta) : model);
							case 'solicitud_vin':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (cmd) {
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													cmd,
													A2(
													$author$project$Helpers$Utilities$delay,
													1.5,
													$author$project$Page$SolicitarChie$ImportersOnDelay(
														_Utils_Tuple2(
															$elm$core$Maybe$Just(
																$elm$core$String$toUpper(fieldDta)),
															$elm$core$Maybe$Nothing)))
												]));
									},
									A2(
										$elm$core$Tuple$pair,
										A2(
											$author$project$Helpers$Utilities$delay,
											0,
											$author$project$Page$SolicitarChie$HandleVinData(fieldDta)),
										A3(
											$elm$core$Basics$composeR,
											$author$project$Csf$Form$strValidator(
												_List_fromArray(
													[$author$project$Csf$Form$Required, allowedExpression_])),
											insert_,
											$elm$core$String$toUpper(fieldDta))));
							case 'solicitud_marca':
								return A2(
									$elm$core$Tuple$pair,
									A2(
										$author$project$Helpers$Utilities$delay,
										1.5,
										$author$project$Page$SolicitarChie$ImportersOnDelay(
											_Utils_Tuple2(
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(
													$elm$core$String$toUpper(fieldDta))))),
									A3(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[$author$project$Csf$Form$Required, allowedExpression_])),
										insert_,
										$elm$core$String$toUpper(fieldDta)));
							case 'solicitud_adquiriente_correo':
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									A3(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[$author$project$Csf$Form$Email])),
										insert_,
										$elm$core$String$toLower(fieldDta)));
							default:
								return A2(
									$elm$core$Tuple$pair,
									$elm$core$Platform$Cmd$none,
									A3(
										$elm$core$Basics$composeR,
										$author$project$Csf$Form$strValidator(
											_List_fromArray(
												[allowedExpression_])),
										insert_,
										$elm$core$String$toUpper(fieldDta)));
						}
					}());
			case 23:
				if (!msg.a.$) {
					var taskNode = msg.a.a;
					var modalMessage_ = ((!model.bl) && $author$project$Page$SolicitarChie$sameAsStockData_(model)) ? '' : $author$project$Page$SolicitarChie$moduleMessage('solicitud_ok_revision');
					var modalHeading_ = $author$project$Page$SolicitarChie$moduleMessage('solicitud_ok_heading');
					var fromSolicitud_ = function (key_) {
						return A3($author$project$Page$SolicitarChie$formFieldValue, key_, '', model.l);
					};
					var expedienteId = A3($author$project$Csf$TaskNodeUtils$string, '', 'unique_id', taskNode);
					var actualizarPeso_ = A4(
						$author$project$Helpers$ApiHandler$actualizarNode,
						ticket_,
						tenant_,
						expedienteId,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'vehiculo_peso_bruto',
									$elm$json$Json$Encode$string(
										fromSolicitud_('solicitud_peso')))
								])));
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{u: false}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									function (_v14) {
										return $author$project$Page$SolicitarChie$NoOp;
									},
									actualizarPeso_),
									A2(
									$author$project$Helpers$Utilities$delay,
									0,
									$author$project$Page$SolicitarChie$ShowModal(
										A2($author$project$Page$SolicitarChie$ErrorInfoModal, modalHeading_, modalMessage_)))
								])));
				} else {
					var error_ = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'solicitud_fail');
					var errorDecoderMap = function (string_) {
						return A2($elm$core$String$contains, 'INVALID_VEHICLE_TYPE', string_) ? A3(
							$elm$core$Basics$composeR,
							$author$project$Page$SolicitarChie$ShowModal,
							$author$project$Helpers$Utilities$delay(0),
							A2(
								$author$project$Page$SolicitarChie$ErrorInfoModal,
								'Error procesando solicitud',
								$author$project$Page$SolicitarChie$moduleMessage('INVALID_VEHICLE_TYPE'))) : (A2($elm$core$String$contains, 'INVALID_VIN_LENGTH', string_) ? A3(
							$elm$core$Basics$composeR,
							$author$project$Page$SolicitarChie$ShowModal,
							$author$project$Helpers$Utilities$delay(0),
							A2(
								$author$project$Page$SolicitarChie$ErrorInfoModal,
								'Error procesando solicitud',
								$author$project$Page$SolicitarChie$moduleMessage('INVALID_VIN_LENGTH'))) : (A2($elm$core$String$contains, 'not possible to identify the importer', string_) ? A3(
							$elm$core$Basics$composeR,
							$author$project$Page$SolicitarChie$ShowModal,
							$author$project$Helpers$Utilities$delay(0),
							A2(
								$author$project$Page$SolicitarChie$ErrorInfoModal,
								'Error procesando solicitud',
								$author$project$Page$SolicitarChie$moduleMessage('invalid_importer'))) : (A2(
							$elm$core$String$contains,
							'solicitud duplicada',
							$author$project$Helpers$Utilities$trimmedToLower(string_)) ? A3(
							$elm$core$Basics$composeR,
							$author$project$Page$SolicitarChie$ShowModal,
							$author$project$Helpers$Utilities$delay(0),
							A2(
								$author$project$Page$SolicitarChie$ErrorInfoModal,
								'Error procesando solicitud',
								$author$project$Page$SolicitarChie$moduleMessage('solicitud_duplicada'))) : (A2(
							$elm$core$String$contains,
							'marca no representada',
							$author$project$Helpers$Utilities$trimmedToLower(string_)) ? A3(
							$elm$core$Basics$composeR,
							$author$project$Page$SolicitarChie$ShowModal,
							$author$project$Helpers$Utilities$delay(0),
							A2($author$project$Page$SolicitarChie$ErrorInfoModal, 'Error procesando solicitud', string_)) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_)))));
					};
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{u: false}),
						function () {
							if ('redirect_' === handled_) {
								return $author$project$Helpers$ApiHandler$toUserHome(session);
							} else {
								if (error_.$ === 4) {
									var status_ = error_.a;
									var body_ = error_.b;
									return A2(
										$elm$core$List$member,
										status_,
										_List_fromArray(
											[400, 500])) ? A4(
										$author$project$Helpers$Utilities$decodeMapString,
										A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_),
										errorDecoderMap,
										A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
										body_) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_);
								} else {
									return A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_);
								}
							}
						}());
				}
			case 24:
				if (!msg.a.$) {
					var updated = msg.a.a;
					var fromSolicitud_ = F2(
						function (key_, default_) {
							return A2(
								$elm$core$Maybe$withDefault,
								default_,
								A2(
									$elm$core$Maybe$map,
									$author$project$Csf$Form$strVal,
									A2($elm$core$Dict$get, key_, model.l)));
						});
					var dataFromSolicitud = function (key_) {
						return A2(fromSolicitud_, key_, '');
					};
					var handleVinDta = A3(
						$elm$core$Basics$composeR,
						$elm$core$String$words,
						$elm$core$String$join(''),
						dataFromSolicitud('solicitud_vin'));
					var tipoVehiculo_ = $author$project$Helpers$Utilities$correctTipoVehiculo_(
						dataFromSolicitud('solicitud_tipo_vehiculo'));
					var vehiculoPPU_ = A2(
						$author$project$Helpers$Utilities$correctVehiclePPU_,
						tipoVehiculo_,
						dataFromSolicitud('solicitud_ppu'));
					var dataExtracted_ = model.bl ? false : $author$project$Page$SolicitarChie$sameAsStockData_(model);
					var solicitarChie_ = A3(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$object,
						$author$project$Helpers$ApiHandler$solicitarCHIENode(ticket_),
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'datos_inscripcion_extraidos',
									$elm$json$Json$Encode$bool(dataExtracted_))
								]),
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapSecond($elm$json$Json$Encode$string),
								_List_fromArray(
									[
										_Utils_Tuple2('solicitud_inscripcion', model.X.p),
										_Utils_Tuple2('patente', vehiculoPPU_),
										_Utils_Tuple2(
										'cit',
										dataFromSolicitud('solicitud_cit')),
										_Utils_Tuple2('vin', handleVinDta),
										_Utils_Tuple2('tipo', tipoVehiculo_),
										_Utils_Tuple2(
										'marca',
										dataFromSolicitud('solicitud_marca')),
										_Utils_Tuple2(
										'modelo',
										dataFromSolicitud('solicitud_modelo')),
										_Utils_Tuple2(
										'motor',
										dataFromSolicitud('solicitud_nro_motor')),
										_Utils_Tuple2(
										'color',
										dataFromSolicitud('solicitud_color')),
										_Utils_Tuple2(
										'ano',
										dataFromSolicitud('solicitud_anno')),
										_Utils_Tuple2(
										'vehiculo_peso_bruto',
										dataFromSolicitud('solicitud_peso')),
										_Utils_Tuple2(
										'distribuidor',
										dataFromSolicitud('solicitud_dealer')),
										_Utils_Tuple2(
										'distribuidor_rut',
										A3(
											$elm$core$String$replace,
											'.',
											'',
											dataFromSolicitud('solicitud_dealer_rut'))),
										_Utils_Tuple2(
										'cliente_correo',
										dataFromSolicitud('solicitud_email')),
										_Utils_Tuple2(
										'cliente_rut',
										A3(
											$elm$core$String$replace,
											'.',
											'',
											dataFromSolicitud('solicitud_adquiriente_rut'))),
										_Utils_Tuple2(
										'cliente_nombre',
										dataFromSolicitud('solicitud_adquiriente_nombre')),
										_Utils_Tuple2(
										'cliente_comuna',
										A2(fromSolicitud_, 'solicitud_adquiriente_comuna', 'SIN CLASIFICACIÓN')),
										_Utils_Tuple2(
										'tenant',
										$author$project$Customized$CustomDropdown$selectedOption(
											A2(
												$author$project$Helpers$Utilities$getDropdown,
												$author$project$Page$SolicitarChie$stringFromField(1),
												model)))
									]))));
					return A2(
						$elm$core$Tuple$pair,
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Task$attempt, $author$project$Page$SolicitarChie$SolicitudDone, solicitarChie_),
									A2($author$project$Page$SolicitarChie$doNotify, 'success', 'inscription_update_ok')
								])));
				} else {
					var error_ = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'inscription_update_fail');
					return A2(
						$elm$core$Tuple$pair,
						model,
						('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_));
				}
			case 25:
				if (!msg.a.$) {
					var hits = msg.a.a.kh;
					var inStock = A2(
						$elm$core$Maybe$withDefault,
						$author$project$TaskNode$emptyTask,
						$elm$core$List$head(hits));
					var dataFromNde_ = function (key_) {
						return A3(
							$author$project$Helpers$Utilities$decodeMbValue,
							'',
							$author$project$Helpers$Utilities$forceStringDecoder,
							A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, inStock));
					};
					var insert__ = A2(
						$elm$core$Basics$composeR,
						dataFromNde_,
						A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $author$project$Csf$Form$strFieldModel));
					var anuladoEnStock_ = 'ANULADO' === dataFromNde_('estado_vehiculo');
					var vhInStockForm_ = anuladoEnStock_ ? model.aj : A3(
						$elm$core$Dict$insert,
						'instock_peso',
						insert__('peso_bruto'),
						A3(
							$elm$core$Dict$insert,
							'instock_anno',
							insert__('ano'),
							A3(
								$elm$core$Dict$insert,
								'instock_color',
								insert__('color'),
								A3(
									$elm$core$Dict$insert,
									'instock_vin',
									insert__('vin'),
									A3(
										$elm$core$Dict$insert,
										'instock_cit',
										insert__('cit'),
										A3(
											$elm$core$Dict$insert,
											'instock_nro_motor',
											insert__('motor'),
											A3(
												$elm$core$Dict$insert,
												'instock_tipo_vehiculo',
												insert__('tipo'),
												A3(
													$elm$core$Dict$insert,
													'instock_modelo',
													insert__('modelo'),
													A3(
														$elm$core$Dict$insert,
														'instock_marca',
														insert__('marca'),
														model.aj)))))))));
					var warningStripMssg_ = _Utils_eq(inStock, $author$project$TaskNode$emptyTask) ? $author$project$Page$SolicitarChie$moduleMessage('vehicle_notfound') : (anuladoEnStock_ ? $author$project$Page$SolicitarChie$moduleMessage('vehicle_nullyfied') : (model.bl ? $author$project$Page$SolicitarChie$moduleMessage('data_incomplete') : ''));
					return function (model_) {
						return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
					}(
						_Utils_update(
							model,
							{u: false, fV: inStock, aj: vhInStockForm_, cr: warningStripMssg_}));
				} else {
					var error_ = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'vinsearch_failed');
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{u: false}),
						('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_));
				}
			case 26:
				if (!msg.b.$) {
					var filename_ = msg.a;
					var dataBytes = msg.b.a;
					var mimeType_ = A3(
						$elm$core$Basics$composeR,
						$elm$core$String$join(''),
						$author$project$Helpers$Utilities$mimeFromExtension,
						A3(
							$elm$core$Basics$composeR,
							$elm$core$List$reverse,
							$elm$core$List$take(1),
							A2($elm$core$String$split, '.', filename_)));
					var bytesDownload_ = A3($elm$file$File$Download$bytes, filename_, mimeType_, dataBytes);
					return A2(
						$elm$core$Tuple$pair,
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Page$SolicitarChie$doNotify, 'success', 'download_ok'),
									bytesDownload_
								])));
				} else {
					var error = msg.b.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'download_failed');
					return A2(
						$elm$core$Tuple$pair,
						model,
						('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_));
				}
			case 27:
				if (!msg.a.$) {
					var stringJson = msg.a.a;
					var _v16 = model;
					var vinDropdown = _v16.ad;
					return function (model_) {
						return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
					}(
						_Utils_update(
							model,
							{
								ad: _Utils_update(
									vinDropdown,
									{
										gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
									})
							}));
				} else {
					var error_ = msg.a.a;
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				}
			case 28:
				if (!msg.a.$) {
					var stringJson = msg.a.a;
					var vinDropdown_ = model.ad;
					return function (model_) {
						return A2(
							$elm$core$Tuple$pair,
							model_,
							A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone));
					}(
						_Utils_update(
							model,
							{
								dp: false,
								ad: _Utils_update(
									vinDropdown_,
									{
										gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
									}),
								fX: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
							}));
				} else {
					var error_ = msg.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{dp: false}),
						A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone));
				}
			case 29:
				if (!msg.a.$) {
					var stringJson = msg.a.a;
					var cmdAction_ = A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone);
					var _v17 = model;
					var dealerDropdown = _v17.aP;
					return function (model_) {
						return A2($elm$core$Tuple$pair, model_, cmdAction_);
					}(
						_Utils_update(
							model,
							{
								aP: _Utils_update(
									dealerDropdown,
									{
										gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'distribuidor', $elm$json$Json$Decode$string, stringJson)
									}),
								dn: false
							}));
				} else {
					var error_ = msg.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{dn: false}),
						A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone));
				}
			case 30:
				if (!msg.a.$) {
					var importers = msg.a.a;
					var importerTuple = function (tnant) {
						return A2(
							$elm$core$Tuple$pair,
							tnant,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Helpers$Utilities$tenantInfo(model.cl),
								function ($) {
									return $.dc;
								})(tnant));
					};
					var handleInStock = F2(
						function (inStock, tInfo) {
							return inStock ? (tInfo + ' (en stock)') : tInfo;
						});
					var importers_ = function (importersMap_) {
						return A2($elm$core$List$map, importersMap_, importers);
					}(
						function (tNde) {
							return A2(
								$elm$core$Tuple$mapSecond,
								handleInStock(
									A3($author$project$Csf$TaskNodeUtils$bool, false, 'stock_available', tNde)),
								importerTuple(
									A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', tNde)));
						});
					var model_ = A3(
						$author$project$Helpers$Utilities$updateDropdownOptions,
						$author$project$Page$SolicitarChie$stringFromField(1),
						importers_,
						model);
					var cmdActions_ = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone)
								]),
							function () {
								var _v18 = $elm$core$List$length(importers_);
								if (_v18 === 1) {
									return $elm$core$List$singleton(
										A3(
											$elm$core$Basics$composeR,
											$author$project$Helpers$Utilities$delay(0),
											$elm$core$Platform$Cmd$map(
												$author$project$Page$SolicitarChie$DropdownMsg(1)),
											$author$project$Customized$CustomDropdown$PickedOption(
												A2(
													$elm$core$Maybe$map,
													$elm$core$Tuple$first,
													$elm$core$List$head(importers_)))));
								} else {
									return $elm$core$List$singleton(
										A3(
											$elm$core$Basics$composeR,
											$author$project$Helpers$Utilities$delay(0),
											$elm$core$Platform$Cmd$map(
												$author$project$Page$SolicitarChie$DropdownMsg(1)),
											$author$project$Customized$CustomDropdown$PickedOption(
												A3(
													$elm$core$Basics$composeR,
													$elm$core$List$head,
													$elm$core$Maybe$map($elm$core$Tuple$first),
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$Tuple$second,
															$elm$core$String$endsWith('(en stock)')),
														importers_)))));
								}
							}()));
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model_,
							{bB: false}),
						cmdActions_);
				} else {
					var error_ = msg.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bB: false}),
						A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone));
				}
			case 31:
				if (!msg.a.$) {
					var taskNde = msg.a.a.je;
					var inStock = msg.a.a.h7;
					var excludedKeys_ = _List_fromArray(
						['solicitud_email', 'solicitud_dealer', 'solicitud_dealer_rut', 'solicitud_documentos_numero', 'solicitud_adquiriente_rut', 'solicitud_adquiriente_nombre', 'solicitud_adquiriente_domicilio', 'solicitud_adquiriente_comuna', 'solicitud_documentos_tipo', 'solicitud_documentos_naturaleza', 'solicitud_documentos_lugar', 'solicitud_documentos_fecha', 'solicitud_fecha_solicitud']);
					var filterDict_ = F2(
						function (key_, value_) {
							return A2(
								$elm$core$Basics$composeR,
								$elm$core$List$member(key_),
								$elm$core$Basics$not)(excludedKeys_) && A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strIsValid,
								$elm$core$Basics$not,
								A2(
									$author$project$Csf$Form$strValidator,
									_List_fromArray(
										[$author$project$Csf$Form$Required]),
									$author$project$Csf$Form$strVal(value_)));
						});
					var decodeAsString = F2(
						function (field_, mbValue) {
							return A3(
								$elm$core$Basics$composeR,
								$elm$core$String$trim,
								$author$project$Helpers$Utilities$removeFromString('^null$'),
								function (decoder_) {
									return A3($author$project$Helpers$Utilities$decodeMbValue, '', decoder_, mbValue);
								}(
									A2($elm$json$Json$Decode$field, field_, $author$project$Helpers$Utilities$forceStringDecoder)));
						});
					var dataFromNde_ = function (key_) {
						return A3(
							$author$project$Helpers$Utilities$decodeMbValue,
							'',
							$author$project$Helpers$Utilities$forceStringDecoder,
							A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, inStock));
					};
					var insert__ = A2(
						$elm$core$Basics$composeR,
						dataFromNde_,
						A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $author$project$Csf$Form$strFieldModel));
					var correctFieldsDta = F2(
						function (field_, data_) {
							switch (field_) {
								case 'vin':
									return A3(
										$elm$core$Basics$composeR,
										$elm$core$String$words,
										$elm$core$String$join(''),
										$author$project$Helpers$Utilities$trimmedEmpty(data_) ? dataFromNde(
											_Utils_Tuple2('vehiculo', 'chassis')) : data_);
								case 'tipo_vehiculo':
									return A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Helpers$Utilities$correctTipoVehiculo_,
											$author$project$Helpers$Utilities$mbeTipoDeVehiculo(data_)));
								case 'correo':
									return $author$project$Helpers$Utilities$trimmedToLower(data_);
								case 'domicilio':
									return A2(
										$elm$core$Basics$composeR,
										$elm$core$String$words,
										$elm$core$String$join(' '))(data_);
								default:
									return data_;
							}
						});
					var dataFromNde = function (_v19) {
						var key_ = _v19.a;
						var field_ = _v19.b;
						return A3(
							$elm$core$Basics$composeR,
							decodeAsString(field_),
							correctFieldsDta(field_),
							A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, taskNde));
					};
					var insertDTPicker_ = F3(
						function (key_, tuple_, d) {
							return function (idata) {
								return A3($elm$core$Dict$insert, key_, idata, d);
							}(
								{
									a0: A3(
										$elm$core$Basics$composeR,
										$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
										$elm$core$Result$toMaybe,
										dataFromNde(tuple_)),
									aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$init(
										$author$project$Page$SolicitarChie$DateTimePickerChanged(key_))
								});
						});
					var dateTimePickers_ = A3(
						insertDTPicker_,
						'solicitud_fecha_solicitud--dtpicker',
						_Utils_Tuple2('solicitud', 'fecha_solicitud'),
						A3(
							insertDTPicker_,
							'solicitud_documentos_fecha--dtpicker',
							_Utils_Tuple2('documentos', 'fecha'),
							model.E));
					var insert_ = A2($elm$core$Basics$composeR, dataFromNde, $author$project$Csf$Form$strFieldModel);
					var obtainImporters_ = A3(
						$elm$core$Basics$composeR,
						$author$project$Page$SolicitarChie$ImportersOnDelay,
						$author$project$Helpers$Utilities$delay(0),
						A2(
							$elm$core$Tuple$pair,
							$elm$core$Maybe$Just(
								dataFromNde(
									_Utils_Tuple2('vehiculo', 'vin'))),
							$elm$core$Maybe$Just(
								dataFromNde(
									_Utils_Tuple2('vehiculo', 'marca')))));
					var selectedVhType_ = A3(
						$elm$core$Basics$composeR,
						$author$project$Helpers$Utilities$delay(0),
						$elm$core$Platform$Cmd$map(
							$author$project$Page$SolicitarChie$DropdownMsg(2)),
						A3(
							$elm$core$Basics$composeR,
							$author$project$Helpers$Utilities$stringToMaybe,
							$author$project$Customized$CustomDropdown$PickedOption,
							dataFromNde(
								_Utils_Tuple2('vehiculo', 'tipo_vehiculo'))));
					var cmdActions_ = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[obtainImporters_, selectedVhType_]));
					var anuladoEnStock_ = 'ANULADO' === dataFromNde_('estado_vehiculo');
					var citFromStock_ = $author$project$Csf$Form$strFieldModel(
						anuladoEnStock_ ? '' : dataFromNde_('cit'));
					var solicitudForm_ = A3(
						$elm$core$Dict$insert,
						'solicitud_fecha_solicitud',
						insert_(
							_Utils_Tuple2('solicitud', 'fecha_solicitud')),
						A3(
							$elm$core$Dict$insert,
							'solicitud_documentos_fecha',
							insert_(
								_Utils_Tuple2('documentos', 'fecha')),
							A3(
								$elm$core$Dict$insert,
								'solicitud_documentos_lugar',
								insert_(
									_Utils_Tuple2('documentos', 'lugar')),
								A3(
									$elm$core$Dict$insert,
									'solicitud_documentos_naturaleza',
									insert_(
										_Utils_Tuple2('documentos', 'naturaleza')),
									A3(
										$elm$core$Dict$insert,
										'solicitud_documentos_tipo',
										insert_(
											_Utils_Tuple2('documentos', 'tipo')),
										A3(
											$elm$core$Dict$insert,
											'solicitud_documentos_numero',
											insert_(
												_Utils_Tuple2('documentos', 'numero')),
											A3(
												$elm$core$Dict$insert,
												'solicitud_adquiriente_correo',
												insert_(
													_Utils_Tuple2('adquiriente', 'correo')),
												A3(
													$elm$core$Dict$insert,
													'solicitud_adquiriente_comuna',
													insert_(
														_Utils_Tuple2('adquiriente', 'comuna')),
													A3(
														$elm$core$Dict$insert,
														'solicitud_adquiriente_domicilio',
														insert_(
															_Utils_Tuple2('adquiriente', 'domicilio')),
														A3(
															$elm$core$Dict$insert,
															'solicitud_adquiriente_nombre',
															insert_(
																_Utils_Tuple2('adquiriente', 'nombre')),
															A3(
																$elm$core$Dict$insert,
																'solicitud_adquiriente_rut',
																insert_(
																	_Utils_Tuple2('adquiriente', 'rut')),
																A3(
																	$elm$core$Dict$insert,
																	'solicitud_dealer_rut',
																	insert_(
																		_Utils_Tuple2('documentos', 'rut_emisor')),
																	A3(
																		$elm$core$Dict$insert,
																		'solicitud_dealer',
																		insert_(
																			_Utils_Tuple2('documentos', 'autorizante')),
																		A3(
																			$elm$core$Dict$insert,
																			'solicitud_email',
																			insert_(
																				_Utils_Tuple2('adquiriente', 'correo')),
																			A3(
																				$elm$core$Dict$insert,
																				'solicitud_ppu',
																				insert_(
																					_Utils_Tuple2('vehiculo', 'ppu')),
																				A3(
																					$elm$core$Dict$insert,
																					'solicitud_nro_motor',
																					insert_(
																						_Utils_Tuple2('vehiculo', 'motor')),
																					A3(
																						$elm$core$Dict$insert,
																						'solicitud_modelo',
																						insert_(
																							_Utils_Tuple2('vehiculo', 'modelo')),
																						A3(
																							$elm$core$Dict$insert,
																							'solicitud_color',
																							insert_(
																								_Utils_Tuple2('vehiculo', 'color')),
																							A3(
																								$elm$core$Dict$insert,
																								'solicitud_marca',
																								insert_(
																									_Utils_Tuple2('vehiculo', 'marca')),
																								A3(
																									$elm$core$Dict$insert,
																									'solicitud_peso',
																									insert_(
																										_Utils_Tuple2('vehiculo', 'peso_bruto')),
																									A3(
																										$elm$core$Dict$insert,
																										'solicitud_anno',
																										insert_(
																											_Utils_Tuple2('vehiculo', 'ano')),
																										A3(
																											$elm$core$Dict$insert,
																											'solicitud_vin',
																											insert_(
																												_Utils_Tuple2('vehiculo', 'vin')),
																											A3($elm$core$Dict$insert, 'solicitud_cit', citFromStock_, model.l)))))))))))))))))))))));
					var extractFailed_ = A3(
						$elm$core$Basics$composeR,
						$elm$core$Dict$isEmpty,
						$elm$core$Basics$not,
						A2($elm$core$Dict$filter, filterDict_, solicitudForm_));
					var vhInStockForm_ = anuladoEnStock_ ? model.aj : A3(
						$elm$core$Dict$insert,
						'instock_anno',
						insert__('ano'),
						A3(
							$elm$core$Dict$insert,
							'instock_color',
							insert__('color'),
							A3(
								$elm$core$Dict$insert,
								'instock_vin',
								insert__('vin'),
								A3(
									$elm$core$Dict$insert,
									'instock_cit',
									insert__('cit'),
									A3(
										$elm$core$Dict$insert,
										'instock_nro_motor',
										insert__('motor'),
										A3(
											$elm$core$Dict$insert,
											'instock_tipo_vehiculo',
											insert__('tipo'),
											A3(
												$elm$core$Dict$insert,
												'instock_modelo',
												insert__('modelo'),
												A3(
													$elm$core$Dict$insert,
													'instock_marca',
													insert__('marca'),
													model.aj))))))));
					var warningStripMssg_ = _Utils_eq(inStock, $author$project$TaskNode$emptyTask) ? $author$project$Page$SolicitarChie$moduleMessage('vehicle_notfound') : (anuladoEnStock_ ? $author$project$Page$SolicitarChie$moduleMessage('vehicle_nullyfied') : (extractFailed_ ? $author$project$Page$SolicitarChie$moduleMessage('data_incomplete') : ''));
					return function (model_) {
						return A2($elm$core$Tuple$pair, model_, cmdActions_);
					}(
						_Utils_update(
							model,
							{X: taskNde, E: dateTimePickers_, bl: extractFailed_, $7: false, l: solicitudForm_, fV: inStock, aj: vhInStockForm_, cr: warningStripMssg_}));
				} else {
					var error = msg.a.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{bl: true, $7: false}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitarChie$MetadataLoadDone),
									A2($author$project$Page$SolicitarChie$doNotify, 'error', 'metadata_fail')
								])));
				}
			case 32:
				if (!msg.a.$) {
					var taskNde = msg.a.a;
					var nameFormatMap_ = A2(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$split('.'),
							$elm$core$List$reverse),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							$elm$core$Maybe$withDefault('pdf')));
					var format_ = A2(
						$elm$core$Maybe$withDefault,
						'pdf',
						A2(
							$elm$core$Maybe$map,
							nameFormatMap_,
							A2($author$project$Csf$TaskNodeUtils$mbstring, 'name', taskNde)));
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{X: taskNde}),
						A2(
							$author$project$Route$goTo,
							session.gL,
							function (query_) {
								return $author$project$Route$SolicitarChie(
									{iI: query_});
							}(
								A3(
									$author$project$Route$appendToQuery,
									'format',
									format_,
									A3($author$project$Route$appendToQuery, 'inscription', taskNde.p, model.kX)))));
				} else {
					var error = msg.a.a;
					var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'upload_fail');
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{az: false}),
						('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitarChie$doNotify, 'error', handled_));
				}
			case 33:
				var uploaderMsg = msg.a;
				return A2(
					$author$project$Page$SolicitarChie$handleUploader,
					uploaderMsg,
					A2(
						$elm$core$Tuple$mapFirst,
						function (u) {
							return _Utils_update(
								model,
								{dG: u});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$SolicitarChie$UploaderMsg),
							A2($author$project$Csf$FileUploader$update, uploaderMsg, model.dG))));
			case 34:
				var field_ = msg.a;
				var dropdownMsg = msg.b;
				var onPickedAtion_ = F2(
					function (mbeStr, mdel) {
						var solicitudForm = mdel.l;
						return (field_ !== 2) ? A2($elm$core$Tuple$pair, mdel, $elm$core$Platform$Cmd$none) : function (str) {
							return function (sf) {
								return A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										mdel,
										{l: sf}),
									A2(
										$author$project$Helpers$Utilities$delay,
										0,
										A2($author$project$Page$SolicitarChie$OnSolicitudUpdated, 'solicitud_tipo_vehiculo', str)));
							}(
								A3(
									$elm$core$Dict$insert,
									'solicitud_tipo_vehiculo',
									$author$project$Csf$Form$strFieldModel(str),
									solicitudForm));
						}(
							A2($elm$core$Maybe$withDefault, '', mbeStr));
					});
				var key_ = $author$project$Page$SolicitarChie$stringFromField(field_);
				var dropdownTupleMap = function (_v23) {
					var mdel = _v23.a;
					var cmdAction_ = _v23.b;
					return A2(
						$elm$core$Tuple$pair,
						mdel,
						function () {
							if (field_ === 1) {
								return A2($author$project$Helpers$Utilities$getDropdown, key_, mdel).bj ? $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmdAction_,
											$author$project$Ports$scrollToBottom('solicitar_chie-form')
										])) : cmdAction_;
							} else {
								return cmdAction_;
							}
						}());
				};
				if (!field_) {
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
				} else {
					return dropdownTupleMap(
						A5(
							$author$project$Helpers$Utilities$handleDropdownMssg,
							key_,
							$author$project$Page$SolicitarChie$DropdownMsg(field_),
							dropdownMsg,
							onPickedAtion_,
							model));
				}
			case 35:
				var notifyMsg = msg.a;
				return A2(
					$author$project$Page$SolicitarChie$handleNotifications,
					model,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Page$SolicitarChie$NotificationsMsg),
						A2(
							$author$project$Csf$Notifications$update,
							notifyMsg,
							{a7: model.g$.a7})));
			case 36:
				if (!msg.a) {
					var _v24 = msg.a;
					var dropdownMsg = msg.b;
					return A2(
						$author$project$Page$SolicitarChie$handleVinDropdown,
						dropdownMsg,
						A2(
							$elm$core$Tuple$mapFirst,
							function (dropdown_) {
								return _Utils_update(
									model,
									{ad: dropdown_});
							},
							A2($author$project$Customized$InputDropdown$update, dropdownMsg, model.ad)));
				} else {
					var _v25 = msg.a;
					var dropdownMsg = msg.b;
					return A2(
						$author$project$Page$SolicitarChie$handleDealerDropdown,
						dropdownMsg,
						A2(
							$elm$core$Tuple$mapFirst,
							function (dropdown_) {
								return _Utils_update(
									model,
									{aP: dropdown_});
							},
							A2($author$project$Customized$InputDropdown$update, dropdownMsg, model.aP)));
				}
			default:
				return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$SolicitudesChie$ActualizarPesoDone = function (a) {
	return {$: 7, a: a};
};
var $author$project$Csf$Call$BadBody = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$SolicitudesChie$CloseModal = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$SolicitudesChie$ConciliationDone = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$SolicitudesChie$DateOnQuery = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$DocumentoEliminado = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$SolicitudesChie$ExportXLSDone = function (a) {
	return {$: 46, a: a};
};
var $author$project$Page$SolicitudesChie$ExtendCHIEDone = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$SolicitudesChie$ExtendCHIEUpdateExtensionsDone = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$SolicitudesChie$FilesLoaded = function (a) {
	return {$: 47, a: a};
};
var $author$project$Page$SolicitudesChie$FilterBadgesMsg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Page$SolicitudesChie$FilterOnDelay = function (a) {
	return {$: 34, a: a};
};
var $author$project$Page$SolicitudesChie$GotNowPosix = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$NodeDownloaded = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$NodePagerMsg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Page$SolicitudesChie$NotificationsMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Page$SolicitudesChie$NullifyCHIEDone = F2(
	function (a, b) {
		return {$: 44, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$ParseDatesToISO = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$SolicitudesChie$ReloadModule = {$: 14};
var $author$project$Page$SolicitudesChie$TableMsg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Page$SolicitudesChie$ToggleErrorTooltip = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$SolicitudesChie$TransitioningOFF = function (a) {
	return {$: 41, a: a};
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Config$ApiEndpoint$anularchie = F3(
	function (tenant_, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-request-service', 'request-service', tenant_, 'request', unique_id, 'cancel']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$anularCHIE = F4(
	function (ticket_, tenant_, unique_id, jsonPayload) {
		return function (endpoint_) {
			return A3(
				$author$project$Helpers$ApiHandler$post,
				endpoint_,
				_List_Nil,
				$elm$http$Http$jsonBody(jsonPayload));
		}(
			A3($author$project$Config$ApiEndpoint$anularchie, tenant_, unique_id, ticket_));
	});
var $author$project$Config$ApiEndpoint$anularExtensionChie = function (ticket_) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['chie-extension-service', 'api', 'extensions', 'annul']),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
			]));
};
var $author$project$Helpers$ApiHandler$anularExtensionCHIE = F2(
	function (ticket_, jsonPayload) {
		return function (endpoint_) {
			return A3(
				$author$project$Helpers$ApiHandler$post,
				endpoint_,
				_List_Nil,
				$elm$http$Http$jsonBody(jsonPayload));
		}(
			$author$project$Config$ApiEndpoint$anularExtensionChie(ticket_));
	});
var $author$project$Page$SolicitudesChie$boolModuleRemove = F2(
	function (key_, model) {
		var moduleBools = model.bu;
		return _Utils_update(
			model,
			{
				bu: A2($elm$core$Dict$remove, key_, moduleBools)
			});
	});
var $author$project$Page$SolicitudesChie$boolToModule = F3(
	function (key_, bool_, model) {
		var moduleBools = model.bu;
		return _Utils_update(
			model,
			{
				bu: A3($elm$core$Dict$insert, key_, bool_, moduleBools)
			});
	});
var $author$project$Helpers$ExtensionsUtils$getActiveExtensions = function (taskNode_) {
	return A2(
		$elm$core$List$filter,
		function (ext) {
			return ext.gl === 'aprobado';
		},
		$author$project$Helpers$ExtensionsUtils$decodeExtensions(taskNode_));
};
var $justinmimbs$date$Date$Years = 0;
var $elm$core$String$reverse = _String_reverse;
var $author$project$Page$SolicitudesChie$getChieDueDate = function (taskNode_) {
	var patente_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'patente', taskNode_);
	var patenteLastCharacter = A3(
		$elm$core$String$slice,
		0,
		1,
		$elm$core$String$reverse(patente_));
	var monthOfValidity = function () {
		switch (patenteLastCharacter) {
			case '9':
				return '01';
			case '0':
				return '02';
			case '1':
				return '04';
			case '2':
				return '05';
			case '3':
				return '06';
			case '4':
				return '07';
			case '5':
				return '08';
			case '6':
				return '09';
			case '7':
				return '10';
			case '8':
				return '11';
			default:
				return '';
		}
	}();
	var getYearFromDate = function (date_) {
		return A3($elm$core$String$slice, 0, 4, date_);
	};
	var fecha_emision_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'fecha_emision_chie', taskNode_);
	var getMonthFromFechaEmision = A3($elm$core$String$slice, 5, 7, fecha_emision_);
	var yearOfValidity = function () {
		var yearsToAdd = (_Utils_cmp(getMonthFromFechaEmision, monthOfValidity) > 0) ? 3 : 2;
		var onlyDatePart = A2(
			$elm$core$Maybe$withDefault,
			fecha_emision_,
			$elm$core$List$head(
				A2($elm$core$String$split, 'T', fecha_emision_)));
		var newDate = getYearFromDate(
			$justinmimbs$date$Date$toIsoString(
				A3(
					$justinmimbs$date$Date$add,
					0,
					yearsToAdd,
					A2(
						$elm$core$Result$withDefault,
						A3($justinmimbs$date$Date$fromCalendarDate, 2026, 0, 1),
						$justinmimbs$date$Date$fromIsoString(onlyDatePart)))));
		return newDate;
	}();
	return ((patente_ === '') || (fecha_emision_ === '')) ? '' : _Utils_ap(yearOfValidity, monthOfValidity);
};
var $author$project$Page$SolicitudesChie$calculateNewDueDate = function (taskNode_) {
	var originalDueDate = $author$project$Page$SolicitudesChie$getChieDueDate(taskNode_);
	var activeExtensions = $author$project$Helpers$ExtensionsUtils$getActiveExtensions(taskNode_);
	var baseDate = $elm$core$List$isEmpty(activeExtensions) ? originalDueDate : A3(
		$elm$core$String$slice,
		0,
		6,
		A3(
			$elm$core$String$replace,
			'/',
			'',
			A3(
				$elm$core$String$replace,
				'-',
				'',
				A2(
					$elm$core$Maybe$withDefault,
					originalDueDate,
					$elm$core$List$head(
						A2(
							$elm$core$String$split,
							'T',
							A2(
								$elm$core$Maybe$withDefault,
								originalDueDate,
								A2(
									$elm$core$Maybe$map,
									function (ext) {
										return ext.j9;
									},
									$elm$core$List$head(activeExtensions)))))))));
	var newDate = function () {
		var year_ = $elm$core$String$fromInt(
			1 + A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A3($elm$core$String$slice, 0, 4, baseDate))));
		var month_ = A3($elm$core$String$slice, 4, 6, baseDate);
		return _Utils_ap(year_, month_);
	}();
	return (originalDueDate === '') ? '' : newDate;
};
var $author$project$Config$ApiEndpoint$nodechildremove = F3(
	function (parent_node, unique_id, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['nodeservice', 'parent', parent_node, 'child', unique_id]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$desasociarNode = F3(
	function (ticket_, parent_node, child_node) {
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$TaskNode$emptyTask, $author$project$Csf$AlbertoApi$decoderTaskNode),
			function (service_) {
				return A2(
					$author$project$Helpers$ApiHandler$delete,
					service_,
					_List_fromArray(
						[
							A2($elm$http$Http$header, 'Content-Type', 'application/json')
						]));
			}(
				A3($author$project$Config$ApiEndpoint$nodechildremove, parent_node, child_node, ticket_)));
	});
var $author$project$Page$SolicitudesChie$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('head_details', 'Detalles de Solicitud'),
		_Utils_Tuple2('card_title_loaded', 'Solicitudes'),
		_Utils_Tuple2('tab_extension', 'Extensión CHI-e'),
		_Utils_Tuple2('export_ok', 'Se ha exportado el excel exitosamente.'),
		_Utils_Tuple2('export_failed', 'Lo sentimos, ha ocurrido un error en la exportación.'),
		_Utils_Tuple2('export_filename', 'Solicitudes_de_chie.xlsx'),
		_Utils_Tuple2('download_failed', 'Lo sentimos, ha ocurrido un error en la descarga del documento.'),
		_Utils_Tuple2('nullify_ok', 'Se ha completado el proceso de anulación satisfactoriamente.'),
		_Utils_Tuple2('nullify_failed', 'Ha ocurrido un error durante el proceso de anulación.'),
		_Utils_Tuple2('conciliate_ok', 'La conciliación se ha reenviado exitosamente.'),
		_Utils_Tuple2('conciliate_partial_ok', 'Varias solicitudes no han sido reenviadas a conciliación.'),
		_Utils_Tuple2('conciliate_failed', 'Lo sentimos, ha ocurrido un error en el reenvío de la conciliación.'),
		_Utils_Tuple2('no_requests_available', 'No existen solicitudes disponibles para Conciliar.'),
		_Utils_Tuple2('no_requests_selected', 'No es posible Conciliar, debe seleccionar al menos una solicitud.'),
		_Utils_Tuple2('files_empty', 'No existen Solicitudes'),
		_Utils_Tuple2('files_load_failed', 'No ha sido posible listar los solicitudes'),
		_Utils_Tuple2('file_details_failed', 'Lo sentimos, ha ocurrido un error obteniendo los detalles de la solicitud.'),
		_Utils_Tuple2('file_documents_empty', 'No se encontraron documentos asociados.'),
		_Utils_Tuple2('file_documents_failed', 'Ha ocurrido un error obteniendo los documentos asociados a la solicitud.'),
		_Utils_Tuple2('file_history_empty', 'No se encontraron tareas en el historial.'),
		_Utils_Tuple2('file_history_failed', 'Ha ocurrido un error obteniendo el historial de la solicitud.'),
		_Utils_Tuple2('deassociate_confirm_message', 'Está seguro que desea eliminar este documento. Tome en consideración que esta operación es '),
		_Utils_Tuple2('deassociate_succeed', '¡Enhorabuena! El documento seleccionado ha sido eliminado satisfactoriamente.'),
		_Utils_Tuple2('deassociate_failed', '¡Lo sentimos! Ha ocurrido un error al eliminar el documento seleccionado.'),
		_Utils_Tuple2('extend_chie_confirm_title', 'Extensión de vigencia del CHI-e'),
		_Utils_Tuple2('extend_chie_confirm_message', 'Confirme que desea extender la vigencia del CHI-e por un periodo adicional de 12 meses.'),
		_Utils_Tuple2('extend_chie_success_message', '¡Se ha creado exitosamente la solicitud!'),
		_Utils_Tuple2('extend_chie_success_detail', 'El representante legal de la importadora debe firmar el nuevo CHI-e.'),
		_Utils_Tuple2('extend_chie_ok', 'Se ha extendido la vigencia del CHI-e exitosamente.'),
		_Utils_Tuple2('extend_chie_failed', 'No es posible extender el CHI-e. Excede el periodo autorizado de 2 años.')
	]);
var $author$project$Page$SolicitudesChie$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_),
			$author$project$Page$SolicitudesChie$moduleCaptions_));
};
var $author$project$Page$SolicitudesChie$doNotify = function (type_) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$SolicitudesChie$moduleMessage,
		A2($author$project$Helpers$Utilities$setNotification, $author$project$Page$SolicitudesChie$NotificationsMsg, type_));
};
var $author$project$Config$ApiEndpoint$conciliarchie = F2(
	function (ticket_, tenant_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-request-service', 'request-service', tenant_, 'request', 'conciliate']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$enviarAConciliacion = F3(
	function (ticket_, tenant_, jsonPayload) {
		return function (endpoint_) {
			return A3(
				$author$project$Helpers$ApiHandler$post,
				endpoint_,
				_List_Nil,
				$elm$http$Http$jsonBody(jsonPayload));
		}(
			A2($author$project$Config$ApiEndpoint$conciliarchie, ticket_, tenant_));
	});
var $author$project$Helpers$ApiHandler$exportarCHIE = F3(
	function (ticket_, tenant_, query_) {
		return $elm$http$Http$task(
			{
				h: $elm$http$Http$jsonBody(
					$author$project$ElasticSearch$encodeQuery(query_)),
				i: _List_Nil,
				j: 'POST',
				k: $author$project$Csf$Call$bytesResolver,
				m: $elm$core$Maybe$Nothing,
				q: A3($author$project$Config$ApiEndpoint$exportarreporte, tenant_, 'files', ticket_)
			});
	});
var $author$project$Helpers$ApiHandler$ExtenderChieResponse = F2(
	function (unique_id, data) {
		return {r: data, jr: unique_id};
	});
var $author$project$Helpers$ApiHandler$decodeExtenderChieResponseDecoder = A2(
	$elm$json$Json$Decode$field,
	'response',
	A2(
		$elm$json$Json$Decode$field,
		'payload',
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Helpers$ApiHandler$ExtenderChieResponse,
			A2($elm$json$Json$Decode$field, 'unique_id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))));
var $author$project$Helpers$ApiHandler$decodeExtenderChieResponse = function (responseString) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Helpers$ApiHandler$decodeExtenderChieResponseDecoder, responseString);
	if (!_v0.$) {
		var value = _v0.a;
		return value;
	} else {
		return {r: $elm$json$Json$Encode$null, jr: ''};
	}
};
var $author$project$Helpers$ApiHandler$extendCHIE = F3(
	function (ticket_, tenant_, _v0) {
		var uuid_expediente_ = _v0.jt;
		var numero_extension_ = _v0.it;
		var solicitante_email_ = _v0.i1;
		var solicitante_ = _v0.i0;
		var motor_ = _v0.im;
		var anno_ = _v0.hn;
		var color_ = _v0.hx;
		var tipo_ = _v0.jh;
		var modelo_ = _v0.ik;
		var patente_ = _v0.iz;
		var vin_ = _v0.jv;
		var marca_ = _v0.ij;
		var fecha_vigencia_chie_ = _v0.hT;
		var fecha_vigencia_chie_xml_ = _v0.hU;
		var cliente_correo_ = _v0.hv;
		var distribuidor_ = _v0.hH;
		var cit_ = _v0.hu;
		var fecha_solicitud_ = _v0.hS;
		var payload = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'uuid_expediente_chie',
						$elm$json$Json$Encode$string(uuid_expediente_)),
						_Utils_Tuple2(
						'numero_extension',
						$elm$json$Json$Encode$int(numero_extension_)),
						_Utils_Tuple2(
						'estado_chie',
						$elm$json$Json$Encode$string('solicitud_registrada')),
						_Utils_Tuple2(
						'solicitante_email',
						$elm$json$Json$Encode$string(solicitante_email_)),
						_Utils_Tuple2(
						'solicitante',
						$elm$json$Json$Encode$string(solicitante_)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('Extension CHI-e')),
						_Utils_Tuple2(
						'motor',
						$elm$json$Json$Encode$string(motor_)),
						_Utils_Tuple2(
						'ano',
						$elm$json$Json$Encode$int(anno_)),
						_Utils_Tuple2(
						'color',
						$elm$json$Json$Encode$string(color_)),
						_Utils_Tuple2(
						'tipo',
						$elm$json$Json$Encode$string(tipo_)),
						_Utils_Tuple2(
						'modelo',
						$elm$json$Json$Encode$string(modelo_)),
						_Utils_Tuple2(
						'patente',
						$elm$json$Json$Encode$string(patente_)),
						_Utils_Tuple2(
						'marca',
						$elm$json$Json$Encode$string(marca_)),
						_Utils_Tuple2(
						'vin',
						$elm$json$Json$Encode$string(vin_)),
						_Utils_Tuple2(
						'fecha_vigencia_chie',
						$elm$json$Json$Encode$string(fecha_vigencia_chie_)),
						_Utils_Tuple2(
						'fecha_vigencia_chie_xml',
						$elm$json$Json$Encode$string(fecha_vigencia_chie_xml_)),
						_Utils_Tuple2(
						'cliente_correo',
						$elm$json$Json$Encode$string(cliente_correo_)),
						_Utils_Tuple2(
						'distribuidor',
						$elm$json$Json$Encode$string(distribuidor_)),
						_Utils_Tuple2(
						'cit',
						$elm$json$Json$Encode$string(cit_)),
						_Utils_Tuple2(
						'fecha_solicitud',
						$elm$json$Json$Encode$string(fecha_solicitud_))
					])));
		return A2(
			$elm$core$Task$map,
			$author$project$Helpers$ApiHandler$decodeExtenderChieResponse,
			A3(
				$author$project$Helpers$ApiHandler$post,
				A3($author$project$Config$ApiEndpoint$nodecreate, tenant_, 'expediente_chie_extension', ticket_),
				_List_Nil,
				payload));
	});
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Page$SolicitudesChie$extenderResponseToExtensionValue = function (response_) {
	var dataString_ = function (key_) {
		return A2(
			$elm$core$Result$withDefault,
			'',
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, key_, $elm$json$Json$Decode$string),
				response_.r));
	};
	var dataMaybeString_ = function (key_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$json$Json$Decode$decodeValue,
					A2(
						$elm$json$Json$Decode$field,
						key_,
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
					response_.r)));
	};
	var dataInt_ = function (key_) {
		return A2(
			$elm$core$Result$withDefault,
			0,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, key_, $elm$json$Json$Decode$int),
				response_.r));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid_extension',
				$elm$json$Json$Encode$string(response_.jr)),
				_Utils_Tuple2(
				'solicitante',
				$elm$json$Json$Encode$string(
					dataString_('solicitante_email'))),
				_Utils_Tuple2(
				'numero_extension',
				$elm$json$Json$Encode$int(
					dataInt_('numero_extension'))),
				_Utils_Tuple2(
				'fecha_vencimiento_extension',
				$elm$json$Json$Encode$string(
					dataString_('fecha_vigencia_chie_xml'))),
				_Utils_Tuple2(
				'fecha_solicitud_extension',
				$elm$json$Json$Encode$string(
					dataString_('fecha_solicitud'))),
				_Utils_Tuple2(
				'fecha_emision_extension',
				$elm$json$Json$Encode$string(
					dataMaybeString_('fecha_emision_extension'))),
				_Utils_Tuple2(
				'estado_general',
				$elm$json$Json$Encode$string('en_proceso')),
				_Utils_Tuple2(
				'estado_chie',
				$elm$json$Json$Encode$string(
					dataString_('estado_chie'))),
				_Utils_Tuple2(
				'correlativo',
				$elm$json$Json$Encode$string(''))
			]));
};
var $author$project$Page$SolicitudesChie$extensionDataToValue = function (ext_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'uuid_extension',
				$elm$json$Json$Encode$string(ext_.ls)),
				_Utils_Tuple2(
				'solicitante',
				$elm$json$Json$Encode$string(ext_.k8)),
				_Utils_Tuple2(
				'numero_extension',
				$elm$json$Json$Encode$int(ext_.kQ)),
				_Utils_Tuple2(
				'fecha_vencimiento_extension',
				$elm$json$Json$Encode$string(ext_.j9)),
				_Utils_Tuple2(
				'fecha_solicitud_extension',
				$elm$json$Json$Encode$string(ext_.j8)),
				_Utils_Tuple2(
				'fecha_emision_extension',
				$elm$json$Json$Encode$string(ext_.j7)),
				_Utils_Tuple2(
				'estado_general',
				$elm$json$Json$Encode$string(ext_.gl)),
				_Utils_Tuple2(
				'estado_chie',
				$elm$json$Json$Encode$string(ext_.j0)),
				_Utils_Tuple2(
				'correlativo',
				$elm$json$Json$Encode$string(ext_.jR)),
				_Utils_Tuple2(
				'fecha_anulacion_extension',
				$elm$json$Json$Encode$string(ext_.j6)),
				_Utils_Tuple2(
				'anulado_por_nombre',
				$elm$json$Json$Encode$string(ext_.jD)),
				_Utils_Tuple2(
				'motivo_anulacion',
				$elm$json$Json$Encode$string(ext_.kC)),
				_Utils_Tuple2(
				'causa_anulacion',
				$elm$json$Json$Encode$string(ext_.jL)),
				_Utils_Tuple2(
				'anulado_por_usuario',
				$elm$json$Json$Encode$string(ext_.jE))
			]));
};
var $author$project$Page$SolicitudesChie$extractErrorMessage = function (error) {
	var decodeErrorBody = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (msg, probs) {
				return {bt: msg, iF: probs};
			}),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'conciliation_problems',
				$elm$json$Json$Decode$list(
					A2($elm$json$Json$Decode$field, 'descripcion', $elm$json$Json$Decode$string)))));
	var buildErrorMessage = function (bodyJson) {
		var _v1 = A2($elm$json$Json$Decode$decodeString, decodeErrorBody, bodyJson);
		if (!_v1.$) {
			var message = _v1.a.bt;
			var problems = _v1.a.iF;
			var problemLines = function () {
				if (!problems.$) {
					var probs = problems.a;
					return A2(
						$elm$core$List$map,
						function (desc) {
							return '- ' + desc;
						},
						probs);
				} else {
					return _List_Nil;
				}
			}();
			var messageLines = function () {
				if (!message.$) {
					var msg = message.a;
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(msg)) ? _List_Nil : _List_fromArray(
						[msg]);
				} else {
					return _List_Nil;
				}
			}();
			var allLines = _Utils_ap(messageLines, problemLines);
			return $elm$core$List$isEmpty(allLines) ? $author$project$Page$SolicitudesChie$moduleMessage('nullify_failed') : A2($elm$core$String$join, '\n', allLines);
		} else {
			return $author$project$Page$SolicitudesChie$moduleMessage('nullify_failed');
		}
	};
	switch (error.$) {
		case 4:
			var bodyJson = error.b;
			return buildErrorMessage(bodyJson);
		case 5:
			var bodyJson = error.a;
			return buildErrorMessage(bodyJson);
		default:
			return $author$project$Page$SolicitudesChie$moduleMessage('nullify_failed');
	}
};
var $author$project$Page$SolicitudesChie$GotNodeDocuments = function (a) {
	return {$: 49, a: a};
};
var $author$project$Page$SolicitudesChie$fileNodeDocuments = F2(
	function (ticket_, tNde) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Page$SolicitudesChie$GotNodeDocuments,
			A3(
				$author$project$Helpers$ApiHandler$childrenFromNode,
				ticket_,
				A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', tNde),
				tNde.p));
	});
var $author$project$Page$SolicitudesChie$GotNodeTaskHistory = function (a) {
	return {$: 50, a: a};
};
var $author$project$Page$SolicitudesChie$fileNodeTaskHistory = F2(
	function (ticket_, tNde) {
		var id = tNde.p;
		var properties = tNde.dm;
		var ids_ = A2(
			$elm$core$List$cons,
			id,
			A2(
				$elm$core$List$map,
				function (e) {
					return e.ls;
				},
				$author$project$Helpers$ExtensionsUtils$decodeExtensions(tNde)));
		return A2(
			$elm$core$Task$attempt,
			$author$project$Page$SolicitudesChie$GotNodeTaskHistory,
			A2($author$project$Helpers$ApiHandler$historialExtendedEnWorkflow, ticket_, ids_));
	});
var $author$project$Helpers$Utilities$regexFind = function (regex_) {
	return $elm$regex$Regex$find(
		$author$project$Helpers$Utilities$customRegex(regex_));
};
var $author$project$Helpers$Utilities$handleSearchPPU_ = function (stringPPU_) {
	var undotPPU_ = A3($elm$core$String$replace, '.', '', stringPPU_);
	var _v0 = A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(0, ''),
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var match = _v1.kw;
				var index = _v1.gv;
				return A2($elm$core$Tuple$pair, index, match);
			},
			$elm$core$List$head(
				A2($author$project$Helpers$Utilities$regexFind, '([0-9]+)', undotPPU_))));
	var index_ = _v0.a;
	var match_ = _v0.b;
	var joinStrData = function (joined) {
		return _Utils_ap(
			joined + '-',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					$elm$core$String$toInt(match_))));
	};
	return (0 < index_) ? joinStrData(
		A3(
			$elm$core$String$replace,
			'-',
			'',
			A3(
				$elm$core$Basics$composeR,
				$elm$core$List$take(1),
				$elm$core$String$join(''),
				A2($elm$core$String$split, match_, undotPPU_)))) : undotPPU_;
};
var $author$project$Page$SolicitudesChie$filtersFromQuery = function (queryData) {
	var toWildcard = F2(
		function (field_, data_) {
			return A3(
				$elm$core$Basics$composeR,
				$author$project$ElasticSearch$string,
				$author$project$ElasticSearch$wildcard(field_),
				'*' + (data_ + '*'));
		});
	var mbeDtaMap = F2(
		function (key_, value_) {
			if ($author$project$Helpers$Utilities$trimmedEmpty(value_)) {
				return _List_Nil;
			} else {
				switch (key_) {
					case 'vin':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('vin'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'cit':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('cit'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'motor':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('motor'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'anno':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('ano'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'color':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('color'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'marca':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('marca'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'modelo':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('modelo'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'tipo_vehiculo':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('tipo'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'correlativo':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('correlativo'),
							$elm$core$List$singleton,
							$author$project$Helpers$Utilities$trimmedToUpper(value_));
					case 'dealer':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('distribuidor'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'importer':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('tenant'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'conciliate':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$term('estado_conciliacion_mtt'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'estado':
						return A3(
							$elm$core$Basics$composeR,
							$author$project$ElasticSearch$match('estado_chie'),
							$elm$core$List$singleton,
							$author$project$ElasticSearch$string(value_));
					case 'patente':
						return A3(
							$elm$core$Basics$composeR,
							toWildcard('patente'),
							$elm$core$List$singleton,
							A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedToUpper, $author$project$Helpers$Utilities$handleSearchPPU_)(value_));
					case 'applicant':
						return $elm$core$List$singleton(
							A2(toWildcard, 'solicitante', value_));
					default:
						return _List_Nil;
				}
			}
		});
	var queryDtaMap = function (key_) {
		return A2(
			$elm$core$Maybe$map,
			mbeDtaMap(key_),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Route$dataFromQuery(key_),
				$elm$core$Maybe$Just)(queryData));
	};
	var excluded_keys = _List_fromArray(
		['fechaini', 'fechafin', 'emisionfini', 'emisionffin']);
	var queryData_ = function (filter_) {
		return A2($elm$core$Dict$filter, filter_, queryData);
	}(
		F2(
			function (key_, _v1) {
				return A2(
					$elm$core$Basics$composeR,
					$elm$core$List$member(key_),
					$elm$core$Basics$not)(excluded_keys);
			}));
	var dataTrimmed = function (key_) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Route$dataFromQuery(key_),
			$elm$core$String$trim)(queryData);
	};
	var appendRange = F2(
		function (_v0, field_) {
			var start_key = _v0.a;
			var end_key = _v0.b;
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$appendDateRange(field_),
				$elm$core$List$singleton,
				_Utils_Tuple2(
					dataTrimmed(start_key),
					dataTrimmed(end_key)));
		});
	return A4(
		$author$project$Helpers$Utilities$handleQueryFilter,
		true,
		queryDtaMap,
		queryData_,
		_Utils_ap(
			A2(
				appendRange,
				_Utils_Tuple2('fechaini', 'fechafin'),
				'inserted_at'),
			A2(
				appendRange,
				_Utils_Tuple2('emisionfini', 'emisionffin'),
				'fecha_emision_chie')));
};
var $korutx$elm_rut$Rut$ThousandsSeparated = 0;
var $author$project$Helpers$Utilities$formatRut = A2(
	$elm$core$Basics$composeR,
	$korutx$elm_rut$Rut$format(0),
	$elm$core$Maybe$withDefault(''));
var $author$project$Csf$TaskNodeUtils$fullName = function (node_) {
	return function (t) {
		return (t === '') ? A3($author$project$Csf$TaskNodeUtils$datastring, '', 'username', node_) : t;
	}(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'nombre', node_),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'apellido', node_),
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'segundoApellido', node_)
				])));
};
var $author$project$Helpers$Utilities$getDtePicker = F2(
	function (key_, _v0) {
		var moduleDatePickers = _v0.gI;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$DatePicker$init.a,
			A2($elm$core$Dict$get, key_, moduleDatePickers));
	});
var $author$project$Page$SolicitudesChie$getEntireDate = function (yyyymm) {
	var yearStr = A3($elm$core$String$slice, 0, 4, yyyymm);
	var year = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(yearStr));
	var monthStr = A3($elm$core$String$slice, 4, 6, yyyymm);
	var month = A2(
		$elm$core$Maybe$withDefault,
		1,
		$elm$core$String$toInt(monthStr));
	var isLeapYear = function (y) {
		return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
	};
	var daysInMonth = F2(
		function (m, y) {
			switch (m) {
				case 2:
					return isLeapYear(y) ? '29' : '28';
				case 4:
					return '30';
				case 6:
					return '30';
				case 9:
					return '30';
				case 11:
					return '30';
				default:
					return '31';
			}
		});
	var lastDay = A2(daysInMonth, month, year);
	return yearStr + ('/' + (monthStr + ('/' + lastDay)));
};
var $author$project$Helpers$ExtensionsUtils$getInProcessExtensions = function (taskNode_) {
	return A2(
		$elm$core$List$filter,
		function (ext) {
			return ext.gl === 'en_proceso';
		},
		$author$project$Helpers$ExtensionsUtils$decodeExtensions(taskNode_));
};
var $author$project$Helpers$Utilities$getModuleDate = F2(
	function (key_, _v0) {
		var moduleDates = _v0.gJ;
		return A2($elm$core$Dict$get, key_, moduleDates);
	});
var $author$project$Page$SolicitudesChie$nodeDetailsRoute = function (taskNode) {
	var node_tenant = A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', taskNode);
	var addToQuery = function (file_uuid_) {
		return A3($author$project$Route$appendToQuery, 'file_uuid', file_uuid_, $author$project$Route$emptyData.iI);
	};
	return function (query_) {
		return $author$project$Route$SolicitudesChie(
			{iI: query_});
	}(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$join(':'),
			addToQuery)(
			_List_fromArray(
				[node_tenant, taskNode.p])));
};
var $author$project$Page$SolicitudesChie$handleExpedienteDetails = F2(
	function (taskNode, model) {
		var session = model.g$;
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Route$goTo(session.gL),
			$elm$core$Tuple$pair(model),
			$author$project$Page$SolicitudesChie$nodeDetailsRoute(taskNode));
	});
var $author$project$TaskNode$insertedAt = $author$project$TaskNode$string('inserted_at');
var $author$project$TaskNode$insertedAtWithDefault = F2(
	function (default_, props) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			$author$project$TaskNode$insertedAt(props));
	});
var $author$project$TaskNode$insertedAtOrEmpty = $author$project$TaskNode$insertedAtWithDefault('');
var $author$project$Page$SolicitudesChie$isValidIntPeso = function (data_) {
	var _v0 = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$toInt)(data_);
	if (!_v0.$) {
		var n = _v0.a;
		return n > 0;
	} else {
		return false;
	}
};
var $author$project$Page$SolicitudesChie$keyQueryFromField = function (field_) {
	switch (field_) {
		case 1:
			return 'vin';
		case 2:
			return 'cit';
		case 3:
			return 'patente';
		case 5:
			return 'correlativo';
		default:
			return '';
	}
};
var $author$project$Config$ApiEndpoint$chieallfiles = F4(
	function (from_, size_, sort_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-search-service', 'search-service', 'files', 'all', 'from', from_, 'size', size_, 'sort', sort_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$listarExpedientes = F4(
	function (ticket_, sorter_, _v0, query_) {
		var from_ = _v0.a;
		var size_ = _v0.b;
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$Helpers$ApiHandler$emptySearchResp, $author$project$Helpers$ApiHandler$taskManagerDecoder),
			A3(
				$author$project$Helpers$ApiHandler$post,
				A4($author$project$Config$ApiEndpoint$chieallfiles, from_, size_, sorter_, ticket_),
				_List_Nil,
				$elm$http$Http$jsonBody(
					$author$project$ElasticSearch$encodeQuery(query_))));
	});
var $author$project$TaskNode$name = $author$project$TaskNode$string('name');
var $author$project$TaskNode$nameWithDefault = F2(
	function (default_, props) {
		return A2(
			$elm$core$Maybe$withDefault,
			default_,
			$author$project$TaskNode$name(props));
	});
var $author$project$TaskNode$nameOrEmpty = $author$project$TaskNode$nameWithDefault('');
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Helpers$Utilities$retrieveFromLocalStorage = function (key_) {
	return $author$project$Helpers$Utilities$handleLocalStorage_(
		_List_fromArray(
			[
				A2($elm$core$Tuple$pair, 'key', key_),
				A2($elm$core$Tuple$pair, 'action', 'retrieve')
			]));
};
var $author$project$Ports$scrollGrandToBottom = _Platform_outgoingPort('scrollGrandToBottom', $elm$json$Json$Encode$string);
var $author$project$Page$SolicitudesChie$updateQueryFromDropdown = F3(
	function (queryKey, mbString, model) {
		var session = model.g$;
		var queryData = model.kX;
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Route$goTo(session.gL),
			$elm$core$Tuple$pair(model),
			function (query_) {
				return $author$project$Route$SolicitudesChie(
					{iI: query_});
			}(
				function () {
					if (!mbString.$) {
						var string_ = mbString.a;
						return A3($author$project$Route$appendToQuery, queryKey, string_, queryData);
					} else {
						return A2($author$project$Route$removeFromQuery, queryKey, queryData);
					}
				}()));
	});
var $author$project$Page$SolicitudesChie$verifyNewDueDate = F2(
	function (taskNode_, newDueDate) {
		var originalChieDate = $author$project$Page$SolicitudesChie$getChieDueDate(taskNode_);
		var maxDueDate = function () {
			var year_ = $elm$core$String$fromInt(
				2 + A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(
						A3($elm$core$String$slice, 0, 4, originalChieDate))));
			var month_ = A3($elm$core$String$slice, 4, 6, originalChieDate);
			return _Utils_ap(year_, month_);
		}();
		return (originalChieDate === '') ? false : (_Utils_cmp(newDueDate, maxDueDate) < 1);
	});
var $author$project$Page$SolicitudesChie$update = F2(
	function (mssg_, model) {
		var session = model.g$;
		var moduleDashlets = model.eO;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		_v0$73:
		while (true) {
			_v0$75:
			while (true) {
				switch (mssg_.$) {
					case 1:
						var title = mssg_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ch: $author$project$Csf$Modal$shown, ci: title}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var motivoDropdown_ = A2(
							$author$project$Helpers$Utilities$getDropdown,
							$author$project$Page$SolicitudesChie$stringFromField(4),
							model);
						var hasActiveExtensions_ = !$elm$core$List$isEmpty(
							$author$project$Helpers$ExtensionsUtils$getActiveExtensions(model.b));
						var extId_ = A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.ls;
								},
								$elm$core$List$head(
									$elm$core$List$reverse(
										$author$project$Helpers$ExtensionsUtils$getActiveExtensions(model.b)))));
						var _v1 = _Utils_Tuple2(
							model.b.p,
							A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
						var unique_id = _v1.a;
						var tenant_ = _v1.b;
						var _v2 = function (dropboxField) {
							return _Utils_Tuple2(
								$author$project$Customized$CustomDropdown$isValidDropbox(dropboxField),
								dropboxField);
						}(
							A2($author$project$Customized$CustomDropdown$validateRequired, true, motivoDropdown_));
						var isValidMotive = _v2.a;
						var dropdown_ = _v2.b;
						var _v3 = function () {
							var _v4 = $author$project$Customized$CustomDropdown$selectedOption(motivoDropdown_);
							if (_v4 === 'Otro') {
								return function (strField_) {
									return _Utils_Tuple2(
										$author$project$Csf$Form$strIsValid(strField_),
										strField_);
								}(
									A2(
										$author$project$Csf$Form$strValidator,
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										$author$project$Csf$Form$strVal(model.Q)));
							} else {
								return _Utils_Tuple2(true, model.Q);
							}
						}();
						var isValidCause = _v3.a;
						var causeField = _v3.b;
						var model_ = A3(
							$author$project$Helpers$Utilities$updateDropdown,
							$author$project$Page$SolicitudesChie$stringFromField(4),
							dropdown_,
							_Utils_update(
								model,
								{Q: causeField, bw: isValidMotive && isValidCause}));
						return A2(
							$elm$core$Tuple$pair,
							model_,
							(isValidMotive && isValidCause) ? A2(
								$elm$core$Task$attempt,
								$author$project$Page$SolicitudesChie$NullifyCHIEDone(
									hasActiveExtensions_ ? 'anull_ext' : 'anull_chie'),
								hasActiveExtensions_ ? A2(
									$author$project$Helpers$ApiHandler$anularExtensionCHIE,
									ticket_,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'unique_id',
												$elm$json$Json$Encode$string(extId_)),
												_Utils_Tuple2(
												'causa_anulacion',
												$elm$json$Json$Encode$string(
													$author$project$Csf$Form$strVal(model.Q))),
												_Utils_Tuple2(
												'motivo_anulacion',
												$elm$json$Json$Encode$string(
													$author$project$Customized$CustomDropdown$selectedOption(motivoDropdown_)))
											]))) : A4(
									$author$project$Helpers$ApiHandler$anularCHIE,
									ticket_,
									tenant_,
									unique_id,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'observations',
												$elm$json$Json$Encode$string(
													$author$project$Csf$Form$strVal(model.Q))),
												_Utils_Tuple2(
												'reason',
												$elm$json$Json$Encode$string(
													$author$project$Customized$CustomDropdown$selectedOption(motivoDropdown_)))
											])))) : $elm$core$Platform$Cmd$none);
					case 3:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{b_: $author$project$Csf$Modal$shown}),
							$elm$core$Platform$Cmd$none);
					case 4:
						var vin_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'vin', model.b);
						var userNode = $author$project$Csf$Flags$userNode(session.ka);
						var tipo_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'tipo', model.b);
						var solicitante_email_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'email', userNode);
						var solicitante_ = $author$project$Csf$TaskNodeUtils$fullName(userNode);
						var patente_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'patente', model.b);
						var numExtensions = 1 + $elm$core$List$length(
							$author$project$Helpers$ExtensionsUtils$getActiveExtensions(model.b));
						var newDueDate_ = $author$project$Page$SolicitudesChie$calculateNewDueDate(model.b);
						var motor_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'motor', model.b);
						var modelo_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'modelo', model.b);
						var model_ = _Utils_update(
							model,
							{b_: $author$project$Csf$Modal$hidden});
						var marca_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'marca', model.b);
						var isValid = A2($author$project$Page$SolicitudesChie$verifyNewDueDate, model.b, newDueDate_);
						var fecha_vigencia_chie_xml_ = $author$project$Page$SolicitudesChie$getEntireDate(newDueDate_);
						var fecha_vigencia_chie_ = newDueDate_;
						var fecha_solicitud_ = model.d9;
						var distribuidor_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'distribuidor', model.b);
						var color_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'color', model.b);
						var cliente_correo_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'cliente_correo', model.b);
						var cit_ = A3($author$project$Csf$TaskNodeUtils$datastring, '', 'cit', model.b);
						var anno_ = A3($author$project$Csf$TaskNodeUtils$dataint, 0, 'ano', model.b);
						var _v5 = _Utils_Tuple2(
							model.b.p,
							A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
						var unique_id = _v5.a;
						var tenant_ = _v5.b;
						return isValid ? A2(
							$elm$core$Tuple$pair,
							model_,
							A2(
								$elm$core$Task$attempt,
								$author$project$Page$SolicitudesChie$ExtendCHIEDone,
								A3(
									$author$project$Helpers$ApiHandler$extendCHIE,
									ticket_,
									tenant_,
									{hn: anno_, hu: cit_, hv: cliente_correo_, hx: color_, hH: distribuidor_, hS: fecha_solicitud_, hT: fecha_vigencia_chie_, hU: fecha_vigencia_chie_xml_, ij: marca_, ik: modelo_, im: motor_, it: numExtensions, iz: patente_, i0: solicitante_, i1: solicitante_email_, jh: tipo_, jt: unique_id, jv: vin_}))) : A2(
							$elm$core$Tuple$pair,
							model_,
							A2($author$project$Page$SolicitudesChie$doNotify, 'error', 'extend_chie_failed'));
					case 10:
						if (!mssg_.a.$) {
							var response = mssg_.a.a;
							var _v6 = _Utils_Tuple2(
								model.b.p,
								A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
							var unique_id = _v6.a;
							var tenant_ = _v6.b;
							var refreshCmd_ = A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cT: $author$project$Csf$Modal$shown,
										dj: $elm$core$Maybe$Just(response)
									}),
								refreshCmd_);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 5:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bL: $author$project$Csf$Modal$shown}),
							$elm$core$Platform$Cmd$none);
					case 6:
						var pesoValue = $author$project$Csf$Form$strVal(model.aG);
						var isValidPeso = $author$project$Page$SolicitudesChie$isValidIntPeso(pesoValue);
						var _v7 = _Utils_Tuple2(
							model.b.p,
							A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
						var unique_id = _v7.a;
						var tenant_ = _v7.b;
						if (isValidPeso && (!$elm$core$String$isEmpty(pesoValue))) {
							var model_ = _Utils_update(
								model,
								{
									bL: $author$project$Csf$Modal$hidden,
									aG: $author$project$Csf$Form$strFieldModel('')
								});
							var jsonBody = $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'vehiculo_peso_bruto',
										$elm$json$Json$Encode$string(pesoValue))
									]));
							return A2(
								$elm$core$Tuple$pair,
								model_,
								A2(
									$elm$core$Task$attempt,
									$author$project$Page$SolicitudesChie$ActualizarPesoDone,
									A4($author$project$Helpers$ApiHandler$actualizarNode, ticket_, tenant_, unique_id, jsonBody)));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 7:
						if (!mssg_.a.$) {
							var updatedNode = mssg_.a.a;
							var _v8 = _Utils_Tuple2(
								updatedNode.p,
								A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', updatedNode));
							var unique_id = _v8.a;
							var tenant_ = _v8.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b: updatedNode}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'El valor del peso bruto del vehículo se ha actualizado satisfactoriamente.'),
											A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id))
										])));
						} else {
							return _Utils_Tuple2(
								model,
								A2($author$project$Page$SolicitudesChie$doNotify, 'error', 'El valor del peso bruto del vehículo no se ha podido actualizar.'));
						}
					case 8:
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{
									aG: A2(
										$author$project$Csf$Form$strValidator,
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										$author$project$Csf$Form$strVal(model.aG))
								}));
					case 9:
						var string_ = mssg_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aG: A2(
										$author$project$Csf$Form$strValidator,
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										string_)
								}),
							$elm$core$Platform$Cmd$none);
					case 11:
						if (!mssg_.a.$) {
							var updatedNode_ = mssg_.a.a;
							var _v9 = _Utils_Tuple2(
								updatedNode_.p,
								A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', updatedNode_));
							var unique_id = _v9.a;
							var tenant_ = _v9.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{b: updatedNode_}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id)),
											A2($author$project$Page$SolicitudesChie$fileNodeTaskHistory, ticket_, updatedNode_)
										])));
						} else {
							var _v10 = _Utils_Tuple2(
								model.b.p,
								A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
							var unique_id = _v10.a;
							var tenant_ = _v10.b;
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id)),
											A2($author$project$Page$SolicitudesChie$fileNodeTaskHistory, ticket_, model.b)
										])));
						}
					case 12:
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bZ: true}),
							A3(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$ParseDatesToISO,
								$author$project$Helpers$Utilities$delay(0),
								A3(
									$elm$core$Basics$composeR,
									$elm$json$Json$Encode$object,
									$elm$json$Json$Encode$encode(0),
									_List_fromArray(
										[
											_Utils_Tuple2(
											'from_action',
											$elm$json$Json$Encode$string('export_xls'))
										]))));
					case 13:
						var states_ = _List_fromArray(
							['PENDIENTE_CONCILIACION_ERROR', 'PENDIENTE_CONCILIACION_POR_ERROR']);
						var forConciliate_ = function (filter_) {
							return A2($elm$core$List$filter, filter_, model.jb.r);
						}(
							A2(
								$elm$core$Basics$composeL,
								function (state_) {
									return A2($elm$core$List$member, state_, states_);
								},
								A2(
									$elm$core$Basics$composeL,
									A2($author$project$Csf$TaskNodeUtils$string, '', 'estado_conciliacion_mtt'),
									function ($) {
										return $.r;
									})));
						var checkedRequests_ = function (filterMap_) {
							return A2($elm$core$List$filterMap, filterMap_, forConciliate_);
						}(
							function (item) {
								return item.dt ? $elm$core$Maybe$Just(item.r.p) : $elm$core$Maybe$Nothing;
							});
						return model.bQ ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : ($elm$core$List$isEmpty(forConciliate_) ? _Utils_Tuple2(
							model,
							A2($author$project$Page$SolicitudesChie$doNotify, 'info', 'no_requests_available')) : ($elm$core$List$isEmpty(checkedRequests_) ? _Utils_Tuple2(
							model,
							A2($author$project$Page$SolicitudesChie$doNotify, 'error', 'no_requests_selected')) : A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bQ: true}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Page$SolicitudesChie$ConciliationDone,
								A3(
									$author$project$Helpers$ApiHandler$enviarAConciliacion,
									ticket_,
									$author$project$Csf$Flags$tenantId(session.ka),
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, checkedRequests_))))));
					case 14:
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$author$project$Route$goTo,
								session.gL,
								$author$project$Route$SolicitudesChie(
									{iI: model.kX})));
					case 15:
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{
									Q: A2(
										$author$project$Csf$Form$strValidator,
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										$author$project$Csf$Form$strVal(model.Q))
								}));
					case 16:
						var string_ = mssg_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Q: A2(
										$author$project$Csf$Form$strValidator,
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										string_)
								}),
							$elm$core$Platform$Cmd$none);
					case 17:
						var stringJson = mssg_.a;
						var query_ = function (queryDatesMap) {
							return A2($elm$core$Dict$map, queryDatesMap, model.kX);
						}(
							F2(
								function (key_, value_) {
									switch (key_) {
										case 'fechaini':
											return A2(
												$elm$core$Maybe$withDefault,
												value_,
												A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 0, 0, value_));
										case 'fechafin':
											return A2(
												$elm$core$Maybe$withDefault,
												value_,
												A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 23, 59, value_));
										case 'emisionfini':
											return A3(
												$elm$core$String$replace,
												'Z',
												'',
												A2(
													$elm$core$Maybe$withDefault,
													value_,
													A4($author$project$Csf$DateFormat$toUtcIsoString, 0, 0, 0, value_)));
										case 'emisionffin':
											return A3(
												$elm$core$String$replace,
												'Z',
												'',
												A2(
													$elm$core$Maybe$withDefault,
													value_,
													A4($author$project$Csf$DateFormat$toUtcIsoString, 0, 23, 59, value_)));
										default:
											return value_;
									}
								}));
						var fromStringJson_ = F3(
							function (key_, default_, decodes_) {
								return function (decoder_) {
									return A3($author$project$Helpers$Utilities$decodeString_, default_, decoder_, stringJson);
								}(
									A2($elm$json$Json$Decode$field, key_, decodes_));
							});
						var stringFromJson = F2(
							function (key_, default_) {
								return A3(fromStringJson_, key_, default_, $elm$json$Json$Decode$string);
							});
						var andThenFromFiles = function (search_) {
							return A2(
								$elm$core$Task$map,
								$elm$core$Tuple$pair(search_),
								A3(
									$author$project$Helpers$ApiHandler$buscarAgregaciones,
									ticket_,
									'files',
									_Utils_ap(
										_List_fromArray(
											['estado_chie', 'motor', 'tipo', 'ano', 'marca', 'modelo', 'color']),
										$author$project$Page$SolicitudesChie$isSupportUser(session) ? _List_fromArray(
											['distribuidor', 'tenant']) : ($author$project$Page$SolicitudesChie$showDealer(session) ? _List_fromArray(
											['distribuidor']) : _List_fromArray(
											['tenant'])))));
						};
						return A2(
							$elm$core$Tuple$pair,
							model,
							function () {
								var _v11 = A2(stringFromJson, 'from_action', '');
								if (_v11 === 'export_xls') {
									return A2(
										$elm$core$Task$attempt,
										$author$project$Page$SolicitudesChie$ExportXLSDone,
										A3(
											$author$project$Helpers$ApiHandler$exportarCHIE,
											ticket_,
											$author$project$Csf$Flags$tenantId(session.ka),
											$author$project$Page$SolicitudesChie$filtersFromQuery(query_)));
								} else {
									return A2(
										$elm$core$Task$attempt,
										$author$project$Page$SolicitudesChie$FilesLoaded,
										A2(
											$elm$core$Task$andThen,
											andThenFromFiles,
											A4(
												$author$project$Helpers$ApiHandler$listarExpedientes,
												ticket_,
												A2(stringFromJson, 'sort_by', 'inserted_at:desc'),
												_Utils_Tuple2(
													A2(stringFromJson, 'from_', '0'),
													A2(stringFromJson, 'size_', '10')),
												$author$project$Page$SolicitudesChie$filtersFromQuery(query_))));
								}
							}());
					case 18:
						return A2(
							$elm$core$Tuple$pair,
							model,
							$author$project$Helpers$Utilities$retrieveFromLocalStorage('prevLocation'));
					case 19:
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$author$project$Route$goTo,
								session.gL,
								$author$project$Route$SolicitarChie($author$project$Route$emptyData)));
					case 20:
						var location_ = mssg_.a;
						var defaultRoute_ = A2(
							$author$project$Route$goTo,
							session.gL,
							$author$project$Route$SolicitudesChie($author$project$Route$emptyData));
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$elm$core$Maybe$withDefault,
								defaultRoute_,
								A2(
									$elm$core$Maybe$map,
									$author$project$Route$goTo_(session.gL),
									$author$project$Helpers$Utilities$stringToMaybe(location_))));
					case 21:
						var stringJson = mssg_.a;
						var posix_ = mssg_.b;
						var parseDatesToISO_ = A2(
							$author$project$Helpers$Utilities$delay,
							0,
							$author$project$Page$SolicitudesChie$ParseDatesToISO(stringJson));
						var offset_ = A2($justinmimbs$time_extra$Time$Extra$toOffset, model.lG, posix_);
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{dE: offset_}),
							parseDatesToISO_);
					case 23:
						var mbeString = mssg_.a;
						var zone_ = mssg_.b;
						var actionMap_ = function (cmd_) {
							return A2(
								$elm$core$Maybe$withDefault,
								cmd_,
								function (stringMap_) {
									return A2($elm$core$Maybe$map, stringMap_, mbeString);
								}(
									function (string_) {
										return A2(
											$elm$core$Task$perform,
											$author$project$Page$SolicitudesChie$GotNowPosix(string_),
											$elm$time$Time$now);
									}));
						};
						return A2(
							$elm$core$Tuple$mapSecond,
							actionMap_,
							A2($author$project$Csf$Core$onTimeZone, zone_, model));
					case 22:
						var posix = mssg_.a;
						var second = A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								A2($elm$time$Time$toSecond, model.lG, posix)));
						var minute = A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								A2($elm$time$Time$toMinute, model.lG, posix)));
						var hour = A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								A2($elm$time$Time$toHour, model.lG, posix)));
						var dateFromPosix = A2($justinmimbs$date$Date$fromPosix, model.lG, posix);
						var dateIso = $justinmimbs$date$Date$toIsoString(dateFromPosix);
						var dateTimeIso = dateIso + ('T' + (hour + (':' + (minute + (':' + (second + 'Z'))))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bR: dateIso, d9: dateTimeIso}),
							$elm$core$Platform$Cmd$none);
					case 24:
						switch (mssg_.a) {
							case 'nullify-modal':
								return function (model_) {
									return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
								}(
									A5(
										$author$project$Helpers$Utilities$initDropdown,
										$author$project$Config$AppStates$motivosAnulacionCHIE,
										$author$project$Page$SolicitudesChie$stringFromField(4),
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just('Seleccione motivo...'),
										_Utils_update(
											model,
											{
												Q: $author$project$Csf$Form$strFieldModel(''),
												ch: $author$project$Csf$Modal$hidden,
												ci: 'Anular CHI-e'
											})));
							case 'delete-modal':
								return function (model_) {
									return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
								}(
									_Utils_update(
										model,
										{
											am: {ef: '', hP: '', br: false, bF: '', dJ: $author$project$Csf$Modal$hidden}
										}));
							case 'extend-chie-modal':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{b_: $author$project$Csf$Modal$hidden}),
									$elm$core$Platform$Cmd$none);
							case 'actualizar-peso-modal':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											bL: $author$project$Csf$Modal$hidden,
											aG: $author$project$Csf$Form$strFieldModel('')
										}),
									$elm$core$Platform$Cmd$none);
							case 'extend-chie-success-modal':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{cT: $author$project$Csf$Modal$hidden}),
									A2($author$project$Page$SolicitudesChie$fileNodeTaskHistory, ticket_, model.b));
							default:
								break _v0$75;
						}
					case 26:
						var uuid_ = mssg_.a;
						return function (errorTooltip_) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ao: errorTooltip_}),
								$elm$core$Platform$Cmd$none);
						}(
							A2(
								$elm$core$Maybe$withDefault,
								A3($elm$core$Dict$insert, uuid_, true, $elm$core$Dict$empty),
								A2(
									$elm$core$Maybe$map,
									function (show_) {
										return A3($elm$core$Dict$insert, uuid_, !show_, model.ao);
									},
									A2($elm$core$Dict$get, uuid_, model.ao))));
					case 25:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ao: $elm$core$Dict$empty}),
							$elm$core$Platform$Cmd$none);
					case 27:
						var tabKey_ = mssg_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ae: tabKey_}),
							$elm$core$Platform$Cmd$none);
					case 28:
						var unique_id = mssg_.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aK: unique_id}),
							$elm$core$Platform$Cmd$none);
					case 29:
						var _v13 = model;
						var deAssociate = _v13.am;
						var fileLoaded = _v13.b;
						var taskActionDelete = A3($author$project$Helpers$ApiHandler$desasociarNode, ticket_, fileLoaded.p, deAssociate.ef);
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{
									am: _Utils_update(
										deAssociate,
										{br: true})
								}),
							A2($elm$core$Task$attempt, $author$project$Page$SolicitudesChie$DocumentoEliminado, taskActionDelete));
					case 30:
						if (!mssg_.a.$) {
							var tNde = mssg_.a.a;
							return $author$project$Helpers$Utilities$trimmedEmpty(tNde.p) ? A2(
								$elm$core$Tuple$pair,
								model,
								A3(
									$elm$core$Basics$composeR,
									$author$project$Page$SolicitudesChie$DocumentoEliminado,
									$author$project$Helpers$Utilities$delay(0),
									$elm$core$Result$Err(
										$author$project$Csf$Call$BadBody('Error retrieving node data.')))) : A2(
								$elm$core$Tuple$pair,
								A3($author$project$Page$SolicitudesChie$boolToModule, 'docs_loading', true, model),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'deassociate_succeed'),
											A2(
											$author$project$Helpers$Utilities$delay,
											0,
											$author$project$Page$SolicitudesChie$CloseModal('delete-modal')),
											A2($author$project$Page$SolicitudesChie$fileNodeDocuments, ticket_, model.b)
										])));
						} else {
							var error_ = mssg_.a.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'deassociate_failed');
							var _v14 = model;
							var deAssociate = _v14.am;
							return ('redirect_' === handled_) ? A2(
								$elm$core$Tuple$pair,
								model,
								$author$project$Helpers$ApiHandler$toUserHome(session)) : A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{
										am: _Utils_update(
											deAssociate,
											{
												hP: $author$project$Page$SolicitudesChie$moduleMessage(handled_),
												br: false
											})
									}),
								$elm$core$Platform$Cmd$none);
						}
					case 31:
						var filename = mssg_.a;
						var taskNode_ = mssg_.b;
						var _v15 = function (ext_) {
							return _Utils_Tuple2(filename + ('.' + ext_), ext_);
						}(
							A3(
								$elm$core$Basics$composeR,
								$elm$core$List$take(1),
								$elm$core$String$join(''),
								A3(
									$elm$core$Basics$composeR,
									$elm$core$String$split('.'),
									$elm$core$List$reverse,
									$author$project$TaskNode$nameOrEmpty(taskNode_.dm))));
						var filename_ = _v15.a;
						var extension_ = _v15.b;
						var mimeType_ = $author$project$Helpers$Utilities$mimeFromExtension(extension_);
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								function (mapTenant) {
									return A2(
										$elm$core$Maybe$map,
										mapTenant,
										A2($author$project$Csf$TaskNodeUtils$mbstring, 'tenant', taskNode_));
								}(
									function (tenant_) {
										return A2(
											$elm$core$Task$attempt,
											$author$project$Page$SolicitudesChie$NodeDownloaded(
												_Utils_Tuple2(filename_, mimeType_)),
											A3($author$project$Helpers$ApiHandler$descargarNodeFile, ticket_, tenant_, taskNode_.p));
									})));
					case 32:
						var docName = mssg_.a;
						var tNde = mssg_.b;
						var id = tNde.p;
						var properties = tNde.dm;
						var _v16 = model;
						var deAssociate = _v16.am;
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{
									am: _Utils_update(
										deAssociate,
										{ef: id, bF: docName, dJ: $author$project$Csf$Modal$shown})
								}));
					case 33:
						if (!mssg_.b.$) {
							var _v17 = mssg_.a;
							var filename_ = _v17.a;
							var mimeType_ = _v17.b;
							var dataBytes = mssg_.b.a;
							return A2(
								$elm$core$Tuple$pair,
								model,
								A3($elm$file$File$Download$bytes, filename_, mimeType_, dataBytes));
						} else {
							var error = mssg_.b.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'download_failed');
							return A2(
								$elm$core$Tuple$pair,
								model,
								('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_));
						}
					case 34:
						var query_ = mssg_.a;
						return (!_Utils_eq(model.kX, query_)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitudesChie$ReloadModule));
					case 35:
						var tupleDteRange = mssg_.a;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$author$project$Helpers$Utilities$todaysDateRange,
								tupleDteRange,
								$author$project$Page$SolicitudesChie$DateOnQuery('update_query')));
					case 36:
						var tupleDteRange = mssg_.a;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A3(
								$author$project$Helpers$Utilities$lastNDaysRange,
								tupleDteRange,
								-7,
								$author$project$Page$SolicitudesChie$DateOnQuery('update_query')));
					case 37:
						var tupleDteRange = mssg_.a;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A3(
								$author$project$Helpers$Utilities$lastNDaysRange,
								tupleDteRange,
								-30,
								$author$project$Page$SolicitudesChie$DateOnQuery('update_query')));
					case 38:
						var event_ = mssg_.a;
						var eventNode = A3($author$project$Helpers$Utilities$decodeValue_, $author$project$TaskNode$emptyTask, $author$project$Helpers$ApiHandler$decodeTaskNode, event_);
						var notEventOwner = !_Utils_eq(
							$author$project$Csf$Flags$username(session.ka),
							A3($author$project$Csf$TaskNodeUtils$string, '', 'owner', eventNode));
						var notFromFileLoad_ = 'CHIE_FILE_UPDATE' !== A3($author$project$Csf$TaskNodeUtils$string, '', 'event_type', eventNode);
						var putIntoNode_ = F3(
							function (key_, default_, tNde) {
								return function (dataValue_) {
									return A3($author$project$TaskNode$put, key_, dataValue_, tNde);
								}(
									A3($author$project$Csf$TaskNodeUtils$datavalue, default_, key_, eventNode));
							});
						var stringFromData_ = function (key_) {
							return A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, eventNode);
						};
						var updatedHits_ = function (tNdeMap_) {
							return A2($elm$core$List$map, tNdeMap_, model.bp.kh);
						}(
							function (tNde) {
								return _Utils_eq(
									tNde.p,
									stringFromData_('file')) ? A3(
									putIntoNode_,
									'estado_chie',
									$elm$json$Json$Encode$string(''),
									tNde) : tNde;
							});
						var closed_onerror = A3($author$project$Csf$TaskNodeUtils$bool, false, 'closed_onerror', eventNode);
						if (closed_onerror) {
							return A2(
								$elm$core$Tuple$pair,
								model,
								$author$project$Helpers$ApiHandler$triggsUpInfoChannel(ticket_));
						} else {
							return function (model_) {
								return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
							}(
								notFromFileLoad_ ? model : _Utils_update(
									model,
									{
										bp: function (loaded_) {
											return _Utils_update(
												loaded_,
												{kh: updatedHits_});
										}(model.bp),
										jb: $author$project$Csf$Table$init(
											{r: updatedHits_, w: model.jb.w})
									}));
						}
					case 39:
						var field_ = mssg_.a;
						var data_ = mssg_.b;
						var updField = A3(
							$elm$core$Dict$insert,
							'value_',
							$elm$json$Json$Encode$string(data_),
							A2(
								$author$project$Helpers$Utilities$embeddedDict,
								$author$project$Page$SolicitudesChie$stringFromField(field_),
								model.cf));
						var queryDta = $author$project$Helpers$Utilities$trimmedEmpty(data_) ? function (key_) {
							return A2($elm$core$Dict$remove, key_, model.kX);
						}(
							$author$project$Page$SolicitudesChie$keyQueryFromField(field_)) : A3(
							$author$project$Route$appendToQuery,
							$author$project$Page$SolicitudesChie$keyQueryFromField(field_),
							$elm$core$String$trim(data_),
							model.kX);
						var fields_ = A3(
							$elm$core$Dict$insert,
							$author$project$Page$SolicitudesChie$stringFromField(field_),
							updField,
							model.cf);
						var cmdAction_ = A2(
							$author$project$Helpers$Utilities$delay,
							1.5,
							$author$project$Page$SolicitudesChie$FilterOnDelay(queryDta));
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{cf: fields_, kX: queryDta}),
							cmdAction_);
					case 40:
						var dashlet_ = mssg_.a;
						return function (action_) {
							return A3($author$project$Helpers$Utilities$dashletToggle, dashlet_, action_, model);
						}(
							A2(
								$author$project$Helpers$Utilities$delay,
								0.5,
								$author$project$Page$SolicitudesChie$TransitioningOFF(dashlet_)));
					case 41:
						var dashlet_ = mssg_.a;
						return A2($author$project$Helpers$Utilities$transitioningOff, dashlet_, model);
					case 42:
						var key_ = mssg_.a;
						var pickerMsg = mssg_.b;
						var _v19 = A3(
							$author$project$Helpers$Utilities$handlePickerMsg,
							_Utils_Tuple2(
								A2($author$project$Helpers$Utilities$getModuleDate, key_, model),
								A2($author$project$Helpers$Utilities$getDtePicker, key_, model)),
							$author$project$Helpers$Utilities$pickerSettings_(key_),
							pickerMsg);
						var mbeDate = _v19.a;
						var picker_ = _v19.b;
						var action_ = _v19.c;
						var handlePickerChange = function (mdel) {
							return A3(
								$elm$core$Basics$composeR,
								$author$project$Helpers$Utilities$delay(0),
								$elm$core$Tuple$pair(mdel),
								A2(
									$author$project$Page$SolicitudesChie$DateOnQuery,
									action_,
									_List_fromArray(
										[
											A2($elm$core$Tuple$pair, key_, mbeDate)
										])));
						};
						return handlePickerChange(
							A2(
								$elm$core$Basics$composeR,
								A2($author$project$Helpers$Utilities$updateDtePicker, key_, picker_),
								A2($author$project$Helpers$Utilities$updateModuleDate, key_, mbeDate))(model));
					case 43:
						var action_ = mssg_.a;
						var datesData = mssg_.b;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A5(
								$author$project$Helpers$ApiHandler$dateOnQueryMsg,
								action_,
								datesData,
								session.gL,
								model.kX,
								$author$project$Route$SolicitudesChie($author$project$Route$emptyData)));
					case 44:
						if (!mssg_.b.$) {
							if (mssg_.a === 'anull_ext') {
								var strJson = mssg_.b.a;
								var closeModalCmd_ = A2(
									$author$project$Csf$Core$timeout,
									0,
									$author$project$Page$SolicitudesChie$CloseModal('nullify-modal'));
								var _v20 = _Utils_Tuple2(
									model.b.p,
									A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
								var unique_id = _v20.a;
								var tenant_ = _v20.b;
								var refreshCmd_ = A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id));
								return A2(
									$elm$core$Tuple$pair,
									model,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'nullify_ok'),
												closeModalCmd_,
												refreshCmd_
											])));
							} else {
								var strJson = mssg_.b.a;
								return A2(
									$elm$core$Tuple$pair,
									model,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'nullify_ok'),
												A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitudesChie$ReloadModule)
											])));
							}
						} else {
							var from_ = mssg_.a;
							var error = mssg_.b.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'nullify_failed');
							var errorMessage = $author$project$Page$SolicitudesChie$extractErrorMessage(error);
							var _v21 = _Utils_Tuple2(
								model.b.p,
								A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', model.b));
							var unique_id = _v21.a;
							var tenant_ = _v21.b;
							var refreshCmd_ = A2($author$project$Page$SolicitudesChie$fileNodeDetails, ticket_, tenant_ + (':' + unique_id));
							return A2(
								$elm$core$Tuple$mapFirst,
								function (model_) {
									return _Utils_update(
										model_,
										{bw: false});
								},
								('redirect_' === handled_) ? A2(
									$elm$core$Tuple$pair,
									model,
									$author$project$Helpers$ApiHandler$toUserHome(session)) : ((from_ === 'anull_ext') ? A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{ch: $author$project$Csf$Modal$hidden, ci: 'Anular CHI-e'}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Page$SolicitudesChie$doNotify, 'error', errorMessage),
												refreshCmd_
											]))) : A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{
											de: $author$project$Page$SolicitudesChie$moduleMessage(handled_)
										}),
									$elm$core$Platform$Cmd$none)));
						}
					case 45:
						if (!mssg_.a.$) {
							var string_ = mssg_.a.a;
							var erroresFromJson = function (uuid_) {
								return function (decoder_) {
									return A3($author$project$Helpers$Utilities$decodeString_, _List_Nil, decoder_, string_);
								}(
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											[uuid_, 'errores']),
										$elm$json$Json$Decode$list($elm$json$Json$Decode$value)));
							};
							var checkedRequests_ = function (filterMap_) {
								return A2($elm$core$List$filterMap, filterMap_, model.jb.r);
							}(
								function (item) {
									return item.dt ? A3(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$pair(item.r.p),
										$elm$core$Maybe$Just,
										erroresFromJson(item.r.p)) : $elm$core$Maybe$Nothing;
								});
							return A3(
								$elm$core$Basics$composeR,
								$elm$core$Platform$Cmd$batch,
								$elm$core$Tuple$pair(model),
								A3(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$core$Basics$append(
										_List_fromArray(
											[
												A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitudesChie$ReloadModule)
											])),
									A2(
										$elm$core$List$all,
										A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$isEmpty),
										checkedRequests_) ? A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'conciliate_ok') : (A2(
										$elm$core$List$any,
										A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$isEmpty),
										checkedRequests_) ? A2($author$project$Page$SolicitudesChie$doNotify, 'info', 'conciliate_partial_ok') : A2($author$project$Page$SolicitudesChie$doNotify, 'error', 'conciliate_failed'))));
						} else {
							var error_ = mssg_.a.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'conciliate_failed');
							return A2(
								$elm$core$Tuple$mapFirst,
								function (model_) {
									return _Utils_update(
										model_,
										{bQ: false});
								},
								('redirect_' === handled_) ? A2(
									$elm$core$Tuple$pair,
									model,
									$author$project$Helpers$ApiHandler$toUserHome(session)) : A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{
											de: $author$project$Page$SolicitudesChie$moduleMessage(handled_)
										}),
									$elm$core$Platform$Cmd$none));
						}
					case 46:
						if (!mssg_.a.$) {
							var dataBytes = mssg_.a.a;
							return A2(
								$elm$core$Basics$composeR,
								$elm$core$Platform$Cmd$batch,
								$elm$core$Tuple$pair(
									_Utils_update(
										model,
										{bZ: false})))(
								_List_fromArray(
									[
										A2($author$project$Page$SolicitudesChie$doNotify, 'success', 'export_ok'),
										A3(
										$elm$file$File$Download$bytes,
										$author$project$Page$SolicitudesChie$moduleMessage('export_filename'),
										$author$project$Helpers$Utilities$mimeFromExtension('xlsx'),
										dataBytes)
									]));
						} else {
							var error = mssg_.a.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'export_failed');
							return A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{bZ: false}),
								('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_));
						}
					case 47:
						if (!mssg_.a.$) {
							var _v22 = mssg_.a.a;
							var searchResp = _v22.a;
							var aggregations = _v22.b;
							var tenantInfo_ = function (tnant) {
								return $author$project$Helpers$Utilities$trimmedEmpty(
									A2(
										$elm$core$Basics$composeR,
										$author$project$Helpers$Utilities$tenantInfo(model.cl),
										function ($) {
											return $.dc;
										})(tnant)) ? tnant : A2(
									$elm$core$Basics$composeR,
									$author$project$Helpers$Utilities$tenantInfo(model.cl),
									function ($) {
										return $.dc;
									})(tnant);
							};
							var decodeAnnoAggregations_ = F2(
								function (field_, actionMap) {
									return A2(
										$elm$core$List$map,
										function (agg) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(agg),
												actionMap(
													$elm$core$String$fromInt(agg)));
										},
										A3($author$project$Helpers$Utilities$decodeAggregations, field_, $elm$json$Json$Decode$int, aggregations));
								});
							var decodeAggregations_ = F2(
								function (field_, actionMap) {
									return A2(
										$elm$core$List$map,
										function (agg) {
											return _Utils_Tuple2(
												agg,
												actionMap(agg));
										},
										A3($author$project$Helpers$Utilities$decodeAggregations, field_, $elm$json$Json$Decode$string, aggregations));
								});
							var estadosAggs = A2(decodeAggregations_, 'estado_chie', $author$project$Helpers$Utilities$estadoDelChie);
							var importerAggs = A2(decodeAggregations_, 'tenant', tenantInfo_);
							var marcaVehiculoAggs = A2(decodeAggregations_, 'marca', $elm$core$Basics$identity);
							var modeloVehiculoAggs = A2(decodeAggregations_, 'modelo', $elm$core$Basics$identity);
							var nroMotorAggs = A2(decodeAggregations_, 'motor', $elm$core$Basics$identity);
							var tipoVehiculoAggs = A2(decodeAggregations_, 'tipo', $elm$core$Basics$identity);
							var dealerAggs = A2(decodeAggregations_, 'distribuidor', $elm$core$Basics$identity);
							var colorVehiculoAggs = A2(decodeAggregations_, 'color', $elm$core$Basics$identity);
							var annoVehiculoAggs = A2(decodeAnnoAggregations_, 'ano', $elm$core$Basics$identity);
							var updateDropdownsAggs_ = function (mdel) {
								return A3(
									$author$project$Helpers$Utilities$updateDropdownOptions,
									$author$project$Page$SolicitudesChie$stringFromField(11),
									tipoVehiculoAggs,
									A3(
										$author$project$Helpers$Utilities$updateDropdownOptions,
										$author$project$Page$SolicitudesChie$stringFromField(12),
										nroMotorAggs,
										A3(
											$author$project$Helpers$Utilities$updateDropdownOptions,
											$author$project$Page$SolicitudesChie$stringFromField(13),
											importerAggs,
											A3(
												$author$project$Helpers$Utilities$updateDropdownOptions,
												$author$project$Page$SolicitudesChie$stringFromField(9),
												modeloVehiculoAggs,
												A3(
													$author$project$Helpers$Utilities$updateDropdownOptions,
													$author$project$Page$SolicitudesChie$stringFromField(8),
													marcaVehiculoAggs,
													A3(
														$author$project$Helpers$Utilities$updateDropdownOptions,
														$author$project$Page$SolicitudesChie$stringFromField(7),
														colorVehiculoAggs,
														A3(
															$author$project$Helpers$Utilities$updateDropdownOptions,
															$author$project$Page$SolicitudesChie$stringFromField(6),
															annoVehiculoAggs,
															A3(
																$author$project$Helpers$Utilities$updateDropdownOptions,
																$author$project$Page$SolicitudesChie$stringFromField(10),
																estadosAggs,
																A3(
																	$author$project$Helpers$Utilities$updateDropdownOptions,
																	$author$project$Page$SolicitudesChie$stringFromField(14),
																	dealerAggs,
																	mdel)))))))));
							};
							var _v23 = A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesChie$NodePagerMsg),
								A2($author$project$Csf$NodePager$updateNodePager, searchResp.lo, model.aF));
							var ndePager = _v23.a;
							var pagerCmd = _v23.b;
							var cmdActions_ = $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										pagerCmd,
										$author$project$Helpers$ApiHandler$triggsUpInfoChannel(ticket_)
									]));
							return A2(
								$elm$core$Tuple$mapFirst,
								updateDropdownsAggs_,
								function (model_) {
									return A2($elm$core$Tuple$pair, model_, cmdActions_);
								}(
									_Utils_update(
										model,
										{
											b7: false,
											bp: searchResp,
											aF: ndePager,
											jb: $author$project$Csf$Table$init(
												{r: searchResp.kh, w: model.jb.w})
										})));
						} else {
							var error = mssg_.a.a;
							var nodePager_ = function (pager_) {
								return _Utils_update(
									pager_,
									{gR: true});
							}(model.aF);
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, '');
							var cmdAction_ = ($author$project$Helpers$Utilities$trimmedEmpty(handled_) || ('redirect_' === handled_)) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_);
							return function (model_) {
								return A2($elm$core$Tuple$pair, model_, cmdAction_);
							}(
								_Utils_update(
									model,
									{b7: true, aF: nodePager_}));
						}
					case 48:
						if (!mssg_.a.$) {
							var _v24 = mssg_.a.a;
							var expNde = _v24.a;
							var iNde = _v24.b;
							var taskActions_ = $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Page$SolicitudesChie$fileNodeDocuments, ticket_, expNde),
										A2($author$project$Page$SolicitudesChie$fileNodeTaskHistory, ticket_, expNde)
									]));
							var modelMapFirst_ = A2(
								$elm$core$Basics$composeL,
								A2($author$project$Page$SolicitudesChie$boolToModule, 'docs_loading', true),
								A2($author$project$Page$SolicitudesChie$boolToModule, 'history_loading', true));
							var maybeCmdUpdateExtensions_ = function () {
								var _v25 = model.dj;
								if (_v25.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var extendResp_ = _v25.a;
									var hasInProcessExtension_ = !$elm$core$List$isEmpty(
										$author$project$Helpers$ExtensionsUtils$getInProcessExtensions(expNde));
									if (hasInProcessExtension_) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var updatedExtensions_ = function (lst) {
											return _Utils_ap(
												lst,
												_List_fromArray(
													[
														$author$project$Page$SolicitudesChie$extenderResponseToExtensionValue(extendResp_)
													]));
										}(
											A2(
												$elm$core$List$map,
												$author$project$Page$SolicitudesChie$extensionDataToValue,
												$author$project$Helpers$ExtensionsUtils$decodeExtensions(expNde)));
										return A2(
											$elm$core$Task$attempt,
											$author$project$Page$SolicitudesChie$ExtendCHIEUpdateExtensionsDone,
											A4(
												$author$project$Helpers$ApiHandler$actualizarNode,
												ticket_,
												A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', expNde),
												expNde.p,
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'extensiones',
															A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, updatedExtensions_))
														]))));
									}
								}
							}();
							var dateInsertAtChie = A3(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$author$project$Csf$Form$strFieldModel,
								A3(
									$author$project$Csf$DateFormat$formatIsoDate,
									'DD/MM/YYYY | hh:mm A',
									model.lG,
									$author$project$TaskNode$insertedAtOrEmpty(expNde.dm)));
							var dataFromInscripcion = function (key_) {
								return A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, iNde);
							};
							var dateDocumentoInscripcion = A3(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$author$project$Csf$Form$strFieldModel,
								A3(
									$author$project$Csf$DateFormat$formatIsoDate,
									'DD/MM/YYYY',
									$elm$time$Time$utc,
									dataFromInscripcion('documentos_fecha')));
							var dateSolicitudInscripcion = A3(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$author$project$Csf$Form$strFieldModel,
								A3(
									$author$project$Csf$DateFormat$formatIsoDate,
									'DD/MM/YYYY | hh:mm A',
									$elm$time$Time$utc,
									dataFromInscripcion('solicitud_fecha_solicitud')));
							var emisorFormattedRut = A3(
								$elm$core$Basics$composeR,
								$author$project$Helpers$Utilities$formatRut,
								$author$project$Csf$Form$strFieldModel,
								dataFromInscripcion('documentos_rut_emisor'));
							var insertInscripcion_ = A2($elm$core$Basics$composeR, dataFromInscripcion, $author$project$Csf$Form$strFieldModel);
							var dataFromExpediente = function (key_) {
								return A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, expNde);
							};
							var dateAnulacionChie = A3(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$author$project$Csf$Form$strFieldModel,
								A3(
									$author$project$Csf$DateFormat$formatIsoDate,
									'DD/MM/YYYY | hh:mm A',
									$elm$time$Time$utc,
									dataFromExpediente('fecha_anulacion_chie')));
							var dateEmisionChie = A3(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(''),
								$author$project$Csf$Form$strFieldModel,
								A3(
									$author$project$Csf$DateFormat$formatIsoDate,
									'DD/MM/YYYY | hh:mm A',
									$elm$time$Time$utc,
									A3(
										$elm$core$String$replace,
										'.SSS',
										'',
										dataFromExpediente('fecha_emision_chie'))));
							var estadoFromNde = $author$project$Csf$Form$strFieldModel(
								A2($elm$core$Basics$composeR, dataFromExpediente, $author$project$Helpers$Utilities$estadoDelChie)('estado_chie'));
							var insertExp_ = A2($elm$core$Basics$composeR, dataFromExpediente, $author$project$Csf$Form$strFieldModel);
							var motivoRechazo = ('cancelled' === dataFromExpediente('approvement_outcome')) ? insertExp_('approvement_message') : insertExp_('validation_message');
							var propietarioFormattedRut = A3(
								$elm$core$Basics$composeR,
								$author$project$Helpers$Utilities$formatRut,
								$author$project$Csf$Form$strFieldModel,
								dataFromExpediente('cliente_rut'));
							var annoVehiculo = $author$project$Csf$Form$strFieldModel(
								A3(
									$author$project$Helpers$Utilities$decodeValue_,
									'',
									$author$project$Helpers$Utilities$forceStringDecoder,
									A3(
										$author$project$Csf$TaskNodeUtils$datavalue,
										$elm$json$Json$Encode$string(''),
										'ano',
										expNde)));
							var solicitudForm_ = A3(
								$elm$core$Dict$insert,
								'solicitud_fecha_anulacion',
								dateAnulacionChie,
								A3(
									$elm$core$Dict$insert,
									'solicitud_usuario_anulador',
									insertExp_('anulado_por_usuario'),
									A3(
										$elm$core$Dict$insert,
										'solicitud_nombre_anulador',
										insertExp_('anulado_por_nombre'),
										A3(
											$elm$core$Dict$insert,
											'solicitud_motivo_anulacion',
											insertExp_('motivo_anulacion'),
											A3(
												$elm$core$Dict$insert,
												'solicitud_causa_anulacion',
												insertExp_('causa_anulacion'),
												A3(
													$elm$core$Dict$insert,
													'solicitud_mensaje_validacion',
													insertExp_('validation_message'),
													A3(
														$elm$core$Dict$insert,
														'solicitud_motivo_rechazo',
														motivoRechazo,
														A3(
															$elm$core$Dict$insert,
															'solicitud_correlativo',
															insertExp_('correlativo'),
															A3(
																$elm$core$Dict$insert,
																'solicitud_fecha_emision',
																dateEmisionChie,
																A3(
																	$elm$core$Dict$insert,
																	'solicitud_estado',
																	estadoFromNde,
																	A3(
																		$elm$core$Dict$insert,
																		'solicitud_solicitante',
																		insertExp_('solicitante_email'),
																		A3(
																			$elm$core$Dict$insert,
																			'solicitud_fecha_solicitud_chie',
																			dateInsertAtChie,
																			A3(
																				$elm$core$Dict$insert,
																				'solicitud_documentos_naturaleza',
																				insertInscripcion_('documentos_naturaleza'),
																				A3(
																					$elm$core$Dict$insert,
																					'solicitud_documentos_fecha',
																					dateDocumentoInscripcion,
																					A3(
																						$elm$core$Dict$insert,
																						'solicitud_documentos_lugar',
																						insertInscripcion_('documentos_lugar'),
																						A3(
																							$elm$core$Dict$insert,
																							'solicitud_documentos_tipo',
																							insertInscripcion_('documentos_tipo'),
																							A3(
																								$elm$core$Dict$insert,
																								'solicitud_documentos_numero',
																								insertInscripcion_('documentos_numero'),
																								A3(
																									$elm$core$Dict$insert,
																									'solicitud_documentos_rut_emisor',
																									emisorFormattedRut,
																									A3(
																										$elm$core$Dict$insert,
																										'solicitud_documentos_autorizante',
																										insertInscripcion_('documentos_autorizante'),
																										A3(
																											$elm$core$Dict$insert,
																											'solicitud_fecha_solicitud',
																											dateSolicitudInscripcion,
																											A3(
																												$elm$core$Dict$insert,
																												'solicitud_inscripcion_email',
																												insertInscripcion_('adquiriente_correo'),
																												A3(
																													$elm$core$Dict$insert,
																													'solicitud_propietario_domicilio',
																													insertInscripcion_('adquiriente_domicilio'),
																													A3(
																														$elm$core$Dict$insert,
																														'solicitud_propietario_comuna',
																														insertExp_('cliente_comuna'),
																														A3(
																															$elm$core$Dict$insert,
																															'solicitud_propietario_nombre',
																															insertExp_('cliente_nombre'),
																															A3(
																																$elm$core$Dict$insert,
																																'solicitud_propietario_email',
																																insertExp_('cliente_correo'),
																																A3(
																																	$elm$core$Dict$insert,
																																	'solicitud_propietario_rut',
																																	propietarioFormattedRut,
																																	A3(
																																		$elm$core$Dict$insert,
																																		'solicitud_ppu',
																																		insertExp_('patente'),
																																		A3(
																																			$elm$core$Dict$insert,
																																			'solicitud_anno',
																																			annoVehiculo,
																																			A3(
																																				$elm$core$Dict$insert,
																																				'solicitud_color',
																																				insertExp_('color'),
																																				A3(
																																					$elm$core$Dict$insert,
																																					'solicitud_nro_motor',
																																					insertExp_('motor'),
																																					A3(
																																						$elm$core$Dict$insert,
																																						'solicitud_tipo_vehiculo',
																																						insertExp_('tipo'),
																																						A3(
																																							$elm$core$Dict$insert,
																																							'solicitud_modelo',
																																							insertExp_('modelo'),
																																							A3(
																																								$elm$core$Dict$insert,
																																								'solicitud_marca',
																																								insertExp_('marca'),
																																								A3(
																																									$elm$core$Dict$insert,
																																									'solicitud_cit',
																																									insertExp_('cit'),
																																									A3(
																																										$elm$core$Dict$insert,
																																										'solicitud_vin',
																																										insertExp_('vin'),
																																										model.l)))))))))))))))))))))))))))))))))));
							var model_ = _Utils_update(
								model,
								{cD: false, b: expNde, dj: $elm$core$Maybe$Nothing, l: solicitudForm_});
							return _Utils_Tuple2(
								model_,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[taskActions_, maybeCmdUpdateExtensions_])));
						} else {
							var error = mssg_.a.a;
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'file_details_failed');
							return A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{cD: false}),
								('redirect_' === handled_) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_));
						}
					case 49:
						if (!mssg_.a.$) {
							var documents_ = mssg_.a.a;
							var modelMapFirst_ = A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$boolModuleRemove('docs_loading'),
								$author$project$Page$SolicitudesChie$boolModuleRemove('docs_failed'));
							var docsFilter = function (field_) {
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Basics$eq(field_),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.dm;
										},
										$author$project$TaskNode$typeOrEmpty));
							};
							var activeDocument_ = A2(
								$elm$core$Maybe$withDefault,
								'',
								A3(
									$elm$core$Basics$composeR,
									$elm$core$List$head,
									$elm$core$Maybe$map(
										function ($) {
											return $.p;
										}),
									function (_v26) {
										var first_ = _v26.a;
										var second_ = _v26.b;
										return _Utils_ap(first_, second_);
									}(
										A2(
											$elm$core$List$partition,
											docsFilter('solicitud_primera_inscripcion'),
											A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													docsFilter('chie_data'),
													$elm$core$Basics$not),
												documents_)))));
							return A2(
								$elm$core$Tuple$mapFirst,
								modelMapFirst_,
								function (model_) {
									return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
								}(
									_Utils_update(
										model,
										{
											aK: activeDocument_,
											b5: $elm$core$List$reverse(
												A2(
													$elm$core$List$sortBy,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.dm;
														},
														$author$project$TaskNode$insertedAtOrEmpty),
													A2(
														$elm$core$List$filter,
														A2(
															$elm$core$Basics$composeR,
															docsFilter('solicitud_chie'),
															$elm$core$Basics$not),
														documents_)))
										})));
						} else {
							var error_ = mssg_.a.a;
							var modelMapFirst_ = A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$boolModuleRemove('docs_loading'),
								A2($author$project$Page$SolicitudesChie$boolToModule, 'docs_failed', true));
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'file_documents_failed');
							return ('redirect_' === handled_) ? A2(
								$elm$core$Tuple$pair,
								model,
								$author$project$Helpers$ApiHandler$toUserHome(session)) : A2(
								$elm$core$Tuple$mapFirst,
								modelMapFirst_,
								A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{aK: '', b5: _List_Nil}),
									A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_)));
						}
					case 50:
						if (!mssg_.a.$) {
							var taskHistory_ = mssg_.a.a;
							var modelMapFirst_ = A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$boolModuleRemove('history_loading'),
								$author$project$Page$SolicitudesChie$boolModuleRemove('history_failed'));
							return A2(
								$elm$core$Tuple$mapFirst,
								modelMapFirst_,
								A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{
											b6: A2(
												$elm$core$List$filter,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.dm;
													},
													A2(
														$elm$core$Basics$composeR,
														A2(
															$elm$core$Basics$composeR,
															$author$project$TaskNode$string('status'),
															$elm$core$Maybe$withDefault('')),
														$elm$core$Basics$neq('hidden'))),
												taskHistory_)
										}),
									$elm$core$Platform$Cmd$none));
						} else {
							var error_ = mssg_.a.a;
							var modelMapFirst_ = A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$boolModuleRemove('history_loading'),
								A2($author$project$Page$SolicitudesChie$boolToModule, 'history_failed', true));
							var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'file_history_failed');
							return ('redirect_' === handled_) ? A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{b6: _List_Nil}),
								$author$project$Helpers$ApiHandler$toUserHome(session)) : A2(
								$elm$core$Tuple$mapFirst,
								modelMapFirst_,
								A2(
									$elm$core$Tuple$pair,
									_Utils_update(
										model,
										{b6: _List_Nil}),
									A2($author$project$Page$SolicitudesChie$doNotify, 'error', handled_)));
						}
					case 51:
						var pagerMsg = mssg_.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (pager_) {
								return _Utils_update(
									model,
									{aF: pager_});
							},
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesChie$NodePagerMsg),
								A2($author$project$Csf$NodePager$update, pagerMsg, model.aF)));
					case 52:
						var fbadgesMsg = mssg_.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (badges_) {
								return _Utils_update(
									model,
									{b8: badges_});
							},
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesChie$FilterBadgesMsg),
								A2($author$project$Csf$FilterBadges$update, fbadgesMsg, model.b8)));
					case 53:
						var field_ = mssg_.a;
						var dropdownMsg = mssg_.b;
						var key_ = $author$project$Page$SolicitudesChie$stringFromField(field_);
						var proceedToScrool = function (_v30) {
							var mdel = _v30.a;
							var cmdAction_ = _v30.b;
							return function (_v29) {
								var dropdownId = _v29.cF;
								var dropdownOpen = _v29.bj;
								return dropdownOpen ? A2(
									$elm$core$Tuple$pair,
									mdel,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												cmdAction_,
												$author$project$Ports$scrollGrandToBottom(dropdownId)
											]))) : A2($elm$core$Tuple$pair, mdel, cmdAction_);
							}(
								A2($author$project$Helpers$Utilities$getDropdown, key_, mdel));
						};
						var handleMssg_ = function (action_) {
							return A5(
								$author$project$Helpers$Utilities$handleDropdownMssg,
								key_,
								$author$project$Page$SolicitudesChie$DropdownMsg(field_),
								dropdownMsg,
								action_,
								model);
						};
						switch (field_) {
							case 10:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('estado'));
							case 4:
								var onPicked_ = F2(
									function (_v28, mdel) {
										return A2(
											$elm$core$Tuple$pair,
											_Utils_update(
												mdel,
												{
													Q: $author$project$Csf$Form$strFieldModel('')
												}),
											$elm$core$Platform$Cmd$none);
									});
								return handleMssg_(onPicked_);
							case 14:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('dealer'));
							case 13:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('importer'));
							case 15:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('conciliate'));
							case 11:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('tipo_vehiculo'));
							case 12:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('motor'));
							case 6:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('anno'));
							case 7:
								return handleMssg_(
									$author$project$Page$SolicitudesChie$updateQueryFromDropdown('color'));
							case 8:
								return proceedToScrool(
									handleMssg_(
										$author$project$Page$SolicitudesChie$updateQueryFromDropdown('marca')));
							case 9:
								return proceedToScrool(
									handleMssg_(
										$author$project$Page$SolicitudesChie$updateQueryFromDropdown('modelo')));
							default:
								return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
						}
					case 54:
						switch (mssg_.a.$) {
							case 3:
								switch (mssg_.a.a) {
									case 'expediente_details':
										var _v31 = mssg_.a;
										var taskNode_ = _v31.b;
										return A2($author$project$Page$SolicitudesChie$handleExpedienteDetails, taskNode_, model);
									case 'toggle_error_tooltip':
										var _v32 = mssg_.a;
										var taskNode_ = _v32.b;
										return _Utils_Tuple2(
											model,
											A2(
												$author$project$Helpers$Utilities$delay,
												0,
												$author$project$Page$SolicitudesChie$ToggleErrorTooltip(taskNode_.p)));
									default:
										break _v0$73;
								}
							case 2:
								var state_ = mssg_.a.a;
								return A4(
									$author$project$Helpers$ApiHandler$handleTableSort,
									state_,
									model,
									$author$project$Page$SolicitudesChie$allowedToSortBy(session),
									$author$project$Route$SolicitudesChie($author$project$Route$emptyData));
							default:
								break _v0$73;
						}
					case 55:
						var notifyMsg = mssg_.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (_v33) {
								var toasties = _v33.a7;
								return _Utils_update(
									model,
									{
										g$: _Utils_update(
											session,
											{a7: toasties})
									});
							},
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesChie$NotificationsMsg),
								A2(
									$author$project$Csf$Notifications$update,
									notifyMsg,
									{a7: session.a7})));
					default:
						break _v0$75;
				}
			}
			return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
		}
		var tableMsg = mssg_.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (table_) {
				return _Utils_update(
					model,
					{jb: table_});
			},
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesChie$TableMsg),
				A2($author$project$Csf$Table$update, tableMsg, model.jb)));
	});
var $author$project$Page$SolicitudesPendientes$DateOnQuery = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$DateTimePickerChanged = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$FilterBadgesMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Page$SolicitudesPendientes$FilterOnDelay = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$SolicitudesPendientes$GotStockVins = function (a) {
	return {$: 38, a: a};
};
var $author$project$Page$SolicitudesPendientes$HandleVinData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$SolicitudesPendientes$NodeDownloaded = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$NodePagerMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Page$SolicitudesPendientes$NotificationsMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Page$SolicitudesPendientes$OnSolicitudUpdated = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$OpenDateTimePicker = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$ParseDatesToISO = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$SolicitudesPendientes$ReloadModule = {$: 1};
var $author$project$Page$SolicitudesPendientes$TableMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$SolicitudesPendientes$TaskForwarded = function (a) {
	return {$: 37, a: a};
};
var $author$project$Page$SolicitudesPendientes$TasksLoaded = function (a) {
	return {$: 36, a: a};
};
var $author$project$Page$SolicitudesPendientes$TransitioningOFF = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$SolicitudesPendientes$VinsFounded = function (a) {
	return {$: 40, a: a};
};
var $author$project$Config$ApiEndpoint$chietaskreview = F3(
	function (ticket_, task_id, task_action) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-request-service', 'task-service', 'task', 'review', task_id, task_action]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$processChieReview = F4(
	function (ticket_, action_, uuid, jsonPayload) {
		return A3(
			$author$project$Helpers$ApiHandler$post,
			A3($author$project$Config$ApiEndpoint$chietaskreview, ticket_, uuid, action_),
			_List_Nil,
			$elm$http$Http$jsonBody(jsonPayload));
	});
var $author$project$Csf$AlbertoApi$api = 'api';
var $author$project$Csf$AlbertoApi$qsTicket = $elm$url$Url$Builder$string('alf_ticket');
var $author$project$Csf$AlbertoApi$url = F2(
	function (path, queryParams) {
		return A2($elm$url$Url$Builder$absolute, path, queryParams);
	});
var $author$project$Csf$AlbertoApi$findNodeEndpoint = function (_v0) {
	var id = _v0.p;
	var tenant = _v0.jg;
	var ticket = _v0.d;
	return A2(
		$author$project$Csf$AlbertoApi$url,
		_List_fromArray(
			[$author$project$Csf$AlbertoApi$api, 'extended-api', 'node', 'find', tenant, id]),
		_List_fromArray(
			[
				$author$project$Csf$AlbertoApi$qsTicket(ticket)
			]));
};
var $author$project$Csf$Call$resolverJson = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$author$project$Csf$Call$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($author$project$Csf$Call$Timeout);
				case 2:
					return $elm$core$Result$Err($author$project$Csf$Call$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					var ret = $elm$core$Result$Err(
						A2($author$project$Csf$Call$BadStatus, metadata.bE, body));
					var _v1 = metadata.bE;
					switch (_v1) {
						case 401:
							return $elm$core$Result$Err($author$project$Csf$Call$Unauthorized);
						case 400:
							if ($author$project$Csf$Call$isJSON(metadata.i)) {
								var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Csf$Call$decoder401, body);
								if (!_v2.$) {
									var invalidCredentials = _v2.a;
									return (invalidCredentials.hP === '401') ? $elm$core$Result$Err($author$project$Csf$Call$Unauthorized) : ret;
								} else {
									return ret;
								}
							} else {
								return ret;
							}
						case 500:
							var _v3 = A2($elm$json$Json$Decode$decodeString, $author$project$Csf$Call$decoderNullTicket, body);
							if (!_v3.$) {
								var invalidTicket = _v3.a;
								return _Utils_eq(invalidTicket.fj, $author$project$Csf$Call$invalidTicketDesc) ? $elm$core$Result$Err($author$project$Csf$Call$Unauthorized) : ret;
							} else {
								var ret1 = _v3.a;
								return ret;
							}
						default:
							return ret;
					}
				default:
					var metadata = response.a;
					var body = response.b;
					var _v4 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v4.$) {
						var value = _v4.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v4.a;
						return $elm$core$Result$Err(
							$author$project$Csf$Call$BadBody(
								$elm$json$Json$Decode$errorToString(err)));
					}
			}
		});
};
var $author$project$Csf$AlbertoApi$taskFindNode = function (req) {
	return $elm$http$Http$task(
		{
			h: $elm$http$Http$emptyBody,
			i: _List_Nil,
			j: 'GET',
			k: $author$project$Csf$Call$resolverJson($author$project$Csf$AlbertoApi$decoderTaskNode),
			m: $elm$core$Maybe$Nothing,
			q: $author$project$Csf$AlbertoApi$findNodeEndpoint(req)
		});
};
var $author$project$Page$SolicitudesPendientes$ModuleActions$forwardingTask = F3(
	function (forwardData, inscripcionJson, jsonBody) {
		var outcome_code = A2(
			$elm$core$Result$withDefault,
			1,
			function (decoder_) {
				return A2($elm$json$Json$Decode$decodeValue, decoder_, jsonBody);
			}(
				A2($elm$json$Json$Decode$field, 'approvement_outcome_code', $elm$json$Json$Decode$int)));
		var fromData = function (key_) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, key_, forwardData));
		};
		var inscripcion_ = fromData('inscripcion');
		var namespace_ = fromData('namespace');
		var task_id = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$withDefault(''),
			$elm$core$List$reverse(
				A2($elm$core$String$split, '/', namespace_)));
		var tenant_ = fromData('tenant');
		var ticket_ = fromData('ticket');
		var vehicle_vin = fromData('vehicle_vin');
		var ficha_ = fromData('ficha_tecnica');
		var andThenFromNode = function (tNde) {
			return A4(
				$author$project$Helpers$ApiHandler$actualizarNode,
				ticket_,
				tenant_,
				tNde.p,
				A3(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					$elm$json$Json$Encode$object,
					function (solicitados) {
						return _Utils_Tuple2(
							'chie_solicitados',
							$elm$json$Json$Encode$int(solicitados));
					}(
						A3(
							$elm$core$Basics$composeR,
							$elm$core$Basics$add(-1),
							$elm$core$Basics$max(0),
							A3($author$project$Csf$TaskNodeUtils$dataint, 0, 'chie_solicitados', tNde)))));
		};
		var mapAndThenLote = function (lote_uuid) {
			return A2(
				$elm$core$Task$andThen,
				andThenFromNode,
				$author$project$Csf$AlbertoApi$taskFindNode(
					{p: lote_uuid, jg: tenant_, d: ticket_}));
		};
		var andThenFromSearch = function (sData) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Task$succeed($author$project$TaskNode$emptyTask),
				A2(
					$elm$core$Maybe$map,
					mapAndThenLote,
					A2(
						$author$project$Csf$TaskNodeUtils$mbstring,
						'lote_vehiculos',
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$TaskNode$emptyTask,
							$elm$core$List$head(sData.kh)))));
		};
		var _v0 = (!outcome_code) ? A2($elm$core$Tuple$pair, 'pendiente_firma', 'approval') : A2($elm$core$Tuple$pair, 'solicitud_anulada', 'rejection');
		var estado_chie = _v0.a;
		var task_action = _v0.b;
		var updateFichaTecnicaVehicular_ = $author$project$Helpers$Utilities$trimmedEmpty(ficha_) ? $elm$core$Task$succeed($author$project$TaskNode$emptyTask) : A4(
			$author$project$Helpers$ApiHandler$actualizarNode,
			ticket_,
			tenant_,
			ficha_,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'estado_chie',
						$elm$json$Json$Encode$string(estado_chie))
					])));
		var updateLoteVehiculos_ = ('solicitud_anulada' === estado_chie) ? A2(
			$elm$core$Task$andThen,
			andThenFromSearch,
			A2(
				$elm$core$Task$map,
				A2($author$project$Helpers$Utilities$decodeString_, $author$project$Helpers$ApiHandler$emptySearchResp, $author$project$Helpers$ApiHandler$taskManagerDecoder),
				A2(
					$author$project$Helpers$ApiHandler$get,
					A3($author$project$Config$ApiEndpoint$vehiclesbyfield, ticket_, 'vin', vehicle_vin),
					_List_Nil))) : $elm$core$Task$succeed($author$project$TaskNode$emptyTask);
		var updateInscripcion_ = ('approval' === task_action) ? A4($author$project$Helpers$ApiHandler$actualizarNode, ticket_, tenant_, inscripcion_, inscripcionJson) : $elm$core$Task$succeed($author$project$TaskNode$emptyTask);
		return A2(
			$elm$core$Task$andThen,
			function (_v3) {
				return updateFichaTecnicaVehicular_;
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return updateLoteVehiculos_;
				},
				A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return updateInscripcion_;
					},
					A4($author$project$Helpers$ApiHandler$processChieReview, ticket_, task_action, task_id, jsonBody))));
	});
var $author$project$Helpers$Utilities$replaceInString = F3(
	function (slice_, replace_, string_) {
		return A2(
			$elm$core$Maybe$withDefault,
			string_,
			A2(
				$elm$core$Maybe$map,
				function (regex_) {
					return A3(
						$elm$regex$Regex$replace,
						regex_,
						function (_v0) {
							return replace_;
						},
						string_);
				},
				$elm$regex$Regex$fromString(slice_)));
	});
var $author$project$Page$SolicitudesPendientes$ModuleActions$approveRequest = F3(
	function (model, onValid_, onInvalid_) {
		var session = model.g$;
		var taskLoaded = model.fF;
		var solicitudForm = model.l;
		var validateVinLength = A2($author$project$Csf$Form$AllowedExpression, '^[0-9A-Z]{17}$', 'Longitud de VIN incorrecta (17 caracteres)');
		var validateVhTypeDropdown = function (mdel) {
			return function (d) {
				return A3(
					$author$project$Helpers$Utilities$updateDropdown,
					$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(7),
					d,
					mdel);
			}(
				A2(
					$author$project$Customized$CustomDropdown$validateRequired,
					true,
					A2(
						$author$project$Helpers$Utilities$getDropdown,
						$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(7),
						mdel)));
		};
		var validateRutFormat = A2($author$project$Csf$Form$AllowedExpression, $author$project$Helpers$Utilities$allowedRutFormat, 'Formato de RUT inválido');
		var validateForm = F3(
			function (key_, validation_, formDict) {
				return function (strField_) {
					return A3($elm$core$Dict$insert, key_, strField_, formDict);
				}(
					A3(
						$elm$core$Basics$composeR,
						A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim),
						$author$project$Csf$Form$strValidator(validation_),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Csf$Form$strFieldModel(''),
							A2($elm$core$Dict$get, key_, formDict))));
			});
		var validatedSolicitudForm_ = A3(
			validateForm,
			'inscripcion_adquiriente_correo',
			_List_fromArray(
				[$author$project$Csf$Form$Email]),
			A3(
				validateForm,
				'inscripcion_documentos_numero',
				_List_fromArray(
					[$author$project$Csf$Form$Required]),
				A3(
					validateForm,
					'inscripcion_documentos_numero',
					_List_fromArray(
						[$author$project$Csf$Form$Required]),
					A3(
						validateForm,
						'solicitud_cliente_rut',
						_List_fromArray(
							[$author$project$Csf$Form$Required, validateRutFormat]),
						A3(
							validateForm,
							'solicitud_distribuidor_rut',
							_List_fromArray(
								[$author$project$Csf$Form$Required, validateRutFormat]),
							A3(
								validateForm,
								'solicitud_distribuidor',
								_List_fromArray(
									[$author$project$Csf$Form$Required]),
								A3(
									validateForm,
									'solicitud_email',
									_List_fromArray(
										[$author$project$Csf$Form$Required, $author$project$Csf$Form$Email]),
									A3(
										validateForm,
										'solicitud_cit',
										_List_fromArray(
											[$author$project$Csf$Form$Required]),
										A3(
											validateForm,
											'solicitud_vin',
											_List_fromArray(
												[$author$project$Csf$Form$Required, validateVinLength]),
											A3(
												validateForm,
												'solicitud_ppu',
												_List_fromArray(
													[$author$project$Csf$Form$Required]),
												A3(
													validateForm,
													'solicitud_ano',
													_List_fromArray(
														[$author$project$Csf$Form$Required]),
													A3(
														validateForm,
														'solicitud_color',
														_List_fromArray(
															[$author$project$Csf$Form$Required]),
														A3(
															validateForm,
															'solicitud_marca',
															_List_fromArray(
																[$author$project$Csf$Form$Required]),
															A3(
																validateForm,
																'solicitud_modelo',
																_List_fromArray(
																	[$author$project$Csf$Form$Required]),
																A3(
																	validateForm,
																	'solicitud_nro_motor',
																	_List_fromArray(
																		[$author$project$Csf$Form$Required]),
																	A3(
																		validateForm,
																		'solicitud_tipo_vehiculo',
																		_List_fromArray(
																			[$author$project$Csf$Form$Required]),
																		solicitudForm))))))))))))))));
		var processInscripcionKey_ = function (key_) {
			return A2(
				$author$project$Helpers$Utilities$removeFromString,
				'inscripcion_',
				A2(
					$author$project$Helpers$Utilities$removeFromString,
					'nro_',
					A3(
						$author$project$Helpers$Utilities$replaceInString,
						'^solicitud_',
						'vehiculo_',
						A3(
							$elm$core$String$replace,
							'solicitud_distribuidor',
							'documentos_autorizante',
							A3(
								$elm$core$String$replace,
								'solicitud_distribuidor_rut',
								'documentos_rut_emisor',
								A3($elm$core$String$replace, 'solicitud_cliente', 'adquiriente', key_))))));
		};
		var processExpedienteKey_ = function (key_) {
			return A3(
				$elm$core$String$replace,
				'email',
				'cliente_correo',
				A3(
					$elm$core$String$replace,
					'ppu',
					'patente',
					A3(
						$elm$core$String$replace,
						'nro_',
						'',
						A3(
							$elm$core$String$replace,
							'_vehiculo',
							'',
							A3($elm$core$String$replace, 'solicitud_', '', key_)))));
		};
		var node_ = A3(
			$author$project$Helpers$Utilities$decodeMbValue,
			$author$project$TaskNode$emptyTask,
			$author$project$Csf$AlbertoApi$decoderTaskNode,
			A2($author$project$Csf$TaskNodeUtils$mbvalue, 'node', taskLoaded));
		var namespace_ = A3(
			$author$project$Csf$TaskNodeUtils$string,
			'',
			'namespace',
			A3(
				$author$project$Helpers$Utilities$decodeMbValue,
				$author$project$TaskNode$emptyTask,
				$author$project$Helpers$ApiHandler$decodeTaskNode,
				A2($author$project$Csf$TaskNodeUtils$mbvalue, 'task', taskLoaded)));
		var fromNode = function (key_) {
			return A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, node_);
		};
		var formFieldValue_ = F2(
			function (key_, solicitudForm_) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim),
						A2($elm$core$Dict$get, key_, solicitudForm_)));
			});
		var tipoVehiculo_ = A2(formFieldValue_, 'solicitud_tipo_vehiculo', validatedSolicitudForm_);
		var invalidFormPPU_ = A2(
			$author$project$Helpers$Utilities$isInvalidPPU_,
			tipoVehiculo_,
			A2(formFieldValue_, 'solicitud_ppu', validatedSolicitudForm_));
		var expedienteJson_ = F2(
			function (expKey_, fieldValue_) {
				return (!_Utils_eq(
					fromNode(expKey_),
					fieldValue_)) ? _List_fromArray(
					[
						A2(
						$elm$core$Tuple$pair,
						expKey_,
						$elm$json$Json$Encode$string(fieldValue_))
					]) : _List_Nil;
			});
		var encodeMapValue_ = function (val) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Encode$string,
					$author$project$Helpers$Utilities$stringToMaybe(val)));
		};
		var data_ = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('unique_id', node_.p),
					_Utils_Tuple2('namespace', namespace_),
					_Utils_Tuple2(
					'ticket',
					$author$project$Csf$Flags$ticket(session.ka)),
					_Utils_Tuple2(
					'tenant',
					A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', node_)),
					_Utils_Tuple2(
					'inscripcion',
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'solicitud_inscripcion', node_)),
					_Utils_Tuple2(
					'ficha_tecnica',
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'ficha_tecnica_vehicular', node_))
				]));
		var correctFormVType_ = function (formField_) {
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$correctTipoVehiculo_,
				$author$project$Csf$Form$strFieldModel,
				A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(formField_));
		};
		var correctFormRutFormat_ = function (formField_) {
			return A3(
				$elm$core$Basics$composeR,
				A2($elm$core$String$replace, '.', ''),
				$author$project$Csf$Form$strFieldModel,
				A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(formField_));
		};
		var correctFormPPU_ = function (formField_) {
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$correctVehiclePPU_(tipoVehiculo_),
				$author$project$Csf$Form$strFieldModel,
				A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(formField_));
		};
		var correctFormDocumentDate_ = function (formField_) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(''),
				$author$project$Csf$Form$strFieldModel,
				A3(
					$elm$core$Basics$composeR,
					$elm$core$String$split('T'),
					$elm$core$List$head,
					A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(formField_)));
		};
		var clearedSolicitudForm = A3(
			$elm$core$Dict$update,
			'inscripcion_documentos_fecha',
			$elm$core$Maybe$map(correctFormDocumentDate_),
			A3(
				$elm$core$Dict$update,
				'solicitud_distribuidor_rut',
				$elm$core$Maybe$map(correctFormRutFormat_),
				A3(
					$elm$core$Dict$update,
					'solicitud_cliente_rut',
					$elm$core$Maybe$map(correctFormRutFormat_),
					A3(
						$elm$core$Dict$update,
						'solicitud_tipo_vehiculo',
						$elm$core$Maybe$map(correctFormVType_),
						A3(
							$elm$core$Dict$update,
							'solicitud_ppu',
							$elm$core$Maybe$map(correctFormPPU_),
							A2(
								$elm$core$Dict$remove,
								'solicitud_solicitante',
								A2(
									$elm$core$Dict$remove,
									'solicitud_fecha',
									A2($elm$core$Dict$remove, 'solicitud_estado', validatedSolicitudForm_))))))));
		var expedienteFormMap_ = function (key_) {
			return A2($elm$core$String$startsWith, 'solicitud_', key_) ? A3(
				$elm$core$Basics$composeR,
				expedienteJson_(
					processExpedienteKey_(key_)),
				$elm$core$Maybe$Just,
				A2(formFieldValue_, key_, clearedSolicitudForm)) : $elm$core$Maybe$Nothing;
		};
		var expedienteJsonBody = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$filterMap(expedienteFormMap_),
			$elm$core$List$concat,
			$elm$core$Dict$keys(clearedSolicitudForm));
		var inscripcionFormMap_ = function (key_) {
			return A2(
				$elm$core$Tuple$pair,
				processInscripcionKey_(key_),
				A2(
					$elm$core$Basics$composeR,
					formFieldValue_(key_),
					encodeMapValue_)(clearedSolicitudForm));
		};
		var inscripcionJsonBody = $elm$json$Json$Encode$object(
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Dict$keys,
				$elm$core$List$map(inscripcionFormMap_),
				A2(
					$elm$core$Dict$remove,
					'solicitud_email',
					A2($elm$core$Dict$remove, 'solicitud_cit', clearedSolicitudForm))));
		var atLeastOneInvalid = A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeR, $author$project$Csf$Form$strIsValid, $elm$core$Basics$not),
			$elm$core$Dict$values(validatedSolicitudForm_));
		return A2(
			$elm$core$Tuple$mapFirst,
			A2(
				$elm$core$Basics$composeR,
				validateVhTypeDropdown,
				function (mdl) {
					return _Utils_update(
						mdl,
						{l: validatedSolicitudForm_});
				}),
			(atLeastOneInvalid || invalidFormPPU_) ? A2(
				$elm$core$Tuple$pair,
				_Utils_update(
					model,
					{ar: invalidFormPPU_}),
				onInvalid_) : A2(
				$elm$core$Tuple$pair,
				_Utils_update(
					model,
					{e: true, ar: invalidFormPPU_}),
				A2(
					$elm$core$Task$attempt,
					onValid_,
					A3(
						$author$project$Page$SolicitudesPendientes$ModuleActions$forwardingTask,
						data_,
						inscripcionJsonBody,
						A3(
							$elm$core$Basics$composeR,
							$elm$core$Basics$append(expedienteJsonBody),
							$elm$json$Json$Encode$object,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'approvement_message',
									$elm$json$Json$Encode$string('approved')),
									_Utils_Tuple2(
									'approvement_outcome_code',
									$elm$json$Json$Encode$int(0))
								]))))));
	});
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('aprobar_emision_header_title', 'Revisar Solicitudes CHI-e'),
		_Utils_Tuple2('aprobar_emision_card_title', 'Aprobar solicitud'),
		_Utils_Tuple2('aprobar_emision_card_title_loaded', 'Tareas pendientes'),
		_Utils_Tuple2('firmar_certificado_header_title', 'Firmar Solicitudes CHI-e'),
		_Utils_Tuple2('firmar_certificado_card_title', 'Fimar solicitud'),
		_Utils_Tuple2('firmar_certificado_card_title_loaded', 'Tareas por fimar'),
		_Utils_Tuple2('vinsearch_failed', 'Lo sentimos, ha ocurrido un error en la consulta al Stock.'),
		_Utils_Tuple2('task_details_failed', 'Ha ocurrido un error al consultar los detalles de la tarea.'),
		_Utils_Tuple2('aprobar_emision_tasks_empty', 'No hay Tareas Pendientes.'),
		_Utils_Tuple2('firmar_certificado_tasks_empty', 'No hay Tareas por Firmar.'),
		_Utils_Tuple2('task_load_failed', 'Lo sentimos, no ha sido posible listar las tareas.'),
		_Utils_Tuple2('approved_ok', 'La solicitud ha sido aprobada correctamente.'),
		_Utils_Tuple2('approved_failed', 'Lo sentimos, ha ocurrido un error durante el proceso de aprobación.'),
		_Utils_Tuple2('nullify_ok', 'La solicitud ha sido anulada correctamente.'),
		_Utils_Tuple2('nullify_failed', 'Lo sentimos, ha ocurrido un error durante el proceso de anulación.')
	]);
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleCaptions_));
};
var $author$project$Page$SolicitudesPendientes$doNotify = F2(
	function (type_, key_) {
		return A3(
			$author$project$Helpers$Utilities$setNotification,
			$author$project$Page$SolicitudesPendientes$NotificationsMsg,
			type_,
			$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(key_));
	});
var $author$project$Page$SolicitudesPendientes$handleDealerDropdown = F2(
	function (dropdownMsg, _v0) {
		var model = _v0.a;
		var dropdownCmd = _v0.b;
		var solicitudForm_ = function (fieldData_) {
			return function (strField) {
				return A3($elm$core$Dict$insert, 'solicitud_distribuidor', strField, model.l);
			}(
				A2(
					$author$project$Csf$Form$strValidator,
					_List_fromArray(
						[$author$project$Csf$Form$Required]),
					fieldData_));
		};
		var cmdAction_ = A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Page$SolicitudesPendientes$InputDropdownMsg(1),
			dropdownCmd);
		return function (model_) {
			return A2($elm$core$Tuple$pair, model_, cmdAction_);
		}(
			function () {
				if (dropdownMsg.$ === 3) {
					var dealer_ = dropdownMsg.a;
					return _Utils_update(
						model,
						{
							l: solicitudForm_(dealer_)
						});
				} else {
					return model;
				}
			}());
	});
var $author$project$Page$SolicitudesPendientes$ModuleActions$handleNamespaceDetails = F2(
	function (taskNode, model) {
		var session = model.g$;
		var taskName = model.jd;
		var taskname_ = A3($author$project$Csf$TaskNodeUtils$string, '', 'name', taskNode);
		var pageRoute_ = A2(
			$elm$core$List$member,
			taskName,
			_List_fromArray(
				['chie_firmar_certificado', 'chie_firmar_certificado_extension'])) ? $author$project$Route$PendientesDeFirma : $author$project$Route$PendientesAprobacion;
		var addToQuery = function (namespace_) {
			return A3($author$project$Route$appendToQuery, 'namespace', namespace_, $author$project$Route$emptyData.iI);
		};
		return A3(
			$elm$core$Basics$composeR,
			$author$project$Route$goTo(session.gL),
			$elm$core$Tuple$pair(model),
			function (query_) {
				return pageRoute_(
					{iI: query_});
			}(
				A3(
					$elm$core$Basics$composeR,
					$elm$core$String$join(''),
					addToQuery,
					A2(
						$elm$core$String$split,
						'//' + (taskname_ + '/'),
						A3($author$project$Csf$TaskNodeUtils$string, '', 'namespace', taskNode)))));
	});
var $author$project$Page$SolicitudesPendientes$handleNotifications = F2(
	function (model, _v0) {
		var session = model.g$;
		var taskName = model.jd;
		var toasties = _v0.a.a7;
		var notifyCmd_ = _v0.b;
		var pageRoute_ = (taskName === 'chie_firmar_certificado') ? $author$project$Route$PendientesDeFirma : $author$project$Route$PendientesAprobacion;
		var onNullify_ = function (removed_) {
			return model.e && removed_;
		}(
			(!A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('nullify_ok'),
				toasties)) && A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('nullify_ok'),
				session.a7));
		var onApprove_ = function (removed_) {
			return model.e && removed_;
		}(
			(!A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('approved_ok'),
				toasties)) && A3(
				$author$project$Helpers$Utilities$hasNotification,
				'success',
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('approved_ok'),
				session.a7));
		return A2(
			$elm$core$Tuple$pair,
			_Utils_update(
				model,
				{
					g$: _Utils_update(
						session,
						{a7: toasties})
				}),
			(onApprove_ || onNullify_) ? $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						notifyCmd_,
						A2(
						$author$project$Route$goTo,
						session.gL,
						pageRoute_($author$project$Route$emptyData))
					])) : notifyCmd_);
	});
var $author$project$Page$SolicitudesPendientes$VehicleVinFound = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$SolicitudesPendientes$handleVinDropdown = F2(
	function (dropdownMsg, _v0) {
		var model = _v0.a;
		var session = model.g$;
		var dropdownCmd = _v0.b;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var solicitudForm_ = function (fieldData_) {
			return function (strField) {
				return A3($elm$core$Dict$insert, 'solicitud_vin', strField, model.l);
			}(
				A2(
					$author$project$Csf$Form$strValidator,
					_List_fromArray(
						[$author$project$Csf$Form$Required]),
					fieldData_));
		};
		if (dropdownMsg.$ === 3) {
			var vinNumber_ = dropdownMsg.a;
			return A2(
				$elm$core$Tuple$pair,
				_Utils_update(
					model,
					{
						e: true,
						l: solicitudForm_(vinNumber_)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Page$SolicitudesPendientes$InputDropdownMsg(0),
							dropdownCmd),
							A2(
							$elm$core$Task$attempt,
							$author$project$Page$SolicitudesPendientes$VehicleVinFound,
							A2($author$project$Helpers$ApiHandler$vehiculoByVin, ticket_, vinNumber_))
						])));
		} else {
			return A2(
				$elm$core$Tuple$pair,
				model,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Page$SolicitudesPendientes$InputDropdownMsg(0),
					dropdownCmd));
		}
	});
var $author$project$Config$ApiEndpoint$chie_extensionspagedtasks = F4(
	function (from_, size_, sort_, ticket_) {
		return A2(
			$author$project$Config$ApiEndpoint$url,
			_List_fromArray(
				['chie-extension-service', 'api', 'tasks', 'from', from_, 'size', size_, 'sort', sort_]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'alf_ticket', ticket_)
				]));
	});
var $author$project$Helpers$ApiHandler$listarSolicitudesExtensiones = F4(
	function (ticket_, sorter_, _v0, tasks_name) {
		var from_ = _v0.a;
		var size_ = _v0.b;
		return A2(
			$elm$core$Task$map,
			A2($author$project$Helpers$Utilities$decodeString_, $author$project$Helpers$ApiHandler$emptySearchResp, $author$project$Helpers$ApiHandler$taskManagerDecoder),
			A3(
				$author$project$Helpers$ApiHandler$post,
				A4($author$project$Config$ApiEndpoint$chie_extensionspagedtasks, from_, size_, sorter_, ticket_),
				_List_Nil,
				$elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'task_names',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, tasks_name))
							])))));
	});
var $author$project$Page$SolicitudesPendientes$ModuleActions$nullifyRequest = F2(
	function (model, actionMsg) {
		var session = model.g$;
		var nullifyMssgField = model.df;
		var taskLoaded = model.fF;
		var node_ = A3(
			$author$project$Helpers$Utilities$decodeMbValue,
			$author$project$TaskNode$emptyTask,
			$author$project$Csf$AlbertoApi$decoderTaskNode,
			A2($author$project$Csf$TaskNodeUtils$mbvalue, 'node', taskLoaded));
		var namespace_ = A3(
			$author$project$Csf$TaskNodeUtils$string,
			'',
			'namespace',
			A3(
				$author$project$Helpers$Utilities$decodeMbValue,
				$author$project$TaskNode$emptyTask,
				$author$project$Helpers$ApiHandler$decodeTaskNode,
				A2($author$project$Csf$TaskNodeUtils$mbvalue, 'task', taskLoaded)));
		var msgField_ = A3(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			$author$project$Csf$Form$strValidator(
				_List_fromArray(
					[$author$project$Csf$Form$Required])),
			$author$project$Csf$Form$strVal(nullifyMssgField));
		var data_ = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('unique_id', node_.p),
					_Utils_Tuple2('namespace', namespace_),
					_Utils_Tuple2(
					'ticket',
					$author$project$Csf$Flags$ticket(session.ka)),
					_Utils_Tuple2(
					'tenant',
					A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', node_)),
					_Utils_Tuple2(
					'vehicle_vin',
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'vin', node_)),
					_Utils_Tuple2(
					'ficha_tecnica',
					A3($author$project$Csf$TaskNodeUtils$datastring, '', 'ficha_tecnica_vehicular', node_))
				]));
		return A2(
			$elm$core$Tuple$mapFirst,
			function (m) {
				return _Utils_update(
					m,
					{df: msgField_});
			},
			A2($elm$core$Basics$composeR, $author$project$Csf$Form$strIsValid, $elm$core$Basics$not)(msgField_) ? A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none) : A2(
				$elm$core$Tuple$pair,
				_Utils_update(
					model,
					{e: true}),
				A2(
					$elm$core$Task$attempt,
					actionMsg,
					A3(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$object,
						A2(
							$author$project$Page$SolicitudesPendientes$ModuleActions$forwardingTask,
							data_,
							$elm$json$Json$Encode$object(_List_Nil)),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'approvement_message',
								$elm$json$Json$Encode$string(
									A2($elm$core$Basics$composeR, $author$project$Csf$Form$strVal, $elm$core$String$trim)(msgField_))),
								_Utils_Tuple2(
								'approvement_outcome_code',
								$elm$json$Json$Encode$int(1))
							])))));
	});
var $author$project$Page$SolicitudesPendientes$onDateTimePickerChanged = F3(
	function (key_, dtePickerMsg, model) {
		var handleDtePickerUpdate = F2(
			function (dTPicker, _v2) {
				var newPicker = _v2.a;
				var newPicked = _v2.b;
				if (A2($elm$core$String$contains, 'documentos_fecha', key_)) {
					if (!newPicked.$) {
						var p = newPicked.a;
						return _Utils_update(
							dTPicker,
							{
								a0: newPicked,
								aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$closePicker(newPicker)
							});
					} else {
						return _Utils_update(
							dTPicker,
							{aw: newPicker});
					}
				} else {
					return function (_v1) {
						var pkr = _v1.a;
						var pkd = _v1.b;
						return _Utils_update(
							dTPicker,
							{a0: pkd, aw: pkr});
					}(
						A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$core$Maybe$Just),
								$elm$core$Maybe$withDefault(dTPicker.a0)),
							_Utils_Tuple2(newPicker, newPicked)));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return function (dTPicker_) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{
									E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
								}),
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$SolicitudesPendientes$OnSolicitudUpdated,
									A3($elm$core$String$replace, '--dtpicker', '', key_),
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, dTPicker_.a0)))));
					}(
						A2(
							handleDtePickerUpdate,
							dTPicker,
							function (settings_) {
								return A3($mercurymedia$elm_datetime_picker$SingleDatePicker$update, settings_, dtePickerMsg, dTPicker.aw);
							}(
								A2($author$project$Page$SolicitudesPendientes$dateTimePickerSettings, key_, model))));
				},
				A2($elm$core$Dict$get, key_, model.E)));
	});
var $author$project$Page$SolicitudesPendientes$ModuleActions$onSolicitudUpdated = F2(
	function (model, _v0) {
		var solicitudForm = model.l;
		var key_ = _v0.a;
		var fieldDta = _v0.b;
		var mssg_ = _v0.c;
		var insert_ = function (strField) {
			return function (sForm) {
				return _Utils_update(
					model,
					{l: sForm});
			}(
				A3($elm$core$Dict$insert, key_, strField, solicitudForm));
		};
		var formField_ = F2(
			function (key__, mdel) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Csf$Form$strVal,
						A2($elm$core$Dict$get, key__, mdel.l)));
			});
		var formPPU_ = formField_('solicitud_ppu');
		var tipoVehiculo_ = formField_('solicitud_tipo_vehiculo');
		var validateFormPPU_ = function (mdel) {
			return _Utils_update(
				mdel,
				{
					ar: A2(
						$elm$core$List$member,
						key_,
						_List_fromArray(
							['solicitud_ppu', 'solicitud_tipo_vehiculo'])) ? A2(
						$author$project$Helpers$Utilities$isInvalidPPU_,
						tipoVehiculo_(mdel),
						formPPU_(mdel)) : mdel.ar
				});
		};
		var invertTuple_ = function (_v2) {
			var cmdAction_ = _v2.a;
			var mdel = _v2.b;
			return A2(
				$elm$core$Tuple$pair,
				validateFormPPU_(mdel),
				cmdAction_);
		};
		var allowedExpression_ = A2($author$project$Csf$Form$AllowedExpression, $author$project$Helpers$Utilities$allowedChars, 'El campo contiene caracteres no permitidos');
		return invertTuple_(
			function () {
				switch (key_) {
					case 'solicitud_email':
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$Platform$Cmd$none,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[$author$project$Csf$Form$Required, $author$project$Csf$Form$Email])),
								insert_,
								$elm$core$String$toLower(fieldDta)));
					case 'solicitud_cit':
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$Platform$Cmd$none,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[$author$project$Csf$Form$Required, allowedExpression_])),
								insert_,
								$elm$core$String$toUpper(fieldDta)));
					case 'inscripcion_adquiriente_correo':
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$Platform$Cmd$none,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[$author$project$Csf$Form$Email])),
								insert_,
								$elm$core$String$toLower(fieldDta)));
					case 'solicitud_distribuidor':
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$Platform$Cmd$none,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[allowedExpression_])),
								insert_,
								$elm$core$String$toUpper(fieldDta)));
					case 'solicitud_vin':
						return A2(
							$elm$core$Tuple$pair,
							A2($author$project$Helpers$Utilities$delay, 0, mssg_),
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[$author$project$Csf$Form$Required, allowedExpression_])),
								insert_,
								$elm$core$String$toUpper(fieldDta)));
					default:
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$Platform$Cmd$none,
							A3(
								$elm$core$Basics$composeR,
								$author$project$Csf$Form$strValidator(
									_List_fromArray(
										[allowedExpression_])),
								insert_,
								$elm$core$String$toUpper(fieldDta)));
				}
			}());
	});
var $author$project$Page$SolicitudesPendientes$openDateTimePicker = F2(
	function (key_, model) {
		var dateTimePickers = model.E;
		var currentDateTime = model.bS;
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return function (dTPicker_) {
						return _Utils_update(
							model,
							{
								E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
							});
					}(
						function (picker_) {
							return _Utils_update(
								dTPicker,
								{aw: picker_});
						}(
							function (settings_) {
								return A4($mercurymedia$elm_datetime_picker$SingleDatePicker$openPicker, settings_, currentDateTime, dTPicker.a0, dTPicker.aw);
							}(
								A2($author$project$Page$SolicitudesPendientes$dateTimePickerSettings, key_, model))));
				},
				A2($elm$core$Dict$get, key_, dateTimePickers)));
	});
var $author$project$Page$SolicitudesPendientes$pickerSettings = function (id) {
	return function (settings_) {
		return _Utils_update(
			settings_,
			{
				ge: $author$project$DatePicker$Date$es.ly,
				gz: _List_fromArray(
					[
						_Utils_Tuple2('form-control', true)
					]),
				gA: $elm$core$Maybe$Just(id + '--date-field'),
				gB: $elm$core$Maybe$Just(id + '--date'),
				gK: $author$project$DatePicker$Date$es.kz
			});
	}($author$project$DatePicker$defaultSettings);
};
var $author$project$Page$SolicitudesPendientes$updateQueryFromDropdown = F3(
	function (key_, mbeString, model) {
		var session = model.g$;
		var taskName = model.jd;
		var queryData = model.kX;
		var removeKey_ = A2($author$project$Route$removeFromQuery, key_, queryData);
		var pageRoute_ = (taskName === 'chie_firmar_certificado') ? $author$project$Route$PendientesDeFirma : $author$project$Route$PendientesAprobacion;
		var appendKey_ = function (string_) {
			return A3($author$project$Route$appendToQuery, key_, string_, queryData);
		};
		return A2(
			$elm$core$Tuple$pair,
			model,
			A2(
				$author$project$Route$goTo,
				session.gL,
				function (q_) {
					return pageRoute_(
						{iI: q_});
				}(
					A2(
						$elm$core$Maybe$withDefault,
						removeKey_,
						A2($elm$core$Maybe$map, appendKey_, mbeString)))));
	});
var $author$project$Page$SolicitudesPendientes$update = F2(
	function (mssg_, model) {
		var session = model.g$;
		var moduleDashlets = model.eO;
		var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
		var pageRoute_ = A2(
			$elm$core$List$member,
			model.jd,
			_List_fromArray(
				['chie_firmar_certificado', 'chie_firmar_certificado_extension'])) ? $author$project$Route$PendientesDeFirma : $author$project$Route$PendientesAprobacion;
		_v0$55:
		while (true) {
			switch (mssg_.$) {
				case 1:
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$author$project$Route$goTo,
							session.gL,
							pageRoute_(
								{iI: model.kX})));
				case 2:
					return A2(
						$elm$core$Tuple$pair,
						model,
						$author$project$Helpers$Utilities$retrieveFromLocalStorage('prevLocation'));
				case 3:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bv: $author$project$Csf$Modal$shown}),
						$elm$core$Platform$Cmd$none);
				case 4:
					return A3(
						$author$project$Page$SolicitudesPendientes$ModuleActions$approveRequest,
						_Utils_update(
							model,
							{aW: 'approve_action'}),
						$author$project$Page$SolicitudesPendientes$TaskForwarded,
						A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', 'fields_with_errors'));
				case 5:
					return A2(
						$author$project$Page$SolicitudesPendientes$ModuleActions$nullifyRequest,
						_Utils_update(
							model,
							{aW: 'nullify_action'}),
						$author$project$Page$SolicitudesPendientes$TaskForwarded);
				case 6:
					var show_ = mssg_.a;
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{fz: show_}),
						$elm$core$Platform$Cmd$none);
				case 7:
					var location_ = mssg_.a;
					var defaultRoute_ = A2(
						$author$project$Route$goTo,
						session.gL,
						pageRoute_($author$project$Route$emptyData));
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							defaultRoute_,
							A2(
								$elm$core$Maybe$map,
								$author$project$Route$goTo_(session.gL),
								$author$project$Helpers$Utilities$stringToMaybe(location_))));
				case 8:
					var stringJson = mssg_.a;
					var task_names_ = A2(
						$elm$core$List$member,
						model.jd,
						_List_fromArray(
							['chie_firmar_certificado', 'chie_firmar_certificado_extension'])) ? _List_fromArray(
						['chie_firmar_certificado', 'chie_firmar_certificado_extension']) : _List_fromArray(
						['chie_aprobar_emision']);
					var query_ = function (queryDatesMap) {
						return A2($elm$core$Dict$map, queryDatesMap, model.kX);
					}(
						F2(
							function (key_, value_) {
								switch (key_) {
									case 'fechaini':
										return A2(
											$elm$core$Maybe$withDefault,
											value_,
											A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 0, 0, value_));
									case 'fechafin':
										return A2(
											$elm$core$Maybe$withDefault,
											value_,
											A4($author$project$Csf$DateFormat$toUtcIsoString, model.dE, 23, 59, value_));
									default:
										return value_;
								}
							}));
					var fromStringJson_ = F3(
						function (key_, default_, decodes_) {
							return function (decoder_) {
								return A3($author$project$Helpers$Utilities$decodeString_, default_, decoder_, stringJson);
							}(
								A2($elm$json$Json$Decode$field, key_, decodes_));
						});
					var stringFromJson = F2(
						function (key_, default_) {
							return A3(fromStringJson_, key_, default_, $elm$json$Json$Decode$string);
						});
					var andThenFromFiles = function (search_) {
						return A2(
							$elm$core$Task$map,
							function (taggs_) {
								return _Utils_Tuple2(search_, taggs_);
							},
							A3(
								$author$project$Helpers$ApiHandler$buscarAgregaciones,
								ticket_,
								'files',
								_List_fromArray(
									['distribuidor', 'marca', 'modelo'])));
					};
					return A3(
						$elm$core$Basics$composeR,
						$elm$core$Task$attempt($author$project$Page$SolicitudesPendientes$TasksLoaded),
						$elm$core$Tuple$pair(model),
						A2(
							$elm$core$Task$andThen,
							andThenFromFiles,
							A4(
								$author$project$Helpers$ApiHandler$listarSolicitudesExtensiones,
								ticket_,
								A2(stringFromJson, 'sort_by', 'inserted_at:desc'),
								_Utils_Tuple2(
									A2(stringFromJson, 'from_', '0'),
									A2(stringFromJson, 'size_', '10')),
								task_names_)));
				case 9:
					var key_ = mssg_.a;
					var updateMdelDatePickers = function (dTPicker_) {
						return _Utils_update(
							model,
							{
								E: A3($elm$core$Dict$insert, key_, dTPicker_, model.E)
							});
					};
					var cmdAction_ = A2(
						$author$project$Helpers$Utilities$delay,
						0,
						A2(
							$author$project$Page$SolicitudesPendientes$OnSolicitudUpdated,
							A3($elm$core$String$replace, '--dtpicker', '', key_),
							''));
					var tupleModelAction_ = function (mdel) {
						return A2($elm$core$Tuple$pair, mdel, cmdAction_);
					};
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (dTPicker) {
								return A3(
									$elm$core$Basics$composeR,
									updateMdelDatePickers,
									tupleModelAction_,
									_Utils_update(
										dTPicker,
										{
											a0: $elm$core$Maybe$Nothing,
											aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$init(
												$author$project$Page$SolicitudesPendientes$DateTimePickerChanged(key_))
										}));
							},
							A2($elm$core$Dict$get, key_, model.E)));
				case 10:
					if (mssg_.b.$ === 1) {
						var key_ = mssg_.a;
						var _v2 = mssg_.b;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A2(
								$elm$core$Task$perform,
								$author$project$Page$SolicitudesPendientes$OpenDateTimePicker(key_),
								A2($elm$core$Task$map, $elm$core$Maybe$Just, $elm$time$Time$now)));
					} else {
						var key_ = mssg_.a;
						var nowDateTime = mssg_.b.a;
						return function (mdel) {
							return A2($elm$core$Tuple$pair, mdel, $elm$core$Platform$Cmd$none);
						}(
							A2(
								$author$project$Page$SolicitudesPendientes$openDateTimePicker,
								key_,
								_Utils_update(
									model,
									{bS: nowDateTime})));
					}
				case 11:
					var key_ = mssg_.a;
					var dtePickerMsg = mssg_.b;
					return A3($author$project$Page$SolicitudesPendientes$onDateTimePickerChanged, key_, dtePickerMsg, model);
				case 12:
					var mbeString = mssg_.a;
					var _v3 = mssg_.b;
					var currentZone = _v3.a;
					var nowPosix = _v3.b;
					var mdelMap_ = function (m) {
						return _Utils_update(
							m,
							{
								bS: nowPosix,
								dE: A2($justinmimbs$time_extra$Time$Extra$toOffset, m.lG, nowPosix)
							});
					};
					var actionMap_ = function (cmd_) {
						return A2(
							$elm$core$Maybe$withDefault,
							cmd_,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Page$SolicitudesPendientes$ParseDatesToISO,
									$author$project$Helpers$Utilities$delay(0)),
								mbeString));
					};
					return A3(
						$elm$core$Tuple$mapBoth,
						mdelMap_,
						actionMap_,
						A2($author$project$Csf$Core$onTimeZone, currentZone, model));
				case 13:
					return function (model_) {
						return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
					}(
						_Utils_update(
							model,
							{
								bv: $author$project$Csf$Modal$hidden,
								df: $author$project$Csf$Form$strFieldModel('')
							}));
				case 14:
					var instock_key = mssg_.a;
					var request_key = A3($elm$core$String$replace, 'instock_', 'solicitud_', instock_key);
					var stringFieldMap = function (field_) {
						return A3($elm$core$Dict$insert, request_key, field_, model.l);
					};
					var solicitudForm_ = A2(
						$elm$core$Maybe$withDefault,
						model.l,
						A2(
							$elm$core$Maybe$map,
							stringFieldMap,
							A2($elm$core$Dict$get, instock_key, model.aj)));
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{l: solicitudForm_}),
						function () {
							if (instock_key === 'instock_tipo_vehiculo') {
								return A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Page$SolicitudesPendientes$DropdownMsg(7),
									A3(
										$elm$core$Basics$composeR,
										$author$project$Customized$CustomDropdown$PickedOption,
										$author$project$Helpers$Utilities$delay(0),
										A3(
											$elm$core$Basics$composeR,
											$author$project$Helpers$Utilities$correctTipoVehiculo_,
											$author$project$Helpers$Utilities$mbeTipoDeVehiculo,
											A3(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$map($author$project$Csf$Form$strVal),
												$elm$core$Maybe$withDefault(''),
												A2($elm$core$Dict$get, 'instock_tipo_vehiculo', model.aj)))));
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 15:
					var vinDta = mssg_.a;
					var vinDta_ = $author$project$Helpers$Utilities$trimmedToUpper(vinDta);
					var _v5 = model;
					var vinDropdown = _v5.ad;
					var vinsRetrieved = _v5.fX;
					var doNotSearch_ = $elm$core$String$isEmpty(vinDta_) || A2(
						$elm$core$List$any,
						$elm$core$String$contains(vinDta_),
						vinsRetrieved);
					return doNotSearch_ ? A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{
								ad: _Utils_update(
									vinDropdown,
									{gh: vinsRetrieved})
							}),
						$elm$core$Platform$Cmd$none) : A3(
						$elm$core$Basics$composeR,
						$elm$core$Task$attempt($author$project$Page$SolicitudesPendientes$VinsFounded),
						$elm$core$Tuple$pair(model),
						function (service_) {
							return A2($author$project$Helpers$ApiHandler$get, service_, _List_Nil);
						}($author$project$Config$ApiEndpoint$chievinspublic + ('?filter=*' + (vinDta_ + '*'))));
				case 16:
					var tab_key = mssg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ae: tab_key}),
						$elm$core$Platform$Cmd$none);
				case 17:
					var unique_id = mssg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aK: unique_id}),
						$elm$core$Platform$Cmd$none);
				case 18:
					var taskNode_ = mssg_.a;
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2($author$project$Page$SolicitudesPendientes$doNotify, 'info', 'working_action'));
				case 19:
					var filename = mssg_.a;
					var taskNode_ = mssg_.b;
					var _v6 = function (ext_) {
						return _Utils_Tuple2(filename + ('.' + ext_), ext_);
					}(
						A3(
							$elm$core$Basics$composeR,
							$elm$core$List$take(1),
							$elm$core$String$join(''),
							A3(
								$elm$core$Basics$composeR,
								$elm$core$String$split('.'),
								$elm$core$List$reverse,
								$author$project$TaskNode$nameOrEmpty(taskNode_.dm))));
					var filename_ = _v6.a;
					var extension_ = _v6.b;
					var mimeType_ = $author$project$Helpers$Utilities$mimeFromExtension(extension_);
					var mapTenant = function (tenant_) {
						return A2(
							$elm$core$Task$attempt,
							$author$project$Page$SolicitudesPendientes$NodeDownloaded(
								_Utils_Tuple2(filename_, mimeType_)),
							A3($author$project$Helpers$ApiHandler$descargarNodeFile, ticket_, tenant_, taskNode_.p));
					};
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								mapTenant,
								A2($author$project$Csf$TaskNodeUtils$mbstring, 'tenant', taskNode_))));
				case 20:
					if (!mssg_.b.$) {
						var _v7 = mssg_.a;
						var filename_ = _v7.a;
						var mimeType_ = _v7.b;
						var dataBytes = mssg_.b.a;
						return A2(
							$elm$core$Tuple$pair,
							model,
							A3($elm$file$File$Download$bytes, filename_, mimeType_, dataBytes));
					} else {
						var error = mssg_.b.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleHttpError, error, 'download_failed');
						return A2(
							$elm$core$Tuple$pair,
							model,
							('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', handled_));
					}
				case 21:
					if (!mssg_.a.$) {
						var hits = mssg_.a.a.kh;
						var inStock = A2(
							$elm$core$Maybe$withDefault,
							$author$project$TaskNode$emptyTask,
							$elm$core$List$head(hits));
						var dataFromNde_ = function (key_) {
							return A3(
								$author$project$Helpers$Utilities$decodeMbValue,
								'',
								$author$project$Helpers$Utilities$forceStringDecoder,
								A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, inStock));
						};
						var insert__ = A2(
							$elm$core$Basics$composeR,
							dataFromNde_,
							A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $author$project$Csf$Form$strFieldModel));
						var anuladoEnStock_ = 'ANULADO' === dataFromNde_('estado_vehiculo');
						var vhInStockForm_ = anuladoEnStock_ ? model.aj : A3(
							$elm$core$Dict$insert,
							'instock_anno',
							insert__('ano'),
							A3(
								$elm$core$Dict$insert,
								'instock_color',
								insert__('color'),
								A3(
									$elm$core$Dict$insert,
									'instock_vin',
									insert__('vin'),
									A3(
										$elm$core$Dict$insert,
										'instock_cit',
										insert__('cit'),
										A3(
											$elm$core$Dict$insert,
											'instock_nro_motor',
											insert__('motor'),
											A3(
												$elm$core$Dict$insert,
												'instock_tipo_vehiculo',
												insert__('tipo'),
												A3(
													$elm$core$Dict$insert,
													'instock_modelo',
													insert__('modelo'),
													A3(
														$elm$core$Dict$insert,
														'instock_marca',
														insert__('marca'),
														model.aj))))))));
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{e: false, fV: inStock, aj: vhInStockForm_}));
					} else {
						var error_ = mssg_.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error_, 'vinsearch_failed');
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{e: false}),
							('redirect_' === handled_) ? $author$project$Helpers$ApiHandler$toUserHome(session) : A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', handled_));
					}
				case 22:
					var query_ = mssg_.a;
					return (!_Utils_eq(query_, model.kX)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						model,
						A2($author$project$Helpers$Utilities$delay, 0, $author$project$Page$SolicitudesPendientes$ReloadModule));
				case 23:
					return A2(
						$elm$core$Tuple$pair,
						model,
						A2(
							$author$project$Helpers$Utilities$todaysDateRange,
							_Utils_Tuple2('fechaini', 'fechafin'),
							$author$project$Page$SolicitudesPendientes$DateOnQuery('update_query')));
				case 24:
					return A2(
						$elm$core$Tuple$pair,
						model,
						A3(
							$author$project$Helpers$Utilities$lastNDaysRange,
							_Utils_Tuple2('fechaini', 'fechafin'),
							-7,
							$author$project$Page$SolicitudesPendientes$DateOnQuery('update_query')));
				case 25:
					return A2(
						$elm$core$Tuple$pair,
						model,
						A3(
							$author$project$Helpers$Utilities$lastNDaysRange,
							_Utils_Tuple2('fechaini', 'fechafin'),
							-30,
							$author$project$Page$SolicitudesPendientes$DateOnQuery('update_query')));
				case 26:
					var dashlet_ = mssg_.a;
					return function (action_) {
						return A3($author$project$Helpers$Utilities$dashletToggle, dashlet_, action_, model);
					}(
						A2(
							$author$project$Helpers$Utilities$delay,
							0.5,
							$author$project$Page$SolicitudesPendientes$TransitioningOFF(dashlet_)));
				case 27:
					var dashlet_ = mssg_.a;
					return A2($author$project$Helpers$Utilities$transitioningOff, dashlet_, model);
				case 28:
					var fieldDta = mssg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								df: A2(
									$author$project$Csf$Form$strValidator,
									_List_fromArray(
										[$author$project$Csf$Form$Required]),
									fieldDta)
							}),
						$elm$core$Platform$Cmd$none);
				case 29:
					var field_ = mssg_.a;
					var data_ = mssg_.b;
					var _v8 = function () {
						switch (field_) {
							case 4:
								return A2(
									$elm$core$Tuple$pair,
									'ppu',
									$elm$core$String$toUpper(data_));
							case 1:
								return A2(
									$elm$core$Tuple$pair,
									'vin',
									$elm$core$String$toUpper(data_));
							case 3:
								return A2(
									$elm$core$Tuple$pair,
									'email',
									$elm$core$String$toLower(data_));
							default:
								return A2($elm$core$Tuple$pair, '', data_);
						}
					}();
					var queryKey_ = _v8.a;
					var data__ = _v8.b;
					var updatedField_ = A3(
						$elm$core$Dict$insert,
						'value_',
						$elm$json$Json$Encode$string(data__),
						A2(
							$author$project$Helpers$Utilities$embeddedDict,
							$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_),
							model.cf));
					var updateModuleFields_ = function (mdel) {
						var moduleFields = mdel.cf;
						return _Utils_update(
							mdel,
							{
								cf: A3(
									$elm$core$Dict$insert,
									$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_),
									updatedField_,
									moduleFields)
							});
					};
					var queryDta = $author$project$Helpers$Utilities$trimmedEmpty(data__) ? A2($elm$core$Dict$remove, queryKey_, model.kX) : A3(
						$author$project$Route$appendToQuery,
						queryKey_,
						$elm$core$String$trim(data__),
						model.kX);
					return A2(
						$elm$core$Tuple$mapFirst,
						updateModuleFields_,
						A2(
							$elm$core$Tuple$mapSecond,
							$author$project$Helpers$Utilities$delay(1.5),
							A2(
								$elm$core$Tuple$pair,
								_Utils_update(
									model,
									{kX: queryDta}),
								$author$project$Page$SolicitudesPendientes$FilterOnDelay(queryDta))));
				case 30:
					var pickerMsg = mssg_.a;
					return function (_v10) {
						var model_ = _v10.a;
						var action_ = _v10.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$SolicitudesPendientes$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('fechaini', model_.b4)
										]))));
					}(
						function (_v11) {
							var date_ = _v11.a;
							var picker_ = _v11.b;
							var action_ = _v11.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cM: picker_, b4: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b4, model.cM),
								$author$project$Page$SolicitudesPendientes$pickerSettings('fechaini'),
								pickerMsg)));
				case 31:
					var pickerMsg = mssg_.a;
					return function (_v12) {
						var model_ = _v12.a;
						var action_ = _v12.b;
						return _Utils_Tuple2(
							model_,
							A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$SolicitudesPendientes$DateOnQuery,
									action_,
									_List_fromArray(
										[
											_Utils_Tuple2('fechafin', model_.b3)
										]))));
					}(
						function (_v13) {
							var date_ = _v13.a;
							var picker_ = _v13.b;
							var action_ = _v13.c;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{cL: picker_, b3: date_}),
								action_);
						}(
							A3(
								$author$project$Helpers$Utilities$handlePickerMsg,
								_Utils_Tuple2(model.b3, model.cL),
								$author$project$Page$SolicitudesPendientes$pickerSettings('fechafin'),
								pickerMsg)));
				case 32:
					var key_ = mssg_.a;
					switch (key_) {
						case 'solicitud_vin':
							return A2(
								$elm$core$Tuple$pair,
								model,
								A2(
									$author$project$Helpers$Utilities$delay,
									0,
									A2($author$project$Page$SolicitudesPendientes$InputDropdownMsg, 0, $author$project$Customized$InputDropdown$DropdownOpened)));
						case 'solicitud_distribuidor':
							return A2(
								$elm$core$Tuple$pair,
								model,
								A2(
									$author$project$Helpers$Utilities$delay,
									0,
									A2($author$project$Page$SolicitudesPendientes$InputDropdownMsg, 1, $author$project$Customized$InputDropdown$DropdownOpened)));
						default:
							return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 33:
					var key_ = mssg_.a;
					var code_ = mssg_.b;
					if (key_ === 'solicitud_vin') {
						var vinFormField_ = A3(
							$elm$core$Basics$composeR,
							$elm$core$String$words,
							$elm$core$String$join(''),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Csf$Form$strVal,
									A2($elm$core$Dict$get, 'solicitud_vin', model.l))));
						return A2(
							$elm$core$Tuple$pair,
							model,
							((13 === code_) && A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedEmpty, $elm$core$Basics$not)(vinFormField_)) ? A2(
								$author$project$Helpers$Utilities$delay,
								0,
								A2(
									$author$project$Page$SolicitudesPendientes$InputDropdownMsg,
									0,
									$author$project$Customized$InputDropdown$ItemClicked(vinFormField_))) : $elm$core$Platform$Cmd$none);
					} else {
						return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 34:
					var key_ = mssg_.a;
					var fieldDta = mssg_.b;
					return A2(
						$author$project$Page$SolicitudesPendientes$ModuleActions$onSolicitudUpdated,
						model,
						_Utils_Tuple3(
							key_,
							fieldDta,
							$author$project$Page$SolicitudesPendientes$HandleVinData(fieldDta)));
				case 35:
					var action_ = mssg_.a;
					var datesData = mssg_.b;
					return A2(
						$elm$core$Tuple$pair,
						model,
						A5(
							$author$project$Helpers$ApiHandler$dateOnQueryMsg,
							action_,
							datesData,
							session.gL,
							model.kX,
							pageRoute_($author$project$Route$emptyData)));
				case 36:
					if (!mssg_.a.$) {
						var _v16 = mssg_.a.a;
						var searchResp = _v16.a;
						var aggregations = _v16.b;
						var aggregationsMap = F2(
							function (actionMap_, agg_) {
								return A2(
									$elm$core$Tuple$pair,
									agg_,
									actionMap_(agg_));
							});
						var decodeAggregations_ = F2(
							function (field_, actionMap) {
								return A2(
									$elm$core$List$map,
									aggregationsMap(actionMap),
									A3($author$project$Helpers$Utilities$decodeAggregations, field_, $elm$json$Json$Decode$string, aggregations));
							});
						var dealerAggs = A2(decodeAggregations_, 'distribuidor', $elm$core$Basics$identity);
						var marcaVehiculoAggs = A2(decodeAggregations_, 'marca', $elm$core$Basics$identity);
						var modeloVehiculoAggs = A2(decodeAggregations_, 'modelo', $elm$core$Basics$identity);
						var updateDropdownsAggs_ = function (mdel) {
							return A3(
								$author$project$Helpers$Utilities$updateDropdownOptions,
								$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(6),
								modeloVehiculoAggs,
								A3(
									$author$project$Helpers$Utilities$updateDropdownOptions,
									$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(5),
									marcaVehiculoAggs,
									A3(
										$author$project$Helpers$Utilities$updateDropdownOptions,
										$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(8),
										dealerAggs,
										mdel)));
						};
						var _v17 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$NodePagerMsg),
							A2($author$project$Csf$NodePager$updateNodePager, searchResp.lo, model.aF));
						var ndePager = _v17.a;
						var cmdAction_ = _v17.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							updateDropdownsAggs_,
							function (model_) {
								return A2($elm$core$Tuple$pair, model_, cmdAction_);
							}(
								_Utils_update(
									model,
									{
										eI: searchResp,
										aF: ndePager,
										jb: $author$project$Csf$Table$init(
											{r: searchResp.kh, w: model.jb.w}),
										dA: false
									})));
					} else {
						var error = mssg_.a.a;
						var nodePager_ = function (pager_) {
							return _Utils_update(
								pager_,
								{gR: true});
						}(model.aF);
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, '');
						var cmdAction_ = ($author$project$Helpers$Utilities$trimmedEmpty(handled_) || ('redirect_' === handled_)) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', handled_);
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, cmdAction_);
						}(
							_Utils_update(
								model,
								{aF: nodePager_, dA: true}));
					}
				case 37:
					if (!mssg_.a.$) {
						var tNde = mssg_.a.a;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{bv: $author$project$Csf$Modal$hidden}),
							function () {
								var _v18 = model.aW;
								switch (_v18) {
									case 'approve_action':
										return A2($author$project$Page$SolicitudesPendientes$doNotify, 'success', 'approved_ok');
									case 'nullify_action':
										return A2($author$project$Page$SolicitudesPendientes$doNotify, 'success', 'nullify_ok');
									default:
										return $elm$core$Platform$Cmd$none;
								}
							}());
					} else {
						var error = mssg_.a.a;
						var handled_ = A2(
							$author$project$Helpers$ApiHandler$handleCallError,
							error,
							function () {
								var _v20 = model.aW;
								switch (_v20) {
									case 'approve_action':
										return 'approved_failed';
									case 'nullify_action':
										return 'nullify_failed';
									default:
										return 'error_received';
								}
							}());
						var errorDecoder = A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string);
						var defaultCmdAction = A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', handled_);
						var errorDecoderMap = function (error_) {
							return $author$project$Helpers$Utilities$trimmedEmpty(error_) ? defaultCmdAction : A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', error_);
						};
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{e: false, aW: ''}),
							function () {
								if ('redirect_' === handled_) {
									return $author$project$Helpers$ApiHandler$toUserHome(session);
								} else {
									if (error.$ === 4) {
										var status_ = error.a;
										var body_ = error.b;
										return A2(
											$elm$core$List$member,
											status_,
											_List_fromArray(
												[400, 500])) ? A4($author$project$Helpers$Utilities$decodeMapString, defaultCmdAction, errorDecoderMap, errorDecoder, body_) : defaultCmdAction;
									} else {
										return defaultCmdAction;
									}
								}
							}());
					}
				case 41:
					if (!mssg_.a.$) {
						var task = mssg_.a.a.li;
						var vehiculo = mssg_.a.a.lu;
						var inscription = mssg_.a.a.kp;
						var history = mssg_.a.a.kg;
						var documents = mssg_.a.a.j_;
						var uniqueIdExpedienteChie = $author$project$Csf$Form$strFieldModel(
							A3(
								$elm$core$Basics$composeR,
								function ($) {
									return $.dm;
								},
								$author$project$TaskNode$uniqueIdOrEmpty,
								A3(
									$author$project$Helpers$Utilities$decodeMbValue,
									$author$project$TaskNode$emptyTask,
									$author$project$Csf$AlbertoApi$decoderTaskNode,
									A2($author$project$Csf$TaskNodeUtils$mbvalue, 'node', task))));
						var fetchStockVins_ = A2(
							$elm$core$Task$attempt,
							$author$project$Page$SolicitudesPendientes$GotStockVins,
							A2($author$project$Helpers$ApiHandler$get, $author$project$Config$ApiEndpoint$chievinspublic, _List_Nil));
						var fechaSolicitudChie = A3(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(''),
							$author$project$Csf$Form$strFieldModel,
							A3(
								$author$project$Csf$DateFormat$formatIsoDate,
								'DD/MM/YYYY hh:mm A',
								model.lG,
								A3(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dm;
									},
									$author$project$TaskNode$insertedAtOrEmpty,
									A3(
										$author$project$Helpers$Utilities$decodeMbValue,
										$author$project$TaskNode$emptyTask,
										$author$project$Csf$AlbertoApi$decoderTaskNode,
										A2($author$project$Csf$TaskNodeUtils$mbvalue, 'node', task)))));
						var docsFilter = function (field_) {
							return A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$eq(field_),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.dm;
									},
									$author$project$TaskNode$typeOrEmpty));
						};
						var dataFromVehicle = function (key_) {
							return A3(
								$author$project$Helpers$Utilities$decodeMbValue,
								'',
								$author$project$Helpers$Utilities$forceStringDecoder,
								A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, vehiculo));
						};
						var insert__ = A2(
							$elm$core$Basics$composeR,
							dataFromVehicle,
							A2($elm$core$Basics$composeR, $elm$core$String$toUpper, $author$project$Csf$Form$strFieldModel));
						var dataFromNde = function (key_) {
							return A3(
								$elm$core$Basics$composeR,
								$elm$core$String$trim,
								$author$project$Helpers$Utilities$removeFromString('^null$'),
								A3(
									$author$project$Helpers$Utilities$decodeMbValue,
									'',
									$author$project$Helpers$Utilities$forceStringDecoder,
									A2(
										$author$project$Csf$TaskNodeUtils$mbdatavalue,
										key_,
										A3(
											$author$project$Helpers$Utilities$decodeMbValue,
											$author$project$TaskNode$emptyTask,
											$author$project$Csf$AlbertoApi$decoderTaskNode,
											A2($author$project$Csf$TaskNodeUtils$mbvalue, 'node', task)))));
						};
						var estadoChieFromTaskNde = $author$project$Csf$Form$strFieldModel(
							A2($elm$core$Basics$composeR, dataFromNde, $author$project$Helpers$Utilities$estadoDelChie)('estado_chie'));
						var insert_ = A2($elm$core$Basics$composeR, dataFromNde, $author$project$Csf$Form$strFieldModel);
						var selectedVhType_ = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Page$SolicitudesPendientes$DropdownMsg(7),
							A3(
								$elm$core$Basics$composeR,
								$author$project$Customized$CustomDropdown$PickedOption,
								$author$project$Helpers$Utilities$delay(0),
								A2($elm$core$Basics$composeR, dataFromNde, $author$project$Helpers$Utilities$mbeTipoDeVehiculo)('tipo')));
						var dataFromInscription_ = function (key_) {
							return A3(
								$elm$core$Basics$composeR,
								$elm$core$String$trim,
								$author$project$Helpers$Utilities$removeFromString('^null$'),
								A3($author$project$Csf$TaskNodeUtils$datastring, '', key_, inscription));
						};
						var fechaSolicitudInscripcion = A3(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(''),
							$author$project$Csf$Form$strFieldModel,
							A2(
								$elm$core$Maybe$map,
								$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime,
								A3(
									$elm$core$Basics$composeR,
									$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
									$elm$core$Result$toMaybe,
									dataFromInscription_('solicitud_fecha_solicitud'))));
						var insertDTPicker_ = F2(
							function (key_, d) {
								return function (idata) {
									return A3($elm$core$Dict$insert, key_, idata, d);
								}(
									{
										a0: A3(
											$elm$core$Basics$composeR,
											$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
											$elm$core$Result$toMaybe,
											dataFromInscription_(
												A3(
													$elm$core$String$replace,
													'inscripcion_',
													'',
													A3($elm$core$String$replace, '--dtpicker', '', key_)))),
										aw: $mercurymedia$elm_datetime_picker$SingleDatePicker$init(
											$author$project$Page$SolicitudesPendientes$DateTimePickerChanged(key_))
									});
							});
						var dateTimePickers_ = A2(
							insertDTPicker_,
							'inscripcion_solicitud_fecha_solicitud--dtpicker',
							A2(insertDTPicker_, 'inscripcion_documentos_fecha--dtpicker', model.E));
						var insertInscription_ = A2($elm$core$Basics$composeR, dataFromInscription_, $author$project$Csf$Form$strFieldModel);
						var solicitudForm_ = A3(
							$elm$core$Dict$insert,
							'inscripcion_documentos_naturaleza',
							insertInscription_('documentos_naturaleza'),
							A3(
								$elm$core$Dict$insert,
								'inscripcion_documentos_fecha',
								insertInscription_('documentos_fecha'),
								A3(
									$elm$core$Dict$insert,
									'inscripcion_documentos_lugar',
									insertInscription_('documentos_lugar'),
									A3(
										$elm$core$Dict$insert,
										'inscripcion_documentos_tipo',
										insertInscription_('documentos_tipo'),
										A3(
											$elm$core$Dict$insert,
											'inscripcion_documentos_numero',
											insertInscription_('documentos_numero'),
											A3(
												$elm$core$Dict$insert,
												'inscripcion_adquiriente_domicilio',
												insertInscription_('adquiriente_domicilio'),
												A3(
													$elm$core$Dict$insert,
													'inscripcion_adquiriente_correo',
													insertInscription_('adquiriente_correo'),
													A3(
														$elm$core$Dict$insert,
														'inscripcion_solicitud_fecha_solicitud',
														fechaSolicitudInscripcion,
														A3(
															$elm$core$Dict$insert,
															'inscripcion_id_expediente',
															uniqueIdExpedienteChie,
															A3(
																$elm$core$Dict$insert,
																'solicitud_email',
																insert_('cliente_correo'),
																A3(
																	$elm$core$Dict$insert,
																	'solicitud_cit',
																	insert_('cit'),
																	A3(
																		$elm$core$Dict$insert,
																		'solicitud_distribuidor_rut',
																		insert_('distribuidor_rut'),
																		A3(
																			$elm$core$Dict$insert,
																			'solicitud_distribuidor',
																			insert_('distribuidor'),
																			A3(
																				$elm$core$Dict$insert,
																				'solicitud_cliente_comuna',
																				insert_('cliente_comuna'),
																				A3(
																					$elm$core$Dict$insert,
																					'solicitud_cliente_nombre',
																					insert_('cliente_nombre'),
																					A3(
																						$elm$core$Dict$insert,
																						'solicitud_cliente_rut',
																						insert_('cliente_rut'),
																						A3(
																							$elm$core$Dict$insert,
																							'solicitud_ppu',
																							insert_('patente'),
																							A3(
																								$elm$core$Dict$insert,
																								'solicitud_color',
																								insert_('color'),
																								A3(
																									$elm$core$Dict$insert,
																									'solicitud_ano',
																									insert_('ano'),
																									A3(
																										$elm$core$Dict$insert,
																										'solicitud_vin',
																										insert_('vin'),
																										A3(
																											$elm$core$Dict$insert,
																											'solicitud_nro_motor',
																											insert_('motor'),
																											A3(
																												$elm$core$Dict$insert,
																												'solicitud_modelo',
																												insert_('modelo'),
																												A3(
																													$elm$core$Dict$insert,
																													'solicitud_marca',
																													insert_('marca'),
																													A3(
																														$elm$core$Dict$insert,
																														'solicitud_estado',
																														estadoChieFromTaskNde,
																														A3(
																															$elm$core$Dict$insert,
																															'solicitud_fecha',
																															fechaSolicitudChie,
																															A3(
																																$elm$core$Dict$insert,
																																'solicitud_solicitante',
																																insert_('solicitante'),
																																model.l))))))))))))))))))))))))));
						var cmdActions_ = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[fetchStockVins_, selectedVhType_]));
						var anuladoEnStock_ = 'ANULADO' === dataFromVehicle('estado_vehiculo');
						var vhInStockForm_ = anuladoEnStock_ ? model.aj : A3(
							$elm$core$Dict$insert,
							'instock_anno',
							insert__('ano'),
							A3(
								$elm$core$Dict$insert,
								'instock_color',
								insert__('color'),
								A3(
									$elm$core$Dict$insert,
									'instock_vin',
									insert__('vin'),
									A3(
										$elm$core$Dict$insert,
										'instock_cit',
										insert__('cit'),
										A3(
											$elm$core$Dict$insert,
											'instock_nro_motor',
											insert__('motor'),
											A3(
												$elm$core$Dict$insert,
												'instock_tipo_vehiculo',
												insert__('tipo'),
												A3(
													$elm$core$Dict$insert,
													'instock_modelo',
													insert__('modelo'),
													A3(
														$elm$core$Dict$insert,
														'instock_marca',
														insert__('marca'),
														model.aj))))))));
						var activeDocument_ = A2(
							$elm$core$Maybe$withDefault,
							'',
							A3(
								$elm$core$Basics$composeR,
								$elm$core$List$head,
								$elm$core$Maybe$map(
									function ($) {
										return $.p;
									}),
								function (_v21) {
									var first_ = _v21.a;
									var second_ = _v21.b;
									return _Utils_ap(first_, second_);
								}(
									A2(
										$elm$core$List$partition,
										docsFilter('solicitud_primera_inscripcion'),
										documents))));
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, cmdActions_);
						}(
							_Utils_update(
								model,
								{
									aK: activeDocument_,
									E: dateTimePickers_,
									l: solicitudForm_,
									fD: $elm$core$List$reverse(
										A2(
											$elm$core$List$sortBy,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.dm;
												},
												$author$project$TaskNode$insertedAtOrEmpty),
											documents)),
									fE: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.dm;
											},
											A2(
												$elm$core$Basics$composeR,
												A2(
													$elm$core$Basics$composeR,
													$author$project$TaskNode$string('status'),
													$elm$core$Maybe$withDefault('')),
												$elm$core$Basics$neq('hidden'))),
										history),
									fF: task,
									fV: vehiculo,
									aj: vhInStockForm_
								}));
					} else {
						var error = mssg_.a.a;
						var handled_ = A2($author$project$Helpers$ApiHandler$handleCallError, error, 'task_details_failed');
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{cD: false}),
							('redirect_' === handled_) ? $elm$core$Platform$Cmd$none : A2($author$project$Page$SolicitudesPendientes$doNotify, 'error', handled_));
					}
				case 38:
					if (!mssg_.a.$) {
						var stringJson = mssg_.a.a;
						var vinDropdown_ = model.ad;
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{
									cD: false,
									ad: _Utils_update(
										vinDropdown_,
										{
											gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
										}),
									fX: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
								}));
					} else {
						var error_ = mssg_.a.a;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{cD: false}),
							$elm$core$Platform$Cmd$none);
					}
				case 39:
					if (!mssg_.a.$) {
						var stringJson = mssg_.a.a;
						var dealerDropdown_ = function (d) {
							return _Utils_update(
								d,
								{
									gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'distribuidor', $elm$json$Json$Decode$string, stringJson)
								});
						}(model.aP);
						return function (model_) {
							return A2($elm$core$Tuple$pair, model_, $elm$core$Platform$Cmd$none);
						}(
							_Utils_update(
								model,
								{aP: dealerDropdown_, dn: false}));
					} else {
						var error_ = mssg_.a.a;
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{dn: false}),
							$elm$core$Platform$Cmd$none);
					}
				case 40:
					if (!mssg_.a.$) {
						var stringJson = mssg_.a.a;
						var vinDropdown_ = function (v) {
							return _Utils_update(
								v,
								{
									gh: A3($author$project$Helpers$Utilities$decodeAggregations, 'vin', $elm$json$Json$Decode$string, stringJson)
								});
						}(model.ad);
						return A2(
							$elm$core$Tuple$pair,
							_Utils_update(
								model,
								{ad: vinDropdown_}),
							$elm$core$Platform$Cmd$none);
					} else {
						var error_ = mssg_.a.a;
						return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 42:
					var field_ = mssg_.a;
					var dropdownMsg = mssg_.b;
					var key_ = $author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_);
					var proceedToScrool = function (_v24) {
						var mdel = _v24.a;
						var cmdAction_ = _v24.b;
						return function (_v23) {
							var dropdownId = _v23.cF;
							var dropdownOpen = _v23.bj;
							return dropdownOpen ? A2(
								$elm$core$Tuple$pair,
								mdel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmdAction_,
											$author$project$Ports$scrollGrandToBottom(dropdownId)
										]))) : A2($elm$core$Tuple$pair, mdel, cmdAction_);
						}(
							A2($author$project$Helpers$Utilities$getDropdown, key_, mdel));
					};
					var handleMssg_ = function (action_) {
						return A5(
							$author$project$Helpers$Utilities$handleDropdownMssg,
							key_,
							$author$project$Page$SolicitudesPendientes$DropdownMsg(field_),
							dropdownMsg,
							action_,
							model);
					};
					switch (field_) {
						case 8:
							return handleMssg_(
								$author$project$Page$SolicitudesPendientes$updateQueryFromDropdown('dealer'));
						case 5:
							return proceedToScrool(
								handleMssg_(
									$author$project$Page$SolicitudesPendientes$updateQueryFromDropdown('marca')));
						case 6:
							return proceedToScrool(
								handleMssg_(
									$author$project$Page$SolicitudesPendientes$updateQueryFromDropdown('modelo')));
						case 7:
							return handleMssg_(
								F2(
									function (mbeStr, mdel) {
										var solicitudForm = mdel.l;
										return function (str) {
											return function (sf) {
												return A2(
													$elm$core$Tuple$pair,
													_Utils_update(
														mdel,
														{l: sf}),
													A2(
														$author$project$Helpers$Utilities$delay,
														0,
														A2($author$project$Page$SolicitudesPendientes$OnSolicitudUpdated, 'solicitud_tipo_vehiculo', str)));
											}(
												A3(
													$elm$core$Dict$insert,
													'solicitud_tipo_vehiculo',
													$author$project$Csf$Form$strFieldModel(str),
													solicitudForm));
										}(
											A2($elm$core$Maybe$withDefault, '', mbeStr));
									}));
						default:
							return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 43:
					var pagerMsg = mssg_.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (pager_) {
							return _Utils_update(
								model,
								{aF: pager_});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$NodePagerMsg),
							A2($author$project$Csf$NodePager$update, pagerMsg, model.aF)));
				case 44:
					var badgesMsg = mssg_.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (badges_) {
							return _Utils_update(
								model,
								{b8: badges_});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$FilterBadgesMsg),
							A2($author$project$Csf$FilterBadges$update, badgesMsg, model.b8)));
				case 45:
					switch (mssg_.a.$) {
						case 3:
							if (mssg_.a.a === 'namespace_details') {
								var _v25 = mssg_.a;
								var taskNode_ = _v25.b;
								return A2($author$project$Page$SolicitudesPendientes$ModuleActions$handleNamespaceDetails, taskNode_, model);
							} else {
								break _v0$55;
							}
						case 2:
							var state_ = mssg_.a.a;
							return A4(
								$author$project$Helpers$ApiHandler$handleTableSort,
								state_,
								model,
								$author$project$Page$SolicitudesPendientes$allowedToSortBy,
								pageRoute_($author$project$Route$emptyData));
						default:
							break _v0$55;
					}
				case 46:
					var notifyMsg = mssg_.a;
					return A2(
						$author$project$Page$SolicitudesPendientes$handleNotifications,
						model,
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$NotificationsMsg),
							A2(
								$author$project$Csf$Notifications$update,
								notifyMsg,
								{a7: model.g$.a7})));
				case 47:
					if (!mssg_.a) {
						var _v26 = mssg_.a;
						var dropdownMsg = mssg_.b;
						return A2(
							$author$project$Page$SolicitudesPendientes$handleVinDropdown,
							dropdownMsg,
							A2(
								$elm$core$Tuple$mapFirst,
								function (dropdown_) {
									return _Utils_update(
										model,
										{ad: dropdown_});
								},
								A2($author$project$Customized$InputDropdown$update, dropdownMsg, model.ad)));
					} else {
						var _v27 = mssg_.a;
						var dropdownMsg = mssg_.b;
						return A2(
							$author$project$Page$SolicitudesPendientes$handleDealerDropdown,
							dropdownMsg,
							A2(
								$elm$core$Tuple$mapFirst,
								function (dropdown_) {
									return _Utils_update(
										model,
										{aP: dropdown_});
								},
								A2($author$project$Customized$InputDropdown$update, dropdownMsg, model.aP)));
					}
				default:
					return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
			}
		}
		var tableMsg = mssg_.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (table_) {
				return _Utils_update(
					model,
					{jb: table_});
			},
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Page$SolicitudesPendientes$TableMsg),
				A2($author$project$Csf$Table$update, tableMsg, model.jb)));
	});
var $author$project$Helpers$Utilities$updateLocalStorage = F2(
	function (key_, value_) {
		return $author$project$Helpers$Utilities$handleLocalStorage_(
			_List_fromArray(
				[
					A2($elm$core$Tuple$pair, 'action', 'update'),
					A2($elm$core$Tuple$pair, 'key', key_),
					A2($elm$core$Tuple$pair, 'value', value_)
				]));
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Helpers$ApiHandler$userTenant = function (userNde) {
	var tenants_ = A2(
		$elm$core$List$filterMap,
		$author$project$Helpers$Utilities$stringToMaybe,
		_Utils_ap(
			_List_fromArray(
				[
					A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', userNde)
				]),
			function (tuple_) {
				return _Utils_ap(tuple_.a, tuple_.b);
			}(
				A2(
					$elm$core$List$partition,
					$elm$core$Basics$neq('dox'),
					A3($author$project$Csf$TaskNodeUtils$dataliststr, _List_Nil, 'tenants', userNde)))));
	var tenantFilter = F2(
		function (groupsToMatch, tenant_) {
			return function (anyMatch_) {
				return A2($elm$core$List$any, anyMatch_, groupsToMatch);
			}(
				A2(
					$elm$core$Basics$composeR,
					$author$project$Helpers$Utilities$trimmedToLower,
					$elm$core$String$contains(tenant_)));
		});
	var _v0 = A2(
		$elm$core$List$partition,
		$elm$core$String$endsWith('_CHIE_ROLE_ADMINISTRATOR'),
		A2(
			$elm$core$List$filter,
			$elm$core$String$contains('_CHIE_ROLE_'),
			$author$project$Helpers$ApiHandler$userGroups(userNde)));
	var gAdmins_ = _v0.a;
	var userGroups_ = _v0.b;
	return A3(
		$elm$core$Basics$composeR,
		$elm_community$list_extra$List$Extra$unique,
		$elm$core$List$head,
		_Utils_ap(
			A2(
				$elm$core$List$filter,
				tenantFilter(gAdmins_),
				tenants_),
			A2(
				$elm$core$List$filter,
				tenantFilter(userGroups_),
				tenants_)));
};
var $author$project$Main$update = F2(
	function (msg, model) {
		var session_ = $author$project$Main$pageSession(model.t);
		var navKey_ = $author$project$Csf$Session$navKey(session_);
		var _v0 = _Utils_Tuple2(msg, model.t);
		_v0$4:
		while (true) {
			_v0$15:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						var url_ = _v0.a.a;
						var urlPath_ = A2(
							$elm$core$Basics$composeR,
							$author$project$Route$fromUrl,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$Route$routeToString),
								$elm$core$Maybe$withDefault('')));
						var handleUrlChange = function (cmd_) {
							var _v1 = !_Utils_eq(
								urlPath_(url_),
								urlPath_(model.q));
							if (!_v1) {
								return cmd_;
							} else {
								return A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$append(
										_List_fromArray(
											[cmd_])),
									$elm$core$Platform$Cmd$batch)(
									_List_fromArray(
										[
											A2(
											$author$project$Helpers$Utilities$updateLocalStorage,
											'prevLocation',
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm$url$Url$percentDecode(
													urlPath_(model.q))))
										]));
							}
						};
						return A2(
							$elm$core$Tuple$mapSecond,
							handleUrlChange,
							A2(
								$author$project$Main$changeRouteTo,
								$author$project$Route$fromUrl(url_),
								_Utils_update(
									model,
									{
										t: A2(
											$author$project$Main$updPageSession,
											model.t,
											_Utils_update(
												session_,
												{a7: $pablen$toasty$Toasty$initialState})),
										q: url_
									})));
					case 2:
						var urlRequest = _v0.a.a;
						return A2(
							$elm$core$Tuple$pair,
							model,
							function () {
								if (!urlRequest.$) {
									var url = urlRequest.a;
									return A2(
										$elm$core$Maybe$withDefault,
										A2($elm$browser$Browser$Navigation$pushUrl, navKey_, url.iA),
										A2(
											$elm$core$Maybe$map,
											$author$project$Route$goTo(navKey_),
											$author$project$Route$fromUrl(url)));
								} else {
									var href = urlRequest.a;
									return A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$elm$browser$Browser$Navigation$load,
											$author$project$Helpers$Utilities$stringToMaybe(href)));
								}
							}());
					case 3:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 4) {
								var _v3 = _v0.a.a.a;
								var usrNde = _v3.a;
								var rawList = _v3.b;
								var _v4 = _v0.b;
								var url_ = _v4.a;
								var session = _v4.b;
								var updFlags = function (flags_) {
									return _Utils_update(
										flags_,
										{
											g8: $author$project$Helpers$ApiHandler$userTenant(usrNde),
											co: $elm$core$Maybe$Just(usrNde)
										});
								}(session.ka);
								var updHeader = function (header_) {
									return _Utils_update(
										header_,
										{
											g$: _Utils_update(
												session,
												{ka: updFlags})
										});
								}(model.et);
								var tenantsDict_ = $author$project$Helpers$Utilities$buildTenantsDict(
									A2($elm$core$List$map, $author$project$Config$AppTenants$tenantRawToTuple, rawList));
								return A2(
									$author$project$Main$changeRouteTo,
									$author$project$Route$fromUrl(url_),
									_Utils_update(
										model,
										{
											et: updHeader,
											t: $author$project$Main$Redirect(
												_Utils_update(
													session,
													{ka: updFlags})),
											cl: tenantsDict_
										}));
							} else {
								break _v0$15;
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$elm$core$Tuple$pair,
								model,
								A2($author$project$Route$goTo, navKey_, $author$project$Route$Logout));
						}
					case 5:
						if (_v0.b.$ === 4) {
							break _v0$4;
						} else {
							var headerMsg = _v0.a.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Main$HeaderMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									function (header_) {
										return _Utils_update(
											model,
											{et: header_});
									},
									A2($author$project$Csf$Header$update, headerMsg, model.et)));
						}
					case 6:
						if (_v0.b.$ === 4) {
							break _v0$4;
						} else {
							var sidebarMsg = _v0.a.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Main$SiderBarMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									function (sidebar_) {
										return _Utils_update(
											model,
											{dv: sidebar_});
									},
									A2($author$project$Csf$FilterSideBar$update, sidebarMsg, model.dv)));
						}
					case 8:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 7:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$Dashboard,
									$author$project$Main$DashboardMsg,
									model,
									A2($author$project$Page$DashboardChie$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 9:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 6:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$Pendientes,
									$author$project$Main$PendientesMsg,
									model,
									A2($author$project$Page$SolicitudesPendientes$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 10:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 8:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$Repositorio,
									$author$project$Main$RepositorioMsg,
									model,
									A2($author$project$Page$RepositorioChie$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 7:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 5:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$Cargas,
									$author$project$Main$CargasMsg,
									model,
									A2($author$project$Page$HistorialDeCargas$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 12:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 9:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$CargarStock,
									$author$project$Main$CargarStockMsg,
									model,
									A2($author$project$Page$CargarStock$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 11:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 10:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$SolicitudesChie,
									$author$project$Main$SolicitudesChieMsg,
									model,
									A2($author$project$Page$SolicitudesChie$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 13:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 11:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$SolicitarChie,
									$author$project$Main$SolicitarChieMsg,
									model,
									A2($author$project$Page$SolicitarChie$update, mssg, mdel));
							default:
								break _v0$15;
						}
					case 14:
						switch (_v0.b.$) {
							case 4:
								break _v0$4;
							case 12:
								var mssg = _v0.a.a;
								var mdel = _v0.b.a;
								return A4(
									$author$project$Main$updateWith,
									$author$project$Main$ConsultarStock,
									$author$project$Main$ConsultarStockMsg,
									model,
									A2($author$project$Page$ConsultarStock$update, mssg, mdel));
							default:
								break _v0$15;
						}
					default:
						if (_v0.b.$ === 4) {
							break _v0$4;
						} else {
							break _v0$15;
						}
				}
			}
			return A2($elm$core$Tuple$pair, model, $elm$core$Platform$Cmd$none);
		}
		var _v5 = _v0.b;
		var url_ = _v5.a;
		var session = _v5.b;
		return A2(
			$author$project$Main$changeRouteTo,
			$author$project$Route$fromUrl(url_),
			model);
	});
var $author$project$Page$ConsultarStock$Last30DaysFilterMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$ConsultarStock$Last7DaysFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$ConsultarStock$OnFilterUpdated = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Page$ConsultarStock$TodayFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Csf$FilterSideBar$HtmlAttr = function (a) {
	return {$: 5, a: a};
};
var $author$project$Csf$FilterSideBar$attr = $author$project$Csf$FilterSideBar$HtmlAttr;
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Csf$FilterSideBar$bindTo = function (value_) {
	return $author$project$Csf$FilterSideBar$HtmlAttr(
		$elm$html$Html$Attributes$value(value_));
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Csf$Core$processConfigAttribute = A2(
	$elm$core$List$foldl,
	F2(
		function (item, _v0) {
			var attrs_ = _v0.a;
			var dict = _v0.b;
			switch (item.$) {
				case 1:
					var attr_ = item.a;
					return _Utils_Tuple2(
						A2($elm$core$List$cons, attr_, attrs_),
						dict);
				case 2:
					var html_ = item.a;
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'htmltag', item, dict));
				case 0:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'heading', item, dict));
				case 3:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'stacked', item, dict));
				default:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'loading', item, dict));
			}
		}),
	_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty));
var $author$project$Csf$Core$commandLink = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Core$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var heading_ = function () {
			var _v2 = A2($elm$core$Dict$get, 'heading', params);
			if ((!_v2.$) && (!_v2.a.$)) {
				var v = _v2.a.a;
				return v;
			} else {
				return '';
			}
		}();
		var command = A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('btn btn-link btn-sm p-0'),
				attrs_),
			_List_fromArray(
				[
					$elm$html$Html$text(heading_)
				]));
		var stacked_ = function () {
			var _v1 = A2($elm$core$Dict$get, 'stacked', params);
			if ((!_v1.$) && (_v1.a.$ === 3)) {
				var v = _v1.a.a;
				return v;
			} else {
				return false;
			}
		}();
		return stacked_ ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[command])) : command;
	});
var $author$project$Page$ConsultarStock$dataFromField = F3(
	function (field_, key_, _v0) {
		var moduleFields = _v0.cf;
		return A5(
			$author$project$Helpers$Utilities$fromEmbeddedDict,
			$author$project$Page$ConsultarStock$stringFromField(field_),
			key_,
			'',
			$elm$json$Json$Decode$string,
			moduleFields);
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Helpers$Utilities$informationStrip = F4(
	function (mssgType, fsize18, attrs_, message_) {
		var divAttrs_ = function () {
			switch (mssgType) {
				case 'info':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('infostrip-info-mssg')
						]);
				case 'warning':
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('infostrip-warning-mssg')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('infostrip-error-mssg')
						]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_Utils_ap(attrs_, divAttrs_),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 pl-1 pr-1 row-col-vertical-align')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-1 m-0 p-0 text-center')
								]),
							_List_fromArray(
								[
									function (iconAttrs_) {
									return A2($elm$html$Html$i, iconAttrs_, _List_Nil);
								}(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'color', '#FFF'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													A2($elm$core$Tuple$pair, 'f-18', fsize18),
													A2($elm$core$Tuple$pair, 'zmdi zmdi-info zmdi-hc-fw', 'info' === mssgType),
													A2($elm$core$Tuple$pair, 'zmdi zmdi-alert-triangle zmdi-hc-fw', 'info' !== mssgType)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-11 p-0 m-0 text-left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'padding-top', '1px')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'color', '#FFF')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message_)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Helpers$Utilities$errorInfoStrip = $author$project$Helpers$Utilities$informationStrip('error');
var $author$project$Csf$Core$Heading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Csf$Core$heading = $author$project$Csf$Core$Heading;
var $author$project$Csf$FilterSideBar$Heading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Csf$FilterSideBar$heading = $author$project$Csf$FilterSideBar$Heading;
var $author$project$Csf$FilterSideBar$getHeading = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'heading', params);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var v = _v0.a.a;
		return v;
	} else {
		return '';
	}
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Csf$FilterSideBar$processConfigAttribute = A2(
	$elm$core$List$foldl,
	F2(
		function (item, _v0) {
			var attrs_ = _v0.a;
			var dict = _v0.b;
			switch (item.$) {
				case 5:
					var attr_ = item.a;
					return _Utils_Tuple2(
						A2($elm$core$List$cons, attr_, attrs_),
						dict);
				case 0:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'toggleEvent', item, dict));
				case 1:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'heading', item, dict));
				case 2:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'toggled', item, dict));
				case 3:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'transitioning', item, dict));
				default:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'icon', item, dict));
			}
		}),
	_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty));
var $author$project$Csf$FilterSideBar$inputField = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$FilterSideBar$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var heading_ = $author$project$Csf$FilterSideBar$getHeading(params);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf form-group')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						(heading_ !== '') ? _List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('f-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(heading_)
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('csf form-control input-sm'),
								attrs_),
							_List_Nil)
						]),
						children
					])));
	});
var $author$project$Helpers$Utilities$invalidDateRage = F2(
	function (startDate, endDate) {
		var mbeMapEnd = F2(
			function (ini_, end_) {
				return 2 === A2($justinmimbs$date$Date$compare, ini_, end_);
			});
		var mbeMapStart = function (ini_) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					mbeMapEnd(ini_),
					endDate));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, mbeMapStart, startDate));
	});
var $author$project$Csf$FilterSideBar$labeledField = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$FilterSideBar$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var heading_ = $author$project$Csf$FilterSideBar$getHeading(params);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf form-group')
					]),
				attrs_),
			$elm$core$List$concat(
				_List_fromArray(
					[
						(heading_ !== '') ? _List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('f-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(heading_)
								]))
						]) : _List_Nil,
						children
					])));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Csf$Core$HtmlAttr = function (a) {
	return {$: 1, a: a};
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Csf$Core$onClickEvent = function (msg) {
	return $author$project$Csf$Core$HtmlAttr(
		$elm$html$Html$Events$onClick(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Csf$FilterSideBar$onInputEvent = function (msg) {
	return $author$project$Csf$FilterSideBar$HtmlAttr(
		$elm$html$Html$Events$onInput(msg));
};
var $author$project$Page$ConsultarStock$ToggleDashlet = function (a) {
	return {$: 13, a: a};
};
var $author$project$Csf$FilterSideBar$collapsedItem = function (icon_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('listview__item csf-collapsed-sidebar-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('actions listview__actions')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('actions__item'),
								$elm$html$Html$Attributes$class(icon_),
								$elm$html$Html$Attributes$class('zmdi-hc-lg'),
								A2($elm$html$Html$Attributes$style, 'color', '#747a80')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Csf$FilterSideBar$dashlet = F3(
	function (attrs, children, model) {
		var _v0 = $author$project$Csf$FilterSideBar$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var evt = function () {
			var _v5 = A2($elm$core$Dict$get, 'toggleEvent', params);
			if ((!_v5.$) && (!_v5.a.$)) {
				var v = _v5.a.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(v)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var heading_ = $author$project$Csf$FilterSideBar$getHeading(params);
		var icon_ = function () {
			var _v4 = A2($elm$core$Dict$get, 'icon', params);
			if ((!_v4.$) && (_v4.a.$ === 4)) {
				var v = _v4.a.a;
				return v;
			} else {
				return '';
			}
		}();
		var toggled_ = function () {
			var _v3 = A2($elm$core$Dict$get, 'toggled', params);
			if ((!_v3.$) && (_v3.a.$ === 2)) {
				var v = _v3.a.a;
				return v;
			} else {
				return false;
			}
		}();
		var transitioning_ = function () {
			var _v2 = A2($elm$core$Dict$get, 'transitioning', params);
			if ((!_v2.$) && (_v2.a.$ === 3)) {
				var v = _v2.a.a;
				return v;
			} else {
				return false;
			}
		}();
		var _v1 = model.w;
		if (!_v1) {
			return $author$project$Csf$FilterSideBar$collapsedItem(icon_);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('listview__item listview--bordered listview__item--sidebar csf-sidebar-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cursor-pointer')
									]),
									evt
								])),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('listview__img'),
										A2($elm$html$Html$Attributes$style, 'margin', '0 5px 0 0'),
										A2($elm$html$Html$Attributes$style, 'height', 'auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(icon_),
												$elm$html$Html$Attributes$class('zmdi-hc-lg')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('listview__content')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(heading_)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('actions listview__actions'),
										A2($elm$html$Html$Attributes$style, 'font-size', '1.4rem'),
										A2($elm$html$Html$Attributes$style, 'margin-right', '15px')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('actions__item'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('zmdi zmdi-plus', (!toggled_) && (!transitioning_)),
														_Utils_Tuple2('zmdi zmdi-minus', toggled_ || transitioning_)
													])),
												A2($elm$html$Html$Attributes$style, 'color', '#747a80')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-break')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidebar-dashlet-content csf-slide-up'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('csf-slide-down', toggled_)
									]))
							]),
						children)
					]));
		}
	});
var $author$project$Csf$FilterSideBar$Icon = function (a) {
	return {$: 4, a: a};
};
var $author$project$Csf$FilterSideBar$icon = $author$project$Csf$FilterSideBar$Icon;
var $author$project$Csf$FilterSideBar$ToggleEvent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Csf$FilterSideBar$onToggle = $author$project$Csf$FilterSideBar$ToggleEvent;
var $author$project$Csf$FilterSideBar$Toggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Csf$FilterSideBar$toggled = $author$project$Csf$FilterSideBar$Toggled;
var $author$project$Csf$FilterSideBar$Transitioning = function (a) {
	return {$: 3, a: a};
};
var $author$project$Csf$FilterSideBar$transitioning = $author$project$Csf$FilterSideBar$Transitioning;
var $author$project$Page$ConsultarStock$renderDashlet = F6(
	function (toMsg, heading_, dashlet_, icon_class_, _v0, children_) {
		var moduleDashlets = _v0.eO;
		var boolFromDashlet = function (key_) {
			return A5($author$project$Helpers$Utilities$fromEmbeddedDict, dashlet_, key_, false, $elm$json$Json$Decode$bool, moduleDashlets);
		};
		var dashlet_attrs = _List_fromArray(
			[
				$author$project$Csf$FilterSideBar$heading(heading_),
				$author$project$Csf$FilterSideBar$onToggle(
				toMsg(
					$author$project$Page$ConsultarStock$ToggleDashlet(dashlet_))),
				$author$project$Csf$FilterSideBar$toggled(
				boolFromDashlet('toggled_')),
				$author$project$Csf$FilterSideBar$icon('zmdi ' + icon_class_),
				$author$project$Csf$FilterSideBar$transitioning(
				boolFromDashlet('transitioning_'))
			]);
		return A2($author$project$Csf$FilterSideBar$dashlet, dashlet_attrs, children_);
	});
var $author$project$Csf$Core$Stacked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Csf$Core$stacked = $author$project$Csf$Core$Stacked;
var $author$project$DatePicker$Blur = {$: 8};
var $author$project$DatePicker$ClearDate = {$: 11};
var $author$project$DatePicker$Focus = {$: 7};
var $author$project$DatePicker$SubmitText = {$: 6};
var $author$project$DatePicker$Text = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $author$project$DatePicker$ChangeFocusAndPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$DatePicker$ChangePeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$DatePicker$MouseDown = {$: 9};
var $author$project$DatePicker$MouseUp = {$: 10};
var $author$project$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $author$project$DatePicker$groupQuarters = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 3) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $author$project$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.bP;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $author$project$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.bP;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $author$project$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $author$project$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $author$project$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			hB: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			gc: date
		};
	});
var $author$project$DatePicker$Date$Decade = 2;
var $author$project$DatePicker$Date$prevPeriod = function (period) {
	switch (period) {
		case 0:
			return 1;
		case 1:
			return 2;
		default:
			return period;
	}
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$DatePicker$Pick = function (a) {
	return {$: 4, a: a};
};
var $author$project$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.ey(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $author$project$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'active',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.f5(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $author$project$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.gc;
		var today = _v0.a8;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $author$project$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.O;
		var today = model.a8;
		var pickedDateOrToday = A2($elm$core$Maybe$withDefault, today, pickedDate);
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.ej) - 1;
		var dpClassList = $author$project$DatePicker$mkClassList(settings);
		var dpClass = $author$project$DatePicker$mkClass(settings);
		var currentDate = A2($elm$core$Maybe$withDefault, pickedDateOrToday, focused);
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($author$project$DatePicker$prepareDates, currentDate, settings.ej);
		var currentMonth = _v0.gc;
		var currentDates = _v0.hB;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$author$project$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.d2;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$author$project$DatePicker$Date$changeYear(currentDate),
						$author$project$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$author$project$DatePicker$Date$yearRange,
							{gc: currentMonth, a8: today},
							settings.d2),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					function () {
					var _v3 = model.ag;
					switch (_v3) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('days')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												dpClass('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_fromArray(
													[
														dpClass('weekdays')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('prev'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('‹')
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('switch'),
																		$elm$html$Html$Attributes$colspan(5),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangePeriod(
																			$author$project$DatePicker$Date$prevPeriod(model.ag)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		settings.gK(
																			$justinmimbs$date$Date$month(currentDate))),
																		$elm$html$Html$text(' '),
																		$elm$html$Html$text(
																		settings.dR(
																			$justinmimbs$date$Date$year(currentDate)))
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('next'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('›')
																	]))
															])),
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$map,
															function (d) {
																return A2(
																	$elm$html$Html$td,
																	_List_fromArray(
																		[
																			dpClass('dow')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			settings.ge(d))
																		]));
															},
															A2(
																$elm$core$List$take,
																7,
																A2(
																	$elm$core$List$drop,
																	firstDayOffset,
																	$elm$core$List$concat(
																		A2(
																			$elm$core$List$repeat,
																			2,
																			_List_fromArray(
																				[0, 1, 2, 3, 4, 5, 6])))))))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_fromArray(
													[
														dpClass('days')
													]),
												dayList)
											]))
									]));
						case 1:
							var quarters = _List_fromArray(
								[
									_List_fromArray(
									[0, 1, 2, 3]),
									_List_fromArray(
									[4, 5, 6, 7]),
									_List_fromArray(
									[8, 9, 10, 11])
								]);
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('years')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												dpClass('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('prev'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('‹')
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('switch'),
																		$elm$html$Html$Attributes$colspan(5),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangePeriod(
																			$author$project$DatePicker$Date$prevPeriod(model.ag)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		settings.dR(
																			$justinmimbs$date$Date$year(currentDate)))
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('next'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 0, 1, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('›')
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												dpClass('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tbody,
												_List_fromArray(
													[
														dpClass('days')
													]),
												A2(
													$elm$core$List$map,
													function (quarter) {
														return A2(
															$elm$html$Html$tr,
															_List_Nil,
															A2(
																$elm$core$List$map,
																function (m) {
																	return A2(
																		$elm$html$Html$td,
																		_List_fromArray(
																			[
																				dpClass('month'),
																				dpClassList(
																				_List_fromArray(
																					[
																						_Utils_Tuple2(
																						'active',
																						_Utils_eq(
																							$justinmimbs$date$Date$month(pickedDateOrToday),
																							m))
																					])),
																				$elm$html$Html$Events$onClick(
																				$author$project$DatePicker$ChangeFocusAndPeriod(
																					A3(
																						$justinmimbs$date$Date$fromCalendarDate,
																						$justinmimbs$date$Date$year(currentDate),
																						m,
																						1)))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$DatePicker$Date$es.kA(m))
																			]));
																},
																quarter));
													},
													quarters))
											]))
									]));
						default:
							var decadeStart = (($justinmimbs$date$Date$year(currentDate) / 10) | 0) * 10;
							var decadeEnd = decadeStart + 10;
							var decade = $author$project$DatePicker$groupQuarters(
								A2(
									$elm$core$List$map,
									function (y) {
										return A3(
											$justinmimbs$date$Date$fromCalendarDate,
											y,
											$justinmimbs$date$Date$month(currentDate),
											1);
									},
									A2($elm$core$List$range, decadeStart - 1, decadeEnd)));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('years')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												dpClass('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('prev'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 0, -10, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('‹')
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('switch'),
																		$elm$html$Html$Attributes$colspan(5),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangePeriod(
																			$author$project$DatePicker$Date$prevPeriod(model.ag)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(decadeStart)),
																		$elm$html$Html$text(' - '),
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(decadeEnd))
																	])),
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		dpClass('next'),
																		$elm$html$Html$Events$onClick(
																		$author$project$DatePicker$ChangeFocus(
																			A3($justinmimbs$date$Date$add, 0, 10, currentDate)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('›')
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												dpClass('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tbody,
												_List_fromArray(
													[
														dpClass('days')
													]),
												A2(
													$elm$core$List$map,
													function (quarter) {
														return A2(
															$elm$html$Html$tr,
															_List_Nil,
															A2(
																$elm$core$List$map,
																function (d) {
																	return A2(
																		$elm$html$Html$td,
																		_List_fromArray(
																			[
																				dpClass('month'),
																				dpClassList(
																				_List_fromArray(
																					[
																						_Utils_Tuple2(
																						'active',
																						_Utils_eq(
																							$justinmimbs$date$Date$year(d),
																							$justinmimbs$date$Date$year(currentDate)))
																					])),
																				$elm$html$Html$Events$onClick(
																				$author$project$DatePicker$ChangeFocusAndPeriod(
																					A3(
																						$justinmimbs$date$Date$fromCalendarDate,
																						$justinmimbs$date$Date$year(d),
																						$justinmimbs$date$Date$month(d),
																						$justinmimbs$date$Date$day(d))))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				settings.dR(
																					$justinmimbs$date$Date$year(d)))
																			]));
																},
																quarter));
													},
													decade))
											]))
									]));
					}
				}()
				]));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var showHide = function () {
			if (pickedDate.$ === 1) {
				return 'zmdiCalendarNoteCustomDate';
			} else {
				return 'hidden';
			}
		}();
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.gA));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.bP + 'input', true)
				]),
			settings.gz);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.gB)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($author$project$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($author$project$DatePicker$Text),
							$elm$html$Html$Events$onBlur($author$project$DatePicker$Blur),
							$elm$html$Html$Events$onClick($author$project$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($author$project$DatePicker$Focus),
							$elm$html$Html$Attributes$autocomplete(false)
						]),
					_Utils_ap(
						settings.gy,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var hideShow = function () {
			if (pickedDate.$ === 1) {
				return 'hidden';
			} else {
				return 'zmdiCloseClearDate';
			}
		}();
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.kV),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.gd, pickedDate)),
						model.aq))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.bP + 'container', true),
			settings.ga);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-calendar-note zmdi-hc-lg zmdi-custom-date p-0 m-0 fs-2-3rem ' + showHide),
							$elm$html$Html$Events$onClick($author$project$DatePicker$Focus)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-close fs-2-1rem zmdi-clear-date p-0 m-0 ' + hideShow),
							$elm$html$Html$Events$onClick($author$project$DatePicker$ClearDate)
						]),
					_List_Nil),
					model.au ? A3($author$project$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$ConsultarStock$cargaDashlet = F2(
	function (toMsg, model) {
		var fechaCargaIni = model.b0;
		var fechaCargaFin = model.b$;
		var dtPickerCargaIni = model.cI;
		var dtPickerCargaFin = model.cH;
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$ConsultarStock$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$ConsultarStock$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$ConsultarStock$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		var cargaInvalidRange = A2($author$project$Helpers$Utilities$invalidDateRage, fechaCargaIni, fechaCargaFin);
		return A6(
			$author$project$Page$ConsultarStock$renderDashlet,
			toMsg,
			'Carga',
			'dashlet_carga',
			'zmdi-case-check',
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 9, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha de Carga')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Hoy'),
									A3(
									$elm$core$Basics$composeL,
									$author$project$Csf$Core$onClickEvent,
									toMsg,
									$author$project$Page$ConsultarStock$TodayFilterMsg('dashlet_carga'))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 7 días'),
									A3(
									$elm$core$Basics$composeL,
									$author$project$Csf$Core$onClickEvent,
									toMsg,
									$author$project$Page$ConsultarStock$Last7DaysFilterMsg('dashlet_carga'))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 30 días'),
									A3(
									$elm$core$Basics$composeL,
									$author$project$Csf$Core$onClickEvent,
									toMsg,
									$author$project$Page$ConsultarStock$Last30DaysFilterMsg('dashlet_carga'))
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_Nil,
					_List_fromArray(
						[
							cargaInvalidRange ? A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							false,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-1')
								]),
							'Fecha inicio mayor que Fecha fin.') : $elm$html$Html$text('')
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha inicio'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Page$ConsultarStock$CargaIniPickerMsg, toMsg),
									A3(
										$author$project$DatePicker$view,
										fechaCargaIni,
										$author$project$Helpers$Utilities$pickerSettings_('cargafini'),
										dtPickerCargaIni))
								]))
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha fin'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Page$ConsultarStock$CargaFinPickerMsg, toMsg),
									A3(
										$author$project$DatePicker$view,
										fechaCargaFin,
										$author$project$Helpers$Utilities$pickerSettings_('cargaffin'),
										dtPickerCargaFin))
								]))
						]))
				]));
	});
var $author$project$SelectTwo$selectOption = F2(
	function (msg, _v0) {
		var val = _v0.a;
		var txt = _v0.b;
		return _Utils_Tuple3(
			$elm$core$Maybe$Just(
				msg(val)),
			txt,
			true);
	});
var $author$project$SelectTwo$basicSelectOptions = F2(
	function (msg, list) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'',
				A2(
					$elm$core$List$map,
					$author$project$SelectTwo$selectOption(msg),
					list))
			]);
	});
var $author$project$SelectTwo$Private$tuple3First = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	return a;
};
var $author$project$SelectTwo$defaultsFromList = F2(
	function (defaults, list) {
		return A2(
			$elm$core$List$filter,
			function (l) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2($elm$core$List$member, a, defaults);
						},
						$author$project$SelectTwo$Private$tuple3First(l)));
			},
			A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var l = _v0.b;
					return l;
				},
				list));
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$SelectTwo$Types$SelectTwoTrigger = function (a) {
	return {$: 0, a: a};
};
var $author$project$SelectTwo$Private$buildDropdown = F7(
	function (id_, defaults, list, showSearch, ajax, delay, noResultsMessage) {
		return {jB: ajax, jW: defaults, jX: delay, kk: id_, kv: list, kH: noResultsMessage, k7: showSearch, lz: 0, lA: 0, lD: 0};
	});
var $author$project$SelectTwo$Private$location = F8(
	function (id_, sender, defaults, list, showSearch, noResultsMessage, ajax, delay) {
		return A2(
			$elm$json$Json$Decode$map,
			function (msg) {
				return {bt: msg, kW: true, la: true};
			},
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$SelectTwo$Types$SelectTwoTrigger, sender),
				$elm$json$Json$Decode$succeed(
					A7($author$project$SelectTwo$Private$buildDropdown, id_, defaults, list, showSearch, ajax, delay, noResultsMessage))));
	});
var $author$project$SelectTwo$Types$SetSelectTwoSearch = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$SelectTwo$Html$preventAndStop = function (msg) {
	return $elm$json$Json$Decode$succeed(
		{bt: msg, kW: true, la: true});
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$SelectTwo$Html$multiSelectSpan = F9(
	function (sender, id_, defaults, list, clearMsg, closeOnClear, disabled, placeholder, ajax) {
		var theList = ajax ? _List_fromArray(
			[
				_Utils_Tuple2('', defaults)
			]) : list;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select2-selection select2-selection--multiple')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-selection__rendered')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var msg = _v0.a;
								var txt = _v0.b;
								var sel = _v0.c;
								return A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select2-selection__choice')
										]),
									_List_fromArray(
										[
											function () {
											if (!clearMsg.$) {
												var clrMsg = clearMsg.a;
												return closeOnClear ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('select2-selection__choice__remove'),
															A2(
															$elm$html$Html$Events$custom,
															'click',
															$author$project$SelectTwo$Html$preventAndStop(
																sender(
																	$author$project$SelectTwo$Types$SelectTwoSelected(
																		$elm$core$Maybe$Just(
																			clrMsg(msg))))))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('×')
														])) : A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('select2-selection__choice__remove'),
															$elm$html$Html$Events$onClick(
															clrMsg(msg))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('×')
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}(),
											$elm$html$Html$text(txt)
										]));
							},
							A2(
								$elm$core$List$filter,
								function (a) {
									return A2($elm$core$List$member, a, defaults);
								},
								A2($elm$core$List$concatMap, $elm$core$Tuple$second, theList))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('select2-search select2-search--inline')
									]),
								_List_fromArray(
									[
										(!disabled) ? A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select2-search__field'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeR, $author$project$SelectTwo$Types$SetSelectTwoSearch, sender)),
												$elm$html$Html$Attributes$id(id_ + '--search'),
												$elm$html$Html$Attributes$placeholder(
												($elm$core$List$length(defaults) > 0) ? '' : placeholder)
											]),
										_List_Nil) : $elm$html$Html$text('')
									]))
							])))
				]));
	});
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$SelectTwo$Html$singleSelectSpan = F5(
	function (sender, _default, clearMsg, closeOnClear, placeholder) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3($elm$core$Maybe$Nothing, '', false),
			_default);
		var defaultMsg = _v0.a;
		var defaultText = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select2-selection select2-selection--single')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-selection__rendered')
						]),
					_List_fromArray(
						[
							function () {
							if (defaultText === '') {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select2-selection__placeholder')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(placeholder)
										]));
							} else {
								if (!clearMsg.$) {
									var msg = clearMsg.a;
									return closeOnClear ? A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select2-selection__clear'),
												A2(
												$elm$html$Html$Events$custom,
												'click',
												$author$project$SelectTwo$Html$preventAndStop(
													sender(
														$author$project$SelectTwo$Types$SelectTwoSelected(
															$elm$core$Maybe$Just(
																msg(defaultMsg))))))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('×')
											])) : A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select2-selection__clear'),
												$elm$html$Html$Events$onClick(
												msg(defaultMsg))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('×')
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}
						}(),
							$elm$html$Html$text(defaultText)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-selection__arrow')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$b, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$SelectTwo$Html$select2 = F2(
	function (sender, _v0) {
		var defaults = _v0.jW;
		var list = _v0.kv;
		var clearMsg = _v0.jN;
		var showSearch = _v0.k7;
		var width = _v0.lz;
		var placeholder = _v0.kV;
		var id_ = _v0.kk;
		var disabled = _v0.jY;
		var multiSelect = _v0.kE;
		var noResultsMessage = _v0.kH;
		var ajax = _v0.jB;
		var delay = _v0.jX;
		var closeOnClear = _v0.jO;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('select2 elm-select2 select2-container select2-container--default select2-container--below select2-container--focus', true),
							_Utils_Tuple2('select2-container--disabled', disabled)
						])),
					$elm$html$Html$Attributes$id(id_),
					A2($elm$html$Html$Attributes$style, 'width', width),
					(!disabled) ? A2(
					$elm$html$Html$Events$custom,
					'click',
					A8($author$project$SelectTwo$Private$location, id_, sender, defaults, list, showSearch && (!multiSelect), noResultsMessage, ajax, delay)) : A2($elm$html$Html$Attributes$attribute, 'data-blank', '')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selection')
						]),
					_List_fromArray(
						[
							multiSelect ? A9($author$project$SelectTwo$Html$multiSelectSpan, sender, id_, defaults, list, clearMsg, closeOnClear, disabled, placeholder, ajax) : A5(
							$author$project$SelectTwo$Html$singleSelectSpan,
							sender,
							$elm$core$List$head(defaults),
							clearMsg,
							closeOnClear,
							placeholder)
						]))
				]));
	});
var $author$project$SelectTwo$Types$ResultScroll = function (a) {
	return {$: 10, a: a};
};
var $author$project$SelectTwo$Types$STNull = {$: 8};
var $author$project$SelectTwo$Private$filterList = F2(
	function (filter, _v0) {
		var text = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					A2(
						$elm$core$Basics$composeR,
						function (a) {
							return A2(
								$elm$core$String$contains,
								a,
								$elm$core$String$toLower(text));
						},
						$elm$core$Maybe$Just)),
				filter));
	});
var $author$project$SelectTwo$Private$filterGroup = F2(
	function (filter, list) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$filter(
				$author$project$SelectTwo$Private$filterList(filter)),
			list);
	});
var $author$project$SelectTwo$Types$SelectTwoHovered = function (a) {
	return {$: 2, a: a};
};
var $author$project$SelectTwo$Private$boolToString = function (a) {
	if (a) {
		return 'True';
	} else {
		return 'False';
	}
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$SelectTwo$Private$tuple3Second = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	return b;
};
var $author$project$SelectTwo$Html$runCustomHtml = F2(
	function (customHtml, option) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(
				$author$project$SelectTwo$Private$tuple3Second(option)),
			A2(
				$elm$core$Maybe$andThen,
				function (ch) {
					return ch(option);
				},
				customHtml));
	});
var $author$project$SelectTwo$Html$select2ListItem = F5(
	function (sender, defaults, hovered, customHtml, option) {
		var _v0 = option;
		var msg = _v0.a;
		var display = _v0.b;
		var enabled = _v0.c;
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$concatMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('select2-results__option', true),
									_Utils_Tuple2(
									'select2-results__option--highlighted',
									_Utils_eq(msg, hovered))
								])),
							$elm$html$Html$Events$onMouseOver(
							sender(
								$author$project$SelectTwo$Types$SelectTwoHovered(msg)))
						]),
						enabled ? _List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							sender(
								$author$project$SelectTwo$Types$SelectTwoSelected(msg))),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-selected',
							$elm$core$String$toLower(
								$author$project$SelectTwo$Private$boolToString(
									A2($elm$core$List$member, option, defaults))))
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-disabled',
							$elm$core$String$toLower(
								$author$project$SelectTwo$Private$boolToString(!enabled)))
						])
					])),
			_List_fromArray(
				[
					A2($author$project$SelectTwo$Html$runCustomHtml, customHtml, option)
				]));
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$SelectTwo$Private$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $author$project$SelectTwo$Private$uniqueBy = F2(
	function (f, list) {
		return A4($author$project$SelectTwo$Private$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$SelectTwo$Html$select2ListGroup = F5(
	function (sender, defaults, hovered, customHtml, _v0) {
		var label = _v0.a;
		var list = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select2-results__option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-results__group')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-results__options select2-results__options--nested')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$SelectTwo$Html$select2ListItem, sender, defaults, hovered, customHtml),
						A2($author$project$SelectTwo$Private$uniqueBy, $elm$core$Basics$identity, list)))
				]));
	});
var $author$project$SelectTwo$Html$listOrGroup = F6(
	function (sender, defaults, list, hovered, search, customHtml) {
		return (($elm$core$List$length(list) === 1) && (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(list))) === '')) ? A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(
					A4($author$project$SelectTwo$Html$select2ListItem, sender, defaults, hovered, customHtml)),
				A2(
					$elm$core$Maybe$map,
					$author$project$SelectTwo$Private$uniqueBy($elm$core$Basics$identity),
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$filter(
							$author$project$SelectTwo$Private$filterList(search)),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							$elm$core$List$head(list)))))) : A2(
			$elm$core$List$map,
			A4($author$project$SelectTwo$Html$select2ListGroup, sender, defaults, hovered, customHtml),
			A2(
				$elm$core$List$map,
				$author$project$SelectTwo$Private$filterGroup(search),
				list));
	});
var $author$project$SelectTwo$Html$noResultsFound = function (noResults) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('select2-results__option', true),
						_Utils_Tuple2('select2-results__message', true)
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, 'No Results Found', noResults))
			]));
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$SelectTwo$Private$px = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromFloat,
	function (a) {
		return a + 'px';
	});
var $author$project$SelectTwo$Types$ScrollInfo = F2(
	function (scrollHeight, scrollTop) {
		return {k3: scrollHeight, k4: scrollTop};
	});
var $author$project$SelectTwo$Html$scrollPosition = function (wrapper) {
	return A2(
		$elm$json$Json$Decode$map,
		wrapper,
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$SelectTwo$Types$ScrollInfo,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'scrollHeight']),
				$elm$json$Json$Decode$int),
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$add,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'scrollTop']),
					$elm$json$Json$Decode$int),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'clientHeight']),
					$elm$json$Json$Decode$int))));
};
var $author$project$SelectTwo$Html$select2DropdownDraw = F7(
	function (sender, _v0, hovered, search, ajaxList, ajaxParams, customHtml) {
		var id_ = _v0.kk;
		var defaults = _v0.jW;
		var list = _v0.kv;
		var showSearch = _v0.k7;
		var x = _v0.lA;
		var y = _v0.lD;
		var width = _v0.lz;
		var ajax = _v0.jB;
		var noResultsMessage = _v0.kH;
		var theList = ajax ? ((A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var loading = _v1.br;
					return loading;
				},
				ajaxParams)) && $elm$core$List$isEmpty(ajaxList)) ? _List_fromArray(
			[
				_Utils_Tuple2(
				'',
				_List_fromArray(
					[
						_Utils_Tuple3($elm$core$Maybe$Nothing, 'Searching', false)
					]))
			]) : ajaxList) : list;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-select2 select2-container select2-container--default select2-container--open'),
					$elm$html$Html$Attributes$id(id_ + '-dropdown'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$author$project$SelectTwo$Private$px(x)),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$author$project$SelectTwo$Private$px(y)),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$author$project$SelectTwo$Private$px(width))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-dropdown select2-dropdown--below')
						]),
					_List_fromArray(
						[
							showSearch ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select2-search select2-search--dropdown')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('csf form-control input-sm'),
											$elm$html$Html$Attributes$autocomplete(false),
											$elm$html$Html$Attributes$id(id_ + '--search'),
											$elm$html$Html$Events$onInput(
											A2($elm$core$Basics$composeR, $author$project$SelectTwo$Types$SetSelectTwoSearch, sender)),
											A2(
											$elm$html$Html$Events$custom,
											'click',
											$author$project$SelectTwo$Html$preventAndStop(
												sender($author$project$SelectTwo$Types$STNull)))
										]),
									_List_Nil)
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select2-results')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select2-results__options'),
											A2(
											$elm$html$Html$Events$on,
											'scroll',
											$author$project$SelectTwo$Html$scrollPosition(
												A2($elm$core$Basics$composeR, $author$project$SelectTwo$Types$ResultScroll, sender)))
										]),
									(ajax && (_Utils_eq(
										theList,
										_List_fromArray(
											[
												_Utils_Tuple2('', _List_Nil)
											])) || $elm$core$List$isEmpty(theList))) ? _List_fromArray(
										[
											$author$project$SelectTwo$Html$noResultsFound(noResultsMessage)
										]) : A6($author$project$SelectTwo$Html$listOrGroup, sender, defaults, theList, hovered, search, customHtml))
								]))
						]))
				]));
	});
var $author$project$SelectTwo$Html$select2Dropdown = F3(
	function (sender, customHtml, model) {
		var _v0 = model.k5;
		if (!_v0.$) {
			var dropdown = _v0.a.eg;
			var hovered = _v0.a.h3;
			var search = _v0.a.gZ;
			var list = _v0.a.kv;
			var ajaxParams = _v0.a.bd;
			return A7($author$project$SelectTwo$Html$select2DropdownDraw, sender, dropdown, hovered, search, list, ajaxParams, customHtml);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Customized$CustomDropdown$dropdownComponent = F2(
	function (disabled_, model) {
		var pickedOption = model.by;
		var dataListSet = model.ec;
		var dropdownList_ = A2($author$project$SelectTwo$basicSelectOptions, $author$project$Customized$CustomDropdown$PickedOption, dataListSet);
		return _List_fromArray(
			[
				A2(
				$author$project$SelectTwo$Html$select2,
				$author$project$Customized$CustomDropdown$SelectTwoMsg_,
				{
					jB: false,
					jN: $elm$core$Maybe$Just(
						function (_v0) {
							return $author$project$Customized$CustomDropdown$PickedOption($elm$core$Maybe$Nothing);
						}),
					jO: true,
					jW: A2(
						$author$project$SelectTwo$defaultsFromList,
						_List_fromArray(
							[
								$author$project$Customized$CustomDropdown$PickedOption(pickedOption)
							]),
						dropdownList_),
					jX: 0,
					jY: disabled_,
					kk: model.cF,
					kv: dropdownList_,
					kE: false,
					kH: $elm$core$Maybe$Nothing,
					kV: A2($elm$core$Maybe$withDefault, 'Seleccione un elemento...', model.gi),
					k7: false,
					lz: '100%'
				}),
				A3($author$project$SelectTwo$Html$select2Dropdown, $author$project$Customized$CustomDropdown$SelectTwoMsg_, $elm$core$Maybe$Nothing, model)
			]);
	});
var $author$project$Customized$CustomDropdown$dropbox = F5(
	function (attrs_, disabled_, growWhenOpen_, heading_, model) {
		var dropdownId = model.cF;
		var dropdownOpen = model.bj;
		var invalidDropdown = model.cG && _Utils_eq($elm$core$Maybe$Nothing, model.by);
		var headLabel = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)(heading_) ? _List_Nil : (A2(
			$elm$core$String$startsWith,
			'*',
			$elm$core$String$trim(heading_)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('* ')
							])),
						A3(
						$elm$core$Basics$composeL,
						$elm$html$Html$text,
						A2($elm$core$String$replace, '*', ''),
						$elm$core$String$trim(heading_))
					]))
			]) : (A2(
			$elm$core$String$endsWith,
			'*',
			$elm$core$String$trim(heading_)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						A3(
						$elm$core$Basics$composeL,
						$elm$html$Html$text,
						A2($elm$core$String$replace, '*', ''),
						$elm$core$String$trim(heading_)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' *')
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(heading_)
					]))
			])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf form-group position-relative'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('height-if-open', growWhenOpen_ && dropdownOpen)
						]))
				]),
			_Utils_ap(
				headLabel,
				_List_fromArray(
					[
						function (divAttrs_) {
						return A2(
							$elm$html$Html$div,
							_Utils_ap(divAttrs_, attrs_),
							A2($author$project$Customized$CustomDropdown$dropdownComponent, disabled_, model));
					}(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('is-invalid', invalidDropdown)
									])),
								A2($elm$html$Html$Attributes$style, 'border', 'none'),
								A2($elm$html$Html$Attributes$style, 'padding', '0'),
								$elm$html$Html$Attributes$tabindex(0),
								$elm$html$Html$Attributes$id('dropbox__' + dropdownId)
							])),
						invalidDropdown ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invalid-feedback')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Campo requerido')
							])) : $elm$html$Html$text('')
					])));
	});
var $author$project$Page$ConsultarStock$chieDashlet = F2(
	function (toMsg, model) {
		var fechaEmisionIni = model.b2;
		var fechaEmisionFin = model.b1;
		var dtPickerEmisionIni = model.cK;
		var dtPickerEmisionFin = model.cJ;
		var emisionInvalidRange = A2($author$project$Helpers$Utilities$invalidDateRage, fechaEmisionIni, fechaEmisionFin);
		return A6(
			$author$project$Page$ConsultarStock$renderDashlet,
			toMsg,
			'CHI-e',
			'dashlet_chie',
			'zmdi-star-outline',
			model,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$ConsultarStock$DropdownMsg(8),
						toMsg),
					A5($author$project$Customized$CustomDropdown$dropbox, _List_Nil, false, true, 'Estado', model.aS))
				]));
	});
var $author$project$Page$ConsultarStock$vehiculoDashlet = F2(
	function (toMsg, model) {
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$ConsultarStock$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$ConsultarStock$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$ConsultarStock$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		return A6(
			$author$project$Page$ConsultarStock$renderDashlet,
			toMsg,
			'Vehículo',
			'dashlet_vehiculo',
			'zmdi-car',
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 1, _List_Nil),
					_List_Nil),
					A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$ConsultarStock$DropdownMsg(11),
						toMsg),
					A5($author$project$Customized$CustomDropdown$dropbox, _List_Nil, false, false, 'Estado', model.bX)),
					A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$ConsultarStock$DropdownMsg(4),
						toMsg),
					A5($author$project$Customized$CustomDropdown$dropbox, _List_Nil, false, false, 'Tipo', model.a5)),
					A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$ConsultarStock$DropdownMsg(3),
						toMsg),
					A5($author$project$Customized$CustomDropdown$dropbox, _List_Nil, false, false, 'Año', model.aN)),
					A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$ConsultarStock$DropdownMsg(6),
						toMsg),
					A5($author$project$Customized$CustomDropdown$dropbox, _List_Nil, false, false, 'Marca', model.aZ)),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 7, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 5, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 10, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 2, _List_Nil),
					_List_Nil)
				]));
	});
var $author$project$Page$ConsultarStock$filterSideBar = F2(
	function (toMsg, model) {
		return _List_fromArray(
			[
				A2($author$project$Page$ConsultarStock$vehiculoDashlet, toMsg, model),
				A2($author$project$Page$ConsultarStock$cargaDashlet, toMsg, model),
				A2($author$project$Page$ConsultarStock$chieDashlet, toMsg, model)
			]);
	});
var $author$project$Page$HistorialDeCargas$filterSideBar = F2(
	function (toMsg, model) {
		return _List_Nil;
	});
var $author$project$Page$SolicitudesChie$OnFilterUpdated = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$dataFromField = F3(
	function (field_, key_, _v0) {
		var moduleFields = _v0.cf;
		return A5(
			$author$project$Helpers$Utilities$fromEmbeddedDict,
			$author$project$Page$SolicitudesChie$stringFromField(field_),
			key_,
			'',
			$elm$json$Json$Decode$string,
			moduleFields);
	});
var $author$project$Page$SolicitudesChie$ToggleDashlet = function (a) {
	return {$: 40, a: a};
};
var $author$project$Page$SolicitudesChie$renderDashlet = F6(
	function (toMsg, heading_, dashlet_, icon_class_, _v0, children_) {
		var moduleDashlets = _v0.eO;
		var boolFromDashlet = function (key_) {
			return A5($author$project$Helpers$Utilities$fromEmbeddedDict, dashlet_, key_, false, $elm$json$Json$Decode$bool, moduleDashlets);
		};
		return function (dashlet_attrs) {
			return A2($author$project$Csf$FilterSideBar$dashlet, dashlet_attrs, children_);
		}(
			_List_fromArray(
				[
					$author$project$Csf$FilterSideBar$heading(heading_),
					$author$project$Csf$FilterSideBar$onToggle(
					toMsg(
						$author$project$Page$SolicitudesChie$ToggleDashlet(dashlet_))),
					$author$project$Csf$FilterSideBar$toggled(
					boolFromDashlet('toggled_')),
					$author$project$Csf$FilterSideBar$icon('zmdi ' + icon_class_),
					$author$project$Csf$FilterSideBar$transitioning(
					boolFromDashlet('transitioning_'))
				]));
	});
var $author$project$Page$SolicitudesChie$chieDashlet = F2(
	function (toMsg, model) {
		var session = model.g$;
		var moduleDropdown_ = F4(
			function (field_, disabled_, growOnOpen_, heading_) {
				return A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$SolicitudesChie$DropdownMsg(field_),
						toMsg),
					A5(
						$author$project$Customized$CustomDropdown$dropbox,
						_List_Nil,
						disabled_,
						growOnOpen_,
						heading_,
						A2(
							$author$project$Helpers$Utilities$getDropdown,
							$author$project$Page$SolicitudesChie$stringFromField(field_),
							model)));
			});
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$SolicitudesChie$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$SolicitudesChie$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		var dealerAndApplicant = $author$project$Page$SolicitudesChie$isSupportUser(session) ? _List_fromArray(
			[
				A4(moduleDropdown_, 14, false, false, 'Distribuidor'),
				A4(moduleDropdown_, 13, false, false, 'Importador')
			]) : ($author$project$Page$SolicitudesChie$showDealer(session) ? _List_fromArray(
			[
				A4(moduleDropdown_, 14, false, false, 'Distribuidor')
			]) : _List_fromArray(
			[
				A4(moduleDropdown_, 13, false, false, 'Importador')
			]));
		return A6(
			$author$project$Page$SolicitudesChie$renderDashlet,
			toMsg,
			'Solicitud',
			'dashlet_chie',
			'zmdi-file-text',
			model,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A4(moduleDropdown_, 10, false, false, 'Estado CHI-e'),
							A4(moduleDropdown_, 15, false, false, 'Estado Conciliación')
						]),
						dealerAndApplicant,
						_List_fromArray(
						[
							A2(
							$author$project$Csf$FilterSideBar$inputField,
							A2(field_attr, 5, _List_Nil),
							_List_Nil)
						])
					])));
	});
var $author$project$Page$SolicitudesChie$Last30DaysFilterMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Page$SolicitudesChie$Last7DaysFilterMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Page$SolicitudesChie$TodayFilterMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$SolicitudesChie$datePickerView = F2(
	function (key_, model) {
		return A3(
			$author$project$DatePicker$view,
			A2($author$project$Helpers$Utilities$getModuleDate, key_, model),
			$author$project$Helpers$Utilities$pickerSettings_(key_),
			A2($author$project$Helpers$Utilities$getDtePicker, key_, model));
	});
var $author$project$Page$SolicitudesChie$emisionDashlet = F2(
	function (toMsg, model) {
		var tupleDteRange = _Utils_Tuple2('emisionfini', 'emisionffin');
		var cargaInvalidRange = A2(
			$author$project$Helpers$Utilities$invalidDateRage,
			A2($author$project$Helpers$Utilities$getModuleDate, 'emisionfini', model),
			A2($author$project$Helpers$Utilities$getModuleDate, 'emisionffin', model));
		return A6(
			$author$project$Page$SolicitudesChie$renderDashlet,
			toMsg,
			'Fecha de emisión',
			'dashlet_emision',
			'zmdi-calendar-note',
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Rango de fechas')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Hoy'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$TodayFilterMsg(tupleDteRange)))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 7 días'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$Last7DaysFilterMsg(tupleDteRange)))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 30 días'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$Last30DaysFilterMsg(tupleDteRange)))
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_Nil,
					_List_fromArray(
						[
							cargaInvalidRange ? A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							false,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-1')
								]),
							'Fecha inicio mayor que Fecha fin') : $elm$html$Html$text('')
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha inicio'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$SolicitudesChie$DatePickerMsg('emisionfini'),
										toMsg),
									A2($author$project$Page$SolicitudesChie$datePickerView, 'emisionfini', model))
								]))
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha fin'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$SolicitudesChie$DatePickerMsg('emisionffin'),
										toMsg),
									A2($author$project$Page$SolicitudesChie$datePickerView, 'emisionffin', model))
								]))
						]))
				]));
	});
var $author$project$Page$SolicitudesChie$fechaDashlet = F2(
	function (toMsg, model) {
		var tupleDteRange = _Utils_Tuple2('fechaini', 'fechafin');
		var cargaInvalidRange = A2(
			$author$project$Helpers$Utilities$invalidDateRage,
			A2($author$project$Helpers$Utilities$getModuleDate, 'fechaini', model),
			A2($author$project$Helpers$Utilities$getModuleDate, 'fechafin', model));
		return A6(
			$author$project$Page$SolicitudesChie$renderDashlet,
			toMsg,
			'Fecha de solicitud',
			'dashlet_fecha',
			'zmdi-calendar-note',
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Rango de fechas')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Hoy'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$TodayFilterMsg(tupleDteRange)))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 7 días'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$Last7DaysFilterMsg(tupleDteRange)))
								]),
							_List_Nil),
							A2(
							$author$project$Csf$Core$commandLink,
							_List_fromArray(
								[
									$author$project$Csf$Core$stacked(true),
									$author$project$Csf$Core$heading('Últimos 30 días'),
									$author$project$Csf$Core$onClickEvent(
									toMsg(
										$author$project$Page$SolicitudesChie$Last30DaysFilterMsg(tupleDteRange)))
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_Nil,
					_List_fromArray(
						[
							cargaInvalidRange ? A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							false,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-1')
								]),
							'Fecha inicio mayor que Fecha fin') : $elm$html$Html$text('')
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha inicio'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$SolicitudesChie$DatePickerMsg('fechaini'),
										toMsg),
									A2($author$project$Page$SolicitudesChie$datePickerView, 'fechaini', model))
								]))
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha fin'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', cargaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$SolicitudesChie$DatePickerMsg('fechafin'),
										toMsg),
									A2($author$project$Page$SolicitudesChie$datePickerView, 'fechafin', model))
								]))
						]))
				]));
	});
var $author$project$Page$SolicitudesChie$vehicleDashlet = F2(
	function (toMsg, model) {
		var session = model.g$;
		var moduleDropdown_ = F4(
			function (field_, disabled_, growOnOpen_, heading_) {
				return A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$SolicitudesChie$DropdownMsg(field_),
						toMsg),
					A5(
						$author$project$Customized$CustomDropdown$dropbox,
						_List_Nil,
						disabled_,
						growOnOpen_,
						heading_,
						A2(
							$author$project$Helpers$Utilities$getDropdown,
							$author$project$Page$SolicitudesChie$stringFromField(field_),
							model)));
			});
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$SolicitudesChie$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$SolicitudesChie$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesChie$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		return A6(
			$author$project$Page$SolicitudesChie$renderDashlet,
			toMsg,
			'Vehículo',
			'dashlet_vehicle',
			'zmdi-car',
			model,
			_List_fromArray(
				[
					A4(moduleDropdown_, 11, false, false, 'Tipo'),
					A4(moduleDropdown_, 12, false, false, 'No Motor'),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 1, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 2, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 3, _List_Nil),
					_List_Nil),
					A4(moduleDropdown_, 6, false, false, 'Año'),
					A4(moduleDropdown_, 7, false, false, 'Color'),
					A4(moduleDropdown_, 8, false, false, 'Marca'),
					A4(moduleDropdown_, 9, false, false, 'Modelo')
				]));
	});
var $author$project$Page$SolicitudesChie$filterSideBar = F2(
	function (toMsg, model) {
		var queryData = model.kX;
		return A2($elm$core$Dict$member, 'file_uuid', queryData) ? _List_Nil : _List_fromArray(
			[
				A2($author$project$Page$SolicitudesChie$emisionDashlet, toMsg, model),
				A2($author$project$Page$SolicitudesChie$fechaDashlet, toMsg, model),
				A2($author$project$Page$SolicitudesChie$chieDashlet, toMsg, model),
				A2($author$project$Page$SolicitudesChie$vehicleDashlet, toMsg, model)
			]);
	});
var $author$project$Page$SolicitudesPendientes$Last30DaysFilterMsg = {$: 25};
var $author$project$Page$SolicitudesPendientes$Last7DaysFilterMsg = {$: 24};
var $author$project$Page$SolicitudesPendientes$OnFilterUpdated = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$TodayFilterMsg = {$: 23};
var $author$project$Page$SolicitudesPendientes$ModuleHelpers$dataFromField = F3(
	function (field_, key_, _v0) {
		var moduleFields = _v0.cf;
		return A5(
			$author$project$Helpers$Utilities$fromEmbeddedDict,
			$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_),
			key_,
			'',
			$elm$json$Json$Decode$string,
			moduleFields);
	});
var $author$project$Page$SolicitudesPendientes$ToggleDashlet = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$SolicitudesPendientes$renderDashlet = F6(
	function (toMsg, heading_, dashlet_, icon_class_, _v0, children_) {
		var moduleDashlets = _v0.eO;
		var boolFromDashlet = function (key_) {
			return A5($author$project$Helpers$Utilities$fromEmbeddedDict, dashlet_, key_, false, $elm$json$Json$Decode$bool, moduleDashlets);
		};
		var dashlet_attrs = _List_fromArray(
			[
				$author$project$Csf$FilterSideBar$attr(
				$elm$html$Html$Attributes$class(dashlet_)),
				$author$project$Csf$FilterSideBar$heading(heading_),
				$author$project$Csf$FilterSideBar$onToggle(
				toMsg(
					$author$project$Page$SolicitudesPendientes$ToggleDashlet(dashlet_))),
				$author$project$Csf$FilterSideBar$toggled(
				boolFromDashlet('toggled_')),
				$author$project$Csf$FilterSideBar$icon('zmdi ' + icon_class_),
				$author$project$Csf$FilterSideBar$transitioning(
				boolFromDashlet('transitioning_'))
			]);
		return A2($author$project$Csf$FilterSideBar$dashlet, dashlet_attrs, children_);
	});
var $author$project$Page$SolicitudesPendientes$tareaDashlet = F2(
	function (toMsg, model) {
		var fechaFilterIni = model.b4;
		var fechaFilterFin = model.b3;
		var dtPickerFechaIni = model.cM;
		var dtPickerFechaFin = model.cL;
		var tareaInvalidRange = A2($author$project$Helpers$Utilities$invalidDateRage, fechaFilterIni, fechaFilterFin);
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$SolicitudesPendientes$ModuleHelpers$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$SolicitudesPendientes$ModuleHelpers$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesPendientes$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		var commandLink_ = F2(
			function (heading_, mssg_) {
				return function (attrs_) {
					return A2($author$project$Csf$Core$commandLink, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$author$project$Csf$Core$stacked(true),
							$author$project$Csf$Core$heading(heading_),
							$author$project$Csf$Core$onClickEvent(
							toMsg(mssg_))
						]));
			});
		return A6(
			$author$project$Page$SolicitudesPendientes$renderDashlet,
			toMsg,
			'Tarea',
			'dashlet_tarea',
			'zmdi-calendar-note',
			model,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Rango de fechas')
						]),
					_List_fromArray(
						[
							A2(commandLink_, 'Hoy', $author$project$Page$SolicitudesPendientes$TodayFilterMsg),
							A2(commandLink_, 'Últimos 7 días', $author$project$Page$SolicitudesPendientes$Last7DaysFilterMsg),
							A2(commandLink_, 'Últimos 30 días', $author$project$Page$SolicitudesPendientes$Last30DaysFilterMsg)
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_Nil,
					_List_fromArray(
						[
							tareaInvalidRange ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('datepicker-error-mssg')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row m-0 pl-1 pr-1 row-col-vertical-align')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-1 m-0 p-0')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('zmdi zmdi-alert-triangle zmdi-hc-fw'),
															A2($elm$html$Html$Attributes$style, 'color', '#FFF')
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-11 p-0 m-0 left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	A2($elm$html$Html$Attributes$style, 'color', '#FFF')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Fecha inicio es mayor que Fecha fin')
																]))
														]))
												]))
										]))
								])) : $elm$html$Html$text('')
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha inicio'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', tareaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Page$SolicitudesPendientes$FechaIniPickerMsg, toMsg),
									A3(
										$author$project$DatePicker$view,
										fechaFilterIni,
										$author$project$Page$SolicitudesPendientes$pickerSettings('fechaini'),
										dtPickerFechaIni))
								]))
						])),
					A2(
					$author$project$Csf$FilterSideBar$labeledField,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading('Fecha fin'),
							$author$project$Csf$FilterSideBar$attr(
							$elm$html$Html$Attributes$class('position-static'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('datepicker-error', tareaInvalidRange)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Page$SolicitudesPendientes$FechaFinPickerMsg, toMsg),
									A3(
										$author$project$DatePicker$view,
										fechaFilterFin,
										$author$project$Page$SolicitudesPendientes$pickerSettings('fechafin'),
										dtPickerFechaFin))
								]))
						]))
				]));
	});
var $author$project$Page$SolicitudesPendientes$vehicleDashlet = F2(
	function (toMsg, model) {
		var session = model.g$;
		var moduleDropdown_ = F4(
			function (field_, disabled_, growOnOpen_, heading_) {
				return A2(
					$elm$html$Html$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$SolicitudesPendientes$DropdownMsg(field_),
						toMsg),
					A5(
						$author$project$Customized$CustomDropdown$dropbox,
						_List_Nil,
						disabled_,
						growOnOpen_,
						heading_,
						A2(
							$author$project$Helpers$Utilities$getDropdown,
							$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_),
							model)));
			});
		var field_attr = F2(
			function (field_, added_) {
				return _Utils_ap(
					added_,
					_List_fromArray(
						[
							$author$project$Csf$FilterSideBar$heading(
							A3($author$project$Page$SolicitudesPendientes$ModuleHelpers$dataFromField, field_, 'label_', model)),
							$author$project$Csf$FilterSideBar$bindTo(
							A3($author$project$Page$SolicitudesPendientes$ModuleHelpers$dataFromField, field_, 'value_', model)),
							$author$project$Csf$FilterSideBar$onInputEvent(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$SolicitudesPendientes$OnFilterUpdated(field_),
								toMsg))
						]));
			});
		return A6(
			$author$project$Page$SolicitudesPendientes$renderDashlet,
			toMsg,
			'Vehículo',
			'dashlet_vehicle',
			'zmdi-car',
			model,
			_List_fromArray(
				[
					A4(moduleDropdown_, 8, false, false, 'Distribuidor'),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 1, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 4, _List_Nil),
					_List_Nil),
					A2(
					$author$project$Csf$FilterSideBar$inputField,
					A2(field_attr, 3, _List_Nil),
					_List_Nil),
					A4(moduleDropdown_, 5, false, false, 'Marca'),
					A4(moduleDropdown_, 6, false, false, 'Modelo')
				]));
	});
var $author$project$Page$SolicitudesPendientes$filterSideBar = F2(
	function (toMsg, model) {
		var queryData = model.kX;
		return A2($elm$core$Dict$member, 'namespace', queryData) ? _List_Nil : _List_fromArray(
			[
				A2($author$project$Page$SolicitudesPendientes$tareaDashlet, toMsg, model),
				A2($author$project$Page$SolicitudesPendientes$vehicleDashlet, toMsg, model)
			]);
	});
var $author$project$Csf$Layout31$LayoutConfig = $elm$core$Basics$identity;
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Csf$Layout31$config = {
	d8: A2($elm$html$Html$div, _List_Nil, _List_Nil),
	ed: false,
	el: A2($elm$html$Html$footer, _List_Nil, _List_Nil),
	et: A2($elm$html$Html$header, _List_Nil, _List_Nil)
};
var $author$project$Csf$Layout31$content = F2(
	function (content_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{d8: content_});
	});
var $author$project$Csf$Layout31$footer = F2(
	function (footer_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{el: footer_});
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Csf$Footer$FooterConfig = $elm$core$Basics$identity;
var $author$project$Csf$Footer$backgroundColor = F2(
	function (color, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{d_: color});
	});
var $author$project$Csf$Footer$config = {d_: '#000000', ed: false, eD: _List_Nil, eE: _List_Nil, c4: '', dq: _List_Nil, fk: _List_Nil, dr: ''};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Csf$Footer$leftContent = F2(
	function (leftContent_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{eD: leftContent_});
	});
var $author$project$Csf$Footer$leftLogoUrl = F2(
	function (leftLogoUrl_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{c4: leftLogoUrl_});
	});
var $author$project$Csf$Footer$rightContent = F2(
	function (rightContent_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{dq: rightContent_});
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Csf$Footer$view = function (_v0) {
	var conf = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('csf-footer'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('container-debug', conf.ed)
					])),
				A2($elm$html$Html$Attributes$style, 'background-color', conf.d_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf-footer-lft-logo')
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2($elm$html$Html$img, attrs_, _List_Nil);
					}(
						_Utils_ap(
							conf.eE,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(conf.c4),
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'super'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'closed hidden',
											$elm$core$String$isEmpty(conf.c4))
										]))
								])))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf-footer-lft-text')
					]),
				conf.eD),
				function (attrs_) {
				return A2($elm$html$Html$div, attrs_, conf.dq);
			}(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf-footer-rght-text'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'closed hidden',
								$elm$core$List$isEmpty(conf.dq))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf-footer-rght-logo'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'closed hidden',
								$elm$core$String$isEmpty(conf.dr))
							]))
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2($elm$html$Html$img, attrs_, _List_Nil);
					}(
						_Utils_ap(
							conf.fk,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(conf.dr),
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'super')
								])))
					]))
			]));
};
var $author$project$Main$footerView = function (model) {
	var span1_attr = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'display', 'block'),
			A2($elm$html$Html$Attributes$style, 'height', '12px'),
			A2($elm$html$Html$Attributes$style, 'padding', '2px 1px')
		]);
	var footer_logo_ = A3(
		$elm$core$Basics$composeR,
		function ($) {
			return $.ka;
		},
		$author$project$Csf$Flags$asset('footer_logo'),
		$author$project$Main$pageSession(model.t));
	var div2_attr = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'top', '1px'),
			$elm$html$Html$Attributes$class('position-relative')
		]);
	var leftContent_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'clear', 'both')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				div2_attr,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('© 2020')
							]))
					]))
			]));
	var rightContent_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'clear', 'both')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				div2_attr,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('CONTÁCTENOS: ')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#fff'),
								A2($elm$html$Html$Attributes$style, 'text-decoration', 'none'),
								$elm$html$Html$Attributes$href('mailto:sopchie@totalcheck.cl')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('sopchie@totalcheck.cl')
							]))
					]))
			]));
	return $author$project$Csf$Footer$view(
		A2(
			$author$project$Csf$Footer$backgroundColor,
			'#000000',
			A2(
				$author$project$Csf$Footer$rightContent,
				_List_fromArray(
					[rightContent_]),
				A2(
					$author$project$Csf$Footer$leftContent,
					_List_fromArray(
						[leftContent_]),
					A2($author$project$Csf$Footer$leftLogoUrl, footer_logo_, $author$project$Csf$Footer$config)))));
};
var $author$project$Csf$Layout31$header = F2(
	function (header_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{et: header_});
	});
var $author$project$Helpers$Utilities$assetImage = F3(
	function (attr_, img_, flags_) {
		return A2(
			$elm$html$Html$img,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(
						A2($author$project$Csf$Flags$asset, img_, flags_))
					]),
				attr_),
			_List_Nil);
	});
var $author$project$Csf$Header$HeaderConfig = $elm$core$Basics$identity;
var $author$project$Csf$Header$config = function (toMsg) {
	return {
		d7: {go: $elm$core$Maybe$Nothing, iA: '/configuration', iI: $elm$core$Maybe$Nothing},
		eA: _List_Nil,
		c7: A2($elm$html$Html$span, _List_Nil, _List_Nil),
		eJ: {go: $elm$core$Maybe$Nothing, iA: '/logout', iI: $elm$core$Maybe$Nothing},
		e7: {go: $elm$core$Maybe$Nothing, iA: '/profile', iI: $elm$core$Maybe$Nothing},
		ds: $elm$core$Maybe$Nothing,
		fJ: toMsg,
		fO: {go: $elm$core$Maybe$Nothing, iA: '/users', iI: $elm$core$Maybe$Nothing}
	};
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Csf$Header$items = F2(
	function (items_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{eA: items_});
	});
var $author$project$Csf$Header$logo = F2(
	function (logo_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{c7: logo_});
	});
var $author$project$Csf$Header$logoutUrl = F2(
	function (logoutUrl_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{eJ: logoutUrl_});
	});
var $author$project$Csf$Header$ToggleProfileMsg = 0;
var $author$project$Csf$Core$attr = $author$project$Csf$Core$HtmlAttr;
var $author$project$Csf$Core$dropdown__menu = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$div,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu position-absolute'),
							A2($elm$html$Html$Attributes$style, 'will-change', 'transform')
						]),
						attrs
					])),
			children);
	});
var $author$project$Csf$Core$routeToString = function (route) {
	return _Utils_ap(
		route.iA,
		_Utils_ap(
			(!_Utils_eq(route.iI, $elm$core$Maybe$Nothing)) ? ('?' + A2($elm$core$Maybe$withDefault, '', route.iI)) : '',
			(!_Utils_eq(route.go, $elm$core$Maybe$Nothing)) ? ('#' + A2($elm$core$Maybe$withDefault, '', route.go)) : ''));
};
var $author$project$Csf$Core$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Csf$Core$routeToString(targetRoute));
};
var $author$project$Csf$Core$list = function (l) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2($elm$core$List$filter, $elm$core$Tuple$second, l));
};
var $author$project$Csf$Core$listview = F2(
	function (attrs, children) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('listview'),
				attrs),
			children);
	});
var $author$project$Csf$Core$listview__bordered = $elm$html$Html$Attributes$class('listview--bordered');
var $author$project$Csf$Core$listview__item = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Core$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var heading_ = function () {
			var _v1 = A2($elm$core$Dict$get, 'heading', params);
			if ((!_v1.$) && (!_v1.a.$)) {
				var v = _v1.a.a;
				return v;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('listview__item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listview__content')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								$author$project$Csf$Core$list(
								_List_fromArray(
									[
										_Utils_Tuple2(
										A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('listview__heading'),
												attrs_),
											_List_fromArray(
												[
													$elm$html$Html$text(heading_)
												])),
										heading_ !== '')
									])),
								children
							])))
				]));
	});
var $author$project$Csf$Core$menu__right = $elm$html$Html$Attributes$class('dropdown-menu-right');
var $author$project$Csf$Core$show = function (isTrue) {
	return $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('show', isTrue)
			]));
};
var $author$project$Csf$Header$profileItem = F3(
	function (path, _v0, model) {
		var conf = _v0;
		var session = model.g$;
		return A2(
			$elm$html$Html$map,
			conf.fJ,
			A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('position-relative')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inbox-action'),
								$elm$html$Html$Events$onClick(0),
								A2(
								$elm$html$Html$Attributes$attribute,
								'title_',
								$author$project$Csf$Flags$username(session.ka))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'margin-right', '5px'),
										A2($elm$html$Html$Attributes$style, 'width', '30px'),
										A2($elm$html$Html$Attributes$style, 'height', '30px'),
										A2($elm$html$Html$Attributes$style, 'border-radius', '50%'),
										$elm$html$Html$Attributes$src(path)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Csf$Core$dropdown__menu,
						_List_fromArray(
							[
								$author$project$Csf$Core$menu__right,
								$author$project$Csf$Core$show(model.cn),
								A2($elm$html$Html$Attributes$style, 'top', '43px'),
								A2($elm$html$Html$Attributes$style, 'left', '-57px'),
								A2($elm$html$Html$Attributes$style, 'width', '97px'),
								A2($elm$html$Html$Attributes$style, 'min-width', '97px'),
								$elm$html$Html$Attributes$id('profile-menu')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Csf$Core$listview,
								_List_fromArray(
									[
										$author$project$Csf$Core$listview__bordered,
										$elm$html$Html$Attributes$class('csf-profile-item')
									]),
								$author$project$Csf$Core$list(
									_List_fromArray(
										[
											_Utils_Tuple2(
											A2(
												$author$project$Csf$Core$listview__item,
												_List_fromArray(
													[
														$author$project$Csf$Core$heading('Mi Perfil'),
														$author$project$Csf$Core$attr(
														$author$project$Csf$Core$href(conf.e7)),
														$author$project$Csf$Core$attr(
														$elm$html$Html$Events$onClick(0))
													]),
												_List_Nil),
											false),
											_Utils_Tuple2(
											A2(
												$author$project$Csf$Core$listview__item,
												_List_fromArray(
													[
														$author$project$Csf$Core$heading('Configuración'),
														$author$project$Csf$Core$attr(
														$author$project$Csf$Core$href(conf.d7)),
														$author$project$Csf$Core$attr(
														$elm$html$Html$Events$onClick(0))
													]),
												_List_Nil),
											false),
											_Utils_Tuple2(
											A2(
												$author$project$Csf$Core$listview__item,
												_List_fromArray(
													[
														$author$project$Csf$Core$heading('Usuarios'),
														$author$project$Csf$Core$attr(
														$author$project$Csf$Core$href(conf.fO)),
														$author$project$Csf$Core$attr(
														$elm$html$Html$Events$onClick(0))
													]),
												_List_Nil),
											false),
											_Utils_Tuple2(
											A2(
												$author$project$Csf$Core$listview__item,
												_List_fromArray(
													[
														$author$project$Csf$Core$heading('Cerrar Sesión'),
														$author$project$Csf$Core$attr(
														$author$project$Csf$Core$href(conf.eJ)),
														$author$project$Csf$Core$attr(
														$elm$html$Html$Events$onClick(0))
													]),
												_List_Nil),
											true)
										])))
							]))
					])));
	});
var $author$project$Csf$Header$secondaryLogo = F2(
	function (logo_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				ds: $elm$core$Maybe$Just(logo_)
			});
	});
var $author$project$Csf$Header$view = F2(
	function (model, _v0) {
		var conf = _v0;
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header__logo hidden-sm-down')
						]),
					_List_fromArray(
						[conf.c7])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header__logo hidden-sm-down')
						]),
					$author$project$Csf$Core$list(
						_List_fromArray(
							[
								_Utils_Tuple2(
								A2(
									$elm$core$Maybe$withDefault,
									A2($elm$html$Html$div, _List_Nil, _List_Nil),
									conf.ds),
								!_Utils_eq(conf.ds, $elm$core$Maybe$Nothing))
							]))),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('csf-top-nav')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(item, conf, model);
						},
						conf.eA))
				]));
	});
var $author$project$Main$headerView = function (model) {
	var tenantLogoMap_ = F2(
		function (height_, logo_) {
			return A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2($elm$html$Html$img, attrs_, _List_Nil);
					}(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(logo_),
								A2($elm$html$Html$Attributes$style, 'height', height_),
								$elm$html$Html$Attributes$class('float-left')
							]))
					]));
		});
	var session = $author$project$Main$pageSession(model.t);
	var tenantOrImporter_ = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Csf$Flags$tenantId(session.ka),
		A3(
			$elm$core$Basics$composeR,
			$author$project$Helpers$Utilities$stringToMaybe,
			$elm$core$Maybe$map($elm$core$String$toLower),
			A3(
				$author$project$Csf$TaskNodeUtils$datastring,
				'',
				'importador',
				$author$project$Csf$Flags$userNode(session.ka))));
	var tenantLogo_ = function (_v0) {
		var logo = _v0.c7;
		var height = _v0.cW;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				tenantLogoMap_(height),
				$author$project$Helpers$Utilities$stringToMaybe(logo)));
	}(
		A2($author$project$Helpers$Utilities$tenantInfo, model.cl, tenantOrImporter_));
	var mainLogo_ = A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Helpers$Utilities$assetImage,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('float-left')
					]),
				'chie_logo',
				session.ka)
			]));
	return A2(
		$author$project$Csf$Header$view,
		model.et,
		A2(
			$author$project$Csf$Header$logoutUrl,
			{
				go: $elm$core$Maybe$Nothing,
				iA: $author$project$Route$routeToString($author$project$Route$Logout),
				iI: $elm$core$Maybe$Nothing
			},
			A2(
				$author$project$Csf$Header$items,
				_List_fromArray(
					[
						$author$project$Csf$Header$profileItem(
						A2($author$project$Csf$Flags$asset, 'user_logo', session.ka))
					]),
				A2(
					$author$project$Csf$Header$secondaryLogo,
					tenantLogo_,
					A2(
						$author$project$Csf$Header$logo,
						mainLogo_,
						$author$project$Csf$Header$config($author$project$Main$HeaderMsg))))));
};
var $author$project$Csf$FilterSideBar$SideBarConfig = $elm$core$Basics$identity;
var $author$project$Csf$FilterSideBar$config = function (toMsg) {
	return {
		d8: A2($elm$html$Html$div, _List_Nil, _List_Nil),
		eb: _List_Nil,
		fJ: toMsg
	};
};
var $author$project$Csf$FilterSideBar$content = F2(
	function (content_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{d8: content_});
	});
var $author$project$Csf$FilterSideBar$dashlets = F2(
	function (dashlets_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{eb: dashlets_});
	});
var $author$project$Csf$FilterSideBar$MouseEnteredMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Csf$FilterSideBar$MouseLeaveMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Csf$FilterSideBar$SideBarMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Csf$FilterSideBar$actionIcon = function (state) {
	if (state === 2) {
		return A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('zmdi zmdi-chevron-left')
				]),
			_List_Nil);
	} else {
		return A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('zmdi zmdi-chevron-right')
				]),
			_List_Nil);
	}
};
var $author$project$Csf$FilterSideBar$invertState = function (state) {
	switch (state) {
		case 2:
			return 0;
		case 0:
			return 2;
		default:
			return state;
	}
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Csf$FilterSideBar$viewHeading = function (model) {
	var _v0 = model.w;
	if (!_v0) {
		return $author$project$Csf$FilterSideBar$collapsedItem('zmdi zmdi-filter-list');
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('listview__item listview--bordered'),
					A2($elm$html$Html$Attributes$style, 'padding', '10px 0px 10px 20px'),
					A2($elm$html$Html$Attributes$style, 'height', '40px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'baseline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listview__img'),
							A2($elm$html$Html$Attributes$style, 'margin', '0 5px 0 0'),
							A2($elm$html$Html$Attributes$style, 'height', 'auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('zmdi zmdi-filter-list zmdi-hc-lg')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listview__content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Filtrar por')
						]))
				]));
	}
};
var $author$project$Csf$FilterSideBar$view = F2(
	function (model, _v0) {
		var conf = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf-pushable position-relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('csf-collapsable sidebar-layout fh-mainarea bg-white position-absolute'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('uncover', (model.w === 2) || (model.w === 1))
								])),
							$elm$html$Html$Events$onMouseEnter(
							conf.fJ(
								$author$project$Csf$FilterSideBar$MouseEnteredMsg(0))),
							$elm$html$Html$Events$onMouseLeave(
							conf.fJ(
								$author$project$Csf$FilterSideBar$MouseLeaveMsg(0)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Csf$Core$listview,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('csf-sidebar--expanded-width listview--bordered', !(!model.w)),
											_Utils_Tuple2('csf-sidebar--collapsed-width', !model.w)
										]))
								]),
							A2(
								$elm$core$List$cons,
								$author$project$Csf$FilterSideBar$viewHeading(model),
								A2(
									$elm$core$List$map,
									function (d) {
										return d(model);
									},
									conf.eb)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fh-mainarea'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('csf-sidebar-pusher', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('csf-sidebar-separator fh-mainarea')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('position-absolute csf-sidebar-actionable'),
											A2($elm$html$Html$Attributes$style, 'top', '25px'),
											$elm$html$Html$Events$onMouseEnter(
											conf.fJ(
												$author$project$Csf$FilterSideBar$MouseEnteredMsg(1))),
											$elm$html$Html$Events$onMouseLeave(
											conf.fJ(
												$author$project$Csf$FilterSideBar$MouseLeaveMsg(1)))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-sm bg-white btn--icon btn-outline-border rounded-circle'),
													A2($elm$html$Html$Attributes$style, 'width', '30px'),
													A2($elm$html$Html$Attributes$style, 'height', '30px'),
													A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 0px 2px #00000029'),
													A2($elm$html$Html$Attributes$style, 'border', '0.8px solid #CCCCCC'),
													$elm$html$Html$Events$onClick(
													conf.fJ(
														$author$project$Csf$FilterSideBar$SideBarMsg(
															$author$project$Csf$FilterSideBar$invertState(model.w))))
												]),
											_List_fromArray(
												[
													$author$project$Csf$FilterSideBar$actionIcon(model.w)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('csf-sidebar-maincontent fh-mainarea')
								]),
							_List_fromArray(
								[conf.d8]))
						]))
				]));
	});
var $author$project$Main$mainContentView = F3(
	function (dashlets, contentView, model) {
		return $elm$core$List$isEmpty(dashlets) ? contentView : A2(
			$author$project$Csf$FilterSideBar$view,
			model.dv,
			A2(
				$author$project$Csf$FilterSideBar$content,
				contentView,
				A2(
					$author$project$Csf$FilterSideBar$dashlets,
					dashlets,
					$author$project$Csf$FilterSideBar$config($author$project$Main$SiderBarMsg))));
	});
var $author$project$Route$href = A2($elm$core$Basics$composeR, $author$project$Route$routeToString, $elm$html$Html$Attributes$href);
var $author$project$Customized$MenuBar$effectiveItems = F2(
	function (items, checkIcon) {
		var correctMargin = F2(
			function (itm, item_class_) {
				return itm.gC ? A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[item_class_, 'sub-header__icon'])) : item_class_;
			});
		var nav_link_class = function (itm) {
			return A3(
				$elm$core$Basics$composeR,
				correctMargin(itm),
				$elm$html$Html$Attributes$class,
				itm.hk ? 'nav-link text-white active' : 'nav-link text-white');
		};
		var filterMapItems = function (itm) {
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$eq(checkIcon),
				$elm$core$Basics$and(itm.iY),
				itm.gC) ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									nav_link_class(itm),
									itm.h4
								]),
							_List_fromArray(
								[itm.h]))
						]))) : $elm$core$Maybe$Nothing;
		};
		return A2($elm$core$List$filterMap, filterMapItems, items);
	});
var $author$project$Customized$MenuBar$view = F2(
	function (attributes, items) {
		var textMenu = A2($author$project$Customized$MenuBar$effectiveItems, items, false);
		var iconMenu = A2($author$project$Customized$MenuBar$effectiveItems, items, true);
		var _v0 = $elm$core$List$isEmpty(iconMenu) ? _Utils_Tuple2('col-sm-12', 'hidden') : _Utils_Tuple2('col-sm-10', 'col-sm-2');
		var classTextDiv = _v0.a;
		var classIconDiv = _v0.b;
		return A2(
			$elm$html$Html$div,
			attributes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(classTextDiv)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('nav nav-pills sub-header')
								]),
							textMenu)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(classIconDiv)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('nav nav-pills sub-header')
								]),
							iconMenu)
						]))
				]));
	});
var $author$project$Main$menuBarView = function (model) {
	var page = model.t;
	var showMenu_ = function (role_keys) {
		return function (user_) {
			return A2($author$project$Helpers$ApiHandler$hasUserAccess, user_, role_keys);
		}(
			$author$project$Csf$Flags$userNode(
				A2(
					$elm$core$Basics$composeR,
					$author$project$Main$pageSession,
					function ($) {
						return $.ka;
					})(page)));
	};
	var session = $author$project$Main$pageSession(page);
	var isActive = function (currentPage) {
		return _Utils_eq(
			currentPage,
			function () {
				var _v0 = model.t;
				switch (_v0.$) {
					case 5:
						return 'check_stock';
					case 9:
						return 'check_stock';
					case 12:
						return 'check_stock';
					case 7:
						return 'app_dashboard';
					case 11:
						return 'chie_files';
					case 10:
						return 'chie_files';
					case 6:
						var taskName = _v0.a.jd;
						switch (taskName) {
							case 'chie_aprobar_emision':
								return 'pending_tasks';
							case 'chie_firmar_certificado':
								return 'signing_tasks';
							case 'chie_firmar_certificado_extension':
								return 'signing_tasks';
							default:
								return '';
						}
					default:
						return '';
				}
			}());
	};
	var iconItem = function (icon_) {
		return function (icon_attr) {
			return A2($elm$html$Html$i, icon_attr, _List_Nil);
		}(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('zmdi ' + icon_),
					A2($elm$html$Html$Attributes$style, 'font-size', '1.3rem')
				]));
	};
	var dashboard_on = 'on' === A2($author$project$Csf$Flags$asset, 'dashboard', session.ka);
	var attributes = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'height', '25px'),
			A2($elm$html$Html$Attributes$style, 'margin-top', '50px'),
			$elm$html$Html$Attributes$class('bg-blue position-absolute sub-header'),
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
		]);
	return A2(
		$author$project$Customized$MenuBar$view,
		attributes,
		_List_fromArray(
			[
				{
				hk: isActive('app_dashboard'),
				h: A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Helpers$Utilities$appMessage('app_dashboard'))
						])),
				h4: $author$project$Route$href($author$project$Route$DashboardChie),
				gC: false,
				iY: dashboard_on && showMenu_(
					_List_fromArray(
						['MANAGER']))
			},
				{
				hk: isActive('check_stock'),
				h: A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Helpers$Utilities$appMessage('check_stock'))
						])),
				h4: $author$project$Route$href(
					$author$project$Route$ConsultarStock($author$project$Route$emptyData)),
				gC: false,
				iY: showMenu_(
					_List_fromArray(
						['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']))
			},
				{
				hk: isActive('chie_files'),
				h: A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Helpers$Utilities$appMessage('chie_files'))
						])),
				h4: $author$project$Route$href(
					$author$project$Route$SolicitudesChie($author$project$Route$emptyData)),
				gC: false,
				iY: showMenu_(
					_List_fromArray(
						['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE', 'APPROVER', 'NULLIFIER', 'APPLICANT']))
			},
				{
				hk: isActive('pending_tasks'),
				h: A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Helpers$Utilities$appMessage('pending_tasks'))
						])),
				h4: $author$project$Route$href(
					$author$project$Route$PendientesAprobacion($author$project$Route$emptyData)),
				gC: false,
				iY: showMenu_(
					_List_fromArray(
						['SUPPORT', 'APPROVER']))
			},
				{
				hk: isActive('signing_tasks'),
				h: A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Helpers$Utilities$appMessage('signing_tasks'))
						])),
				h4: $author$project$Route$href(
					$author$project$Route$PendientesDeFirma($author$project$Route$emptyData)),
				gC: false,
				iY: showMenu_(
					_List_fromArray(
						['SUPPORT', 'LEGAL_REPRESENTATIVE']))
			}
			]));
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Csf$Layout31$view = function (_v0) {
	var conf = _v0;
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-layout')
					]),
				_List_fromArray(
					[conf.et])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fh-mainarea'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('container-debug', conf.ed)
									]))
							]),
						_List_fromArray(
							[conf.d8]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('footer-layout'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('container-debug', conf.ed)
							]))
					]),
				_List_fromArray(
					[conf.el]))
			]));
};
var $author$project$Main$layoutView = F3(
	function (contentDashlets, contentView, model) {
		return $author$project$Csf$Layout31$view(
			A2(
				$author$project$Csf$Layout31$footer,
				$author$project$Main$footerView(model),
				A2(
					$author$project$Csf$Layout31$content,
					A3($author$project$Main$mainContentView, contentDashlets, contentView, model),
					A2(
						$author$project$Csf$Layout31$header,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Main$headerView(model),
									$author$project$Main$menuBarView(model)
								])),
						$author$project$Csf$Layout31$config))));
	});
var $author$project$Main$pageTitle = function (title_) {
	return $author$project$Helpers$Utilities$trimmedEmpty(title_) ? $author$project$Helpers$Utilities$appMessage('app_title') : A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append(' :: '),
		$elm$core$Basics$append(title_),
		$author$project$Helpers$Utilities$appMessage('app_title'));
};
var $author$project$Page$CargarStock$pageTitle = $author$project$Page$CargarStock$moduleMessage('load_stock');
var $author$project$Page$ConsultarStock$pageTitle = $author$project$Page$ConsultarStock$moduleMessage('check_stock');
var $author$project$Page$DashboardChie$pageTitle = $author$project$Helpers$Utilities$appMessage('app_dashboard');
var $author$project$Page$HistorialDeCargas$pageTitle = $author$project$Page$HistorialDeCargas$moduleMessage('logging_loads');
var $author$project$Page$Maintenance$pageTitle = $author$project$Helpers$Utilities$appMessage('maintenance_title');
var $author$project$Page$NotFound$pageTitle = $author$project$Helpers$Utilities$appMessage('notfound_title');
var $author$project$Page$RepositorioChie$pageTitle = $author$project$Helpers$Utilities$appMessage('app_repository');
var $author$project$Page$SolicitarChie$pageTitle = $author$project$Page$SolicitarChie$moduleMessage('request_chie');
var $author$project$Page$SolicitudesChie$pageTitle = $author$project$Page$SolicitudesChie$moduleMessage('chie_files');
var $author$project$Page$SolicitudesPendientes$pageTitle = $author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('pending_tasks');
var $elm_community$typed_svg$TypedSvg$Types$PaintNone = {$: 5};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$circle = $elm_community$typed_svg$TypedSvg$Core$node('circle');
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString = function (length) {
	switch (length.$) {
		case 0:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'cm';
		case 1:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'em';
		case 2:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'ex';
		case 3:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'in';
		case 4:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'mm';
		case 5:
			var x = length.a;
			return $elm$core$String$fromFloat(x);
		case 6:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pc';
		case 7:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + '%';
		case 8:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pt';
		case 9:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'px';
		default:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'rem';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$cx = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cx',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$cy = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'cy',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString = function (paint) {
	switch (paint.$) {
		case 0:
			var color = paint.a;
			return $avh4$elm_color$Color$toCssString(color);
		case 1:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['var(' + (string + ')')]));
		case 2:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['url(#', string, ')']));
		case 3:
			return 'context-fill';
		case 4:
			return 'context-stroke';
		default:
			return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $author$project$Csf$Form$getShow = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'show', params);
	if ((!_v0.$) && (_v0.a.$ === 21)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$FieldAttrs = function (a) {
	return {$: 6, a: a};
};
var $author$project$Csf$Form$processConfigAttribute = A2(
	$elm$core$List$foldl,
	F2(
		function (item, _v0) {
			var attrs_ = _v0.a;
			var dict = _v0.b;
			switch (item.$) {
				case 26:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'width', item, dict));
				case 27:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'placeholder', item, dict));
				case 28:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'disabled', item, dict));
				case 30:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'multiple', item, dict));
				case 31:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'ajax', item, dict));
				case 32:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'delay', item, dict));
				case 33:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'noresultmsg', item, dict));
				case 34:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'closeonclear', item, dict));
				case 29:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'showsearch', item, dict));
				case 0:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'active', item, dict));
				case 1:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'changeevent', item, dict));
				case 2:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'checked', item, dict));
				case 3:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'checkevent', item, dict));
				case 4:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'description', item, dict));
				case 5:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'elemtype', item, dict));
				case 6:
					var v = item.a;
					var vals = function () {
						var _v2 = A2($elm$core$Dict$get, 'fieldattrs', dict);
						if ((!_v2.$) && (_v2.a.$ === 6)) {
							var v_ = _v2.a.a;
							return v_;
						} else {
							return _List_Nil;
						}
					}();
					var vals1 = _Utils_ap(v, vals);
					return _Utils_Tuple2(
						attrs_,
						A3(
							$elm$core$Dict$insert,
							'fieldattrs',
							$author$project$Csf$Form$FieldAttrs(vals1),
							dict));
				case 7:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'focused', item, dict));
				case 10:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'icon', item, dict));
				case 11:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'id', item, dict));
				case 12:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'inputmodel', item, dict));
				case 8:
					var attr_ = item.a;
					return _Utils_Tuple2(
						A2($elm$core$List$cons, attr_, attrs_),
						dict);
				case 9:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'heading', item, dict));
				case 13:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'label', item, dict));
				case 14:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'loading', item, dict));
				case 15:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'rutformatter', item, dict));
				case 16:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'rutmodel', item, dict));
				case 17:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'selectevent', item, dict));
				case 19:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'selectmodel', item, dict));
				case 20:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'selectviewmodel', item, dict));
				case 18:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'selecttomsg', item, dict));
				case 21:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'show', item, dict));
				case 22:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'toggled', item, dict));
				case 23:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'toggleEvent', item, dict));
				case 24:
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'transitioning', item, dict));
				default:
					var v = item.a;
					return _Utils_Tuple2(
						attrs_,
						A3($elm$core$Dict$insert, 'value', item, dict));
			}
		}),
	_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty));
var $elm_community$typed_svg$TypedSvg$Types$Px = function (a) {
	return {$: 9, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$px = $elm_community$typed_svg$TypedSvg$Types$Px;
var $elm_community$typed_svg$TypedSvg$Attributes$r = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'r',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $author$project$Csf$Form$loader = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var isShow = A2(
			$elm$core$Maybe$withDefault,
			false,
			$author$project$Csf$Form$getShow(params));
		var showAttr = isShow ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex')
			]) : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'none')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-loader position-absolute')
					]),
				_Utils_ap(showAttr, attrs_)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-loader__spinner')
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$svg,
							_List_fromArray(
								[
									A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 25, 25, 50, 50)
								]),
							_List_fromArray(
								[
									A2(
									$elm_community$typed_svg$TypedSvg$circle,
									_List_fromArray(
										[
											$elm_community$typed_svg$TypedSvg$Attributes$cx(
											$elm_community$typed_svg$TypedSvg$Types$px(50)),
											$elm_community$typed_svg$TypedSvg$Attributes$cy(
											$elm_community$typed_svg$TypedSvg$Types$px(50)),
											$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone),
											$elm_community$typed_svg$TypedSvg$Attributes$r(
											$elm_community$typed_svg$TypedSvg$Types$px(20)),
											A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10'),
											A2($elm$html$Html$Attributes$attribute, 'stroke-width', '2')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Csf$Form$Loading = function (a) {
	return {$: 14, a: a};
};
var $author$project$Csf$Form$loading = $author$project$Csf$Form$Loading;
var $author$project$Csf$Form$Show = function (a) {
	return {$: 21, a: a};
};
var $author$project$Csf$Form$show = $author$project$Csf$Form$Show;
var $author$project$Helpers$Utilities$processLoader = function (loading_) {
	return A2(
		$author$project$Csf$Form$loader,
		_List_fromArray(
			[
				$author$project$Csf$Form$show(loading_),
				$author$project$Csf$Form$loading(loading_)
			]),
		_List_Nil);
};
var $author$project$Page$CargarStock$CancelRegistration = {$: 3};
var $author$project$Page$CargarStock$GoBackToStock = {$: 1};
var $author$project$Page$CargarStock$ProcessRegistraton = {$: 4};
var $author$project$Csf$Form$HtmlAttr = function (a) {
	return {$: 8, a: a};
};
var $author$project$Csf$Form$attr = $author$project$Csf$Form$HtmlAttr;
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Csf$Form$btn = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var loading_ = function () {
			var _v1 = A2($elm$core$Dict$get, 'loading', params);
			if ((!_v1.$) && (_v1.a.$ === 14)) {
				var v = _v1.a.a;
				return v;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$button,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-primary')
						]),
						attrs_,
						loading_ ? _List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]) : _List_Nil
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-spinner zmdi-hc-fw zmdi-hc-spin'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !loading_)
								]))
						]),
					_List_Nil),
				children));
	});
var $author$project$Csf$FileUploader$UploaderConfig = $elm$core$Basics$identity;
var $author$project$Csf$FileUploader$bttnLabel = F2(
	function (btn_label, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				cy: $elm$core$String$toUpper(btn_label)
			});
	});
var $author$project$Csf$FileUploader$bttnLoading = F2(
	function (loading_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{cz: loading_});
	});
var $author$project$Csf$Form$getHeading = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'heading', params);
	if ((!_v0.$) && (_v0.a.$ === 9)) {
		var v = _v0.a.a;
		return v;
	} else {
		return '';
	}
};
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Csf$Form$card = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var heading_ = $author$project$Csf$Form$getHeading(params);
		var headerHtml = (heading_ !== '') ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(heading_)
							]))
					]))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('card'),
				attrs_),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-body')
						]),
					_Utils_ap(headerHtml, children))
				]));
	});
var $author$project$Csf$Form$class_ = A2($elm$core$Basics$composeL, $author$project$Csf$Form$HtmlAttr, $elm$html$Html$Attributes$class);
var $author$project$Csf$Form$div_ = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		return A2($elm$html$Html$div, attrs_, children);
	});
var $author$project$Csf$Form$getElemType = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'elemtype', params);
	if ((!_v0.$) && (_v0.a.$ === 5)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$getId = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'id', params);
	if ((!_v0.$) && (_v0.a.$ === 11)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$conditional = F2(
	function (attrs, children) {
		var children_ = A2(
			$elm$core$List$map,
			function (_v3) {
				var render = _v3.iL;
				var elem_ = _v3.hK;
				return A2(render, elem_.D, elem_.J);
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.iZ;
				},
				A2(
					$elm$core$List$map,
					function (_v1) {
						var elem_ = _v1;
						var _v2 = $author$project$Csf$Form$processConfigAttribute(elem_.D);
						var params1 = _v2.b;
						var render = $author$project$Csf$Form$getElemType(params1);
						var show_ = A2(
							$elm$core$Maybe$withDefault,
							true,
							$author$project$Csf$Form$getShow(params1));
						return {
							hK: elem_,
							iL: A2($elm$core$Maybe$withDefault, $author$project$Csf$Form$div_, render),
							iZ: show_ && (!_Utils_eq(render, $elm$core$Maybe$Nothing))
						};
					},
					children)));
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var condId = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $elm$html$Html$Attributes$id, $elm$core$List$singleton),
				$author$project$Csf$Form$getId(params)));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(condId, attrs_),
			children_);
	});
var $author$project$Csf$FileUploader$config = function (toMsg_) {
	var btn_label = 'CARGAR FICHERO';
	return {cy: btn_label, cz: false, ev: _List_Nil, ew: '', e$: _List_Nil, e6: 'Realice una carga de ficheros', fr: 'Arraste el fichero o use el botón ' + ('\"' + (btn_label + '\".')), fJ: toMsg_};
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Csf$Core$content = F2(
	function (attrs_, children) {
		return A2(
			$elm$html$Html$section,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('content--boxed'),
				attrs_),
			children);
	});
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Csf$Form$Elem = $elm$core$Basics$identity;
var $author$project$Csf$Form$elem = F2(
	function (attrs, children) {
		return {D: attrs, J: children};
	});
var $author$project$Csf$Form$ElemType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Csf$Form$elemtype = $author$project$Csf$Form$ElemType;
var $author$project$Csf$FileUploader$imageSource = F2(
	function (source, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{ew: source});
	});
var $author$project$Helpers$Utilities$imagesPath = $elm$core$Basics$append('/emision/static/images');
var $author$project$Csf$Form$onClick_ = A2($elm$core$Basics$composeL, $author$project$Csf$Form$HtmlAttr, $elm$html$Html$Events$onClick);
var $author$project$Csf$FileUploader$primaryText = F2(
	function (text_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{e6: text_});
	});
var $rundis$elm_bootstrap$Bootstrap$Progress$Animated = function (a) {
	return {$: 5, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Progress$animated = $rundis$elm_bootstrap$Bootstrap$Progress$Animated(true);
var $rundis$elm_bootstrap$Bootstrap$Progress$Attrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Progress$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Progress$Attrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Progress$Options = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Progress$applyOption = F2(
	function (modifier, _v0) {
		var options = _v0;
		switch (modifier.$) {
			case 0:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{lt: value_});
			case 1:
				var height_ = modifier.a;
				return _Utils_update(
					options,
					{cW: height_});
			case 2:
				var label_ = modifier.a;
				return _Utils_update(
					options,
					{c3: label_});
			case 3:
				var role_ = modifier.a;
				return _Utils_update(
					options,
					{a3: role_});
			case 4:
				var striped_ = modifier.a;
				return _Utils_update(
					options,
					{g2: striped_});
			case 5:
				var animated_ = modifier.a;
				return _Utils_update(
					options,
					{dY: animated_});
			case 6:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{I: attrs_});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{hi: attrs_});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Progress$defaultOptions = {dY: false, I: _List_Nil, cW: $elm$core$Maybe$Nothing, c3: _List_Nil, a3: $elm$core$Maybe$Nothing, g2: false, lt: 0, hi: _List_Nil};
var $rundis$elm_bootstrap$Bootstrap$Progress$roleClass = function (role) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (role) {
				case 0:
					return 'bg-success';
				case 1:
					return 'bg-info';
				case 2:
					return 'bg-warning';
				default:
					return 'bg-danger';
			}
		}());
};
var $rundis$elm_bootstrap$Bootstrap$Progress$toAttributes = function (_v0) {
	var options = _v0;
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-value-now',
					$elm$core$String$fromFloat(options.lt)),
					A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
					A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100'),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(options.lt) + '%'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('progress-bar', true),
							_Utils_Tuple2('progress-bar-striped', options.g2 || options.dY),
							_Utils_Tuple2('progress-bar-animated', options.dY)
						]))
				]),
				function () {
				var _v1 = options.cW;
				if (!_v1.$) {
					var height_ = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$style,
							'height',
							$elm$core$String$fromInt(height_) + 'px')
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.a3;
				if (!_v2.$) {
					var role_ = _v2.a;
					return _List_fromArray(
						[
							$rundis$elm_bootstrap$Bootstrap$Progress$roleClass(role_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				options.I
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Progress$renderBar = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Progress$applyOption, $rundis$elm_bootstrap$Bootstrap$Progress$defaultOptions, modifiers);
	var opts = options;
	return A2(
		$elm$html$Html$div,
		$rundis$elm_bootstrap$Bootstrap$Progress$toAttributes(options),
		opts.c3);
};
var $rundis$elm_bootstrap$Bootstrap$Progress$progress = function (modifiers) {
	var _v0 = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Progress$applyOption, $rundis$elm_bootstrap$Bootstrap$Progress$defaultOptions, modifiers);
	var options = _v0;
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('progress'),
			options.hi),
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Progress$renderBar(modifiers)
			]));
};
var $rundis$elm_bootstrap$Bootstrap$Progress$Value = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Progress$value = function (val) {
	return $rundis$elm_bootstrap$Bootstrap$Progress$Value(val);
};
var $author$project$Page$CargarStock$progressBarTiny = function (value_) {
	var div_attrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('tiny_progress__ text-center')
		]);
	var background_ = (100 !== value_) ? A2($elm$html$Html$Attributes$style, 'background-color', '#02A6CE') : A2($elm$html$Html$Attributes$style, 'background-color', '#28a745');
	var attributes = _List_fromArray(
		[background_]);
	var progress_attr = _List_fromArray(
		[
			$rundis$elm_bootstrap$Bootstrap$Progress$value(value_),
			$rundis$elm_bootstrap$Bootstrap$Progress$animated,
			$rundis$elm_bootstrap$Bootstrap$Progress$attrs(attributes)
		]);
	return A2(
		$elm$html$Html$div,
		div_attrs,
		_List_fromArray(
			[
				$rundis$elm_bootstrap$Bootstrap$Progress$progress(progress_attr)
			]));
};
var $author$project$Csf$FileUploader$secondaryText = F2(
	function (text_, _v0) {
		var conf = _v0;
		return function (sText) {
			return _Utils_update(
				conf,
				{fr: sText});
		}(
			$elm$core$String$trim(text_) + (' \"' + (conf.cy + '\".')));
	});
var $author$project$Csf$Form$style_ = F2(
	function (rule, val) {
		return $author$project$Csf$Form$HtmlAttr(
			A2($elm$html$Html$Attributes$style, rule, val));
	});
var $billstclair$elm_sortable_table$Table$HtmlDetails = F2(
	function (attributes, children) {
		return {I: attributes, J: children};
	});
var $billstclair$elm_sortable_table$Table$Column = $elm$core$Basics$identity;
var $billstclair$elm_sortable_table$Table$veryCustomColumn = $elm$core$Basics$identity;
var $author$project$Csf$Table$customColumn = function (def) {
	return $billstclair$elm_sortable_table$Table$veryCustomColumn(
		{
			dc: def.dc,
			bD: def.bD,
			dI: function (data) {
				return A2(
					$billstclair$elm_sortable_table$Table$HtmlDetails,
					$author$project$Csf$Core$list(
						_List_fromArray(
							[
								_Utils_Tuple2(
								A2(
									$elm$html$Html$Attributes$style,
									'width',
									A2($elm$core$Maybe$withDefault, '0px', def.lz)),
								!_Utils_eq($elm$core$Maybe$Nothing, def.lz))
							])),
					_List_fromArray(
						[
							A3(
							$elm$core$Basics$composeL,
							def.V,
							function ($) {
								return $.r;
							},
							data)
						]));
			}
		});
};
var $author$project$Csf$TaskNodeUtils$mbint = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TaskNode$int(key),
		function ($) {
			return $.dm;
		});
};
var $author$project$Helpers$Utilities$showValidYear = function (year_) {
	return (1900 > year_) ? '' : $elm$core$String$fromInt(year_);
};
var $author$project$Page$CargarStock$justtext = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return $elm$html$Html$text(
			function () {
				if (key_ === 'ano') {
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Helpers$Utilities$showValidYear,
							A2($author$project$Csf$TaskNodeUtils$mbint, key_, taskNode_)));
				} else {
					return A3($author$project$Csf$TaskNodeUtils$string, default_, key_, taskNode_);
				}
			}());
	});
var $author$project$Page$CargarStock$linkable = F2(
	function (key_, taskNode_) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table_linkable')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Csf$TaskNodeUtils$string, '', key_, taskNode_))
				]));
	});
var $billstclair$elm_sortable_table$Table$None = {$: 0};
var $billstclair$elm_sortable_table$Table$unsortable = $billstclair$elm_sortable_table$Table$None;
var $author$project$Csf$Table$CustomEventMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$CargarStock$validationIcon = F2(
	function (model, taskNode_) {
		var validatedVehicles = model.aI;
		var showError = model.aH;
		var mapValidVehicles = function (vh_) {
			return _Utils_Tuple2(vh_.ld, vh_.hQ);
		};
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(false, _List_Nil),
			A3(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				$elm$core$Maybe$map(mapValidVehicles),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dH;
						},
						$elm$core$Basics$eq(taskNode_.p)),
					validatedVehicles)));
		var succeed_ = _v0.a;
		var errors_ = _v0.b;
		var image_icon = function (attrs_) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$img, attrs_, _List_Nil)
					]));
		}(
			succeed_ ? _List_fromArray(
				[
					$elm$html$Html$Attributes$src(
					$author$project$Helpers$Utilities$imagesPath('/ic_check_circle_24px.svg'))
				]) : _List_fromArray(
				[
					$elm$html$Html$Attributes$id(taskNode_.p),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					$elm$html$Html$Attributes$src(
					$author$project$Helpers$Utilities$imagesPath('/ic_error_24px.svg')),
					$elm$html$Html$Events$onClick(
					A2($author$project$Csf$Table$CustomEventMsg, 'toggle_error_tooltip', taskNode_))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('position-relative vh_error__tooltip_container')
				]),
			function () {
				var _v1 = _Utils_Tuple2(
					succeed_,
					$elm$core$List$isEmpty(errors_));
				if (!_v1.a) {
					if (_v1.b) {
						return _List_fromArray(
							[
								$elm$html$Html$text('')
							]);
					} else {
						return A3(
							$elm$core$Basics$composeR,
							$elm$core$Dict$get(taskNode_.p),
							$elm$core$Maybe$withDefault(false),
							showError) ? _List_fromArray(
							[
								image_icon,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('position-absolute vh_error__tooltip mb-0'),
										A2($elm$html$Html$Attributes$style, 'left', '135%')
									]),
								A2(
									$elm$core$List$map,
									function (error_) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row m-0 p-1')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$CargarStock$moduleMessage(error_))
												]));
									},
									errors_))
							]) : _List_fromArray(
							[image_icon]);
					}
				} else {
					return _List_fromArray(
						[image_icon]);
				}
			}());
	});
var $author$project$Page$CargarStock$tableConfig = function (model) {
	var strFromDict = function (key_) {
		return A2($author$project$Csf$TaskNodeUtils$string, '', key_);
	};
	return {
		f8: _List_fromArray(
			[
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$validationIcon(model),
					dc: '',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$linkable('vin'),
					dc: 'Vin',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Just('15%')
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('tipo', '')),
					dc: 'Tipo',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('marca', '')),
					dc: 'Marca',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('modelo', '')),
					dc: 'Modelo',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('ano', '')),
					dc: 'Año',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('color', '')),
					dc: 'Color',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('motor', '')),
					dc: 'N° Motor',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$CargarStock$justtext(
						_Utils_Tuple2('cit', '')),
					dc: 'C.I.T',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Nothing
				})
			]),
		hC: $elm$core$Maybe$Nothing,
		hD: $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stock_vh-table'),
					A2($elm$html$Html$Attributes$style, 'font-size', '14px')
				])),
		hb: function ($) {
			return $.p;
		}
	};
};
var $author$project$Csf$Notifications$genericToast = F4(
	function (variantClass, iconClass, title, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('notification')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row alert alert-dismissible alert-inverse alert--notify animated fadeInRight alert'),
							$elm$html$Html$Attributes$class(variantClass),
							A2($elm$html$Html$Attributes$attribute, 'style', 'align-items: center; width: 100%;')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row pr-0 mr-0'),
									A2($elm$html$Html$Attributes$attribute, 'style', 'align-items: center; width: 100%;')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-1 pr-0 m-0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(iconClass)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-10 pl-0 pr-0 m-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
									$elm$html$Html$Attributes$class('alert--notify__close'),
									A2($elm$html$Html$Attributes$attribute, 'data-notify', 'dismiss'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('zmdi zmdi-close')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Csf$Notifications$toastView = function (t) {
	switch (t.$) {
		case 0:
			var title = t.a;
			var message = t.b;
			return (title === 'Success') ? A4($author$project$Csf$Notifications$genericToast, 'alert alert-success alert-dismissible', 'zmdi zmdi-check', title, message) : A4($author$project$Csf$Notifications$genericToast, 'alert alert-info alert-dismissible', 'zmdi zmdi-check', title, message);
		case 1:
			var title = t.a;
			var message = t.b;
			return A4($author$project$Csf$Notifications$genericToast, 'alert alert-warning alert-dismissible', 'zmdi zmdi-alert-triangle', title, message);
		default:
			var title = t.a;
			var message = t.b;
			return A4($author$project$Csf$Notifications$genericToast, 'alert alert-danger alert-dismissible', 'zmdi zmdi-alert-triangle', title, message);
	}
};
var $pablen$toasty$Toasty$itemContainer = F4(
	function (_v0, tagger, _v1, toastView) {
		var cfg = _v0;
		var id = _v1.a;
		var status = _v1.b;
		var toast = _v1.c;
		var attrs = function () {
			if (!status) {
				return cfg.hc;
			} else {
				return cfg.hd;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$String$fromInt(id),
			A2(
				$elm$html$Html$li,
				_Utils_ap(
					cfg.gD,
					_Utils_ap(
						attrs,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								tagger(
									$pablen$toasty$Toasty$TransitionOut(id)))
							]))),
				_List_fromArray(
					[
						toastView(toast)
					])));
	});
var $elm$html$Html$Keyed$ol = $elm$html$Html$Keyed$node('ol');
var $pablen$toasty$Toasty$view = F4(
	function (cfg, toastView, tagger, _v0) {
		var toasts = _v0.a;
		var seed = _v0.b;
		var _v1 = cfg;
		var c = _v1;
		return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$Keyed$ol,
			c.f9,
			A2(
				$elm$core$List$map,
				function (toast) {
					return A4($pablen$toasty$Toasty$itemContainer, cfg, tagger, toast, toastView);
				},
				toasts));
	});
var $author$project$Csf$Notifications$toast = function (_v0) {
	var toasties = _v0.a7;
	return A4($pablen$toasty$Toasty$view, $author$project$Csf$Notifications$toastConfig, $author$project$Csf$Notifications$toastView, $author$project$Csf$Notifications$ToastyMsg, toasties);
};
var $author$project$Csf$FileUploader$DoFileSelect = {$: 2};
var $author$project$Csf$FileUploader$DragFileIn = {$: 0};
var $author$project$Csf$FileUploader$DragFileOut = {$: 1};
var $author$project$Csf$Core$btn = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Core$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var loading_ = function () {
			var _v1 = A2($elm$core$Dict$get, 'loading', params);
			if ((!_v1.$) && (_v1.a.$ === 4)) {
				var v = _v1.a.a;
				return v;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$button,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$class('btn btn-primary ml-2')
						]),
						attrs_,
						loading_ ? _List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]) : _List_Nil
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-spinner zmdi-hc-fw zmdi-hc-spin'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !loading_)
								]))
						]),
					_List_Nil),
				children));
	});
var $author$project$Csf$Core$cssclass = function (class_) {
	return $author$project$Csf$Core$HtmlAttr(
		$elm$html$Html$Attributes$class(class_));
};
var $elm$file$File$decoder = _File_decoder;
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Csf$FileUploader$dropFileDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$Csf$FileUploader$OnFileUploaded, $elm$file$File$decoder));
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Csf$FileUploader$hiJackOn = F2(
	function (event, evtDecoder) {
		var hiJack = function (mssg) {
			return _Utils_Tuple2(mssg, true);
		};
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, hiJack, evtDecoder));
	});
var $author$project$Csf$Core$Loading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Csf$Core$loading = $author$project$Csf$Core$Loading;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Csf$FileUploader$view = F2(
	function (model, _v0) {
		var conf = _v0;
		var div_attributes = function (attributes) {
			return A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(conf.fJ),
				attributes);
		}(
			conf.cz ? _List_fromArray(
				[
					$elm$html$Html$Attributes$class('fupld__container fupld__opaque')
				]) : _List_fromArray(
				[
					$elm$html$Html$Attributes$class('fupld__container'),
					A2(
					$author$project$Csf$FileUploader$hiJackOn,
					'dragover',
					$elm$json$Json$Decode$succeed($author$project$Csf$FileUploader$DragFileIn)),
					A2(
					$author$project$Csf$FileUploader$hiJackOn,
					'dragenter',
					$elm$json$Json$Decode$succeed($author$project$Csf$FileUploader$DragFileIn)),
					A2(
					$author$project$Csf$FileUploader$hiJackOn,
					'dragleave',
					$elm$json$Json$Decode$succeed($author$project$Csf$FileUploader$DragFileOut)),
					A2($author$project$Csf$FileUploader$hiJackOn, 'drop', $author$project$Csf$FileUploader$dropFileDecoder)
				]));
		return A2(
			$elm$html$Html$div,
			div_attributes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-12 fupld_img__container')
							]),
						conf.ev),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('position-relative')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(conf.ew),
											A2($elm$html$Html$Attributes$style, 'height', '110px')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('zmdi zmdi-plus position-absolute')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-12 fupld_text__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Medium'),
									A2($elm$html$Html$Attributes$style, 'font-size', '20px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(conf.e6)
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
									A2($elm$html$Html$Attributes$style, 'font-size', '14px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(conf.fr)
								])),
							function (h4_attrs_) {
							return A2($elm$html$Html$h4, h4_attrs_, conf.e$);
						}(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('position-relative'),
									A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
									A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
									A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
								]))
						])),
					A2(
					$elm$html$Html$map,
					conf.fJ,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-12 fupld_btn__container')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Csf$Core$btn,
								_List_fromArray(
									[
										$author$project$Csf$Core$cssclass('btn-sm'),
										$author$project$Csf$Core$onClickEvent($author$project$Csf$FileUploader$DoFileSelect),
										$author$project$Csf$Core$loading(conf.cz)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(conf.cy)
									]))
							])))
				]));
	});
var $author$project$Csf$Table$TableMsg = function (a) {
	return {$: 2, a: a};
};
var $billstclair$elm_sortable_table$Table$Config = $elm$core$Basics$identity;
var $billstclair$elm_sortable_table$Table$customConfig = function (_v0) {
	var toId = _v0.hb;
	var toMsg = _v0.fJ;
	var columns = _v0.f8;
	var customizations = _v0.jS;
	return {
		f8: A2(
			$elm$core$List$map,
			function (_v1) {
				var cData = _v1;
				return cData;
			},
			columns),
		jS: customizations,
		hb: toId,
		fJ: toMsg
	};
};
var $billstclair$elm_sortable_table$Table$simpleRowAttrs = function (_v0) {
	return _List_Nil;
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$String$fromList = _String_fromList;
var $billstclair$elm_sortable_table$Table$nbsp = $elm$core$String$fromList(
	_List_fromArray(
		[
			$elm$core$Char$fromCode(160)
		]));
var $billstclair$elm_sortable_table$Table$darkGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#555')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap($billstclair$elm_sortable_table$Table$nbsp, symbol))
			]));
};
var $billstclair$elm_sortable_table$Table$lightGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#ccc')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap($billstclair$elm_sortable_table$Table$nbsp, symbol))
			]));
};
var $billstclair$elm_sortable_table$Table$simpleTheadHelp = function (_v0) {
	var name = _v0.a;
	var status = _v0.b;
	var click = _v0.c;
	var content = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$text(name)
					]);
			case 1:
				var selected = status.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(name),
						selected ? $billstclair$elm_sortable_table$Table$darkGrey('↓') : $billstclair$elm_sortable_table$Table$lightGrey('↓')
					]);
			default:
				if (status.a.$ === 1) {
					var _v2 = status.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$billstclair$elm_sortable_table$Table$lightGrey('↕')
						]);
				} else {
					var isReversed = status.a.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$billstclair$elm_sortable_table$Table$darkGrey(
							isReversed ? '↑' : '↓')
						]);
				}
		}
	}();
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[click]),
		content);
};
var $billstclair$elm_sortable_table$Table$simpleThead = function (headers) {
	return A2(
		$billstclair$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		A2($elm$core$List$map, $billstclair$elm_sortable_table$Table$simpleTheadHelp, headers));
};
var $billstclair$elm_sortable_table$Table$defaultCustomizations = {f4: $elm$core$Maybe$Nothing, k2: $billstclair$elm_sortable_table$Table$simpleRowAttrs, le: _List_Nil, g6: _List_Nil, lk: $elm$core$Maybe$Nothing, ll: $billstclair$elm_sortable_table$Table$simpleThead};
var $author$project$Csf$Table$rowAttrs = function (data) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('selected', data.dt)
				]))
		]);
};
var $author$project$Csf$Table$nbsp = $elm$core$String$fromList(
	_List_fromArray(
		[
			$elm$core$Char$fromCode(160)
		]));
var $author$project$Csf$Table$darkGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#555')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap($author$project$Csf$Table$nbsp, symbol))
			]));
};
var $author$project$Csf$Table$lightGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#ccc')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap($author$project$Csf$Table$nbsp, symbol))
			]));
};
var $author$project$Csf$Table$simpleTheadHelp = function (_v0) {
	var name = _v0.a;
	var status = _v0.b;
	var click = _v0.c;
	var content = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$text(name)
					]);
			case 1:
				var selected = status.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(name),
								selected ? $author$project$Csf$Table$darkGrey('↓') : $author$project$Csf$Table$lightGrey('↓')
							]))
					]);
			default:
				if (status.a.$ === 1) {
					var _v2 = status.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name),
									$author$project$Csf$Table$lightGrey('↕')
								]))
						]);
				} else {
					var isReversed = status.a.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name),
									$author$project$Csf$Table$darkGrey(
									isReversed ? '↑' : '↓')
								]))
						]);
				}
		}
	}();
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[click]),
		content);
};
var $author$project$Csf$Table$simpleThead = function (headers) {
	return A2(
		$billstclair$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Csf$Table$simpleTheadHelp, headers));
};
var $author$project$Csf$Table$tableAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('table csf-table')
	]);
var $author$project$Csf$Table$tableFooter = $elm$core$Maybe$Just(
	A2($billstclair$elm_sortable_table$Table$HtmlDetails, _List_Nil, _List_Nil));
var $author$project$Csf$Table$config = function (conf) {
	return $billstclair$elm_sortable_table$Table$customConfig(
		{
			f8: conf.f8,
			jS: _Utils_update(
				$billstclair$elm_sortable_table$Table$defaultCustomizations,
				{
					k2: $author$project$Csf$Table$rowAttrs,
					le: $elm$core$List$concat(
						_List_fromArray(
							[
								$author$project$Csf$Table$tableAttrs,
								A2($elm$core$Maybe$withDefault, _List_Nil, conf.hD)
							])),
					lk: $author$project$Csf$Table$tableFooter,
					ll: A2($elm$core$Maybe$withDefault, $author$project$Csf$Table$simpleThead, conf.hC)
				}),
			hb: A2(
				$elm$core$Basics$composeL,
				conf.hb,
				function ($) {
					return $.r;
				}),
			fJ: $author$project$Csf$Table$TableMsg
		});
};
var $elm$html$Html$caption = _VirtualDom_node('caption');
var $billstclair$elm_sortable_table$Table$applySorter = F3(
	function (isReversed, sorter, data) {
		switch (sorter.$) {
			case 0:
				return data;
			case 1:
				var srt = sorter.a;
				return srt(data);
			case 2:
				var srt = sorter.a;
				return $elm$core$List$reverse(
					srt(data));
			case 3:
				var srt = sorter.a;
				return isReversed ? $elm$core$List$reverse(
					srt(data)) : srt(data);
			default:
				var srt = sorter.a;
				return isReversed ? srt(data) : $elm$core$List$reverse(
					srt(data));
		}
	});
var $billstclair$elm_sortable_table$Table$findSorter = F2(
	function (selectedColumn, columnData) {
		findSorter:
		while (true) {
			if (!columnData.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var name = columnData.a.dc;
				var sorter = columnData.a.bD;
				var remainingColumnData = columnData.b;
				if (_Utils_eq(name, selectedColumn)) {
					return $elm$core$Maybe$Just(sorter);
				} else {
					var $temp$selectedColumn = selectedColumn,
						$temp$columnData = remainingColumnData;
					selectedColumn = $temp$selectedColumn;
					columnData = $temp$columnData;
					continue findSorter;
				}
			}
		}
	});
var $billstclair$elm_sortable_table$Table$sort = F3(
	function (_v0, columnData, data) {
		var selectedColumn = _v0.a;
		var isReversed = _v0.b;
		var _v1 = A2($billstclair$elm_sortable_table$Table$findSorter, selectedColumn, columnData);
		if (_v1.$ === 1) {
			return data;
		} else {
			var sorter = _v1.a;
			return A3($billstclair$elm_sortable_table$Table$applySorter, isReversed, sorter, data);
		}
	});
var $billstclair$elm_sortable_table$Table$getSortedData = F3(
	function (_v0, state, data) {
		var toId = _v0.hb;
		var toMsg = _v0.fJ;
		var columns = _v0.f8;
		var customizations = _v0.jS;
		return A3($billstclair$elm_sortable_table$Table$sort, state, columns, data);
	});
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $billstclair$elm_sortable_table$Table$Reversible = function (a) {
	return {$: 2, a: a};
};
var $billstclair$elm_sortable_table$Table$Sortable = function (a) {
	return {$: 1, a: a};
};
var $billstclair$elm_sortable_table$Table$Unsortable = {$: 0};
var $billstclair$elm_sortable_table$Table$onClick = F3(
	function (name, isReversed, toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'click',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A3(
					$elm$json$Json$Decode$map2,
					$billstclair$elm_sortable_table$Table$State,
					$elm$json$Json$Decode$succeed(name),
					$elm$json$Json$Decode$succeed(isReversed))));
	});
var $billstclair$elm_sortable_table$Table$toHeaderInfo = F3(
	function (_v0, toMsg, _v1) {
		var sortName = _v0.a;
		var isReversed = _v0.b;
		var name = _v1.dc;
		var sorter = _v1.bD;
		switch (sorter.$) {
			case 0:
				return _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Unsortable,
					A3($billstclair$elm_sortable_table$Table$onClick, sortName, isReversed, toMsg));
			case 1:
				return _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Sortable(
						!_Utils_eq(name, sortName)),
					A3($billstclair$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 2:
				return _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Sortable(
						_Utils_eq(name, sortName)),
					A3($billstclair$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 3:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(!isReversed)),
					A3($billstclair$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($billstclair$elm_sortable_table$Table$onClick, name, false, toMsg));
			default:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(isReversed)),
					A3($billstclair$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$billstclair$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($billstclair$elm_sortable_table$Table$onClick, name, false, toMsg));
		}
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $billstclair$elm_sortable_table$Table$viewCell = F2(
	function (data, _v0) {
		var viewData = _v0.dI;
		var details = viewData(data);
		return A2($elm$html$Html$td, details.I, details.J);
	});
var $billstclair$elm_sortable_table$Table$viewRowHelp = F3(
	function (columns, toRowAttrs, data) {
		return A2(
			$elm$html$Html$tr,
			toRowAttrs(data),
			A2(
				$elm$core$List$map,
				$billstclair$elm_sortable_table$Table$viewCell(data),
				columns));
	});
var $billstclair$elm_sortable_table$Table$viewRow = F4(
	function (toId, columns, toRowAttrs, data) {
		return _Utils_Tuple2(
			toId(data),
			A4($elm$html$Html$Lazy$lazy3, $billstclair$elm_sortable_table$Table$viewRowHelp, columns, toRowAttrs, data));
	});
var $billstclair$elm_sortable_table$Table$view = F3(
	function (conf, state, data) {
		var toId = conf.hb;
		var toMsg = conf.fJ;
		var columns = conf.f8;
		var customizations = conf.jS;
		var theadDetails = customizations.ll(
			A2(
				$elm$core$List$map,
				A2($billstclair$elm_sortable_table$Table$toHeaderInfo, state, toMsg),
				columns));
		var thead = A2(
			$elm$html$Html$thead,
			theadDetails.I,
			_List_fromArray(
				[
					A2($elm$html$Html$tr, _List_Nil, theadDetails.J)
				]));
		var sortedData = A3($billstclair$elm_sortable_table$Table$getSortedData, conf, state, data);
		var tbody = A3(
			$elm$html$Html$Keyed$node,
			'tbody',
			customizations.g6,
			A2(
				$elm$core$List$map,
				A3($billstclair$elm_sortable_table$Table$viewRow, toId, columns, customizations.k2),
				sortedData));
		var withFoot = function () {
			var _v1 = customizations.lk;
			if (_v1.$ === 1) {
				return A2($elm$core$List$cons, tbody, _List_Nil);
			} else {
				var attributes = _v1.a.I;
				var children = _v1.a.J;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$tfoot, attributes, children),
					A2($elm$core$List$cons, tbody, _List_Nil));
			}
		}();
		return A2(
			$elm$html$Html$table,
			customizations.le,
			function () {
				var _v0 = customizations.f4;
				if (_v0.$ === 1) {
					return A2($elm$core$List$cons, thead, withFoot);
				} else {
					var attributes = _v0.a.I;
					var children = _v0.a.J;
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$caption, attributes, children),
						A2($elm$core$List$cons, thead, withFoot));
				}
			}());
	});
var $author$project$Csf$Table$view = F2(
	function (conf, model) {
		return A3(
			$billstclair$elm_sortable_table$Table$view,
			$author$project$Csf$Table$config(conf),
			model.w,
			model.r);
	});
var $author$project$Page$CargarStock$view = function (model) {
	var session = model.g$;
	var tableModel = model.jb;
	var validatedVehicles = model.aI;
	var doShowTable = A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(tableModel.r);
	var progressBarValue_ = (!doShowTable) ? 0 : A3(
		$elm$core$Basics$composeR,
		$elm$core$Basics$round,
		$elm$core$Basics$toFloat,
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Basics$fdiv(model.ce),
			$elm$core$Basics$mul(100),
			A2($elm$core$Basics$composeR, $elm$core$List$length, $elm$core$Basics$toFloat)(tableModel.r)));
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		$elm_community$list_extra$List$Extra$count(
			function (_v2) {
				return true;
			}),
		A2(
			$elm$core$Tuple$mapFirst,
			$elm_community$list_extra$List$Extra$count(
				function (_v1) {
					return true;
				}),
			A2(
				$elm$core$List$partition,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ld;
					},
					$elm$core$Basics$not),
				validatedVehicles)));
	var vh_errored = _v0.a;
	var vh_succeed = _v0.b;
	var vh_process_title = _List_fromArray(
		[
			$elm$html$Html$text('Vehículos para Emisión:'),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-weight-bolder ml-2')
				]),
			_List_fromArray(
				[
					A3(
					$elm$core$Basics$composeL,
					$elm$html$Html$text,
					$elm$core$String$fromInt,
					$elm$core$List$length(tableModel.r))
				])),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-0 ml-5 pl-2 pr-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Vehículos sin error:'),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-weight-bolder ml-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(vh_succeed))
						]))
				])),
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-0 ml-5 pl-2 pr-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Vehículos con error:'),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-weight-bolder ml-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(vh_errored))
						]))
				]))
		]);
	var _v3 = doShowTable ? _Utils_Tuple3(
		$author$project$Page$CargarStock$moduleMessage('head_loaded'),
		vh_process_title,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('f-14 m-0')
			])) : _Utils_Tuple3(
		$author$project$Page$CargarStock$moduleMessage('head_unload'),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Page$CargarStock$moduleMessage('card_title_unload'))
			]),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('f-14 m-0')
			]));
	var head_title = _v3.a;
	var card_title = _v3.b;
	var card_attributes = _v3.c;
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(head_title)
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('col-sm-12', true)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Page$CargarStock$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 csf-content-pkg card-body--no-padding f-12'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-8')
													]),
												_List_fromArray(
													[
														A2($elm$html$Html$h4, card_attributes, card_title)
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-4 text-uppercase text-right'),
														$author$project$Csf$Form$attr(
														$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('hidden', doShowTable)
																])))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(!doShowTable)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary just-icon ml-2'),
																		$author$project$Csf$Form$attr(
																		A2($elm$html$Html$Attributes$attribute, 'title_', 'Cancelar carga')),
																		A2($author$project$Csf$Form$style_, 'min-width', '25px'),
																		$author$project$Csf$Form$onClick_($author$project$Page$CargarStock$GoBackToStock)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$i,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('zmdi zmdi-close f-16')
																			]),
																		_List_Nil)
																	]))
															]))
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-4 text-uppercase text-right'),
														$author$project$Csf$Form$attr(
														$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('hidden', !doShowTable)
																])))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(doShowTable)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$CargarStock$CancelRegistration)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Cancelar')
																	])),
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$loading(model.a2),
																		$author$project$Csf$Form$onClick_($author$project$Page$CargarStock$ProcessRegistraton)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Cargar')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$show(doShowTable)
													]),
												_List_fromArray(
													[
														$author$project$Page$CargarStock$progressBarTiny(progressBarValue_)
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$show(!doShowTable)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$FileUploader$view,
														model.dG,
														A2(
															$author$project$Csf$FileUploader$secondaryText,
															'Arrastre la nómina aquí o use el botón',
															A2(
																$author$project$Csf$FileUploader$primaryText,
																'Cree una nueva carga de importaciones',
																A2(
																	$author$project$Csf$FileUploader$bttnLoading,
																	model.az,
																	A2(
																		$author$project$Csf$FileUploader$bttnLabel,
																		'Cargar Planilla',
																		A2(
																			$author$project$Csf$FileUploader$imageSource,
																			$author$project$Helpers$Utilities$imagesPath('/excel-file.svg'),
																			$author$project$Csf$FileUploader$config($author$project$Page$CargarStock$UploaderMsg)))))))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center'),
														$author$project$Csf$Form$show(doShowTable)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Page$CargarStock$TableMsg,
														A2(
															$author$project$Csf$Table$view,
															$author$project$Page$CargarStock$tableConfig(model),
															tableModel))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$ConsultarStock$DoExportXLS = {$: 1};
var $author$project$Page$ConsultarStock$GoToCargarStock = {$: 3};
var $author$project$Page$ConsultarStock$NoOp = {$: 0};
var $author$project$Page$ConsultarStock$CloseConfirmNullifyModal = {$: 21};
var $author$project$Page$ConsultarStock$DoNullifyVehicle = {$: 4};
var $author$project$Csf$Modal$Config = $elm$core$Basics$identity;
var $author$project$Csf$Modal$attrs = F2(
	function (attrs_, _v0) {
		var conf = _v0;
		var options = conf.R;
		return _Utils_update(
			conf,
			{
				R: _Utils_update(
					options,
					{I: attrs_})
			});
	});
var $author$project$Csf$Modal$Body = $elm$core$Basics$identity;
var $author$project$Csf$Modal$body = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				h: $elm$core$Maybe$Just(
					{I: attributes, J: children})
			});
	});
var $author$project$Csf$Modal$config = function (closeMsg) {
	return {
		h: $elm$core$Maybe$Nothing,
		cA: closeMsg,
		el: $elm$core$Maybe$Nothing,
		et: $elm$core$Maybe$Nothing,
		R: {I: _List_Nil, f6: true, cX: true, c9: $elm$core$Maybe$Nothing},
		dQ: $elm$core$Maybe$Nothing,
		fY: $elm$core$Maybe$Nothing
	};
};
var $author$project$Csf$Modal$Footer = $elm$core$Basics$identity;
var $author$project$Csf$Modal$footer = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				el: $elm$core$Maybe$Just(
					{I: attributes, J: children})
			});
	});
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Csf$Modal$Header = $elm$core$Basics$identity;
var $author$project$Csf$Modal$header = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				et: $elm$core$Maybe$Just(
					{I: attributes, J: children})
			});
	});
var $author$project$Csf$Modal$titledHeader = F3(
	function (itemFn, attributes, children) {
		return A2(
			$author$project$Csf$Modal$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					itemFn,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('modal-title'),
						attributes),
					children)
				]));
	});
var $author$project$Csf$Modal$h5 = $author$project$Csf$Modal$titledHeader($elm$html$Html$h5);
var $author$project$Csf$Modal$hideOnBackdropClick = F2(
	function (hide, _v0) {
		var conf = _v0;
		var options = conf.R;
		return _Utils_update(
			conf,
			{
				R: _Utils_update(
					options,
					{cX: hide})
			});
	});
var $author$project$Csf$Modal$StartClose = 1;
var $author$project$Csf$Modal$getCloseMsg = function (config_) {
	var _v0 = config_.dQ;
	if (!_v0.$) {
		var animationMsg = _v0.a;
		return animationMsg(1);
	} else {
		return config_.cA;
	}
};
var $author$project$Csf$Modal$isFade = function (conf) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			conf.dQ));
};
var $author$project$Csf$Modal$backdrop = F2(
	function (visibility, conf) {
		var attributes = function () {
			switch (visibility) {
				case 0:
					return _Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal-backdrop', true),
										_Utils_Tuple2(
										'fade',
										$author$project$Csf$Modal$isFade(conf)),
										_Utils_Tuple2('show', true)
									]))
							]),
						conf.R.cX ? _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Csf$Modal$getCloseMsg(conf))
							]) : _List_Nil);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', true)
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', false)
								]))
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', false),
									_Utils_Tuple2(
									'fade',
									$author$project$Csf$Modal$isFade(conf)),
									_Utils_Tuple2('show', false)
								]))
						]);
			}
		}();
		return _List_fromArray(
			[
				A2($elm$html$Html$div, attributes, _List_Nil)
			]);
	});
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['className']),
	$elm$json$Json$Decode$string);
var $rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Csf$Modal$containerClickDecoder = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (c) {
			return A2($elm$core$String$contains, 'elm-bootstrap-modal', c) ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignoring');
		},
		$rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$target($rundis$elm_bootstrap$Bootstrap$Utilities$DomHelper$className));
};
var $author$project$Csf$Modal$display = F2(
	function (visibility, conf) {
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$author$project$Csf$Modal$isFade(conf)),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', false)
							])),
						A2(
						$elm$html$Html$Events$on,
						'transitionend',
						$elm$json$Json$Decode$succeed(conf.cA))
					]);
			default:
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'height', '0px'),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$author$project$Csf$Modal$isFade(conf)),
								_Utils_Tuple2('show', false)
							]))
					]);
		}
	});
var $author$project$Csf$BootstrapInternal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $author$project$Csf$Modal$modalClass = function (size) {
	var _v0 = $author$project$Csf$BootstrapInternal$screenSizeOption(size);
	if (!_v0.$) {
		var s = _v0.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-' + s)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Csf$Modal$modalAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('modal-dialog', true),
						_Utils_Tuple2('modal-dialog-centered', options.f6)
					])),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto')
			]),
		_Utils_ap(
			options.I,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Csf$Modal$modalClass, options.c9))));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Csf$Modal$renderBody = function (maybeBody) {
	if (!maybeBody.$) {
		var cfg = maybeBody.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-body'),
					cfg.I),
				cfg.J));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Modal$renderFooter = function (maybeFooter) {
	if (!maybeFooter.$) {
		var cfg = maybeFooter.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-footer'),
					cfg.I),
				cfg.J));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Modal$closeButton = function (closeMsg) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('close'),
				$elm$html$Html$Events$onClick(closeMsg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('×')
			]));
};
var $author$project$Csf$Modal$renderHeader = function (conf_) {
	var _v0 = conf_.et;
	if (!_v0.$) {
		var cfg = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('modal-header'),
					cfg.I),
				_Utils_ap(
					cfg.J,
					_List_fromArray(
						[
							$author$project$Csf$Modal$closeButton(
							$author$project$Csf$Modal$getCloseMsg(conf_))
						]))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Modal$renderWrap = function (conf_) {
	var _v0 = conf_.fY;
	if (!_v0.$) {
		var cfg = _v0.a;
		return _List_fromArray(
			[
				$elm$core$Maybe$Just(
				A3(
					$elm$html$Html$node,
					cfg.gj,
					cfg.I,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Csf$Modal$renderHeader(conf_),
								$author$project$Csf$Modal$renderBody(conf_.h),
								$author$project$Csf$Modal$renderFooter(conf_.el)
							]))))
			]);
	} else {
		return _List_fromArray(
			[
				$author$project$Csf$Modal$renderHeader(conf_),
				$author$project$Csf$Modal$renderBody(conf_.h),
				$author$project$Csf$Modal$renderFooter(conf_.el)
			]);
	}
};
var $author$project$Csf$Modal$view = F2(
	function (visibility, _v0) {
		var conf = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							A2($author$project$Csf$Modal$display, visibility, conf)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'role', 'document'),
											$elm$html$Html$Attributes$class('elm-bootstrap-modal')
										]),
									_Utils_ap(
										$author$project$Csf$Modal$modalAttributes(conf.R),
										conf.R.cX ? _List_fromArray(
											[
												A2(
												$elm$html$Html$Events$on,
												'click',
												$author$project$Csf$Modal$containerClickDecoder(conf.cA))
											]) : _List_Nil)),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-content')
											]),
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											$author$project$Csf$Modal$renderWrap(conf)))
									]))
							]))
					]),
				A2($author$project$Csf$Modal$backdrop, visibility, conf)));
	});
var $author$project$Csf$Modal$Wrap = $elm$core$Basics$identity;
var $author$project$Csf$Modal$wrap = F3(
	function (element, attributes, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fY: $elm$core$Maybe$Just(
					{I: attributes, gj: element})
			});
	});
var $author$project$Page$ConsultarStock$confirmModalView = function (model) {
	var confirmModal = model.cB;
	var _v0 = model.bw ? _Utils_Tuple2($author$project$Page$ConsultarStock$NoOp, $author$project$Page$ConsultarStock$NoOp) : _Utils_Tuple2($author$project$Page$ConsultarStock$CloseConfirmNullifyModal, $author$project$Page$ConsultarStock$DoNullifyVehicle);
	var cancelAction = _v0.a;
	var doAction = _v0.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, confirmModal)) ? $elm$html$Html$text('') : function (mdal) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				]),
			_List_fromArray(
				[mdal]));
	}(
		A2(
			$author$project$Csf$Modal$view,
			confirmModal,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (bttnAttrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							bttnAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
								$author$project$Csf$Form$onClick_(cancelAction)
							])),
						function (bttnAttrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							bttnAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anular')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$loading(model.bw)
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3')
						]),
					_List_fromArray(
						[
							$author$project$Helpers$Utilities$trimmedEmpty(model.de) ? $elm$html$Html$text('') : A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							true,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1 pt-1 pb-1')
								]),
							model.de),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12 p-0 f-16 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$ConsultarStock$moduleMessage('confirm_nullify'))
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
									A2($elm$html$Html$Attributes$style, 'top', '-15px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Anulación de Vehículo')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									!model.bw,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Csf$Core$loader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('page-loader position-absolute'),
			A2($elm$html$Html$Attributes$style, 'z-index', '10'),
			A2($elm$html$Html$Attributes$style, 'background', 'transparent')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-loader__spinner')
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$svg,
					_List_fromArray(
						[
							A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 25, 25, 50, 50)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$circle,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$cx(
									$elm_community$typed_svg$TypedSvg$Types$px(50)),
									$elm_community$typed_svg$TypedSvg$Attributes$cy(
									$elm_community$typed_svg$TypedSvg$Types$px(50)),
									$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone),
									$elm_community$typed_svg$TypedSvg$Attributes$r(
									$elm_community$typed_svg$TypedSvg$Types$px(20)),
									A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10'),
									A2($elm$html$Html$Attributes$attribute, 'stroke-width', '2')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Page$ConsultarStock$acciones_ = F2(
	function (ticket_, taskNode_) {
		var nullify_ = $elm$html$Html$Events$onClick(
			A2($author$project$Csf$Table$CustomEventMsg, 'anular_vehiculo', taskNode_));
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('f-16')
				]),
			_List_fromArray(
				[
					function (anchorAttrs_) {
					return A2(
						$elm$html$Html$a,
						anchorAttrs_,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('zmdi zmdi-delete'),
										A2($elm$html$Html$Attributes$style, 'padding', '0 5px')
									]),
								_List_Nil)
							]));
				}(
					_List_fromArray(
						[
							nullify_,
							A2($elm$html$Html$Attributes$style, 'color', '#7f7f7f'),
							A2($elm$html$Html$Attributes$attribute, 'title_', 'Anular vehículo'),
							$elm$html$Html$Attributes$class('pl-1 pr-1 position-relative just-icon')
						]))
				]));
	});
var $author$project$Helpers$Utilities$forceValueToString = F2(
	function (default_, value_) {
		return A2(
			$elm$core$Result$withDefault,
			default_,
			A2($elm$json$Json$Decode$decodeValue, $author$project$Helpers$Utilities$forceStringDecoder, value_));
	});
var $author$project$Page$ConsultarStock$fromTaskNode = F2(
	function (key_, taskNode_) {
		switch (key_) {
			case 'ano':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$forceValueToString(''),
					A2($author$project$Csf$TaskNodeUtils$mbvalue, key_, taskNode_));
			case 'inserted_at':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			case 'id_lote':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			case 'estado_chie':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$estadoDelChie,
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			case 'estado_vehiculo':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$estadoDelVehiculo,
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			default:
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
		}
	});
var $billstclair$elm_sortable_table$Table$IncOrDec = function (a) {
	return {$: 3, a: a};
};
var $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy = function (toComparable) {
	return $billstclair$elm_sortable_table$Table$IncOrDec(
		$elm$core$List$sortBy(toComparable));
};
var $author$project$Page$ConsultarStock$justtext = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(default_),
			$elm$html$Html$text,
			A2($author$project$Page$ConsultarStock$fromTaskNode, key_, taskNode_));
	});
var $author$project$Page$ConsultarStock$linkable = F2(
	function (key_, taskNode_) {
		var key_val = A2(
			$elm$core$Maybe$withDefault,
			key_,
			A2($author$project$Page$ConsultarStock$fromTaskNode, key_, taskNode_));
		var href_ = function () {
			if (key_ === 'id_lote') {
				return A3(
					$elm$core$Basics$composeR,
					$author$project$Route$ConsultarStock,
					$author$project$Route$href,
					{
						iI: A3($author$project$Route$appendToQuery, 'id_carga', key_val, $author$project$Route$emptyData.iI)
					});
			} else {
				return $elm$html$Html$Attributes$href('');
			}
		}();
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table_linkable'),
					href_
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(key_val)
				]));
	});
var $author$project$Page$ConsultarStock$textdate = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var format_ = _v0.b;
		var zone_ = _v0.c;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			$elm$html$Html$text,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Csf$DateFormat$formatIsoDate, format_, zone_),
					$elm$core$Maybe$withDefault('')),
				A2($author$project$Page$ConsultarStock$fromTaskNode, key_, taskNode_)));
	});
var $author$project$Page$ConsultarStock$tableConfig = function (model) {
	var zone = model.lG;
	var session = model.g$;
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var doSortBy = function (_v0) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$ConsultarStock$fromTaskNode(key_),
			$elm$core$Maybe$withDefault(default_));
	};
	return {
		f8: _List_fromArray(
			[
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('vin', '')),
					dc: 'Vin',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('vin', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$textdate(
						_Utils_Tuple3('inserted_at', 'DD/MM/YYYY hh:mm A', zone)),
					dc: 'Fecha | Hora',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('inserted_at', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Just('155px')
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$linkable('id_lote'),
					dc: 'ID Carga',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('id_lote', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('tipo', '')),
					dc: 'Tipo',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('tipo', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('marca', '')),
					dc: 'Marca',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('marca', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('modelo', '')),
					dc: 'Modelo',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('modelo', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('ano', '')),
					dc: 'Año',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('ano', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('color', '')),
					dc: 'Color',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('color', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('motor', '')),
					dc: 'N° Motor',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('motor', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('cit', '')),
					dc: 'C.I.T',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('cit', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('estado_chie', '')),
					dc: 'Estado CHI-e',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('estado_chie', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$justtext(
						_Utils_Tuple2('estado_vehiculo', '')),
					dc: 'Estado Vehículo',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('estado_vehiculo', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$ConsultarStock$acciones_(ticket_),
					dc: 'Acciones',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Just('100px')
				})
			]),
		hC: $elm$core$Maybe$Nothing,
		hD: $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stock_vh-table'),
					A2($elm$html$Html$Attributes$style, 'min-width', '1710px')
				])),
		hb: function ($) {
			return $.p;
		}
	};
};
var $author$project$Csf$FilterBadges$ClearBadge = function (a) {
	return {$: 1, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Badge$Primary = 0;
var $rundis$elm_bootstrap$Bootstrap$Badge$Roled = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Badge$roleOption = function (role) {
	switch (role) {
		case 0:
			return 'badge-primary';
		case 1:
			return 'badge-secondary';
		case 2:
			return 'badge-success';
		case 3:
			return 'badge-info';
		case 4:
			return 'badge-warning';
		case 5:
			return 'badge-danger';
		case 6:
			return 'badge-light';
		default:
			return 'badge-dark';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeClass = function (option) {
	return $elm$html$Html$Attributes$class(
		function () {
			if (option.$ === 1) {
				return 'badge-pill';
			} else {
				var role = option.a;
				return $rundis$elm_bootstrap$Bootstrap$Badge$roleOption(role);
			}
		}());
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeAttributes = function (options) {
	return A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$class('badge'),
		A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Badge$badgeClass, options));
};
var $rundis$elm_bootstrap$Bootstrap$Badge$badgeInternal = F3(
	function (options, attributes, children) {
		return A2(
			$elm$html$Html$span,
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Badge$badgeAttributes(options),
				attributes),
			children);
	});
var $rundis$elm_bootstrap$Bootstrap$Badge$badgePrimary = $rundis$elm_bootstrap$Bootstrap$Badge$badgeInternal(
	_List_fromArray(
		[
			$rundis$elm_bootstrap$Bootstrap$Badge$Roled(0)
		]));
var $author$project$Csf$FilterBadges$closeIcon = function (routeKey) {
	return function (iconAttrs_) {
		return A2($elm$html$Html$i, iconAttrs_, _List_Nil);
	}(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('zmdi zmdi-close ml-2'),
				A2($elm$html$Html$Attributes$style, 'font-size', '18px'),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
				$elm$html$Html$Events$onClick(
				$author$project$Csf$FilterBadges$ClearBadge(routeKey))
			]));
};
var $author$project$Csf$FilterBadges$spanInfoData = function (data_) {
	return function (spanAttrs_) {
		return A2(
			$elm$html$Html$span,
			spanAttrs_,
			_List_fromArray(
				[
					$elm$html$Html$text(data_)
				]));
	}(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('position-relative'),
				A2($elm$html$Html$Attributes$style, 'bottom', '2.5px')
			]));
};
var $author$project$Csf$FilterBadges$view = function (model) {
	var query_ = A2(
		$elm$core$Dict$filter,
		$author$project$Csf$FilterBadges$routeFilter($elm$core$Basics$not),
		$author$project$Route$queryFromRoute(model.bC));
	return $elm$core$Dict$isEmpty(query_) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row m-0 f-14')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-auto pt-2 pb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Has seleccionado:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-auto pl-2 pr-2 pt-1 pb-1 filter-badges_ text-left')
					]),
				function (badgeMap) {
					return A2(
						$elm$core$List$map,
						badgeMap,
						$elm$core$Dict$keys(query_));
				}(
					function (key_) {
						return A2(
							$rundis$elm_bootstrap$Bootstrap$Badge$badgePrimary,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-1 pt-1 pb-1 pl-2 pr-2')
								]),
							_List_fromArray(
								[
									$author$project$Csf$FilterBadges$spanInfoData(
									model.ha(
										A2($author$project$Route$dataFromQuery, key_, query_))),
									$author$project$Csf$FilterBadges$closeIcon(key_)
								]));
					})),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-auto pt-2 pb-2 pr-2 pl-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table_linkable'),
								$elm$html$Html$Events$onClick(
								$author$project$Csf$FilterBadges$ClearBadge('all-badges'))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('zmdi zmdi-delete mr-1')
									]),
								_List_Nil),
								$elm$html$Html$text('Borrar filtros')
							]))
					]))
			]));
};
var $author$project$Csf$NodePager$ActualPageField = 0;
var $author$project$Csf$NodePager$ItemsPerPageField = 1;
var $author$project$Csf$NodePager$NextPage = {$: 2};
var $author$project$Csf$NodePager$NoAction = {$: 0};
var $author$project$Csf$NodePager$PrevPage = {$: 1};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs = function (a) {
	return {$: 6, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs = function (a) {
	return {$: 2, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Row$attrs = function (attrs_) {
	return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs(attrs_);
};
var $rundis$elm_bootstrap$Bootstrap$Form$Col = $elm$core$Basics$identity;
var $rundis$elm_bootstrap$Bootstrap$Form$col = F2(
	function (options, children) {
		return {J: children, hJ: $elm$html$Html$div, R: options};
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col = 0;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width = F2(
	function (screenSize, columnCount) {
		return {hy: columnCount, iT: screenSize};
	});
var $rundis$elm_bootstrap$Bootstrap$General$Internal$XS = 0;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign = F2(
	function (align_, options) {
		var _v0 = align_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						dW: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						dU: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						dT: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						dS: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						dV: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset = F2(
	function (offset_, options) {
		var _v0 = offset_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						eW: $elm$core$Maybe$Just(offset_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						eT: $elm$core$Maybe$Just(offset_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						eS: $elm$core$Maybe$Just(offset_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						eR: $elm$core$Maybe$Just(offset_)
					});
			default:
				return _Utils_update(
					options,
					{
						eV: $elm$core$Maybe$Just(offset_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder = F2(
	function (order_, options) {
		var _v0 = order_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						e5: $elm$core$Maybe$Just(order_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						e3: $elm$core$Maybe$Just(order_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						e2: $elm$core$Maybe$Just(order_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						e1: $elm$core$Maybe$Just(order_)
					});
			default:
				return _Utils_update(
					options,
					{
						e4: $elm$core$Maybe$Just(order_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull = F2(
	function (pull_, options) {
		var _v0 = pull_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						fc: $elm$core$Maybe$Just(pull_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						fa: $elm$core$Maybe$Just(pull_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						e9: $elm$core$Maybe$Just(pull_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						e8: $elm$core$Maybe$Just(pull_)
					});
			default:
				return _Utils_update(
					options,
					{
						fb: $elm$core$Maybe$Just(pull_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush = F2(
	function (push_, options) {
		var _v0 = push_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						fh: $elm$core$Maybe$Just(push_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						ff: $elm$core$Maybe$Just(push_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						fe: $elm$core$Maybe$Just(push_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						fd: $elm$core$Maybe$Just(push_)
					});
			default:
				return _Utils_update(
					options,
					{
						fg: $elm$core$Maybe$Just(push_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth = F2(
	function (width_, options) {
		var _v0 = width_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						dO: $elm$core$Maybe$Just(width_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						dM: $elm$core$Maybe$Just(width_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						dL: $elm$core$Maybe$Just(width_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						dK: $elm$core$Maybe$Just(width_)
					});
			default:
				return _Utils_update(
					options,
					{
						dN: $elm$core$Maybe$Just(width_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 6:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						I: _Utils_ap(options.I, attrs)
					});
			case 0:
				var width_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth, width_, options);
			case 1:
				var offset_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset, offset_, options);
			case 2:
				var pull_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull, pull_, options);
			case 3:
				var push_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush, push_, options);
			case 4:
				var order_ = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder, order_, options);
			case 5:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign, align, options);
			default:
				var align = modifier.a;
				return _Utils_update(
					options,
					{
						fH: $elm$core$Maybe$Just(align)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('1');
		case 2:
			return $elm$core$Maybe$Just('2');
		case 3:
			return $elm$core$Maybe$Just('3');
		case 4:
			return $elm$core$Maybe$Just('4');
		case 5:
			return $elm$core$Maybe$Just('5');
		case 6:
			return $elm$core$Maybe$Just('6');
		case 7:
			return $elm$core$Maybe$Just('7');
		case 8:
			return $elm$core$Maybe$Just('8');
		case 9:
			return $elm$core$Maybe$Just('9');
		case 10:
			return $elm$core$Maybe$Just('10');
		case 11:
			return $elm$core$Maybe$Just('11');
		case 12:
			return $elm$core$Maybe$Just('12');
		default:
			return $elm$core$Maybe$Just('auto');
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass = function (_v0) {
	var screenSize = _v0.iT;
	var columnCount = _v0.hy;
	return $elm$html$Html$Attributes$class(
		'col' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption(columnCount)))));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes = function (widths) {
	var width_ = function (w) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass, w);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, width_, widths));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions = {dS: $elm$core$Maybe$Nothing, dT: $elm$core$Maybe$Nothing, dU: $elm$core$Maybe$Nothing, dV: $elm$core$Maybe$Nothing, dW: $elm$core$Maybe$Nothing, I: _List_Nil, eR: $elm$core$Maybe$Nothing, eS: $elm$core$Maybe$Nothing, eT: $elm$core$Maybe$Nothing, eV: $elm$core$Maybe$Nothing, eW: $elm$core$Maybe$Nothing, e1: $elm$core$Maybe$Nothing, e2: $elm$core$Maybe$Nothing, e3: $elm$core$Maybe$Nothing, e4: $elm$core$Maybe$Nothing, e5: $elm$core$Maybe$Nothing, e8: $elm$core$Maybe$Nothing, e9: $elm$core$Maybe$Nothing, fa: $elm$core$Maybe$Nothing, fb: $elm$core$Maybe$Nothing, fc: $elm$core$Maybe$Nothing, fd: $elm$core$Maybe$Nothing, fe: $elm$core$Maybe$Nothing, ff: $elm$core$Maybe$Nothing, fg: $elm$core$Maybe$Nothing, fh: $elm$core$Maybe$Nothing, fH: $elm$core$Maybe$Nothing, dK: $elm$core$Maybe$Nothing, dL: $elm$core$Maybe$Nothing, dM: $elm$core$Maybe$Nothing, dN: $elm$core$Maybe$Nothing, dO: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		default:
			return '11';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString = function (screenSize) {
	var _v0 = $rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize);
	if (!_v0.$) {
		var s = _v0.a;
		return '-' + (s + '-');
	} else {
		return '-';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass = function (_v0) {
	var screenSize = _v0.iT;
	var offsetCount = _v0.iv;
	return $elm$html$Html$Attributes$class(
		'offset' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption(offsetCount)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes = function (offsets) {
	var offset_ = function (m) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass, m);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, offset_, offsets));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption = function (size) {
	switch (size) {
		case 0:
			return 'first';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		case 12:
			return '12';
		default:
			return 'last';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes = function (orders) {
	var order_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.iT;
			var moveCount = m.a.cg;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'order' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, order_, orders));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		default:
			return '12';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes = function (pulls) {
	var pull_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.iT;
			var moveCount = m.a.cg;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'pull' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, pull_, pulls));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes = function (pushes) {
	var push_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.iT;
			var moveCount = m.a.cg;
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class(
					'push' + ($rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, push_, pushes));
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption = function (dir) {
	switch (dir) {
		case 1:
			return 'center';
		case 0:
			return 'left';
		default:
			return 'right';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass = function (_v0) {
	var dir = _v0.hG;
	var size = _v0.i_;
	return $elm$html$Html$Attributes$class(
		'text' + (A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return '-' + (s + '-');
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size))) + $rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption(dir)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		default:
			return 'end';
	}
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass = F2(
	function (prefix, _v0) {
		var align = _v0.hm;
		var screenSize = _v0.iT;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(
				prefix,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return v + '-';
							},
							$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))),
					$rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption(align))));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes = F2(
	function (prefix, aligns) {
		var align = function (a) {
			return A2(
				$elm$core$Maybe$map,
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass(prefix),
				a);
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, align, aligns));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions, modifiers);
	var shouldAddDefaultXs = !$elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[options.dO, options.dM, options.dL, options.dK, options.dN])));
	return _Utils_ap(
		$rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes(
			_List_fromArray(
				[
					shouldAddDefaultXs ? $elm$core$Maybe$Just(
					A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width, 0, 0)) : options.dO,
					options.dM,
					options.dL,
					options.dK,
					options.dN
				])),
		_Utils_ap(
			$rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes(
				_List_fromArray(
					[options.eW, options.eT, options.eS, options.eR, options.eV])),
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes(
					_List_fromArray(
						[options.fc, options.fa, options.e9, options.e8, options.fb])),
				_Utils_ap(
					$rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes(
						_List_fromArray(
							[options.fh, options.ff, options.fe, options.fd, options.fg])),
					_Utils_ap(
						$rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes(
							_List_fromArray(
								[options.e5, options.e3, options.e2, options.e1, options.e4])),
						_Utils_ap(
							A2(
								$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
								'align-self-',
								_List_fromArray(
									[options.dW, options.dU, options.dT, options.dS, options.dV])),
							_Utils_ap(
								function () {
									var _v0 = options.fH;
									if (!_v0.$) {
										var a = _v0.a;
										return _List_fromArray(
											[
												$rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(a)
											]);
									} else {
										return _List_Nil;
									}
								}(),
								options.I)))))));
};
var $rundis$elm_bootstrap$Bootstrap$Form$renderCol = function (_v0) {
	var elemFn = _v0.hJ;
	var options = _v0.R;
	var children = _v0.J;
	return A2(
		elemFn,
		$rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
		children);
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign = F2(
	function (align, options) {
		var _v0 = align.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						er: $elm$core$Maybe$Just(align)
					});
			case 1:
				return _Utils_update(
					options,
					{
						ep: $elm$core$Maybe$Just(align)
					});
			case 2:
				return _Utils_update(
					options,
					{
						eo: $elm$core$Maybe$Just(align)
					});
			case 3:
				return _Utils_update(
					options,
					{
						en: $elm$core$Maybe$Just(align)
					});
			default:
				return _Utils_update(
					options,
					{
						eq: $elm$core$Maybe$Just(align)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign = F2(
	function (align_, options) {
		var _v0 = align_.iT;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						fT: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						fR: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						fQ: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						fP: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						fS: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 2:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						I: _Utils_ap(options.I, attrs)
					});
			case 0:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign, align, options);
			default:
				var align = modifier.a;
				return A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign, align, options);
		}
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions = {I: _List_Nil, en: $elm$core$Maybe$Nothing, eo: $elm$core$Maybe$Nothing, ep: $elm$core$Maybe$Nothing, eq: $elm$core$Maybe$Nothing, er: $elm$core$Maybe$Nothing, fP: $elm$core$Maybe$Nothing, fQ: $elm$core$Maybe$Nothing, fR: $elm$core$Maybe$Nothing, fS: $elm$core$Maybe$Nothing, fT: $elm$core$Maybe$Nothing};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		case 2:
			return 'end';
		case 3:
			return 'around';
		default:
			return 'between';
	}
};
var $rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass = function (_v0) {
	var align = _v0.hm;
	var screenSize = _v0.iT;
	return $elm$html$Html$Attributes$class(
		'justify-content-' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return v + '-';
				},
				$rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + $rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption(align)));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes = function (aligns) {
	var align = function (a) {
		return A2($elm$core$Maybe$map, $rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass, a);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, align, aligns));
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption, $rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_Utils_ap(
			A2(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
				'align-items-',
				_List_fromArray(
					[options.fT, options.fR, options.fQ, options.fP, options.fS])),
			_Utils_ap(
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes(
					_List_fromArray(
						[options.er, options.ep, options.eo, options.en, options.eq])),
				options.I)));
};
var $rundis$elm_bootstrap$Bootstrap$Form$row = F2(
	function (options, cols) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-group'),
				$rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes(options)),
			A2($elm$core$List$map, $rundis$elm_bootstrap$Bootstrap$Form$renderCol, cols));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col6 = 6;
var $rundis$elm_bootstrap$Bootstrap$General$Internal$SM = 1;
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColWidth = function (a) {
	return {$: 0, a: a};
};
var $rundis$elm_bootstrap$Bootstrap$Grid$Internal$width = F2(
	function (size, count) {
		return $rundis$elm_bootstrap$Bootstrap$Grid$Internal$ColWidth(
			A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width, size, count));
	});
var $rundis$elm_bootstrap$Bootstrap$Grid$Col$sm6 = A2($rundis$elm_bootstrap$Bootstrap$Grid$Internal$width, 1, 6);
var $author$project$Csf$NodePager$OnBlured = function (a) {
	return {$: 4, a: a};
};
var $author$project$Csf$NodePager$OnFocused = function (a) {
	return {$: 5, a: a};
};
var $author$project$Csf$NodePager$OnKeyReleased = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Csf$NodePager$OnUpdated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Csf$NodePager$customizeWidth = function (baseValue_) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		function (width) {
			return width + 'px';
		},
		A3(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$mul(11.8),
				$elm$core$Basics$ceiling),
			$elm$core$Basics$max(30),
			A3(
				$elm$core$Basics$composeR,
				$elm$core$String$length,
				$elm$core$Basics$toFloat,
				$elm$core$String$fromInt(baseValue_))));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Csf$NodePager$onKeyUp = function (key) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, key, $elm$html$Html$Events$keyCode));
};
var $author$project$Csf$NodePager$wrappedInputField = F3(
	function (attrs_, field_, model) {
		var totalPages = model.lp;
		var maxPageSize = model.bs;
		var processValue = function (value_) {
			return (!value_) ? '' : $elm$core$String$fromInt(value_);
		};
		var fieldValue = function () {
			if (!field_) {
				return processValue(model.bb);
			} else {
				return processValue(model.bc);
			}
		}();
		var inputAttr = _Utils_ap(
			attrs_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control input-sm text-center pl-2 pr-2'),
					A2($elm$html$Html$Attributes$style, 'border', '1px solid #e0e0e0'),
					A2($elm$html$Html$Attributes$style, 'height', '25px'),
					$elm$html$Html$Attributes$value(fieldValue),
					$elm$html$Html$Events$onBlur(
					$author$project$Csf$NodePager$OnBlured(field_)),
					$elm$html$Html$Events$onFocus(
					$author$project$Csf$NodePager$OnFocused(field_)),
					$elm$html$Html$Events$onInput(
					$author$project$Csf$NodePager$OnUpdated(field_)),
					$author$project$Csf$NodePager$onKeyUp(
					$author$project$Csf$NodePager$OnKeyReleased(field_))
				]));
		var dynamicWidth = function () {
			if (!field_) {
				return $author$project$Csf$NodePager$customizeWidth(totalPages);
			} else {
				return $author$project$Csf$NodePager$customizeWidth(maxPageSize);
			}
		}();
		var containerAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-group mb-2 mt-2'),
				A2($elm$html$Html$Attributes$style, 'width', dynamicWidth),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
			]);
		return A2(
			$elm$html$Html$div,
			containerAttrs,
			$elm$core$List$singleton(
				A2($elm$html$Html$input, inputAttr, _List_Nil)));
	});
var $author$project$Csf$NodePager$view = function (model) {
	var elementType = model.gk;
	var totalPages = model.lp;
	var bttn_set_ = F3(
		function (action_, cursor_, icon_) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(action_),
						A2($elm$html$Html$Attributes$style, 'cursor', cursor_)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('zmdi ' + (icon_ + ' pl-2 pr-2'))
							]),
						_List_Nil)
					]));
		});
	var nextBttn = _Utils_eq(model.lp, model.af) ? A3(bttn_set_, $author$project$Csf$NodePager$NoAction, 'not-allowed', 'zmdi-chevron-right') : A3(bttn_set_, $author$project$Csf$NodePager$NextPage, 'pointer', 'zmdi-chevron-right');
	var prevBttn = (1 === model.af) ? A3(bttn_set_, $author$project$Csf$NodePager$NoAction, 'not-allowed', 'zmdi-chevron-left') : A3(bttn_set_, $author$project$Csf$NodePager$PrevPage, 'pointer', 'zmdi-chevron-left');
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pager__footer float-right')
			]),
		_List_fromArray(
			[
				A2(
				$rundis$elm_bootstrap$Bootstrap$Form$row,
				_List_fromArray(
					[
						$rundis$elm_bootstrap$Bootstrap$Grid$Row$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-0 mr-0')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rundis$elm_bootstrap$Bootstrap$Form$col,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Grid$Col$sm6,
								$rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-left')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Csf$NodePager$wrappedInputField,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$id('_perPage')
											]),
										1,
										model),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'padding', '3px 5px')
											]),
										_List_fromArray(
											[
												A3(
												$elm$core$Basics$composeR,
												$elm$core$Basics$append(elementType),
												$elm$html$Html$text,
												' por página')
											]))
									]))
							])),
						A2(
						$rundis$elm_bootstrap$Bootstrap$Form$col,
						_List_fromArray(
							[
								$rundis$elm_bootstrap$Bootstrap$Grid$Col$sm6,
								$rundis$elm_bootstrap$Bootstrap$Grid$Col$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-right')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pager__ul m-0')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[prevBttn])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Csf$NodePager$wrappedInputField,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$id('_actualPage')
													]),
												0,
												model)
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pr-2 pl-2'),
														A2($elm$html$Html$Attributes$style, 'font-size', '12px')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														' de ' + $elm$core$String$fromInt(totalPages))
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[nextBttn]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$ConsultarStock$view = function (model) {
	var session = model.g$;
	var loadedStock = model.eH;
	var nodePager = model.aF;
	var card_title = $author$project$Page$ConsultarStock$moduleMessage('card_title_loaded') + (' (' + ($elm$core$String$fromInt(loadedStock.lo) + ')'));
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(
			model.dw,
			$elm$core$Dict$isEmpty(model.kX),
			$elm$core$List$isEmpty(loadedStock.kh));
		_v1$3:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b) {
					if (_v1.c) {
						return _Utils_Tuple3(
							$author$project$Page$ConsultarStock$moduleMessage('filtered_empty'),
							$author$project$Page$ConsultarStock$NoOp,
							'');
					} else {
						break _v1$3;
					}
				} else {
					if (_v1.c) {
						return _Utils_Tuple3(
							$author$project$Page$ConsultarStock$moduleMessage('vehiculos_empty'),
							$author$project$Page$ConsultarStock$GoToCargarStock,
							'Cargar Vehículos');
					} else {
						break _v1$3;
					}
				}
			} else {
				return _Utils_Tuple3(
					$author$project$Page$ConsultarStock$moduleMessage('vehiculos_failed'),
					$author$project$Page$ConsultarStock$ReloadModule,
					'Intente Nuevamente');
			}
		}
		return _Utils_Tuple3('', $author$project$Page$ConsultarStock$NoOp, '');
	}();
	var box_message = _v0.a;
	var box_action = _v0.b;
	var box_button = _v0.c;
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$ConsultarStock$moduleMessage('head_loaded'))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('position-absolute f-14'),
								A2($elm$html$Html$Attributes$style, 'right', '35px'),
								$author$project$Route$href(
								$author$project$Route$HistorialDeCargas($author$project$Route$emptyData))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-2'),
										$elm$html$Html$Attributes$src(
										$author$project$Helpers$Utilities$imagesPath('/ic_hcargas_15px.svg'))
									]),
								_List_Nil),
								$elm$html$Html$text(
								$author$project$Page$ConsultarStock$moduleMessage('logging_loads'))
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										A2($elm$html$Html$Attributes$style, 'min-height', '400px')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Page$ConsultarStock$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										$author$project$Page$ConsultarStock$confirmModalView(model),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 csf-content-pkg card-body--no-padding f-12'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-8')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('f-14 m-0'),
																A2($elm$html$Html$Attributes$style, 'color', '#000')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(card_title)
															]))
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-4 text-uppercase text-right')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(
																A3($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not, loadedStock.kh))
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$ConsultarStock$GoToCargarStock)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Cargar vehículos')
																	])),
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$ConsultarStock$DoExportXLS),
																		$author$project$Csf$Form$loading(model.bZ)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Exportar XLS')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center'),
														$author$project$Csf$Form$show(
														(!nodePager.gR) || A3($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not, loadedStock.kh))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Page$ConsultarStock$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
																A2($elm$html$Html$Attributes$style, 'min-height', '400px')
															]),
														(!nodePager.gR) ? _List_fromArray(
															[$author$project$Csf$Core$loader]) : _List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Page$ConsultarStock$TableMsg,
																A2(
																	$author$project$Csf$Table$view,
																	$author$project$Page$ConsultarStock$tableConfig(model),
																	model.jb))
															])),
														A2(
														$elm$html$Html$map,
														$author$project$Page$ConsultarStock$NodePagerMsg,
														$author$project$Csf$NodePager$view(nodePager))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white pt-3 pb-3'),
														$author$project$Csf$Form$show(
														A3(
															$elm$core$Basics$composeR,
															$elm$core$List$isEmpty,
															$elm$core$Basics$and(nodePager.gR),
															loadedStock.kh))
													]),
												_List_fromArray(
													[
														(!_Utils_eq(
														box_message,
														$author$project$Page$ConsultarStock$moduleMessage('vehiculos_failed'))) ? A2(
														$elm$html$Html$map,
														$author$project$Page$ConsultarStock$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)) : $elm$html$Html$text(''),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('vertical-centered'),
																A2($elm$html$Html$Attributes$style, 'min-height', '320px')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('col-sm-12')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$img,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-3'),
																				$elm$html$Html$Attributes$src(
																				$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
																			]),
																		_List_Nil),
																		A2(
																		$elm$html$Html$h4,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
																				A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
																				A2($elm$html$Html$Attributes$style, 'font-size', '14px')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(box_message)
																			])),
																		(!_Utils_eq($author$project$Page$ConsultarStock$NoOp, box_action)) ? A2(
																		$author$project$Csf$Form$btn,
																		_List_fromArray(
																			[
																				$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																				$author$project$Csf$Form$onClick_(box_action)
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(box_button)
																			])) : $elm$html$Html$text('')
																	]))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Helpers$Utilities$coreLoader = function (loading_) {
	return loading_ ? $author$project$Csf$Core$loader : $elm$html$Html$text('');
};
var $author$project$Page$DashboardChie$moduleCaptions_ = _List_fromArray(
	[
		A2($elm$core$Tuple$pair, 'head_title', 'Panel de Reportes'),
		A2($elm$core$Tuple$pair, 'tab_histogram', 'Emisiones diarias'),
		A2($elm$core$Tuple$pair, 'tab_regions', 'Regiones'),
		A2($elm$core$Tuple$pair, 'tab_dealers', 'Emisiones por Distribuidor'),
		A2($elm$core$Tuple$pair, 'future_range', 'El rango de fechas sobrepasa la fecha actual.'),
		A2($elm$core$Tuple$pair, 'invalid_range', 'El rango de fechas seleccionado no es válido.'),
		A2($elm$core$Tuple$pair, 'emptydata_response', 'No existen datos para el rango de fechas seleccionado.'),
		A2($elm$core$Tuple$pair, 'gotdrawdata_failed', 'Ha ocurrido un error obteniendo los datos del reporte.')
	]);
var $author$project$Page$DashboardChie$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Helpers$Utilities$appMessage(key_),
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_),
			$author$project$Page$DashboardChie$moduleCaptions_));
};
var $author$project$Page$DashboardChie$SwitchTabItem = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$DashboardChie$navItem = F2(
	function (tab_key, isActive) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item'),
					A2($elm$html$Html$Attributes$style, 'width', 'auto')
				]),
			_List_fromArray(
				[
					function (anchor_attrs) {
					return A2(
						$elm$html$Html$a,
						anchor_attrs,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$DashboardChie$moduleMessage(tab_key))
							]));
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-link text-uppercase'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									isActive(tab_key))
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Page$DashboardChie$SwitchTabItem(tab_key)),
							A2($elm$html$Html$Attributes$style, 'color', 'inherit')
						]))
				]));
	});
var $author$project$Page$DashboardChie$view = function (model) {
	var session = model.g$;
	var activeTab = model.aL;
	var grayBoxMessage = model.ca;
	var grayBoxDiv_ = $author$project$Helpers$Utilities$trimmedEmpty(grayBoxMessage) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('vertical-centered text-center'),
				A2($elm$html$Html$Attributes$style, 'min-height', '320px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-3'),
								$elm$html$Html$Attributes$src(
								$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
							]),
						_List_Nil),
						function (attrs_) {
						return A2(
							$elm$html$Html$h4,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Page$DashboardChie$moduleMessage(grayBoxMessage))
								]));
					}(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
								A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							])),
						('gotdrawdata_failed' !== grayBoxMessage) ? $elm$html$Html$text('') : function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Intente Nuevamente')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
								$author$project$Csf$Form$onClick_(
								$author$project$Page$DashboardChie$FecthDataForDraw(activeTab))
							]))
					]))
			]));
	var googleChartDiv = F3(
		function (tabID, attrs_, children_) {
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Page$DashboardChie$toChartID(tabID)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'closed hidden',
									!$author$project$Helpers$Utilities$trimmedEmpty(grayBoxMessage))
								])),
							A2($elm$html$Html$Attributes$style, 'height', '520px'),
							A2($elm$html$Html$Attributes$style, 'width', '100%')
						]),
					attrs_),
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Helpers$Utilities$coreLoader(model.bT)
						]),
					children_));
		});
	var datePickerError_ = $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'datepicker-error',
				!$author$project$Helpers$Utilities$trimmedEmpty(model.an))
			]));
	var datePickerDiv = F3(
		function (heading_, attrs_, datePicker_) {
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 pl-2 pr-2'),
							A2($elm$html$Html$Attributes$style, 'max-height', '55px')
						]),
					attrs_),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('f-12')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(heading_)
							])),
						datePicker_
					]));
		});
	var dateRangePicker_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row m-0 vertical-centered')
			]),
		_List_fromArray(
			[
				A3(
				datePickerDiv,
				'Fecha de inicio',
				_List_fromArray(
					[datePickerError_]),
				A2(
					$elm$html$Html$map,
					$author$project$Page$DashboardChie$FechaIniPickerMsg,
					A3($author$project$DatePicker$view, model.aU, $author$project$Page$DashboardChie$fechaIniSettings, model.cO))),
				A3(
				datePickerDiv,
				'Fecha de fin',
				_List_fromArray(
					[datePickerError_]),
				A2(
					$elm$html$Html$map,
					$author$project$Page$DashboardChie$FechaFinPickerMsg,
					A3($author$project$DatePicker$view, model.aT, $author$project$Page$DashboardChie$fechaFinSettings, model.cN))),
				$author$project$Helpers$Utilities$trimmedEmpty(model.an) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm-4 position-relative'),
						A2($elm$html$Html$Attributes$style, 'top', '6px')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Helpers$Utilities$errorInfoStrip,
						true,
						_List_Nil,
						$author$project$Page$DashboardChie$moduleMessage(model.an))
					]))
			]));
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$DashboardChie$moduleMessage('head_title'))
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row'),
								A2($elm$html$Html$Attributes$style, 'display', 'flex')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12 bg-white')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('nav nav-tabs nav-fill')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Page$DashboardChie$navItem,
												'tab_histogram',
												$elm$core$Basics$eq(model.aL)),
												A2(
												$author$project$Page$DashboardChie$navItem,
												'tab_regions',
												$elm$core$Basics$eq(model.aL)),
												A2(
												$author$project$Page$DashboardChie$navItem,
												'tab_dealers',
												$elm$core$Basics$eq(model.aL))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('pt-3'),
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														A3(
														$elm$core$Basics$composeL,
														$author$project$Csf$Form$show,
														$elm$core$Basics$eq('tab_histogram'),
														activeTab)
													]),
												_List_fromArray(
													[
														dateRangePicker_,
														A3(googleChartDiv, 'tab_histogram', _List_Nil, _List_Nil),
														grayBoxDiv_
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('pt-3'),
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														A3(
														$elm$core$Basics$composeL,
														$author$project$Csf$Form$show,
														$elm$core$Basics$eq('tab_regions'),
														activeTab)
													]),
												_List_fromArray(
													[
														dateRangePicker_,
														A3(
														googleChartDiv,
														'tab_regions',
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('position-relative')
															]),
														_List_Nil),
														grayBoxDiv_
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('pt-3'),
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														A3(
														$elm$core$Basics$composeL,
														$author$project$Csf$Form$show,
														$elm$core$Basics$eq('tab_dealers'),
														activeTab)
													]),
												_List_fromArray(
													[
														dateRangePicker_,
														A3(googleChartDiv, 'tab_dealers', _List_Nil, _List_Nil),
														grayBoxDiv_
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$HistorialDeCargas$GoBackToStock = {$: 2};
var $author$project$Page$HistorialDeCargas$NoOp = {$: 0};
var $author$project$Page$HistorialDeCargas$CloseModal = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$HistorialDeCargas$DoNullifyLote = {$: 3};
var $author$project$Page$HistorialDeCargas$confirmModalView = function (model) {
	var confirmModal = model.cB;
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	var _v0 = model.bw ? A2($elm$core$Tuple$pair, $author$project$Page$HistorialDeCargas$NoOp, $author$project$Page$HistorialDeCargas$NoOp) : A2(
		$elm$core$Tuple$pair,
		$author$project$Page$HistorialDeCargas$DoNullifyLote,
		$author$project$Page$HistorialDeCargas$CloseModal(
			$author$project$Page$HistorialDeCargas$NullifyModal(
				_Utils_Tuple2('', ''))));
	var doAction = _v0.a;
	var cancelAction = _v0.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, confirmModal)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			confirmModal,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (bttnAttrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							bttnAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
								$author$project$Csf$Form$onClick_(cancelAction)
							])),
						function (bttnAttrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							bttnAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anular')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$loading(model.bw)
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3')
						]),
					_List_fromArray(
						[
							$author$project$Helpers$Utilities$trimmedEmpty(model.de) ? $elm$html$Html$text('') : A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							true,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1 pt-1 pb-1')
								]),
							model.de),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12 f-16 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$HistorialDeCargas$moduleMessage('confirm_nullify'))
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anulación de Carga')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									!model.bw,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Page$HistorialDeCargas$errorInfoModalView = function (model) {
	var errorInfoModal = model.cQ;
	var errorInfoMssg = model.cR;
	var modalCloseAction = $author$project$Page$HistorialDeCargas$CloseModal(
		$author$project$Page$HistorialDeCargas$ErrorInfoModal(''));
	var isAnError_ = A2($elm$core$String$contains, 'error', errorInfoMssg);
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	return (!_Utils_eq($author$project$Csf$Modal$shown, errorInfoModal)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__container')
			]),
		A3(
			$elm$core$Basics$composeR,
			$author$project$Csf$Modal$view(errorInfoModal),
			$elm$core$List$singleton,
			A3(
				$author$project$Csf$Modal$footer,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Aceptar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(modalCloseAction),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-2 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row p-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									isAnError_ ? _List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(
													$author$project$Helpers$Utilities$imagesPath('/ic_error_.svg'))
												]),
											_List_Nil)
										]) : _List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(
													$author$project$Helpers$Utilities$imagesPath('/ic_info_.svg'))
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row p-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('f-14')
												]),
											isAnError_ ? _List_fromArray(
												[
													$elm$html$Html$text('Error procesando datos de la carga')
												]) : _List_fromArray(
												[
													$elm$html$Html$text('Procesando datos de la carga')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row pl-5 pr-5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('f-12'),
													A2($elm$html$Html$Attributes$style, 'color', '#707070')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(errorInfoMssg)
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '420px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									true,
									$author$project$Csf$Modal$config(modalCloseAction)))))))));
};
var $author$project$Page$HistorialDeCargas$acciones_ = F2(
	function (ticket_, taskNode_) {
		var nullify_ = $elm$html$Html$Events$onClick(
			A2($author$project$Csf$Table$CustomEventMsg, 'anular_carga', taskNode_));
		var download_ = _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$Csf$Table$CustomEventMsg, 'download_carga', taskNode_))
			]);
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('f-16')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pl-1 pr-1 position-relative just-icon'),
							nullify_,
							A2($elm$html$Html$Attributes$style, 'color', '#7f7f7f'),
							A2($elm$html$Html$Attributes$attribute, 'title_', 'Anular carga')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('zmdi zmdi-delete'),
									A2($elm$html$Html$Attributes$style, 'padding', '0 5px')
								]),
							_List_Nil)
						])),
					function (attrs_) {
					return A2(
						$elm$html$Html$a,
						attrs_,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('zmdi zmdi-download'),
										A2($elm$html$Html$Attributes$style, 'padding', '0 5px')
									]),
								_List_Nil)
							]));
				}(
					_Utils_ap(
						download_,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1 pr-1 position-relative just-icon'),
								A2($elm$html$Html$Attributes$style, 'color', '#000'),
								A2($elm$html$Html$Attributes$attribute, 'title_', 'Descargar nómina')
							])))
				]));
	});
var $author$project$Config$AppStates$estadosLote = _List_fromArray(
	[
		_Utils_Tuple2('ANULADO', 'Anulada'),
		_Utils_Tuple2('APROBADO', 'Aprobada'),
		_Utils_Tuple2('RECHAZADO', 'Rechazada'),
		_Utils_Tuple2('REGISTRADO', 'Registrada'),
		_Utils_Tuple2('FINALIZADO', 'Finalizada')
	]);
var $author$project$Helpers$Utilities$estadoDelLote = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'Registrada',
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_))($author$project$Config$AppStates$estadosLote));
};
var $author$project$Page$HistorialDeCargas$fromTaskNode = F2(
	function (key_, taskNode_) {
		var numbers_data = _List_fromArray(
			['chie_emitidos', 'chie_anulados', 'chie_solicitados', 'cantidad_vehiculos', 'vehiculos_anulados']);
		switch (key_) {
			case 'fecha_ultima_emision_chie':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			case 'inserted_at':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			case 'estado_lote':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$estadoDelLote,
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			case 'id_lote':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			default:
				return A2($elm$core$List$member, key_, numbers_data) ? A3(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault('0'),
					$elm$core$Maybe$Just,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromInt,
						A2($author$project$Csf$TaskNodeUtils$mbint, key_, taskNode_))) : A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
		}
	});
var $author$project$Page$HistorialDeCargas$justtext = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(default_),
			$elm$html$Html$text,
			A2($author$project$Page$HistorialDeCargas$fromTaskNode, key_, taskNode_));
	});
var $author$project$Page$HistorialDeCargas$linkable = F2(
	function (key_, taskNode_) {
		var dataValue_ = function (meta_) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($author$project$Page$HistorialDeCargas$fromTaskNode, meta_, taskNode_));
		};
		var attributes_ = function () {
			if (key_ === 'id_lote') {
				return A2(
					$elm$core$List$member,
					dataValue_('estado_lote'),
					_List_fromArray(
						['Aprobada', 'Anulada', 'Finalizada'])) ? A3(
					$elm$core$Basics$composeR,
					$author$project$Route$href,
					$elm$core$List$singleton,
					function (query_) {
						return $author$project$Route$ConsultarStock(
							{iI: query_});
					}(
						A3(
							$author$project$Route$appendToQuery,
							'id_carga',
							dataValue_(key_),
							$author$project$Route$emptyData.iI))) : _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$Csf$Table$CustomEventMsg, 'show_infoModal', taskNode_))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href('')
					]);
			}
		}();
		return function (attrs_) {
			return A2(
				$elm$html$Html$a,
				attrs_,
				_List_fromArray(
					[
						$elm$html$Html$text(
						dataValue_(key_))
					]));
		}(
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table_linkable')
					]),
				attributes_));
	});
var $author$project$Page$HistorialDeCargas$textdate = F3(
	function (default_, _v0, taskNode_) {
		var key_ = _v0.a;
		var format_ = _v0.b;
		var zone_ = _v0.c;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(default_),
			$elm$html$Html$text,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Csf$DateFormat$formatIsoDate, format_, zone_),
					$elm$core$Maybe$withDefault('')),
				A2($author$project$Page$HistorialDeCargas$fromTaskNode, key_, taskNode_)));
	});
var $author$project$Page$HistorialDeCargas$tableConfig = function (_v0) {
	var zone = _v0.lG;
	var session = _v0.g$;
	var user_ = A2($author$project$Csf$TaskNodeUtils$string, '', 'creator');
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var doSortBy = function (_v1) {
		var key_ = _v1.a;
		var default_ = _v1.b;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$HistorialDeCargas$fromTaskNode(key_),
			$elm$core$Maybe$withDefault(default_));
	};
	return {
		f8: _List_fromArray(
			[
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$linkable('id_lote'),
					dc: 'ID Carga',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('id_lote', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: A2(
						$author$project$Page$HistorialDeCargas$textdate,
						'',
						_Utils_Tuple3('inserted_at', 'DD/MM/YYYY hh:mm A', zone)),
					dc: 'Fecha | Hora',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('inserted_at', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Just('180px')
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('creador_nombre', '')),
					dc: 'Usuario',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('creador_nombre', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('estado_lote', 'Registrada')),
					dc: 'Estado',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('estado_lote', 'Registrada')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('cantidad_vehiculos', '')),
					dc: 'Vehículos',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('cantidad_vehiculos', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('vehiculos_anulados', '')),
					dc: 'Vehículos anulados',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('vehiculos_anulados', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('chie_solicitados', '')),
					dc: 'CHI-e solicitados',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('chie_solicitados', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('chie_emitidos', '')),
					dc: 'CHI-e emitidos',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('chie_emitidos', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$justtext(
						_Utils_Tuple2('chie_anulados', '')),
					dc: 'CHI-e anulados',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('chie_anulados', '')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Nothing
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: A2(
						$author$project$Page$HistorialDeCargas$textdate,
						'-',
						_Utils_Tuple3('fecha_ultima_emision_chie', 'DD/MM/YYYY hh:mm:ss A', zone)),
					dc: 'Fecha última emisión',
					bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
						A2(
							$elm$core$Basics$composeL,
							doSortBy(
								_Utils_Tuple2('fecha_ultima_emision_chie', '-')),
							function ($) {
								return $.r;
							})),
					lz: $elm$core$Maybe$Just('180px')
				}),
				$author$project$Csf$Table$customColumn(
				{
					V: $author$project$Page$HistorialDeCargas$acciones_(ticket_),
					dc: 'Acciones',
					bD: $billstclair$elm_sortable_table$Table$unsortable,
					lz: $elm$core$Maybe$Just('100px')
				})
			]),
		hC: $elm$core$Maybe$Nothing,
		hD: $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stock_vh-table')
				])),
		hb: function ($) {
			return $.p;
		}
	};
};
var $author$project$Page$HistorialDeCargas$view = function (model) {
	var session = model.g$;
	var loadedHistory = model.bq;
	var nodePager = model.aF;
	var card_title = $author$project$Page$HistorialDeCargas$moduleMessage('card_title_loaded') + (' (' + ($elm$core$String$fromInt(loadedHistory.lo) + ')'));
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(
			model.cZ,
			$elm$core$Dict$isEmpty(model.kX),
			$elm$core$List$isEmpty(loadedHistory.kh));
		_v1$3:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b) {
					if (_v1.c) {
						return _Utils_Tuple3(
							$author$project$Page$HistorialDeCargas$moduleMessage('filtered_empty'),
							$author$project$Page$HistorialDeCargas$NoOp,
							'');
					} else {
						break _v1$3;
					}
				} else {
					if (_v1.c) {
						return _Utils_Tuple3(
							$author$project$Page$HistorialDeCargas$moduleMessage('history_empty'),
							$author$project$Page$HistorialDeCargas$NoOp,
							'');
					} else {
						break _v1$3;
					}
				}
			} else {
				return _Utils_Tuple3(
					$author$project$Page$HistorialDeCargas$moduleMessage('history_failed'),
					$author$project$Page$HistorialDeCargas$ReloadModule,
					'Intente Nuevamente');
			}
		}
		return _Utils_Tuple3('', $author$project$Page$HistorialDeCargas$NoOp, '');
	}();
	var box_message = _v0.a;
	var box_action = _v0.b;
	var box_button = _v0.c;
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$HistorialDeCargas$moduleMessage('head_loaded'))
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										A2($elm$html$Html$Attributes$style, 'min-height', '400px')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Page$HistorialDeCargas$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										$author$project$Page$HistorialDeCargas$confirmModalView(model),
										$author$project$Page$HistorialDeCargas$errorInfoModalView(model),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 csf-content-pkg card-body--no-padding f-12'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-8')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('f-14 m-0'),
																A2($elm$html$Html$Attributes$style, 'color', '#000')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(card_title)
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-4 text-uppercase text-right')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$btn,
														_List_fromArray(
															[
																$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary just-icon ml-2'),
																$author$project$Csf$Form$attr(
																A2($elm$html$Html$Attributes$attribute, 'title_', 'Cerrar historial')),
																A2($author$project$Csf$Form$style_, 'min-width', '25px'),
																$author$project$Csf$Form$onClick_($author$project$Page$HistorialDeCargas$GoBackToStock)
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$i,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('zmdi zmdi-close f-16')
																	]),
																_List_Nil)
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center'),
														$author$project$Csf$Form$show(
														(!nodePager.gR) || A3($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not, loadedHistory.kh))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
																A2($elm$html$Html$Attributes$style, 'min-height', '400px')
															]),
														(!nodePager.gR) ? _List_fromArray(
															[$author$project$Csf$Core$loader]) : _List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Page$HistorialDeCargas$TableMsg,
																A2(
																	$author$project$Csf$Table$view,
																	$author$project$Page$HistorialDeCargas$tableConfig(model),
																	model.jb))
															])),
														A2(
														$elm$html$Html$map,
														$author$project$Page$HistorialDeCargas$NodePagerMsg,
														$author$project$Csf$NodePager$view(nodePager))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center pt-3 pb-3 vertical-centered'),
														A2($author$project$Csf$Form$style_, 'min-height', '400px'),
														$author$project$Csf$Form$show(
														A3(
															$elm$core$Basics$composeR,
															$elm$core$List$isEmpty,
															$elm$core$Basics$and(nodePager.gR),
															loadedHistory.kh))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-sm-12')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-3'),
																		$elm$html$Html$Attributes$src(
																		$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$h4,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
																		A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
																		A2($elm$html$Html$Attributes$style, 'font-size', '14px')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(box_message)
																	])),
																(!_Utils_eq($author$project$Page$HistorialDeCargas$NoOp, box_action)) ? function (attrs_) {
																return A2(
																	$author$project$Csf$Form$btn,
																	attrs_,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(box_button)
																		]));
															}(
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_(box_action)
																	])) : $elm$html$Html$text('')
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Page$Maintenance$view = function (session) {
	var imgAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$src(
			$author$project$Helpers$Utilities$imagesPath('/working_man.gif')),
			A2($elm$html$Html$Attributes$style, 'height', '260px'),
			A2($elm$html$Html$Attributes$style, 'margin-top', '2.5rem'),
			A2($elm$html$Html$Attributes$style, 'margin-bottom', '1.5rem'),
			$elm$html$Html$Attributes$alt('Maintenance Mode')
		]);
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('content'),
				$elm$html$Html$Attributes$class('container text-center'),
				$elm$html$Html$Attributes$tabindex(-1)
			]),
		_List_fromArray(
			[
				A2($elm$html$Html$img, imgAttrs_, _List_Nil),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Helpers$Utilities$appMessage('maintenance_h2'))
					])),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Helpers$Utilities$appMessage('maintenance_h3'))
					]))
			]));
};
var $author$project$Page$NotFound$view = function (session) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('content'),
				$elm$html$Html$Attributes$class('container text-center'),
				$elm$html$Html$Attributes$tabindex(-1)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(
						$author$project$Helpers$Utilities$imagesPath('/page404.png')),
						A2($elm$html$Html$Attributes$style, 'height', '260px'),
						$elm$html$Html$Attributes$alt('Page Not Found')
					]),
				_List_Nil),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '-80px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Helpers$Utilities$appMessage('page_notfound'))
					]))
			]));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Csf$Form$fieldattr = function (attr_) {
	return $author$project$Csf$Form$FieldAttrs(
		_List_fromArray(
			[attr_]));
};
var $author$project$Csf$Form$getFieldAttrs = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'fieldattrs', params);
	if ((!_v0.$) && (_v0.a.$ === 6)) {
		var v = _v0.a.a;
		return v;
	} else {
		return _List_Nil;
	}
};
var $author$project$Csf$Form$getInputModel = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'inputmodel', params);
	if ((!_v0.$) && (_v0.a.$ === 12)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$inputField = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var fieldattrs_ = $author$project$Csf$Form$getFieldAttrs(params);
		var heading_ = $author$project$Csf$Form$getHeading(params);
		var maybeModel = $author$project$Csf$Form$getInputModel(params);
		var attrs1_ = function () {
			if (!maybeModel.$) {
				var model = maybeModel.a;
				return A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$value(model.lt),
					attrs_);
			} else {
				return attrs_;
			}
		}();
		var maybeValue = A2($elm$core$Maybe$map, $author$project$Csf$Form$strVal, maybeModel);
		var validationResult = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Csf$Form$NotFocusedValue,
			A2(
				$elm$core$Maybe$map,
				function (_v3) {
					var m = _v3;
					return m.aJ;
				},
				maybeModel));
		var isInvalid = function () {
			if (!validationResult.$) {
				return true;
			} else {
				return false;
			}
		}();
		var isValid = _Utils_eq(validationResult, $author$project$Csf$Form$ValidValue) && ((!_Utils_eq(
			maybeValue,
			$elm$core$Maybe$Just(''))) && (!_Utils_eq(maybeValue, $elm$core$Maybe$Nothing)));
		var content = _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('csf form-control input-sm '),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-valid', isValid),
									_Utils_Tuple2('is-invalid', isInvalid)
								]))
						]),
					attrs1_),
				_List_Nil)
			]);
		var content1 = function () {
			if (!validationResult.$) {
				var err = validationResult.a;
				return _Utils_ap(
					content,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('invalid-feedback')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(err)
								]))
						]));
			} else {
				return content;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('csf form-group position-relative')
					]),
				fieldattrs_),
			$elm$core$List$concat(
				_List_fromArray(
					[
						(heading_ !== '') ? _List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('f-12')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(heading_)
								]))
						]) : _List_Nil,
						content1,
						children
					])));
	});
var $author$project$Csf$Form$InputModel = function (a) {
	return {$: 12, a: a};
};
var $author$project$Csf$Form$inputModel = $author$project$Csf$Form$InputModel;
var $author$project$Helpers$Utilities$inputFormField = F6(
	function (required_, heading_, fieldAttr_, inputAttr_, inputModel_, children_) {
		var trimmedLabel = A3(
			$elm$core$String$replace,
			'*',
			'',
			$elm$core$String$trim(heading_));
		var formFieldAttr = A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append(
				A2($elm$core$List$map, $author$project$Csf$Form$attr, inputAttr_)),
			$elm$core$Basics$append(
				A2($elm$core$List$map, $author$project$Csf$Form$fieldattr, fieldAttr_)));
		var fieldLabel_ = A3(
			$elm$core$Basics$composeR,
			$elm$html$Html$label(_List_Nil),
			$elm$core$List$singleton,
			required_ ? _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('* ')
						])),
					$elm$html$Html$text(trimmedLabel)
				]) : _List_fromArray(
				[
					$elm$html$Html$text(trimmedLabel)
				]));
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$Basics$append(fieldLabel_),
			function (attrs_) {
				return A2($author$project$Csf$Form$inputField, attrs_, children_);
			}(
				formFieldAttr(
					_List_fromArray(
						[
							$author$project$Csf$Form$inputModel(inputModel_)
						]))));
	});
var $author$project$Config$ApiEndpoint$nodepreview = function (unique_id) {
	return A2(
		$author$project$Config$ApiEndpoint$url,
		_List_fromArray(
			['nodeservice', 'preview', unique_id]),
		_List_Nil);
};
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Helpers$Utilities$textareaFormField = F3(
	function (textAttrs_, heading_, strModel) {
		var labelHeading = $author$project$Helpers$Utilities$trimmedEmpty(heading_) ? _List_Nil : (A2(
			$elm$core$String$startsWith,
			'*',
			$elm$core$String$trim(heading_)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('* ')
							])),
						A3(
						$elm$core$Basics$composeL,
						$elm$html$Html$text,
						A2($elm$core$String$replace, '*', ''),
						$elm$core$String$trim(heading_))
					]))
			]) : (A2($elm$core$String$endsWith, '*', heading_) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						A3(
						$elm$core$Basics$composeL,
						$elm$html$Html$text,
						A2($elm$core$String$replace, '*', ''),
						$elm$core$String$trim(heading_)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' *')
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('f-12')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(heading_)
					]))
			])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf form-group position-relative m-0')
				]),
			_Utils_ap(
				labelHeading,
				_List_fromArray(
					[
						function (areaAttrs_) {
						return A2($elm$html$Html$textarea, areaAttrs_, _List_Nil);
					}(
						_Utils_ap(
							textAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chie-textarea form-control'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'is-invalid',
											!$author$project$Csf$Form$strIsValid(strModel))
										])),
									$elm$html$Html$Attributes$rows(3),
									$elm$html$Html$Attributes$value(
									$author$project$Csf$Form$strVal(strModel))
								]))),
						$author$project$Csf$Form$strIsValid(strModel) ? $elm$html$Html$text('') : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('invalid-feedback')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Campo requerido')
							]))
					])));
	});
var $author$project$Customized$DocumentNotFound$moduleCaptions_ = _List_fromArray(
	[
		_Utils_Tuple2('h4_font120px', '404'),
		_Utils_Tuple2('h4_font35px', 'Documento no encontrado'),
		_Utils_Tuple2('h4_font25px', 'Lo sentimos, el documento no existe o ha sido eliminado.')
	]);
var $author$project$Customized$DocumentNotFound$moduleMessage = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A3(
			$elm$core$Basics$composeR,
			$elm$core$Dict$fromList,
			$elm$core$Dict$get(key_),
			$author$project$Customized$DocumentNotFound$moduleCaptions_));
};
var $author$project$Customized$DocumentNotFound$view = function () {
	var divAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-center pt-5'),
			A2($elm$html$Html$Attributes$style, 'width', '100%'),
			A2($elm$html$Html$Attributes$style, 'min-height', '400px'),
			A2($elm$html$Html$Attributes$style, 'border', '1px solid #CCC'),
			A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular')
		]);
	return A2(
		$elm$html$Html$div,
		divAttrs_,
		_List_fromArray(
			[
				function (attrs_) {
				return A2(
					$elm$html$Html$h4,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Customized$DocumentNotFound$moduleMessage('h4_font120px'))
						]));
			}(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3'),
						A2($elm$html$Html$Attributes$style, 'color', '#0a568a'),
						A2($elm$html$Html$Attributes$style, 'font-size', '120px')
					])),
				function (attrs_) {
				return A2(
					$elm$html$Html$h4,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Customized$DocumentNotFound$moduleMessage('h4_font35px'))
						]));
			}(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3'),
						A2($elm$html$Html$Attributes$style, 'color', '#000'),
						A2($elm$html$Html$Attributes$style, 'font-size', '35px')
					])),
				function (attrs_) {
				return A2(
					$elm$html$Html$h4,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Customized$DocumentNotFound$moduleMessage('h4_font25px'))
						]));
			}(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-3'),
						A2($elm$html$Html$Attributes$style, 'color', '#000'),
						A2($elm$html$Html$Attributes$style, 'font-size', '25px')
					]))
			]));
}();
var $author$project$Page$RepositorioChie$documentPreviewer = F2(
	function (model, host) {
		var session = model.g$;
		var documentNde = model.bU;
		var documentLoaded = model.bh;
		var sectionHeight = $author$project$Helpers$Utilities$trimmedEmpty(documentNde.p) ? A2($elm$html$Html$Attributes$style, 'min-height', '400px') : A2($elm$html$Html$Attributes$style, 'height', 'auto');
		var isNullified = 'anulado_chie' === A3($author$project$Csf$TaskNodeUtils$string, '', 'estado_chie', documentNde);
		var tabTitle = isNullified ? 'Detalles de Anulación' : 'Detalles de Firma Electrónica Avanzada';
		var hasCause = 'Otro' === A3($author$project$Csf$TaskNodeUtils$string, '', 'motivo_anulacion', documentNde);
		var googlePreview = function (url) {
			return A3($elm$core$String$replace, 'local-', 'canary-', 'https://docs.google.com/viewer?embedded=true&url=https://' + (host + url));
		};
		var formField = F3(
			function (attrs_, key_, heading_) {
				return function (fieldMdel) {
					return A6(
						$author$project$Helpers$Utilities$inputFormField,
						false,
						heading_,
						attrs_,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$readonly(true)
							]),
						fieldMdel,
						_List_Nil);
				}(
					$author$project$Csf$Form$strFieldModel(
						function () {
							switch (key_) {
								case 'inserted_at':
									return A2(
										$elm$core$Maybe$withDefault,
										'',
										A3(
											$author$project$Csf$DateFormat$formatIsoDate,
											'DD/MM/YYYY | hh:mm A',
											model.lG,
											A3($author$project$Csf$TaskNodeUtils$string, '', key_, documentNde)));
								case 'fecha_firma_chie':
									return A2(
										$elm$core$Maybe$withDefault,
										'',
										A3(
											$author$project$Csf$DateFormat$formatIsoDate,
											'DD/MM/YYYY | hh:mm A',
											$elm$time$Time$utc,
											A3(
												$elm$core$String$replace,
												'.SSS',
												'',
												function (default_) {
													return A2(
														$elm$core$Maybe$withDefault,
														default_,
														A2($author$project$Csf$TaskNodeUtils$mbstring, key_, documentNde));
												}(
													A3($author$project$Csf$TaskNodeUtils$string, '', 'fecha_emision_chie', documentNde)))));
								case 'fecha_emision_chie':
									return A2(
										$elm$core$Maybe$withDefault,
										'',
										A3(
											$author$project$Csf$DateFormat$formatIsoDate,
											'DD/MM/YYYY | hh:mm A',
											$elm$time$Time$utc,
											A3(
												$elm$core$String$replace,
												'.SSS',
												'',
												A3($author$project$Csf$TaskNodeUtils$string, '', key_, documentNde))));
								case 'fecha_anulacion_chie':
									return A2(
										$elm$core$Maybe$withDefault,
										'',
										A3(
											$author$project$Csf$DateFormat$formatIsoDate,
											'DD/MM/YYYY | hh:mm A',
											model.lG,
											A3($author$project$Csf$TaskNodeUtils$string, '', key_, documentNde)));
								default:
									return A3($author$project$Csf$TaskNodeUtils$string, '', key_, documentNde);
							}
						}()));
			});
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white repochie_section'),
					sectionHeight
				]),
			_List_fromArray(
				[
					$author$project$Helpers$Utilities$processLoader(!documentLoaded),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col repochie_left')
								]),
							_List_fromArray(
								[
									A3($author$project$Helpers$Utilities$assetImage, _List_Nil, 'chie_logo', session.ka)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col repochie_right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(
											$author$project$Helpers$Utilities$imagesPath('/emision-chie_.png'))
										]),
									_List_Nil)
								]))
						])),
					(!documentLoaded) ? $elm$html$Html$text('') : ($author$project$Helpers$Utilities$trimmedEmpty(documentNde.p) ? $author$project$Customized$DocumentNotFound$view : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-7 text-center pr-0')
								]),
							_List_fromArray(
								[
									function (attrs_) {
									return A2($elm$html$Html$iframe, attrs_, _List_Nil);
								}(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pb-3'),
											A2($elm$html$Html$Attributes$style, 'border', 'none'),
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'height', '100%'),
											A2($elm$html$Html$Attributes$style, 'min-height', '100vh'),
											function () {
											var _v0 = A2(
												$elm$core$String$startsWith,
												'canary-',
												A3($elm$core$String$replace, 'local-', 'canary-', host));
											if (_v0) {
												return $elm$html$Html$Attributes$src(
													$author$project$Config$ApiEndpoint$nodepreview(documentNde.p));
											} else {
												return $elm$html$Html$Attributes$src(
													googlePreview(
														$author$project$Config$ApiEndpoint$nodepreview(documentNde.p)));
											}
										}()
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('nav nav-tabs nav-fill')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('nav-item'),
													A2($elm$html$Html$Attributes$style, 'width', 'auto')
												]),
											_List_fromArray(
												[
													function (anchor_attrs) {
													return A2(
														$elm$html$Html$a,
														anchor_attrs,
														_List_fromArray(
															[
																$elm$html$Html$text(tabTitle)
															]));
												}(
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('nav-link text-uppercase active'),
															A2($elm$html$Html$Attributes$style, 'color', 'inherit')
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('row pl-2 pr-2')
														]),
													isNullified ? _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'fecha_anulacion_chie',
																'Fecha de Anulación')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'anulado_por_nombre',
																'Nombre Anulador')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'anulado_por_usuario',
																'Usuario Anulador')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'motivo_anulacion',
																'Motivo de Anulación')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-12'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('hidden', !hasCause)
																		]))
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Helpers$Utilities$textareaFormField,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('mb-2'),
																			$elm$html$Html$Attributes$readonly(true)
																		]),
																	'Causa de Anulación',
																	$author$project$Csf$Form$strFieldModel(
																		A3($author$project$Csf$TaskNodeUtils$string, '', 'causa_anulacion', documentNde)))
																]))
														]) : _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'firmante_nombre',
																'Nombre Firmante')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'firmante_cargo',
																'Cargo Firmante')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'fecha_firma_chie',
																'Fecha/Hora Firma')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'codigo_firma',
																'Código Firma')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-6')
																]),
															A3(
																formField,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-2')
																	]),
																'empresa_certificadora_rut',
																'RUT Empresa Certificadora')),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('col-sm-12')
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Helpers$Utilities$textareaFormField,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('mb-2'),
																			$elm$html$Html$Attributes$readonly(true)
																		]),
																	'Empresa Certificadora',
																	$author$project$Csf$Form$strFieldModel(
																		A3($author$project$Csf$TaskNodeUtils$string, '', 'empresa_certificadora_nombre', documentNde)))
																]))
														]))
												]))
										]))
								]))
						])))
				]));
	});
var $author$project$Page$RepositorioChie$OnCodeBlured = {$: 3};
var $author$project$Page$RepositorioChie$OnCodeSubmited = {$: 4};
var $author$project$Page$RepositorioChie$OnCodeUpdated = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$Csf$Form$onBlur_ = A2($elm$core$Basics$composeL, $author$project$Csf$Form$HtmlAttr, $elm$html$Html$Events$onBlur);
var $author$project$Csf$Form$onInput_ = A2($elm$core$Basics$composeL, $author$project$Csf$Form$HtmlAttr, $elm$html$Html$Events$onInput);
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Csf$Form$readonly_ = A2($elm$core$Basics$composeL, $author$project$Csf$Form$HtmlAttr, $elm$html$Html$Attributes$readonly);
var $author$project$Page$RepositorioChie$documentVerifier = function (model) {
	var session = model.g$;
	var errorMssg = model.bW;
	var documentNde = model.bU;
	var documentLoaded = model.bh;
	var errorSpan = $elm$core$String$isEmpty(errorMssg) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('d-inline-block pt-4')
			]),
		_List_Nil) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert-error d-inline-block pr-2 pl-2 mb-1'),
				A2($elm$html$Html$Attributes$style, 'line-height', '23px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-1 zmdi zmdi-alert-triangle')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'relative'),
						A2($elm$html$Html$Attributes$style, 'top', '-1px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(errorMssg)
					]))
			]));
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('login'),
				$elm$html$Html$Events$onSubmit($author$project$Page$RepositorioChie$OnCodeSubmited)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content--boxed login__block active pt-5')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'height', '145px'),
								$elm$html$Html$Attributes$src(
								$author$project$Helpers$Utilities$imagesPath('/chie_bloque.png'))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pb-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('block__label')
									]),
								_List_fromArray(
									[
										errorSpan,
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('d-block c-black f-16')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Valide su documento')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('login__block__body text-left mt-2 pb-4')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Csf$Form$inputField,
								_List_fromArray(
									[
										$author$project$Csf$Form$class_('pl-1 pr-1'),
										$author$project$Csf$Form$inputModel(model.aA),
										$author$project$Csf$Form$onBlur_($author$project$Page$RepositorioChie$OnCodeBlured),
										$author$project$Csf$Form$onInput_($author$project$Page$RepositorioChie$OnCodeUpdated),
										$author$project$Csf$Form$readonly_(model.cp),
										$author$project$Csf$Form$fieldattr(
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '2rem')),
										$author$project$Csf$Form$attr(
										$elm$html$Html$Attributes$placeholder('* Código de verificación'))
									]),
								_List_Nil),
								A2(
								$author$project$Csf$Form$btn,
								_List_fromArray(
									[
										$author$project$Csf$Form$class_('bttn btn-primary text-uppercase login__block__btn btn-sm w-100 m-0'),
										$author$project$Csf$Form$loading(model.cp)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Validar')
									]))
							])),
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-4 pb-5 pt-4'),
								$elm$html$Html$Attributes$src(
								$author$project$Helpers$Utilities$imagesPath('/emision-chie_.png'))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$RepositorioChie$view = F2(
	function (model, host) {
		var documentNde = model.bU;
		var documentLoaded = model.bh;
		return ((!documentLoaded) && ('doc_verify' === documentNde.p)) ? $author$project$Page$RepositorioChie$documentVerifier(model) : A2($author$project$Page$RepositorioChie$documentPreviewer, model, host);
	});
var $author$project$Page$SolicitarChie$CancelarSolicitud = {$: 4};
var $author$project$Page$SolicitarChie$CerrarSolicitud = {$: 2};
var $author$project$Csf$Form$Value = function (a) {
	return {$: 25, a: a};
};
var $author$project$Csf$Form$bindTo = $author$project$Csf$Form$Value;
var $author$project$Csf$Form$Description = function (a) {
	return {$: 4, a: a};
};
var $author$project$Csf$Form$description = $author$project$Csf$Form$Description;
var $author$project$Page$SolicitarChie$CloseModal = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$SolicitarChie$errorInfoModalView = function (model) {
	var errorInfoModal = model.cQ;
	var errorInfoData = model.cP;
	var modalCloseAction = $author$project$Page$SolicitarChie$CloseModal(
		A2($author$project$Page$SolicitarChie$ErrorInfoModal, '', ''));
	var iconSource_ = A2(
		$elm$core$String$contains,
		'error',
		$author$project$Helpers$Utilities$trimmedToLower(errorInfoData.cV)) ? $author$project$Helpers$Utilities$imagesPath('/ic_error_.svg') : $author$project$Helpers$Utilities$imagesPath('/ic_check_ok_.svg');
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	return (!_Utils_eq($author$project$Csf$Modal$shown, errorInfoModal)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__container')
			]),
		A3(
			$elm$core$Basics$composeR,
			$author$project$Csf$Modal$view(errorInfoModal),
			$elm$core$List$singleton,
			A3(
				$author$project$Csf$Modal$footer,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Aceptar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(modalCloseAction),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-2 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row p-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(iconSource_)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row p-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('f-14')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(errorInfoData.cV)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row pl-5 pr-5'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'hidden',
											$author$project$Helpers$Utilities$trimmedEmpty(errorInfoData.bt))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('f-12'),
													A2($elm$html$Html$Attributes$style, 'color', '#707070')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(errorInfoData.bt)
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '420px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									true,
									$author$project$Csf$Modal$config(modalCloseAction)))))))));
};
var $author$project$Csf$Form$Heading = function (a) {
	return {$: 9, a: a};
};
var $author$project$Csf$Form$heading = $author$project$Csf$Form$Heading;
var $author$project$Page$SolicitarChie$requestSteps = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(1, 'document_upload'),
			_Utils_Tuple2(2, 'request_data'),
			_Utils_Tuple2(3, 'request_summary')
		]));
var $author$project$Page$SolicitarChie$stepName_ = function (index_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'document_upload',
		A2($elm$core$Dict$get, index_, $author$project$Page$SolicitarChie$requestSteps));
};
var $author$project$Csf$Form$value_ = $author$project$Csf$Form$Value;
var $author$project$Csf$Form$getChangeEvent = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'changeevent', params);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$getValue = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'value', params);
	if ((!_v0.$) && (_v0.a.$ === 25)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Csf$Form$getDescription = function (params) {
	var _v0 = A2($elm$core$Dict$get, 'description', params);
	if ((!_v0.$) && (_v0.a.$ === 4)) {
		var v = _v0.a.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Csf$Form$wizzardItemToHtml = F2(
	function (parentParams, _v0) {
		var elem_ = _v0;
		var index = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('index')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(parentParams.gv + 1))
					]))
			]);
		var _v1 = $author$project$Csf$Form$processConfigAttribute(elem_.D);
		var attrs_ = _v1.a;
		var params = _v1.b;
		var currentVal = $author$project$Csf$Form$getValue(params);
		var active_ = (!_Utils_eq(currentVal, $elm$core$Maybe$Nothing)) && _Utils_eq(parentParams.lt, currentVal);
		var activeClass = _List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('active', active_)
					]))
			]);
		var onClickEvt = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (event) {
					return _List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							event(
								A2($elm$core$Maybe$withDefault, '', currentVal)))
						]);
				},
				parentParams.cS));
		var description_ = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (desc) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(desc)
								]))
						]);
				},
				$author$project$Csf$Form$getDescription(params)));
		var fieldattrs_ = $author$project$Csf$Form$getFieldAttrs(params);
		var heading_ = $author$project$Csf$Form$getHeading(params);
		var headingContet = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(heading_)
					]))
			]);
		return A2(
			$elm$html$Html$li,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-item')
					]),
				_Utils_ap(
					activeClass,
					_Utils_ap(fieldattrs_, onClickEvt))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('nav-link')
							]),
						activeClass),
					_Utils_ap(
						index,
						_Utils_ap(headingContet, description_)))
				]));
	});
var $author$project$Csf$Form$wizzard = F2(
	function (attrs, children) {
		var _v0 = $author$project$Csf$Form$processConfigAttribute(attrs);
		var attrs_ = _v0.a;
		var params = _v0.b;
		var currentVal = $author$project$Csf$Form$getValue(params);
		var activeChildren = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					var elem_ = _v2;
					return elem_.J;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var elem_ = _v1;
							return function (val) {
								return _Utils_eq(val, currentVal) && (!_Utils_eq(val, $elm$core$Maybe$Nothing));
							}(
								$author$project$Csf$Form$getValue(
									$author$project$Csf$Form$processConfigAttribute(elem_.D).b));
						},
						children))));
		var onChangeEvt = $author$project$Csf$Form$getChangeEvent(params);
		var children_ = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, elem_) {
					return A2(
						$author$project$Csf$Form$wizzardItemToHtml,
						{cS: onChangeEvt, gv: index, lt: currentVal},
						elem_);
				}),
			children);
		var wizzardMenu = _List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav nav-pills nav-fill csf-wizzard')
					]),
				children_)
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(wizzardMenu, activeChildren));
	});
var $author$project$Csf$Form$WizzardItem = $elm$core$Basics$identity;
var $author$project$Csf$Form$wizzardItem = F2(
	function (attrs, children) {
		return {D: attrs, J: children};
	});
var $author$project$Page$SolicitarChie$ProcesarSolicitud = {$: 5};
var $author$project$Page$SolicitarChie$ClearDateTimePicker = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$SolicitarChie$CopyFromStock = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$SolicitarChie$OnSolicitudFocused = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$SolicitarChie$OnSolicitudKeyFreed = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Page$SolicitarChie$ShowPPUTooltip = function (a) {
	return {$: 8, a: a};
};
var $author$project$Helpers$Utilities$doCapitalize = function (string_) {
	var mapWord = function (word_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var hd = _v0.a;
					var tl = _v0.b;
					return _Utils_ap(
						A3($elm$core$Basics$composeR, $elm$core$String$fromChar, $elm$core$String$toUpper, hd),
						tl);
				},
				A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$uncons)(word_)));
	};
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$List$map(mapWord),
		$elm$core$String$join(' '),
		$elm$core$String$words(
			$author$project$Helpers$Utilities$trimmedToLower(string_)));
};
var $author$project$Customized$InputDropdown$MouseEntered = function (a) {
	return {$: 4, a: a};
};
var $author$project$Customized$InputDropdown$MouseLeaved = {$: 0};
var $author$project$Customized$InputDropdown$dropdown = F2(
	function (formFieldValue_, model) {
		var liTagItem_ = function (dataValue_) {
			return function (attrs_) {
				return A2(
					$elm$html$Html$li,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text(dataValue_)
						]));
			}(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('select2-results__option'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'select2-results__option--highlighted',
								_Utils_eq(dataValue_, model.cY))
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Customized$InputDropdown$ItemClicked(dataValue_)),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Customized$InputDropdown$MouseEntered(dataValue_)),
						$elm$html$Html$Events$onMouseLeave($author$project$Customized$InputDropdown$MouseLeaved),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-selected',
						(!_Utils_eq(formFieldValue_, dataValue_)) ? 'false' : 'true')
					]));
		};
		var containerAttrs_ = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-select2 select2-container select2-container--default select2-container--open position-absolute'),
				A2($elm$html$Html$Attributes$style, 'top', '25px'),
				A2($elm$html$Html$Attributes$style, 'left', '0px'),
				A2($elm$html$Html$Attributes$style, 'width', '100%')
			]);
		return A2(
			$elm$html$Html$div,
			containerAttrs_,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select2-dropdown select2-dropdown--below')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select2-results')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select2-results__options')
										]),
									function (dataFilterMap_) {
										return A2($elm$core$List$filterMap, dataFilterMap_, model.gh);
									}(
										function (value_) {
											return A2($elm$core$String$contains, formFieldValue_, value_) ? $elm$core$Maybe$Just(
												liTagItem_(value_)) : $elm$core$Maybe$Nothing;
										}))
								]))
						]))
				]));
	});
var $author$project$Helpers$Utilities$formatoVhPPU = function (tipoVehiculo_) {
	return function (n) {
		return A2($elm$core$String$repeat, n, 'A') + '.00';
	}(
		A2(
			$elm$core$Maybe$withDefault,
			4,
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$String$toInt,
				$author$project$Config$AppVehiculos$couldBeMoto(tipoVehiculo_))));
};
var $author$project$Helpers$Utilities$onKeyUp = function (tagger_) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, tagger_, $elm$html$Html$Events$keyCode));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePositionStyles = function (_v0) {
	var triggerEl = _v0.lq;
	var pickerEl = _v0.kU;
	var _v1 = _Utils_Tuple2(triggerEl.ju.lz, triggerEl.ju.cW);
	var viewPortWidth = _v1.a;
	var viewPortHeight = _v1.b;
	var _v2 = _Utils_Tuple2(triggerEl.gj.lA, triggerEl.gj.lD);
	var triggerX = _v2.a;
	var triggerY = _v2.b;
	var _v3 = _Utils_Tuple2(triggerEl.gj.lz, triggerEl.gj.cW);
	var triggerWidth = _v3.a;
	var triggerHeight = _v3.b;
	var _v4 = _Utils_Tuple2(pickerEl.gj.lz, pickerEl.gj.cW);
	var pickerWidth = _v4.a;
	var pickerHeight = _v4.b;
	var posY = (_Utils_cmp((triggerY + triggerHeight) + pickerHeight, viewPortHeight) > 0) ? ((triggerY + triggerHeight) - pickerHeight) : (triggerY + triggerHeight);
	var posX = (_Utils_cmp(triggerX + pickerWidth, viewPortWidth) > 0) ? ((triggerX + triggerWidth) - pickerWidth) : triggerX;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$elm$core$String$fromFloat(posX) + 'px'),
			A2(
			$elm$html$Html$Attributes$style,
			'top',
			$elm$core$String$fromFloat(posY) + 'px')
		]);
};
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix = 'elm-datetimepicker--';
var $mercurymedia$elm_datetime_picker$SingleDatePicker$NextMonth = {$: 0};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$NextYear = {$: 2};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$PrevMonth = {$: 1};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$PrevYear = {$: 3};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$Icon = $elm$core$Basics$identity;
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$defaultAttributes = function (name) {
	return {
		f7: $elm$core$Maybe$Just('feather feather-' + name),
		i_: 24,
		fA: '',
		g3: 2,
		hg: '0 0 24 24'
	};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder = F2(
	function (name, src) {
		return {
			D: $mercurymedia$elm_datetime_picker$DatePicker$Icons$defaultAttributes(name),
			c: src
		};
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronLeft = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('15 18 9 12 15 6')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronRight = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('9 18 15 12 9 6')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsLeft = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevrons-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('11 17 6 12 11 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('18 17 13 12 18 7')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsRight = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevrons-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('13 17 18 12 13 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('6 17 11 12 6 7')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml = F2(
	function (attributes, _v0) {
		var src = _v0.c;
		var attrs = _v0.D;
		var strSize = $elm$core$String$fromFloat(attrs.i_);
		var baseAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height(
				_Utils_ap(strSize, attrs.fA)),
				$elm$svg$Svg$Attributes$width(
				_Utils_ap(strSize, attrs.fA)),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(attrs.g3)),
				$elm$svg$Svg$Attributes$viewBox(attrs.hg)
			]);
		var combinedAttributes = _Utils_ap(
			function () {
				var _v1 = attrs.f7;
				if (!_v1.$) {
					var c = _v1.a;
					return A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$class(c),
						baseAttributes);
				} else {
					return baseAttributes;
				}
			}(),
			attributes);
		return A2(
			$elm$svg$Svg$svg,
			combinedAttributes,
			A2(
				$elm$core$List$map,
				$elm$svg$Svg$map($elm$core$Basics$never),
				src));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay = function (firstWeekDay) {
	switch (firstWeekDay) {
		case 0:
			return _List_fromArray(
				[0, 1, 2, 3, 4, 5, 6]);
		case 1:
			return _List_fromArray(
				[1, 2, 3, 4, 5, 6, 0]);
		case 2:
			return _List_fromArray(
				[2, 3, 4, 5, 6, 0, 1]);
		case 3:
			return _List_fromArray(
				[3, 4, 5, 6, 0, 1, 2]);
		case 4:
			return _List_fromArray(
				[4, 5, 6, 0, 1, 2, 3]);
		case 5:
			return _List_fromArray(
				[5, 6, 0, 1, 2, 3, 4]);
		default:
			return _List_fromArray(
				[6, 0, 1, 2, 3, 4, 5]);
	}
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewHeaderDay = F2(
	function (formatDay, day) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-day')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					formatDay(day))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewWeekHeader = function (settings) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-week')
			]),
		A2(
			$elm$core$List$cons,
			settings.fy ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-week-number')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('W')
					])) : $elm$html$Html$text(''),
			A2(
				$elm$core$List$map,
				$mercurymedia$elm_datetime_picker$SingleDatePicker$viewHeaderDay(settings.kc),
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay(settings.ek))));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize = F2(
	function (size, _v0) {
		var attrs = _v0.D;
		var src = _v0.c;
		return {
			D: _Utils_update(
				attrs,
				{i_: size}),
			c: src
		};
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewCalendarHeader = F3(
	function (settings, model, time) {
		var year = $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, settings.lG, time));
		var monthName = settings.kd(
			A2($elm$time$Time$toMonth, settings.lG, time));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-navigation')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('previous-year'),
											$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-chevron'),
											$elm$html$Html$Events$onClick(
											model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$PrevYear))
										]),
									_List_fromArray(
										[
											A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsLeft))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('previous-month'),
											$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-chevron'),
											$elm$html$Html$Events$onClick(
											model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$PrevMonth))
										]),
									_List_fromArray(
										[
											A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronLeft))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('month')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(monthName)
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('year')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(year)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-navigation')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('next-month'),
											$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-chevron'),
											$elm$html$Html$Events$onClick(
											model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$NextMonth))
										]),
									_List_fromArray(
										[
											A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronRight))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('next-year'),
											$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-header-chevron'),
											$elm$html$Html$Events$onClick(
											model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$NextYear))
										]),
									_List_fromArray(
										[
											A2(
											$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
											_List_Nil,
											A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronsRight))
										]))
								]))
						])),
					$mercurymedia$elm_datetime_picker$SingleDatePicker$viewWeekHeader(settings)
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$showHoveredIfEnabled = function (hovered) {
	return hovered.jY ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(hovered);
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$determineDateTime = F3(
	function (zone, selectionTuple, hoveredDay) {
		var hovered = A2($elm$core$Maybe$andThen, $mercurymedia$elm_datetime_picker$SingleDatePicker$showHoveredIfEnabled, hoveredDay);
		if (!hovered.$) {
			var h = hovered.a;
			return A3($mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$selectDay, zone, selectionTuple, h);
		} else {
			return selectionTuple;
		}
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$timeIsStartOfDay = F2(
	function (settings, time) {
		var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.lG, time);
		var hour = _v0.gr;
		var minute = _v0.gH;
		return (!hour) && (!minute);
	});
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$calendar = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'clock',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('3'),
					$elm$svg$Svg$Attributes$y('4'),
					$elm$svg$Svg$Attributes$width('18'),
					$elm$svg$Svg$Attributes$height('18'),
					$elm$svg$Svg$Attributes$rx('2'),
					$elm$svg$Svg$Attributes$ry('2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('16'),
					$elm$svg$Svg$Attributes$y1('2'),
					$elm$svg$Svg$Attributes$x2('16'),
					$elm$svg$Svg$Attributes$y2('6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('8'),
					$elm$svg$Svg$Attributes$y1('2'),
					$elm$svg$Svg$Attributes$x2('8'),
					$elm$svg$Svg$Attributes$y2('6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('3'),
					$elm$svg$Svg$Attributes$y1('10'),
					$elm$svg$Svg$Attributes$x2('21'),
					$elm$svg$Svg$Attributes$y2('10')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewDate = F2(
	function (settings, dateTime) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'selection-date')
				]),
			_List_fromArray(
				[
					A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
					_List_Nil,
					A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$calendar)),
					$elm$html$Html$text(
					A2(settings.jT, settings.lG, dateTime))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$ToggleTimePickerVisibility = {$: 7};
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$check = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'check',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('20 6 9 17 4 12')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'clock',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12 6 12 12 16 14')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$edit = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'edit',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z')
				]),
			_List_Nil)
		]));
var $mercurymedia$elm_datetime_picker$SingleDatePicker$SetHour = function (a) {
	return {$: 8, a: a};
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$SetMinute = function (a) {
	return {$: 9, a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute = F2(
	function (zone, _v0) {
		var pickerDay = _v0.a;
		var selection = _v0.b;
		var _v1 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.g1);
		var startBoundaryHour = _v1.a;
		var startBoundaryMinute = _v1.b;
		var _v2 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, selection);
		var selectedMinute = _v2.b;
		var earliestSelectableHour = (_Utils_cmp(selectedMinute, startBoundaryMinute) < 0) ? (startBoundaryHour + 1) : startBoundaryHour;
		var _v3 = A2($mercurymedia$elm_datetime_picker$DatePicker$Utilities$timeOfDayFromPosix, zone, pickerDay.hM);
		var endBoundaryHour = _v3.a;
		var endBoundaryMinute = _v3.b;
		var latestSelectableHour = (_Utils_cmp(selectedMinute, endBoundaryMinute) > 0) ? (endBoundaryHour - 1) : endBoundaryHour;
		return _Utils_Tuple2(earliestSelectableHour, latestSelectableHour);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$filterSelectableTimes = F3(
	function (zone, baseDay, selectionTuple) {
		if (!selectionTuple.$) {
			var _v1 = selectionTuple.a;
			var pickerDay = _v1.a;
			var selection = _v1.b;
			var _v2 = A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
				zone,
				_Utils_Tuple2(pickerDay, selection));
			var earliestSelectableMinute = _v2.a;
			var latestSelectableMinute = _v2.b;
			var _v3 = A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
				zone,
				_Utils_Tuple2(pickerDay, selection));
			var earliestSelectableHour = _v3.a;
			var latestSelectableHour = _v3.b;
			return {
				iV: A2($elm$core$List$range, earliestSelectableHour, latestSelectableHour),
				iW: A2($elm$core$List$range, earliestSelectableMinute, latestSelectableMinute)
			};
		} else {
			var _v4 = A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$minuteBoundsForSelectedHour,
				zone,
				_Utils_Tuple2(baseDay, baseDay.g1));
			var earliestSelectableMinute = _v4.a;
			var latestSelectableMinute = _v4.b;
			var _v5 = A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$hourBoundsForSelectedMinute,
				zone,
				_Utils_Tuple2(baseDay, baseDay.g1));
			var earliestSelectableHour = _v5.a;
			var latestSelectableHour = _v5.b;
			return {
				iV: A2($elm$core$List$range, earliestSelectableHour, latestSelectableHour),
				iW: A2($elm$core$List$range, earliestSelectableMinute, latestSelectableMinute)
			};
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero = function (value) {
	var string = $elm$core$String$fromInt(value);
	return ($elm$core$String$length(string) === 1) ? ('0' + string) : string;
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateHourOptions = F3(
	function (zone, selectionTuple, selectableHours) {
		var isSelected = function (h) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var selection = _v0.b;
						return _Utils_eq(
							A2($elm$time$Time$toHour, zone, selection),
							h);
					},
					selectionTuple));
		};
		return A2(
			$elm$core$List$map,
			function (hour) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(hour)),
							$elm$html$Html$Attributes$selected(
							isSelected(hour))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero(hour))
						]));
			},
			selectableHours);
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateMinuteOptions = F3(
	function (zone, selectionTuple, selectableMinutes) {
		var isSelected = function (m) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var selection = _v0.b;
						return _Utils_eq(
							A2($elm$time$Time$toMinute, zone, selection),
							m);
					},
					selectionTuple));
		};
		return A2(
			$elm$core$List$map,
			function (minute) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(minute)),
							$elm$html$Html$Attributes$selected(
							isSelected(minute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$mercurymedia$elm_datetime_picker$DatePicker$Utilities$addLeadingZero(minute))
						]));
			},
			selectableMinutes);
	});
var $elm_community$html_extra$Html$Events$Extra$customDecoder = F2(
	function (d, f) {
		var resultDecoder = function (x) {
			if (!x.$) {
				var a = x.a;
				return $elm$json$Json$Decode$succeed(a);
			} else {
				var e = x.a;
				return $elm$json$Json$Decode$fail(e);
			}
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			resultDecoder,
			A2($elm$json$Json$Decode$map, f, d));
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm_community$html_extra$Html$Events$Extra$maybeStringToResult = $elm$core$Result$fromMaybe('could not convert string');
var $elm_community$html_extra$Html$Events$Extra$targetValueIntParse = A2(
	$elm_community$html_extra$Html$Events$Extra$customDecoder,
	$elm$html$Html$Events$targetValue,
	A2($elm$core$Basics$composeR, $elm$core$String$toInt, $elm_community$html_extra$Html$Events$Extra$maybeStringToResult));
var $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronDown = A2(
	$mercurymedia$elm_datetime_picker$DatePicker$Icons$makeBuilder,
	'chevron-down',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('6 9 12 15 18 9')
				]),
			_List_Nil)
		]));
var $elm$html$Html$select = _VirtualDom_node('select');
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewSelect = F2(
	function (attributes, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'select')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$select, attributes, content),
					A2(
					$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
					_List_Nil,
					A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$chevronDown))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewTimePicker = F4(
	function (settings, model, baseDay, selectionTuple) {
		var _v0 = A3($mercurymedia$elm_datetime_picker$DatePicker$SingleUtilities$filterSelectableTimes, settings.lG, baseDay, selectionTuple);
		var selectableHours = _v0.iV;
		var selectableMinutes = _v0.iW;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'time-picker')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'select-container')
						]),
					_List_fromArray(
						[
							A2(
							$mercurymedia$elm_datetime_picker$SingleDatePicker$viewSelect,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('hour-select'),
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2(
										$elm$json$Json$Decode$map,
										model.K,
										A2($elm$json$Json$Decode$map, $mercurymedia$elm_datetime_picker$SingleDatePicker$SetHour, $elm_community$html_extra$Html$Events$Extra$targetValueIntParse)))
								]),
							A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateHourOptions, settings.lG, selectionTuple, selectableHours)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'select-spacer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(':')
								])),
							A2(
							$mercurymedia$elm_datetime_picker$SingleDatePicker$viewSelect,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('minute-select'),
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2(
										$elm$json$Json$Decode$map,
										model.K,
										A2($elm$json$Json$Decode$map, $mercurymedia$elm_datetime_picker$SingleDatePicker$SetMinute, $elm_community$html_extra$Html$Events$Extra$targetValueIntParse)))
								]),
							A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateMinuteOptions, settings.lG, selectionTuple, selectableMinutes))
						]))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewTimeOrTimePicker = F6(
	function (settings, timePickerVisible, baseDay, model, selection, timePickerSettings) {
		var displayTime = A3($mercurymedia$elm_datetime_picker$SingleDatePicker$determineDateTime, settings.lG, model.S, model.h3);
		var _v0 = settings.lm;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var _v1 = timePickerVisible ? _Utils_Tuple2(
					A4($mercurymedia$elm_datetime_picker$SingleDatePicker$viewTimePicker, settings, model, baseDay, displayTime),
					$mercurymedia$elm_datetime_picker$DatePicker$Icons$check) : _Utils_Tuple2(
					$elm$html$Html$text(
						A2(timePickerSettings.ln, settings.lG, selection)),
					$mercurymedia$elm_datetime_picker$DatePicker$Icons$edit);
				var viewToggleView = _v1.a;
				var toggleIcon = _v1.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'selection-time')
						]),
					_List_fromArray(
						[
							A2(
							$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
							_List_Nil,
							A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock)),
							viewToggleView,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'time-picker-toggle'),
									$elm$html$Html$Events$onClick(
									model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$ToggleTimePickerVisibility))
								]),
							_List_fromArray(
								[
									A2(
									$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
									_List_Nil,
									A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, toggleIcon))
								]))
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'selection-time')
						]),
					_List_fromArray(
						[
							A2(
							$mercurymedia$elm_datetime_picker$DatePicker$Icons$toHtml,
							_List_Nil,
							A2($mercurymedia$elm_datetime_picker$DatePicker$Icons$withSize, 16, $mercurymedia$elm_datetime_picker$DatePicker$Icons$clock)),
							A4($mercurymedia$elm_datetime_picker$SingleDatePicker$viewTimePicker, settings, model, baseDay, displayTime)
						]));
		}
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewDateTime = F6(
	function (settings, timePickerVisible, baseDay, model, selection, timePickerSettings) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'footer-datetime-container')
				]),
			_List_fromArray(
				[
					A2($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDate, settings, selection),
					A6($mercurymedia$elm_datetime_picker$SingleDatePicker$viewTimeOrTimePicker, settings, timePickerVisible, baseDay, model, selection, timePickerSettings)
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewDateOrDateTime = F5(
	function (settings, timePickerVisible, baseDay, model, selection) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDate, settings, selection),
			A2(
				$elm$core$Maybe$map,
				function (timePickerSettings) {
					return (_Utils_eq(settings.lm, $mercurymedia$elm_datetime_picker$SingleDatePicker$NeverVisible) && A2($mercurymedia$elm_datetime_picker$SingleDatePicker$timeIsStartOfDay, settings, selection)) ? A2($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDate, settings, selection) : A6($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDateTime, settings, timePickerVisible, baseDay, model, selection, timePickerSettings);
				},
				$mercurymedia$elm_datetime_picker$SingleDatePicker$getTimePickerSettings(settings)));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewEmpty = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'footer-empty')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('––.––.––––')
		]));
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewFooter = F4(
	function (settings, timePickerVisible, baseDay, model) {
		var displayTime = A3($mercurymedia$elm_datetime_picker$SingleDatePicker$determineDateTime, settings.lG, model.S, model.h3);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'footer')
				]),
			_List_fromArray(
				[
					function () {
					if (displayTime.$ === 1) {
						return $mercurymedia$elm_datetime_picker$SingleDatePicker$viewEmpty;
					} else {
						var _v1 = displayTime.a;
						var selection = _v1.b;
						return A5($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDateOrDateTime, settings, timePickerVisible, baseDay, model, selection);
					}
				}()
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$ClearHoveredDay = {$: 5};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad = F3(
	function (firstWeekDay, monthStartDay, isFrontPad) {
		var listOfWeekday = $mercurymedia$elm_datetime_picker$DatePicker$Utilities$generateListOfWeekDay(firstWeekDay);
		var calculatedPadInt = function () {
			var _v0 = A2($elm_community$list_extra$List$Extra$elemIndex, monthStartDay, listOfWeekday);
			if (!_v0.$) {
				var val = _v0.a;
				return isFrontPad ? (-val) : (7 - val);
			} else {
				return 0;
			}
		}();
		return calculatedPadInt;
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthDataToPickerDays = F4(
	function (zone, isDisabledFn, allowableTimesFn, posixList) {
		return A2(
			$elm$core$List$map,
			function (posix) {
				return A4($mercurymedia$elm_datetime_picker$DatePicker$Utilities$pickerDayFromPosix, zone, isDisabledFn, allowableTimesFn, posix);
			},
			posixList);
	});
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(
	function (interval, step, zone, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(current),
				$elm$time$Time$posixToMillis(until)) < 0) {
				var $temp$interval = interval,
					$temp$step = step,
					$temp$zone = zone,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
				interval = $temp$interval;
				step = $temp$step;
				zone = $temp$zone;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$range = F5(
	function (interval, step, zone, start, until) {
		return A6(
			$justinmimbs$time_extra$Time$Extra$rangeHelp,
			interval,
			A2($elm$core$Basics$max, 1, step),
			zone,
			until,
			_List_Nil,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$splitIntoWeeks = F2(
	function (weeks, days) {
		splitIntoWeeks:
		while (true) {
			if ($elm$core$List$length(days) <= 7) {
				return A2($elm$core$List$cons, days, weeks);
			} else {
				var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, 7, days);
				var week = _v0.a;
				var restOfDays = _v0.b;
				var newWeeks = A2($elm$core$List$cons, week, weeks);
				var $temp$weeks = newWeeks,
					$temp$days = restOfDays;
				weeks = $temp$weeks;
				days = $temp$days;
				continue splitIntoWeeks;
			}
		}
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthData = F5(
	function (zone, isDisabledFn, firstWeekDay, allowableTimesFn, time) {
		var monthStart = A3($justinmimbs$time_extra$Time$Extra$floor, 2, zone, time);
		var monthStartDay = A2($elm$time$Time$toWeekday, zone, monthStart);
		var monthEnd = A4(
			$justinmimbs$time_extra$Time$Extra$add,
			11,
			-1,
			zone,
			A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, zone, monthStart));
		var monthEndDay = A2($elm$time$Time$toWeekday, zone, monthEnd);
		var frontPad = A5(
			$justinmimbs$time_extra$Time$Extra$range,
			11,
			1,
			zone,
			A4(
				$justinmimbs$time_extra$Time$Extra$add,
				11,
				A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad, firstWeekDay, monthStartDay, true),
				zone,
				monthStart),
			monthStart);
		var endPad = A5(
			$justinmimbs$time_extra$Time$Extra$range,
			11,
			1,
			zone,
			monthEnd,
			A4(
				$justinmimbs$time_extra$Time$Extra$add,
				11,
				A3($mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePad, firstWeekDay, monthEndDay, false),
				zone,
				monthEnd));
		return $elm$core$List$reverse(
			A2(
				$mercurymedia$elm_datetime_picker$DatePicker$Utilities$splitIntoWeeks,
				_List_Nil,
				A4(
					$mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthDataToPickerDays,
					zone,
					isDisabledFn,
					allowableTimesFn,
					_Utils_ap(
						frontPad,
						_Utils_ap(
							A5($justinmimbs$time_extra$Time$Extra$range, 11, 1, zone, monthStart, monthEnd),
							endPad)))));
	});
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$SetDay = function (a) {
	return {$: 6, a: a};
};
var $mercurymedia$elm_datetime_picker$SingleDatePicker$SetHoveredDay = function (a) {
	return {$: 4, a: a};
};
var $mercurymedia$elm_datetime_picker$DatePicker$Styles$singleDayClasses = F5(
	function (classPrefix, isHidden, isDisabled, isPicked, isToday) {
		return isHidden ? (classPrefix + ('calendar-day ' + (classPrefix + 'hidden'))) : (isDisabled ? (classPrefix + ('calendar-day ' + (classPrefix + 'disabled'))) : (isPicked ? (classPrefix + ('calendar-day ' + (classPrefix + 'picked'))) : (isToday ? (classPrefix + ('calendar-day ' + (classPrefix + 'today'))) : (classPrefix + 'calendar-day'))));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewDay = F4(
	function (settings, model, currentMonth, day) {
		var isPicked = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var pickerDay = _v0.a;
					return _Utils_eq(pickerDay, day);
				},
				model.S));
		var isFocused = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (fday) {
					return _Utils_eq(
						A2($mercurymedia$elm_datetime_picker$SingleDatePicker$generatePickerDay, settings, fday),
						day);
				},
				settings.kb));
		var dayParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.lG, day.g1);
		var dayClasses = A5(
			$mercurymedia$elm_datetime_picker$DatePicker$Styles$singleDayClasses,
			$mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix,
			!_Utils_eq(dayParts.il, currentMonth),
			day.jY,
			isPicked,
			isFocused);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$disabled(day.jY),
					$elm$html$Html$Attributes$class(dayClasses),
					$elm$html$Html$Events$onClick(
					model.K(
						$mercurymedia$elm_datetime_picker$SingleDatePicker$SetDay(day))),
					$elm$html$Html$Events$onMouseOver(
					model.K(
						$mercurymedia$elm_datetime_picker$SingleDatePicker$SetHoveredDay(day)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(dayParts.hE))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewWeek = F4(
	function (settings, currentMonth, model, week) {
		var firstDateOfWeek = A2(
			$elm$core$Maybe$map,
			function (day) {
				return A2($justinmimbs$date$Date$fromPosix, settings.lG, day.g1);
			},
			$elm$core$List$head(week));
		var dateWeekNumber = function () {
			if (!firstDateOfWeek.$) {
				var date = firstDateOfWeek.a;
				return $elm$core$String$fromInt(
					$justinmimbs$date$Date$weekNumber(date));
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-week')
				]),
			A2(
				$elm$core$List$cons,
				settings.fy ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-week-number')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(dateWeekNumber)
						])) : $elm$html$Html$text(''),
				A2(
					$elm$core$List$map,
					A3($mercurymedia$elm_datetime_picker$SingleDatePicker$viewDay, settings, model, currentMonth),
					week)));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewMonth = F3(
	function (settings, model, viewTime) {
		var currentMonth = A2($justinmimbs$time_extra$Time$Extra$posixToParts, settings.lG, viewTime).il;
		var allowedTimesOfDayFn = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.dX;
			},
			$mercurymedia$elm_datetime_picker$SingleDatePicker$getTimePickerSettings(settings));
		var weeks = A5($mercurymedia$elm_datetime_picker$DatePicker$Utilities$monthData, settings.lG, settings.kr, settings.ek, allowedTimesOfDayFn, viewTime);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-month'),
					$elm$html$Html$Events$onMouseOut(
					model.K($mercurymedia$elm_datetime_picker$SingleDatePicker$ClearHoveredDay))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A3($mercurymedia$elm_datetime_picker$SingleDatePicker$viewWeek, settings, currentMonth, model),
						weeks))
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$viewPicker = F5(
	function (attributes, settings, timePickerVisible, baseDay, model) {
		var offsetTime = A4($justinmimbs$time_extra$Time$Extra$add, 2, model.U, settings.lG, baseDay.g1);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(settings.p),
						$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'picker-container'),
						$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'single')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($mercurymedia$elm_datetime_picker$SingleDatePicker$classPrefix + 'calendar-container')
						]),
					_List_fromArray(
						[
							A3($mercurymedia$elm_datetime_picker$SingleDatePicker$viewCalendarHeader, settings, model, offsetTime),
							A3($mercurymedia$elm_datetime_picker$SingleDatePicker$viewMonth, settings, model, offsetTime)
						])),
					A4($mercurymedia$elm_datetime_picker$SingleDatePicker$viewFooter, settings, timePickerVisible, baseDay, model)
				]));
	});
var $mercurymedia$elm_datetime_picker$SingleDatePicker$view = F2(
	function (settings, _v0) {
		var model = _v0;
		var _v1 = _Utils_Tuple2(model.bi, model.ay);
		_v1$2:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					var timePickerVisible = _v3.a;
					var baseDay = _v3.b;
					return A5($mercurymedia$elm_datetime_picker$SingleDatePicker$viewPicker, _List_Nil, settings, timePickerVisible, baseDay, model);
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.b.$ === 1) {
					var triggerDomElement = _v1.a.a.bH;
					var pickerDomElement = _v1.a.a.bz;
					var _v4 = _v1.b;
					var timePickerVisible = _v4.a;
					var baseDay = _v4.b;
					var attributes = function () {
						var _v5 = _Utils_Tuple2(triggerDomElement.gj, pickerDomElement.gj);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var triggerEl = _v5.a.a;
							var pickerEl = _v5.b.a;
							return $mercurymedia$elm_datetime_picker$DatePicker$Utilities$calculatePositionStyles(
								{kU: pickerEl, lq: triggerEl});
						} else {
							return _List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'visibility', 'hidden')
								]);
						}
					}();
					return A5($mercurymedia$elm_datetime_picker$SingleDatePicker$viewPicker, attributes, settings, timePickerVisible, baseDay, model);
				} else {
					break _v1$2;
				}
			}
		}
		return $elm$html$Html$text('');
	});
var $author$project$Page$SolicitarChie$solicitudFormView = function (model) {
	var vinDropdown = model.ad;
	var dealerDropdown = model.aP;
	var stockFormField = function (key_) {
		return A3($author$project$Page$SolicitarChie$getFormField, key_, '', model.aj);
	};
	var solicitudFormField = function (key_) {
		return A3($author$project$Page$SolicitarChie$getFormField, key_, '', model.l);
	};
	var tipoVehiculo_ = $author$project$Csf$Form$strVal(
		solicitudFormField('solicitud_tipo_vehiculo'));
	var tooltipView_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0 p-1'),
					A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Para ' + $author$project$Helpers$Utilities$doCapitalize(tipoVehiculo_))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0 p-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'El formato debe ser ' + $author$project$Helpers$Utilities$formatoVhPPU(tipoVehiculo_))
				]))
		]);
	var vinDropdown_ = (vinDropdown.bj && (!model.u)) ? $elm$core$List$singleton(
		A2(
			$elm$html$Html$map,
			$author$project$Page$SolicitarChie$InputDropdownMsg(0),
			function (vinValue_) {
				return A2($author$project$Customized$InputDropdown$dropdown, vinValue_, vinDropdown);
			}(
				A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)('solicitud_vin')))) : _List_Nil;
	var rightHeader_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-sm p-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('f-12_5')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Datos en Stock de Vehículos')
						]))
				]))
		]);
	var moduleDropdown__ = F5(
		function (attrs_, field_, disabled_, growOnOpen_, label_) {
			return A2(
				$elm$html$Html$map,
				$author$project$Page$SolicitarChie$DropdownMsg(field_),
				A5(
					$author$project$Customized$CustomDropdown$dropbox,
					attrs_,
					disabled_,
					growOnOpen_,
					label_,
					A2(
						$author$project$Helpers$Utilities$getDropdown,
						$author$project$Page$SolicitarChie$stringFromField(field_),
						model)));
		});
	var leftHeader_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-sm p-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('f-12_5')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Datos extraídos del Certificado')
						]))
				]))
		]);
	var keyFromStock = A2($elm$core$String$replace, 'instock_', 'solicitud_');
	var keyFromRequest = A2($elm$core$String$replace, 'solicitud_', 'instock_');
	var emailInvalid_ = A3(
		$elm$core$Basics$composeR,
		$author$project$Csf$Form$strIsValid,
		$elm$core$Basics$not,
		solicitudFormField('solicitud_email'));
	var dealerDropdown_ = (dealerDropdown.bj && (!model.u)) ? $elm$core$List$singleton(
		A2(
			$elm$html$Html$map,
			$author$project$Page$SolicitarChie$InputDropdownMsg(1),
			function (dealerValue_) {
				return A2($author$project$Customized$InputDropdown$dropdown, dealerValue_, dealerDropdown);
			}(
				A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)('solicitud_dealer')))) : _List_Nil;
	var dateTimePickerActionIcon = F2(
		function (key_, pickedDTime) {
			if (pickedDTime.$ === 1) {
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-calendar-note zmdi-hc-lg zmdi-custom-date p-0 m-0 fs-2-3rem zmdiCalendarNoteCustomDate'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Page$SolicitarChie$OpenDateTimePicker, key_, $elm$core$Maybe$Nothing))
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-close fs-2-1rem zmdi-clear-date p-0 m-0 zmdiCloseClearDate'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitarChie$ClearDateTimePicker(key_))
						]),
					_List_Nil);
			}
		});
	var dateTimePickerView_ = function (key_) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return _List_fromArray(
						[
							A2(dateTimePickerActionIcon, key_, dTPicker.a0),
							A2(
							$mercurymedia$elm_datetime_picker$SingleDatePicker$view,
							A2($author$project$Page$SolicitarChie$dateTimePickerSettings, key_, model),
							dTPicker.aw)
						]);
				},
				A2($elm$core$Dict$get, key_, model.E)));
	};
	var dateFormatByKey_ = function (key_) {
		return function (format_) {
			return A2($author$project$Csf$DateFormat$formatIsoDate, format_, $elm$time$Time$utc);
		}(
			(key_ === 'solicitud_documentos_fecha') ? 'DD/MM/YYYY' : 'DD/MM/YYYY | hh:mm A');
	};
	var dateTimePickerField_ = F4(
		function (attrs_, required_, formKey_, heading_) {
			return function (_v3) {
				var fieldModel_ = _v3.a;
				var divAttrs_ = _v3.b;
				var inputAttrs_ = _v3.c;
				return A6(
					$author$project$Helpers$Utilities$inputFormField,
					required_,
					heading_,
					divAttrs_,
					inputAttrs_,
					fieldModel_,
					dateTimePickerView_(formKey_ + '--dtpicker'));
			}(
				function (_v2) {
					var fieldModel_ = _v2.a;
					var divAttrs_ = _v2.b;
					return _Utils_Tuple3(
						fieldModel_,
						divAttrs_,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('non-opacity'),
								$elm$html$Html$Attributes$readonly(true),
								$elm$html$Html$Events$onFocus(
								A2($author$project$Page$SolicitarChie$OpenDateTimePicker, formKey_ + '--dtpicker', $elm$core$Maybe$Nothing))
							]));
				}(
					function (fieldModel_) {
						return A2(
							$elm$core$Tuple$pair,
							fieldModel_,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('csf-custom-datetimepicker')
									]),
								attrs_));
					}(
						A3(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(''),
							$author$project$Csf$Form$strFieldModel,
							A2(
								dateFormatByKey_,
								formKey_,
								$author$project$Csf$Form$strVal(
									solicitudFormField(formKey_)))))));
		});
	var correctCompare_ = A2($elm$core$Basics$composeR, $elm$core$String$trim, $author$project$Helpers$Utilities$correctTipoVehiculo_);
	var copyIcon_ = function (attributes_) {
		return _List_fromArray(
			[
				function (attrs_) {
				return A2($elm$html$Html$i, attrs_, _List_Nil);
			}(
				_Utils_ap(
					attributes_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-long-arrow-left f-16'),
							A2($elm$html$Html$Attributes$attribute, 'title_', 'Copiar valor'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'left', '-6px'),
							A2($elm$html$Html$Attributes$style, 'top', '26px')
						])))
			]);
	};
	var compareFields_ = F3(
		function (compare_, inStock_, fromRequest_) {
			return A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedEmpty, $elm$core$Basics$not)(inStock_) && A2(
				compare_,
				correctCompare_(inStock_),
				correctCompare_(fromRequest_));
		});
	var fieldsAreEquals_ = function (instock_key) {
		return A3(
			compareFields_,
			$elm$core$Basics$eq,
			$author$project$Csf$Form$strVal(
				stockFormField(instock_key)),
			A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)(
				keyFromStock(instock_key)));
	};
	var fieldsNotEquals_ = function (instock_key) {
		return A3(
			compareFields_,
			$elm$core$Basics$neq,
			$author$project$Csf$Form$strVal(
				stockFormField(instock_key)),
			A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)(
				keyFromStock(instock_key)));
	};
	var mb3ClassCondition_ = function (key_) {
		return A2($elm$core$Basics$composeR, fieldsNotEquals_, $elm$core$Basics$not)(
			keyFromRequest(key_)) && (!((key_ === 'solicitud_ppu') && (model.ar && (!emailInvalid_))));
	};
	var mb4ClassCondition_ = function (key_) {
		return fieldsNotEquals_(
			keyFromRequest(key_)) || ((key_ === 'solicitud_ppu') && (model.ar && (!emailInvalid_)));
	};
	var showCopyIcon_ = function (key_) {
		return fieldsNotEquals_(key_) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Page$SolicitarChie$CopyFromStock(key_))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('closed hidden')
			]);
	};
	var stockFromField_ = F2(
		function (key_, heading_) {
			return _Utils_ap(
				copyIcon_(
					showCopyIcon_(key_)),
				A6(
					$author$project$Helpers$Utilities$inputFormField,
					false,
					heading_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$readonly(true)
						]),
					stockFormField(key_),
					_List_Nil));
		});
	var successWarnAttrs_ = F2(
		function (allowMb4, key_) {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mb-3',
							mb3ClassCondition_(key_))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mb-4',
							allowMb4 && mb4ClassCondition_(key_))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'warning-border',
							fieldsNotEquals_(
								keyFromRequest(key_)))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'success-border',
							fieldsAreEquals_(
								keyFromRequest(key_)))
						]))
				]);
		});
	var vhTypeAttrs_ = function (allow) {
		return A2(successWarnAttrs_, allow, 'solicitud_tipo_vehiculo');
	}(
		$author$project$Customized$CustomDropdown$isValidDropbox(
			function (k) {
				return A2($author$project$Helpers$Utilities$getDropdown, k, model);
			}(
				$author$project$Page$SolicitarChie$stringFromField(2))));
	var successWarnIcon_ = F2(
		function (noIcon, key_) {
			return fieldsNotEquals_(
				keyFromRequest(key_)) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-alert-triangle zmdi-hc-fw'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden closed', noIcon)
								])),
							A2($elm$html$Html$Attributes$style, 'color', '#FFA136'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						])),
					A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strIsValid)(key_) ? function (attrs_) {
					return A2(
						$elm$html$Html$span,
						attrs_,
						_List_fromArray(
							[
								$elm$html$Html$text('No coincide con el valor en Stock')
							]));
				}(
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('position-absolute'),
								A2($elm$html$Html$Attributes$style, 'left', '20px'),
								A2($elm$html$Html$Attributes$style, 'font-size', '80%')
							]),
						noIcon ? _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'bottom', '2.5px')
							]) : _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'bottom', '5px')
							]))) : $elm$html$Html$text('')
				]) : (fieldsAreEquals_(
				keyFromRequest(key_)) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-check zmdi-hc-fw'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden closed', noIcon)
								])),
							A2($elm$html$Html$Attributes$style, 'color', '#00BA83'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						]))
				]) : (((key_ === 'solicitud_ppu') && model.ar) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-alert-circle zmdi-hc-fw'),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$Page$SolicitarChie$ShowPPUTooltip(true)),
							$elm$html$Html$Events$onMouseLeave(
							$author$project$Page$SolicitarChie$ShowPPUTooltip(false)),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'color', '#FF3636'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						])),
					function (attrs_) {
					return A2(
						$elm$html$Html$span,
						attrs_,
						_List_fromArray(
							[
								$elm$html$Html$text('El formato de la patente no es válido')
							]));
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute'),
							A2($elm$html$Html$Attributes$style, 'color', '#ff6b68'),
							A2($elm$html$Html$Attributes$style, 'font-size', '80%'),
							A2($elm$html$Html$Attributes$style, 'left', '20px'),
							A2($elm$html$Html$Attributes$style, 'top', '48px')
						])),
					model.fz ? function (attrs_) {
					return A2($elm$html$Html$div, attrs_, tooltipView_);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute vh_error__tooltip mb-0'),
							A2($elm$html$Html$Attributes$style, 'left', '95%'),
							A2($elm$html$Html$Attributes$style, 'top', '-12px')
						])) : $elm$html$Html$text('')
				]) : _List_Nil));
		});
	var customFormField_ = F5(
		function (attrs_, required_, key_, heading_, children_) {
			return function (input_) {
				return _Utils_ap(
					input_,
					A2(successWarnIcon_, false, key_));
			}(
				function (_v1) {
					var outAttrs_ = _v1.a;
					var innerAttrs_ = _v1.b;
					return A6(
						$author$project$Helpers$Utilities$inputFormField,
						required_,
						heading_,
						outAttrs_,
						innerAttrs_,
						solicitudFormField(key_),
						children_);
				}(
					function (outAttrs_) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_ap(attrs_, outAttrs_),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$readonly(model.u),
									$elm$html$Html$Events$onFocus(
									$author$project$Page$SolicitarChie$OnSolicitudFocused(key_)),
									$author$project$Helpers$Utilities$onKeyUp(
									$author$project$Page$SolicitarChie$OnSolicitudKeyFreed(key_))
								]));
					}(
						_Utils_ap(
							A2(successWarnAttrs_, true, key_),
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									$author$project$Page$SolicitarChie$OnSolicitudUpdated(key_)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('error-border', (key_ === 'solicitud_ppu') && model.ar)
										]))
								])))));
		});
	var inputFormField_ = F4(
		function (attrs_, required_, key_, heading_) {
			return function (input_) {
				return _Utils_ap(
					input_,
					A2(successWarnIcon_, false, key_));
			}(
				function (_v0) {
					var fieldAttrs_ = _v0.a;
					var inputAttrs_ = _v0.b;
					return A6(
						$author$project$Helpers$Utilities$inputFormField,
						required_,
						heading_,
						fieldAttrs_,
						inputAttrs_,
						solicitudFormField(key_),
						_List_Nil);
				}(
					function (attrs__) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_ap(attrs_, attrs__),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$readonly(model.u)
								]));
					}(
						_Utils_ap(
							A2(successWarnAttrs_, true, key_),
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									$author$project$Page$SolicitarChie$OnSolicitudUpdated(key_)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('error-border', (key_ === 'solicitud_ppu') && model.ar)
										]))
								])))));
		});
	var moduleDropdown_ = F4(
		function (field_, disabled_, growOnOpen_, label_) {
			return (field_ === 2) ? _Utils_ap(
				_List_fromArray(
					[
						A5(moduleDropdown__, vhTypeAttrs_, field_, disabled_, growOnOpen_, label_)
					]),
				A2(successWarnIcon_, true, 'solicitud_tipo_vehiculo')) : _List_fromArray(
				[
					A5(moduleDropdown__, _List_Nil, field_, disabled_, growOnOpen_, label_)
				]);
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-uppercase f-14')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Vehículo')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						leftHeader_),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						rightHeader_)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A5(
							customFormField_,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(vinDropdown.cF)
								]),
							true,
							'solicitud_vin',
							'VIN',
							vinDropdown_)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_vin', 'VIN'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_cit', 'C.I.T')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_cit', 'C.I.T'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_marca', 'Marca')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_marca', 'Marca'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_modelo', 'Modelo')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_modelo', 'Modelo'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(moduleDropdown_, 2, model.u, false, '* Tipo de Vehículo')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_tipo_vehiculo', 'Tipo de Vehículo'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_nro_motor', 'Nro Motor')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_nro_motor', 'Nro Motor'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_color', 'Color')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_color', 'Color'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_anno', 'Año')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_anno', 'Año'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_peso', 'Peso')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A2(stockFromField_, 'instock_peso', 'Peso'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pt-3'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-uppercase f-14')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('1ra Inscripción')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A5(
							customFormField_,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(dealerDropdown.cF)
								]),
							true,
							'solicitud_dealer',
							'Distribuidor',
							dealerDropdown_)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_dealer_rut', 'Rut Distribuidor')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_ppu', 'Patente')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_documentos_numero', 'Número Factura')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_adquiriente_nombre', 'Nombre Propietario')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_adquiriente_rut', 'Rut Propietario')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, true, 'solicitud_email', 'Email Propietario')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_adquiriente_comuna', 'Comuna Propietario')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-12')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_adquiriente_domicilio', 'Dirección Propietario')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(dateTimePickerField_, _List_Nil, false, 'solicitud_fecha_solicitud', 'Fecha/Hora Solicitud')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(
							dateTimePickerField_,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hide--footer')
								]),
							false,
							'solicitud_documentos_fecha',
							'Fecha Documento')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_adquiriente_correo', 'Email Inscripción')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_documentos_tipo', 'Tipo Documento')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_documentos_naturaleza', 'Naturaleza Documento')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-6')
							]),
						A4(inputFormField_, _List_Nil, false, 'solicitud_documentos_lugar', 'Lugar Documento'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pt-3'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-uppercase f-14')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Importador')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-7')
							]),
						A4(moduleDropdown_, 1, model.u || model.bB, false, '* Importador'))
					]))
			]));
};
var $author$project$Helpers$Utilities$warningInfoStrip = $author$project$Helpers$Utilities$informationStrip('warning');
var $author$project$Page$SolicitarChie$wizzardRequestItem_ = function (model) {
	var certificado = model.X;
	var previewer_ = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Config$ApiEndpoint$nodepreview,
			$author$project$Helpers$Utilities$stringToMaybe(certificado.p)));
	var infoStrip_ = A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedEmpty, $elm$core$Basics$not)(model.cr) ? A3(
		$author$project$Helpers$Utilities$warningInfoStrip,
		true,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-1 pb-1 mb-3')
			]),
		model.cr) : $elm$html$Html$text('');
	var hideOnLoading = $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('closed hidden', model.c6)
			]));
	var separatorDivRow_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row m-0 mt-2 mb-2'),
				A2($elm$html$Html$Attributes$style, 'height', '0.8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 15px'),
				hideOnLoading
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm p-0'),
						A2($elm$html$Html$Attributes$style, 'background-color', '#CCCCCC')
					]),
				_List_Nil)
			]));
	var formAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$id('solicitar_chie-form'),
			$elm$html$Html$Attributes$class('col-sm-5'),
			A2($elm$html$Html$Attributes$style, 'max-height', '725px'),
			A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
			A2($elm$html$Html$Attributes$style, 'overflow-x', 'hidden'),
			A2($elm$html$Html$Attributes$style, 'padding-right', '10px')
		]);
	var containerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('bg-white pt-2 pb-4'),
			A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
			A2($elm$html$Html$Attributes$style, 'padding-right', '25px')
		]);
	return A3(
		$elm$core$Basics$composeR,
		$elm$html$Html$div(containerAttrs_),
		$elm$core$List$singleton,
		A3(
			$elm$core$Basics$composeR,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-3'),
						A2($elm$html$Html$Attributes$style, 'border', '1px solid #CCCCCC'),
						A2($elm$html$Html$Attributes$style, 'min-height', '400px')
					])),
			$elm$core$List$singleton,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 p-2 pl-3'),
							hideOnLoading
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm p-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'font', 'normal normal bold 18px/22px Roboto')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Datos de la Solicitud')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 pl-3 pb-4'),
							hideOnLoading
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-7 text-center p-0')
								]),
							_List_fromArray(
								[
									function (attrs_) {
									return A2($elm$html$Html$iframe, attrs_, _List_Nil);
								}(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(previewer_),
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'height', '100%'),
											A2($elm$html$Html$Attributes$style, 'border', 'none'),
											A2($elm$html$Html$Attributes$style, 'min-height', '100vh')
										]))
								])),
							A2(
							$elm$html$Html$div,
							formAttrs_,
							_List_fromArray(
								[
									infoStrip_,
									$author$project$Page$SolicitarChie$solicitudFormView(model)
								]))
						])),
					separatorDivRow_,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 p-3'),
							hideOnLoading
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm p-0 text-right')
								]),
							_List_fromArray(
								[
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Cancelar')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_($author$project$Page$SolicitarChie$CancelarSolicitud),
											$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										])),
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Anterior')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_($author$project$Page$SolicitarChie$CerrarSolicitud),
											$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										])),
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Siguiente')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_($author$project$Page$SolicitarChie$ProcesarSolicitud),
											$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										]))
								]))
						]))
				])));
};
var $author$project$Page$SolicitarChie$CrearTheSolicitud = {$: 6};
var $author$project$Page$SolicitarChie$DownloadInscription = function (a) {
	return {$: 18, a: a};
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Page$SolicitarChie$wizzardSummaryItem_ = function (model) {
	var queryData = model.kX;
	var certificado = model.X;
	var separatorDivRow_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row m-0 mt-1 mb-1'),
				A2($elm$html$Html$Attributes$style, 'height', '0.8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 15px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm p-0'),
						A2($elm$html$Html$Attributes$style, 'background-color', '#CCCCCC')
					]),
				_List_Nil)
			]));
	var previewer_ = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Config$ApiEndpoint$nodepreview,
			$author$project$Helpers$Utilities$stringToMaybe(certificado.p)));
	var innerRow_ = function (attrs_) {
		return $elm$html$Html$div(
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row m-0 pt-1 pb-1')
					]),
				attrs_));
	};
	var inscriptionRow = F2(
		function (_v1, bodyRows_) {
			var heading_ = _v1.a;
			var value_ = _v1.b;
			return $author$project$Helpers$Utilities$trimmedEmpty(value_) ? bodyRows_ : A2(
				$elm$core$List$append,
				bodyRows_,
				_List_fromArray(
					[
						A2(
						innerRow_,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(heading_)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-8')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(value_)
									]))
							]))
					]));
		});
	var iconItem_ = function (icon_) {
		return A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('zmdi ' + (icon_ + ' f-16'))
				]),
			_List_Nil);
	};
	var formatDate_ = function (format_) {
		return A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(''),
			A2($author$project$Csf$DateFormat$formatIsoDate, format_, $elm$time$Time$utc));
	};
	var formValue_ = function (key_) {
		return A3($author$project$Page$SolicitarChie$formFieldValue, key_, '', model.l);
	};
	var tipoVehiculo_ = $author$project$Helpers$Utilities$correctTipoVehiculo_(
		formValue_('solicitud_tipo_vehiculo'));
	var vehiculoPPU_ = A2(
		$author$project$Helpers$Utilities$correctVehiclePPU_,
		tipoVehiculo_,
		formValue_('solicitud_ppu'));
	var documentName_ = 'inscripcion.' + A3(
		$elm$core$String$replace,
		'image',
		'jpg',
		A3(
			$elm$core$Basics$composeR,
			$author$project$Helpers$Utilities$stringToMaybe,
			$elm$core$Maybe$withDefault('pdf'),
			A2($author$project$Route$dataFromQuery, 'format', queryData)));
	var dealerFormattedRut_ = A2($elm$core$Basics$composeR, formValue_, $author$project$Helpers$Utilities$formatRut)('solicitud_dealer_rut');
	var containerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('bg-white pt-2 pb-4'),
			A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
			A2($elm$html$Html$Attributes$style, 'padding-right', '25px')
		]);
	var clienteFormattedRut_ = A2($elm$core$Basics$composeR, formValue_, $author$project$Helpers$Utilities$formatRut)('solicitud_adquiriente_rut');
	var _v0 = model.u ? _Utils_Tuple3($author$project$Page$SolicitarChie$NoOp, $author$project$Page$SolicitarChie$NoOp, $author$project$Page$SolicitarChie$NoOp) : _Utils_Tuple3(
		$author$project$Page$SolicitarChie$CancelarSolicitud,
		$author$project$Page$SolicitarChie$ChangeActualStep(2),
		$author$project$Page$SolicitarChie$CrearTheSolicitud);
	var cancelAction = _v0.a;
	var previousAction = _v0.b;
	var requestAction = _v0.c;
	return A3(
		$elm$core$Basics$composeR,
		$elm$html$Html$div(containerAttrs_),
		$elm$core$List$singleton,
		A3(
			$elm$core$Basics$composeR,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-3'),
						A2($elm$html$Html$Attributes$style, 'border', '1px solid #CCCCCC')
					])),
			$elm$core$List$singleton,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 p-2 pl-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm p-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'font', 'normal normal bold 18px/22px Roboto')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Resumen')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 pl-3 pr-3 pb-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-8 pl-0 pr-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'background-color', '#F8F8F8'),
											A2($elm$html$Html$Attributes$style, 'min-height', '240px')
										]),
									_List_fromArray(
										[
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h4,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('m-0 f-14')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Vehículo')
																]))
														]))
												])),
											separatorDivRow_,
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Tipo Vehículo')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(tipoVehiculo_)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('VIN')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_vin'))
														]))
												])),
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Marca')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_marca'))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('N° Motor')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_nro_motor'))
														]))
												])),
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Color')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_color'))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Modelo')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_modelo'))
														]))
												])),
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Año')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_anno'))
														]))
												])),
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Peso')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															formValue_('solicitud_peso'))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-4 pr-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'background-color', '#F8F8F8')
										]),
									A2(
										inscriptionRow,
										_Utils_Tuple2(
											'Fecha Documento',
											A2(
												formatDate_,
												'DD/MM/YYYY',
												formValue_('solicitud_documentos_fecha'))),
										A2(
											inscriptionRow,
											_Utils_Tuple2(
												'Lugar Documento',
												formValue_('solicitud_documentos_lugar')),
											A2(
												inscriptionRow,
												_Utils_Tuple2(
													'Naturaleza Documento',
													formValue_('solicitud_documentos_naturaleza')),
												A2(
													inscriptionRow,
													_Utils_Tuple2(
														'Tipo Documento',
														formValue_('solicitud_documentos_tipo')),
													A2(
														inscriptionRow,
														_Utils_Tuple2(
															'Fecha/Hora Solicitud',
															A2(
																formatDate_,
																'DD/MM/YYYY | hh:mm A',
																formValue_('solicitud_fecha_solicitud'))),
														A2(
															inscriptionRow,
															_Utils_Tuple2(
																'Email Inscripción',
																formValue_('solicitud_adquiriente_correo')),
															A2(
																inscriptionRow,
																_Utils_Tuple2(
																	'Dirección Propietario',
																	formValue_('solicitud_adquiriente_domicilio')),
																A2(
																	inscriptionRow,
																	_Utils_Tuple2(
																		'Comuna Propietario',
																		formValue_('solicitud_adquiriente_comuna')),
																	A2(
																		inscriptionRow,
																		_Utils_Tuple2(
																			'Email Propietario',
																			formValue_('solicitud_email')),
																		A2(
																			inscriptionRow,
																			_Utils_Tuple2('Rut Propietario', clienteFormattedRut_),
																			A2(
																				inscriptionRow,
																				_Utils_Tuple2(
																					'Nombre Propietario',
																					formValue_('solicitud_adquiriente_nombre')),
																				A2(
																					inscriptionRow,
																					_Utils_Tuple2(
																						'Número Factura',
																						formValue_('solicitud_documentos_numero')),
																					A2(
																						inscriptionRow,
																						_Utils_Tuple2('Rut Distribuidor', dealerFormattedRut_),
																						A2(
																							inscriptionRow,
																							_Utils_Tuple2(
																								'Distribuidor',
																								formValue_('solicitud_dealer')),
																							A2(
																								inscriptionRow,
																								_Utils_Tuple2('PPU', vehiculoPPU_),
																								_List_fromArray(
																									[
																										A2(
																										innerRow_,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('col-sm')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h4,
																														_List_fromArray(
																															[
																																$elm$html$Html$Attributes$class('m-0 f-14')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Primera Inscripción')
																															]))
																													]))
																											])),
																										separatorDivRow_
																									]))))))))))))))))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-3'),
											A2($elm$html$Html$Attributes$style, 'background-color', '#F8F8F8')
										]),
									_List_fromArray(
										[
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h4,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('m-0 f-14')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Documento')
																]))
														]))
												])),
											separatorDivRow_,
											A2(
											innerRow_,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-10 pr-0')
														]),
													_List_fromArray(
														[
															A2(
															innerRow_,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('col-sm-4 pl-0')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Nombre')
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('col-sm-8 pr-0')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(documentName_)
																		]))
																])),
															A2(
															innerRow_,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('col-sm-4 pl-0')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Tipo')
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('col-sm-8 pr-0')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Solicitud de Primera Inscripción')
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-2 vertical-centered')
														]),
													_List_fromArray(
														[
															function (attrs_) {
															return A2(
																$elm$html$Html$a,
																attrs_,
																_List_fromArray(
																	[
																		iconItem_('zmdi-open-in-new')
																	]));
														}(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pr-2 position-relative just-icon'),
																	A2($elm$html$Html$Attributes$attribute, 'title_', 'Abrir en nueva pestaña'),
																	$elm$html$Html$Attributes$target('blank_'),
																	$elm$html$Html$Attributes$href(previewer_),
																	A2($elm$html$Html$Attributes$style, 'color', 'inherit')
																])),
															function (attrs_) {
															return A2(
																$elm$html$Html$a,
																attrs_,
																_List_fromArray(
																	[
																		iconItem_('zmdi-download')
																	]));
														}(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pl-2 position-relative just-icon'),
																	A2($elm$html$Html$Attributes$attribute, 'title_', 'Descargar ' + documentName_),
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$SolicitarChie$DownloadInscription(documentName_))
																]))
														]))
												]))
										]))
								]))
						])),
					separatorDivRow_,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 p-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm p-0 text-right')
								]),
							_List_fromArray(
								[
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Cancelar')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_(cancelAction),
											$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
											$author$project$Csf$Form$attr(
											$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('disabled', model.u)
													]))),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										])),
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Anterior')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_(previousAction),
											$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
											$author$project$Csf$Form$attr(
											$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('disabled', model.u)
													]))),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										])),
									function (attrs_) {
									return A2(
										$author$project$Csf$Form$btn,
										attrs_,
										_List_fromArray(
											[
												$elm$html$Html$text('Solicitar')
											]));
								}(
									_List_fromArray(
										[
											$author$project$Csf$Form$onClick_(requestAction),
											$author$project$Csf$Form$loading(model.u),
											$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
											A2($author$project$Csf$Form$style_, 'min-width', '90px')
										]))
								]))
						]))
				])));
};
var $author$project$Csf$FileUploader$imgContainer = F2(
	function (attrs, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{ev: attrs});
	});
var $author$project$Csf$FileUploader$optionalAction = F2(
	function (optional_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{e$: optional_});
	});
var $author$project$Page$SolicitarChie$wizzardUploadItem_ = function (model) {
	var containerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('bg-white pt-2 pb-4'),
			A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
			A2($elm$html$Html$Attributes$style, 'padding-right', '25px')
		]);
	return A3(
		$elm$core$Basics$composeR,
		$elm$html$Html$div(containerAttrs_),
		$elm$core$List$singleton,
		A3(
			$elm$core$Basics$composeR,
			$elm$html$Html$div(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border', '1px solid #CCCCCC')
					])),
			$elm$core$List$singleton,
			_List_fromArray(
				[
					A2(
					$author$project$Csf$FileUploader$view,
					model.dG,
					A2(
						$author$project$Csf$FileUploader$optionalAction,
						_List_fromArray(
							[
								$elm$html$Html$text('(Solo se admiten documentos PDF)')
							]),
						A2(
							$author$project$Csf$FileUploader$secondaryText,
							'Arrastre el documento aquí o use el botón',
							A2(
								$author$project$Csf$FileUploader$primaryText,
								'Adjunte la Solicitud de Primera Inscripción',
								A2(
									$author$project$Csf$FileUploader$bttnLoading,
									model.az,
									A2(
										$author$project$Csf$FileUploader$bttnLabel,
										'Adjuntar',
										A2(
											$author$project$Csf$FileUploader$imgContainer,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'padding-top', '1rem')
												]),
											A2(
												$author$project$Csf$FileUploader$imageSource,
												$author$project$Helpers$Utilities$imagesPath('/pdf-file_blue.png'),
												$author$project$Csf$FileUploader$config($author$project$Page$SolicitarChie$UploaderMsg)))))))))
				])));
};
var $author$project$Page$SolicitarChie$view = function (model) {
	var session = model.g$;
	var actualStep = model.cu;
	var forwarded_ = function (step_) {
		return $elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'step_forwarded',
					_Utils_cmp(step_, actualStep) < 0)
				]));
	};
	var dataLoaded = A2($elm$core$Basics$composeR, $elm$core$Dict$isEmpty, $elm$core$Basics$not)(model.kX) && (!_Utils_eq($author$project$TaskNode$emptyTask, model.X));
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										A2($elm$html$Html$Attributes$style, 'min-height', '400px')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Page$SolicitarChie$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 card-body--no-padding'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												$author$project$Page$SolicitarChie$errorInfoModalView(model),
												$author$project$Helpers$Utilities$coreLoader(model.c6),
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-uppercase m-0 f-14 col-sm-8')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Solicitud de Certificado Homologado Individual Electrónico')
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-4 text-uppercase text-right')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(true)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary just-icon ml-2 mr-2'),
																		A2($author$project$Csf$Form$style_, 'min-width', '25px'),
																		A2(
																		$elm$core$Basics$composeR,
																		$elm$html$Html$Attributes$attribute('title_'),
																		$author$project$Csf$Form$attr)('Cancelar solicitud'),
																		$author$project$Csf$Form$onClick_(
																		(model.u || model.az) ? $author$project$Page$SolicitarChie$NoOp : (dataLoaded ? $author$project$Page$SolicitarChie$CerrarSolicitud : $author$project$Page$SolicitarChie$CancelarSolicitud))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$i,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('zmdi zmdi-close f-16')
																			]),
																		_List_Nil)
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$wizzard,
										_List_fromArray(
											[
												$author$project$Csf$Form$bindTo(
												$author$project$Page$SolicitarChie$stepName_(model.cu))
											]),
										_List_fromArray(
											[
												function (attrs_) {
												return A2(
													$author$project$Csf$Form$wizzardItem,
													attrs_,
													$author$project$Page$SolicitarChie$wizzardUploadItem_(model));
											}(
												_List_fromArray(
													[
														$author$project$Csf$Form$heading('Documento'),
														$author$project$Csf$Form$description('Adjunte la solicitud de Primera Inscripción'),
														$author$project$Csf$Form$value_(
														$author$project$Page$SolicitarChie$stepName_(1)),
														$author$project$Csf$Form$fieldattr(
														forwarded_(1))
													])),
												function (attrs_) {
												return A2(
													$author$project$Csf$Form$wizzardItem,
													attrs_,
													$author$project$Page$SolicitarChie$wizzardRequestItem_(model));
											}(
												_List_fromArray(
													[
														$author$project$Csf$Form$heading('Datos de la Solicitud'),
														$author$project$Csf$Form$description('Complete los datos de la solicitud'),
														$author$project$Csf$Form$value_(
														$author$project$Page$SolicitarChie$stepName_(2)),
														$author$project$Csf$Form$fieldattr(
														forwarded_(2))
													])),
												function (attrs_) {
												return A2(
													$author$project$Csf$Form$wizzardItem,
													attrs_,
													$author$project$Page$SolicitarChie$wizzardSummaryItem_(model));
											}(
												_List_fromArray(
													[
														$author$project$Csf$Form$heading('Resumen'),
														$author$project$Csf$Form$description('Revise y envíe la solicitud'),
														$author$project$Csf$Form$value_(
														$author$project$Page$SolicitarChie$stepName_(3))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$SolicitudesChie$ActualizarPeso = {$: 5};
var $author$project$Page$SolicitudesChie$CloseDetails = {$: 18};
var $author$project$Page$SolicitudesChie$DoConciliate = {$: 13};
var $author$project$Page$SolicitudesChie$DoExportXLS = {$: 12};
var $author$project$Page$SolicitudesChie$ExtendCHIE = {$: 3};
var $author$project$Page$SolicitudesChie$GoToRequestChie = {$: 19};
var $author$project$Page$SolicitudesChie$NoOp = {$: 0};
var $author$project$Page$SolicitudesChie$NullifyCHIE = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$SolicitudesChie$ConfirmActualizarPeso = {$: 6};
var $author$project$Page$SolicitudesChie$OnPesoBlured = {$: 8};
var $author$project$Page$SolicitudesChie$OnPesoUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$SolicitudesChie$actualizarPesoModalView = function (model) {
	var actualizarPesoModalVisibility = model.bL;
	var pesoField = model.aG;
	var pesoValue = $author$project$Csf$Form$strVal(pesoField);
	var isValidPeso = (!$elm$core$String$isEmpty(pesoValue)) && $author$project$Page$SolicitudesChie$isValidIntPeso(pesoValue);
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	var _v0 = _Utils_Tuple2(
		$author$project$Page$SolicitudesChie$CloseModal('actualizar-peso-modal'),
		$author$project$Page$SolicitudesChie$ConfirmActualizarPeso);
	var cancelAction = _v0.a;
	var doAction = _v0.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, actualizarPesoModalVisibility)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			actualizarPesoModalVisibility,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(cancelAction),
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2')
							])),
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Aceptar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$attr(
								(!isValidPeso) ? A2($elm$html$Html$Attributes$attribute, 'disabled', 'True') : A2($elm$html$Html$Attributes$attribute, 'enabled', 'True')),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12')
										]),
									_Utils_ap(
										A6(
											$author$project$Helpers$Utilities$inputFormField,
											false,
											'Peso bruto',
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$placeholder('Escriba el peso bruto del vehículo (# entero > 0)'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Events$onInput($author$project$Page$SolicitudesChie$OnPesoUpdated),
													$elm$html$Html$Events$onBlur($author$project$Page$SolicitudesChie$OnPesoBlured)
												]),
											pesoField,
											_List_Nil),
										_List_fromArray(
											[
												((!$author$project$Page$SolicitudesChie$isValidIntPeso(
												$author$project$Csf$Form$strVal(pesoField))) && (!$elm$core$String$isEmpty(
												$author$project$Csf$Form$strVal(pesoField)))) ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('invalid-feedback d-block')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('El peso debe ser un número mayor que 0')
													])) : $elm$html$Html$text('')
											])))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Actualizar Peso')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									true,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Page$SolicitudesChie$boolModule = F2(
	function (key_, _v0) {
		var moduleBools = _v0.bu;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Dict$get, key_, moduleBools));
	});
var $author$project$Page$SolicitudesChie$chieHasChildren = function (taskNode_) {
	return !$elm$core$List$isEmpty(
		$author$project$Helpers$ExtensionsUtils$decodeExtensions(taskNode_));
};
var $author$project$Helpers$Utilities$correctDocumentNames = function (string_) {
	return A3(
		$elm$core$Basics$composeR,
		$author$project$Helpers$Utilities$doCapitalize,
		A2($elm$core$String$replace, 'Chie', 'CHI-e'),
		A3(
			$elm$core$String$replace,
			'inscripcion',
			'inscripción',
			A3($elm$core$String$replace, 'tecnica', 'técnica', string_)));
};
var $author$project$Page$SolicitudesChie$ConfirmarEliminar = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$DescargarDocumento = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Page$SolicitudesChie$SwitchDocument = function (a) {
	return {$: 28, a: a};
};
var $author$project$Page$SolicitudesChie$EliminarDocumento = {$: 29};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Page$SolicitudesChie$confirmDeleteModalView = function (_v0) {
	var deAssociate = _v0.am;
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	var _v1 = deAssociate.br ? _Utils_Tuple2($author$project$Page$SolicitudesChie$NoOp, $author$project$Page$SolicitudesChie$NoOp) : _Utils_Tuple2(
		$author$project$Page$SolicitudesChie$CloseModal('delete-modal'),
		$author$project$Page$SolicitudesChie$EliminarDocumento);
	var cancelAction = _v1.a;
	var doAction = _v1.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, deAssociate.dJ)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			deAssociate.dJ,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(cancelAction),
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2')
							])),
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Eliminar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$loading(deAssociate.br),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pb-3')
						]),
					_List_fromArray(
						[
							$author$project$Helpers$Utilities$trimmedEmpty(deAssociate.hP) ? $elm$html$Html$text('') : A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							true,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1 pt-1 pb-1')
								]),
							deAssociate.hP),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0 text-left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-black')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Documento: ')
														])),
													$elm$html$Html$text(deAssociate.bF)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('f-14')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$SolicitudesChie$moduleMessage('deassociate_confirm_message')),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-weight-bold text-error')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('irreversible')
														])),
													$elm$html$Html$text('.')
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Eliminar documento')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									!deAssociate.br,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Page$SolicitudesChie$documentosTabView = function (model) {
	var activeTabItem = model.ae;
	var activeDocument = model.aK;
	var fileDocuments = model.b5;
	var session = model.g$;
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var showDleteMenu = function (nde) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Dict$get, nde.p, model.ao));
	};
	var notChieDta_ = A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dm;
			},
			$author$project$TaskNode$typeOrEmpty),
		$elm$core$Basics$neq('chie_data'));
	var ndeType_ = function (nde) {
		return $author$project$TaskNode$typeOrEmpty(nde.dm);
	};
	var ndeState_ = function (nde) {
		return A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', nde);
	};
	var ndeExtension_ = function (nde) {
		return function (ext_) {
			return ((ext_ > 0) && (ext_ <= 2)) ? (' EXT-' + $elm$core$String$fromInt(ext_)) : '';
		}(
			A3($author$project$Csf$TaskNodeUtils$dataint, 0, 'numero_extension', nde));
	};
	var ndeAnuladoExtension_ = function (nde) {
		return (ndeExtension_(nde) === '') ? function (n_) {
			return A2($elm$core$String$contains, 'Ext1', n_) ? ' EXT-1' : (A2($elm$core$String$contains, 'Ext2', n_) ? ' EXT-2' : '');
		}(
			A3($author$project$Csf$TaskNodeUtils$datastring, '', 'name', nde)) : '';
	};
	var nameCondition = function (nde) {
		return ('chie' === ndeType_(nde)) && A2(
			$elm$core$Basics$composeR,
			ndeState_,
			$elm$core$Basics$eq('anulado_chie'))(nde);
	};
	var nameAdds = function (nde) {
		return nameCondition(nde) ? 'anulado' : '';
	};
	var docHeadRows = _List_fromArray(
		[
			$author$project$Helpers$Utilities$coreLoader(
			A2($author$project$Page$SolicitudesChie$boolModule, 'docs_loading', model)),
			$author$project$Page$SolicitudesChie$confirmDeleteModalView(model),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0'),
					A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #ccc'),
					A2($elm$html$Html$Attributes$style, 'color', '#000'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-6 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Nombre del documento')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-4 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Fecha de emisión')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				]))
		]);
	var dloadXmlImg = A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('m-0'),
				$elm$html$Html$Attributes$src(
				$author$project$Helpers$Utilities$imagesPath('/xml-file.png')),
				A2($elm$html$Html$Attributes$style, 'height', '16px')
			]),
		_List_Nil);
	var dloadDocumentIcon = A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('zmdi zmdi-download'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 2px')
			]),
		_List_Nil);
	var deleteDocumentIcon = A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('zmdi zmdi-delete'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 2px')
			]),
		_List_Nil);
	var date_ = function (string_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A3($author$project$Csf$DateFormat$formatIsoDate, 'DD/MM/YYYY | hh:mm A', model.lG, string_));
	};
	var correctDocumentNamesFormated = F2(
		function (name_, nde) {
			return _Utils_ap(
				$author$project$Helpers$Utilities$correctDocumentNames(name_),
				_Utils_ap(
					ndeExtension_(nde),
					ndeAnuladoExtension_(nde)));
		});
	var processName = function (nde) {
		return A2(
			$elm$core$String$join,
			' ',
			function (name_) {
				return _List_fromArray(
					[
						A2(correctDocumentNamesFormated, name_, nde),
						nameAdds(nde)
					]);
			}(
				A3(
					$elm$core$String$replace,
					'_',
					' ',
					ndeType_(nde))));
	};
	var deleteDoc_ = function (tNde) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2(
					$author$project$Page$SolicitudesChie$ConfirmarEliminar,
					processName(tNde),
					tNde))
			]);
	};
	var download_ = function (tNde) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2(
					$author$project$Page$SolicitudesChie$DescargarDocumento,
					processName(tNde),
					tNde))
			]);
	};
	var anchorAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pl-1 pr-1 position-relative just-icon'),
			A2($elm$html$Html$Attributes$style, 'color', 'inherit')
		]);
	var _v0 = A2(
		$elm$core$Tuple$mapSecond,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$withDefault($author$project$TaskNode$emptyTask)),
		A2($elm$core$List$partition, notChieDta_, fileDocuments));
	var filteredDocs_ = _v0.a;
	var chieData_ = _v0.b;
	var dloadChieDtaCond = function (nde) {
		return ('chie' === ndeType_(nde)) && (A2(
			$elm$core$Basics$composeR,
			ndeState_,
			$elm$core$Basics$eq('firmado_chie'))(nde) && (!_Utils_eq(chieData_, $author$project$TaskNode$emptyTask)));
	};
	var deleteDocument = function (nde) {
		if (!$author$project$Page$SolicitudesChie$isSupportUser(session)) {
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
		} else {
			var _v2 = dloadChieDtaCond(nde);
			if (_v2) {
				return _List_fromArray(
					[
						function (attrs_) {
						return A2(
							$elm$html$Html$a,
							attrs_,
							_List_fromArray(
								[deleteDocumentIcon]));
					}(
						_Utils_ap(
							anchorAttrs_,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'title_', 'Eliminar documento'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$SolicitudesChie$ToggleErrorTooltip(nde.p))
								]))),
						(!showDleteMenu(nde)) ? $elm$html$Html$text('') : A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(nde.p),
								$elm$html$Html$Attributes$class('p-0 m-0 position-absolute'),
								A2($elm$html$Html$Attributes$style, 'list-style', 'none'),
								A2($elm$html$Html$Attributes$style, 'left', '-100px'),
								A2($elm$html$Html$Attributes$style, 'top', '25px'),
								A2($elm$html$Html$Attributes$style, 'z-index', '20')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('vh_error__tooltip mb-0')
									]),
								_List_fromArray(
									[
										function (attrs_) {
										return A2(
											$elm$html$Html$div,
											attrs_,
											_List_fromArray(
												[
													$elm$html$Html$text('Eliminar CHI-e')
												]));
									}(
										_Utils_ap(
											deleteDoc_(nde),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row m-0 p-1'),
													A2($elm$html$Html$Attributes$style, 'border-bottom', '0.5px solid lightgray')
												]))),
										function (attrs_) {
										return A2(
											$elm$html$Html$div,
											attrs_,
											_List_fromArray(
												[
													$elm$html$Html$text('Eliminar Documento XML')
												]));
									}(
										_Utils_ap(
											deleteDoc_(chieData_),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row m-0 p-1')
												])))
									]))
							]))
					]);
			} else {
				return $elm$core$List$singleton(
					function (attrs_) {
						return A2(
							$elm$html$Html$a,
							attrs_,
							_List_fromArray(
								[deleteDocumentIcon]));
					}(
						A3(
							$elm$core$Basics$composeR,
							$elm$core$Basics$append(
								deleteDoc_(nde)),
							$elm$core$Basics$append(anchorAttrs_),
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'title_', 'Eliminar documento')
								]))));
			}
		}
	};
	var downloadChieDta_ = function (nde) {
		return dloadChieDtaCond(nde) ? function (attrs_) {
			return A2(
				$elm$html$Html$a,
				attrs_,
				_List_fromArray(
					[dloadXmlImg]));
		}(
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Basics$append(
					download_(chieData_)),
				$elm$core$Basics$append(anchorAttrs_),
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'title_', 'Descargar XML')
					]))) : $elm$html$Html$text('');
	};
	var docsRowMap = function (nde) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected_document',
							_Utils_eq(activeDocument, nde.p))
						])),
					A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #ccc'),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-6 pt-2 pb-2'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitudesChie$SwitchDocument(nde.p))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							processName(nde))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-4 pt-2 pb-2'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitudesChie$SwitchDocument(nde.p))
						]),
					_List_fromArray(
						[
							A3(
							$elm$core$Basics$composeL,
							$elm$html$Html$text,
							date_,
							$author$project$TaskNode$insertedAtOrEmpty(nde.dm))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 p-2')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								function (attrs_) {
								return A2(
									$elm$html$Html$a,
									attrs_,
									_List_fromArray(
										[dloadDocumentIcon]));
							}(
								A3(
									$elm$core$Basics$composeR,
									$elm$core$Basics$append(
										download_(nde)),
									$elm$core$Basics$append(anchorAttrs_),
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'title_', 'Descargar documento')
										])))
							]),
						_Utils_ap(
							deleteDocument(nde),
							_List_fromArray(
								[
									downloadChieDta_(nde)
								]))))
				]));
	};
	var documentsRowContent_ = A2($author$project$Page$SolicitudesChie$boolModule, 'docs_loading', model) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-height', '200px')
				]),
			_List_fromArray(
				[$author$project$Csf$Core$loader]))
		]) : ((!$elm$core$List$isEmpty(filteredDocs_)) ? _Utils_ap(
		docHeadRows,
		A2($elm$core$List$map, docsRowMap, filteredDocs_)) : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center vertical-centered'),
					A2($elm$html$Html$Attributes$style, 'min-height', '320px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-12')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-3'),
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
									A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
									A2($elm$html$Html$Attributes$style, 'font-size', '14px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									function () {
										var _v1 = A2($author$project$Page$SolicitudesChie$boolModule, 'docs_failed', model);
										if (_v1) {
											return $author$project$Page$SolicitudesChie$moduleMessage('file_documents_failed');
										} else {
											return $author$project$Page$SolicitudesChie$moduleMessage('file_documents_empty');
										}
									}())
								]))
						]))
				]))
		]));
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('pt-3'),
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_documentos'),
						activeTabItem)
					]),
				documentsRowContent_)
			]));
};
var $author$project$Page$SolicitudesChie$ConfirmExtendCHIE = {$: 4};
var $author$project$Page$SolicitudesChie$extendChieConfirmationModalView = function (model) {
	var extendChieModalVisibility = model.b_;
	var fileLoaded = model.b;
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	var _v0 = _Utils_Tuple2(
		$author$project$Page$SolicitudesChie$CloseModal('extend-chie-modal'),
		$author$project$Page$SolicitudesChie$ConfirmExtendCHIE);
	var cancelAction = _v0.a;
	var doAction = _v0.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, extendChieModalVisibility)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			extendChieModalVisibility,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(cancelAction),
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2')
							])),
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Aceptar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3 pb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-left')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$SolicitudesChie$moduleMessage('extend_chie_confirm_message'))
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Page$SolicitudesChie$moduleMessage('extend_chie_confirm_title'))
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									true,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Page$SolicitudesChie$extendChieSuccessModalView = function (model) {
	var extendChieSuccessModalVisibility = model.cT;
	return (!_Utils_eq($author$project$Csf$Modal$shown, extendChieSuccessModalVisibility)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			extendChieSuccessModalVisibility,
			A3(
				$author$project$Csf$Modal$footer,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('justify-content-center'),
						A2($elm$html$Html$Attributes$style, 'padding-top', '0')
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Aceptar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(
								$author$project$Page$SolicitudesChie$CloseModal('extend-chie-success-modal')),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-5 pb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-12 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-3'),
													$elm$html$Html$Attributes$src(
													$author$project$Helpers$Utilities$imagesPath('/ic_check_ok_.svg'))
												]),
											_List_Nil),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2 mb-1'),
													A2($elm$html$Html$Attributes$style, 'font-size', 'small')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Page$SolicitudesChie$moduleMessage('extend_chie_success_message'))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-muted'),
													A2($elm$html$Html$Attributes$style, 'font-size', 'small')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Page$SolicitudesChie$moduleMessage('extend_chie_success_detail'))
												]))
										]))
								]))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A2(
							$author$project$Csf$Modal$attrs,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '460px')
								]),
							A2(
								$author$project$Csf$Modal$hideOnBackdropClick,
								false,
								$author$project$Csf$Modal$config(
									$author$project$Page$SolicitudesChie$CloseModal('extend-chie-success-modal')))))))));
};
var $author$project$Page$SolicitudesChie$mappingEstadoChie = function (estado_) {
	switch (estado_) {
		case 'solicitud_registrada':
			return 'Solicitado';
		case 'pendiente_firma':
			return 'Pendiente firma';
		case 'firmado_chie':
			return 'Firmado';
		case 'anulado_chie':
			return 'Anulado';
		case 'notificado_cliente':
			return 'Notificado al cliente';
		case 'registrado_mtt':
			return 'Registrado MTT';
		case 'conciliado_mtt':
			return 'Conciliado MTT';
		case 'notificado_cliente_mtt':
			return 'Notificado al cliente y MTT';
		case 'notificado_registrado_mtt':
			return 'Finalizado';
		default:
			return estado_;
	}
};
var $author$project$Page$SolicitudesChie$extensionTabView = function (model) {
	var activeTabItem = model.ae;
	var fileLoaded = model.b;
	var extensions = $author$project$Helpers$ExtensionsUtils$decodeExtensions(fileLoaded);
	var extensionField = F2(
		function (label, value) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col-sm-6')
					]),
				A6(
					$author$project$Helpers$Utilities$inputFormField,
					false,
					label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$readonly(true)
						]),
					$author$project$Csf$Form$strFieldModel(value),
					_List_Nil));
		});
	var renderExtension = function (ext) {
		var state = ext.j0;
		var fieldsAnulado = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(extensionField, 'Fecha de Anulación', ext.j6),
						A2(extensionField, 'Nombre Anulador', ext.jD),
						A2(extensionField, 'Motivo de Anulación', ext.kC),
						A2(extensionField, 'Causa de Anulación', ext.jL)
					]))
			]);
		var fieldsActiveOrInProcess = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row pl-2 pr-2')
					]),
				_List_fromArray(
					[
						A2(extensionField, 'Fecha/Hora Solicitud Extensión CHI-e', ext.j8),
						A2(extensionField, 'Usuario Solicitante', ext.k8),
						A2(
						extensionField,
						'Estado CHI-e',
						$author$project$Page$SolicitudesChie$mappingEstadoChie(ext.j0)),
						A2(extensionField, 'Correlativo', ext.jR),
						A2(extensionField, 'Fecha de Emisión', ext.j7)
					]))
			]);
		var extensionNumber = ext.kQ;
		var numberLabel = function () {
			switch (extensionNumber) {
				case 1:
					return 'Primera Extensión';
				case 2:
					return 'Segunda Extensión';
				default:
					return 'Extensión ' + $elm$core$String$fromInt(extensionNumber);
			}
		}();
		var requestBlock = A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row pt-3'),
							A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-uppercase f-14')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Solicitud ' + numberLabel)
								]))
						])),
				fieldsActiveOrInProcess));
		var cancellationBlock = (state === 'anulado_chie') ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Anulación ' + numberLabel)
									]))
							])),
					fieldsAnulado))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$cons, requestBlock, cancellationBlock));
	};
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_extension'),
						activeTabItem)
					]),
				$elm$core$List$isEmpty(extensions) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center vertical-centered'),
								A2($elm$html$Html$Attributes$style, 'min-height', '320px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('No existen extensiones registradas')
									]))
							]))
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'min-height', '999px')
							]),
						A2($elm$core$List$map, renderExtension, extensions))
					]))
			]));
};
var $elm$core$String$filter = _String_filter;
var $author$project$Page$SolicitudesChie$getVehicleWeight = function (taskNode_) {
	return $elm$core$String$toFloat(
		function (cleanStr) {
			return $elm$core$String$isEmpty(cleanStr) ? '' : cleanStr;
		}(
			A2(
				$elm$core$String$filter,
				function (_char) {
					return $elm$core$Char$isDigit(_char) || (_char === '.');
				},
				A3(
					$elm$core$String$replace,
					',',
					'.',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($author$project$Csf$TaskNodeUtils$mbdatastring, 'vehiculo_peso_bruto', taskNode_))))));
};
var $author$project$Csf$Timeline$TimelineConfig = $elm$core$Basics$identity;
var $author$project$Csf$Timeline$config = function (toDateFormat_) {
	return {
		fC: $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('active', 'Pendiente'),
					_Utils_Tuple2('closed', 'Finalizada'),
					_Utils_Tuple2('deleted', 'Anulada')
				])),
		dz: $elm$core$Dict$empty,
		fI: toDateFormat_
	};
};
var $author$project$Csf$Timeline$taskTypes = F2(
	function (tasks_, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{dz: tasks_});
	});
var $author$project$Config$Tasks$workflowTasks = _List_fromArray(
	[
		_Utils_Tuple2(
		'chie_aprobar_emision',
		{B: 'Revisar solicitud', C: 'Manual'}),
		_Utils_Tuple2(
		'chie_anular_solicitud',
		{B: 'Anular solicitud', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_validar_solicitud',
		{B: 'Validar solicitud', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_enviar_certificado',
		{B: 'Notificar a Cliente', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_firmar_certificado',
		{B: 'Firmar certificado', C: 'Semiautomática'}),
		_Utils_Tuple2(
		'chie_registrar_solicitud',
		{B: 'Registrar Solicitud', C: 'Evento inicial'}),
		_Utils_Tuple2(
		'chie_complementar_solicitud',
		{B: 'Complementar solicitud', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_registrar_certificado_mtt',
		{B: 'Registrar certificado', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_conciliar_certificado_mtt',
		{B: 'Conciliar certificado con MTT', C: 'Automática'}),
		_Utils_Tuple2(
		'starttask_chie_generar_solicitud',
		{B: 'Registrar solicitud', C: 'Evento inicial'}),
		_Utils_Tuple2(
		'chie_registrar_extension',
		{B: 'Registrar extensión', C: 'Manual'}),
		_Utils_Tuple2(
		'chie_preparar_certificado_extension',
		{B: 'Preparar certificado de extensión', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_firmar_certificado_extension',
		{B: 'Firmar certificado de extensión', C: 'Semiautomática'}),
		_Utils_Tuple2(
		'chie_enviar_certificado_extension',
		{B: 'Notificar a cliente', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_registrar_extension_mtt',
		{B: 'Registrar certificado con MTT', C: 'Automática'}),
		_Utils_Tuple2(
		'chie_conciliar_extension_mtt',
		{B: 'Conciliar certificado con MTT', C: 'Automática'})
	]);
var $author$project$Helpers$Utilities$tasksInfoDict = $elm$core$Dict$fromList($author$project$Config$Tasks$workflowTasks);
var $author$project$Csf$Timeline$accountPicture = F2(
	function (defaulClass, name_) {
		var _v0 = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)(name_);
		if (_v0) {
			return function (icon_) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(defaulClass)
						]),
					_List_fromArray(
						[icon_]));
			}(
				function (icon_attrs) {
					return A2($elm$html$Html$i, icon_attrs, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-account-circle'),
							A2($elm$html$Html$Attributes$style, 'font-size', '40px'),
							A2($elm$html$Html$Attributes$style, 'margin-top', '-2px')
						])));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(defaulClass),
						A2($elm$html$Html$Attributes$style, 'background', '#0167B3'),
						A2($elm$html$Html$Attributes$style, 'color', '#FFF')
					]),
				_List_fromArray(
					[
						A3(
						$elm$core$Basics$composeR,
						$elm$core$String$join(''),
						$elm$html$Html$text,
						A2(
							$elm$core$List$map,
							$elm$core$String$left(1),
							$elm$core$String$words(name_)))
					]));
		}
	});
var $author$project$Csf$Timeline$cardWrapper = F2(
	function (heading_, data_) {
		var _v0 = A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$core$String$isEmpty)(data_);
		if (_v0) {
			return $elm$html$Html$text('');
		} else {
			return function (div_data) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[div_data]));
			}(
				A2(
					$elm$html$Html$small,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('c-black')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(heading_)
								])),
							$elm$html$Html$text(data_)
						])));
		}
	});
var $author$project$Csf$Timeline$nodestr = F2(
	function (key_, _v0) {
		var properties = _v0.dm;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$TaskNode$string, key_, properties));
	});
var $author$project$Csf$Timeline$dictstr = F3(
	function (key_, node_, dict_) {
		return A2(
			$elm$core$Dict$get,
			A2($author$project$Csf$Timeline$nodestr, key_, node_),
			dict_);
	});
var $author$project$Csf$Timeline$taskWrapper = F4(
	function (node_, _v0, index_, length_) {
		var conf = _v0;
		var task_type = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					$elm$core$Basics$append('Tarea ')),
				A3(
					$author$project$Csf$Timeline$dictstr,
					'name',
					node_,
					A2(
						$elm$core$Dict$map,
						F2(
							function (_v3, _v4) {
								var tipo_tarea = _v4.C;
								return tipo_tarea;
							}),
						conf.dz))));
		var status_ = A2($author$project$Csf$Timeline$nodestr, 'status', node_);
		var name_ = A2($author$project$Csf$Timeline$nodestr, 'executedby', node_);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-12')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('timeline-view', true),
											_Utils_Tuple2(
											'last',
											_Utils_cmp(index_, length_ - 1) > -1),
											_Utils_Tuple2(status_, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('arrow')
										]),
									_List_Nil),
									A2($author$project$Csf$Timeline$accountPicture, 'timeline-picture', name_),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('timeline-content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-9')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h5,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('m-t-0')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A3(
																			$author$project$Csf$Timeline$dictstr,
																			'name',
																			node_,
																			A2(
																				$elm$core$Dict$map,
																				F2(
																					function (_v1, _v2) {
																						var nombre = _v2.B;
																						return nombre;
																					}),
																				conf.dz))))
																])),
															A2($author$project$Csf$Timeline$cardWrapper, 'Completado por: ', name_),
															A2(
															$author$project$Csf$Timeline$cardWrapper,
															'Fecha de inicio: ',
															A2(
																$elm$core$Maybe$withDefault,
																'',
																conf.fI(
																	A2($author$project$Csf$Timeline$nodestr, 'ini', node_)))),
															A2(
															$author$project$Csf$Timeline$cardWrapper,
															'Fecha de fin: ',
															A2(
																$elm$core$Maybe$withDefault,
																'',
																conf.fI(
																	A2($author$project$Csf$Timeline$nodestr, 'fin', node_))))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('col-sm-3 pr-0 text-center status_' + status_)
														]),
													_List_fromArray(
														[
															function (iattrs_) {
															return A2($elm$html$Html$i, iattrs_, _List_Nil);
														}(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('zmdi position-absolute'),
																	A2($elm$html$Html$Attributes$attribute, 'title_', task_type),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('zmdi-settings', 'closed' === status_),
																			_Utils_Tuple2('zmdi-account', 'closed' !== status_)
																		]))
																])),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mb-0')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A3($author$project$Csf$Timeline$dictstr, 'status', node_, conf.fC)))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Csf$Timeline$view = F2(
	function (nodes_, config_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline')
				]),
			function (idxdMap_) {
				return A2($elm$core$List$indexedMap, idxdMap_, nodes_);
			}(
				F2(
					function (idx, node_) {
						return A4(
							$author$project$Csf$Timeline$taskWrapper,
							node_,
							config_,
							idx,
							$elm$core$List$length(nodes_));
					})));
	});
var $author$project$Page$SolicitudesChie$historialTabView = function (model) {
	var activeTabItem = model.ae;
	var fileHistory = model.b6;
	var toDateFormat_ = A2($author$project$Csf$DateFormat$formatIsoDate, 'DD/MM/YYYY', model.lG);
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('pt-3'),
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_historial'),
						activeTabItem)
					]),
				_List_fromArray(
					[
						A2($author$project$Page$SolicitudesChie$boolModule, 'history_loading', model) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'min-height', '200px')
							]),
						_List_fromArray(
							[$author$project$Csf$Core$loader])) : ((!$elm$core$List$isEmpty(fileHistory)) ? A2(
						$author$project$Csf$Timeline$view,
						fileHistory,
						A2(
							$author$project$Csf$Timeline$taskTypes,
							$author$project$Helpers$Utilities$tasksInfoDict,
							$author$project$Csf$Timeline$config(toDateFormat_))) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center vertical-centered'),
								A2($elm$html$Html$Attributes$style, 'min-height', '320px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-3'),
												$elm$html$Html$Attributes$src(
												$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h4,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
												A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
												A2($elm$html$Html$Attributes$style, 'font-size', '14px')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												function () {
													var _v0 = A2($author$project$Page$SolicitudesChie$boolModule, 'history_failed', model);
													if (_v0) {
														return $author$project$Page$SolicitudesChie$moduleMessage('file_history_failed');
													} else {
														return $author$project$Page$SolicitudesChie$moduleMessage('file_history_empty');
													}
												}())
											]))
									]))
							])))
					]))
			]));
};
var $author$project$Page$SolicitudesChie$isExpirationDateValid = F2(
	function (currentDateIso, expirationDateStr) {
		var expirationDatePart = A3($elm$core$String$slice, 0, 10, expirationDateStr);
		var currentDatePart = A3($elm$core$String$slice, 0, 10, currentDateIso);
		return _Utils_cmp(expirationDatePart, currentDatePart) > -1;
	});
var $author$project$Page$SolicitudesChie$getVehicleType = function (taskNode_) {
	return $elm$core$String$toUpper(
		A3($author$project$Csf$TaskNodeUtils$datastring, '', 'tipo', taskNode_));
};
var $author$project$Page$SolicitudesChie$isProhibitedVehicleType = function (vehicleType) {
	var prohibitedTypes = _List_fromArray(
		['MOTO', 'MOTORIZADA', 'MOTOCICLETA', 'BICIMOTO', 'TRIMOTO', 'CUADRIMOTO', 'BICICLETA MOTOR', 'TRICICLO MOTOR']);
	return A2($elm$core$List$member, vehicleType, prohibitedTypes);
};
var $author$project$Page$SolicitudesChie$isVehicleWeightValid = function (taskNode_) {
	var weight = $author$project$Page$SolicitudesChie$getVehicleWeight(taskNode_);
	var vehicleType = $author$project$Page$SolicitudesChie$getVehicleType(taskNode_);
	if (weight.$ === 1) {
		return false;
	} else {
		var w = weight.a;
		return ((w < 2700) && (!$author$project$Page$SolicitudesChie$isProhibitedVehicleType(vehicleType))) ? true : (((w >= 2700) && (w < 3860)) ? true : false);
	}
};
var $author$project$Page$SolicitudesChie$isExtendedChieEnabled = function (model) {
	var taskNode_ = model.b;
	var isNotRegistradoMtt = 'notificado_registrado_mtt' !== A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', taskNode_);
	var inProcessExtensions = $author$project$Helpers$ExtensionsUtils$getInProcessExtensions(taskNode_);
	var inProcessExtensionCount = $elm$core$List$length(inProcessExtensions);
	var currentDateIso = model.bR;
	var activeExtensions = $author$project$Helpers$ExtensionsUtils$getActiveExtensions(taskNode_);
	var activeExtensionCount = $elm$core$List$length(activeExtensions);
	if (isNotRegistradoMtt) {
		return false;
	} else {
		if (inProcessExtensionCount > 0) {
			return false;
		} else {
			if (activeExtensionCount > 1) {
				return false;
			} else {
				if (activeExtensionCount === 1) {
					var extension = $elm$core$List$head(activeExtensions);
					var isExpirationValid = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (ext) {
								return A2($author$project$Page$SolicitudesChie$isExpirationDateValid, currentDateIso, ext.j9);
							},
							extension));
					return isExpirationValid && $author$project$Page$SolicitudesChie$isVehicleWeightValid(taskNode_);
				} else {
					var currentDateIso_ = A3(
						$elm$core$String$slice,
						0,
						6,
						A3($elm$core$String$replace, '-', '', currentDateIso));
					var isExpirationValid = function () {
						var getChieDueDate_ = $author$project$Page$SolicitudesChie$getChieDueDate(taskNode_);
						return (getChieDueDate_ === '') ? false : (_Utils_cmp(getChieDueDate_, currentDateIso_) > -1);
					}();
					return $author$project$Page$SolicitudesChie$isVehicleWeightValid(taskNode_) && isExpirationValid;
				}
			}
		}
	}
};
var $author$project$Page$SolicitudesChie$isExtendedChieEnabledWithoutWeight = function (model) {
	var taskNode_ = model.b;
	var vehicleType = $author$project$Page$SolicitudesChie$getVehicleType(taskNode_);
	var isNullify = 'anulado_chie' === A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', taskNode_);
	var inProcessExtensions = $author$project$Helpers$ExtensionsUtils$getInProcessExtensions(taskNode_);
	var inProcessExtensionCount = $elm$core$List$length(inProcessExtensions);
	var currentDateIso = model.bR;
	var activeExtensions = $author$project$Helpers$ExtensionsUtils$getActiveExtensions(taskNode_);
	var activeExtensionCount = $elm$core$List$length(activeExtensions);
	if (isNullify) {
		return false;
	} else {
		if (inProcessExtensionCount > 0) {
			return false;
		} else {
			if (activeExtensionCount > 1) {
				return false;
			} else {
				if (activeExtensionCount === 1) {
					var extension = $elm$core$List$head(activeExtensions);
					var isExpirationValid = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (ext) {
								return A2($author$project$Page$SolicitudesChie$isExpirationDateValid, currentDateIso, ext.j9);
							},
							extension));
					return isExpirationValid && (!$author$project$Page$SolicitudesChie$isProhibitedVehicleType(vehicleType));
				} else {
					var currentDateIso_ = A3(
						$elm$core$String$slice,
						0,
						6,
						A3($elm$core$String$replace, '-', '', currentDateIso));
					var isExpirationValid = function () {
						var getChieDueDate_ = $author$project$Page$SolicitudesChie$getChieDueDate(taskNode_);
						return (getChieDueDate_ === '') ? false : (_Utils_cmp(getChieDueDate_, currentDateIso_) > -1);
					}();
					return isExpirationValid && (!$author$project$Page$SolicitudesChie$isProhibitedVehicleType(vehicleType));
				}
			}
		}
	}
};
var $author$project$Page$SolicitudesChie$isValidateExt = function (model) {
	var taskNode_ = model.b;
	var currentDateIso = model.bR;
	var activeExtension = $elm$core$List$head(
		$elm$core$List$reverse(
			$author$project$Helpers$ExtensionsUtils$getActiveExtensions(taskNode_)));
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (ext) {
				return A2($author$project$Page$SolicitudesChie$isExpirationDateValid, currentDateIso, ext.j9);
			},
			activeExtension));
};
var $author$project$Page$SolicitudesChie$SwitchTabItem = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$SolicitudesChie$navItem = F2(
	function (tab_key, isActive) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item'),
					A2($elm$html$Html$Attributes$style, 'width', 'auto')
				]),
			_List_fromArray(
				[
					function (anchor_attrs) {
					return A2(
						$elm$html$Html$a,
						anchor_attrs,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$SolicitudesChie$moduleMessage(tab_key))
							]));
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-link text-uppercase'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									isActive(tab_key))
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitudesChie$SwitchTabItem(tab_key)),
							A2($elm$html$Html$Attributes$style, 'color', 'inherit')
						]))
				]));
	});
var $author$project$Page$SolicitudesChie$DoNullifyCHIE = {$: 2};
var $author$project$Page$SolicitudesChie$OnCauseBlured = {$: 15};
var $author$project$Page$SolicitudesChie$OnCauseUpdated = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$SolicitudesChie$nullifyModalView = function (model) {
	var nullifyMdalVisibility = model.ch;
	var nullifyCauseField = model.Q;
	var nullifyTitle = model.ci;
	var pickedOption_ = $author$project$Customized$CustomDropdown$selectedOption(
		A2(
			$author$project$Helpers$Utilities$getDropdown,
			$author$project$Page$SolicitudesChie$stringFromField(4),
			model));
	var moduleDropdown_ = F4(
		function (field_, disabled_, growOnOpen_, heading_) {
			return A2(
				$elm$html$Html$map,
				$author$project$Page$SolicitudesChie$DropdownMsg(field_),
				A5(
					$author$project$Customized$CustomDropdown$dropbox,
					_List_Nil,
					disabled_,
					growOnOpen_,
					heading_,
					A2(
						$author$project$Helpers$Utilities$getDropdown,
						$author$project$Page$SolicitudesChie$stringFromField(field_),
						model)));
		});
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	var _v0 = model.bw ? _Utils_Tuple2($author$project$Page$SolicitudesChie$NoOp, $author$project$Page$SolicitudesChie$NoOp) : _Utils_Tuple2(
		$author$project$Page$SolicitudesChie$CloseModal('nullify-modal'),
		$author$project$Page$SolicitudesChie$DoNullifyCHIE);
	var cancelAction = _v0.a;
	var doAction = _v0.b;
	return (!_Utils_eq($author$project$Csf$Modal$shown, nullifyMdalVisibility)) ? $elm$html$Html$text('') : A3(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__container')
				])),
		A2(
			$author$project$Csf$Modal$view,
			nullifyMdalVisibility,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(cancelAction),
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2')
							])),
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anular')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_(doAction),
								$author$project$Csf$Form$loading(model.bw),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3')
						]),
					_List_fromArray(
						[
							$author$project$Helpers$Utilities$trimmedEmpty(model.de) ? $elm$html$Html$text('') : A3(
							$author$project$Helpers$Utilities$errorInfoStrip,
							true,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1 pt-1 pb-1')
								]),
							model.de),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('col-sm-8')
										]),
									_List_fromArray(
										[
											A4(moduleDropdown_, 4, model.bw, false, '* Motivo')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row m-0')
								]),
							function () {
								if (pickedOption_ === 'Otro') {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-12')
												]),
											_List_fromArray(
												[
													function (textAttrs_) {
													return A3($author$project$Helpers$Utilities$textareaFormField, textAttrs_, '* Causa', nullifyCauseField);
												}(
													_List_fromArray(
														[
															$elm$html$Html$Attributes$readonly(model.bw),
															$elm$html$Html$Events$onBlur($author$project$Page$SolicitudesChie$OnCauseBlured),
															$elm$html$Html$Events$onInput($author$project$Page$SolicitudesChie$OnCauseUpdated)
														]))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text(nullifyTitle)
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								A2(
									$author$project$Csf$Modal$hideOnBackdropClick,
									!model.bw,
									$author$project$Csf$Modal$config(cancelAction)))))))));
};
var $author$project$Page$SolicitudesChie$nullifyPermissions = function (_v0) {
	var flags = _v0.ka;
	return A2(
		$author$project$Helpers$ApiHandler$hasUserAccess,
		$author$project$Csf$Flags$userNode(flags),
		_List_fromArray(
			['APPROVER', 'SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']));
};
var $author$project$Page$SolicitudesChie$shouldShowExtendIcon = function (_v0) {
	var flags = _v0.ka;
	return A2(
		$author$project$Helpers$ApiHandler$hasUserAccess,
		$author$project$Csf$Flags$userNode(flags),
		_List_fromArray(
			['APPROVER', 'SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']));
};
var $author$project$Page$SolicitudesChie$showConciliation = function (_v0) {
	var flags = _v0.ka;
	return A2(
		$author$project$Helpers$ApiHandler$hasUserAccess,
		$author$project$Csf$Flags$userNode(flags),
		_List_fromArray(
			['SUPPORT', 'ADMINISTRATOR', 'LEGAL_REPRESENTATIVE']));
};
var $author$project$Config$AppTenants$stylesToAttrs = $elm$core$List$map(
	function (_v0) {
		var prop = _v0.a;
		var val = _v0.b;
		return A2($elm$html$Html$Attributes$style, prop, val);
	});
var $author$project$Page$SolicitudesChie$solicitudTabView = function (model) {
	var activeTabItem = model.ae;
	var fileLoaded = model.b;
	var wasCancelled = 'cancelled' === A3($author$project$Csf$TaskNodeUtils$datastring, '', 'approvement_outcome', fileLoaded);
	var solicitudFormField = function (key_) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Csf$Form$strFieldModel(''),
			A2($elm$core$Dict$get, key_, model.l));
	};
	var showValidation = wasCancelled && A3(
		$elm$core$Basics$composeR,
		$author$project$Helpers$Utilities$trimmedEmpty,
		$elm$core$Basics$not,
		A3($author$project$Csf$TaskNodeUtils$datastring, '', 'validation_message', fileLoaded));
	var showRechazo = 'solicitud_anulada' === A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', fileLoaded);
	var showAnulacion = 'anulado_chie' === A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', fileLoaded);
	var importer_ = A2(
		$author$project$Helpers$Utilities$tenantInfo,
		model.cl,
		A3($author$project$Csf$TaskNodeUtils$string, '', 'tenant', fileLoaded));
	var importerName_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-sm-6'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'hidden',
						$author$project$Helpers$Utilities$trimmedEmpty(importer_.dc))
					]))
			]),
		A6(
			$author$project$Helpers$Utilities$inputFormField,
			false,
			'Importador',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$readonly(true)
				]),
			$author$project$Csf$Form$strFieldModel(importer_.dc),
			_List_Nil));
	var importerLogo_ = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-sm-6'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'hidden',
						$author$project$Helpers$Utilities$trimmedEmpty(importer_.c7))
					]))
			]),
		$elm$core$List$singleton(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('position-relative')
					]),
				_List_fromArray(
					[
						function (attrs_) {
						return A2($elm$html$Html$img, attrs_, _List_Nil);
					}(
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('position-absolute'),
									$elm$html$Html$Attributes$src(importer_.c7)
								]),
							$author$project$Config$AppTenants$stylesToAttrs(importer_.dx)))
					]))));
	var hasCause = 'Otro' === A3($author$project$Csf$TaskNodeUtils$datastring, '', 'motivo_anulacion', fileLoaded);
	var formField = F3(
		function (attrs_, key_, heading_) {
			return A6(
				$author$project$Helpers$Utilities$inputFormField,
				false,
				heading_,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					attrs_),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$readonly(true)
					]),
				solicitudFormField(key_),
				_List_Nil);
		});
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('pt-3'),
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_solicitud'),
						activeTabItem)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Vehículo')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_vin', 'VIN')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_cit', 'C.I.T')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_marca', 'Marca')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_modelo', 'Modelo')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_tipo_vehiculo', 'Tipo de Vehículo')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_nro_motor', 'Nro Motor')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_color', 'Color')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_anno', 'Año')),
								importerName_,
								importerLogo_
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('1ra Inscripción')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_autorizante', 'Distribuidor')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_rut_emisor', 'Rut Distribuidor')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_ppu', 'Patente')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_numero', 'Número Factura')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_propietario_nombre', 'Nombre Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_propietario_rut', 'Rut Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_propietario_email', 'Email Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_propietario_comuna', 'Comuna Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12')
									]),
								A3(formField, _List_Nil, 'solicitud_propietario_domicilio', 'Dirección Propietario ')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_fecha_solicitud', 'Fecha/Hora Solicitud Inscripción')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_fecha', 'Fecha Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_inscripcion_email', 'Email Inscripción')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_tipo', 'Tipo Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_naturaleza', 'Naturaleza Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_documentos_lugar', 'Lugar Documento'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Solicitud')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_fecha_solicitud_chie', 'Fecha/Hora Solicitud CHI-e')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_solicitante', 'Usuario Solicitante')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_estado', 'Estado CHI-e')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', showRechazo)
											]))
									]),
								A3(formField, _List_Nil, 'solicitud_correlativo', 'Correlativo')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', showRechazo)
											]))
									]),
								A3(formField, _List_Nil, 'solicitud_fecha_emision', 'Fecha de Emisión')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', !showRechazo)
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Helpers$Utilities$textareaFormField,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Attributes$readonly(true)
											]),
										'Motivo de Rechazo',
										solicitudFormField('solicitud_motivo_rechazo'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', !showValidation)
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Helpers$Utilities$textareaFormField,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Attributes$readonly(true)
											]),
										'Resultado de la validación',
										solicitudFormField('solicitud_mensaje_validacion'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('hidden', !showAnulacion)
									])),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Anulación')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('hidden', !showAnulacion)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_fecha_anulacion', 'Fecha de Anulación')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_nombre_anulador', 'Nombre Anulador')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(
									formField,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-2')
										]),
									'solicitud_usuario_anulador',
									'Usuario Anulador')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A3(formField, _List_Nil, 'solicitud_motivo_anulacion', 'Motivo de Anulación')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', !hasCause)
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Helpers$Utilities$textareaFormField,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-2'),
												$elm$html$Html$Attributes$readonly(true)
											]),
										'Causa de Anulación',
										solicitudFormField('solicitud_causa_anulacion'))
									]))
							]))
					]))
			]));
};
var $author$project$Csf$TaskNodeUtils$mbliststr = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$TaskNode$liststr(key),
		function ($) {
			return $.dm;
		});
};
var $author$project$Csf$TaskNodeUtils$liststr = F2(
	function (default_, key) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Csf$TaskNodeUtils$mbliststr(key),
			$elm$core$Maybe$withDefault(default_));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Page$SolicitudesChie$conciliationData = F2(
	function (_v0, taskNode_) {
		var errorTooltip = _v0.ao;
		var image_icon = function (state_) {
			return ('solicitud_anulada' === A3($author$project$Csf$TaskNodeUtils$string, '', 'estado_chie', taskNode_)) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('N/A')
					])) : function (attrs_) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($elm$html$Html$img, attrs_, _List_Nil)
						]));
			}(
				function () {
					switch (state_) {
						case 'CONCILIADO':
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/ic_check_circle_24px.svg')),
									$elm$html$Html$Attributes$title('Conciliado')
								]);
						case 'PENDIENTE_CONCILIACION':
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/ic_update_24px.svg')),
									$elm$html$Html$Attributes$title('Enviado a Conciliación')
								]);
						case 'PENDIENTE_CONCILIACION_ERROR':
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$id(taskNode_.p),
									A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/ic_error_24px.svg')),
									$elm$html$Html$Attributes$title('Error en la Conciliación'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Csf$Table$CustomEventMsg, 'toggle_error_tooltip', taskNode_))
								]);
						case 'PENDIENTE_CONCILIACION_POR_ERROR':
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$id(taskNode_.p),
									A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/ic_error_24px.svg')),
									$elm$html$Html$Attributes$title('Error en la Conciliación'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Csf$Table$CustomEventMsg, 'toggle_error_tooltip', taskNode_))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									$author$project$Helpers$Utilities$imagesPath('/ic_schedule_24px.svg')),
									$elm$html$Html$Attributes$title('Pendiente de Conciliación')
								]);
					}
				}());
		};
		var errorsMap = function (error_) {
			return $author$project$Helpers$Utilities$trimmedEmpty(error_) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row m-0 p-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(error_)
						])));
		};
		var displayError = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Dict$get, taskNode_.p, errorTooltip));
		var _v1 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$List$filterMap(errorsMap),
			function (errors_) {
				return _Utils_Tuple2(
					A2($author$project$Csf$TaskNodeUtils$mbstring, 'estado_conciliacion_mtt', taskNode_),
					errors_);
			}(
				A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Csf$TaskNodeUtils$liststr, _List_Nil, 'resultado_conciliacion_mtt', taskNode_),
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($author$project$Csf$TaskNodeUtils$mbstring, 'resultado_conciliacion_mtt', taskNode_)))));
		var mbeState = _v1.a;
		var errorMssgs = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('position-relative vh_error__tooltip_container')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						image_icon('')
					]),
				function (stateMap) {
					return A2($elm$core$Maybe$map, stateMap, mbeState);
				}(
					function (state_) {
						return (!displayError) ? _List_fromArray(
							[
								image_icon(state_)
							]) : _List_fromArray(
							[
								image_icon(state_),
								function (divAttrs_) {
								return A2($elm$html$Html$div, divAttrs_, errorMssgs);
							}(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('position-absolute vh_error__tooltip mb-0'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'normal'),
										A2($elm$html$Html$Attributes$style, 'min-width', '200px'),
										A2($elm$html$Html$Attributes$style, 'right', '130%')
									]))
							]);
					})));
	});
var $author$project$Page$SolicitudesChie$conciliationDisabled = function () {
	var states_ = _List_fromArray(
		['PENDIENTE_CONCILIACION_ERROR', 'PENDIENTE_CONCILIACION_POR_ERROR']);
	return A2(
		$elm$core$Basics$composeL,
		function (state_) {
			return !A2($elm$core$List$member, state_, states_);
		},
		A2($author$project$Csf$TaskNodeUtils$string, '', 'estado_conciliacion_mtt'));
}();
var $author$project$Page$SolicitudesChie$fromTaskNode = F3(
	function (_v0, key_, taskNode_) {
		var tenantsDict = _v0.cl;
		switch (key_) {
			case 'ano':
				return A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					A2($author$project$Csf$TaskNodeUtils$mbint, key_, taskNode_));
			case 'tenant':
				return A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Helpers$Utilities$tenantInfo(tenantsDict),
						function ($) {
							return $.dc;
						}),
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			case 'inserted_at':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			case 'estado_chie':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$estadoDelChie,
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			default:
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
		}
	});
var $author$project$Page$SolicitudesChie$toAccessor = F3(
	function (key_, taskNode_, data_) {
		var new_tabIcon = A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('zmdi zmdi-open-in-new f-14')
				]),
			_List_Nil);
		var icon_link_ = function (attrs_) {
			return A2(
				$elm$html$Html$a,
				attrs_,
				_List_fromArray(
					[new_tabIcon]));
		}(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon_link_'),
					$elm$html$Html$Attributes$target('_blank'),
					A2($elm$html$Html$Attributes$attribute, 'title_', 'Abir en una nueva pestaña'),
					$elm$html$Html$Attributes$href(
					$author$project$Route$routeToString(
						$author$project$Page$SolicitudesChie$nodeDetailsRoute(taskNode_)))
				]));
		var details_event = A2($author$project$Csf$Table$CustomEventMsg, 'expediente_details', taskNode_);
		if (key_ === 'inserted_at') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hovered_link text-left')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(details_event)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(data_)
							])),
						icon_link_
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(details_event)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(data_)
					]));
		}
	});
var $author$project$Page$SolicitudesChie$justtext = F3(
	function (model, _v0, taskNode_) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(default_),
			A2($author$project$Page$SolicitudesChie$toAccessor, key_, taskNode_),
			A3($author$project$Page$SolicitudesChie$fromTaskNode, model, key_, taskNode_));
	});
var $author$project$Csf$Table$SelectDataMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Csf$Table$selectableColumn = function (def) {
	return $billstclair$elm_sortable_table$Table$veryCustomColumn(
		{
			dc: def.dc,
			bD: $billstclair$elm_sortable_table$Table$unsortable,
			dI: function (data) {
				return A2(
					$billstclair$elm_sortable_table$Table$HtmlDetails,
					$author$project$Csf$Core$list(
						_List_fromArray(
							[
								_Utils_Tuple2(
								A2(
									$elm$html$Html$Attributes$style,
									'width',
									A2($elm$core$Maybe$withDefault, '0px', def.lz)),
								!_Utils_eq($elm$core$Maybe$Nothing, def.lz))
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									function (attrs_) {
									return A2($elm$html$Html$input, attrs_, _List_Nil);
								}(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(data.dt),
											$elm$html$Html$Events$onCheck(
											$author$project$Csf$Table$SelectDataMsg(data)),
											$elm$html$Html$Attributes$disabled(
											A3(
												$elm$core$Basics$composeL,
												def.jY,
												function ($) {
													return $.r;
												},
												data)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													A3(
														$elm$core$Basics$composeL,
														def.jY,
														function ($) {
															return $.r;
														},
														data))
												]))
										]))
								]))
						]));
			}
		});
};
var $author$project$Page$SolicitudesChie$textdate = F3(
	function (model, _v0, taskNode_) {
		var key_ = _v0.a;
		var format_ = _v0.b;
		var zone_ = _v0.c;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			A2($author$project$Page$SolicitudesChie$toAccessor, key_, taskNode_),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Csf$DateFormat$formatIsoDate, format_, zone_),
					$elm$core$Maybe$withDefault('')),
				A3($author$project$Page$SolicitudesChie$fromTaskNode, model, key_, taskNode_)));
	});
var $author$project$Page$SolicitudesChie$tableConfig = function (model) {
	var zone = model.lG;
	var session = model.g$;
	var doSortBy = function (_v0) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Page$SolicitudesChie$fromTaskNode, model, key_),
			$elm$core$Maybe$withDefault(default_));
	};
	var rearTable_ = _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: A2(
					$author$project$Page$SolicitudesChie$justtext,
					model,
					_Utils_Tuple2('estado_chie', '')),
				dc: 'Estado CHI-e',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('estado_chie', '')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			}),
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesChie$conciliationData(model),
				dc: 'Conciliación',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('estado_conciliacion_mtt', '-')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			})
		]);
	var dealer_ = $author$project$Page$SolicitudesChie$isSupportUser(session) ? _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: A2(
					$author$project$Page$SolicitudesChie$justtext,
					model,
					_Utils_Tuple2('distribuidor', '')),
				dc: 'Distribuidor',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('distribuidor', '')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			}),
			$author$project$Csf$Table$customColumn(
			{
				V: A2(
					$author$project$Page$SolicitudesChie$justtext,
					model,
					_Utils_Tuple2('tenant', '')),
				dc: 'Importador',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('tenant', '')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			})
		]) : ($author$project$Page$SolicitudesChie$showDealer(session) ? _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: A2(
					$author$project$Page$SolicitudesChie$justtext,
					model,
					_Utils_Tuple2('distribuidor', '')),
				dc: 'Distribuidor',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('distribuidor', '')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			})
		]) : _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: A2(
					$author$project$Page$SolicitudesChie$justtext,
					model,
					_Utils_Tuple2('tenant', '')),
				dc: 'Importador',
				bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2(
						$elm$core$Basics$composeL,
						doSortBy(
							_Utils_Tuple2('tenant', '')),
						function ($) {
							return $.r;
						})),
				lz: $elm$core$Maybe$Nothing
			})
		]));
	var conciliateChecks_ = $author$project$Page$SolicitudesChie$showConciliation(session) ? _List_fromArray(
		[
			$author$project$Csf$Table$selectableColumn(
			{
				jY: $author$project$Page$SolicitudesChie$conciliationDisabled,
				dc: '',
				lz: $elm$core$Maybe$Just('50px')
			})
		]) : _List_Nil;
	return {
		f8: function (frontTable_) {
			return _Utils_ap(
				conciliateChecks_,
				_Utils_ap(
					frontTable_,
					_Utils_ap(dealer_, rearTable_)));
		}(
			_List_fromArray(
				[
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$textdate,
							model,
							_Utils_Tuple3('inserted_at', 'DD/MM/YYYY | hh:mm A', zone)),
						dc: 'Fecha | Hora Solicitud',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('inserted_at', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Just('160px')
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$textdate,
							model,
							_Utils_Tuple3('fecha_emision_chie', 'DD/MM/YYYY | hh:mm A', $elm$time$Time$utc)),
						dc: 'Fecha | Hora Emisión',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('fecha_emision_chie', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Just('155px')
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('vin', '')),
						dc: 'Vin',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('vin', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('tipo', '')),
						dc: 'Tipo',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('tipo', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('marca', '')),
						dc: 'Marca',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('marca', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('modelo', '')),
						dc: 'Modelo',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('modelo', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('ano', '')),
						dc: 'Año',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('ano', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('color', '')),
						dc: 'Color',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('color', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('motor', '')),
						dc: 'N° Motor',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('motor', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('cit', '')),
						dc: 'C.I.T',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('cit', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('patente', '')),
						dc: 'Patente',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('patente', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: A2(
							$author$project$Page$SolicitudesChie$justtext,
							model,
							_Utils_Tuple2('correlativo', '')),
						dc: 'Correlativo',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('correlativo', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Nothing
					})
				])),
		hC: $elm$core$Maybe$Nothing,
		hD: $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf-table_customized stock_vh-table'),
					A2($elm$html$Html$Attributes$style, 'min-width', '1980px')
				])),
		hb: function ($) {
			return $.p;
		}
	};
};
var $author$project$Page$SolicitudesChie$view = function (model) {
	var session = model.g$;
	var loadedFiles = model.bp;
	var nodePager = model.aF;
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var showPreviewer_ = function (node_uuid) {
		return function (frame_attrs) {
			return A2($elm$html$Html$iframe, frame_attrs, _List_Nil);
		}(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-height', '100vh'),
					A2($elm$html$Html$Attributes$style, 'border', 'none'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', '100%'),
					$elm$html$Html$Attributes$src(
					$author$project$Config$ApiEndpoint$nodepreview(node_uuid))
				]));
	};
	var showPagedTable = ((!A2($elm$core$Dict$member, 'file_uuid', model.kX)) && (!nodePager.gR)) || (!$elm$core$List$isEmpty(loadedFiles.kh));
	var nullifyAllowedStates = _List_fromArray(
		['firmado', 'firmado_chie', 'registrado_mtt', 'conciliado_mtt', 'notificado_cliente', 'notificado_cliente_mtt', 'notificado_registrado_mtt']);
	var noDocToPreview = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-2'),
				A2($elm$html$Html$Attributes$style, 'min-height', '400px')
			]),
		_List_fromArray(
			[$author$project$Customized$DocumentNotFound$view]));
	var mayNullify = function (_v3) {
		var isNullyfier = _v3.a;
		var fileState = _v3.b;
		return isNullyfier && A2($elm$core$List$member, fileState, nullifyAllowedStates);
	}(
		function (isNullyfier) {
			return _Utils_Tuple2(
				isNullyfier,
				A3($author$project$Csf$TaskNodeUtils$datastring, '', 'estado_chie', model.b));
		}(
			A2(
				$author$project$Helpers$ApiHandler$hasUserAccess,
				$author$project$Csf$Flags$userNode(session.ka),
				_List_fromArray(
					['NULLIFIER']))));
	var mayConciliate = $author$project$Page$SolicitudesChie$showConciliation(session) && A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(loadedFiles.kh);
	var mayApplyRequest = function (user_) {
		return A2(
			$author$project$Helpers$ApiHandler$hasUserAccess,
			user_,
			_List_fromArray(
				['SUPPORT', 'APPLICANT']));
	}(
		$author$project$Csf$Flags$userNode(session.ka));
	var loaded_document = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (name_) {
				return ' (' + (name_ + ')');
			},
			A3(
				$elm$core$Basics$composeR,
				$author$project$Helpers$Utilities$correctDocumentNames,
				$author$project$Helpers$Utilities$stringToMaybe,
				A3(
					$elm$core$String$replace,
					'_',
					' ',
					A3(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dm;
						},
						$author$project$TaskNode$typeOrEmpty,
						A3(
							$elm$core$Basics$composeR,
							$elm$core$List$head,
							$elm$core$Maybe$withDefault($author$project$TaskNode$emptyTask),
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.p;
									},
									$elm$core$Basics$eq(model.aK)),
								model.b5)))))));
	var listDataFailed = A3(
		$elm$core$Basics$composeR,
		$elm$core$List$isEmpty,
		$elm$core$Basics$and(nodePager.gR),
		loadedFiles.kh) && A3(
		$elm$core$Basics$composeR,
		$elm$core$Dict$member('file_uuid'),
		$elm$core$Basics$not,
		model.kX);
	var havePermissionToChangePeso = _Utils_eq(
		$author$project$Page$SolicitudesChie$getVehicleWeight(model.b),
		$elm$core$Maybe$Nothing) && ($author$project$Page$SolicitudesChie$isSupportUser(session) && $author$project$Page$SolicitudesChie$isExtendedChieEnabledWithoutWeight(model));
	var haveNotExtInProcess = $elm$core$List$isEmpty(
		$author$project$Helpers$ExtensionsUtils$getInProcessExtensions(model.b));
	var haveActiveExtension = !$elm$core$List$isEmpty(
		$author$project$Helpers$ExtensionsUtils$getActiveExtensions(model.b));
	var haveNullifyPermission = haveActiveExtension ? ($author$project$Page$SolicitudesChie$nullifyPermissions(session) && ($author$project$Page$SolicitudesChie$isValidateExt(model) && haveNotExtInProcess)) : (mayNullify && $author$project$Page$SolicitudesChie$nullifyPermissions(session));
	var documentPreviewer_ = A2($author$project$Page$SolicitudesChie$boolModule, 'docs_loading', model) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'min-height', '400px')
			]),
		_List_fromArray(
			[$author$project$Csf$Core$loader])) : A2(
		$elm$core$Maybe$withDefault,
		noDocToPreview,
		A2(
			$elm$core$Maybe$map,
			showPreviewer_,
			$author$project$Helpers$Utilities$stringToMaybe(model.aK)));
	var dataLoaded = A2($elm$core$Dict$member, 'file_uuid', model.kX) && (!_Utils_eq($author$project$TaskNode$emptyTask, model.b));
	var _v0 = A2($elm$core$Dict$member, 'file_uuid', model.kX) ? _Utils_Tuple2(
		$author$project$Page$SolicitudesChie$moduleMessage('head_details'),
		'Expediente de Homologación' + loaded_document) : function (card_title_) {
		return _Utils_Tuple2(
			$author$project$Page$SolicitudesChie$moduleMessage('chie_files'),
			card_title_);
	}(
		$author$project$Page$SolicitudesChie$moduleMessage('card_title_loaded') + (' (' + ($elm$core$String$fromInt(loadedFiles.lo) + ')')));
	var head_title = _v0.a;
	var card_title = _v0.b;
	var _v1 = function () {
		var _v2 = _Utils_Tuple3(
			model.b7,
			$elm$core$Dict$isEmpty(model.kX),
			$elm$core$List$isEmpty(loadedFiles.kh));
		_v2$3:
		while (true) {
			if (!_v2.a) {
				if (!_v2.b) {
					if (_v2.c) {
						return _Utils_Tuple3(
							$author$project$Page$SolicitudesChie$moduleMessage('filtered_empty'),
							$author$project$Page$SolicitudesChie$NoOp,
							'');
					} else {
						break _v2$3;
					}
				} else {
					if (_v2.c) {
						return _Utils_Tuple3(
							$author$project$Page$SolicitudesChie$moduleMessage('files_empty'),
							$author$project$Page$SolicitudesChie$NoOp,
							'');
					} else {
						break _v2$3;
					}
				}
			} else {
				return _Utils_Tuple3(
					$author$project$Page$SolicitudesChie$moduleMessage('files_load_failed'),
					$author$project$Page$SolicitudesChie$ReloadModule,
					'Intente Nuevamente');
			}
		}
		return _Utils_Tuple3('', $author$project$Page$SolicitudesChie$NoOp, '');
	}();
	var box_message = _v1.a;
	var box_action = _v1.b;
	var box_button = _v1.c;
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(head_title)
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12'),
										A2($elm$html$Html$Attributes$style, 'min-height', '400px')
									]),
								_List_fromArray(
									[
										$author$project$Helpers$Utilities$processLoader(model.cD),
										A2(
										$elm$html$Html$map,
										$author$project$Page$SolicitudesChie$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 csf-content-pkg card-body--no-padding f-12'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-7')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('f-14 m-0')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(card_title)
															]))
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-5 text-uppercase text-right')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(true)
															]),
														dataLoaded ? _List_fromArray(
															[
																($author$project$Page$SolicitudesChie$shouldShowExtendIcon(session) && $author$project$Page$SolicitudesChie$isExtendedChieEnabled(model)) ? A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$ExtendCHIE)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Extender CHI-e')
																	])) : $elm$html$Html$text(''),
																havePermissionToChangePeso ? A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$ActualizarPeso)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Actualizar Peso')
																	])) : $elm$html$Html$text(''),
																haveNullifyPermission ? A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
																		$author$project$Csf$Form$onClick_(
																		$author$project$Page$SolicitudesChie$NullifyCHIE(
																			haveActiveExtension ? 'Anular EXT' : 'Anular CHI-e'))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		haveActiveExtension ? 'Anular EXT' : 'Anular CHI-e')
																	])) : $elm$html$Html$text(''),
																A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary just-icon ml-2 mr-2'),
																		$author$project$Csf$Form$attr(
																		A2($elm$html$Html$Attributes$attribute, 'title_', 'Cerrar detalles')),
																		A2($author$project$Csf$Form$style_, 'min-width', '25px'),
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$CloseDetails)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$i,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('zmdi zmdi-close f-16')
																			]),
																		_List_Nil)
																	]))
															]) : _List_fromArray(
															[
																(mayApplyRequest && (!model.b7)) ? A2(
																$author$project$Csf$Form$btn,
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('bttn text-uppercase mr-2'),
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$GoToRequestChie)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Page$SolicitudesChie$moduleMessage('request_chie'))
																	])) : $elm$html$Html$text(''),
																$elm$core$List$isEmpty(loadedFiles.kh) ? $elm$html$Html$text('') : function (attrs_) {
																return A2(
																	$author$project$Csf$Form$btn,
																	attrs_,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Exportar XLS')
																		]));
															}(
																_List_fromArray(
																	[
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$DoExportXLS),
																		$author$project$Csf$Form$loading(model.bZ),
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
																	])),
																mayConciliate ? function (attrs_) {
																return A2(
																	$author$project$Csf$Form$btn,
																	attrs_,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Conciliar')
																		]));
															}(
																_List_fromArray(
																	[
																		$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesChie$DoConciliate),
																		$author$project$Csf$Form$loading(model.bQ),
																		$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
																	])) : $elm$html$Html$text('')
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center'),
														$author$project$Csf$Form$show(showPagedTable)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesChie$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
																A2($elm$html$Html$Attributes$style, 'min-height', '400px')
															]),
														(!nodePager.gR) ? _List_fromArray(
															[$author$project$Csf$Core$loader]) : _List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Page$SolicitudesChie$TableMsg,
																A2(
																	$author$project$Csf$Table$view,
																	$author$project$Page$SolicitudesChie$tableConfig(model),
																	model.jb))
															])),
														A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesChie$NodePagerMsg,
														$author$project$Csf$NodePager$view(nodePager))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center pt-3 pb-3'),
														$author$project$Csf$Form$show(listDataFailed)
													]),
												_List_fromArray(
													[
														(!_Utils_eq(
														box_message,
														$author$project$Page$SolicitudesChie$moduleMessage('files_load_failed'))) ? A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesChie$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)) : $elm$html$Html$text(''),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('vertical-centered'),
																A2($elm$html$Html$Attributes$style, 'min-height', '320px')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('col-sm-12')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$img,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-3'),
																				$elm$html$Html$Attributes$src(
																				$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
																			]),
																		_List_Nil),
																		A2(
																		$elm$html$Html$h4,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
																				A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
																				A2($elm$html$Html$Attributes$style, 'font-size', '14px')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(box_message)
																			])),
																		(!_Utils_eq($author$project$Page$SolicitudesChie$NoOp, box_action)) ? function (attrs_) {
																		return A2(
																			$author$project$Csf$Form$btn,
																			attrs_,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(box_button)
																				]));
																	}(
																		_List_fromArray(
																			[
																				$author$project$Csf$Form$onClick_(box_action),
																				$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
																			])) : $elm$html$Html$text('')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white pb-5'),
														A2($author$project$Csf$Form$style_, 'display', 'flex'),
														$author$project$Csf$Form$show(dataLoaded)
													]),
												_List_fromArray(
													[
														haveNullifyPermission ? $author$project$Page$SolicitudesChie$nullifyModalView(model) : $elm$html$Html$text(''),
														$author$project$Page$SolicitudesChie$extendChieConfirmationModalView(model),
														$author$project$Page$SolicitudesChie$actualizarPesoModalView(model),
														$author$project$Page$SolicitudesChie$extendChieSuccessModalView(model),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-sm-7 text-center pr-0')
															]),
														_List_fromArray(
															[documentPreviewer_])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-sm-5')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('nav nav-tabs nav-fill')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Page$SolicitudesChie$navItem,
																		'tab_solicitud',
																		$elm$core$Basics$eq(model.ae)),
																		$author$project$Page$SolicitudesChie$chieHasChildren(model.b) ? A2(
																		$author$project$Page$SolicitudesChie$navItem,
																		'tab_extension',
																		$elm$core$Basics$eq(model.ae)) : $elm$html$Html$text(''),
																		A2(
																		$author$project$Page$SolicitudesChie$navItem,
																		'tab_historial',
																		$elm$core$Basics$eq(model.ae)),
																		A2(
																		$author$project$Page$SolicitudesChie$navItem,
																		'tab_documentos',
																		$elm$core$Basics$eq(model.ae))
																	])),
																$author$project$Page$SolicitudesChie$solicitudTabView(model),
																$author$project$Page$SolicitudesChie$extensionTabView(model),
																$author$project$Page$SolicitudesChie$historialTabView(model),
																$author$project$Page$SolicitudesChie$documentosTabView(model)
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$SolicitudesPendientes$ApproveRequest = {$: 4};
var $author$project$Page$SolicitudesPendientes$CloseDetails = {$: 2};
var $author$project$Page$SolicitudesPendientes$NoOp = {$: 0};
var $author$project$Page$SolicitudesPendientes$NullifyRequest = {$: 3};
var $author$project$Csf$Form$Disabled = function (a) {
	return {$: 28, a: a};
};
var $author$project$Csf$Form$disabled_ = $author$project$Csf$Form$Disabled;
var $author$project$Page$SolicitudesPendientes$DescargarDocumento = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$SwitchDocument = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$SolicitudesPendientes$documentosTabView = function (model) {
	var activeTabItem = model.ae;
	var taskDocuments = model.fD;
	var session = model.g$;
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var processName = function (name_) {
		return $author$project$Helpers$Utilities$correctDocumentNames(
			A3($elm$core$String$replace, '_', ' ', name_));
	};
	var download_ = function (tNde) {
		return function (ndeType_) {
			return _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$SolicitudesPendientes$DescargarDocumento,
						processName(ndeType_),
						tNde))
				]);
		}(
			$author$project$TaskNode$typeOrEmpty(tNde.dm));
	};
	var docHeadRows = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0'),
					A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #ccc'),
					A2($elm$html$Html$Attributes$style, 'color', '#000'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-6 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Nombre del documento')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-4 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Fecha de emisión')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm-2 pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				]))
		]);
	var date_ = function (string_) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A3($author$project$Csf$DateFormat$formatIsoDate, 'DD/MM/YYYY | hh:mm A', model.lG, string_));
	};
	var anchorAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pl-1 pr-1 position-relative just-icon'),
			A2($elm$html$Html$Attributes$style, 'color', 'inherit')
		]);
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_documentos'),
						activeTabItem),
						$author$project$Csf$Form$class_('pt-3')
					]),
				_Utils_ap(
					docHeadRows,
					function (rowMap) {
						return A2($elm$core$List$map, rowMap, taskDocuments);
					}(
						function (nde) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('row m-0'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selected_document',
												_Utils_eq(model.aK, nde.p))
											])),
										A2($elm$html$Html$Attributes$style, 'border-bottom', '1px solid #ccc'),
										A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('col-sm-6 pt-2 pb-2'),
												$elm$html$Html$Events$onClick(
												$author$project$Page$SolicitudesPendientes$SwitchDocument(nde.p))
											]),
										_List_fromArray(
											[
												A3(
												$elm$core$Basics$composeL,
												$elm$html$Html$text,
												processName,
												$author$project$TaskNode$typeOrEmpty(nde.dm))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('col-sm-4 pt-2 pb-2'),
												$elm$html$Html$Events$onClick(
												$author$project$Page$SolicitudesPendientes$SwitchDocument(nde.p))
											]),
										_List_fromArray(
											[
												A3(
												$elm$core$Basics$composeL,
												$elm$html$Html$text,
												date_,
												$author$project$TaskNode$insertedAtOrEmpty(nde.dm))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('col-sm-2 p-2 text-center')
											]),
										_List_fromArray(
											[
												function (attrs_) {
												return A2(
													$elm$html$Html$a,
													attrs_,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('zmdi zmdi-download'),
																	A2($elm$html$Html$Attributes$style, 'padding', '0 2px')
																]),
															_List_Nil)
														]));
											}(
												A3(
													$elm$core$Basics$composeR,
													$elm$core$Basics$append(
														download_(nde)),
													$elm$core$Basics$append(anchorAttrs_),
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$attribute, 'title_', 'Descargar documento')
														])))
											]))
									]));
						})))
			]));
};
var $author$project$Page$SolicitudesPendientes$historialTabView = function (model) {
	var activeTabItem = model.ae;
	var taskHistory = model.fE;
	var toDateFormat_ = A2($author$project$Csf$DateFormat$formatIsoDate, 'DD/MM/YYYY', model.lG);
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('pt-3'),
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_historial'),
						activeTabItem)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Csf$Timeline$view,
						taskHistory,
						A2(
							$author$project$Csf$Timeline$taskTypes,
							$author$project$Helpers$Utilities$tasksInfoDict,
							$author$project$Csf$Timeline$config(toDateFormat_)))
					]))
			]));
};
var $author$project$Page$SolicitudesPendientes$SwitchTabItem = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$SolicitudesPendientes$navItem = F2(
	function (tab_key, isActive) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-item'),
					A2($elm$html$Html$Attributes$style, 'width', 'auto')
				]),
			_List_fromArray(
				[
					function (anchor_attrs) {
					return A2(
						$elm$html$Html$a,
						anchor_attrs,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(tab_key))
							]));
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nav-link text-uppercase'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									isActive(tab_key))
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitudesPendientes$SwitchTabItem(tab_key)),
							A2($elm$html$Html$Attributes$style, 'color', 'inherit')
						]))
				]));
	});
var $author$project$Page$SolicitudesPendientes$CloseNullifyModal = {$: 13};
var $author$project$Page$SolicitudesPendientes$DoNullifyRequest = {$: 5};
var $author$project$Page$SolicitudesPendientes$OnNullifyMssgUpdated = function (a) {
	return {$: 28, a: a};
};
var $author$project$Page$SolicitudesPendientes$nullifyModalView = function (model) {
	var nullifyModal = model.bv;
	var nullifyMssgField = model.df;
	var headerAttrs_ = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pull-left text-uppercase position-relative'),
			A2($elm$html$Html$Attributes$style, 'top', '-15px')
		]);
	return (!_Utils_eq($author$project$Csf$Modal$shown, nullifyModal)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__container')
			]),
		A3(
			$elm$core$Basics$composeR,
			$author$project$Csf$Modal$view(nullifyModal),
			$elm$core$List$singleton,
			A3(
				$author$project$Csf$Modal$footer,
				_List_Nil,
				_List_fromArray(
					[
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancelar')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesPendientes$CloseNullifyModal),
								$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2')
							])),
						function (attrs_) {
						return A2(
							$author$project$Csf$Form$btn,
							attrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anular')
								]));
					}(
						_List_fromArray(
							[
								$author$project$Csf$Form$onClick_($author$project$Page$SolicitudesPendientes$DoNullifyRequest),
								$author$project$Csf$Form$loading(model.e),
								$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
							]))
					]),
				A3(
					$author$project$Csf$Modal$body,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pt-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-10')
								]),
							A6(
								$author$project$Helpers$Utilities$inputFormField,
								true,
								'Motivo de anulación',
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-2'),
										$elm$html$Html$Events$onInput($author$project$Page$SolicitudesPendientes$OnNullifyMssgUpdated)
									]),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$readonly(model.e)
									]),
								nullifyMssgField,
								_List_Nil))
						]),
					A3(
						$author$project$Csf$Modal$wrap,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-0')
							]),
						A3(
							$author$project$Csf$Modal$h5,
							headerAttrs_,
							_List_fromArray(
								[
									$elm$html$Html$text('Anular Solicitud')
								]),
							A2(
								$author$project$Csf$Modal$attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'max-width', '460px')
									]),
								$author$project$Csf$Modal$config($author$project$Page$SolicitudesPendientes$CloseNullifyModal))))))));
};
var $author$project$Page$SolicitudesPendientes$ClearDateTimePicker = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$SolicitudesPendientes$CopyFromStock = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$SolicitudesPendientes$OnSolicitudFocused = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$SolicitudesPendientes$OnSolicitudKeyFreed = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Page$SolicitudesPendientes$ShowPPUTooltip = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$SolicitudesPendientes$solicitudTabView = function (model) {
	var activeTabItem = model.ae;
	var vinDropdown = model.ad;
	var dealerDropdown = model.aP;
	var taskName = model.jd;
	var rightHeader_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-sm p-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('f-12_5')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Datos en Stock de Vehículos')
						]))
				]))
		]);
	var notForApproval_ = taskName !== 'chie_aprobar_emision';
	var moduleDropdown__ = F5(
		function (attrs_, field_, disabled_, growOnOpen_, label_) {
			return A2(
				$elm$html$Html$map,
				$author$project$Page$SolicitudesPendientes$DropdownMsg(field_),
				A5(
					$author$project$Customized$CustomDropdown$dropbox,
					attrs_,
					disabled_,
					growOnOpen_,
					label_,
					A2(
						$author$project$Helpers$Utilities$getDropdown,
						$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(field_),
						model)));
		});
	var leftHeader_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('col-sm p-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('f-12_5')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Datos en la Solicitud')
						]))
				]))
		]);
	var keyFromStock = A2($elm$core$String$replace, 'instock_', 'solicitud_');
	var keyFromRequest = A2($elm$core$String$replace, 'solicitud_', 'instock_');
	var formField_ = F2(
		function (key_, formFieldSet) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Csf$Form$strFieldModel(''),
				A2($elm$core$Dict$get, key_, formFieldSet));
		});
	var solicitudFormField = function (key_) {
		return A2(formField_, key_, model.l);
	};
	var tipoVehiculo_ = $author$project$Csf$Form$strVal(
		solicitudFormField('solicitud_tipo_vehiculo'));
	var tooltipView_ = _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0 p-1'),
					A2($elm$html$Html$Attributes$style, 'color', '#FF3636')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Para ' + $author$project$Helpers$Utilities$doCapitalize(tipoVehiculo_))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row m-0 p-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'El formato debe ser ' + $author$project$Helpers$Utilities$formatoVhPPU(tipoVehiculo_))
				]))
		]);
	var vinDropdown_ = (vinDropdown.bj && (!model.e)) ? A3(
		$elm$core$Basics$composeR,
		$elm$html$Html$map(
			$author$project$Page$SolicitudesPendientes$InputDropdownMsg(0)),
		$elm$core$List$singleton,
		function (vinValue_) {
			return A2($author$project$Customized$InputDropdown$dropdown, vinValue_, vinDropdown);
		}(
			A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)('solicitud_vin'))) : _List_Nil;
	var stockFormField = function (key_) {
		return A2(formField_, key_, model.aj);
	};
	var dealerDropdown_ = (dealerDropdown.bj && (!model.e)) ? $elm$core$List$singleton(
		A2(
			$elm$html$Html$map,
			$author$project$Page$SolicitudesPendientes$InputDropdownMsg(1),
			function (dealerValue_) {
				return A2($author$project$Customized$InputDropdown$dropdown, dealerValue_, dealerDropdown);
			}(
				A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)('solicitud_distribuidor')))) : _List_Nil;
	var dateTimePickerActionIcon = F2(
		function (key_, pickedDTime) {
			if (pickedDTime.$ === 1) {
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-calendar-note zmdi-hc-lg zmdi-custom-date p-0 m-0 fs-2-3rem zmdiCalendarNoteCustomDate'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Page$SolicitudesPendientes$OpenDateTimePicker, key_, $elm$core$Maybe$Nothing))
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('zmdi zmdi-close fs-2-1rem zmdi-clear-date p-0 m-0 zmdiCloseClearDate'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$SolicitudesPendientes$ClearDateTimePicker(key_))
						]),
					_List_Nil);
			}
		});
	var dateTimePickerView_ = function (key_) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (dTPicker) {
					return _List_fromArray(
						[
							A2(dateTimePickerActionIcon, key_, dTPicker.a0),
							A2(
							$mercurymedia$elm_datetime_picker$SingleDatePicker$view,
							A2($author$project$Page$SolicitudesPendientes$dateTimePickerSettings, key_, model),
							dTPicker.aw)
						]);
				},
				A2($elm$core$Dict$get, key_, model.E)));
	};
	var dateFormatByKey_ = function (key_) {
		return function (format_) {
			return A2($author$project$Csf$DateFormat$formatIsoDate, format_, $elm$time$Time$utc);
		}(
			A2($elm$core$String$contains, 'documentos_fecha', key_) ? 'DD/MM/YYYY' : 'DD/MM/YYYY | hh:mm A');
	};
	var dateTimePickerField_ = F4(
		function (attrs_, required_, formKey_, heading_) {
			return function (_v3) {
				var fieldModel_ = _v3.a;
				var divAttrs_ = _v3.b;
				var inputAttrs_ = _v3.c;
				return A6(
					$author$project$Helpers$Utilities$inputFormField,
					required_,
					heading_,
					divAttrs_,
					inputAttrs_,
					fieldModel_,
					dateTimePickerView_(formKey_ + '--dtpicker'));
			}(
				function (_v2) {
					var fieldModel_ = _v2.a;
					var divAttrs_ = _v2.b;
					return _Utils_Tuple3(
						fieldModel_,
						divAttrs_,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('non-opacity'),
								$elm$html$Html$Attributes$readonly(true),
								$elm$html$Html$Events$onFocus(
								A2($author$project$Page$SolicitudesPendientes$OpenDateTimePicker, formKey_ + '--dtpicker', $elm$core$Maybe$Nothing))
							]));
				}(
					function (fieldModel_) {
						return A2(
							$elm$core$Tuple$pair,
							fieldModel_,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('csf-custom-datetimepicker')
									]),
								attrs_));
					}(
						A3(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(''),
							$author$project$Csf$Form$strFieldModel,
							A2(
								dateFormatByKey_,
								formKey_,
								$author$project$Csf$Form$strVal(
									solicitudFormField(formKey_)))))));
		});
	var correctCompare_ = A2($elm$core$Basics$composeR, $elm$core$String$trim, $author$project$Helpers$Utilities$correctTipoVehiculo_);
	var copyIcon_ = function (attributes_) {
		return _List_fromArray(
			[
				function (attrs_) {
				return A2($elm$html$Html$i, attrs_, _List_Nil);
			}(
				_Utils_ap(
					attributes_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-long-arrow-left f-16'),
							A2($elm$html$Html$Attributes$attribute, 'title_', 'Copiar valor'),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'left', '-6px'),
							A2($elm$html$Html$Attributes$style, 'top', '26px')
						])))
			]);
	};
	var compareFields_ = F3(
		function (compare_, inStock_, fromRequest_) {
			return A2($elm$core$Basics$composeR, $author$project$Helpers$Utilities$trimmedEmpty, $elm$core$Basics$not)(inStock_) && A2(
				compare_,
				correctCompare_(inStock_),
				correctCompare_(fromRequest_));
		});
	var fieldsAreEquals_ = function (instock_key) {
		return A3(
			compareFields_,
			$elm$core$Basics$eq,
			$author$project$Csf$Form$strVal(
				stockFormField(instock_key)),
			A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)(
				keyFromStock(instock_key)));
	};
	var fieldsNotEquals_ = function (instock_key) {
		return A3(
			compareFields_,
			$elm$core$Basics$neq,
			$author$project$Csf$Form$strVal(
				stockFormField(instock_key)),
			A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strVal)(
				keyFromStock(instock_key)));
	};
	var mb3ClassCondition_ = function (key_) {
		return A2($elm$core$Basics$composeR, fieldsNotEquals_, $elm$core$Basics$not)(
			keyFromRequest(key_)) && (!((key_ === 'solicitud_ppu') && model.ar));
	};
	var mb4ClassCondition_ = function (key_) {
		return fieldsNotEquals_(
			keyFromRequest(key_)) || ((key_ === 'solicitud_ppu') && model.ar);
	};
	var showCopyIcon_ = function (key_) {
		return fieldsNotEquals_(key_) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Page$SolicitudesPendientes$CopyFromStock(key_))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('closed hidden')
			]);
	};
	var readonlyFormField = F2(
		function (key_, heading_) {
			return _Utils_ap(
				copyIcon_(
					showCopyIcon_(key_)),
				A6(
					$author$project$Helpers$Utilities$inputFormField,
					false,
					heading_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$readonly(true)
						]),
					stockFormField(key_),
					_List_Nil));
		});
	var successWarnAttrs_ = F2(
		function (allowMb4, key_) {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mb-3',
							mb3ClassCondition_(key_))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mb-4',
							allowMb4 && mb4ClassCondition_(key_))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'warning-border',
							fieldsNotEquals_(
								keyFromRequest(key_)))
						])),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'success-border',
							fieldsAreEquals_(
								keyFromRequest(key_)))
						]))
				]);
		});
	var vhTypeAttrs_ = function (allow) {
		return A2(successWarnAttrs_, allow, 'solicitud_tipo_vehiculo');
	}(
		$author$project$Customized$CustomDropdown$isValidDropbox(
			function (k) {
				return A2($author$project$Helpers$Utilities$getDropdown, k, model);
			}(
				$author$project$Page$SolicitudesPendientes$ModuleHelpers$stringFromField(7))));
	var successWarnIcon_ = F2(
		function (noIcon, key_) {
			return fieldsNotEquals_(
				keyFromRequest(key_)) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-alert-triangle zmdi-hc-fw'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden closed', noIcon)
								])),
							A2($elm$html$Html$Attributes$style, 'color', '#FFA136'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						])),
					A2($elm$core$Basics$composeR, solicitudFormField, $author$project$Csf$Form$strIsValid)(key_) ? function (attrs_) {
					return A2(
						$elm$html$Html$span,
						attrs_,
						_List_fromArray(
							[
								$elm$html$Html$text('No coincide con el valor en Stock')
							]));
				}(
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('position-absolute'),
								A2($elm$html$Html$Attributes$style, 'left', '20px'),
								A2($elm$html$Html$Attributes$style, 'font-size', '80%')
							]),
						noIcon ? _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'bottom', '2.5px')
							]) : _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'bottom', '5px')
							]))) : $elm$html$Html$text('')
				]) : (fieldsAreEquals_(
				keyFromRequest(key_)) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-check zmdi-hc-fw'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden closed', noIcon)
								])),
							A2($elm$html$Html$Attributes$style, 'color', '#00BA83'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						]))
				]) : (((key_ === 'solicitud_ppu') && model.ar) ? _List_fromArray(
				[
					function (attrs_) {
					return A2($elm$html$Html$i, attrs_, _List_Nil);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute zmdi zmdi-alert-circle zmdi-hc-fw'),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$Page$SolicitudesPendientes$ShowPPUTooltip(true)),
							$elm$html$Html$Events$onMouseLeave(
							$author$project$Page$SolicitudesPendientes$ShowPPUTooltip(false)),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'color', '#FF3636'),
							A2($elm$html$Html$Attributes$style, 'right', '18px'),
							A2($elm$html$Html$Attributes$style, 'top', '30px')
						])),
					function (attrs_) {
					return A2(
						$elm$html$Html$span,
						attrs_,
						_List_fromArray(
							[
								$elm$html$Html$text('El formato de la patente no es válido')
							]));
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute'),
							A2($elm$html$Html$Attributes$style, 'color', '#ff6b68'),
							A2($elm$html$Html$Attributes$style, 'font-size', '80%'),
							A2($elm$html$Html$Attributes$style, 'left', '20px'),
							A2($elm$html$Html$Attributes$style, 'top', '48px')
						])),
					model.fz ? function (attrs_) {
					return A2($elm$html$Html$div, attrs_, tooltipView_);
				}(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('position-absolute vh_error__tooltip mb-0'),
							A2($elm$html$Html$Attributes$style, 'left', '95%'),
							A2($elm$html$Html$Attributes$style, 'top', '-12px')
						])) : $elm$html$Html$text('')
				]) : _List_Nil));
		});
	var customFormField_ = F5(
		function (attrs_, readonly_, key_, heading_, children_) {
			return function (input_) {
				return _Utils_ap(
					input_,
					A2(successWarnIcon_, false, key_));
			}(
				function (_v1) {
					var outAttrs_ = _v1.a;
					var innerAttrs_ = _v1.b;
					return A6(
						$author$project$Helpers$Utilities$inputFormField,
						true,
						heading_,
						outAttrs_,
						innerAttrs_,
						solicitudFormField(key_),
						children_);
				}(
					function (outAttrs_) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_ap(attrs_, outAttrs_),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$readonly(model.e || readonly_),
									$elm$html$Html$Events$onFocus(
									$author$project$Page$SolicitudesPendientes$OnSolicitudFocused(key_)),
									$author$project$Helpers$Utilities$onKeyUp(
									$author$project$Page$SolicitudesPendientes$OnSolicitudKeyFreed(key_))
								]));
					}(
						_Utils_ap(
							A2(successWarnAttrs_, true, key_),
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									$author$project$Page$SolicitudesPendientes$OnSolicitudUpdated(key_)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('error-border', (key_ === 'solicitud_ppu') && model.ar)
										]))
								])))));
		});
	var requestFormField = F5(
		function (attrs_, required_, readonly_, key_, heading_) {
			return function (input_) {
				return _Utils_ap(
					input_,
					A2(successWarnIcon_, false, key_));
			}(
				function (_v0) {
					var fieldAttrs_ = _v0.a;
					var inputAttrs_ = _v0.b;
					return A6(
						$author$project$Helpers$Utilities$inputFormField,
						required_,
						heading_,
						fieldAttrs_,
						inputAttrs_,
						solicitudFormField(key_),
						_List_Nil);
				}(
					function (fieldAttrs_) {
						return A2(
							$elm$core$Tuple$pair,
							_Utils_ap(attrs_, fieldAttrs_),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$readonly(readonly_ || notForApproval_)
								]));
					}(
						_Utils_ap(
							A2(successWarnAttrs_, true, key_),
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									$author$project$Page$SolicitudesPendientes$OnSolicitudUpdated(key_)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('error-border', (key_ === 'solicitud_ppu') && model.ar)
										]))
								])))));
		});
	return A2(
		$author$project$Csf$Form$conditional,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Csf$Form$elem,
				_List_fromArray(
					[
						$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
						A3(
						$elm$core$Basics$composeL,
						$author$project$Csf$Form$show,
						$elm$core$Basics$eq('tab_solicitud'),
						activeTabItem),
						$author$project$Csf$Form$class_('pt-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Vehículo')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								leftHeader_),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								rightHeader_)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(
									customFormField_,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(vinDropdown.cF)
										]),
									notForApproval_,
									'solicitud_vin',
									'VIN',
									vinDropdown_)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_vin', 'VIN'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_cit', 'C.I.T')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_cit', 'C.I.T'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_marca', 'Marca')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_marca', 'Marca'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_modelo', 'Modelo')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_modelo', 'Modelo'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A5(moduleDropdown__, vhTypeAttrs_, 7, model.e, false, '* Tipo de Vehículo')
											]),
											A2(successWarnIcon_, true, 'solicitud_tipo_vehiculo')
										]))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_tipo_vehiculo', 'Tipo de Vehículo'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_nro_motor', 'Nro Motor')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_nro_motor', 'Nro Motor'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_color', 'Color')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_color', 'Color'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_ano', 'Año')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A2(readonlyFormField, 'instock_anno', 'Año'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('1ra Inscripción')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(
									customFormField_,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(dealerDropdown.cF)
										]),
									notForApproval_ || model.dn,
									'solicitud_distribuidor',
									'Distribuidor',
									dealerDropdown_)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_distribuidor_rut', ' Rut Distribuidor')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_ppu', 'Patente')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'inscripcion_documentos_numero', 'Número Factura')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'solicitud_cliente_nombre', 'Nombre Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_cliente_rut', 'Rut Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, true, model.e, 'solicitud_email', 'Email Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'solicitud_cliente_comuna', 'Comuna Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-12')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'inscripcion_adquiriente_domicilio', 'Dirección Propietario')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A4(dateTimePickerField_, _List_Nil, false, 'inscripcion_solicitud_fecha_solicitud', 'Fecha/Hora Solicitud Inscripción')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A4(
									dateTimePickerField_,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('hide--footer')
										]),
									false,
									'inscripcion_documentos_fecha',
									'Fecha Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'inscripcion_adquiriente_correo', 'Email Inscripción')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'inscripcion_documentos_tipo', 'Tipo Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'inscripcion_documentos_naturaleza', 'Naturaleza Documento')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, model.e, 'inscripcion_documentos_lugar', 'Lugar Documento'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pt-3'),
								A2($elm$html$Html$Attributes$style, 'padding-left', '15px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-uppercase f-14')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Solicitud')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row pl-2 pr-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, true, 'solicitud_fecha', 'Fecha/Hora Solicitud CHI-e')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, true, 'solicitud_solicitante', 'Usuario Solicitante')),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-6')
									]),
								A5(requestFormField, _List_Nil, false, true, 'solicitud_estado', 'Estado CHI-e'))
							]))
					]))
			]));
};
var $author$project$Helpers$Utilities$tasksInfoName = function (key_) {
	return A2(
		$elm$core$Maybe$withDefault,
		key_,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$get(key_),
			$elm$core$Maybe$map(
				function ($) {
					return $.B;
				}))($author$project$Helpers$Utilities$tasksInfoDict));
};
var $author$project$Page$SolicitudesPendientes$fromTaskNode = F2(
	function (key_, taskNode_) {
		switch (key_) {
			case 'name':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Helpers$Utilities$tasksInfoName,
					A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_));
			case 'inserted_at':
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
			default:
				return A2($author$project$Csf$TaskNodeUtils$mbstring, key_, taskNode_);
		}
	});
var $author$project$Page$SolicitudesPendientes$toAccessor = F2(
	function (taskNode_, data_) {
		return function (attrs_) {
			return A2(
				$elm$html$Html$span,
				attrs_,
				_List_fromArray(
					[
						$elm$html$Html$text(data_)
					]));
		}(
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Csf$Table$CustomEventMsg, 'namespace_details', taskNode_))
				]));
	});
var $author$project$Page$SolicitudesPendientes$justtext = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var default_ = _v0.b;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(default_),
			$author$project$Page$SolicitudesPendientes$toAccessor(taskNode_),
			A2($author$project$Page$SolicitudesPendientes$fromTaskNode, key_, taskNode_));
	});
var $author$project$Page$SolicitudesPendientes$textdate = F2(
	function (_v0, taskNode_) {
		var key_ = _v0.a;
		var format_ = _v0.b;
		var zone_ = _v0.c;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			$author$project$Page$SolicitudesPendientes$toAccessor(taskNode_),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Csf$DateFormat$formatIsoDate, format_, zone_),
					$elm$core$Maybe$withDefault('')),
				A2($author$project$Page$SolicitudesPendientes$fromTaskNode, key_, taskNode_)));
	});
var $author$project$Page$SolicitudesPendientes$tableConfig = function (_v0) {
	var zone = _v0.lG;
	var taskName = _v0.jd;
	var tableColumnsForSigning = (!A2(
		$elm$core$List$member,
		taskName,
		_List_fromArray(
			['chie_firmar_certificado', 'chie_firmar_certificado_extension']))) ? _List_Nil : _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesPendientes$justtext(
					_Utils_Tuple2('cit', '')),
				dc: 'C.I.T',
				bD: $billstclair$elm_sortable_table$Table$unsortable,
				lz: $elm$core$Maybe$Nothing
			}),
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesPendientes$justtext(
					_Utils_Tuple2('correlativo', '')),
				dc: 'Correlativo',
				bD: $billstclair$elm_sortable_table$Table$unsortable,
				lz: $elm$core$Maybe$Nothing
			})
		]);
	var rearTableColumns = _List_fromArray(
		[
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesPendientes$justtext(
					_Utils_Tuple2('marca', '')),
				dc: 'Marca',
				bD: $billstclair$elm_sortable_table$Table$unsortable,
				lz: $elm$core$Maybe$Nothing
			}),
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesPendientes$justtext(
					_Utils_Tuple2('modelo', '')),
				dc: 'Modelo',
				bD: $billstclair$elm_sortable_table$Table$unsortable,
				lz: $elm$core$Maybe$Nothing
			}),
			$author$project$Csf$Table$customColumn(
			{
				V: $author$project$Page$SolicitudesPendientes$justtext(
					_Utils_Tuple2('distribuidor', '')),
				dc: 'Distribuidor solicitante',
				bD: $billstclair$elm_sortable_table$Table$unsortable,
				lz: $elm$core$Maybe$Nothing
			})
		]);
	var doSortBy = function (_v1) {
		var key_ = _v1.a;
		var default_ = _v1.b;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$SolicitudesPendientes$fromTaskNode(key_),
			$elm$core$Maybe$withDefault(default_));
	};
	return {
		f8: function (headTable_) {
			return _Utils_ap(
				headTable_,
				_Utils_ap(tableColumnsForSigning, rearTableColumns));
		}(
			_List_fromArray(
				[
					$author$project$Csf$Table$customColumn(
					{
						V: $author$project$Page$SolicitudesPendientes$textdate(
							_Utils_Tuple3('inserted_at', 'DD/MM/YYYY | hh:mm A', zone)),
						dc: 'Fecha Tarea',
						bD: $billstclair$elm_sortable_table$Table$increasingOrDecreasingBy(
							A2(
								$elm$core$Basics$composeL,
								doSortBy(
									_Utils_Tuple2('inserted_at', '')),
								function ($) {
									return $.r;
								})),
						lz: $elm$core$Maybe$Just('168px')
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: $author$project$Page$SolicitudesPendientes$justtext(
							_Utils_Tuple2('cliente_correo', '')),
						dc: 'Email Propietario',
						bD: $billstclair$elm_sortable_table$Table$unsortable,
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: $author$project$Page$SolicitudesPendientes$justtext(
							_Utils_Tuple2('patente', '')),
						dc: 'Patente',
						bD: $billstclair$elm_sortable_table$Table$unsortable,
						lz: $elm$core$Maybe$Nothing
					}),
					$author$project$Csf$Table$customColumn(
					{
						V: $author$project$Page$SolicitudesPendientes$justtext(
							_Utils_Tuple2('vin', '')),
						dc: 'VIN',
						bD: $billstclair$elm_sortable_table$Table$unsortable,
						lz: $elm$core$Maybe$Nothing
					})
				])),
		hC: $elm$core$Maybe$Nothing,
		hD: $elm$core$Maybe$Just(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('csf-table_customized')
				])),
		hb: function ($) {
			return $.p;
		}
	};
};
var $author$project$Page$SolicitudesPendientes$view = function (model) {
	var session = model.g$;
	var loadedTasks = model.eI;
	var nodePager = model.aF;
	var taskName = model.jd;
	var ticket_ = $author$project$Csf$Flags$ticket(session.ka);
	var tName_ = A2($author$project$Helpers$Utilities$removeFromString, 'chie_', taskName);
	var showPagedTable = A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(loadedTasks.kh) || ((!nodePager.gR) && A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$member('namespace'),
		$elm$core$Basics$not)(model.kX));
	var previewer_ = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Config$ApiEndpoint$nodepreview,
			$author$project$Helpers$Utilities$stringToMaybe(model.aK)));
	var nullifyRequestBttn_ = function () {
		if (taskName === 'chie_firmar_certificado') {
			return $elm$html$Html$text('');
		} else {
			return function (attrs_) {
				return A2(
					$author$project$Csf$Form$btn,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text('Anular')
						]));
			}(
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary text-uppercase ml-2 mr-2'),
						$author$project$Csf$Form$onClick_(
						model.e ? $author$project$Page$SolicitudesPendientes$NoOp : $author$project$Page$SolicitudesPendientes$NullifyRequest)
					]));
		}
	}();
	var listDataFailed = nodePager.gR && ($elm$core$List$isEmpty(loadedTasks.kh) && A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$member('namespace'),
		$elm$core$Basics$not)(model.kX));
	var dataLoaded = A2($elm$core$Dict$member, 'namespace', model.kX) && (!_Utils_eq($author$project$TaskNode$emptyTask, model.fF));
	var approveRequestBttn_ = function () {
		if (taskName === 'chie_firmar_certificado') {
			return $elm$html$Html$text('');
		} else {
			return function (attrs_) {
				return A2(
					$author$project$Csf$Form$btn,
					attrs_,
					_List_fromArray(
						[
							$elm$html$Html$text('Aprobar')
						]));
			}(
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2'),
						$author$project$Csf$Form$disabled_(model.e),
						$author$project$Csf$Form$onClick_(
						model.e ? $author$project$Page$SolicitudesPendientes$NoOp : $author$project$Page$SolicitudesPendientes$ApproveRequest),
						$author$project$Csf$Form$loading(
						model.e && (('approve_action' === model.aW) && _Utils_eq($author$project$Csf$Modal$hidden, model.bv)))
					]));
		}
	}();
	var _v0 = A2($elm$core$Dict$member, 'namespace', model.kX) ? A2(
		$elm$core$Tuple$pair,
		'Detalles de Tarea',
		$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(tName_ + '_card_title')) : A2(
		$elm$core$Tuple$pair,
		$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(tName_ + '_header_title'),
		$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(tName_ + '_card_title_loaded') + (' (' + ($elm$core$String$fromInt(loadedTasks.lo) + ')')));
	var head_title = _v0.a;
	var card_title = _v0.b;
	var _v1 = function () {
		var _v2 = _Utils_Tuple3(
			model.dA,
			$elm$core$Dict$isEmpty(model.kX),
			$elm$core$List$isEmpty(loadedTasks.kh));
		_v2$3:
		while (true) {
			if (!_v2.a) {
				if (!_v2.b) {
					if (_v2.c) {
						return _Utils_Tuple3(
							$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('filtered_empty'),
							$author$project$Page$SolicitudesPendientes$NoOp,
							'');
					} else {
						break _v2$3;
					}
				} else {
					if (_v2.c) {
						return _Utils_Tuple3(
							$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage(tName_ + '_tasks_empty'),
							$author$project$Page$SolicitudesPendientes$NoOp,
							'');
					} else {
						break _v2$3;
					}
				}
			} else {
				return _Utils_Tuple3(
					$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('task_load_failed'),
					$author$project$Page$SolicitudesPendientes$ReloadModule,
					'Intente Nuevamente');
			}
		}
		return _Utils_Tuple3('', $author$project$Page$SolicitudesPendientes$NoOp, '');
	}();
	var box_message = _v1.a;
	var box_action = _v1.b;
	var box_button = _v1.c;
	return A2(
		$author$project$Csf$Core$content,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content__title pr-0 pb-0 pt-0 m-0 vertical-centered'),
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px'),
						A2($elm$html$Html$Attributes$style, 'height', '40px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '14px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(head_title)
							]))
					])),
				A2(
				$author$project$Csf$Form$card,
				_List_fromArray(
					[
						$author$project$Csf$Form$class_('bg-grey-alt bold-heading card-body--no-padding')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('col-sm-12', true)
											])),
										A2($elm$html$Html$Attributes$style, 'min-height', '400px')
									]),
								_List_fromArray(
									[
										$author$project$Helpers$Utilities$processLoader(model.cD),
										A2(
										$elm$html$Html$map,
										$author$project$Page$SolicitudesPendientes$NotificationsMsg,
										$author$project$Csf$Notifications$toast(
											{a7: session.a7})),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-title vertical-centered m-0 csf-content-pkg card-body--no-padding f-12'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 10px'),
												A2($elm$html$Html$Attributes$style, 'height', '40px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('col-sm-8')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('f-14 m-0')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(card_title)
															]))
													])),
												A2(
												$author$project$Csf$Form$conditional,
												_List_fromArray(
													[
														$author$project$Csf$Form$class_('col-sm-4 text-uppercase text-right')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Csf$Form$elem,
														_List_fromArray(
															[
																$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
																$author$project$Csf$Form$show(dataLoaded)
															]),
														_List_fromArray(
															[
																nullifyRequestBttn_,
																approveRequestBttn_,
																function (attrs_) {
																return A2(
																	$author$project$Csf$Form$btn,
																	attrs_,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$i,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('zmdi zmdi-close f-16')
																				]),
																			_List_Nil)
																		]));
															}(
																_List_fromArray(
																	[
																		$author$project$Csf$Form$class_('btn-outline- bttn bttn-outline-primary just-icon ml-2 mr-2'),
																		$author$project$Csf$Form$attr(
																		A2($elm$html$Html$Attributes$attribute, 'title_', 'Cerrar detalles')),
																		A2($author$project$Csf$Form$style_, 'min-width', '25px'),
																		$author$project$Csf$Form$onClick_(
																		model.e ? $author$project$Page$SolicitudesPendientes$NoOp : $author$project$Page$SolicitudesPendientes$CloseDetails)
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white'),
														$author$project$Csf$Form$show(showPagedTable)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesPendientes$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
																A2($elm$html$Html$Attributes$style, 'min-height', '400px')
															]),
														(!nodePager.gR) ? _List_fromArray(
															[$author$project$Csf$Core$loader]) : _List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Page$SolicitudesPendientes$TableMsg,
																A2(
																	$author$project$Csf$Table$view,
																	$author$project$Page$SolicitudesPendientes$tableConfig(model),
																	model.jb))
															])),
														A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesPendientes$NodePagerMsg,
														$author$project$Csf$NodePager$view(nodePager))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_fromArray(
											[
												$author$project$Csf$Form$class_('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white text-center pt-3 pb-3'),
														A2($author$project$Csf$Form$style_, 'min-height', '400px'),
														$author$project$Csf$Form$show(listDataFailed)
													]),
												_List_fromArray(
													[
														(!_Utils_eq(
														box_message,
														$author$project$Page$SolicitudesPendientes$ModuleHelpers$moduleMessage('task_load_failed'))) ? A2(
														$elm$html$Html$map,
														$author$project$Page$SolicitudesPendientes$FilterBadgesMsg,
														$author$project$Csf$FilterBadges$view(model.b8)) : $elm$html$Html$text(''),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('vertical-centered'),
																A2($elm$html$Html$Attributes$style, 'min-height', '320px')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('col-sm-12')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$img,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-3'),
																				$elm$html$Html$Attributes$src(
																				$author$project$Helpers$Utilities$imagesPath('/gray-box.svg'))
																			]),
																		_List_Nil),
																		A2(
																		$elm$html$Html$h4,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('mb-5 text-uppercase'),
																				A2($elm$html$Html$Attributes$style, 'font-family', 'Roboto, Regular'),
																				A2($elm$html$Html$Attributes$style, 'font-size', '14px')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(box_message)
																			])),
																		(!_Utils_eq($author$project$Page$SolicitudesPendientes$NoOp, box_action)) ? function (attrs_) {
																		return A2(
																			$author$project$Csf$Form$btn,
																			attrs_,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(box_button)
																				]));
																	}(
																		_List_fromArray(
																			[
																				$author$project$Csf$Form$onClick_(box_action),
																				$author$project$Csf$Form$class_('bttn text-uppercase ml-2 mr-2')
																			])) : $elm$html$Html$text('')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Csf$Form$conditional,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Csf$Form$elem,
												_List_fromArray(
													[
														$author$project$Csf$Form$elemtype($author$project$Csf$Form$div_),
														$author$project$Csf$Form$class_('p-0 bg-white pb-5'),
														A2($author$project$Csf$Form$style_, 'display', 'flex'),
														$author$project$Csf$Form$show(dataLoaded)
													]),
												_List_fromArray(
													[
														$author$project$Page$SolicitudesPendientes$nullifyModalView(model),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-sm-7 text-center pr-0')
															]),
														_List_fromArray(
															[
																function (frame_attrs) {
																return A2($elm$html$Html$iframe, frame_attrs, _List_Nil);
															}(
																_List_fromArray(
																	[
																		A2($elm$html$Html$Attributes$style, 'min-height', '100vh'),
																		A2($elm$html$Html$Attributes$style, 'border', 'none'),
																		A2($elm$html$Html$Attributes$style, 'width', '100%'),
																		A2($elm$html$Html$Attributes$style, 'height', '100%'),
																		$elm$html$Html$Attributes$src(previewer_)
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('col-sm-5')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('nav nav-tabs nav-fill')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Page$SolicitudesPendientes$navItem,
																		'tab_solicitud',
																		$elm$core$Basics$eq(model.ae)),
																		A2(
																		$author$project$Page$SolicitudesPendientes$navItem,
																		'tab_historial',
																		$elm$core$Basics$eq(model.ae)),
																		A2(
																		$author$project$Page$SolicitudesPendientes$navItem,
																		'tab_documentos',
																		$elm$core$Basics$eq(model.ae))
																	])),
																$author$project$Page$SolicitudesPendientes$solicitudTabView(model),
																$author$project$Page$SolicitudesPendientes$documentosTabView(model),
																$author$project$Page$SolicitudesPendientes$historialTabView(model)
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Main$view = function (model) {
	var url = model.q;
	var renderPageView = F2(
		function (toMsg, pageView) {
			return A2($elm$html$Html$map, toMsg, pageView);
		});
	var _v0 = model.t;
	switch (_v0.$) {
		case 1:
			var session = _v0.a;
			return {
				h: _List_fromArray(
					[
						$author$project$Page$NotFound$view(session)
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$NotFound$pageTitle)
			};
		case 0:
			var session_ = _v0.a;
			return {
				h: _List_fromArray(
					[
						$author$project$Helpers$Utilities$processLoader(true)
					]),
				bF: $author$project$Main$pageTitle('')
			};
		case 3:
			var session = _v0.a;
			return {
				h: _List_fromArray(
					[
						$author$project$Page$Maintenance$view(session)
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$Maintenance$pageTitle)
			};
		case 7:
			var model_ = _v0.a;
			return {
				h: _List_fromArray(
					[
						function (viewContent) {
						return A3($author$project$Main$layoutView, _List_Nil, viewContent, model);
					}(
						A2(
							renderPageView,
							$author$project$Main$DashboardMsg,
							$author$project$Page$DashboardChie$view(model_)))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$DashboardChie$pageTitle)
			};
		case 8:
			var model_ = _v0.a;
			return {
				h: _List_fromArray(
					[
						A2(
						renderPageView,
						$author$project$Main$RepositorioMsg,
						A2($author$project$Page$RepositorioChie$view, model_, url.ki))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$RepositorioChie$pageTitle)
			};
		case 6:
			var model_ = _v0.a;
			var contentRender = function (viewContent) {
				return function (dashlets_) {
					return A3($author$project$Main$layoutView, dashlets_, viewContent, model);
				}(
					A2($author$project$Page$SolicitudesPendientes$filterSideBar, $author$project$Main$PendientesMsg, model_));
			};
			return {
				h: _List_fromArray(
					[
						A3(
						$elm$core$Basics$composeR,
						renderPageView($author$project$Main$PendientesMsg),
						contentRender,
						$author$project$Page$SolicitudesPendientes$view(model_))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$SolicitudesPendientes$pageTitle)
			};
		case 9:
			var model_ = _v0.a;
			return {
				h: _List_fromArray(
					[
						function (viewContent) {
						return A3($author$project$Main$layoutView, _List_Nil, viewContent, model);
					}(
						A2(
							renderPageView,
							$author$project$Main$CargarStockMsg,
							$author$project$Page$CargarStock$view(model_)))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$CargarStock$pageTitle)
			};
		case 11:
			var model_ = _v0.a;
			return {
				h: _List_fromArray(
					[
						function (viewContent) {
						return A3($author$project$Main$layoutView, _List_Nil, viewContent, model);
					}(
						A2(
							renderPageView,
							$author$project$Main$SolicitarChieMsg,
							$author$project$Page$SolicitarChie$view(model_)))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$SolicitarChie$pageTitle)
			};
		case 10:
			var model_ = _v0.a;
			var contentRender = function (viewContent) {
				return function (dashlets_) {
					return A3($author$project$Main$layoutView, dashlets_, viewContent, model);
				}(
					A2($author$project$Page$SolicitudesChie$filterSideBar, $author$project$Main$SolicitudesChieMsg, model_));
			};
			return {
				h: _List_fromArray(
					[
						A3(
						$elm$core$Basics$composeR,
						renderPageView($author$project$Main$SolicitudesChieMsg),
						contentRender,
						$author$project$Page$SolicitudesChie$view(model_))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$SolicitudesChie$pageTitle)
			};
		case 12:
			var model_ = _v0.a;
			var contentRender = function (viewContent) {
				return function (dashlets_) {
					return A3($author$project$Main$layoutView, dashlets_, viewContent, model);
				}(
					A2($author$project$Page$ConsultarStock$filterSideBar, $author$project$Main$ConsultarStockMsg, model_));
			};
			return {
				h: _List_fromArray(
					[
						A3(
						$elm$core$Basics$composeR,
						renderPageView($author$project$Main$ConsultarStockMsg),
						contentRender,
						$author$project$Page$ConsultarStock$view(model_))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$ConsultarStock$pageTitle)
			};
		case 5:
			var model_ = _v0.a;
			var contentRender = function (viewContent) {
				return function (dashlets_) {
					return A3($author$project$Main$layoutView, dashlets_, viewContent, model);
				}(
					A2($author$project$Page$HistorialDeCargas$filterSideBar, $author$project$Main$CargasMsg, model_));
			};
			return {
				h: _List_fromArray(
					[
						A3(
						$elm$core$Basics$composeR,
						renderPageView($author$project$Main$CargasMsg),
						contentRender,
						$author$project$Page$HistorialDeCargas$view(model_))
					]),
				bF: $author$project$Main$pageTitle($author$project$Page$HistorialDeCargas$pageTitle)
			};
		default:
			return {
				h: _List_Nil,
				bF: $author$project$Main$pageTitle('')
			};
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{kn: $author$project$Main$init, kR: $author$project$Main$ChangedUrl, kS: $author$project$Main$ClickedLink, lc: $author$project$Main$subscriptions, lr: $author$project$Main$update, lv: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));